'use strict';
( function() {
    angular
        .module( 'jigsawCorpLms', [
            'ngAnimate',
            'ngCookies',
            'ngTouch',
            'ngSanitize',
            'ngMessages',
            'ngAria',
            'ngResource',
            'ui.router',
            'mm.foundation',
            'toastr',
            'com.2fdevs.videogular',
            'com.2fdevs.videogular.plugins.controls',
            'com.2fdevs.videogular.plugins.overlayplay',
            'com.2fdevs.videogular.plugins.poster',
            'ngMaterial',
            'ui-rangeSlider',
            'slickCarousel',
            'angular-carousel',
            'ui.select',
            'errorUtils',
            'lazy-scroll',
            'base64',
            'firebase',
            'angular-intro',
            'ngRaven'
        ] );
} )();

'use strict';
(function() {
    angular
        .module('jigsawCorpLms')
        .directive('textSizeSlider', function($rootScope) {
            return {
                restrict: 'E',
                templateUrl: 'app/Features/learnerView/template/videoPlayerPage/partials/textSlider/textSizeSlider.html',
                scope: {
                    min: '@',
                    max: '@',
                    unit: '@',
                    value: '@',
                    step: '@'
                },
                link: function(scope) {
                    scope.textSize = scope.value;
                    scope.$watch('textSize', function(size) {
                        $rootScope.$broadcast('textSizeChanged');
                        var ele = angular.element('.vid-trscript-txt-section');
                        ele[0].style.fontSize = size + scope.unit;
                    });

                    scope.txtValueChange = function(v) {
                        scope.textSize = v;
                    }
                }
            }
        });


})();
'use strict';
(function() {
    angular
        .module('jigsawCorpLms')
        .directive('seekBar', [ function() {
            return {
                restrict: 'E',
                require: '^videogular',
                scope: {
                    onDrag: '&',
                    isSwiped: '='
                },
                link: function(scope, elem, attr, API) {
                    var percentTime = 0;
                    scope.onUpdateTime = function onUpdateTime(newCurrentTime) {
                        if (angular.isNumber(newCurrentTime) && API.totalTime) {
                            percentTime = 100 * (newCurrentTime / API.totalTime);

                            if (percentTime <= 100) {
                                elem.css('width', percentTime + '%');
                            }

                        } else {
                            elem.css('width', 0);
                        }
                    };
                    scope.$watch(
                        function() {
                            return API.currentTime;
                        },
                        function(newVal) {
                            scope.onUpdateTime(newVal);
                        }
                    );
                }
             }
        } ] );


})();

'use strict';
(function() {
    angular
        .module('jigsawCorpLms')
        .directive('rewindTen', [ '$filter', function($filter) {
            return {
                restrict: 'E',
                require: '^videogular',
                templateUrl: 'app/Features/learnerView/template/videoPlayerPage/partials/rewindTen/rewindTen.html',
                link: function(scope, elem, attrs, API) {

                    scope.API = API;
                    scope.rewindTen = function() {
                        var m, p, s;
                        scope.seekTo10 = $filter('date')(scope.API.currentTime, 'mm:ss', '+0000');
                        p = scope.seekTo10.split(':');
                        s = 0;
                        m = 1;
                        while (p.length > 0) {
                            s += m * parseInt(p.pop(), 10);
                            m *= 60;
                        }
                        s = s - 10;
                        if (s > 0) {
                            scope.API.seekTime(s);
                            scope.API.play();
                        } else {
                            scope.API.seekTime(0);
                            scope.API.play();
                        }
                    };
                }
            }
        } ]);

})();

'use strict';
angular.module('jigsawCorpLms')
    .directive('imgWidthThumbnail', [ function() {
        return {
            restrict: 'A',
            scope: {
                width: '@imgWidth'
            },
            link: function(scope, elem) {
                elem.on('load', function() {
                    var imgStrip = $(this)[ 0 ].naturalWidth;
                    var div = elem.parent();
                    div[ 0 ].style.width = imgStrip + 'px';
                });
            }
        }
    } ]);

'use strict';
angular.module( 'jigsawCorpLms' )
    .directive( 'vidCuepoints', [ function() {
        return {
            restrict: 'E',
            require: '^videogular',
            scope: {
                cuepoints: '=vgCuepointsConfig',
                weight: '=vgCuepointsWeight'
            },
            templateUrl: 'app/Features/learnerView/template/videoPlayerPage/partials/Cuepoints/vidCuePoints.html',
            link: function( scope, elem, attr, API ) {
                scope.calcLeft = function( cuepoint ) {
                    if ( API.totalTime === 0 ) {
                        return '-1000';
                    }
                    var videoLength = API.totalTime / 1000;
                    return ( cuepoint.start * 100 / videoLength ).toString();
                };
                scope.circleDia = function( cuepoint ) {
                    return ( cuepoint.weight );
                };
                scope.cuepointActivate = function cuepointActivate( newCurrentTime ) {
                    scope.currentTime = newCurrentTime / 1000;
                };
                scope.cuepointBuffered = function cuepointBuffered( bufferedTime ) {
                    scope.bufferEnd = bufferedTime / 1000;
                };
                scope.activeCue = function activeCue( cuepoint ) {
                    return ( cuepoint.start );
                }
                scope.$watch(
                    function() {
                        return API.currentTime;
                    },
                    function( newVal ) {
                        scope.cuepointActivate( newVal );
                    }
                );
                scope.$watch(
                    function() {
                        return API.bufferEnd;
                    },
                    function( newVal ) {
                        scope.cuepointBuffered( newVal );
                    }
                );
            }
        }
    } ] );

'use strict';
angular
    .module('jigsawCorpLms')
    .controller('widgetsBarCtrl', function($scope, fetchData) {

        fetchData.fetchBuyerWidgetsBarData().then(function(response) {

            $scope.bJourneyObj.widgetsBar = response.data;
            $scope.templateUrlGenerator($scope.bJourneyObj.widgetsBar.widgets);


            $scope.expandedWidgetsBar = false;
            $scope.bJourneyObj.widget = [];
            $scope.bJourneyObj.widget[1] = $scope.bJourneyObj.widgetsBar.widgets[0].checked;
            $scope.bJourneyObj.widget[2] = $scope.bJourneyObj.widgetsBar.widgets[1].checked;
            $scope.bJourneyObj.widget[3] = $scope.bJourneyObj.widgetsBar.widgets[2].checked;
            $scope.bJourneyObj.widget[4] = $scope.bJourneyObj.widgetsBar.widgets[3].checked;
            $scope.bJourneyObj.widget[5] = $scope.bJourneyObj.widgetsBar.widgets[4].checked;
        });


        $scope.changeStyle = function(event) {
            if ($scope.expandedWidgetsBar) {
                return { top: "-35px" }
            } else {
                return { top: "-85px" }
            }

        };

        $scope.openWidgetsBar = function() {
            if ($scope.activeTile != "") {
                $scope.tileClick($scope.activeTile);
            }
            $scope.expandedWidgetsBar = !$scope.expandedWidgetsBar;
            $scope.activeTile = "";
        };

        $scope.updatedWidget = function() {
            $scope.bJourneyObj.widgetsBar.widgets[0].checked = $scope.bJourneyObj.widget[1];
            $scope.bJourneyObj.widgetsBar.widgets[1].checked = $scope.bJourneyObj.widget[2];
            $scope.bJourneyObj.widgetsBar.widgets[2].checked = $scope.bJourneyObj.widget[3];
            $scope.bJourneyObj.widgetsBar.widgets[3].checked = $scope.bJourneyObj.widget[4];
            $scope.bJourneyObj.widgetsBar.widgets[4].checked = $scope.bJourneyObj.widget[5];
            $scope.expandedWidgetsBar = false;
            $scope.templateUrlGenerator($scope.bJourneyObj.widgetsBar.widgets);
        };


        $scope.slickConfig = {
            enabled: true,
            autoplay: false,
            draggable: true,
            autoplaySpeed: 3000,
            infinite: false,
            variableWidth: true,
            method: {},
            event: {
                afterChange: function(event, slick, currentSlide, nextSlide) {
                    $scope.currentIndex = currentSlide; // save current index each time
                }
            }
        };

        $scope.slideClipboardLeft = function() {
            $scope.slickConfig.method.slickNext();
        };

        $scope.slideClipboardRight = function() {
            $scope.slickConfig.method.slickPrev();
        };
    });
'use strict';
( function() {
    angular
        .module( 'jigsawCorpLms' )
        .config( routerConfig );

    /** @ngInject */
    function routerConfig( $stateProvider ) {
        $stateProvider
            .state( 'buyer.dashboard.trackProgress', {
                url: '/buyerdashboard/trackProgress',
                templateUrl: 'app/Features/buyerJourney/partials/buyerDashboard/templates/trackProgress/trackProgress.html'
            } );
    }

} )();

'use strict';
angular
    .module('jigsawCorpLms')
    .run(['$anchorScroll', function($anchorScroll) {
        $anchorScroll.yOffset = 50; // always scroll by 50 extra pixels
    }])
    .controller('skillsTileCtrl', function($http, $scope, $timeout, fetchData, $anchorScroll, $location, DataCache) {



        var user_data = DataCache.returnData('userData');

        $http.defaults.headers.common['Authorization'] = "Bearer " + user_data.jwttoken;
        $http.defaults.headers.common['Content-Type'] = "application/x-www-form-urlencoded";


        $scope.byList = false;
        $scope.byDisc = true;

        $scope.overlayActive = false;
        $scope.modeVar = 'monthly';
        $scope.initialLength = 4;
        $scope.showMore = true;

        $scope.bJourneyObj.dropdownData = [];
        $scope.skills = [];
        $scope.skillsLib = [];

        angular.copy($scope.bJourneyObj.dashDataskills, $scope.bJourneyObj.dropdownData);

        $scope.gotoAnchor = function(event) {

            var newHash = $(event.target).closest('.expanded-wrp');

            if ($location.hash() !== newHash) {
                $location.hash(newHash);
            } else {
                $anchorScroll();
            }

        };




        $timeout(function() {
            if ($scope.bJourneyObj.dashDataskills.learningSkills.length > 0) {

                for (var i = 0; i < $scope.bJourneyObj.dashDataskills.learningSkills.length; i++) {
                    $scope.skills.push($scope.bJourneyObj.dashDataskills.learningSkills[i]);
                }

                //  for (var j = 0; j < $scope.libSkills.learningSkills.length; j++)
                //  {
                //     $scope.skillsLib.push($scope.libSkills.learningSkills[j]);
                //  }

            }
        }, 200);


        var initializeDropdown = function() {

            var initialModel = {};
            //angular.copy( $scope.bJourneyObj.dropdownData[ 0 ], initialModel );

            initialModel.moduleName = null;
            initialModel.lpTitle = 'All';
            initialModel.dummy = 'i am dummy';
            $scope.bJourneyObj.dropdownData.unshift(initialModel);
            //$scope.bJourneyObj.selectLP = initialModel;

        };

        var data;
        var role = $scope.role;

        if ($scope.bJourneyObj.isHead) {

            data = { "clientId": $scope.id };
            $scope.byTeam = true;
            $scope.byPath = false;

        } else if ($scope.bJourneyObj.isManager) {

            data = { "fbUsername": $scope.fbId };
            //data={"teamId":$scope.id};
            $scope.byPath = true;
            $scope.byTeam = false;

        }


        fetchData.fetchSkillsDrillDownbyPath(data, role).then(function(response) {
            if (response.data.status !== "error") {

                $scope.skillsByPath = response.data;
                var skillsGPJsonArray = $scope.skillsByPath.learningSkills;
                var skillsMap = [];
                var initialModel = {};
                initialModel.lpTitle = 'All';

                for (var i = 0; i < skillsGPJsonArray.length; i++) {
                    var teamObj = skillsGPJsonArray[i];

                    if (skillsMap[teamObj.lpTitle] === undefined) {
                        var teamArr = [];
                        teamArr.push(teamObj);
                        skillsMap[teamObj.lpTitle] = teamArr;
                    } else {
                        skillsMap[teamObj.lpTitle].push(teamObj);
                    }

                }

                $scope.skillsPArray = [];
                $scope.skillsPArray.unshift(initialModel);

                for (var elem in skillsMap) {
                    var skillsObj = skillsMap[elem];
                    var graphValue = [];
                    var otherFields = [];
                    var sLearner = 0;
                    for (var i = 0; i < skillsObj.length; i++) {
                        sLearner = sLearner + skillsObj[i].SkillLearners;
                        graphValue.push({ "percentage": skillsObj[i].pctOfSkillsAcq, "skills": skillsObj[i].moduleShortTitle, "learners": skillsObj[i].SkillLearners });
                        otherFields.push({ "data": skillsObj[i] })
                    }
                    if (sLearner > 0) {
                        $scope.skillsPArray.push({ "lpTitle": elem, "graph": graphValue, "value": otherFields });
                    }


                }
            } else {
                console.log(response);
            }

        });

        fetchData.fetchSkillsDrillDownbyTeam(data, role).then(function(response) {

            if (response.data.status !== "error") {

                $scope.skillsByTeam = response.data;
                var skillsGPJsonArray = $scope.skillsByTeam.learningSkills;
                var skillsMap = [];
                var initialModel = {};
                initialModel.team = 'All';

                for (var i = 0; i < skillsGPJsonArray.length; i++) {
                    var teamObj = skillsGPJsonArray[i];
                    if (skillsMap[teamObj.teamName] === undefined) {
                        var teamArr = [];
                        skillsMap[teamObj.teamName] = teamArr;
                        skillsMap[teamObj.teamName].push(teamObj);
                    } else {
                        skillsMap[teamObj.teamName].push(teamObj);
                    }
                }

                $scope.skillsArray = [];
                $scope.sArray = [];
                $scope.sArray.unshift(initialModel);
                for (var elem in skillsMap) {

                    var skillsObj = skillsMap[elem];
                    var lpMap = [];

                    for (var k = 0; k < skillsObj.length; k++) {

                        var lpObj = skillsObj[k];

                        if (lpMap[lpObj.lpTitle] === undefined) {
                            var lpArr = [];
                            lpMap[lpObj.lpTitle] = lpArr;
                            lpMap[lpObj.lpTitle].push(lpObj);
                        } else {
                            lpMap[lpObj.lpTitle].push(lpObj);
                        }
                    }

                    var lpValue = [];

                    for (var ele in lpMap) {
                        lpValue.push({ "learningpath": ele, "data": lpMap[ele] });
                    }


                    $scope.lpDetails = [];
                    var graphValue = [];
                    var otherFields = [];

                    var lpArray = [];
                    for (var j = 0; j < lpValue.length; j++) {
                        //if(lpValue[j].SkillLearners)
                        //console.log(lpValue[j]);
                        var sLearner = 0;
                        var graphVal = [];
                        var value = [];
                        var dataVal = lpValue[j].data;
                        for (var k = 0; k < dataVal.length; k++) {
                            sLearner = sLearner + dataVal[k].SkillLearners;
                            graphVal.push({ "percentage": dataVal[k].pctOfSkillsAcq, "skills": dataVal[k].moduleShortTitle, "learners": dataVal[k].SkillLearners });
                            value.push({ "value": dataVal[k] });

                        }
                        if (sLearner > 0) {
                            lpArray.push({ "lp": lpValue[j].learningpath, "graph": graphVal, "value": value });
                        }

                    }
                    $scope.sArray.push({ "team": elem, "learningpath": lpArray });
                }
            } else {
                console.log(response);
            }
        });


        $scope.skillListViewClick = function(byTeam, byList) {

            $scope.byList = byList;
            $scope.byDisc = !byList;
            $scope.byTeam = byTeam;
            $scope.byPath = !byTeam;

            if ($scope.byList) {

                $timeout(function() {
                    var height = $('.bteam-list-view-wrp').height() + $('.bdashboard-tiles').height() - 220;
                    $('#btotal-learning-section').closest('.bdashboard-tiles').css('height', height);
                }, 200);
            } else {
                $timeout(function() {
                    var height = $('.bdashboard-tiles').height();
                    $('#btotal-learning-section').closest('.bdashboard-tiles').css('height', height);
                }, 200);
            }
        }



        $scope.activeSkillsFilterFunc = function(filterKey) {

            if ($scope.activeFilter == filterKey) {

                $scope.activeFilter = '';
                $scope.learnersTData = $scope.learners;

            } else {

                $scope.activeFilter = filterKey;
                $scope.learnersTData.usersForLp = $filter('orderBy')($scope.learnersTData.usersForLp, $scope.activeFilter, true);

            }
        };


        $scope.overlayActiveFunc = function() {
            $scope.overlayActive = !$scope.overlayActive;
        };

        if ($scope.bJourneyObj.isManager) {
            $scope.bJourneyObj.dashData.teamData = $scope.bJourneyObj.dashData.pathData;
            initializeDropdown();
        };

        $scope.filterSelectedLP = function(item) {
            if ($scope.bJourneyObj.selectLP && $scope.bJourneyObj.selectLP.lpTitle !== 'All') {

                if ($scope.bJourneyObj.selectLP.lpTitle === item.lpTitle) {
                    return item;
                }
            } else {
                return item;
            }
        };

        $scope.filterSelectedTeam = function(item) {
            if ($scope.bJourneyObj.selectTeam && $scope.bJourneyObj.selectTeam.teamName !== 'All') {

                if ($scope.bJourneyObj.selectTeam.teamName === item.teamName) {
                    return item;
                }
            } else {
                return item;
            }
        };

        $scope.selectedLPFunc = function(lp) {
            $timeout(function() {
                angular.element('.width-fifty-percent').css('height', 'auto');
                $scope.retrieveHieght();
                $scope.bJourneyObj.lHealthTableExpnd = false;

            }, 300);
        };

        $scope.selectedTeamFunc = function(lp) {
            $timeout(function() {
                angular.element('.width-fifty-percent').css('height', 'auto');
                $scope.retrieveHieght();
                $scope.bJourneyObj.lHealthTableExpnd = false;

            }, 300);
        };

        $scope.showMoreTopics = function(module) {
            $scope.showMore = !$scope.showMore;
            $scope.initialLength = module.length;
        };
        $scope.showLessTopics = function() {
            $scope.showMore = !$scope.showMore;
            $scope.initialLength = 3;
        };

        $scope.gotoAnchor1 = function() {

            $timeout(function() {

                var newHash = 'blearners-section';

                if ($location.hash() !== newHash) {
                    $location.hash(newHash);
                } else {
                    $anchorScroll();
                }

            }, 400);

        };

        var prevInd;
        //for path - showLearners method

        $scope.showLearnersForPath = function(id, index, mainTileIndex) {
            $scope.learnersLoaded = false;
            var moduleId = index + 1;
            if (index == 0) {
                index = 1;
            }

            if ($scope.bJourneyObj.isManager) {

                if ($scope.byPath) {
                    var l2pData = { "lpId_O": id, "fbUsername": $scope.fbId };
                    fetchData.skillLevelTwoByPath(l2pData).then(function(response) {
                        if (response.data.status !== "error") {
                            $scope.skillL2DatabyPath = response.data;
                            $scope.learnersLoaded = true;
                            $scope.learnerTable();
                            $scope.gotoAnchor1();
                        } else {
                            console.log(response);
                        }
                    });
                } else if ($scope.byTeam) {
                    var l2tData = { "teamId_O": id, "fbUsername": $scope.fbId };
                    fetchData.skillLevelTwoByTeam(l2tData).then(function(response) {
                        if (response.data.status !== "error") {

                            $scope.skillL2DatabyTeam = response.data;
                            $scope.learnersLoaded = true;
                            $scope.learnerTable();
                        } else {
                            console.log(response);
                        }

                    });
                }


                var sdata = { "fbUsername": $scope.fbId, "lpId": id };

                $scope.learnerTable = function() {
                    var angularEle = angular.element('.width-fifty-percent');
                    var selectItemOffset = angularEle[index - 1].offsetTop;
                    var ind = 0;

                    $scope.currentTable = index;

                    if (index == prevInd) {
                        $scope.bJourneyObj.lHealthTableExpnd = !$scope.bJourneyObj.lHealthTableExpnd;
                    } else {
                        $scope.bJourneyObj.lHealthTableExpnd = true;
                    }

                    $scope.resetTileheight(angularEle);

                    $timeout(function() {
                        var height = $('.width-fifty-percent').height() + $('.blearners-section').height() + 60;
                        if ($scope.bJourneyObj.lHealthTableExpnd) {
                            while (ind < angularEle.length) {
                                if (angularEle[ind].offsetTop == selectItemOffset) {
                                    angularEle[ind].style.height = height + 'px';
                                } else {
                                    angularEle[ind].style.height = 'auto';
                                }
                                ind++;
                            }
                        }
                        $scope.retrieveHieght();
                    }, 200);
                    prevInd = index;
                };

            }
            $scope.tileClick(mainTileIndex, 'expand');

        };
        // ends here


        $scope.showLearners = function(id, index, mainTileIndex) {
            $scope.learnersLoaded = false;
            var moduleId = index + 1;

            if ($scope.bJourneyObj.isManager) {

                if ($scope.byPath) {
                    var l2pData = { "lpId_O": id, "fbUsername": $scope.fbId };
                    fetchData.skillLevelTwoByPath(l2pData).then(function(response) {
                        if (response.data.status !== "error") {
                            $scope.skillL2DatabyPath = response.data;
                            $scope.learnersLoaded = true;
                            $scope.learnerTable();
                            $scope.gotoAnchor1();
                        } else {
                            console.log(response);
                        }
                    });
                } else if ($scope.byTeam) {
                    var l2tData = { "teamId_O": id, "fbUsername": $scope.fbId };
                    fetchData.skillLevelTwoByTeam(l2tData).then(function(response) {
                        if (response.data.status !== "error") {
                            $scope.skillL2DatabyTeam = response.data;
                            $scope.learnersLoaded = true;
                            $scope.learnerTable();
                        } else {
                            console.log(response);
                        }

                    });
                }


                var sdata = { "fbUsername": $scope.fbId, "lpId": id };

                $scope.learnerTable = function() {
                    var angularEle = angular.element('.width-fifty-percent');
                    var selectItemOffset = angularEle[index].offsetTop;
                    var ind = 0;

                    $scope.currentTable = index;

                    if (index == prevInd) {
                        $scope.bJourneyObj.lHealthTableExpnd = !$scope.bJourneyObj.lHealthTableExpnd;
                    } else {
                        $scope.bJourneyObj.lHealthTableExpnd = true;
                    }

                    $scope.resetTileheight(angularEle);

                    $timeout(function() {
                        var height = $('.width-fifty-percent').height() + $('.blearners-section').height() + 60;
                        if ($scope.bJourneyObj.lHealthTableExpnd) {
                            while (ind < angularEle.length) {
                                if (angularEle[ind].offsetTop == selectItemOffset) {
                                    angularEle[ind].style.height = height + 'px';
                                } else {
                                    angularEle[ind].style.height = 'auto';
                                }
                                ind++;
                            }
                        }
                        $scope.retrieveHieght();

                    }, 200);
                    $timeout(function() {
                        $scope.retrieveHieght();
                    }, 3000);

                    prevInd = index;
                };

            }
            $scope.tileClick(mainTileIndex, 'expand');

        };

        $scope.resetTileheight = function(elements) {
            for (var i = 0; i < elements.length; i++) {
                elements[i].style.height = 'auto';
            };
        };


        // export excel function

        //   $scope.exportData = function () {
        //
        //      var blob = new Blob([angular.element('.bteam-list-view-wrp').html()], {
        //          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
        //      });
        //
        //      saveAs(blob, "Report.xls");
        // };

    });
'use strict';
angular
    .module('jigsawCorpLms')
    .controller('roiTileCtrl', function($scope) {
        $scope.overlayActive = false;

        $scope.overlayActiveFunc = function() {
            $scope.overlayActive = !$scope.overlayActive;
        };
    });
'use strict';
( function() {
    angular
        .module( 'jigsawCorpLms' )
        .config( routerConfig );

    /** @ngInject */
    function routerConfig( $stateProvider ) {
        $stateProvider
            .state( 'buyer.dashboard.purchaseHistory', {
                url: '/buyerdashboard/purchaseHistory',
                templateUrl: 'app/Features/buyerJourney/partials/buyerDashboard/templates/purchaseHistory/purchaseHistory.html',
                controller: 'purchaseHistoryCtrll'
            } );
    }

} )();

'use strict';
angular
    .module('jigsawCorpLms')
    .controller('purchaseHistoryCtrll', function($http, $scope, fetchData, $state, DataCache) {
        //var itrLength = $scope.bJourneyObj.purchaseHistory.length;

        var user_data = DataCache.returnData('userData');

        $http.defaults.headers.common['Authorization'] = "Bearer " + user_data.jwttoken;
        $http.defaults.headers.common['Content-Type'] = "application/x-www-form-urlencoded";


        var todaysDate = moment(new Date());
        var nextMonthDate = todaysDate.add(1, 'M');
        var nextMonthFormattedDate = nextMonthDate.format('YYYY/MM/DD');
        var expiryDate;
        var tempDate;
        var data;

        if ($scope.bJourneyObj.isHead) {
            data = { "clientId": $scope.id };
        } else if ($scope.bJourneyObj.isManager) {
            data = { "fbUsername": $scope.fbId };
        }

        $scope.activeCtrl =

            fetchData.fetchBuyerPurchaseHistoryData(data).then(function(response) {
                $scope.bjPurchaseHistory = response.data;
                $scope.bjPurchaseHistory.purchaseHistory.filter(function(value) {
                    tempDate = moment(value.expiryDate);
                    expiryDate = tempDate.format('YYYY/MM/DD');
                    if (moment(nextMonthFormattedDate).isAfter(expiryDate) || moment(nextMonthFormattedDate).isSame(expiryDate)) {
                        value.initiateDateWarning = true;
                    }
                });
            });
        // console.log($scope.bJourneyObj.purchaseHistory);
        //   $scope.bJourneyObj.purchaseHistory.filter( function( value ) {
        //       console.log(value);
        //       tempDate = moment( value.expiryDate );
        //       expiryDate = tempDate.format( 'YYYY/MM/DD' );
        //       if ( moment( nextMonthFormattedDate ).isAfter( expiryDate ) || moment( nextMonthFormattedDate ).isSame( expiryDate ) ) {
        //           value.initiateDateWarning = true;
        //       }
        //   } );

        $scope.backButton = function() {
            //alert("back button clicked");
            $state.go('buyer.dashboard.trackProgress');
        }
    });
'use strict';
angular
    .module('jigsawCorpLms')
    .controller('licenseManagementCtrl', function($http, $scope, $state, fetchData, $anchorScroll, $location, $rootScope, $timeout, DataCache) {


        var user_data = DataCache.returnData('userData');

        $http.defaults.headers.common['Authorization'] = "Bearer " + user_data.jwttoken;
        $http.defaults.headers.common['Content-Type'] = "application/x-www-form-urlencoded";

        $scope.byDisc = true;
        $scope.byList = false;
        $scope.overlayActive = false;

        $scope.currentGraphDataIndex = 2;
        $scope.previousGraphBtn = false;
        $scope.nextGraphBtn = false;


        $scope.modeVar = 'monthly';
        $scope.bJourneyObj.selectedLPath = '';
        var data;
        var role = $scope.role;

        $timeout(function() {
            $scope.gotoAnchor = function(event) {
                var newHash = event.target.id;
                $location.hash(newHash);
                $anchorScroll();
            };
        }, 30);


        if ($scope.bJourneyObj.isHead) {

            data = { "clientId": $scope.id };
            $scope.byTeam = true;
            $scope.byPath = false;

        } else if ($scope.bJourneyObj.isManager) {

            data = { "fbUsername": $scope.fbId };
            $scope.byTeam = false;
            $scope.byPath = true;

        }


        // drill down functions start here

        fetchData.fetchBJLicenseMngBP(data, role).then(function(response) {


            $scope.LMByPathGraph = response.data;


            var dataValue = response.data;
            var unAllocatedData = [];
            var unAllocatedLicences = 0;

            $scope.licenseData = [];
            $scope.final = [];

            for (var i = 0; i < dataValue.licenceMgmtGraph.length; i++) {

                unAllocatedLicences += dataValue.licenceMgmtGraph[i].unUsedLicences;
                $scope.licenseData.push(dataValue.licenceMgmtGraph[i]);

            }

            unAllocatedData.push({ "lpTitle": "Unallocated", "usedLicences": unAllocatedLicences });
            $scope.UnallocatedLicense = unAllocatedLicences;
            $scope.final.push({ "licenceMgmtGraph": $scope.licenseData });

        });

        fetchData.fetchBJLicenseMngBT(data, role).then(function(response) {

            $scope.LMByTeamGraph = response.data;


        });


        // first level drill down ends here


        // if($scope.bJourneyObj.isHead ){
        //   fetchData.fetchLMDDpathTV(data,role).then(function( response){
        //       $scope.bJourneyObj.lhlicensePTV=response.data;
        //   });
        //
        //   fetchData.fetchLMDDpathLV(data,role).then(function( response){
        //       $scope.bJourneyObj.lhlicensePLV=response.data;
        //   });
        //
        //   fetchData.fetchLMDDteamTV(data).then(function( response){
        //       $scope.bJourneyObj.lhlicenseTV=response.data;
        //   });
        //
        //   fetchData.fetchLMDDteamLV(data).then(function( response){
        //       $scope.bJourneyObj.lhlicenseLV=response.data;
        //   });
        // }
        // else if($scope.bJourneyObj.isManager){
        //   fetchData.fetchLMDDpathTV(data,role).then(function( response){
        //       $scope.bJourneyObj.lhlicensePTsV=response.data;
        //   });
        //
        //   fetchData.fetchLMDDpathLV(data,role).then(function( response){
        //       $scope.bJourneyObj.lhlicensePLV=response.data;
        //   });
        // }


        $scope.modeChangeFunc = function(mode) {
            $scope.modeVar = mode;
            $scope.overlayActive = !$scope.overlayActive;
        };

        $scope.overlayActiveFunc = function() {
            $scope.overlayActive = !$scope.overlayActive;
        };

        $scope.optionSelected = function() {



            $scope.bJourneyObj.skillTableExpnd = false; // collapses further expanded states of tiles - below three lines
            $scope.bJourneyObj.lHealthTableExpnd = false;
            $rootScope.$broadcast('closeTiles');

            if (!$scope.isMediumScrennDevice && !$scope.isMobilePhoneDevice) {
                $scope.bJourneyObj.currentTab = 'learnersView';
                $state.go('buyer.dashboard.learnersView');
            } else {
                window.alert('This view is available in desktop only');
            }
            // $scope.bJourneyObj.currentTab = 'learnersView';
            // $state.go( 'buyer.dashboard.learnersView' );
        };

        $scope.purchaseHistory = function() {
            $scope.bJourneyObj.skillTableExpnd = false; // collapses further expanded states of tiles - below three lines
            $scope.bJourneyObj.lHealthTableExpnd = false;
            $rootScope.$broadcast('closeTiles');

            $state.go('buyer.dashboard.purchaseHistory');
        };

        /*  $scope.gradientColor=function(){
                console.log("Inside gradientColor");
                var totalLicense=$scope.LMData.licenceMgmtContents[0].purchasedLicences;
                var unallocatedLicense=$scope.LMData.licenceMgmtContents[0].unAllocatedLicences;
                var unallocatedPercentage=(unallocatedLicense*100)/totalLicense;
                var remainingPerc=100 -unallocatedPercentage;
                console.log("done 1->");
                angular.element(document.querySelector('.unallocatedLicense')).css('background','linear-gradient(180deg, #ab0000 '+unallocatedPercentage+'%, #1ad21e '+remainingPerc+'%)');
                angular.element(document.querySelector('.unallocatedLicense')).css('-webkit-background-clip',' text');
                angular.element(document.querySelector('.unallocatedLicense')).css('-webkit-text-fill-color','transparent');
                console.log("done 2->");
          }*/

        $scope.chartDataFunc = function(itrLength) {
            if (itrLength - 2 > 0) {
                $scope.previousGraphBtn = true;
            } else {
                $scope.previousGraphBtn = false;
            };
            if (itrLength < $scope.LMData.licenceMgmtContents.length) {
                $scope.nextGraphBtn = true;
            } else {
                $scope.nextGraphBtn = false;
            };

            $scope.learningHealthChartData = [];
            for (var i = itrLength - 2; i < itrLength; i++) {
                if ($scope.LMData.licenceMgmtContents[i]) {
                    $scope.learningHealthChartData.push($scope.LMData.licenceMgmtContents[i]);
                } else {
                    break;
                }
            };
        };

        $scope.chartDataFunc($scope.currentGraphDataIndex);

        $scope.fetchNextGraphData = function() {

            if ($scope.currentGraphDataIndex < $scope.LMData.licenceMgmtContents.length) {
                $scope.currentGraphDataIndex++;
            }

            $scope.chartDataFunc($scope.currentGraphDataIndex);
        };

        $scope.fetchPreviousGraphData = function() {

            if ($scope.currentGraphDataIndex - 2 != 0) {
                $scope.currentGraphDataIndex--;
            }

            $scope.chartDataFunc($scope.currentGraphDataIndex);
        };

    });
'use strict';
angular
    .module('jigsawCorpLms')
    .run(['$anchorScroll', function($anchorScroll) {
        $anchorScroll.yOffset = 50; // always scroll by 50 extra pixels
    }])
    .controller('learningHoursCtrl', function($http, $scope, fetchData, $timeout, $location, $anchorScroll, DataCache) {


        var user_data = DataCache.returnData('userData');

        $http.defaults.headers.common['Authorization'] = "Bearer " + user_data.jwttoken;
        $http.defaults.headers.common['Content-Type'] = "application/x-www-form-urlencoded";

        $scope.byList = false;
        $scope.byDisc = true;
        $scope.overlayActive = false;
        $scope.filterActive = false;
        $scope.currentGraphDataIndex = 5;
        $scope.previousGraphBtn = false;
        $scope.nextGraphBtn = false;
        $scope.leftExpanded = 0;

        var data;
        var role;

        // my changes
        if ($scope.bJourneyObj.isHead) {
            data = { "clientId": $scope.id };
            role = $scope.role;
            $scope.byTeam = true;
            $scope.byPath = false;
        } else if ($scope.bJourneyObj.isManager) {
            data = { "fbUsername": $scope.fbId };

            //data={"teamId":$scope.id};
            role = $scope.role;
            $scope.byTeam = false;
            $scope.byPath = true;
        }



        $scope.listViewClick = function(event, byList, byTeam) {

            $scope.byList = byList;
            $scope.byDisc = !byList;
            $scope.byTeam = byTeam;
            $scope.byPath = !byTeam;

            if ($scope.byList) {

                $timeout(function() {
                    var height = $('.bteam-list-view-wrp').height() + $('.bdashboard-tiles').height() - 200;
                    if (height > 679) {
                        $(event.target).closest('.bdashboard-tiles').css('height', height);
                    } else {
                        height = 680;
                        $(event.target).closest('.bdashboard-tiles').css('height', height);
                    }

                }, 200);
            } else {
                $timeout(function() {
                    var height = $('.bexpanded-graph-wrp').height() + $('.bdashboard-tiles').height() - 200;
                    $(event.target).closest('.bdashboard-tiles').css('height', height);
                }, 200);
            }
        }



        $scope.graphViewClick = function(event) {

            $timeout(function() {
                var height = $('.bexpanded-graph-wrp').height() + $('.bdashboard-tiles').height() - 200;
                $(event.target).closest('.bdashboard-tiles').css('height', height);
            }, 200);
        }

        $scope.gotoAnchor1 = function() {

            $timeout(function() {

                var newHash = 'blearners-section';

                if ($location.hash() !== newHash) {
                    $location.hash(newHash);
                } else {
                    $anchorScroll();
                }

            }, 400);

        };


        fetchData.LearningHrsLevelOnetableView(data, role).then(function(response) {


            if (response.data.status !== "error") {
                $scope.lHrsLevel1TV = response.data;
            } else {
                console.log(response);
            }
        });


        fetchData.LearningHrsLevelOnetableViewByTeam(data, role).then(function(response) {

            if (response.data.status !== "error") {
                $scope.lHrsLevel1TVByTeam = response.data;
            } else {
                console.log(response);
            }
        });

        fetchData.fetchLHrsDrillDownByTeam(data, role).then(function(response) {

            if (response.data.status !== "error") {
                $scope.lhrsByTeam = response.data;
                var lpHrsGJsonArray = $scope.lhrsByTeam.TotalLearningHrsGraph;
                $scope.lhrsG = [];
                $scope.GraphData = [];
                $scope.learningHourPanelData = [];
                var totalHoursTeamMap = [];
                for (var i = 0; i < lpHrsGJsonArray.length; i++) {

                    var teamObj = lpHrsGJsonArray[i];

                    if (totalHoursTeamMap[teamObj.teamName] === undefined) {
                        var teamArr = [];
                        teamArr.push(teamObj);
                        totalHoursTeamMap[teamObj.teamName] = teamArr;
                    } else {
                        totalHoursTeamMap[teamObj.teamName].push(teamObj);
                    }
                }

                $scope.lhrsArray = [];
                $scope.lhrsobj = [];

                for (var elem in totalHoursTeamMap) {


                    var lhrsObj = totalHoursTeamMap[elem];
                    $scope.lhrsobj.push({ "data": lhrsObj });
                    var graphValue = [];
                    var otherFields = [];
                    var percentage = 0;
                    var isFirst = true;
                    var tas = 0;

                    for (var i = 0; i < lhrsObj.length; i++) {
                        if (lhrsObj[i].hoursExpected == 0) {
                            percentage = 0;
                        } else {
                            percentage = lhrsObj[i].hours / lhrsObj[i].hoursExpected * 100;
                        }
                        tas = tas + lhrsObj[i].timeAlreadySpent;
                        graphValue.push({ "hours": lhrsObj[i].hours, "weekNum": lhrsObj[i].weekNum, "percentageChange": Math.abs(percentage) });
                        otherFields.push({ "data": lhrsObj[i] })
                    }
                    $scope.lhrsArray.push({ "teamName": elem, "graph": graphValue, "timespent": lhrsObj[0].timeAlreadySpent, "value": otherFields });
                }
            } else {
                console.log(response);
            }
        });


        fetchData.fetchLHrsDrillDownByPath(data, role).then(function(response) {
            if (response.data.status !== "error") {

                $scope.lhrsByPath = response.data;
                var lpHrsGPJsonArray = $scope.lhrsByPath.TotalLearningHrsGraph;
                $scope.lhrsG = [];
                $scope.GraphData = [];
                $scope.learningHourPanelData = [];
                var totalHoursTeamMap = [];
                for (var i = 0; i < lpHrsGPJsonArray.length; i++) {

                    var teamObj = lpHrsGPJsonArray[i];
                    if (totalHoursTeamMap[teamObj.lpTitle] === undefined) {
                        var teamArr = [];
                        teamArr.push(teamObj);
                        totalHoursTeamMap[teamObj.lpTitle] = teamArr;
                    } else {
                        totalHoursTeamMap[teamObj.lpTitle].push(teamObj);
                    }
                }
                $scope.lhrsPArray = [];
                for (var elem in totalHoursTeamMap) {
                    var lhrsObj = totalHoursTeamMap[elem];
                    var graphValue = [];
                    var otherFields = [];
                    var percentage = 0;
                    var pathHours = 0;
                    for (var i = 0; i < lhrsObj.length; i++) {
                        if (lhrsObj[i].hoursExpected == 0) {
                            percentage = 0;
                        } else {
                            percentage = ((lhrsObj[i].hoursRequired - lhrsObj[i].hours) / lhrsObj[i].hoursRequired) * 100;
                        }
                        graphValue.push({ "hours": lhrsObj[i].hours, "weekNum": lhrsObj[i].weekNum, "percentageChange": Math.abs(percentage) });
                        otherFields.push({ "data": lhrsObj[i] });
                        pathHours = pathHours + lhrsObj[i].timeAlreadySpent;
                    }
                    if (pathHours > 0) {
                        $scope.lhrsPArray.push({ "lpTitle": elem, "graph": graphValue, "timespent": lhrsObj[0].timeAlreadySpent, "value": otherFields });
                    }
                }
            } else {
                console.log(response);
            }
        });







        //changes end here





        /*  fetchData.fetchLHrsDrillDown(data).then(function( response){
              $scope.bJourneyObj.lhrsData=response.data;
          });

          fetchData.fetchLHrsDrillDownGraph(data).then(function( response){
              $scope.bJourneyObj.lhrsGraphData=response.data;
          });*/

        $scope.chartDataFunc = function(itrLength) {
            if (itrLength - 5 > 0) {
                $scope.previousGraphBtn = true;
            } else {
                $scope.previousGraphBtn = false;
            };
            if (itrLength < $scope.bJourneyObj.dashDataHrs.learningHrs.length) {
                $scope.nextGraphBtn = true;
            } else {
                $scope.nextGraphBtn = false;
            };
            $scope.learningHoursChartData = [];
            for (var i = itrLength - 5; i < itrLength; i++) {
                if ($scope.bJourneyObj.dashDataHrs.learningHrs[i]) {

                    $scope.learningHoursChartData.push($scope.bJourneyObj.dashDataHrs.learningHrs[i]);
                } else {
                    break;
                }
            };
        };
        $scope.chartDataFunc($scope.currentGraphDataIndex);

        $scope.fetchNextGraphData = function() {
            if ($scope.currentGraphDataIndex < $scope.bJourneyObj.dashDataHrs.learningHrs.length) {
                $scope.currentGraphDataIndex++;
            }
            $scope.chartDataFunc($scope.currentGraphDataIndex);
        };

        $scope.fetchPreviousGraphData = function() {
            if ($scope.currentGraphDataIndex - 5 != 0) {
                $scope.currentGraphDataIndex--;
            }
            $scope.chartDataFunc($scope.currentGraphDataIndex);
        };

        $scope.overlayActiveFunc = function() {
            $scope.overlayActive = !$scope.overlayActive;
        };

        $scope.overlayFilter = function() {
            $scope.filterActive = !$scope.filterActive;
        };

        if ($scope.bJourneyObj.isManager) {
            $scope.bJourneyObj.dashData.teamData = $scope.bJourneyObj.dashData.pathData;
        };

        var prevInd;
        $scope.showLearners = function(lpId, index, mainTileIndex) {
            if ($scope.bJourneyObj.isManager) {
                $scope.learnersLoaded = false;
                if ($scope.byPath) {
                    var l2pData = { "lpId_O": lpId, "fbUsername": $scope.fbId };
                    fetchData.LearningHrsLevelTwoByPath(l2pData).then(function(response) {

                        if (response.data.status !== "error") {

                            $scope.lHrsLevel2PV = response.data;
                            $scope.learnersLoaded = true;
                            $scope.learnerTable();
                            $scope.gotoAnchor1();
                        } else {
                            console.log(response);
                        }
                    });
                } else if ($scope.byTeam) {
                    var l2tData = { "teamId_O": lpId, "fbUsername": $scope.fbId };

                    fetchData.LearningHrsLevelTwoByTeam(l2tData).then(function(response) {
                        if (response.data.status !== "error") {
                            $scope.lHrsLevel2TV = response.data;
                            $scope.learnersLoaded = true;
                            $scope.learnerTable();
                            $scope.gotoAnchor1();
                        } else {
                            console.log(response);
                        }
                    });
                }

                $scope.learnerTable = function() {
                    var angularEle = angular.element('.width-fifty-percent');
                    var selectItemOffset = angularEle[index].offsetTop;
                    var ind = 0;

                    $scope.currentTable = index;

                    if (index == prevInd) {
                        $scope.bJourneyObj.lHealthTableExpnd = !$scope.bJourneyObj.lHealthTableExpnd;
                    } else {
                        $scope.bJourneyObj.lHealthTableExpnd = true;
                    }

                    $scope.resetTileheight(angularEle);

                    $timeout(function() {
                        var height = $('.width-fifty-percent')[index].clientHeight + $('.blearners-section').height();

                        if ($scope.bJourneyObj.lHealthTableExpnd) {
                            while (ind < angularEle.length) {
                                if (angularEle[ind].offsetTop == selectItemOffset) {
                                    angularEle[ind].style.height = height + 'px';
                                } else {
                                    angularEle[ind].style.height = 'auto';
                                }
                                ind++;
                            }
                        }
                        $scope.retrieveHieght();
                    }, 200);
                    prevInd = index;
                }
            }
            $timeout(function() {
                $scope.tileClick(mainTileIndex, 'expand');
            }, 300);
        };

    });
'use strict';
angular
    .module('jigsawCorpLms')
    .run(['$anchorScroll', function($anchorScroll) {
        $anchorScroll.yOffset = 50; // always scroll by 50 extra pixels
    }])
    .controller('learningHealthCtrl', function($http, $scope, $timeout, fetchData, DataCache, $sce, $rootScope, $anchorScroll, $location) {


        var user_data = DataCache.returnData('userData');

        $http.defaults.headers.common['Authorization'] = "Bearer " + user_data.jwttoken;
        $http.defaults.headers.common['Content-Type'] = "application/x-www-form-urlencoded";

        $scope.byTeam = true;
        $scope.byPath = false;
        $scope.byList = false;
        $scope.byDisc = true;

        $scope.overlayActive = false;
        $scope.filterActive = false;

        $scope.currentGraphDataIndex = 5;
        $scope.previousGraphBtn = false;
        $scope.nextGraphBtn = false;

        $scope.beforeNotifySuccess = true;
        $scope.afterNotifySuccess = false;

        $scope.NotifyScreen = $sce.trustAsResourceUrl('app/Features/buyerJourney/partials/buyerDashboard/templates/learningHealthTile/notifyUser/notifyUser.html');

        if ($scope.bJourneyObj.isManager) {
            $scope.bJourneyObj.dashData.teamData = "";
        };



        var role = $scope.role;
        var data;
        var ddData;

        if ($scope.bJourneyObj.isHead) {
            ddData = { "clientId": $scope.id };
        } else if ($scope.bJourneyObj.isManager) {
            ddData = { "fbUsername": $scope.fbId };
        }

        //First level drill down functions start here


        fetchData.fetchLHDrillDown(ddData, role).then(function(response) {
            $scope.bJourneyObj.lhDrillData = response.data;
        });

        fetchData.fetchLHDrillDownByPath(ddData, role).then(function(response) {
            $scope.bJourneyObj.lhDrillDataByPath = response.data;
        });

        // first level drill down ends here


        // second level drill down starts here




        // second level drill down ends here

        $scope.chartDataFunc = function(itrLength) {
            if (itrLength - 5 > 0) {
                $scope.previousGraphBtn = true;
            } else {
                $scope.previousGraphBtn = false;
            };
            if (itrLength < $scope.bJourneyObj.dashData.LearningHealth.length) {
                $scope.nextGraphBtn = true;
            } else {
                $scope.nextGraphBtn = false;
            };

            $scope.learningHealthChartData = [];
            for (var i = itrLength - 5; i < itrLength; i++) {
                if ($scope.bJourneyObj.dashData.LearningHealth[i]) {
                    $scope.learningHealthChartData.push($scope.bJourneyObj.dashData.LearningHealth[i]);
                } else {
                    break;
                }
            };
        };


        $scope.gotoAnchor1 = function() {

            $timeout(function() {

                var newHash = 'blearners-section';
                if ($location.hash() !== newHash) {
                    $location.hash(newHash);
                } else {
                    $anchorScroll();
                }

            }, 400);

        };

        $scope.chartDataFunc($scope.currentGraphDataIndex);

        $scope.fetchNextGraphData = function() {

            if ($scope.currentGraphDataIndex < $scope.bJourneyObj.dashData.LearningHealth.length) {
                $scope.currentGraphDataIndex++;
            }

            $scope.chartDataFunc($scope.currentGraphDataIndex);
        };

        $scope.fetchPreviousGraphData = function() {

            if ($scope.currentGraphDataIndex - 5 != 0) {
                $scope.currentGraphDataIndex--;
            }

            $scope.chartDataFunc($scope.currentGraphDataIndex);
        };

        $scope.checkLearnersFunc = function(parentIndex, state, status) {

            var itr = $scope.bJourneyObj.dashData.teamData[parentIndex].lpLearnersData;

            for (var i = 0; i < itr.length; i++) {
                if (itr[i].status == status) {
                    itr[i].checked = state;
                }

            };
        };

        $scope.overlayActiveFunc = function() {
            $scope.overlayActive = !$scope.overlayActive;
        };

        $scope.overlayFilter = function() {
            $scope.filterActive = !$scope.filterActive;
        };

        $scope.enableNotifyFunc = function() {

            $scope.teamIds = [];
            var itrLength = $scope.bJourneyObj.lhDrillData.LearningHealthByTeam.length;

            for (var i = 0; i < itrLength; i++) {
                if ($scope.bJourneyObj.team[$scope.bJourneyObj.lhDrillData.LearningHealthByTeam[i].teamId]) {
                    $scope.teamIds.push($scope.bJourneyObj.lhDrillData.LearningHealthByTeam[i].teamId);
                }
            };

        };


        // $timeout(function()
        // {
        //       $scope.toggleNotifyScreen = function()
        //       {
        //           $scope.shwNotifyScreen = !$scope.shwNotifyScreen;
        //       }
        //
        // },200);

        var prevInd;
        var l2data;

        $scope.showLearners = function(id, index, mainTileIndex) {
            $scope.learnersLoaded = false;

            // if($scope.bJourneyObj.isHead)
            // {
            //       l2data={"clientId":$scope.id,"lpId":id};
            //
            //       fetchData.LHByPathLearnerDetails(l2data,role).then(function (response)
            //       {
            //             $scope.byPathLD=response.data;
            //       });
            // }
            if ($scope.bJourneyObj.isManager) {
                if ($scope.byPath) {
                    l2data = { "fbUsername": $scope.fbId, "lpId_O": id };

                    fetchData.LHByPathLearnerDetails(l2data, role).then(function(response) {
                        $scope.byPathLD = response.data;
                        $scope.learnersLoaded = true;
                        $scope.learnerTable();
                        $scope.gotoAnchor1();
                    });

                } else {
                    l2data = { "fbUsername": $scope.fbId, "teamId_O": id };
                    fetchData.LHByTeamLearnerDetails(l2data, role).then(function(response) {
                        $scope.byPathLD = response.data;
                        $scope.learnerTable();
                        $scope.gotoAnchor1();
                        $scope.learnersLoaded = true;

                    });
                }


            }

            //  $rootScope.$on("learner-loaded",function(){
            $scope.learnerTable = function() {

                var angularEle = angular.element('.bpie-chart-section');
                var selectItemOffset = angularEle[index].offsetTop;
                var ind = 0;


                $scope.currentTable = index;
                if (index == prevInd) {
                    $scope.bJourneyObj.lHealthTableExpnd = !$scope.bJourneyObj.lHealthTableExpnd;
                } else {
                    $scope.bJourneyObj.lHealthTableExpnd = true;
                }

                $scope.resetTileheight(angularEle);

                $timeout(function() {
                    var height = $('.bpie-chart-section')[index].clientHeight + $('.blearners-section').height();
                   
                    if ($scope.bJourneyObj.lHealthTableExpnd) {
                        while (ind < angularEle.length) {
                            if (angularEle[ind].offsetTop == selectItemOffset) {
                                angularEle[ind].style.height = height + 'px';
                            } 
                            //else {
                                //angularEle[ind].style.height = auto;
                            // }
                            ind++;
                        }
                    }
                    $scope.retrieveHieght();
                }, 200);
                prevInd = index;
            }
            $timeout(function() {
                $scope.tileClick(mainTileIndex, 'expand');
            }, 300);

        };

        $scope.changeView = function(team, path) {
            $scope.byTeam = team;
            $scope.byPath = path;
        }

    });
'use strict';
( function() {
    angular
        .module( 'jigsawCorpLms' )
        .config( routerConfig );

    /** @ngInject */
    function routerConfig( $stateProvider ) {
        $stateProvider
            .state( 'buyer.dashboard.learnersView', {
                url: '/buyerdashboard/learnersView',
                templateUrl: 'app/Features/buyerJourney/partials/buyerDashboard/templates/learnersView/learnersView.html'
            } );
    }

} )();

'use strict';
angular
    .module('jigsawCorpLms')
    .controller('learnersViewCtrl', function($scope, $window, $filter, $anchorScroll, $location, fetchData, $timeout, $sce, DataCache, $http, $rootScope) {

        var ldata = { "fbUsername": $scope.fbId };

        $scope.authData = DataCache.returnData("userData");
        $http.defaults.headers.common['Authorization'] = "Bearer " + $scope.authData.jwttoken;
        $http.defaults.headers.common['Content-Type'] = "application/x-www-form-urlencoded";


        $rootScope.activeController = "noIntro";
        $rootScope.$broadcast('new-controller-loaded');

        $scope.showExpandedLearnersView = false;

        fetchData.BJlearners(ldata).then(function(response) {
            if (response.data.status !== "error") {

                $scope.learnersTData = response.data;
                //console.log($scope.learnersTData);
                $scope.learners = angular.copy($scope.learnersTData);
                $scope.activeFilter = '';
                $scope.lPDropdown = [];
                angular.copy($scope.learnersTData.usersForLp, $scope.lPDropdown);

                if ($scope.bJourneyObj.selectedLPath == '') {
                    $scope.lPDropdown[0].thisIsFirstItem = true;
                    $scope.bJourneyObj.selectModel = $scope.lPDropdown[0];
                } else {
                    var itrLength = $scope.lPDropdown;
                    for (var i = 0; i < itrLength.length; i++) {
                        if ($scope.lPDropdown[i].lpName == $scope.bJourneyObj.selectedLPath) {
                            $scope.lPDropdown[0].thisIsFirstItem = true;
                            $scope.bJourneyObj.selectModel = $scope.lPDropdown[i];
                        }
                    };
                };
                var sort = "false";
                $scope.activeFilterFunc = function(filterKey) {
                    if ($scope.activeFilter == filterKey) {
                        $scope.activeFilter = '';
                        $scope.learnersTData = $scope.learners;
                    } else {
                        $scope.activeFilter = filterKey;
                        $scope.learnersTData.usersForLp = $filter('orderBy')($scope.learnersTData.usersForLp, $scope.activeFilter, true);
                    }
                };

                $scope.learnersDetails = function(id, path) {
                    $scope.bJourneyObj.selectModel = path;
                    $location.hash(id);
                    $anchorScroll();
                };

                $scope.enableNotify = function() {
                    // var learner_ids = [];
                    // var itrLength = $scope.learnersTData.usersForLp.length;
                    // for ( var i = 0; i < itrLength; i++ ) {
                    //     if ( $scope.bJourneyObj.learner[ $scope.learnersTData.usersForLp[ i ].id ] ) {
                    //         learner_ids.push( $scope.learnersTData.usersForLp[ i ].id );
                    //     }
                    // };
                    // $scope.activeTabFunc( "notify" );
                    window.alert("notify learner_id");
                };
            }
        });

        var prevElem = "";
        var prevIndex = null;

        $scope.loadBadgeData = function(index, lpId, fbUserName, expandedView) {

            if (prevIndex == index) {
                $scope.prevIndex = true;
            } else {
                $scope.prevIndex = false;
            }

            $scope[prevElem] = false;
            var ele = 'showExpandedLearnersView' + index;

            if (prevElem != ele) {
                prevElem = ele;
            }

            if ($scope[ele] == true && $scope.prevIndex) {
                $scope[ele] = false;
            } else if ($scope[ele] == false && !$scope.prevIndex) {
                $scope[ele] = true;
            } else if ($scope[ele] == false && $scope.prevIndex) {
                $scope[ele] = false;
            } else if ($scope[ele] == undefined) {
                $scope[ele] = true;
            }

            prevIndex = index;

            if ($scope[ele]) {

                var bdata = { "managerFbUserName": $scope.fbId, "lpId_O": lpId, "fbUsername_O": fbUserName }

                fetchData.BadgeHead(bdata).then(function(response) {
                    if (response.data.status !== "error") {

                        $scope.Bhead = response.data;
                    }
                });

                fetchData.LBadgeData(bdata).then(function(response) {
                    if (response.data.status !== "error") {
                        $scope.BData = response.data;
                        //console.log($scope.BData)
                    }
                });
            }

        }


        $scope.$on('approveRetake', function() {

            var aData = { "fbUSerId": $scope.learner, "lpId": $scope.lpId, "ptId": $scope.ptId, "moduleSeqId": $scope.moduleSeqId, "moduleTitle": $scope.moduleTitle }
            fetchData.approveLearner(aData).then(function(response) {
                $scope.learner = null;
                $scope.ptId = null;
                $scope.moduleSeqId = null;
                angular.element(".learner-view:eq(" + $scope.index + ")").css('display', 'none');
                angular.element(".approved-learner:eq(" + $scope.index + ")").css('display', 'block');
            });

        });

        $scope.approveLearner = function(learner, lpId, ptId, moduleSeqId, index, moduleTitle) {

            $rootScope.$broadcast('approval-popout');

            $scope.index = index;
            $scope.learner = learner;
            $scope.ptId = ptId;
            $scope.lpId = lpId;
            $scope.moduleSeqId = moduleSeqId;
            $scope.moduleTitle = moduleTitle;

        }

        $scope.rejectLearner = function(learner, ptId) {

            var rData = { "fbUSerId": learner, "ptId": ptId }

            fetchData.rejectLearner(rData).then(function(response) {
                if (response.data.status !== "error") {

                }
            });
        }

    });
'use strict';
angular
    .module('jigsawCorpLms')
    .controller('dashNavCtrl', function($scope, $state, fetchData, $rootScope, $timeout) {


        $rootScope.headerShow = true;
        $scope.bJourneyObj.currentTab = 'trackProgress';
        $scope.userProfile = false;

        $rootScope.$on("dashboard-data-fetched", function() {
            $scope.bJourneyObj.currentTab = 'trackProgress';
            $state.go('buyer.dashboard.trackProgress');
        });

        $rootScope.$on("buyers-profile", function() {
            $state.go('buyer.dashboard.userProfile');
        });

        $scope.trackProgressTab = function() {

            $scope.bJourneyObj.currentTab = 'trackProgress';
            $state.go('buyer.dashboard.trackProgress');

        };

        $scope.learnersTab = function() {


            $scope.bJourneyObj.skillTableExpnd = false; // collapses further expanded states of tiles - below three lines
            $scope.bJourneyObj.lHealthTableExpnd = false;
            $rootScope.$broadcast('closeTiles');

            if (!$scope.isMediumScrennDevice && !$scope.isMobilePhoneDevice) {
                $scope.bJourneyObj.currentTab = 'learnersView';
                $state.go('buyer.dashboard.learnersView');
            } else {
                window.alert('This view is available in desktop only');
            }

        };


        $scope.purchaseHistoryTab = function() {

            if (!$scope.isMediumScrennDevice && !$scope.isMobilePhoneDevice) {
                $scope.bJourneyObj.currentTab = 'purchaseHistory';
                $state.go('buyer.dashboard.purchaseHistory');
            } else {
                window.alert('This view is available in desktop only');
            }
        };



    });
'use strict';
( function() {
    angular
        .module( 'jigsawCorpLms' )
        .config( routerConfig );

    /** @ngInject */
    function routerConfig( $stateProvider ) {
        $stateProvider
            .state( 'buyer.dashboard.content', {
                url: '/buyerdashboard/content',
                templateUrl: 'app/Features/buyerJourney/partials/buyerDashboard/templates/content/content.html'
            } );
    }

} )();

'use strict';
( function() {
    angular
        .module( 'jigsawCorpLms' )
        .config( routerConfig );

    /** @ngInject */
    function routerConfig( $stateProvider ) {
        $stateProvider
            .state( 'buyer.allocation.success', {
                url: '/allocationSuccess',
                templateUrl: 'app/Features/buyerJourney/partials/allocationScreen/partials/successScreen/successScreen.html',
                controller: 'allocationSuccessScreenCtrl'
            } );
    }

} )();

'use strict';
angular
    .module('jigsawCorpLms')
    .controller('allocationSuccessScreenCtrl', function($scope, $state) {
        $scope.lpAllocatedNum = 1;

        if ($scope.bJourneyObj.learningPathSecondTeam != null) {
            $scope.lpAllocatedNum = 2;
        };

        $scope.goToAllocationPage = function() {
            $state.go('buyer.allocation.allocationForm');
        };

        $scope.goTOBDash = function() {
            $state.go('buyer.dashboard');
        };
    });
'use strict';
( function() {
    angular
        .module( 'jigsawCorpLms' )
        .config( routerConfig );

    /** @ngInject */
    function routerConfig( $stateProvider ) {
        $stateProvider
            .state( 'buyer.allocation.allocationForm', {
                url: '/allocationForm',
                templateUrl: 'app/Features/buyerJourney/partials/allocationScreen/partials/allocationForm/allocationForm.html',
                controller: 'allocationFormCtrl'
            } );
    }

} )();

'use strict';
angular
    .module('jigsawCorpLms')
    .controller('allocationFormCtrl', function($scope, $state) {
        $scope.anotherTeam = false;
        $scope.bJourneyObj.inputTeamName = $scope.bJourneyObj.user.defaultTeamName;

        $scope.anotherTeamFunc = function() {
            $scope.anotherTeam = !$scope.anotherTeam;
        };

        $scope.goToSuccess = function(isValid) {
            if (isValid) {
                $state.go('buyer.allocation.success');
            }
        };

        $scope.selectedTeamManagerFunc = function(tm) {
            $scope.bJourneyObj.inputCorporateMail = tm.emailID;
            $scope.bJourneyObj.inputContactNumber = tm.contactNumber;
            $scope.mangaerSelected = true;
        };

        $scope.goToDashboard = function() {
            $state.go('buyer.dashboard');
        };
    });
'use strict';
angular
    .module('jigsawCorpLms')
    .controller('performanceAnalyticsCtrl', function($scope, $state, fetchData) {

    });
'use strict';
( function() {
    angular
        .module( 'jigsawCorpLms' )
        .config( routerConfig );

    function routerConfig( $stateProvider ) {
        $stateProvider
            .state( 'home.modulesummary', {
                url: '/summary',
                templateUrl: 'app/Features/proficiencyTest/template/moduleSummaryPage/moduleSummaryPage.html',
                controller: 'moduleSummaryPageCtrl'
            } );

    }

} )();

'use strict';
angular
    .module('jigsawCorpLms')
    .controller('moduleSummaryPageCtrl', function($scope, fetchData) {

        fetchData.fetchModuleSummaryPageData().then(function(response) {
            $scope.summaryData = response.data.moduleSummary;
        });

    });
'use strict';
( function() {
    angular
        .module( 'jigsawCorpLms' )
        .config( routerConfig );

    function routerConfig( $stateProvider ) {
        $stateProvider
            .state( 'home.learn.ytc', {
                url: '.ytc',
                templateUrl: 'app/Features/learnerView/template/youTubePlayerPage/youTubePlayerPage.html',
                controller: 'youTubePlayerctrl'
            } );

    }

})();

'use strict';
angular
    .module('jigsawCorpLms')
    .controller('youTubePlayerctrl', function($scope, $state, $sce, $http, $filter, $rootScope, $location,
        $timeout, fetchData, videoUtilities, DataCache, $controller, $window, FirebaseService) {

        angular.extend(this, $controller('rubricGuideCtrl', {
            $scope: $scope
        }));


        $rootScope.activeController = "youTubePlayerctrl";
        $rootScope.$emit('new-controller-loaded');


        $scope.activeModule = DataCache.returnData('thisModuleData');
        $scope.details = DataCache.returnData('details');
        $scope.activeModuleData = $scope.details[$scope.activeModule.moduleId][$rootScope.currentSequenceId];

        $scope.isYouTubeVideo = false;
        $scope.isWebLink = false;

        var userData = DataCache.returnData("userData");
        $scope.authData = DataCache.returnData('userData');

        var ref = FirebaseService.ref.child($rootScope.events);

        $scope.eventObject = {
            "group": "lprogress",
            "type": "lweblink",
            "data": {
                "action": "complete",
                "teamId": userData.teamId,
                "clientId": userData.clientId,
                "lpId": userData.lpId,
                "lpTitle": userData.lpTitle,
                "token": userData.token,
                "currentVideoTime": $scope.activeModuleData.metaData.duration,
                "timeSpent": $scope.activeModuleData.metaData.duration,
                "moduleId": $scope.activeModule.moduleId.toString(),
                "resourceId": angular.copy($rootScope.currentResourceId).toString(),
                "moduleSeqId": $scope.activeModule.sequenceId.toString(),
                "resourceSeqId": $rootScope.currentSequenceId + '',
                "timestamp": $filter('date')(new Date(), 'yyyy-MM-dd HH:mm:ss')
            }
        };



        $scope.contentType = $scope.activeModuleData.metaData.videoType;

        function getId(url) {
            var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
            var match = url.match(regExp);

            if (match && match[2].length == 11) {
                return match[2];
            } else {
                return 'error';
            }
        }

        if ($scope.contentType === "videolink") {
            $scope.isYouTubeVideo = true;
            $scope.isWebLink = false;
            $scope.yturl = $scope.activeModuleData.metaData.videoUrl;
            $scope.ytId = getId($scope.yturl);
            var youTubeFrame = '<iframe width="100%" height="100%" src="//www.youtube.com/embed/' + $scope.ytId + '" frameborder="0" allowfullscreen></iframe>';
            document.getElementById("yt-container").innerHTML = youTubeFrame;
            ref.push().child($scope.authData.uid).set($scope.eventObject);

        } else if ($scope.contentType === "weblink") {
            $scope.isWebLink = true;
            $scope.isYouTubeVideo = false;
            $scope.webLink = $scope.activeModuleData.metaData.videoUrl;
            // $scope.weblinkDescription = $scope.activeModuleData.metaData.description;
        }



        // Video Player Next Button

        $scope.nextItemOnPlaylist = function() {
            ++$rootScope.currentSequenceId;
            $scope.changeStatePlaylist();

        }
        $scope.previoustItemOnPlaylist = function() {
            --$rootScope.currentSequenceId;
            if ($rootScope.currentSequenceId > 0) {
                $scope.changeStatePlaylist();
            }

        }
        $scope.openLink = function(source) {
            ref.push().child($scope.authData.uid).set($scope.eventObject);
            $window.open(source, '_blank');
        }


        $scope.youtubeIntroOptions = $rootScope.introData;

        $scope.startIntro = DataCache.returnData("youtubeIntro");
        if ($scope.startIntro === undefined || $scope.startIntro === null) {
            $scope.startIntro = true;
        }


        $timeout(function() {
            if ($rootScope.firstTimeLogin && $scope.startIntro) {
                $scope.CallMe();
                $scope.startIntro = false;
                DataCache.saveGlobalData("youtubeIntro", $scope.startIntro);
            }
        }, 200);

        $scope.hintFirstTime = true;


        var showHelp = true;
        var activeElem = document.activeElement;
        var codeset = { 72: false };

        if (activeElem && (activeElem.tagName.toLowerCase() == 'input' &&
                activeElem.type == 'text' ||
                activeElem.tagName.toLowerCase() == 'textarea')) showHelp = false;

        $scope.IntroOptions = $rootScope.introData;

        $window.onkeydown = function(e) {
            if (e.keyCode in codeset) {
                codeset[e.keyCode] = true;
                if (codeset[72] && showHelp) {
                    angular.element('.d-hints').removeAttr("data-hint");
                    if ($rootScope.activeController === "videoPlayerctrl") {
                        if ($scope.hintFirstTime) {
                            introJs().setOptions($scope.IntroOptions);
                            introJs().addHints();
                            $scope.hintFirstTime = false;
                        } else {
                            introJs().showHints();
                            introJs().refresh();
                        }
                        codeset[72] = false;
                    }
                }
            }

            if (e.keyCode == 27) {

                angular.element('#d-point').attr("data-hint", "Earn points while you learn! You’re already up by 20 points by simply setting up your profile.");
                angular.element('#d-burger').attr("data-hint", "Want help? Want to report an issue? Or do you simply want to change your settings? Access your entire menu options here.");
                angular.element('#d-status').attr("data-hint", "Track the overall status of your learning here. Click on your Avatar on the left for a closer look at your activity, progress and where you stand on the Leaderboard.");

                introJs().hideHints();
            }

        };

        $window.onkeyup = function(e) {
            if (e.keyCode in codeset) {
                codeset[e.keyCode] = false;
            }
        };


        // intro changes ends here

    });
'use strict';
( function() {
    angular
        .module( 'jigsawCorpLms' )
        .config( routerConfig );

    function routerConfig( $stateProvider ) {
        $stateProvider
            .state( 'home.learn.video', {
                url: '.video',
                templateUrl: 'app/Features/learnerView/template/videoPlayerPage/videoPlayer.html',
                controller: 'videoPlayerctrl',
                controllerAs: 'videoPlayerctrl'
            } );

    }

})();

'use strict';
angular
    .module('jigsawCorpLms')
    .controller('videoPlayerctrl', function($scope, $state, $sce, $http, $filter, $rootScope, $location,
        $timeout, fetchData, videoUtilities, DataCache, $controller, $window) {

        angular.extend(this, $controller('videoCommonCntrl', {
            $scope: $scope
        }));


        $rootScope.activeController = "videoPlayerctrl";
        $rootScope.$broadcast('new-controller-loaded');

        // Video Player Next Button

        $scope.nextItemOnPlaylist = function() {
            ++$rootScope.currentSequenceId;
            $scope.changeStatePlaylist();

        }
        $scope.previoustItemOnPlaylist = function() {
            --$rootScope.currentSequenceId;
            if ($rootScope.currentSequenceId > 0) {
                $scope.changeStatePlaylist();
            }

        }
        $scope.resetRadioModel = function() {
            $scope.selectedIssue.issueName = undefined;
            $scope.riFullView = false;
        }

        // changes for intro.js

        $scope.videoIntroOptions = $rootScope.introData;
        $scope.ShouldAutoStart = false;

        $scope.startIntro = DataCache.returnData("videoIntro");
        if ($scope.startIntro === undefined || $scope.startIntro === null) {
            $scope.startIntro = true;
        }

        $timeout(function() {
            if ($rootScope.firstTimeLogin && $scope.startIntro) {
                $scope.CallMe();
                $scope.startIntro = false;
                DataCache.saveGlobalData("videoIntro", $scope.startIntro);
            }
        }, 200);


        $scope.hintFirstTime = true;

        var showHelp = true;
        var activeElem = document.activeElement;
        var codeset = { 72: false };

        if (activeElem && (activeElem.tagName.toLowerCase() == 'input' &&
                activeElem.type == 'text' ||
                activeElem.tagName.toLowerCase() == 'textarea')) showHelp = false;

        $scope.IntroOptions = $rootScope.introData;

        $window.onkeydown = function(e) {
            if (e.keyCode in codeset) {
                codeset[e.keyCode] = true;
                if (codeset[72] && showHelp) {
                    angular.element('.d-hints').removeAttr("data-hint");
                    if ($rootScope.activeController === "videoPlayerctrl") {
                        if ($scope.hintFirstTime) {
                            introJs().setOptions($scope.IntroOptions);
                            introJs().addHints();
                            $scope.hintFirstTime = false;
                        } else {
                            introJs().showHints();
                            introJs().refresh();
                        }
                        codeset[72] = false;
                    }
                }
            }

            if (e.keyCode == 27) {

                angular.element('#d-point').attr("data-hint", "Earn points while you learn! You’re already up by 20 points by simply setting up your profile.");
                angular.element('#d-burger').attr("data-hint", "Want help? Want to report an issue? Or do you simply want to change your settings? Access your entire menu options here.");
                angular.element('#d-status').attr("data-hint", "Track the overall status of your learning here. Click on your Avatar on the left for a closer look at your activity, progress and where you stand on the Leaderboard.");

                introJs().hideHints();
            }

        };

        $window.onkeyup = function(e) {
            if (e.keyCode in codeset) {
                codeset[e.keyCode] = false;
            }
        };


        // intro changes ends here

    });
'use strict';
( function() {
    angular
        .module( 'jigsawCorpLms' )
        .config( routerConfig );

    function routerConfig( $stateProvider ) {
        $stateProvider
            .state( 'home.learn.resources', {
                url: '.resources',
                templateUrl: 'app/Features/learnerView/template/resourceLinkPage/resourceLinkPage.html',
                controller: 'resourceLinkPageCtrl'
            } );

    }

} )();

'use strict';
angular
    .module('jigsawCorpLms')
    .controller('resourceLinkPageCtrl', function($scope, fetchData, $base64, DataCache, $rootScope, $window, $timeout) {

        $rootScope.activeController = "resourceLinkPageCtrl";
        $rootScope.$broadcast('new-controller-loaded');
        $scope.activeModule = DataCache.returnData('thisModuleData');
        $scope.details = DataCache.returnData('details');

        $scope.totalItems = $scope.details[$scope.activeModule.moduleId].length - 1;

        if ($rootScope.currentSequenceId === undefined) {
            $rootScope.currentSequenceId = DataCache.returnData('currentSequenceId');
        }

        if ($rootScope.currentResourceId === undefined) {
            $rootScope.currentResourceId = DataCache.returnData('currentResourceId');
        }


        var materialObject = $scope.details[$scope.activeModule.moduleId][$rootScope.currentSequenceId];


        // Why materialId is hardcoded here
        var payload = {
            "materialId": materialObject.id
        };


        fetchData.fetchResourceLinkPage(payload).then(function(response) {
            $scope.resourcesData = response.data.material;

            // Content issue in the backend - once its converted base64 string uncomment the line
            angular.forEach($scope.resourcesData, function(value, key) {
                value.title = $base64.decode(value.title);
                //value.title = value.title;
            }, this);
        });
        $scope.openLink = function(source) {
            $window.open(source, '_blank');
        }

        $timeout(function() {
            if ($rootScope.firstTimeLogin && $scope.startIntro) {
                $scope.CallMe();
                $scope.startIntro = false;
                DataCache.saveGlobalData("videoIntro", $scope.startIntro);
            }
        }, 200);


        $scope.hintFirstTime = true;

        var showHelp = true;
        var activeElem = document.activeElement;
        var codeset = { 72: false };

        if (activeElem && (activeElem.tagName.toLowerCase() == 'input' &&
                activeElem.type == 'text' ||
                activeElem.tagName.toLowerCase() == 'textarea')) showHelp = false;

        $scope.IntroOptions = $rootScope.introData;

        $window.onkeydown = function(e) {
            if (e.keyCode in codeset) {
                codeset[e.keyCode] = true;
                if (codeset[72] && showHelp) {
                    angular.element('.d-hints').removeAttr("data-hint");

                    if ($rootScope.activeController === "resourceLinkPageCtrl") {
                        if ($scope.hintFirstTime) {
                            introJs().setOptions($scope.IntroOptions);
                            introJs().addHints();
                            $scope.hintFirstTime = false;
                        } else {
                            introJs().showHints();
                            introJs().refresh();
                        }
                        codeset[72] = false;
                    }
                }
            }

            if (e.keyCode == 27) {
                //angular.element('.d-hints').css('display','block');
                angular.element('#d-point').attr("data-hint", "Earn points while you learn! You’re already up by 20 points by simply setting up your profile.");
                angular.element('#d-burger').attr("data-hint", "Want help? Want to report an issue? Or do you simply want to change your settings? Access your entire menu options here.");
                angular.element('#d-status').attr("data-hint", "Track the overall status of your learning here. Click on your Avatar on the left for a closer look at your activity, progress and where you stand on the Leaderboard.");

                introJs().hideHints();
            }

        };

        $window.onkeyup = function(e) {
            if (e.keyCode in codeset) {
                codeset[e.keyCode] = false;
            }
        };


        // intro changes ends here
    });
'use strict';
( function() {
    angular
        .module( 'jigsawCorpLms' )
        .config( routerConfig );

    function routerConfig( $stateProvider ) {
        $stateProvider
            .state( 'home.learn.quiz', {
                url: '.quiz',
                templateUrl: 'app/Features/learnerView/template/quizPage/quizPage.html',
                controller: 'quizPageCntrl'
            } );

    }

} )();

'use strict';
angular
  .module('jigsawCorpLms')
  .controller('quizPageCntrl', function($scope, fetchData, $state, $rootScope, $sce, $location, $window, $base64, DataCache, $filter, FirebaseService) {

      $scope.quizTemplateUrl = $sce.trustAsResourceUrl('app/Features/learnerView/template/quizPage/templates/quiz_launch.html');
      $scope.quizPageState = 'launchPage';
      $scope.parentObj = {};
      $scope.crtAnswer = 0;
      $rootScope.relatedVideo = false;
      $scope.quizAttempted = false;

      var copyObj = {};
      $scope.error;

      $rootScope.activeController = "quizPageCntrl";
      $rootScope.$broadcast('new-controller-loaded');

      $scope.authData = DataCache.returnData('userData');
      $scope.summaryData = DataCache.returnData('summary');
      $scope.activeModule = DataCache.returnData('thisModuleData');
      if (DataCache.returnLpData('currentLp') === 'active') {
        $scope.details = DataCache.returnData('details');
      } else {
        $scope.details = DataCache.returnLpData(DataCache.returnLpData('currentLp')).details
      }

      if ($rootScope.currentSequenceId === undefined) {
        $rootScope.currentSequenceId = DataCache.returnData('currentSequenceId');
      }

      if ($rootScope.currentResourceId === undefined) {
        $rootScope.currentResourceId = DataCache.returnData('currentResourceId');
      }


      $scope.module = $scope.details[$scope.activeModule.moduleId][$rootScope.currentSequenceId];

      $scope.totalItems = $scope.details[$scope.activeModule.moduleId].length - 1;

      if ($scope.module.status === 'Completed') {
        $scope.quizAttempted = true;
      }


      $scope.userAnswerReport = [];

      var date = new Date();
      var ref = FirebaseService.ref.child($rootScope.events);

      var userData = DataCache.returnData("userData");

      $scope.eventObject = {
        "group": "lprogress",
        "type": "lquiz",
        "data": {
          "action": "start",
          "teamId": userData.teamId,
          "clientId": userData.clientId,
          "lpId": userData.lpId,
          "lpTitle": userData.lpTitle,
          "token": userData.token,
          "moduleId": $scope.activeModule.moduleId.toString(),
          "resourceId": $rootScope.currentResourceId.toString(),
          "moduleSeqId": $scope.activeModule.sequenceId.toString(),
          "resourceSeqId": $rootScope.currentSequenceId.toString(),
          "timestamp": 0

        }
      };



      $scope.loadData = function() {

        var payload = {
          "lpId": $scope.summaryData.lpId,
          "moduleId": $scope.activeModule.moduleId,
          "quizId": $scope.module.id,
          "limit": $scope.module.metaData.totalQuestionsToDisplay
        };
        fetchData.fetchQuizData(payload).then(function(response) {

          if (response.data.status === 'error') {
            $scope.error = response.data.error;
            return;
          }
          $scope.quizData = response.data;
          $scope.rearrangeQuizQuestions($scope.quizData.questions);

          $scope.currentQuestionIndex = $scope.quizData.questionSeqId ? $scope.quizData.questionSeqId : 0;
          if ($scope.currentQuestionIndex == $scope.quizData.questions.length) {
            $scope.currentQuestionIndex = $scope.currentQuestionIndex - 1;
          }
          $scope.quizTemplateUrl = $sce.trustAsResourceUrl('app/Features/learnerView/template/quizPage/templates/quiz_question.html');
          $scope.quizPageState = 'questionPage';



          if ($scope.module.status !== 'In Progress') {

            // sending firebase events
            $scope.eventObject.data.action = "start";
            if (DataCache.returnLpData('currentLp') === 'active') {
              ref.push().child($scope.authData.uid).set($scope.eventObject);
            }

            // update status
            var nextPayload = {
              "quizData": {
                "questionSeqId": $scope.currentQuestionIndex,
                "status": "start",
                "questions": $scope.quizData.questions
              },
              "lpId": $scope.summaryData.lpId,
              "moduleId": $scope.activeModule.moduleId,
              "quizId": $scope.details[$scope.activeModule.moduleId][$rootScope.currentSequenceId].id
            };
            fetchData.sendUpdateQuizData(nextPayload).then(function(response) {});
          }
        });
      };

      if ($scope.module.status !== 'Not Started') {
        if ($scope.module.status === 'Completed') {
          $scope.quizTemplateUrl = $sce.trustAsResourceUrl('app/Features/learnerView/template/quizPage/templates/quiz_launch.html');
          $scope.quizPageState = 'launchPage';
        } else {
          $scope.loadData();
        }
      } else if ($scope.error) {
        $scope.quizTemplateUrl = $sce.trustAsResourceUrl('app/Features/learnerView/template/quizPage/templates/quiz_launch.html');
        $scope.quizPageState = 'launchPage';
        //$window.alert(response.data.error);
      }
      $scope.startQuiz = function() {
        $scope.loadData();
      }

      // report issue
      $scope.expandedReportIssue = false;
      var rissuesObj = {
        "issues": {
          "content": [{
            "type": "disagree with answer"
          }, {
            "type": "question is not clear"
          }, {
            "type": "answer is not clear"
          }],
          "tech": [{
            "type": "question/answer not displayed properly"
          }, {
            "type": "did not skip"
          }]
        }
      };
      $scope.riQuizFullView = false;
      /*        $scope.reportIssueFunc = function() {
                  $scope.expandedReportIssue = !$scope.expandedReportIssue;
              };
      */
      $scope.showRIssuesExpanded = function(problem) {
        $scope.riFullView = true;
        $scope.problemSelected = problem;
        $scope.selectedIssue = rissuesObj.issues[problem];
      };
      $scope.sendRIssue = function() {
        alert($scope.selectedIssue.issueName);
        $scope.expandedReportIssue = false;
        $scope.expandedReportIssueMob = false;
      };

      $scope.showRIssuesExpandedMob = function(problem) {
        $scope.riQuizFullView = true;
        $scope.problemSelected = problem;
        $scope.selectedIssue = rissuesObj.issues[problem];
      };

      $scope.expandedReportIssueMob = false;
      $scope.reportIssueMobFunc = function() {
        // $scope.showTrimScreen = true;
        $scope.expandedReportIssueMob = !$scope.expandedReportIssueMob;
      };

      $scope.goBackToIssuesList = function() {
        $scope.riQuizFullView = false;
      };

      $scope.rearrangeQuizQuestions = function(response) {
        $scope.quizQuestionsData = [];
        $scope.noOfQuestions = response.length;
        for (var i = 0; i < response.length; i++) {
          var tempOptions = [];
          var tempObj;
          var tempAns
          //var decodedOptions = $base64.decode( response[ i ].choices );
          var decodedOptions = JSON.parse(response[i].choices);
          decodedOptions.forEach(function(val, ind) {

              if (Object.keys(val) != 'ans' && val[Object.keys(val)] != 'NA') {
                if (response[i].optionType === 'html') {
                  tempOptions.push(decodeURIComponent($window.atob(val[Object.keys(val)]).split('').map(function(c) {
                      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
                    }).join('')));
                  }
                  else {
                    tempOptions.push(val[Object.keys(val)]);
                  }
                } else {
                  tempAns = val;
                }

              })
            //  Separate Options and Answers

            tempObj = {
              "q_id": response[i].questionId,
              "question": decodeURIComponent($window.atob(response[i].question).split('').map(function(c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
              }).join('')),
              "type": response[i].optionType,
              "options": tempOptions,
              "answerContent": tempAns,
              "relatedVideoId": response[i].relatedVideoId,
              "relatedVideoSeqId": response[i].relatedVideoSeqId,
              "relatedVideoModuleId": $scope.activeModule.moduleId,
              "relatedVideoTitle": response[i].relatedVideoTitle,
              "description": response[i].explanation,
              "answerStatus": response[i].answerStatus,
              "crctOption": response[i].crctOption,
              "usrSelectedOption": response[i].usrSelectedOption
            }

            $scope.quizQuestionsData.push(tempObj); $scope.currentQuestionIndex = response.questionSeqId;
          }
          $scope.quizReport = [];
          $scope.quizQuestionsData.forEach(function(val, ind) {
            var temp = {
              "answerStatus": val.answerStatus,
              "relatedVideoTitle": val.relatedVideoTitle,
              "relatedVideoId": val.relatedVideoId,
              "relatedVideoSeqId": val.relatedVideoSeqId,
              "relatedVideoModuleId": $scope.activeModule.moduleId,
              "crctOption": val.crctOption,
              "usrSelectedOption": val.usrSelectedOption
            }
            $scope.quizReport.push(temp);
          });

        };

        $scope.answerSubmitted = function(isValid, index) {
          if (isValid) {
            var crctAnsKey;
            var thisQuestion = $scope.quizQuestionsData[index];
            crctAnsKey = parseInt(thisQuestion.answerContent['ans']);
            var correctAns = thisQuestion.options[crctAnsKey - 1];
            var selectedAns = thisQuestion.eachQuestion;
            // $scope.userAnswer = selectedAns.option_id - 1;
            $scope.showAnswer = true;
            //$scope.quizPageState = 'answerSubmitted';

            $scope.quizReport[index].usrSelectedOption = selectedAns;
            $scope.quizReport[index].crctOption = correctAns;

            //
            $scope.quizData.questions[index].crctOption = correctAns;
            $scope.quizData.questions[index].usrSelectedOption = selectedAns;

            $location.hash('answerExp');
            if (correctAns === selectedAns) {
              $scope.ansStatus = true;
              $scope.quizReport[index].answerStatus = 'true';
              $scope.quizData.questions[index].status = 'correct';
              $scope.quizData.questions[index].answerStatus = 'true';
            } else if (!selectedAns) {
              $scope.ansStatus = false;
              $scope.quizReport[index].answerStatus = 'skipped';
              $scope.quizData.questions[index].status = 'skipped';
              $scope.quizData.questions[index].answerStatus = 'skipped';

            } else {

              $scope.ansStatus = false;
              $scope.quizReport[index].answerStatus = 'false';
              $scope.quizData.questions[index].status = 'incorrect'
              $scope.quizData.questions[index].answerStatus = 'false';
            }



            // Send data
            var nextPayload = {
              "quizData": {
                "questionSeqId": index + 1,
                "status": "In Progress",
                "questions": $scope.quizData.questions
              },
              "lpId": $scope.summaryData.lpId,
              "moduleId": $scope.activeModule.moduleId,
              "quizId": $scope.details[$scope.activeModule.moduleId][$rootScope.currentSequenceId].id
            };
            fetchData.sendUpdateQuizData(nextPayload).then(function(response) {});

            var savePayload = {
              "questionId": $scope.quizData.questions[index].questionId,
              "lpId": $scope.summaryData.lpId,
              "moduleId": $scope.activeModule.moduleId,
              "quizId": $scope.details[$scope.activeModule.moduleId][$rootScope.currentSequenceId].id,
              "status": $scope.quizData.questions[index].status
            };

            fetchData.saveQuizQuestion(savePayload).then(function(response) {});

          } else {
            $scope.errMessage = true;
          }
        };

        $scope.nextQuestion = function() {
          $scope.quizPageState = 'questionPage';
          $scope.showAnswer = false;
          $scope.goNextState();

        };

        $scope.setOptionHeight = function() {
          if ($state.current.url === '/learn.quiz' && $scope.quizPageState === 'questionPage') {
            var height = 'calc(' + $('.qz-qstn-answers-section .answer-item-wrp')[0].offsetHeight + 'px';
            return {
              'min-height': height
            }
          }
          // angular.element('.answer-item-wrp').css('min-height',height);
        }

        $scope.goNextState = function() {
          if ($scope.currentQuestionIndex + 1 < $scope.quizQuestionsData.length) {
            $scope.ansStatus = false;
            $scope.currentQuestionIndex++;

            $scope.quizReport[$scope.currentQuestionIndex].answerStatus = $scope.quizData.questions[$scope.currentQuestionIndex].answerStatus;

            var skipPayload = {
              "quizData": {
                "questionSeqId": $scope.currentQuestionIndex + 1,
                "status": "In Progress",
                "questions": $scope.quizData.questions
              },
              "lpId": $scope.summaryData.lpId,
              "moduleId": $scope.activeModule.moduleId,
              "quizId": $scope.details[$scope.activeModule.moduleId][$rootScope.currentSequenceId].id
            };
            fetchData.sendUpdateQuizData(skipPayload).then(function(response) {});

          } else {
            var completePayload = {
              "quizData": {
                "questionSeqId": $scope.currentQuestionIndex + 1,
                "status": "complete",
                "questions": $scope.quizData.questions
              },
              "lpId": $scope.summaryData.lpId,
              "moduleId": $scope.activeModule.moduleId,
              "quizId": $scope.details[$scope.activeModule.moduleId][$rootScope.currentSequenceId].id
            };
            fetchData.sendCompleteQuizData(completePayload).then(function(response) {});

            var i = 0;
            $scope.quizPageState = 'endQuiz';

            $scope.eventObject.data.action = "submit";
            $scope.eventObject.data.timeSpent = 10 / 60;
            if (DataCache.returnLpData('currentLp') === 'active') {
              ref.push().child($scope.authData.uid).set($scope.eventObject);
            }

            while (i < $scope.quizReport.length) {
              if ($scope.quizReport[i].answerStatus == 'true') {
                $scope.crtAnswer = $scope.crtAnswer + 1;
              }
              i++;
            }
            if ($scope.crtAnswer / $scope.noOfQuestions > 0.6) {
              $scope.lowScrMsg = false;
            } else {
              $scope.lowScrMsg = true;
            }

            $scope.activeModule = DataCache.returnData('thisModuleData');
            if (DataCache.returnLpData('currentLp') === 'active') {
              $scope.details = DataCache.returnData('details');
            } else {
              $scope.details = DataCache.returnLpData(DataCache.returnLpData('currentLp')).details
            }

            $scope.module = $scope.details[$scope.activeModule.moduleId][$rootScope.currentSequenceId];

            $scope.quizTemplateUrl = $sce.trustAsResourceUrl('app/Features/learnerView/template/quizPage/templates/quiz_end.html');
            $scope.attemptsLeft = $scope.module.totalAttempts - $scope.module.totalAttempted;
          }
        }


        //TO DO: This level of nesting is not a good code practice, either re think the logic or make seperate functions
        $scope.skipQuestion = function(index) {
          if (!$scope.quizReport[index].answerStatus) {
            $scope.quizReport[$scope.currentQuestionIndex].answerStatus = 'skipped';
            $scope.quizData.questions[index].status = 'skipped';
            $scope.quizData.questions[index].answerStatus = 'skipped';
          }
          $scope.goNextState();
        };

        $scope.quizBookMark = function() {
          $scope.quizBookMarked = !$scope.quizBookMarked;
        };

        $scope.prevQuestion = function() {

          $scope.showAnswer = false;
          $location.hash(null);

          if ($scope.currentQuestionIndex - 1 >= 0) {
            $scope.currentQuestionIndex = $scope.currentQuestionIndex - 1;
            $scope.quizReport[$scope.currentQuestionIndex].answerStatus = $scope.quizData.questions[$scope.currentQuestionIndex].answerStatus;
          } else {
            $scope.quizTemplateUrl = $sce.trustAsResourceUrl('app/Features/learnerView/template/quizPage/templates/quiz_launch.html');
            $scope.quizPageState = 'launchPage';

          }
        };
        $scope.goTonextQuestion = function() {
          $location.hash(null);
          $scope.nextQuestion();
        };

        $scope.optionSelected = function(answer) {

        };

        $scope.relaunch = function() {
          $state.go('home.learn.quiz', {}, { reload: 'home.learn.quiz', inherit: false, notify: true });
        }

        $scope.loadRelatedVideo = function(relatedVideoId, relatedVideoSeqId) {
          var modulePlaylistItems = DataCache.returnData("thisModuleDetails");
          var resourceId = modulePlaylistItems[relatedVideoSeqId].id;
          $rootScope.quizSequenceId = $rootScope.currentSequenceId;
          $rootScope.quizResourceId = $rootScope.currentResourceId;
          $rootScope.currentSequenceId = relatedVideoSeqId;
          $rootScope.currentResourceId = resourceId;
          $rootScope.currentBcId = relatedVideoId;
          $rootScope.relatedVideo = true;
          $rootScope.showProfTestBar = true;
          $state.go('home.learn.video', { sequenceId: relatedVideoSeqId }, { reload: 'home.learn.video', inherit: false, notify: true });
          $rootScope.$broadcast('quizPaused');
          // $rootScope.$broadcast('scrollPlaylist');
        }


        $scope.hintFirstTime = true;

        var showHelp = true;
        var activeElem = document.activeElement;
        var codeset = { 72: false };

        if (activeElem && (activeElem.tagName.toLowerCase() == 'input' &&
            activeElem.type == 'text' ||
            activeElem.tagName.toLowerCase() == 'textarea')) showHelp = false;

        $scope.IntroOptions = $rootScope.introData;

        $window.onkeydown = function(e) {
          if (e.keyCode in codeset) {
            codeset[e.keyCode] = true;
            if (codeset[72] && showHelp) {
              angular.element('.d-hints').removeAttr("data-hint");
              if ($rootScope.activeController === "quizPageCntrl") {
                if ($scope.hintFirstTime) {
                  introJs().setOptions($scope.IntroOptions);
                  introJs().addHints();
                  $scope.hintFirstTime = false;
                } else {
                  introJs().showHints();
                  introJs().refresh();
                }
                codeset[72] = false;
              }
            }
          }

          if (e.keyCode == 27) {
            angular.element('#d-point').attr("data-hint", "Earn points while you learn! You’re already up by 20 points by simply setting up your profile.");
            angular.element('#d-burger').attr("data-hint", "Want help? Want to report an issue? Or do you simply want to change your settings? Access your entire menu options here.");
            angular.element('#d-status').attr("data-hint", "Track the overall status of your learning here. Click on your Avatar on the left for a closer look at your activity, progress and where you stand on the Leaderboard.");

            introJs().hideHints();
          }

        };

        $window.onkeyup = function(e) {
          if (e.keyCode in codeset) {
            codeset[e.keyCode] = false;
          }
        };


        // intro changes ends here


      });

'use strict';
( function() {
    angular
        .module( 'jigsawCorpLms' )
        .config( routerConfig );

    function routerConfig( $stateProvider ) {
        $stateProvider
            .state( 'home.learn.assessment', {
                url: '.assessment',
                templateUrl: 'app/Features/learnerView/template/caseStudyPage/caseStudyPage.html',
                controller: 'caseStudyPageCntrl'
            } );

    }

} )();

'use strict';
angular
  .module('jigsawCorpLms')
  .controller('caseStudyPageCntrl', function($scope, fetchData, $state, $http, $rootScope, $sce, $location, $window, DataCache, $base64, $filter, FirebaseService, RestEndpoints, $timeout) {

    $rootScope.activeController = "caseStudyPageCntrl";
    $rootScope.$broadcast('new-controller-loaded');

    $scope.quizTemplateUrl = $sce.trustAsResourceUrl('app/Features/learnerView/template/caseStudyPage/template/caseStudylaunch.html');
    $scope.quizPageState = 'launchPage';
    $scope.parentObj = {};

    var user_data = DataCache.returnData('userData');

    $http.defaults.headers.common['Authorization'] = "Bearer " + user_data.jwttoken;
    $http.defaults.headers.common['Content-Type'] = "application/x-www-form-urlencoded";

    $scope.authData = DataCache.returnData('userData');
    $scope.summaryData = DataCache.returnData('summary');
    $scope.activeModule = DataCache.returnData('thisModuleData');
    
    if (DataCache.returnLpData('currentLp') === 'active') {
      $scope.details = DataCache.returnData('details');
    } else {
      $scope.details = DataCache.returnLpData(DataCache.returnLpData('currentLp')).details
    }

    if ($rootScope.currentSequenceId === undefined) {
      $rootScope.currentSequenceId = DataCache.returnData('currentSequenceId');
    }

    if ($rootScope.currentResourceId === undefined) {
      $rootScope.currentResourceId = DataCache.returnData('currentResourceId');
    }

    $scope.module = $scope.details[$scope.activeModule.moduleId][$rootScope.currentSequenceId];
    $scope.noOfQuestions = $scope.module.metaData.totalQuestions;
    $scope.totalItems = $scope.details[$scope.activeModule.moduleId].length - 1;

    var ref = FirebaseService.ref.child($rootScope.events);
    var userData = DataCache.returnData("userData");

    $scope.eventObject = {
      "group": "lprogress",
      "type": "lcsa",
      "data": {
        "action": "start",
        "teamId": userData.teamId,
        "clientId": userData.clientId,
        "lpId": userData.lpId,
        "lpTitle": userData.lpTitle,
        "token": userData.token,
        "moduleId": $scope.activeModule.moduleId.toString(),
        "resourceId": $rootScope.currentResourceId.toString(),
        "moduleSeqId": $scope.activeModule.sequenceId.toString(),
        "resourceSeqId": $rootScope.currentSequenceId.toString(),
        "timestamp": $filter('date')(new Date(), 'yyyy-MM-dd HH:mm:ss')
      }

    };

    $scope.launchLab = function() {

      var payload = {
        "csaId": $scope.module.id
      };

      fetchData.fetchCaseStudyExercise(payload).then(function(response) {
        $scope.questionsData = response.data.csa[0];
        $scope.questionsData.excerciseHtml = decodeURIComponent($window.atob($scope.questionsData.excerciseHtml).split('').map(function(c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
        $scope.quizTemplateUrl = $sce.trustAsResourceUrl('app/Features/learnerView/template/caseStudyPage/template/caseStudyQuestion.html');
        $scope.quizPageState = 'questionPage';
        // start event
        $scope.eventObject.data.action = "start";
        if (DataCache.returnLpData('currentLp') === 'active') {
          ref.push().child($scope.authData.uid).set($scope.eventObject);
        }
      });
    };

    $scope.goToDashboard = function() {
      $rootScope.scndHdr = true;
      $state.go('home.dashboard');
      $rootScope.dashArrow = true;
      $rootScope.moduleHeader = false;
    };

    $scope.skipQuestion = function() {
      if ($scope.currentQuestionIndex + 1 < $scope.questionsData.length) {
        $scope.currentQuestionIndex++;
      } else {
        $scope.quizPageState = 'endQuiz';
        $scope.quizTemplateUrl = $sce.trustAsResourceUrl('app/Features/learnerView/template/quizPage/templates/quiz_end.html');
      }
    };

    $scope.caseStudyBookMark = function() {
      $scope.caseStudyBookMarked = !$scope.caseStudyBookMarked;
    };

    $scope.prevQuestion = function() {
      $scope.showAnswer = false;
      $location.hash(null);
      if ($scope.currentQuestionIndex - 1 > $scope.questionsData.length) {
        $scope.currentQuestionIndex--;
      } else {
        $scope.quizTemplateUrl = $sce.trustAsResourceUrl('app/Features/learnerView/template/quizPage/templates/quiz_launch.html');
        $scope.quizPageState = 'launchPage';

      }
    };
    $scope.goTonextQuestion = function() {
      $location.hash(null);
      $scope.nextQuestion();
    };

    $scope.optionSelected = function(answer) {

    };

    $scope.launchJigsawlabs = function() {
      $scope.parentObj.launchLabOverlay = !$scope.parentObj.launchLabOverlay;
      if (!$scope.parentObj.launchLabOverlay) {
        window.open("http://www.jigsawacademy.com/online-sas-training/");
      }
    }

    $scope.launchDownloadAnswerSheet = function() {
      $scope.parentObj.launchAnswerOverlay = !$scope.parentObj.launchAnswerOverlay;
    }

    $scope.baseUrl = RestEndpoints.baseURL + "/file"; // "http://localhost:1442/reports";
    $scope.download = function(fileName) {
      $window.open($scope.baseUrl + "/download/" + user_data.jwttoken + "/" + $scope.activeModule.sequenceId + "/" + fileName, "_blank");

    }

    $scope.displayAnswerSheet = function() {

      $scope.parentObj.launchAnswerOverlay = false;


      var payload = {
        "csaId": $scope.module.id
      };

      fetchData.fetchCaseStudySolution(payload).then(function(response) {
        $scope.questionsData = response.data.csa[0];
        $scope.questionsData.solutionHtml = decodeURIComponent($window.atob($scope.questionsData.solutionHtml).split('').map(function(c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
        $scope.quizTemplateUrl = $sce.trustAsResourceUrl('app/Features/learnerView/template/caseStudyPage/template/caseStudyAnswer.html');
        $scope.quizPageState = 'questionPage';
        // end event
        $scope.eventObject.data.action = "submit";
        $scope.eventObject.data.timeSpent = parseInt($scope.parentObj.timeSpent);
        if (DataCache.returnLpData('currentLp') === 'active') {
          ref.push().child($scope.authData.uid).set($scope.eventObject);
        }
      });
    }

    //TO DO: Is this function needed?
    $scope.openNewWindow = function() {
      $scope.parentObj.launchLabOverlay = false;
      window.open("http://www.jigsawacademy.com/online-sas-training/");
    }
    $scope.launchLabMob = function() {
      $scope.mobLaunchErr = true;
    }
    $scope.closeErrScrn = function() {
      $scope.mobLaunchErr = !$scope.mobLaunchErr;
    }

    // $scope.download = function(fileName){
    //     var downloadLink = angular.element('<a></a>');
    //     downloadLink.attr('href','http://res.cloudinary.com/jigsawcorplms/raw/upload/v1/jigsaw/files/'+fileName);
    //     downloadLink.attr('download', fileName);
    //     downloadLink[0].click();

    // }

    $timeout(function() {
      if ($rootScope.firstTimeLogin && $scope.startIntro) {
        $scope.CallMe();
        $scope.startIntro = false;
        DataCache.saveGlobalData("videoIntro", $scope.startIntro);
      }
    }, 200);


    $scope.hintFirstTime = true;

    var showHelp = true;
    var activeElem = document.activeElement;
    var codeset = { 72: false };

    if (activeElem && (activeElem.tagName.toLowerCase() == 'input' &&
        activeElem.type == 'text' ||
        activeElem.tagName.toLowerCase() == 'textarea')) showHelp = false;

    $scope.IntroOptions = $rootScope.introData;

    $window.onkeydown = function(e) {
      if (e.keyCode in codeset) {
        codeset[e.keyCode] = true;
        if (codeset[72] && showHelp) {
          angular.element('.d-hints').removeAttr("data-hint");

          if ($rootScope.activeController === "caseStudyPageCntrl") {
            if ($scope.hintFirstTime) {
              introJs().setOptions($scope.IntroOptions);
              introJs().addHints();
              $scope.hintFirstTime = false;
            } else {
              introJs().showHints();
              introJs().refresh();
            }
            codeset[72] = false;
          }
        }
      }

      if (e.keyCode == 27) {
        //angular.element('.d-hints').css('display','block');
        angular.element('#d-point').attr("data-hint", "Earn points while you learn! You’re already up by 20 points by simply setting up your profile.");
        angular.element('#d-burger').attr("data-hint", "Want help? Want to report an issue? Or do you simply want to change your settings? Access your entire menu options here.");
        angular.element('#d-status').attr("data-hint", "Track the overall status of your learning here. Click on your Avatar on the left for a closer look at your activity, progress and where you stand on the Leaderboard.");

        introJs().hideHints();
      }

    };

    $window.onkeyup = function(e) {
      if (e.keyCode in codeset) {
        codeset[e.keyCode] = false;
      }
    };


    // intro changes ends here


  });

'use strict';
( function() {
    angular
        .module( 'jigsawCorpLms' )
        .config( routerConfig );

    /** @ngInject */
    function routerConfig( $stateProvider ) {
        $stateProvider
            .state( 'home.help.takeTour', {
                url: '/takeAtour',
                templateUrl: 'app/Features/helpPage/template/takeTourPage/takeTourPage.html',
                controller: 'takeTourCntrl'
            } );
    }
} )();

'use strict';
angular.module('jigsawCorpLms')
    .controller('takeTourCntrl', function($scope, fetchData, $rootScope, $timeout) {


    });
'use strict';
( function() {
    angular
        .module( 'jigsawCorpLms' )
        .config( routerConfig );

    /** @ngInject */
    function routerConfig( $stateProvider ) {
        $stateProvider
            .state( 'home.help.support', {
                url: '/support',
                templateUrl: 'app/Features/helpPage/template/supportState/supportState.html',
                controller: 'helpSupportCntrl'
            } );
    }
} )();

'use strict';
angular.module('jigsawCorpLms')
    .controller('helpSupportCntrl', function($scope, fetchData, $rootScope, $timeout, $state, DataCache) {

        $scope.user_data = DataCache.returnData("userData");

        if ($scope.user_data.role === "Learner") {
            $scope.supportTopics = [{
                'title': 'Ask Faculty',
                'iconClass': 'icon-learning'
            }, {
                'title': 'Issues & Bugs',
                'iconClass': 'icon-book'
            }, {
                'title': 'Others',
                'iconClass': 'icon-troubleshooting'
            }];
        } else if ($scope.user_data.role === "Manager" || $scope.user_data.role === "L&D Manager") {
            $scope.supportTopics = [{
                'title': 'Issues & Bugs',
                'iconClass': 'icon-book'
            }, {
                'title': 'Others',
                'iconClass': 'icon-troubleshooting'
            }];
        }

        $scope.currentSupportItem = $scope.supportTopics[0].title;
        $scope.srchResultFilter = ["All Tickets", "pending", "resolved"];
        var prevTicket;
        //$scope.selectedFilterLength = $scope.ticketsData.length;

        $scope.srchResultFilterItem = $scope.srchResultFilter[0];
        $scope.srchResultFilterParam = function(index) {
            $scope.selectedFilterLength = 0;
            $scope.toggleSrchFilter = !$scope.toggleSrchFilter;
            $scope.srchResultFilterItem = $scope.srchResultFilter[index];
            switch ($scope.srchResultFilterItem) {
                case 'All Tickets':
                    $scope.selectedFilter = undefined;
                    $scope.selectedFilterLength = $scope.ticketsData.length;
                    break;
                case "pending":
                    $scope.selectedFilter = false;
                    for (var i = 0; i < $scope.ticketsData.length; i++) {
                        if (!$scope.ticketsData[i].ticketStatus) {
                            $scope.selectedFilterLength++;
                        }
                    }
                    break;
                case "resolved":
                    $scope.selectedFilter = true;
                    for (var i = 0; i < $scope.ticketsData.length; i++) {
                        if ($scope.ticketsData[i].ticketStatus) {
                            $scope.selectedFilterLength++;
                        }
                    }
                    break;
            }

        };

        $scope.srchFilterToggle = function() {
            $scope.toggleSrchFilter = !$scope.toggleSrchFilter;
        };


        $scope.supportTopic = function(title) {
            $scope.currentSupportItem = title;
        };

        $scope.sendMail = function() {
            $window.location.href = "mailto:help.rubric@jigsawacademy.com";
        }

        $scope.takeNoteChange = function() {
            var ele1 = angular.element("textarea");
            var ele2 = angular.element("input");
            ele1.css('box-shadow', 'none');
            ele2.css('box-shadow', 'none');
        }

        $scope.openTicket = function(type, issue) {


            if (!type || type === "" || type.trim().length === 0) {
                var sub = angular.element("input");
                sub.css({
                    'width': '99.7%',
                    'margin-left': '0.2%',
                    'box-shadow': '0px 0px 22px -3px rgba(209,71,0,1)'
                });
                sub.focus();
                return;
            }
            if (!issue || issue === "" || issue.trim().length === 0) {
                var sub = angular.element("textarea");
                sub.css({
                    'box-shadow': '0px 0px 22px -3px rgba(209,71,0,1)'
                });
                sub.focus();
                return;
            }



            var data = { "requestType": $scope.currentSupportItem, "requestSubject": type, "requestDesc": issue };
            fetchData.supportTicket(data).then(function(response) {

                if (response.data.status !== "error") {
                    $scope.goToDashboard();

                    //  $state.go('home.dashboard');
                }

            });
            // $scope.currentTicket = ticketIndex;
            // if ( prevTicket == ticketIndex ) {
            //     $scope.shwTicket = !$scope.shwTicket;
            // } else {
            //     $scope.shwTicket = true;
            // }
            // prevTicket = ticketIndex;
        };


    });
'use strict';
( function() {
    angular
        .module( 'jigsawCorpLms' )
        .config( routerConfig );

    /** @ngInject */
    function routerConfig( $stateProvider ) {
        $stateProvider
            .state( 'home.help.faq', {
                url: '/faq',
                templateUrl: 'app/Features/helpPage/template/faqState/helpFaq.html',
                controller: 'helpFAQCntrl'
            } );
    }
} )();

'use strict';
angular.module('jigsawCorpLms')
    .controller('helpFAQCntrl', function($scope, fetchData, $rootScope, $timeout, $state, DataCache) {

        var prevQuestion;
        var prevTabState;
        $scope.currentFaqTabName = 1;


        $scope.user_data = DataCache.returnData("userData");

        if ($scope.user_data.role === "Learner") {
            $scope.faqTopics = [{
                'title': 'learning',
                'id': 1,
                'iconClass': 'icon-learning'
            }, {
                'title': 'Content',
                'id': 2,
                'iconClass': 'icon-book'
            }, {
                'title': 'Troubleshooting',
                'id': 3,
                'iconClass': 'icon-troubleshooting'
            }];
        } else {
            $scope.faqTopics = [];
        }

        $scope.openAnswer = function(index) {
            $scope.currentQuestion = index;
            if (prevQuestion == index) {
                $scope.shwAnswer = !$scope.shwAnswer;
            } else {
                $scope.shwAnswer = true;
            }
            prevQuestion = index;
        }

        $scope.changeTabFaq = function(tab) {
            $scope.currentQuestion = undefined;
            $scope.shwAnswer = false;
            $scope.currentFaqTabName = tab;
            switch (tab) {
                case 1:
                    $scope.faqQuestions = $scope.learningQuestions;
                    break;
                case 2:
                    $scope.faqQuestions = $scope.contentQuestions;
                    break;
                case 3:
                    $scope.faqQuestions = $scope.trblShtingQuestions;
                    break;
            }
            if ($scope.currentFaqTabName === prevTabState) {
                $scope.shwFreqntAns = !$scope.shwFreqntAns;
            } else {
                $scope.shwFreqntAns = true;
            };
            prevTabState = tab;

        }
        $scope.raiseAticket = function() {
            $state.go('home.help.support');
        }
    });
'use strict';
( function() {
    angular
        .module( 'jigsawCorpLms' )
        .config( routerConfig );

    /** @ngInject */
    function routerConfig( $stateProvider ) {
        $stateProvider
            .state( 'buyer.welcome', {
                url: '/welcome',
                templateUrl: 'app/Features/buyerJourney/partials/welcomeScreen/welcomeScreen.html',
                controller: 'welcomeScreenCtrl'
            } );
    }

} )();

'use strict';
angular
    .module('jigsawCorpLms')
    .controller('welcomeScreenCtrl', function($controller, $scope, $state, $window, $timeout, $rootScope, $http, DataCache, fetchData, rubricGuide) {


        //console.log($scope.ShouldAutoStart);
        $rootScope.activeController = "welcomeScreenCtrl";
        $rootScope.$broadcast('new-controller-loaded');


        $scope.authData = DataCache.returnData("userData");
        $http.defaults.headers.common['Authorization'] = "Bearer " + $scope.authData.jwttoken;
        $http.defaults.headers.common['Content-Type'] = "application/x-www-form-urlencoded";

        $scope.bJourneyObj.navBarShow = false;

        $rootScope.bheaderShow = false;
        $rootScope.headerShow = false;
        $scope.showDescription = false;
        var activeLp;

        DataCache.saveGlobalData('guide', "$scope.welcomeScreenCtrl");
        $rootScope.activeController = '$scope.welcomeScreenCtrl';

        $scope.goToSetupProfile = function() {
            $rootScope.$broadcast("cookie-updated");
            $state.go('buyer.dashboard.trackProgress');
        };


        $window.onkeypress = function(event) {
            if (event.keyCode == 104) {
                $scope.startGuide('welcomeScreenCtrl');
            }
        };


        $window.onclick = function(event) {

            var classEle = $("#" + event.target.id).children(".lp-description").attr("class");

            if (classEle === undefined) {
                $scope.showDescription = false;
                $("#" + activeLp).children(".lp-description").addClass("ng-hide");
            }
        }



        var prevlp = "";

        $scope.showDesc = function(event) {

            $timeout(function() {

                activeLp = event.target.id;
                var showEle = $("#" + event.target.id).children(".absolute").hasClass("ng-hide");

                if (event.target.id != prevlp) {
                    $("#" + prevlp).children(".absolute").addClass("ng-hide");

                    if (showEle) {
                        $("#" + event.target.id).children(".absolute").removeClass("ng-hide");
                    } else {
                        $("#" + event.target.id).children(".absolute").addClass("ng-hide");
                    }
                } else {
                    if (showEle) {
                        $("#" + event.target.id).children(".absolute").removeClass("ng-hide");
                    } else {
                        $("#" + event.target.id).children(".absolute").addClass("ng-hide");
                    }
                }

                prevlp = event.target.id;
            }, 100);
        }




        // changes for intro.js

        // $scope.IntroOptions =$rootScope.introData;
        // $scope.ShouldAutoStart=false;
        //
        // $timeout(function () {
        //     if($rootScope.firstTimeLogin){
        //       $scope.CallMe();
        //     }
        // }, 200);
        //
        //
        // $window.onkeypress = function(event){
        //    if(event.keyCode == 104 )
        //    {
        //         introJs().addHints();
        //    }
        //    if(event.keyCode == 106 )
        //    {
        //         introJs().hideHints();
        //    }
        //  };

        // intro changes ends here

    });
'use strict';
( function() {
    angular
        .module( 'jigsawCorpLms' )
        .config( routerConfig );

    /** @ngInject */
    function routerConfig( $stateProvider ) {
        $stateProvider
            .state( 'buyer.dashboard', {
                url: '/buyerdashboard',
                templateUrl: 'app/Features/buyerJourney/partials/buyerDashboard/buyerDashboard.html',
                controller: 'buyerDashboardCtrl'
            } );
    }

} )();

'use strict';
angular
    .module('jigsawCorpLms')
    .run(['$anchorScroll', function($anchorScroll) {
        $anchorScroll.yOffset = 50; // always scroll by 50 extra pixels
    }])
    .controller('buyerDashboardCtrl', function($scope, $state, $rootScope, fetchData, $sce, $timeout, DataCache, $anchorScroll, $location, $window, $controller, $http, $cookies, RestEndpoints) {

        //DataCache.loadFromWebstorage();
        angular.extend(this, $controller('userProfileCtrl', {
            $scope: $scope
        }));

        var appWindow = angular.element($window);
        appWindow.bind('resize', function() {
            $scope.bJourneyObj.skillTableExpnd = false; // collapses further expanded states of tiles - below three lines
            $scope.bJourneyObj.lHealthTableExpnd = false;
            $rootScope.$broadcast('closeTiles');
        });

        var user_data = DataCache.returnData('userData');
        $rootScope.templateUrl = DataCache.returnData('templateUrl');
        $http.defaults.headers.common['Authorization'] = "Bearer " + user_data.jwttoken;
        $http.defaults.headers.common['Content-Type'] = "application/x-www-form-urlencoded";


        $rootScope.activeController = "buyerDashboardCtrl";
        $scope.bJourneyObj.currentTab = 'trackProgress';
        $rootScope.$broadcast('new-controller-loaded');




        // console.log("inside DataCache.returnData");
        //   var userDetails=DataCache.returnData("userData");
        //   console.log(userDetails);
        //   var users;
        //   if(userDetails.hasOwnProperty('auth')){
        //     users=userDetails.auth.role;
        //   }else{
        //     users=userDetails.role;
        //   }
        //   if(users === 'Learner'){
        //       $rootScope.templateUrl='';
        //       DataCache.saveRootScopeData('templateUrl',$rootScope.templateUrl);
        //   }else{
        //       $rootScope.templateUrl='app/Common/Directives/popout/popout.html';
        //       DataCache.saveRootScopeData('templateUrl',$rootScope.templateUrl);
        //   }



        $scope.learnersLoaded = true;

        $scope.authData = DataCache.returnData("userData");

        $http.defaults.headers.common['Authorization'] = "Bearer " + $scope.authData.jwttoken;
        $http.defaults.headers.common['Content-Type'] = "application/x-www-form-urlencoded";


        angular.element(document.querySelector('.parent-ui-view')).css('overflow-y', 'hidden');
        angular.element(document.querySelector('.dashboard-ui-view')).attr("style", "position:fixed;top:50px;right:0px");

        $rootScope.bheaderShow = true;
        $scope.bJourneyObj.navBarShow = true;

        $scope.userProfile = false;
        var data;
        var widget_count = 0;
        var role = $scope.role;
        $scope.selectAll = false;
        $scope.lHealth = false;
        $scope.skills = false;
        $scope.skills1 = false;
        $scope.learningHours = false;
        $scope.licenseMng = false;
        $scope.toggleDownloadFilter = false;

        if ($scope.bJourneyObj.isHead) {
            data = { "clientId": $scope.id };
        } else if ($scope.bJourneyObj.isManager) {
            data = { "fbUsername": $scope.fbId };
        }

        if (DataCache.returnData("userData")) {
            $scope.userDetails = DataCache.returnData("userData");
            var users;
            if ($scope.userDetails.hasOwnProperty('auth')) {
                users = $scope.userDetails.auth.role;
            } else {
                users = $scope.userDetails.role;
            }
            if (users === 'L&D Manager') {
                var onTrackBuyerMessages = "_name, the force is strong with your teams. Everyone's on track.";
            } else if (users === 'Manager') {
                var onTrackBuyerMessages = "_name, congratulations! All your learners are on track.";
            }
        }

        // Buyer Dynamic messages
        var firstTimeBuyerMessage = "Hey _name, You have _license unallocated licenses";
        var firstTimeManagerMessage = "Welcome _name !";
        var offTrackBuyerMessages = "_name, you have teams falling behind. Check the Learning Health.";

        $rootScope.$on('lh-loaded', function() {

            fetchData.fetchProfileData().then(function(response) {
                // update avatar level
                $scope.avatar = $rootScope.baseimageurl + '/avatars/1/' + response.data.profile.profilePhotoUrl;
                angular.element($(".setup-profile-image")).css("background", "rgba(0, 0, 0, 0) url('" + $scope.avatar + "') scroll 0px 0px / 100% 100% padding-box border-box");

                var userFirstName = response.data.profile.firstname;
                if ($scope.bJourneyObj.dashData.LearningHealth.length > 0) {
                    if ($scope.bJourneyObj.dashData.LearningHealth[$scope.bJourneyObj.dashData.LearningHealth.length - 1].percentage < 100) {
                        $scope.teamOnTrack = false; // TODO: Karthick please update this flag.
                    } else {
                        $scope.teamOnTrack = true;
                    }
                } else {
                    $scope.teamOnTrack = false;
                }


                if ($rootScope.firstTimeLogin) {
                    $scope.licenses = $scope.bJourneyObj.WelcomeLicense.welcomeScreenData[0].noOfLicensesUnAllocated;
                    if (users === "L&D Manager") {
                        $scope.bJourneyObj.message = firstTimeBuyerMessage.replace("_name", userFirstName).replace("_license", $scope.licenses);
                    } else if (users === "Manager") {
                        $scope.bJourneyObj.message = firstTimeManagerMessage.replace("_name", userFirstName);
                    }
                } else {

                    fetchData.testRetake().then(function(response) {
                        if (response.data.status !== "error") {
                            $scope.lretake = response.data;
                        }
                        if ($scope.lretake && $scope.lretake.retaketest.length > 0) {
                            var BuyerMessages = "Hey _name, you have requests pending for proficiency test retake.";
                            $scope.bJourneyObj.message = BuyerMessages.replace("_name", userFirstName);
                        } else if ($scope.teamOnTrack) {
                            $scope.bJourneyObj.message = onTrackBuyerMessages.replace("_name", userFirstName);
                        } else {
                            $scope.bJourneyObj.message = offTrackBuyerMessages.replace("_name", userFirstName);
                        }
                    });
                }

            });

        });


        fetchData.fetchBuyersJourneyData(data, role).then(function(response) {
            if (response.data.status !== "error") {
                $scope.bJourneyObj.dashboardInfo = response.data;
            } else {
                console.log(response);
            }
        });

        // main tile api calls

        fetchData.fetchBJLearningHealth(data, role).then(function(response) {
            if (response.data.status !== "error") {
                $scope.bJourneyObj.dashData = response.data;
                widget_count++;
                $rootScope.$broadcast(widget_count);
                $rootScope.$broadcast('lh-loaded');

            } else {
                console.log(response);
            }
        });


        var cId;
        if ($scope.authData.hasOwnProperty('auth')) {
            cId = $scope.authData.auth.clientId;
        } else {
            cId = $scope.authData.clientId;
        }
        var roiData = { "clientId": cId };
        fetchData.fetchBJROI(roiData).then(function(response) {
            if (response.data.status !== "error") {
                $scope.bJourneyObj.dashDataROI = response.data;
                widget_count++;
                $rootScope.$broadcast(widget_count);
            } else {
                console.log(response);
            }
        });

        fetchData.fetchBJSkills(data, role).then(function(response) {

            if (response.data.status !== "error") {
                $scope.bJourneyObj.dashDataskills = response.data;
                var skill = $scope.bJourneyObj.dashDataskills.learningSkills;
                $scope.totalSkillAcquired = 0;
                for (var i = 0; i < $scope.bJourneyObj.dashDataskills.learningSkills.length; i++) {
                    $scope.totalSkillAcquired = $scope.totalSkillAcquired + $scope.bJourneyObj.dashDataskills.learningSkills[i].skillCount;
                }

                $scope.totalLearnersCount = 0;

                for (var i = 0; i < skill.length; i++) {
                    $scope.totalLearnersCount = $scope.totalLearnersCount + skill[i].SkillLearners;
                }

                widget_count++;
                $rootScope.$broadcast(widget_count);
            } else {
                console.log(response);
            }

        });

        fetchData.fetchBJTotLrngHrs(data, role).then(function(response) {
            if (response.data.status !== "error") {
                $scope.bJourneyObj.dashDataHrs = response.data;
                var widgetHours = 0;
                for (var i = 0; i < $scope.bJourneyObj.dashDataHrs.learningHrs.length; i++) {
                    widgetHours = widgetHours + $scope.bJourneyObj.dashDataHrs.learningHrs[i].timeAlreadySpent;

                }
                $scope.widgetLearningHours = widgetHours;
                widget_count++;
                $rootScope.$broadcast(widget_count);
            } else {
                console.log(response);
            }
        });


        fetchData.fetchBJLicenseData(data, role).then(function(response) {
            if (response.data.status !== "error") {
                $scope.LMData = response.data;
                widget_count++;
                $rootScope.$broadcast(widget_count);
            } else {
                console.log(response);
            }
        });

        if (role === "L&D Manager") {

            fetchData.fetchBuyerPurchaseHistoryData(data).then(function(response) {
                if (response.data.status !== "error") {
                    $scope.purchaseHistory = response.data;
                } else {
                    console.log(response);
                }
            });

        }

        // main tile api calls ends here


        // sub function

        $scope.templateUrlGenerator = function(data) {

            $scope.widegetUrl = [];
            var path = 'app/Features/buyerJourney/partials/buyerDashboard/templates/';
            var ext = '.html';

            for (var i = 0; i < data.length; i++) {

                if (data[i].checked) {

                    var tempPath = path + data[i].widget_title + '/' + data[i].widget_title + ext;
                    tempPath = $sce.trustAsResourceUrl(tempPath);
                    $scope.widegetUrl.push(tempPath);

                }
            }
        };

        $scope.showTilesFunc = function() {

            $scope.showLearningHealthTile = $scope.bJourneyObj.widgetsBar.widgets[0].checked;
            $scope.showSkillsTile = $scope.bJourneyObj.widgetsBar.widgets[1].checked;
            $scope.showLearningHoursTile = $scope.bJourneyObj.widgetsBar.widgets[2].checked;
            $scope.LicenseManageTile = $scope.bJourneyObj.widgetsBar.widgets[3].checked;
            $scope.showROITile = $scope.bJourneyObj.widgetsBar.widgets[4].checked;

        };

        $rootScope.$on('widgetsDataFetched', function() {

            $scope.bJourneyObj.isWidgetsDataFetched = true;

        });

        $scope.applySchemaMob = function() {
            $timeout(function() {
                var maskew = new Maskew(document.getElementById("setupProfileImageMob"), 20);
            }, 100);

        };

        // $scope.applySchemaMob();

        $scope.usrImage = function() {

            var temp = 'url("' + $rootScope.modelParent.userImage + '")';

            return {
                'background-image': temp
            }
        };

        $scope.setheightOftile = function(elem) {

            var ind = 0;

            while (ind < elem.length) {
                elem[ind].style.height = 'auto';
                ind++;
            }

        };

        $rootScope.$on('closeTiles', function() {

            $scope.tileExpnd = false;
            var angularEle = angular.element('.bdashboard-tiles');
            $scope.resetTileheight(angularEle);

        });

        $rootScope.$on("5", function() {

            $rootScope.$broadcast("dashboard-data-fetched");
            $scope.IntroOptions = $scope.IntroOpt;
        });

        $scope.resetTileheight = function(elements) {
            for (var i = 0; i < elements.length; i++) {
                elements[i].style.height = 'auto';
            };

        };

        $scope.UnselectAll = function(event) {

            if (angular.element(event.target).hasClass('icon-checkbox_selected')) {

                angular.element("#selectAllLabel").removeClass('icon-checkbox_selected');
                angular.element("#selectAllLabel").addClass('icon-checkbox_inactive');

            }
        }

        var prevIndex;

        $scope.badgeItemClick = function(index, id, parentIndex) {

        };


        var prevInd;

        $scope.activeTile = "";
        var selectedTile;

        $scope.tileClick = function(index, expand) {

            if ($scope.activeTile !== index) {

                $scope.activeTile = index;

            } else {
                $scope.activeTile = "";
            }

            if (!$scope.isMediumScrennDevice && !$scope.isMobilePhoneDevice) {

                var angularEle = angular.element('.bdashboard-tiles');
                var selectItemOffset = angularEle[index].offsetTop;
                var ind = 0;

                //  $timeout(function(){
                //    console.log(angular.element( '.expanded-wrp' ).height());
                //  },300);
                if (expand == null) {
                    $scope.bJourneyObj.skillTableExpnd = false;
                    $scope.bJourneyObj.lHealthTableExpnd = false;
                }

                $scope.currentTile = index;
                if (expand == null) {
                    if (index == prevInd) {
                        $timeout(function() {
                            $scope.tileExpnd = !$scope.tileExpnd;
                        }, 200);

                    } else {
                        $timeout(function() {
                            $scope.tileExpnd = true;
                        }, 200);
                    }
                }

                $timeout(function() {
                    $scope.resetTileheight(angularEle);
                    var selectItemOffset = angularEle[index].offsetTop;
                    var updateHeight = angular.element('.expanded-wrp').height();
                    var height;

                    $rootScope.$on('update-height', function() {
                      
                        height = 0;
                        $('.bdashboard-tiles').css('height', 0);
                        updateHeight = angular.element('.expanded-wrp').height();
                        height = $('.main-widget-tile').height() + updateHeight + 60;
                        $('.main-widget-tile').closest('.bdashboard-tiles').css('height', height);
                        
                    });
                    height = $('.bdashboard-tiles').height() + updateHeight + 60;
                    
                    if ($scope.tileExpnd) {
                       
                        while (ind < angularEle.length) {
                            if (angularEle[ind].offsetTop == selectItemOffset) {
                                angularEle[ind].style.height = height + 'px';
                                //}
                            } else {
                                angularEle[ind].style.height = 'auto';
                            }
                            ind++;
                        }
                    }
                }, 200);

                prevInd = index;
            }
        };

        $scope.gotoAnchor = function(event) {

            $timeout(function() {

                var newHash = 'expanded-wrp';

                if ($location.hash() !== newHash) {
                    $location.hash(newHash);
                } else {
                    $anchorScroll();
                }

            }, 200);

        };




        $rootScope.$on("buyers-profile", function() {
            $rootScope.userProfile = true;
            $scope.userProfile = true;
            $scope.bJourneyObj.currentTab = '';
        });

        $rootScope.$on("setting-to-dashboard", function() {
            $rootScope.userProfile = false;
            $scope.userProfile = false;
            $scope.bJourneyObj.currentTab = 'trackProgress';
            $state.go('buyer.dashboard.trackProgress');
        });


        $scope.goToDashboard = function() {
            $scope.userProfile = false;
            $rootScope.userProfile = false;
            $state.go('buyer.dashboard.trackProgress');
        }

        // download funtion starts here
        $scope.downloadlist = function() {
            $scope.toggleDownloadFilter = !$scope.toggleDownloadFilter;
        };
        $scope.passEvent = function($event) {
            var ele1 = angular.element(".downloadlist-filter.table-cell");
            var ele2 = angular.element(".downloadlist-wrp");
            if (ele1[0] === $event.target || $(ele1).find($event.target).length > 0 || ele2[0] === $event.target || $(ele2).find($event.target).length > 0) {} else {
                $scope.toggleDownloadFilter = false;
            }
        }

        $scope.SelectAllDOwnload = function() {

            if (angular.element('.downloadlist-item').children('label').hasClass('icon-checkbox_inactive')) {

                angular.forEach(angular.element('.dwnList'), function(value, key) {
                    angular.element(value).addClass('icon-checkbox_selected');
                    angular.element(value).removeClass('icon-checkbox_inactive');

                });
            } else if (angular.element('.downloadlist-item').children('label').hasClass('icon-checkbox_selected')) {

                angular.forEach(angular.element('.dwnList'), function(value, key) {
                    angular.element(value).addClass('icon-checkbox_inactive');
                    angular.element(value).removeClass('icon-checkbox_selected');

                });

            }
        }


        $scope.downloadWidgetData = function() {

            var downloadWidgetList = [];

            angular.forEach(angular.element('.dwnList'), function(value, key) {

                if (angular.element(value).hasClass('icon-checkbox_selected')) {
                    var widgetID = angular.element(value).attr('id');
                    downloadWidgetList.push(widgetID);
                }

            });

            for (var ele in downloadWidgetList) {
                $scope.SwitchFuction(downloadWidgetList[ele])
            }
        };
        // sub functions ends here

        $scope.retrieveHieght = function() {
            $timeout(function() {
                //var updateHeight=angular.element( '.expanded-wrp' ).height();
                $rootScope.$broadcast('update-height');
            }, 200);
        }


        $scope.baseUrl = RestEndpoints.baseURL + "/reports"; // "http://localhost:1442/reports";
        $scope.downloadReport = function(reportPath) {
            $window.open($scope.baseUrl + "/" + reportPath + "/" + user_data.jwttoken, "_blank");

        }
        $scope.reportFields = [];
        $scope.SwitchFuction = function(caseStr) {

            switch (caseStr) {
                case 'selectAll':
                    {
                        $scope.downloadReport("downloadlearninghealth");
                        $scope.downloadReport("downloadlearninghour", "hours");
                        $scope.downloadReport("downloadlearningskills", "skills");
                        $scope.downloadReport("downloadlicencemgmt", "license");
                    }
                    /*
                    var data =$scope.bJourneyObj.lhDrillData.LearningHealthByTeam;
                    var filename = caseStr;
                    $scope.reportFields={teamName:'Team',managerDesignation:'Designation',managerName:' Manager name',noOfLearnersInTeam:'Learners Count' };
                    var separator =";"
                    $scope.downloadFile(data,filename,$scope.reportFields);
                    */
                    break;
                case 'learning-health':
                    {
                        $scope.downloadReport("downloadlearninghealth");
                    }
                    /*
                    $window.open($scope.baseUrl + "/", "_blank");
                    var data =$scope.bJourneyObj.dashData.LearningHealth;
                    var filename = caseStr;
                    $scope.reportFields={weekNum:'Week Number',weeks:'Date',percentage:' Percentage' };
                    var separator =";"
                    $scope.downloadFile(data,filename,$scope.reportFields);
                    */
                    break;
                case 'skills':
                    {
                        $scope.downloadReport("downloadlearningskills");
                    }
                    /*
                    var data =$scope.bJourneyObj.dashDataskills.learningSkills;
                    var filename = caseStr;
                    $scope.reportFields={lpTitle:'Learning Path',noOfLearnersInModule:'Number of learners in module',pctOfSkillsAcq:' Percentage of skill acquired',totalSkills:'Total skills' };
                    var separator =";"
                    $scope.downloadFile(data,filename,$scope.reportFields);
                    */
                    break;
                case 'learning-hours':
                    {
                        $scope.downloadReport("downloadlearninghour");
                    }
                    /*
                    var data =$scope.bJourneyObj.dashDataHrs.learningHrs;
                    var filename = caseStr;
                    $scope.reportFields={weekNum:'Weeks',weeks:'Date',hours:' Hours for this week',hoursRequired:'Required Hours for ',notCompletedHrs:'Hours not completed for this week',percentage:'percentage',timeAlreadySpent:'Total time spent',totalHrsRequiredToSpend:'Total hours required to be spent' };
                    var separator =";"
                    $scope.downloadFile(data,filename,$scope.reportFields);
                    */
                    break;
                case 'license-management':
                    {
                        $scope.downloadReport("downloadlicencemgmt");
                    }
                    /*
                    var data =$scope.LMData.licenceMgmtContents;
                    var filename = caseStr;
                    $scope.reportFields={purchasedLicences:'License Purchased',allocatedLicences:'License allocated',unAllocatedLicences:'Unallocate Licenses' };
                    var separator =";"
                    $scope.downloadFile(data,filename,$scope.reportFields);
                    */
                    break;
            }
        };

        $scope.downloadFile = function(data, filename, reportFields) {

            var fields = [];
            var header = [];
            var separator = ';';

            angular.forEach($scope.reportFields, function(field, key) {

                if (!field || !key) {
                    throw new Error('error json report fields');
                }

                fields.push(key);
                header.push(field);
            });


            var bodyData = _bodyData();
            var strData = _convertToExcel(bodyData);

            var blob = new Blob([strData], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8" });
            return saveAs(blob, [filename + '.xls']);

            function _bodyData() {
                var dataset = data;
                var body = "";

                angular.forEach(dataset, function(dataItem) {
                    var rowItems = [];

                    angular.forEach(fields, function(field) {

                        if (field.indexOf('.')) {

                            field = field.split(".");
                            var curItem = dataItem;

                            // deep access to obect property
                            angular.forEach(field, function(prop) {
                                if (curItem !== null && curItem !== undefined) {
                                    curItem = curItem[prop];
                                }
                            });

                            dataset = curItem;

                        } else {

                            dataset = dataItem[field];
                        }

                        var fieldValue = dataset !== null ? dataset : ' ';

                        if (fieldValue !== undefined && angular.isObject(fieldValue)) {
                            fieldValue = _objectToString(fieldValue);
                        }

                        if (typeof fieldValue == 'string') {
                            rowItems.push('"' + fieldValue.replace(/"/g, '""') + '"');
                        } else {
                            rowItems.push(fieldValue);
                        }
                    });

                    body += rowItems.join(separator) + '\n';
                });
                return body;
            }

            function _convertToExcel(body) {

                return header.join(separator) + '\n' + body;
            }

            function _objectToString(object) {

                var output = '';
                angular.forEach(object, function(value, key) {
                    output += key + ':' + value + ' ';
                });

                return '"' + output + '"';
            }
        }


        // changes for intro js


        $scope.startIntro = DataCache.returnData("buyerDashboardIntro");
        if ($scope.startIntro === undefined || $scope.startIntro === null) {
            $scope.startIntro = true;
        }

        $timeout(function() {
            if ($rootScope.firstTimeLogin && $scope.startIntro) {
                $rootScope.$broadcast('new-controller-loaded');
                $scope.ShouldAutoStart = true;
                $scope.startIntro = false;
                DataCache.saveGlobalData("buyerDashboardIntro", $scope.startIntro);
            }
        }, 200);


        $scope.hintFirstTime = false;

        //keyCodes for Ctrl(17) Shift(16) and h(72)

        var showHelp = true;
        var activeElem = document.activeElement;

        if (activeElem && (activeElem.tagName.toLowerCase() == 'input' &&
                activeElem.type == 'text' ||
                activeElem.tagName.toLowerCase() == 'textarea')) showHelp = false;



        var codeset = { 72: false };
        $scope.IntroOpt = $rootScope.introData;
        //
        $window.onkeydown = function(e) {
            if (e.keyCode in codeset) {
                codeset[e.keyCode] = true;

                if (codeset[72] && showHelp) {
                    if ($rootScope.activeController === "buyerDashboardCtrl") {

                        $scope.IntroOptions = $scope.IntroOpt;
                        $timeout(function() {
                            introJs().setOptions($scope.IntroOptions);
                            $scope.CallMe();
                            $scope.hintFirstTime = false;
                            codeset[72] = false;
                        }, 100);
                    }

                }
            }
        };

        $window.onkeyup = function(e) {
            if (e.keyCode in codeset) {
                codeset[e.keyCode] = false;
            }
        };




        // intro changes ends here


    });
'use strict';
( function() {
    angular
        .module( 'jigsawCorpLms' )
        .config( routerConfig );

    /** @ngInject */
    function routerConfig( $stateProvider ) {
        $stateProvider
            .state( 'buyer.allocation', {
                url: '/allocation',
                templateUrl: 'app/Features/buyerJourney/partials/allocationScreen/allocationScreen.html',
                controller: 'allocationScreenCtrl'
            } );
    }

} )();

'use strict';
angular
    .module('jigsawCorpLms')
    .controller('allocationScreenCtrl', function($scope, $state) {

        $state.go('buyer.allocation.allocationForm');
    });
// 'use strict';

// angular.module( 'jigsawCorpLms' )
//     .factory( 'httpInterceptor', function( $q, $window, Token, $location, DataCache, $rootScope, $timeout ) {
//         var stepUpResponse = {};
//         var _queue = [];
//         var _excecuteQueue = function() {
//             $timeout( function() {
//                 for ( var i = 0; i <= _queue.length - 1; i++ ) {
//                     _queue[ i ]();
//                 }
//             }, 1 );
//         };
//         return {
//             request: function( config ) {
//                 config.headers = config.headers || {};
//                 var authToken = Token.getAuthToken();
//                 if ( config.url.indexOf( '.html' ) === -1 ) {
//                     if ( authToken ) {
//                         config.headers[ 'x-token' ] = authToken;
//                     }
//                     if ( !_.contains( config.url, 'ReIssueToken' ) ) {
//                         DataCache.saveGlobalData( 'PreviousRequest', config );
//                         if ( $rootScope.isReIssuingToken ) {
//                             var deferred = $q.defer();
//                             _queue.push( function() {
//                                 config.headers[ 'x-token' ] = Token.getAuthToken();
//                                 deferred.resolve( config );
//                             } );
//                             return deferred.promise;
//                         }
//                     } else {
//                         config.url = config.url + '?noCache=' + new Date().getTime();
//                     }
//                 }
//                 return config;
//             },
//             response: function( response ) {
//                 if ( _.contains( response.config.url, 'ReIssueToken' ) && $rootScope.isReIssuingToken ) {
//                     $rootScope.isReIssuingToken = false;
//                     _excecuteQueue();
//                 }
//                 if ( response.headers( 'x-response-type' ) === 'STEPUP' ) {
//                     stepUpResponse = response.data;
//                     DataCache.saveGlobalData( 'StepUp', stepUpResponse );
//                     if ( $location.$$path.indexOf( 'ProfilesAndSettings' ) >= 0 ) {
//                         $location.path( 'MainView/ProfilesAndSettings/OneTimePin' );
//                     } else if ( $location.$$path.indexOf( 'Login' ) >= 0 ) {
//                         $location.path( 'Login/Otp' );
//                     } else if ( $location.$$path.indexOf( 'ScheduleTxnAndTransfer/Receipts' ) >= 0 ) {
//                         $location.path( 'MainView/ScheduleTxnAndTransfer/OneTimePin' );
//                     } else {
//                         $location.path( 'MainView/Otp' );
//                     }
//                     $rootScope.validOtpState = true;
//                     return $q.reject( response );
//                 } else {
//                     return response;
//                 }
//             },
//             responseError: function( rejection ) {
//                 if ( rejection.config.url.indexOf( 'ReIssueToken' ) > -1 && $rootScope.isReIssuingToken ) {
//                     $rootScope.isReIssuingToken = false;
//                     _excecuteQueue();
//                 }
//                 return $q.reject( rejection );
//             }
//         };
//     } );

'use strict';
angular.module('jigsawCorpLms').service('dashboardDataService', function($http, $q) {
    var deferred;
    deferred = $q.defer();
    $http.get('roa-mobile/rest/SecurityService/AuthenticateDI/mappingJigsawDash').then(function(data) {
        deferred.resolve(data);
    });
    this.getdshbrd = function() {
        return deferred.promise;
    };
});
'use strict';
angular.module( 'jigsawCorpLms' ).service( 'SessionStore', function( $window ) {
    // AngularJS will instantiate a singleton by calling "new" on this function
    this.setItem = function( key, value ) {
        if ( $window.Modernizr.sessionstorage ) {
            $window.sessionStorage.setItem( key, value );
        }
    };
    this.getItem = function( key ) {
        if ( $window.Modernizr.sessionstorage ) {
            return $window.sessionStorage.getItem( key );
        }
    };
    this.clear = function() {
        if ( $window.Modernizr.sessionstorage ) {
            $window.sessionStorage.clear();
        }
    };
    this.removeItem = function( key ) {
        if ( $window.Modernizr.sessionstorage ) {
            $window.sessionStorage.removeItem( key );
        }
    };
} );

'use strict';
angular.module('jigsawCorpLms')
    .factory('ServiceEndpoint', function(RestEndpoints, $http, $q, $rootScope, $state, DataCache, $cookies, FirebaseService, $timeout) {
        var endpoints = {};


        function defineEndpoint(name, url, method, lazy) {
            endpoints[name] = {
                name: name,
                url: url,
                method: method,
                lazy: lazy,
                makeRequest: function(payload, responseType) {
                    payload = payload || {};
                    var request = {
                        method: method,
                        url: url,
                        data: payload,
                        lazy: lazy
                    };
                    if (responseType != 'undefined') {
                        request.responseType = responseType;
                    }
                    if (request.data.hasOwnProperty('notificationsIds')) {
                        $rootScope.showLoadingScreen = false;
                    } else {
                        $rootScope.showLoadingScreen = true;
                    }

                    var promise = $http(request).then(function(response) {
                            $rootScope.showLoadingScreen = false;
                            return response;
                        },
                        function(response) {
                            if (response.status === 401) {
                                console.log("unauthorizzed ..");
                                $rootScope.showLoadingScreen = false;
                                //$scope.firebaseLoaded = true;
                                DataCache.clearAll();
                                $cookies.remove('userDetails');
                                DataCache.saveGlobalData("unauthorized","Your previous session has expired. Please login again.");
                                $state.go('login');
                                $state.reload('login');
                                return;
                                
                                //$state.go('login');
                            }
                            $rootScope.showLoadingScreen = false;

                            return $q.reject(response);

                        });
                    $rootScope.showLoadingScreen = true;
                    return promise;
                }
            };
        }

        endpoints.adhockEndpoint = function(name, url, method, lazy) {
            defineEndpoint(name, url, method, lazy);
            return endpoints[name];
        };
        //define end point for all entries in RestEndpoints

        var baseURL = RestEndpoints.baseURL;
        var serviceEndpointsList = RestEndpoints.endpoints;
        for (var i = serviceEndpointsList.length - 1; i >= 0; i--) {
            defineEndpoint(serviceEndpointsList[i].name, baseURL + serviceEndpointsList[i].url,
                serviceEndpointsList[i].method, serviceEndpointsList[i].lazy);
        }
        return endpoints;
    });
'use strict';

angular.module('jigsawCorpLms').service('rubricGuide', function(SessionStore, $rootScope) {
    // AngularJS will instantiate a singleton by calling "new" on this function

    return {
        showGuide: function(key, value) {},
        IntroOptions: function() {}


    };
});
'use strict';

angular.module( 'jigsawCorpLms' )
    .service( 'RefreshHandler', function( DataCache, $window, $rootScope, $state,
        SessionStore ) {
        // AngularJS will instantiate a singleton by calling "new" on this function
        var isRefreshing = false;
        this.loadFromWebstorage = function() {
            DataCache.loadFromWebstorage();
            isRefreshing = true;
        };
        this.isRefreshing = function() {
            return isRefreshing;
        };
        this.refreshDone = function() {
            isRefreshing = false;
        };
        this.bindRefreshWarning = function( message ) {
            if ( $window.Modernizr.sessionstorage ) {
                this.setRedirectState();
                var msg = 'If you refresh then you will be taken back to the first step of and lose your progress';
                if ( $rootScope.isEcomPayment ) {
                    msg = 'If you refresh then you will be taken back to the first step of the process';
                }
                $window.onbeforeunload = function() {
                    if ( message ) {
                        msg = message;
                    }
                    return msg;
                };
            }
        };
        this.unbindRefreshWarning = function() {
            $window.onbeforeunload = null;
            SessionStore.removeItem( 'onRefreshRedirectState' );
        };
    } );

'use strict';
angular
    .module( 'jigsawCorpLms' ).factory( 'ErrorMessage', function( $rootScope ) {
        return {
            showExceptionModal: function( messages ) {
                var errorData = {
                    message: messages
                };
                $rootScope.$broadcast( 'genericServiceError', errorData );
            }
        };
    } );

'use strict';

angular
    .module( 'jigsawCorpLms' ).service( 'DeviceDetector', function( $window, $log ) {
        var windowInnerWidth;
        var maxSmallWidth = 738;
        var maxMediumWidth = 1024;
        var deviceType = '';
        var userAgent = $window.navigator.userAgent;
        var iosDeviceType;
        return {
            checkDevice: function() {
                windowInnerWidth = $window.innerWidth;
                if ( windowInnerWidth > maxMediumWidth ) {
                    deviceType = 'large';
                } else if ( windowInnerWidth >= maxSmallWidth && windowInnerWidth <= maxMediumWidth ) {
                    deviceType = 'medium';
                } else if ( windowInnerWidth < maxSmallWidth ) {
                    deviceType = 'small';
                } else {
                    $log.log( 'Unrecognised device type' );
                }
                return deviceType;
            },
            isIphone: function() {
                if ( userAgent.indexOf( 'iPhone' ) >= 0 ) {
                    iosDeviceType = true;
                }
                return iosDeviceType;
            },
            isIpad: function() {
                if ( userAgent.indexOf( 'iPad' ) >= 0 ) {
                    iosDeviceType = true;
                }
                return iosDeviceType;
            },
            isSafari: function() {
                if ( userAgent.indexOf( 'Safari' ) >= 0 && userAgent.search("Chrome") < 0) {
                    iosDeviceType = true;
                }
                return iosDeviceType;
            },
            getDeviceheight: function() {
                return $window.innerHeight;
            },
            getDeviceWidth: function() {
                return $window.innerWidth;
            },
            isLandscape: function(){
                return $window.matchMedia("(orientation: landscape)").matches;
            },
            isPortrait: function(){
                return $window.matchMedia("(orientation: portrait)").matches;
            }

        };
    } );

'use strict';

angular.module( 'jigsawCorpLms' ).service( 'DataCache', function( SessionStore ,$rootScope) {
    // AngularJS will instantiate a singleton by calling "new" on this function
    var globalData = {};
    var rootScopeData = {};
    var lpDetails = {};
    return {
        saveGlobalData: function( key, value ) {
            var copy = angular.copy( value );
            globalData[ key ] = copy;
            SessionStore.setItem( 'data', angular.toJson( globalData ) );
            return copy;
        },
        saveRootScopeData: function( key, value ) {
            var copy = angular.copy( value );
            rootScopeData[ key ] = copy;
            SessionStore.setItem( 'rootScopeData', angular.toJson( rootScopeData ) );
            return copy;
        },
        saveLpDetails: function(key, value) {
            var copy = angular.copy(value);
            lpDetails[ key ] = value;
            SessionStore.setItem( 'lpDetails', angular.toJson( lpDetails ) );
            return copy;
        },
        returnData: function( key ) {
            var copy = angular.copy( globalData[ key ] );
            return copy;
        },
        returnRootData: function( key ) {
            var copy = angular.copy( rootScopeData[ key ] );
            return copy;
        },
        returnLpData: function (key) {
            var copy = angular.copy(lpDetails[ key ]);
            return copy;
        },
        clearAll: function() {
            globalData = {};
            rootScopeData = {};
            lpDetails = {};
            SessionStore.clear();
        },
        clearCache: function( cacheNames ) {
            if ( Array.isArray( cacheNames ) ) {
                for ( var i = cacheNames.length - 1; i >= 0; i-- ) {
                    this.saveGlobalData( cacheNames[ i ], null );
                }
            } else {
                this.saveGlobalData( cacheNames, null );
            }
        },
        loadFromWebstorage: function() {
            globalData = angular.fromJson( SessionStore.getItem( 'data' ) ) || {};
            rootScopeData = angular.fromJson( SessionStore.getItem( 'rootScopeData' ) ) || {};
            this.loadRootScopeElements();
        },
        loadRootScopeElements: function() {
          for (var key in rootScopeData) {
            $rootScope[ key ] = this.returnRootData(key);
          }

        }
    };
} );
'use strict';
angular.module( 'jigsawCorpLms' )
    .service( 'AppUtilities', function( DataCache ) {
        return {
            removeObjKey: function( value, keyToRemove ) {
                var keyToRemoveLen = keyToRemove.length;
                for ( var i = 0; i < keyToRemoveLen; i++ ) {
                    delete value[ keyToRemove[ i ] ];
                }
                return value;
            },
            isIndexValid: function( val, characterSet ) {
                for ( var i = 0; i < characterSet.length; i++ ) {
                    if ( val.indexOf( characterSet[ i ] ) >= 0 ) {
                        return true;
                    }
                }
                return false;
            }
        };
    } );

'use strict';
angular
    .module( 'jigsawCorpLms' )
    .filter( 'twoDigit', function() {
        return function( number ) {
            var tempString;
            if ( number / 10 >= 0 && number / 10 < 1 ) {
                tempString = '0' + number;
            } else {
                tempString = number;
            }
            return tempString;
        };
    } );



'use strict';
angular
    .module( 'jigsawCorpLms' )
    .filter("trustAsHtml", ['$sce','$base64', function($sce ,$base64) {
        return function(htmlCode){
        	
            return $sce.trustAsHtml(htmlCode);
        }
    }]);
'use strict';
angular
    .module( 'jigsawCorpLms' )
    .filter("sanitize", ['$sce','$base64', function($sce ,$base64) {
        return function(htmlCode){
        	var markup =  $base64.decode(htmlCode);
            return $sce.trustAsHtml(markup);
        }
    }]);

 
'use strict';
angular
    .module( 'jigsawCorpLms' )
    .filter( 'dateFilter', function( $filter ) {
        return function( date ) {
            date = new Date( moment( date ) );
            date = $filter( 'date' )( date, "dd MMM yyyy" );
            return date;
        };
    } );

'use strict';
angular
    .module('jigsawCorpLms')
    .filter('timeFormat', function() {
        return function(milliSec) {
            var timeString;
            var sec = milliSec / 1000;
            var hh = sec / 3600;
            hh = Math.floor(hh);
            sec = sec - hh * 3600;
            var mm = sec / 60;
            mm = Math.floor(mm);
            sec = sec - mm * 60;
            hh = Math.round(hh);
            mm = Math.round(mm);
            sec = Math.round(sec);
            var min = mm;
            var time = sec;
            var hrs = hh;
            if (hh === 0 && mm === 0 && sec !== 0) {
                if (time / 10 >= 0 && time / 10 < 1) {
                    timeString = '00:0' + Number(sec);
                } else {
                    timeString = '00:' + Number(sec);
                }
            } else if (hh === 0 && mm !== 0) {
                if (min / 10 >= 0 && min / 10 < 1) {
                    if (time / 10 >= 0 && time / 10 < 1) {
                        timeString = '0' + Number(mm) + ':0' + Number(sec);
                    } else {
                        timeString = '0' + Number(mm) + ':' + Number(sec);
                    }
                } else {
                    if (time / 10 >= 0 && time / 10 < 1) {
                        timeString = Number(mm) + ':0' + Number(sec);
                    } else {
                        timeString = Number(mm) + ':' + Number(sec);
                    }
                }
            } else if (hh !== 0) {
                if (hrs / 10 > 0 && hrs / 10 < 1) {
                    if (min / 10 >= 0 && min / 10 < 1) {
                        if (time / 10 >= 0 && time / 10 < 1) {
                            timeString = '0' + Number(hh) + ':0' + Number(mm) + ':0' + Number(sec);
                        } else {
                            timeString = '0' + Number(hh) + ':0' + Number(mm) + ':' + Number(sec);
                        }
                    } else {
                        if (time / 10 >= 0 && time / 10 < 1) {
                            timeString = '0' + Number(hh) + ':' + Number(mm) + ':0' + Number(sec);
                        } else {
                            timeString = '0' + Number(hh) + ':' + Number(mm) + ':' + Number(sec);
                        }
                    }
                } else {
                    if (min / 10 >= 0 && min / 10 < 1) {
                        if (time / 10 > 0 && time / 10 < 1) {
                            timeString = Number(hh) + ':0' + Number(mm) + ':0' + Number(sec);
                        } else {
                            timeString = Number(hh) + ':0' + Number(mm) + ':' + Number(sec);
                        }
                    } else {
                        if (time / 10 >= 0 && time / 10 < 1) {
                            timeString = Number(hh) + ':' + Number(mm) + ':0' + Number(sec);
                        } else {
                            timeString = Number(hh) + ':' + Number(mm) + ':' + Number(sec);
                        }
                    }
                }
            } else if (hh === 0 && mm === 0 && sec === 0) {
                timeString = '00:00';
            }
            return timeString;
        };
    });

'use strict';
angular
    .module('jigsawCorpLms')
    .filter('transcriptTime', function() {
        return function(seconds) {
            var timeString;
            var sec = seconds;
            var hh = sec / 3600;
            hh = Math.floor(hh);
            sec = sec - hh * 3600;
            var mm = sec / 60;
            mm = Math.floor(mm);
            sec = sec - mm * 60;
            hh = Math.round(hh);
            mm = Math.round(mm);
            sec = Math.round(sec);
            var min = mm;
            var time = sec;
            var hrs = hh;
            if (hh === 0 && mm === 0 && sec !== 0) {
                if (time / 10 >= 0 && time / 10 < 1) {
                    timeString = '00:0' + Number(sec);
                } else {
                    timeString = '00:' + Number(sec);
                }
            } else if (hh === 0 && mm !== 0) {
                if (min / 10 >= 0 && min / 10 < 1) {
                    if (time / 10 >= 0 && time / 10 < 1) {
                        timeString = '0' + Number(mm) + ':0' + Number(sec);
                    } else {
                        timeString = '0' + Number(mm) + ':' + Number(sec);
                    }
                } else {
                    if (time / 10 >= 0 && time / 10 < 1) {
                        timeString = Number(mm) + ':0' + Number(sec);
                    } else {
                        timeString = Number(mm) + ':' + Number(sec);
                    }
                }
            } else if (hh !== 0) {
                if (hrs / 10 > 0 && hrs / 10 < 1) {
                    if (min / 10 >= 0 && min / 10 < 1) {
                        if (time / 10 >= 0 && time / 10 < 1) {
                            timeString = '0' + Number(hh) + ':0' + Number(mm) + ':0' + Number(sec);
                        } else {
                            timeString = '0' + Number(hh) + ':0' + Number(mm) + ':' + Number(sec);
                        }
                    } else {
                        if (time / 10 >= 0 && time / 10 < 1) {
                            timeString = '0' + Number(hh) + ':' + Number(mm) + ':0' + Number(sec);
                        } else {
                            timeString = '0' + Number(hh) + ':' + Number(mm) + ':' + Number(sec);
                        }
                    }
                } else {
                    if (min / 10 >= 0 && min / 10 < 1) {
                        if (time / 10 > 0 && time / 10 < 1) {
                            timeString = Number(hh) + ':0' + Number(mm) + ':0' + Number(sec);
                        } else {
                            timeString = Number(hh) + ':0' + Number(mm) + ':' + Number(sec);
                        }
                    } else {
                        if (time / 10 >= 0 && time / 10 < 1) {
                            timeString = Number(hh) + ':' + Number(mm) + ':0' + Number(sec);
                        } else {
                            timeString = Number(hh) + ':' + Number(mm) + ':' + Number(sec);
                        }
                    }
                }
            } else if (hh === 0 && mm === 0 && sec === 0) {
                timeString = '00:00';
            }
            return timeString;
        };
    });

// 'use strict';
// angular
//     .module('jigsawCorpLms')
//     .filter('minutesHours', function() {
//         return function(seconds) {
//             var timeString;
//             var sec = seconds;
//             var hh = sec / 3600;
//             hh = Math.floor(hh);
//             sec = sec - hh * 3600;
//             var mm = sec / 60;
//             mm = Math.floor(mm);
//             sec = sec - mm * 60;
//             hh = Math.round(hh);
//             mm = Math.round(mm);
//             sec = Math.round(sec);
//             if (seconds < 60) {
//                 timeString = Number(sec) + 's';
//                 }
//             else {
//                 timeString = Number(hh) + 'h' + Number(mm) + 'm';
//             }
//             return timeString;
//         };
//     });

    'use strict';
angular
    .module('jigsawCorpLms')
    .filter('minutesHours', function() {
        return function(seconds) {
            var timeString;
            // var sec = seconds;
            // var hh = sec / 3600;
            // hh = Math.floor(hh);
            // sec = sec - hh * 3600;
            // var mm = sec / 60;
            // mm = Math.floor(mm);            
            // sec = sec - mm * 60;
            // hh = Math.round(hh);
            // mm = Math.round(mm);
            // sec = Math.round(sec);
            // if(seconds < 60){
            //     timeString = Number(sec) + 's';
            // }
            // else{
            //     timeString = Number(hh) + 'h' + Number(mm) + 'm';
            // }
            // return timeString;

            var min =  seconds;
            var hh = min / 60 ;
            hh = Math.floor(hh);
            min = min - hh*60;
            min = Math.floor(min);
            if(seconds < 60){
                timeString = Number(min) + 'm';
            }else{
                timeString = Number(hh) + 'h' + Number(min) + 'm';
            }
            return timeString;
        };
    });
'use strict';

angular.module( 'jigsawCorpLms' )
    .factory( 'videoUtilities', function() {
        var highlightStorageArray = null;
        return {
            mapHighlightData: function( response, actualResponse ) {
                var orgTranscript = actualResponse.data.video_transcript;
                var scopeData = response.data;

                if ( !scopeData.video_highlighted_text ) scopeData.video_highlighted_text = [];
                var highlightArray = scopeData.video_highlighted_text;
                var highlightArrayLength = highlightArray.length;
                var transcriptArray = response.data.video_transcript;
                for ( var i = 0; i < highlightArrayLength; i++ ) {
                    transcriptArray.filter( function( value, index ) {
                        if ( parseFloat( value.startTime ) === parseFloat( highlightArray[ i ].video_timestamp_start ) ) {
                            var itrCopy = {};
                            angular.copy( orgTranscript[ index ], itrCopy );
                            itrCopy.text = ' ' + itrCopy.text + ' ';
                            value.text = itrCopy.text.replace( new RegExp( highlightArray[ i ].higlightText, "gi" ), function( match ) {
                                var thisId = "t-" + value.startTime;
                                return "<span class='highlightedText' id='" + thisId + "'>" + match + "</span>";
                            } );
                        }
                    } );
                }
                return response;
            },
            createHighlightData: function( response, selectedParams, actualResponse ) {
                var tempCompare = highlightStorageArray;
                var scopeData = response.data;
                var transcriptArray = scopeData.video_transcript;
                var transcriptArrayLength = transcriptArray.length;
                for ( var i = 0; i < transcriptArrayLength; i++ ) {
                    transcriptArray[ i ].text = ' ' + transcriptArray[ i ].text + ' ';
                };
                var highlightArray = scopeData.video_highlighted_text = highlightStorageArray || scopeData.video_highlighted_text;
                var selStartEleStartTime = selectedParams.startContainer.parentNode.id.split( '-' );
                var selEndEleStartTime = selectedParams.endContainer.parentNode.id.split( '-' );

                if ( !highlightArray)
                {
                  highlightArray = [];
                  scopeData.video_highlighted_text = [];
                }

                var selectedItems = transcriptArray.filter( function( value ) {
                    if ( parseFloat( value.startTime ) >= parseFloat( selStartEleStartTime[ 1 ] ) &&
                        parseFloat( value.startTime ) <= parseFloat( selEndEleStartTime[ 1 ] ) ) {
                        return value;
                    }
                } );
                var selectedItemsItr = selectedItems.length;
                for ( var k = 0; k < selectedItemsItr; k++ ) {
                    var tempObj = {};
                    tempObj.video_timestamp_start = selectedItems[ k ].startTime;
                    tempObj.video_timestamp_end = selectedItems[ k ].endTime;
                    tempObj.higlightText = selectedItems[ k ].text;
                    if ( k === 0 ) {
                        var tempFirstSel = selectedParams.toString().substring( 0, selectedItems[ k ].text.length );
                        var theSplitted = tempFirstSel.toString().split( '  ' );
                        tempObj.higlightText = theSplitted[ 0 ];
                    }
                    if ( k === selectedItemsItr - 1 && k !== 0 ) {
                        var tempStr =
                            tempObj.higlightText = selectedItems[ k ].text.substring( 0, selectedParams.endOffset );
                    }
                    highlightArray.push( tempObj );
                }

                highlightStorageArray = highlightArray;
                response.data.video_highlighted_text = highlightArray;
                var returnData = this.mapHighlightData( response, actualResponse );
                return returnData;
            },
            getSelectedText: function() {

            },
            rearrangeTranscriptData: function( response ) {
                var returnData = {};
                var videoData = response.data.video_transcript;
                var count = 0;
                var counter = 0;
                var videos = {};
                var videosData = {};
                videos[ count.toString() ] = [];
                videoData.forEach( function( val, ind ) {
                    if ( val.startOfParagraph ) {
                        videos[ count.toString() ].push( val );
                        counter++;
                    } else {
                        videos[ count.toString() ].push( val );
                        counter++;
                    }
                    if ( videoData[ ( ind + 1 ) ] && videoData[ ( ind + 1 ) ].startOfParagraph ) {
                        count++;
                        counter = 0;
                        videos[ count.toString() ] = [];
                    }
                } );
                count = 0;
                var length = Object.keys( videos ).length;
                var i = 0;
                var temp = {};
                while ( i < length ) {
                    var tempLen = videos[ i ].length;
                    var end = videos[ i ][ tempLen - 1 ].end;
                    var start = videos[ i ][ 0 ].start;
                    temp = {
                        'start': start,
                        'end': end,
                        'val': videos[ i ]
                    };
                    videosData[ i ] = temp;
                    i++;
                }
                returnData.videos = videos;
                returnData.videosData = videosData;
                return returnData;
            }
        };
    } );

'use strict';

angular.module( 'jigsawCorpLms' ).factory( 'Notifications', function( toastr, DeviceDetector ) {

    return {
        toast: function( message ) {
            if ( DeviceDetector.checkDevice() === 'small' ) {
                toastr.success( message, '', {
                    iconClass: 'toast',
                    tapToDismiss: false,
                    timeOut: 3000,
                    extendedTimeOut: 1000
                } );
            } else {
                toastr.success( message, '', {
                    iconClass: 'toast',
                    tapToDismiss: false,
                    timeOut: 3000,
                    extendedTimeOut: 1000
                } );
            }
        },
        toastError: function( message ) {
            if ( DeviceDetector.checkDevice() === 'small' ) {
                toastr.info( message, '', {
                    iconClass: 'toastError',
                    tapToDismiss: false,
                    timeOut: 3000,
                    extendedTimeOut: 1000
                } );
            } else {
                toastr.info( message, '', {
                    iconClass: 'toastError',
                    tapToDismiss: false,
                    timeOut: 3000,
                    extendedTimeOut: 1000
                } );
            }
        }
    };
} );

'use strict';

angular.module( 'jigsawCorpLms' ).factory( 'NavigationUtilities', function() {

    return {
        getRedirectState: function( item ) {
            var returnState;
            if ( item.type === 'ticket' ) {
                //go to help
                returnState = 'home.help.faq';
            } else if ( item.type === 'reminder' ) {
                if ( item.mode === 'proficiency test' ) {
                    //navigate to proficiency test summary
                    returnState = 'home.moduleEnd.profTest';
                } else if ( item.mode === 'quiz' ) {
                    //go to clipboard
                    returnState = 'home.clipboard';
                }
            } else if ( item.type === 'warning' ) {
                //navigate to profile
                returnState = 'home.progressInfoPage';
            } else if ( item.type === 'result' ) {
                if ( item.mode === 'proficiency test' ) {
                    //navigate to proficiency test summary
                    returnState = 'home.moduleEnd.profTest';
                } else if ( item.mode === 'quiz' ) {
                    //navigate to quiz
                    returnState = 'home.learn.quiz';
                }
            } else if ( item.type === 'notification' ) {
                if ( item.mode === 'newVideo' || item.mode === 'trending' ) {
                    //navigate to video player - Library or LP
                    returnState = 'home.learn.video';
                } else if ( item.mode === 'questionAnswered' ) {
                    //navigate to clipboard
                    returnState = 'home.clipboard';
                } else if ( item.mode === 'earnedPoints' || item.mode === 'Idle' ) {
                    //navigate to profile
                    returnState = 'home.progressInfoPage';
                }
            } else if ( item.type === 'Congratulations' && item.mode === 'moduleCompletion' ) {
                //navigate to summary page
                returnState = 'home.moduleEnd.modulesummary';
            } else if ( item.type === 'Congratulations' && item.mode === 'badgeEarned' ) {
                //navigate to profile
                returnState = 'home.progressInfoPage';
            } else if ( item.type === 'Cheers' && ( item.mode === 'achievement' || item.mode === 'excellence' ) ) {
                //navigate to profile
                returnState = 'home.progressInfoPage';
            } else if ( item.type === 'goodToGo' || item.type === 'goodJob' ) {
                //navigate to profile
                returnState = 'home.progressInfoPage';
            }
            return returnState;
        }
    };
} );

'use strict';
angular.module( 'jigsawCorpLms' )
    .factory( 'Flows', function( $state, $rootScope, Notifications, Workflows ) {
        var flows = {};
        var flowConfigurations = {};
        var notificationMessages = {};
        var currentFlow = null;
        var stateBeforeFlow = '';
        var stateBeforeFirstStep = '';
        var stateData = null;
        var stateHeaders = null;
        var addFlow = function( name, flowArray, config ) {
            flows[ name ] = flowArray;
            if ( config ) {
                flowConfigurations[ name ] = config;
            }
        };

        function defineFlows() {
            flows = {};
            for ( var i = Workflows.length - 1; i >= 0; i-- ) {
                addFlow( Workflows[ i ].name, Workflows[ i ].steps, Workflows[ i ].config );
            }
        }

        var _toastMessage = function() {
            if ( currentFlow.config && currentFlow.config.notificationType === 'toast' && notificationMessages.successMessage ) {
                Notifications.toast( notificationMessages.successMessage );
            }
        };
        defineFlows();
        return {
            flows: flows,
            flowConfigurations: flowConfigurations,
            currentFlow: function( flowName ) {
                if ( flowName ) {
                    currentFlow = {};
                    currentFlow.name = flowName;
                    currentFlow.flow = flows[ flowName ];
                    currentFlow.config = flowConfigurations[ flowName ];
                    if ( currentFlow.flow.indexOf( $rootScope.previousState ) < 0 ) {
                        stateBeforeFirstStep = $rootScope.previousState;
                    }
                }
                return currentFlow;
            },
            currentState: function() {
                return $state.current.name;
            },
            goToNextState: function( data, headers ) {
                stateData = null;
                stateHeaders = null;
                var isSuccess;
                var current = $state.current.name;
                if ( typeof $state.current.data !== 'undefined' && $state.current.data.otpState ) {
                    current = $rootScope.stateBeforeOtp;
                }
                var currentFlowArray = currentFlow.flow;
                var index = currentFlowArray.indexOf( current );
                if ( data ) {
                    stateData = data;
                }
                if ( headers ) {
                    stateHeaders = headers;
                    isSuccess = headers( 'x-response-type' ) === 'SUCCESS' || headers( 'x-response-type' ) === 'OK';
                } else {
                    isSuccess = true;
                }
                if ( isSuccess && index === currentFlowArray.length - 2 ) {
                    _toastMessage();
                }
                $state.go( currentFlowArray[ index + 1 ] );
            },
            endFlow: function() {
                currentFlow = null;
                var nextPage = stateBeforeFlow;
                stateBeforeFlow = '';
                if ( !nextPage || nextPage === '' ) {
                    if ( $rootScope.isFirstTimeLogin ) {
                        $rootScope.$broadcast( 'loggedOut' );
                        $state.go( 'Login' );
                    } else if ( $state.current.name === 'Login.LoginOtp' ) {
                        $state.go( 'Login' );
                    } else {
                        $state.go( 'MainView.Dashboard' );
                    }
                } else {
                    $state.go( nextPage );
                }
            },
            markCurrentStateToComeBack: function() {
                stateBeforeFlow = $state.current.name;
            },
            currentStateToComeBack: function() {
                return stateBeforeFlow;
            },
            startFlow: function() {
                $state.go( currentFlow.flow[ 0 ] );
            },
            goBack: function() {
                stateData = null;
                stateHeaders = null;
                var currentFlowIndex = currentFlow.flow.indexOf( $state.current.name );
                if ( currentFlowIndex === 0 ) {
                    $state.go( stateBeforeFirstStep );
                } else if ( currentFlowIndex > 0 ) {
                    $state.go( currentFlow.flow[ currentFlowIndex - 1 ] );
                }
            },
            indexOfState: function() {
                if ( currentFlow ) {
                    return currentFlow.flow.indexOf( $state.current.name );
                }
            },
            stateData: function() {

                return stateData;
            },
            stateHeaders: function() {
                return stateHeaders;
            },
            setStateData: function( data ) {
                stateData = data;
                return stateData;
            },
            createFlow: function( flowName, flowArray, flowConfig ) {
                addFlow( flowName, flowArray, flowConfig );
            },
            setFlowNotificationMessages: function( successMessage, errorMessage ) {
                notificationMessages.successMessage = successMessage;
                if ( errorMessage ) {
                    notificationMessages.errorMessage = errorMessage;
                } else {
                    notificationMessages.errorMessage = null;
                }
                return notificationMessages;

            },
            getFlowNotificationMessages: function() {
                return notificationMessages;
            },
            destroyFlow: function() {
                currentFlow = null;
            }
        };
    } );

'use strict';

angular.module('jigsawCorpLms')
    .service('FirebaseService', function($rootScope, $firebaseAuth, $firebaseObject, $q,DataCache,$cookies,$state,firebase) {

        // ****************for scorching************
//        var config = {
 //                     apiKey: "AIzaSyDNeA0apLoJVdwlGZvl0OwT-FgLNQjAJwU",
 //                       authDomain: "scorching-torch-1899.firebaseapp.com",
 //                       databaseURL: "https://scorching-torch-1899.firebaseio.com",
 //                       storageBucket: "gs://scorching-torch-1899.appspot.com"  
 //                       };


        // ***********for dazzling***************

        var config = {
            apiKey: "AIzaSyB7Fe_vAybPf0gl0SQovUmCw64vX8yjKdM",
            authDomain: "dazzling-fire-2290.firebaseapp.com",
            databaseURL: "https://dazzling-fire-2290.firebaseio.com",
            projectId: "dazzling-fire-2290",
            storageBucket: "dazzling-fire-2290.appspot.com",
            messagingSenderId: "643434941394"
        }
                localStorage.removeItem("firebase:previous_websocket_failure");
                firebase.initializeApp(config);
                //var rootRef = firebase.database().ref();
                //console.log(rootRef);


        return {
            ref: firebase.database().ref(),
            requireAuth: function() {
                var deferred = $q.defer();
                deferred.resolve($firebaseAuth(ref).$requireAuth());
                return deferred.promise;
            },
            refreshToken:function(){
                var deferred = $q.defer();
                 firebase.auth().currentUser.getIdToken(true).then(function(idToken) {
                    console.log(idToken);
                    DataCache.saveGlobalData('idToken', idToken);
                }).catch(function(error) {
                    console.log(error.message);
                    deferred.reject(error);
                });
                return deferred.promise;
            },
            loginWithCustomToken: function(token) {
                var self = this;
                var deferred = $q.defer();
                //console.log(token);
                firebase.auth().signInWithCustomToken(token).then(function(authData){
                    //console.log("success");
                    //console.log(authData);   
                    deferred.resolve(authData);
                 }).catch(function(error) {
               // firebase.auth().signInWithCustomToken(token, function(error, authData) {
                    //if (error) {
                        console.log("error in firebase login");
                        $rootScope.showLoadingScreen = false;
                        var errorCode = error.code;
                        var errorMessage = error.message;
                        console.log(errorCode);
                        console.log(errorMessage);
                        deferred.reject(error);
                        DataCache.clearAll();
                        $cookies.remove('userDetails');
                        $state.go( 'login' );
                    //} 
                    //else {
                        //console.log("logged into firebase");
                        //deferred.resolve(authData);
                    //}
                });

                

                return deferred.promise;
            },

            getDataOfUser: function(authData) {
                var self = this;
                var deferred = $q.defer();
                var refForData = self.ref.child('lp').child(authData.uid).child("/" + authData.lpId);
                refForData.on("value", function(snapshot) {
                    deferred.resolve(snapshot.val());
                }, function(errorObject) {
                    deferred.reject(errorObject.code);
                });
                return deferred.promise;
            }
        };

    });

'use strict';

angular.module('jigsawCorpLms')
    .factory('fetchData', function(ServiceEndpoint, DataCache, $q, $state) {
        return {
            fetchDashboardData: function() {
                return ServiceEndpoint.learnigPathLanding.makeRequest().then(function(response) {
                    return response;
                });
            },
            login: function(payload) {
                return ServiceEndpoint.login.makeRequest(payload).then(function(response) {
                    return response;
                });
            },
            fetchTestUrl: function(payload) {
                return ServiceEndpoint.testUrl.makeRequest(payload).then(function(response) {
                    return response;
                });
            },
            bookmarks: function() {
                return ServiceEndpoint.bookmarks.makeRequest().then(function(response) {
                    return response.data;
                });
            },
            menuHistory: function() {
                return ServiceEndpoint.menuHistory.makeRequest().then(function(response) {
                    return response.data;
                });
            },
            notifications: function() {
                return ServiceEndpoint.notifications.makeRequest().then(function(response) {
                    return response.data;
                });
            },
            updateNotify: function(payload) {
                return ServiceEndpoint.updateNotify.makeRequest(payload).then(function(response) {
                    return response.data;
                });
            },
            dummyDashboardData: function() {
                return ServiceEndpoint.dummyDashboardData.makeRequest().then(function(response) {
                    return response;
                });
            },
            dummyVideoData: function() {
                return ServiceEndpoint.dummyVideoData.makeRequest().then(function(response) {
                    return response;
                });
            },
            fetchTranscript: function(payload) {
                return ServiceEndpoint.mappedTranscript.makeRequest(payload).then(function(response) {
                    return response;
                });
            },
            fetchKeyframes: function() {
                return ServiceEndpoint.videoKeyframes.makeRequest().then(function(response) {
                    return response;
                });
            },
            fetchModuleDetails: function() {
                if (DataCache.returnData('moduleDetails')) {
                    return $q.when(DataCache.returnData('moduleDetails'));
                } else {
                    return ServiceEndpoint.moduleDetails.makeRequest().then(function(response) {
                        DataCache.saveGlobalData('moduleDetails', response.data);
                        return response.data;
                    });
                }
            },
            fetchCountryCodes: function() {
                if (DataCache.returnData('countryCodes')) {
                    return $q.when(DataCache.returnData('countryCodes'));
                } else {
                    return ServiceEndpoint.countryCodes.makeRequest().then(function(response) {
                        DataCache.saveGlobalData('countryCodes', response.data);
                        return response.data;
                    });
                }
            },
            fetchAskExpert: function() {
                return ServiceEndpoint.askExpert.makeRequest().then(function(response) {
                    return response;
                });
            },
            fetchProfileData: function() {
                return ServiceEndpoint.profileData.makeRequest().then(function(response) {
                    return response;
                });
            },
            fetchAvatarData: function() {
                return ServiceEndpoint.uploadAvatarData.makeRequest().then(function(response) {
                    return response;
                });
            },
            fetchClipboardData: function() {
                return ServiceEndpoint.clipboardVideoPage.makeRequest().then(function(response) {
                    return response;
                });
            },
            fetchQuizData: function(payload) {
                return ServiceEndpoint.quizService.makeRequest(payload).then(function(response) {
                    return response;
                });
            },
            fetchOtp: function(payload) {
                return ServiceEndpoint.videoOtp.makeRequest(payload).then(function(response) {
                    return response;
                });
            },
            sendUpdateQuizData: function(payload) {
                return ServiceEndpoint.quizUpdateService.makeRequest(payload).then(function(response) {
                    return response;
                });
            },
            sendCompleteQuizData: function(payload) {
                return ServiceEndpoint.quizCompleteService.makeRequest(payload).then(function(response) {
                    return response;
                });
            },
            fetchImageService: function() {
                return ServiceEndpoint.imageService.makeRequest().then(function(response) {
                    return response;
                });
            },
            fetchClipboardPageData: function() {
                return ServiceEndpoint.clipboardPage.makeRequest().then(function(response) {
                    return response;
                });
            },
            fetchBuyerContentData: function() {
                return ServiceEndpoint.buyerContentService.makeRequest().then(function(response) {
                    return response;
                });
            },
            fetchBuyerHeadFlowData: function() {
                return ServiceEndpoint.buyerHeadFlowService.makeRequest().then(function(response) {
                    return response;
                });
            },
            fetchBuyerManagerFlowData: function() {
                return ServiceEndpoint.buyerManagerFlowService.makeRequest().then(function(response) {
                    return response;
                });
            },

            // fetchBuyerPurchaseHistoryData: function() {
            //     return ServiceEndpoint.buyerPurchaseHistory.makeRequest().then( function( response ) {
            //         return response;
            //     } );
            // },
            // fetchBuyerWidgetsBarData: function() {
            //     return ServiceEndpoint.buyerWidgetsBar.makeRequest().then( function( response ) {
            //         return response;
            //     } );
            // },

            fetchLearnersProfilePageData: function() {
                return ServiceEndpoint.learnersProfileData.makeRequest().then(function(response) {
                    return response;
                });
            },
            fetchUserRank: function() {
                return ServiceEndpoint.fetchUserRank.makeRequest().then(function(response) {
                    return response;
                });
            },
            fetchBadgeData: function() {
                return ServiceEndpoint.badgeData.makeRequest().then(function(response) {
                    return response;
                });
            },
            fetchCaseStudyService: function(payload) {
                return ServiceEndpoint.caseStudyService.makeRequest(payload).then(function(response) {
                    return response;
                });
            },
            fetchCaseStudyExercise: function(payload) {
                return ServiceEndpoint.caseStudyExercise.makeRequest(payload).then(function(response) {
                    return response;
                });
            },
            fetchCaseStudySolution: function(payload) {
                return ServiceEndpoint.caseStudySolution.makeRequest(payload).then(function(response) {
                    return response;
                });
            },
            fetchWelcomeScreenData: function() {
                return ServiceEndpoint.welcomeScreenData.makeRequest().then(function(response) {
                    return response;
                });
            },
            fetchProficiencyTestData: function() {
                return ServiceEndpoint.proficiencyTestService.makeRequest().then(function(response) {
                    return response;
                });
            },
            fetchProficiencyTestSummaryData: function() {
                return ServiceEndpoint.profTestSummary.makeRequest().then(function(response) {
                    return response;
                });
            },
            fetchProficiencyTestQUestions: function() {

                if (DataCache.returnData('profTestQuestions')) {
                    return $q.when(DataCache.returnData('profTestQuestions'));
                } else {
                    return ServiceEndpoint.profTestQuestions.makeRequest().then(function(response) {
                        DataCache.saveGlobalData('profTestQuestions', response.data);

                        return response.data;
                    });
                }
            },
            fetchQuizQuestions: function() {
                return ServiceEndpoint.quizQuestions.makeRequest().then(function(response) {
                    return response;
                });
            },
            fetchResourceLinkPage: function(payload) {
                return ServiceEndpoint.resourceLinkPageData.makeRequest(payload).then(function(response) {
                    return response;
                });
            },
            fetchPerformanceAnalyticsData: function() {
                return ServiceEndpoint.performanceAnalyticsData.makeRequest().then(function(response) {
                    return response;
                });
            },
            fetchModuleSummaryPageData: function() {
                return ServiceEndpoint.moduleSummaryPageData.makeRequest().then(function(response) {
                    return response;
                });
            },
            fetchLibraryData: function() {
                return ServiceEndpoint.libraryData.makeRequest().then(function(response) {
                    return response;
                });
            },
            fetchLibrarySearchData: function() {
                return ServiceEndpoint.librarySearchData.makeRequest().then(function(response) {
                    return response;
                });
            },
            fetchGlobalHelpData: function() {
                return ServiceEndpoint.globalHelpData.makeRequest().then(function(response) {
                    return response;
                });
            },
            fetchGlobalHelpDataManager: function() {
                return ServiceEndpoint.globalHelpDataManager.makeRequest().then(function(response) {
                    return response;
                });
            },
            updateSetupProfileScreenData: function(payload) {
                return ServiceEndpoint.updateProfile.makeRequest(payload).then(function(response) {
                    return response;
                });
            },
            updateProfileScreenData: function(payload) {
                return ServiceEndpoint.updateProfileMinimal.makeRequest(payload).then(function(response) {
                    return response;
                });
            },
            saveQuizQuestion: function(payload) {
                return ServiceEndpoint.saveQuizQuestion.makeRequest(payload).then(function(response) {
                    return response;
                });
            },
            fetchPlaylistData: function() {
                return ServiceEndpoint.playlistData.makeRequest().then(function(response) {
                    return response;
                });
            },
            retrievePassword: function(payload) {
                return ServiceEndpoint.retrievePassword.makeRequest(payload).then(function(response) {
                    return response;
                });
            },
            validateToken: function(payload) {
                return ServiceEndpoint.validateToken.makeRequest(payload).then(function(response) {
                    return response;
                });
            },
            changePassword: function(payload) {
                return ServiceEndpoint.updatePassword.makeRequest(payload).then(function(response) {
                    return response;
                });
            },fetchAllLps: function () {
                return ServiceEndpoint.getPreviousLps.makeRequest().then(function (response) {
                    return response
                })
            },
             // buyers related api's are below
            fetchBuyerWelcomeScreenLicense: function(payload, role) {
                if (role === "L&D Manager") {
                    return ServiceEndpoint.buyerHeadWSLicense.makeRequest(payload).then(function(response) {
                        return response;
                    });
                } else if (role === "Manager") {
                    return ServiceEndpoint.buyerManagerWSLicense.makeRequest(payload).then(function(response) {
                        return response;
                    });
                } else {
                    $state.go('login');
                }
            },
            fetchBuyerWelcomeScreenLp: function(payload, role) {
                if (role === "L&D Manager") {
                    return ServiceEndpoint.buyerHeadWSLp.makeRequest(payload).then(function(response) {
                        return response;
                    });
                } else if (role === "Manager") {
                    return ServiceEndpoint.buyerManagerWSLp.makeRequest(payload).then(function(response) {
                        return response;
                    });
                } else {
                    $state.go('login');
                }
            },
            getAvatar: function(payload) {
                return ServiceEndpoint.getAvatar.makeRequest(payload).then(function(response) {
                    return response;
                });
            },
            fetchBuyersJourneyData: function(payload, role) {
                if (role === "L&D Manager") {
                    return ServiceEndpoint.buyersData.makeRequest(payload).then(function(response) {
                        return response;
                    });
                } else if (role === "Manager") {
                    return ServiceEndpoint.managerbuyersData.makeRequest(payload).then(function(response) {
                        return response;
                    });
                } else {
                    $state.go('login');
                }
            },
            fetchBJLearningHealth: function(payload, role) {
                if (role === "L&D Manager") {
                    return ServiceEndpoint.buyersLearningHealth.makeRequest(payload).then(function(response) {
                        return response;
                    });
                } else if (role === "Manager") {
                    return ServiceEndpoint.buyersManagerLearningHealth.makeRequest(payload).then(function(response) {
                        return response;
                    });
                } else {
                    $state.go('login');
                }
            },
            fetchBJROI: function(payload) {
                return ServiceEndpoint.buyersRoi.makeRequest(payload).then(function(response) {
                    return response;
                });
            },
            fetchBJSkills: function(payload, role) {
                if (role === "L&D Manager") {
                    return ServiceEndpoint.buyersSkills.makeRequest(payload).then(function(response) {
                        return response;
                    });
                } else if (role === "Manager") {
                    return ServiceEndpoint.buyersManagerSkills.makeRequest(payload).then(function(response) {
                        return response;
                    });
                } else {
                    $state.go('login');
                }
            },
            fetchBJLicenseData: function(payload, role) {
                if (role === "L&D Manager") {
                    return ServiceEndpoint.licenseMngHeadData.makeRequest(payload).then(function(response) {
                        return response;
                    });
                } else if (role === "Manager") {
                    return ServiceEndpoint.licenseMngManagerData.makeRequest(payload).then(function(response) {
                        return response;
                    });
                } else {
                    $state.go('login');
                }
            },
            fetchBJTotLrngHrs: function(payload, role) {
                if (role === "L&D Manager") {
                    return ServiceEndpoint.buyerslhrs.makeRequest(payload).then(function(response) {
                        return response;
                    });
                } else if (role === "Manager") {
                    return ServiceEndpoint.buyersManagerlhrs.makeRequest(payload).then(function(response) {
                        return response;
                    });
                } else {
                    $state.go('login');
                }
            },
            // fetchBuyerLearnersData: function() {
            //       return ServiceEndpoint.buyerLearnersDataService.makeRequest().then( function( response ) {
            //           return response;
            //       } );
            //   },

            fetchBuyerPurchaseHistoryData: function(payload) {
                return ServiceEndpoint.buyerPurchaseHistory.makeRequest(payload).then(function(response) {
                    return response;
                });
            },
            fetchBuyerWidgetsBarData: function() {
                return ServiceEndpoint.buyerWidgetsBar.makeRequest().then(function(response) {
                    return response;
                });
            },
            BJlearners: function(payload) {
                return ServiceEndpoint.learners.makeRequest(payload).then(function(response) {
                    return response;
                });
            },
            testRetake: function() {
                return ServiceEndpoint.Lretake.makeRequest().then(function(response) {
                    return response;
                });
            },
            approveLearner: function(payload) {
                return ServiceEndpoint.approveLearner.makeRequest(payload).then(function(response) {
                    return response;
                });
            },
            rejectLearner: function(payload) {
                return ServiceEndpoint.rejectLearner.makeRequest(payload).then(function(response) {
                    return response;
                });
            },
            fetchLHDrillDown: function(payload, role) {
                if (role === "L&D Manager") {
                    return ServiceEndpoint.buyersLHDrillDown.makeRequest(payload).then(function(response) {
                        return response;
                    });
                } else if (role === "Manager") {
                    return ServiceEndpoint.buyersManagerLHDrillDown.makeRequest(payload).then(function(response) {
                        return response;
                    });
                } else {
                    $state.go('login');
                }
            },
            fetchLHDrillDownByPath: function(payload, role) {
                if (role === "L&D Manager") {
                    return ServiceEndpoint.buyersLHDrillDownByPath.makeRequest(payload).then(function(response) {
                        return response;
                    });
                } else if (role === "Manager") {
                    return ServiceEndpoint.buyersManagerLHDrillDownByPath.makeRequest(payload).then(function(response) {
                        return response;
                    });
                } else {
                    $state.go('login');
                }
            },
            LHByPathLearnerDetails: function(payload, role) {
                if (role === "L&D Manager") {
                    return ServiceEndpoint.lhByPathLD.makeRequest(payload).then(function(response) {
                        return response;
                    });
                } else if (role === "Manager") {
                    return ServiceEndpoint.lhByPathLDManager.makeRequest(payload).then(function(response) {
                        return response;
                    });
                } else {
                    $state.go('login');
                }
            },
            LHByTeamLearnerDetails: function(payload, role) {
                if (role === "L&D Manager") {
                    return ServiceEndpoint.lhByTeamLD.makeRequest(payload).then(function(response) {
                        return response;
                    });
                } else if (role === "Manager") {
                    return ServiceEndpoint.lhByTeamLDManager.makeRequest(payload).then(function(response) {
                        return response;
                    });
                } else {
                    $state.go('login');
                }
            },
            fetchBJLicenseMngBP: function(payload, role) {
                if (role === "L&D Manager") {
                    return ServiceEndpoint.licenseMngByPath.makeRequest(payload).then(function(response) {
                        return response;
                    });
                } else if (role === "Manager") {
                    return ServiceEndpoint.licenseMngByPathForManager.makeRequest(payload).then(function(response) {
                        return response;
                    });
                } else {
                    $state.go('login');
                }
            },
            fetchBJLicenseMngBT: function(payload, role) {
                if (role === "L&D Manager") {
                    return ServiceEndpoint.licenseMngByTeam.makeRequest(payload).then(function(response) {
                        return response;
                    });
                } else if (role === "Manager") {
                    return ServiceEndpoint.licenseMngByTeamForManager.makeRequest(payload).then(function(response) {
                        return response;
                    });
                } else {
                    $state.go('login');
                }
            },
            fetchSkillsDrillDownbyPath: function(payload, role) {
                if (role === "L&D Manager") {
                    return ServiceEndpoint.buyersSkillsHeadDrillDownbyPath.makeRequest(payload).then(function(response) {
                        return response;
                    });
                } else if (role === "Manager") {
                    return ServiceEndpoint.buyersSkillsManagerDrillDownbyPath.makeRequest(payload).then(function(response) {
                        return response;
                    });
                } else {
                    $state.go('login');
                }
            },
            fetchSkillsDrillDownbyTeam: function(payload, role) {
                if (role === "L&D Manager") {
                    return ServiceEndpoint.buyersSkillsHeadDrillDownbyTeam.makeRequest(payload).then(function(response) {
                        return response;
                    });
                } else if (role === "Manager") {
                    return ServiceEndpoint.buyersSkillsManagerDrillDownbyTeam.makeRequest(payload).then(function(response) {
                        return response;
                    });
                } else {
                    $state.go('login');
                }
            },
            SkillsDDExpandedView: function(payload, role) {
                if (role === "L&D Manager") {
                    return ServiceEndpoint.SkillsDDExpandedView.makeRequest(payload).then(function(response) {
                        return response;
                    });
                } else if (role === "Manager") {
                    return ServiceEndpoint.ManagerSkillsDDExpandedView.makeRequest(payload).then(function(response) {
                        return response;
                    });
                } else {
                    $state.go('login');
                }
            },
            skillLevelTwoByPath: function(payload) {

                return ServiceEndpoint.skillLevel2ByPath.makeRequest(payload).then(function(response) {
                    return response;

                });
            },
            skillLevelTwoByTeam: function(payload) {

                return ServiceEndpoint.skillLevel2ByTeam.makeRequest(payload).then(function(response) {
                    return response;
                });
            },
            LearningHrsLevelOnetableView: function(payload, role) {
                if (role === "L&D Manager") {
                    return ServiceEndpoint.LearningHrsLevel1tableView.makeRequest(payload).then(function(response) {
                        return response;
                    });
                } else if (role === "Manager") {
                    return ServiceEndpoint.LearningHrsLevel1tableViewManager.makeRequest(payload).then(function(response) {
                        return response;
                    });
                } else {
                    $state.go('login');
                }
            },
            LearningHrsLevelTwoByPath: function(payload) {
                return ServiceEndpoint.LearningHrsLevel2ByPath.makeRequest(payload).then(function(response) {
                    return response;
                });
            },
            LearningHrsLevelTwoByTeam: function(payload) {
                return ServiceEndpoint.LearningHrsLevel2ByTeam.makeRequest(payload).then(function(response) {
                    return response;
                });
            },
            LearningHrsLevelOnetableViewByTeam: function(payload, role) {
                if (role === "L&D Manager") {
                    return ServiceEndpoint.LearningHrsLevel1tableViewByTeam.makeRequest(payload).then(function(response) {
                        return response;
                    });
                } else if (role === "Manager") {
                    return ServiceEndpoint.LearningHrsLevel1tableViewByTeamManager.makeRequest(payload).then(function(response) {
                        return response;
                    });
                } else {
                    $state.go('login');
                }
            },
            fetchLHrsDrillDownByTeam: function(payload, role) {
                if (role === "L&D Manager") {
                    return ServiceEndpoint.learningHrsDDByTeam.makeRequest(payload).then(function(response) {
                        return response;
                    });
                } else if (role === "Manager") {
                    return ServiceEndpoint.learningHrsDDManagerByTeam.makeRequest(payload).then(function(response) {
                        return response;
                    });
                } else {
                    $state.go('login');
                }

            },
            fetchLHrsDrillDownByPath: function(payload, role) {
                if (role === "L&D Manager") {
                    return ServiceEndpoint.learningHrsDDByPath.makeRequest(payload).then(function(response) {
                        return response;
                    });
                } else if (role === "Manager") {
                    return ServiceEndpoint.learningHrsDDByPathManager.makeRequest(payload).then(function(response) {
                        return response;
                    });
                } else {
                    $state.go('login');
                }
            },
            updateProfileImage: function(payload) {
                return ServiceEndpoint.updateProfileImage.makeRequest(payload).then(function(response) {
                    return response;
                });
            },
            LBadgeData: function(payload) {
                return ServiceEndpoint.LBadgeData.makeRequest(payload).then(function(response) {
                    return response;
                });
            },
            BadgeHead: function(payload) {
                return ServiceEndpoint.BadgeHead.makeRequest(payload).then(function(response) {
                    return response;
                });
            },
            supportTicket: function(payload) {
                return ServiceEndpoint.support.makeRequest(payload).then(function(response) {
                    return response;
                });
            },
            feedback: function(payload) {
                return ServiceEndpoint.feedback.makeRequest(payload).then(function(response) {
                    return response;
                });
            },
            getDownloadModuleData: function(payload, responseType) {
                return ServiceEndpoint.getDownloadModuleData.makeRequest(payload, responseType).then(function(response) {
                    return response;
                });
            },
            getPtSummary: function(payload) {
                return ServiceEndpoint.getPtSummary.makeRequest(payload).then(function(response) {
                    return response;
                });
            },
            getLearningObjective: function() {
                return ServiceEndpoint.getLearningObjective.makeRequest().then(function(response) {
                    return response;
                });
            },
            getTermsNconditions: function() {
                return ServiceEndpoint.getTermsNconditions.makeRequest().then(function(response) {
                    return response;
                });
            },
            authessTest: function(payload) {
                return ServiceEndpoint.authessTest.makeRequest(payload).then(function(response) {
                    return response;
                });
            },
            fetchVideoAndAssessmentDuration: function() {
                return ServiceEndpoint.fetchVideoAndAssessmentDuration.makeRequest().then(function(response) {
                    return response;
                });
            },
            fetchUserCertificates: function(payload) {
                return ServiceEndpoint.fetchUserCertificates.makeRequest(payload).then(function(response) {
                    return response;
                });
            },
            fetchUserDownloadableCertificates: function(payload) {
                return ServiceEndpoint.fetchUserDownloadableCertificates.makeRequest(payload).then(function(response) {
                    return response;
                });
            },
            fetchUserAllDownloadableCertificates: function(payload) {
                return ServiceEndpoint.fetchUserAllDownloadableCertificates.makeRequest(payload).then(function(response) {
                    return response;
                });
            },
            fetchUserTotalCertificates: function() {
                return ServiceEndpoint.fetchUserTotalCertificates.makeRequest().then(function(response) {
                    return response;
                });
            },
            updateisNewLpForUser: function(payload) {
                return ServiceEndpoint.updateisNewLpForUser.makeRequest(payload).then(function(response) {
                    return response;
                });
            },
             getLabPassword: function() {
                return ServiceEndpoint.getLabPassword.makeRequest().then(function(response) {
                    return response;
                });
            },
            getLabAccess: function(payload) {
                return ServiceEndpoint.getLabAccess.makeRequest(payload).then(function(response) {
                    return response;
                });
             }
        };
    });

'use strict';

angular.module( 'jigsawCorpLms' )
    .factory( 'clipboardUtilities', function( $filter, fetchData, videoUtilities ) {
        return {
            sortClipData: function( response ) {
                var thisScope = this;
                var activeData = response;
                var temp = $filter( 'orderBy' )( activeData, 'video_id', false );
                var selLen = temp.length;
                var sortedObj = {};
                var arrangedById = [];
                var previousId;
                var concatArray = [];
                for ( var i = 0; i < selLen; i++ ) {
                    var nextId = temp[ i ].video_id;
                    if ( previousId !== nextId ) {
                        arrangedById = [ temp[ i ] ];
                    } else {
                        arrangedById.push( temp[ i ] );

                    }
                    sortedObj[ temp[ i ].video_id ] = arrangedById;
                    previousId = nextId;
                }

                for ( var key in sortedObj ) {
                    if ( sortedObj.hasOwnProperty( key ) ) {
                        sortedObj[ key ] = $filter( 'orderBy' )( sortedObj[ key ], 'clipdata.start_time', false );
                        sortedObj[ key ].filter( function( value ) {
                            if ( value.type === 'highlightedTranscript' ) {
                                thisScope.getVideoTranscript( value );
                            }
                        } );
                        concatArray = concatArray.concat( sortedObj[ key ] );
                    }
                };
                return concatArray;
            },
            getVideoTranscript: function( value ) {
                fetchData.fetchTranscript().then( function( response ) {
                    var transcriptDataCopy = {};
                    var actualTranscriptData = response;
                    angular.copy( response, transcriptDataCopy );
                    var highlightMappedTranscript = videoUtilities.mapHighlightData( transcriptDataCopy, response );
                    var returnData = videoUtilities.rearrangeTranscriptData( transcriptDataCopy );
                    value.transcript = returnData.videosData;
                } );
            }
        };
    } );

'use strict';
angular.module( 'jigsawCorpLms' )
    .factory( 'AuthenticateService', function( $rootScope, ServiceEndpoint, Token, JsonURL, $http, $q, $window,
        ErrorMessage, $state, DataCache, Notifications, ErrorConstant, RegistrationService, $log ) {
        var responseCode, responseMsg, responseType, username;
        var reIssueSuccess = function( response ) {
            responseMsg = response.headers( 'x-sbg-response-message' );
            responseCode = response.headers( 'x-sbg-response-code' );
            if ( responseCode !== '0000' ) {
                var tokenUpdateError = 'Sorry! Error occured while updating session token. Please login again';
                ErrorMessage.showMessage( responseCode, tokenUpdateError );
                try {
                    this.logout();
                } catch ( e ) {
                    $log.log( e );
                }
                return $q.reject( response );
            } else {
                var authToken = response.headers( 'x-sbg-token' );
                Token.setAuthToken( authToken );
                return response.data;
            }
        };
        var reIssueFailure = function( response ) {
            responseMsg = response.headers( 'x-sbg-response-message' ) || ErrorConstant.GENERIC_ERROR;
            ErrorMessage.showMessage( responseCode, responseMsg );
            return $q.reject( response );
        };
        return {
            login: function( payload ) {
                username = payload.digitalId.username;
                var cardResponse = {
                    card: {
                        countryCode: null,
                        number: username,
                        type: null
                    },
                    keyValueMetadata: [],
                    stepUp: null
                };
                DataCache.saveGlobalData( 'username', username );
                DataCache.saveGlobalData( 'authenticateCardNumber', cardResponse );
                return ServiceEndpoint.authenticate.makeRequest( payload ).then( this.loginSuccess ).catch(
                    this.loginError
                );
            },
            loginError: function( response ) {
                responseType = response.headers( 'x-sbg-response-type' );
                if ( responseType !== 'STEPUP' ) {
                    responseMsg = response.headers( 'x-sbg-response-message' ) || ErrorConstant.GENERIC_ERROR;
                    responseCode = response.headers( 'x-sbg-response-code' );
                    if ( $state.current.name !== 'Login' ) {
                        Notifications.toastError( responseMsg );
                    }
                    ErrorMessage.showMessage( responseCode, responseMsg );
                }
                return $q.reject( response );
            },
            loginSuccess: function( response ) {
                $rootScope.loginTime = response.data.userProfile.lastLoggedIn;
                $rootScope.isFirstTimeLogin = false;
                DataCache.saveGlobalData( 'authenticateDI', response.data );
                var authToken = response.headers( 'x-sbg-token' );
                Token.setAuthToken( authToken );
                $rootScope.$broadcast( 'loggedIn' );
                for ( var i = 0; i < response.data.keyValueMetadata.length; i++ ) {
                    if ( response.data.keyValueMetadata[ i ].value === 'Y' &&
                        response.data.keyValueMetadata[ i ].key === 'FIRST_LOGIN' ) {
                        $rootScope.isFirstTimeLogin = true;
                    }
                }
                var isRegistering = ( $state.current.data && $state.current.data.flow === 'Registration' );
                if ( !isRegistering ) {
                    if ( $rootScope.isFirstTimeLogin ) {
                        var firstTimeLoginRequest = {
                            'userId': username
                        };
                        RegistrationService.fetchRetailSecurityChallenge( firstTimeLoginRequest ).then( function( securityQuesResponse ) {
                            DataCache.saveGlobalData( 'fetchRetailSecurityQuestion', securityQuesResponse );
                            $state.go( 'Registration.SecurityQuestions' );
                        } );
                    } else if ( $rootScope.isEcomPayment ) {
                        $state.go( 'MainView.EcomPayment.EcomPaymentDetail' );
                    } else {
                        $state.go( 'MainView.Dashboard' );
                    }
                }
                return response.data;
            },
            logout: function( isSessionTimedOut ) {
                $rootScope.showLogoutMsg = true;
                if ( isSessionTimedOut ) {
                    $rootScope.logoutMsg = 'To protect your account, we have automatically logged you out of internet banking.' +
                        'You can login again when you are ready.';
                } else {
                    $rootScope.logoutMsg = 'You have been successfully logged out';
                }
                $rootScope.$broadcast( 'loggedOut' );
                $state.go( this.getCurrentLoginState() );
            },
            reIssueToken: function() {
                return ServiceEndpoint.reIssueToken.makeRequest().then( function( response ) {
                        return reIssueSuccess( response );
                    },
                    function( response ) {
                        return reIssueFailure( response );
                    }
                );
            },
            reIssueTokenLazy: function() {
                $rootScope.isReIssuingToken = true;
                return ServiceEndpoint.reIssueTokenLazy.makeRequest().then( function( response ) {
                        $rootScope.isReIssuingToken = false;
                        return reIssueSuccess( response );
                    },
                    function( response ) {
                        $rootScope.isReIssuingToken = false;
                        return reIssueFailure( response );
                    }
                );
            },
            getCurrentLoginState: function() {
                var redirectLoginState = '';
                if ( $window.sessionStorage.getItem( 'stanbic_session_mode' ) === 'Retail' ) {
                    redirectLoginState = 'Login';
                } else {
                    redirectLoginState = 'LoginSME';
                }

                return redirectLoginState;
            }

        };
    } );
/*( function( app ) {
    app.factory( 'JsonURL', function() {

        var baseURL = 'http://196.8.132.68/standimg/InternetBanking/Nigeria';
        var urls = {
            terms: '/Terms.json',
            faq: '/FAQs.json'
        };
        return {
            getURL: function( name ) {
                return baseURL + urls[ name ];
            },
            baseURL: baseURL,
            urls: urls
        };

    } );

} )( angular.module( 'sbNigApp.factory.JsonURL', [] ) );*/

'use strict';
(function() {
    angular
        .module('jigsawCorpLms')
        .directive('videoProgressBar', [ function() {
            return {
                restrict: 'E',
                scope: { current: '@' },
                templateUrl: 'app/Common/Directives/video_progressbar_list/videoProgressBar.html',
                link: function(scope) {

                    scope.currentos = { 'width': scope.current };
                }
            }
        } ]);


})();

'use strict';
(function() {
    angular
        .module('jigsawCorpLms')
        .directive('clipVideoPlayer', ['$rootScope', '$state', '$sce',
            function($rootScope, $state, $sce) {
                return {
                    restrict: 'E',
                    scope: {
                        clipData: '='
                    },
                    templateUrl: 'app/Common/Directives/video_player/video_player.html',
                    link: function(scope, elem) {
                        scope.onPlayerReady = function(API) {
                            scope.API = API;
                            scope.Videoconfig = {
                                sources: [{
                                    src: $sce.trustAsResourceUrl(scope.clipData.video_url),
                                    type: 'video/mp4'
                                }],
                                plugins: {
                                    poster: 'http://n1.sdlcdn.com/imgs/a/p/7/Become-A-Data-Scientist-Certified-SDL737299275-1-3b986.jpg'
                                }
                            };
                        };
                        scope.startVideo = function() {
                            $rootScope.dashArrow = false;
                            if (screen.width < 1025) {
                                $rootScope.scndHdr = true;
                                $state.go('home.playlist');
                            } else {
                                $rootScope.scndHdr = false;
                                $state.go('home.learn.video');
                            }
                        };
                        var myElem = elem[0].offsetTop;

                        scope.videoPlayerScroll = function(offset) {
                            console.log(offset);

                        }
                        scope.$watch(
                            function() {
                                return myElem;
                            },
                            function(newVal) {
                                scope.videoPlayerScroll(newVal);
                            }
                        );



                    }
                }
            }
        ]);

})();
'use strict';
(function() {
    angular
        .module('jigsawCorpLms')
        .directive('userProgressBar', ['$rootScope', 'fetchData', '$anchorScroll', '$timeout', 'DataCache', function($rootScope, fetchData, $anchorScroll, $timeout, DataCache) {
            return {
                restrict: 'E',
                scope: {
                    lpData: '=',
                    openNextFlow: '&'
                },
                templateUrl: 'app/Common/Directives/user_progress_bar/userProgressBar.html',
                controller: function($scope) {
                    $scope.startVideo = function(a) {
                        $scope.openNextFlow({
                            module: a
                        });
                    };
                },
                link: function(scope, elem, attrs) {

                    scope.lpAttr = DataCache.returnData("lpAttr");
                    scope.summary = DataCache.returnData('summary');

                    scope.expectedCompletion = 10;
                    scope.hrsToDayRatio = 2.5;
                    scope.widthPerWeek = 120;
                    scope.leftMaxReached = true;
                    scope.carouselEle = angular.element('.progress-bar-wrp-dummy');
                    $rootScope.$on('progress-updated', function() {
                        scope.lpAttr = DataCache.returnData("lpAttr");
                        scope.summary = DataCache.returnData('summary');
                        scope.modulesData = scope.summary;
                    });
                    scope.rearrangeData = function() {
                        scope.totalTime = Math.ceil(scope.lpData.total_duration / 60);
                        scope.lpStartDate = scope.lpData.lpStartDate;
                        var lpBeginDate = new Date(moment(scope.lpStartDate));
                        scope.lpEndDate = scope.lpData.lpEndDate;
                        var TemplpEndDate = new Date(moment(scope.lpEndDate));
                        scope.noOfWeeks = Math.round((TemplpEndDate - lpBeginDate) / 604800000);
                        scope.setWeekWidth();
                        scope.modulesData = scope.lpData.modules;
                        scope.modulesData.push(scope.lpData.current_module);
                        scope.modulesData[scope.modulesData.length - 1].current_item = true;
                        var startDate = moment(scope.lpData.start_time);
                        var lpDaysDuration = Math.ceil(scope.noOfWeeks * 7);
                    };

                    scope.moveLeft = function(item, currentIndex, totalItems) {
                        var width = item.widthPercentByWeek;
                        if (currentIndex == (totalItems - 1)) width = 0;
                        return { width: width + '%' }
                    };
                    scope.libActivefunc = function() {
                        scope.libActive = !scope.libActive;
                    };
                    scope.getModuleCompletedWidth = function(percentage) {
                        return (percentage);
                    };
                    scope.openInfoTab = function(index) {
                        scope.progressTimelineIndex = index;
                        var curEl = angular.element(".progress-bar-wrp");
                        var scrollPos = $(curEl).find(".progress-timeline-arrow-box");
                        curEl.animate({
                            scrollLeft: 120
                        }, 300);
                        $anchorScroll(curEl);
                    };
                    scope.closeTile = function() {
                        scope.progressTimelineIndex = null;
                    };
                    scope.setWeekWidth = function() {
                        scope.weekWidth = scope.noOfWeeks * scope.widthPerWeek + 'px'
                    };
                    scope.completedwidth = function(width) {
                        return {
                            width: width + '%'
                        }
                    };
                    scope.moveCarouselLeft = function() {

                        var tempEle = elem[0].children[0].children[1].clientWidth;

                        var maxLeft = (scope.noOfWeeks * scope.widthPerWeek) - tempEle;
                        maxLeft = maxLeft * (-1)
                        var TempLeft = scope.carouselEle[0].style.left.split('px');
                        if (TempLeft[0].length > 0) {
                            var eleLeft = parseInt(TempLeft[0]);
                        } else {
                            var eleLeft = 0;
                        }
                        var moveLeft = eleLeft - 240;
                        scope.leftMaxReached = false;

                        if (moveLeft < 0 && moveLeft >= maxLeft) {
                            scope.rightMaxReached = false;

                            $(scope.carouselEle).animate({
                                left: (moveLeft) + 'px'
                            });
                        } else {
                            scope.rightMaxReached = true;
                            $(scope.carouselEle).animate({
                                left: maxLeft + 'px'
                            });
                        }
                    };
                    scope.swipeLeft = function() {
                        scope.moveCarouselLeft();
                    };
                    scope.swipeRight = function() {
                        scope.moveCarouselRight();
                    };

                    scope.passEvent = function($event) {
                        var ele1 = angular.element(".progress-timeline-arrow-box");
                        var ele2 = angular.element(".progress-timeline-module");
                        if (ele1[0] === $event.target || $(ele1).find($event.target).length > 0 || $(ele2).find($event.target).length > 0) {} else {
                            scope.closeTile();
                        }
                    }

                    $rootScope.$on('closeTile', function() {
                        scope.closeTile();
                    });

                    scope.moveCarouselRight = function() {
                        var tempEle = elem[0].children[0].children[1].clientWidth;

                        var maxLeft = (scope.noOfWeeks * scope.widthPerWeek) - tempEle;
                        maxLeft = maxLeft * (-1)
                        var TempLeft = scope.carouselEle[0].style.left.split('px');
                        if (TempLeft[0].length > 0) {
                            var eleLeft = parseInt(TempLeft[0]);
                        } else {
                            var eleLeft = 0;
                        }
                        var moveLeft = eleLeft + 240;
                        if (moveLeft < 0 && moveLeft >= maxLeft) {
                            scope.leftMaxReached = false;
                            scope.rightMaxReached = false;
                            $(scope.carouselEle).animate({
                                left: moveLeft + 'px'
                            });
                        } else {
                            scope.leftMaxReached = true;
                            $(scope.carouselEle).animate({
                                left: 0 + 'px'
                            });
                        }
                    };
                }
            }
        }]);
})();
'use strict';
angular
    .module( 'jigsawCorpLms' )
    .directive( 'uploadedFile', function( $rootScope ) {
        return {
            scope: {
                selectedavatar: "=",
                overlayTrigger: '='
            },
            link: function( scope, element ) {
                $rootScope.errorInput = false;

                function readURL( input ) {
                    if ( input.target.files && input.target.files[ 0 ] ) {
                        var reader = new FileReader();
                        scope.overlayTrigger.selectedOverlay = true;
                        reader.addEventListener( "load", function() {
                            //scope.overlayTrigger.selectedImage = reader.result;
                            $rootScope.$digest();
                            $rootScope.$broadcast( 'imageLoaded', reader.result );
                        }, false );
                        reader.readAsDataURL( input.target.files[ 0 ] );

                    }
                };

                element.bind( "change", function( changeEvent ) {
                    scope.$apply( function() {
                        var allowedFileType = [ "JPEG", "PNG", "JPG" ];
                        var fileTypeRegex = [ new RegExp( allowedFileType[ 0 ], 'gi' ), new RegExp( allowedFileType[ 1 ], 'gi' ), new RegExp( allowedFileType[ 2 ], 'gi' ) ];
                        if ( changeEvent.target.files[ 0 ].type.match( fileTypeRegex[ 0 ] ) || changeEvent.target.files[ 0 ].type.match( fileTypeRegex[ 1 ] ) || changeEvent.target.files[ 0 ].type.match( fileTypeRegex[ 2 ] ) ) {
                            $rootScope.errorInput = false;
                            scope.selectedavatar = changeEvent.target.files[ 0 ].name;
                            readURL( changeEvent );

                        } else {
                            $rootScope.errorInput = true;
                            scope.selectedavatar = 'please select valid file type';
                        }

                    } );
                } );
            }
        }
    } );

'use strict';
angular
    .module( 'jigsawCorpLms' )
    .directive( 'uploadAvatar', function( $rootScope, fetchData, $timeout, Notifications,DataCache,$http ) {
        return {
            restrict: 'E',
            templateUrl: 'app/Common/Directives/uploadAvatar/uploadAvatar.html',
            link: function( scope ) {

                scope.authData = DataCache.returnData("userData");
                if (scope.authData == null || scope.authData == undefined || !scope.authData) {
                    return;
                }
                $http.defaults.headers.common['Authorization'] = "Bearer "+scope.authData.jwttoken;
                $http.defaults.headers.common['Content-Type'] = "application/x-www-form-urlencoded";


                try{
                    if($rootScope.baseimageurl === undefined){
                  $rootScope.baseimageurl= DataCache.returnData('baseimageurl');
                }
                var user="";

                if(scope.authData.fbUsername === undefined){
                    user=scope.authData.auth.fbUsername;
                }else{
                    user=scope.authData.fbUsername;
                }
                scope.reloadDirective = true;
                fetchData.fetchAvatarData().then( function( response ) {
                    if(response.data["error"]){
                        console.log("error in fetching avatar");
                    }
                    else{
                        scope.avatars = response.data.avatars;
                        for(var i=0;i<scope.avatars.length;i++){
                          scope.avatars[i].imageUrl=$rootScope.baseimageurl+"/avatars/"+scope.avatars[i].avatarLevel+"/"+scope.avatars[i].avatarPhoto;
                      }
                    }
                } );

                scope.parentObj.selectedOverlay = false;

                } catch(e){
                    console.error(e);
                }

                scope.selectedAvatarChange = function( pos ) {
                    scope.parentObj.selectedOverlay = true;
                    scope.parentObj.selectedImage = scope.avatars[ pos ].imageUrl;
                    scope.parentObj.selectedImageName = scope.avatars[ pos ].avatarPhoto;
                };

                scope.closeUploadAvatarOverlay = function() {
                    scope.parentObj.selectedOverlay = false;
                }

                scope.unSelectAvatarFunc = function() {
                    scope.parentObj.selectedImage = null;
                };

                scope.closeUploadAvatar = function() {
                    scope.parentObj.uploadAvatar = false;
                    scope.parentObj.selectedOverlay = false;
                };

                scope.uploadDisplayPicture = function() {
                   var data={"profilePhotoUrl":scope.parentObj.selectedImageName}
                     DataCache.saveGlobalData('avatar',scope.parentObj.selectedImageName);
                    fetchData.updateProfileImage(data).then( function( response ) {

                            if (!response.data['error'] ) {
                                if(scope.authData.role == "Learner"){
                                    $rootScope.$broadcast('avatarUpdated');
                                }

                                angular.element($(".scnd-hdr-userimg")).css("background","rgba(0, 0, 0, 0) url('"+scope.parentObj.selectedImage+"') scroll 0px 0px / 100% 100% padding-box border-box");
                                angular.element($(".prog-pg-hdr-userimg")).css("background","rgba(0, 0, 0, 0) url('"+scope.parentObj.selectedImage+"') scroll 0px 0px / 100% 100% padding-box border-box");
                                angular.element($(".setup-profile-image")).css("background","rgba(0, 0, 0, 0) url('"+scope.parentObj.selectedImage+"') scroll 0px 0px / 100% 100% padding-box border-box");

                                //$rootScope.modelParent.userImage = response.data.displayPic;
                                $( '.upload-state-picture' ).css("background","rgba(0, 0, 0, 0) url('"+scope.parentObj.selectedImage+"') scroll 0px 0px / 100% 100% padding-box border-box");
                                //Notifications.toast( response.headers( 'x-response-message' ) );
                            } else{
                              //  Notifications.toastError( response.headers( 'x-response-message' ) );
                            }
                            scope.closeUploadAvatar();
                    } );
                };

                scope.applySchemaOption = function( thisId, angle ) {
                    scope.allOptionsLoaded = false;
                    $timeout( function() {
                        scope.allOptionsLoaded = true;
                        var maskew = new Maskew( document.getElementById( thisId ), parseInt( angle ) );
                    }, 2000 );
                };

                $rootScope.$on( 'imageLoaded', function( event, value ) {
                    $( '#trapeziumProfileImageOption' ).css( 'background-image', 'url(' + value + ')' );
                    $( '#squareProfileImageOption' ).css( 'background-image', 'url(' + value + ')' );
                    $( '#rhombusProfileImageOption' ).css( 'background-image', 'url(' + value + ')' );
                } );
            }
        }
    } );


// 'use strict';
// ( function ( ) {
//     angular
//         .module( 'jigsawCorpLms' )
//         .directive( 'txtResize', [ function ( $document ) {
//             return {
//                 restrict: 'A',
//                 scope: {
//                     maxwidth: '@'
//                 },



//                 link: function ( scope, elem, attrs ) {
//                     var elem_width, max_width, reduction_scale;
//                     max_width = scope.maxwidth;
           
//                     elem_width = elem[ 0 ].offsetWidth;
//                     if ( elem_width > max_width ) {
//                         reduction_scale = max_width / elem_width;

//                         if ( reduction_scale > .6 ) {
//                             elem[ 0 ].style.transform = 'scale(' + reduction_scale + ')';
//                         } else {
//                             elem[ 0 ].style.transform = 'scale(' + 0.8 + ')';
//                         }
//                         // elem[ 0 ].style.width = elem_width + "px";
//                     }
//                     // return elem[ 0 ].parentNode.parentNode.style.width = max_width + "px";
//                 }
//             }
//         } ] );

// } )( );

'use strict';
( function() {
    angular
        .module( 'jigsawCorpLms' )
        .directive( 'quizTimer', [ '$rootScope', '$timeout', function( $rootScope, $timeout ) {
            return {
                restrict: 'E',
                scope: {
                    startTime: '=',
                    startTimer: '=',
                },
                templateUrl: 'app/Common/Directives/quizTimer/quizTimer.html',
                link: function( scope, elem, attrs ) {
                    scope.$watch(
                        function() {
                            return scope.startTimer;
                        },
                        function( newVal ) {
                            scope.countdown( newVal );
                        }
                    );
                    $timeout( function() {
                        scope.timeInSec = scope.startTime * 60;

                    }, 500 );

                    var stopped;
                    scope.countdown = function( val ) {
                        if ( val ) {
                            stopped = $timeout( function() {
                                scope.timeInSec--;
                                $rootScope.countdownTime = scope.timeInSec;
                                if ( scope.timeInSec > 0 ) {
                                    scope.countdown( true );
                                } else {
                                    scope.startTimer = false;
                                }

                            }, 1000 );
                        }
                    };
                }
            }
        } ] );

} )();

'use strict';
(function() {
    angular
        .module('jigsawCorpLms')
        .directive('proficiencyProgressBar', [ '$filter','DataCache', '$rootScope', function($filter, DataCache, $rootScope) {
            return {
                restrict: 'E',
                scope: {
                    totalTests: '=?bind',
                    actualCompletion: '=',
                    proposedCompletion: '='
                },
                templateUrl: 'app/Common/Directives/proficiency_progress_bar/proficiency_progress_bar.html',
                link: function(scope, elem, attrs) {

                  var user_data = DataCache.returnData('userData');

                    $rootScope.$on('progress-updated',function(){


                        scope.data = DataCache.returnData('summary');
                        scope.modulesData = scope.summary;
                          // scope.showProgress();
                        scope.totalTests = 0;
                        scope.completedTest = 0;
                        scope.data = DataCache.returnData( 'summary' );
                        for (var i = 0; i < scope.data.modules.length; i++){
                          if(scope.data.modules[i].proficiencyTest !== 0 && scope.data.modules[i].proficiencyTest !== null){
                            scope.totalTests += 1;
                            if (scope.data.modules[i].ptResult === 'PASS') {
                              scope.completedTest++;
                            }
                          }
                        }
                        scope.width = 100 / scope.totalTests +'%';

                        // angular.forEach(scope.data.modules, function(value, key) {
                        //   if(key !== 0 && value.ptResult === 'PASS'){
                        //     scope.completedTest = scope.completedTest + 1;
                        //   }
                        // }, this);
                    });

                    var user;
                    if(user_data.hasOwnProperty('auth')){
                        user = user_data.auth.role;
                    }else {
                      user = user_data.role;
                    }
                    if(user === 'Learner'){
                      scope.completedTest = 0;
                      scope.totalTests = 0;
                      scope.data = DataCache.returnData( 'summary' );
                      for (var i = 0; i < scope.data.modules.length; i++){
                        if(scope.data.modules[i].proficiencyTest !== 0 && scope.data.modules[i].proficiencyTest !== null){
                          scope.totalTests += 1;
                          if (scope.data.modules[i].ptResult === 'PASS') {
                            scope.completedTest++;
                          }
                        }
                      }
                      scope.width = 100 / scope.totalTests +'%';

                      // angular.forEach(scope.data.modules, function(value, key) {
                      //   if(key !== 0 && value.ptResult === 'PASS'){
                      //     scope.completedTest = scope.completedTest + 1;
                      //   }
                      // }, this);

                      scope.getNumber = function(num) {
                          return new Array(num);
                      }
                      scope.setListWidth = function(totalTests) {
                         var width = 100 / totalTests;
                         return(width);
                      }

                      scope.setWidthOfEstimate = function(actual , total) {
                          var width = actual / total;
                          width = width*100;
                          return(width);
                      }

                    }
                    $rootScope.mCount = scope.totalTests;
                    DataCache.saveGlobalData("mCount",$rootScope.mCount);



                }
            }
        }  ] );

})();

'use strict';
(function() {
    angular
        .module('jigsawCorpLms')
        .directive('primaryProgressBar', ['DataCache', '$rootScope', function(DataCache, $rootScope) {
            return {
                restrict: 'E',
                scope: {
                    proposedCompletion: '=proposedCompletion',
                    actualCompletion: '=actualCompletion',
                    expectedCompletion:'=expectedCompletion',
                },
                templateUrl: 'app/Common/Directives/primary_progress_bar/primary_progress_bar.html',
                link: function(scope) {

                  var user_data = DataCache.returnData('userData');
                  var user;
                  if(user_data.hasOwnProperty('auth')){
                      user = user_data.auth.role;
                  }else {
                    user = user_data.role;
                  }

                  if(user === 'Learner'){

                    scope.data = DataCache.returnData( 'summary' );
                    scope.actualCompletion = scope.data.progress.toFixed(0);


                    if($rootScope.newLpAttr === undefined){

                        $rootScope.newLpAttr=DataCache.returnData( 'lpAttr' );
                    }
                    scope.lpAttr = $rootScope.newLpAttr;

                    scope.$watch(function() {
                      return $rootScope.newLpAttr;
                    }, function() {
                      scope.lpAttr = $rootScope.newLpAttr;
                    }, true);

                    var perWeekHrs = DataCache.returnData('perWeekHrs');
                    var totalWeeks = DataCache.returnData('totalWeeks');
                    var currentWeek = DataCache.returnData("currentWeek");

                    var weeksCompleted = scope.data.durationCompleted/perWeekHrs;


                    if(weeksCompleted > currentWeek){
                        scope.message = (weeksCompleted - currentWeek).toFixed(0) + " % left";
                    }else if(weeksCompleted < currentWeek){
                        scope.message =  "You should have been at "+((currentWeek/totalWeeks)*100).toFixed(0) +" %";
                    }else{
                        scope.message =  "You are on track";
                    }

                    scope.updateTrackMessage = function(){

                         

                        if ( $rootScope.firstTimeLogin )
                        {
                            scope.lpAttr.trackProgressMessage = "Start learning !";
                        }
                        else
                        {
                            if (scope.lpAttr.actualProgress >= scope.lpAttr.expectedCompletionPerct && scope.lpAttr.actualProgress != 100)
                            {
                                scope.trackProgressMessage = "You are " + (scope.lpAttr.actualProgress - scope.lpAttr.expectedCompletionPerct) + "% ahead of schedule";
                            }
                            else if (scope.lpAttr.actualProgress <= scope.lpAttr.expectedCompletionPerct)
                            {
                                scope.trackProgressMessage = "You should be at " + scope.lpAttr.expectedCompletionPerct +"%";
                            }
                            else if (scope.lpAttr.actualProgress === 100)
                            {
                                scope.trackProgressMessage = "100% completed";
                            }
                        }
                         
                    }
                    scope.updateTrackMessage();

                    $rootScope.$on('progress-updated',function(){
                         
                        scope.updateTrackMessage();
                    });



                    // white line
                    scope.changePropseWidth = function() {
                        //scope.proposedCompletion = 20;
                        return { width: '0%' }
                    };
                    // blue line
                    scope.changeActualWidth = function() {
                        return { width: scope.lpAttr.actualProgress + '%' }

                    }
                    // red mark
                    scope.expctedWidth = function() {
                         return { width: scope.lpAttr.expectedCompletionPerct + '%' }
                    }
                }


              }
            }
        } ]);

})();

'use strict';
angular
    .module('jigsawCorpLms')
    .directive('popout', ['$rootScope', 'fetchData', '$timeout', 'DataCache', '$http', '$state', '$cookies', function($rootScope, $state, $timeout, DataCache, $cookies) {
        return {
            restrict: 'E',

            link: function(scope) {

                //scope.setToDefault();
                $rootScope.popoutShow = false;
                scope.logoutPopOut = false;
                scope.noContentPopout = false;
                scope.logoutPopOut = false;
                scope.approvalPopOut = false;
                scope.isSafari = false;
                $rootScope.modulePopup = false;
                $rootScope.userDetailsPopOut = false;
                scope.userDetailsPopOut = false;
                scope.savePasswordPopOut = false;
                //scope.approvalPopOut=false;
                var authInfo = DataCache.returnData('userData');


                $rootScope.$on('approval-popout', function() {
                    scope.showPopUp();
                    scope.setToDefault();
                    scope.approvalPopOut = true;
                });

                $rootScope.$on('isSafariBrowser', function() {
                    scope.showPopUp();
                    scope.setToDefault();
                    scope.isSafari = true;
                });

                $rootScope.$on('noContentPopout', function() {
                    scope.showPopUp();
                    scope.setToDefault();
                    scope.noContentPopout = true;
                });

                scope.setToDefault = function() {
                    scope.noContentPopout = false;
                    scope.logoutPopOut = false;
                    scope.approvalPopOut = false;
                    $rootScope.modulePopup = false;
                    scope.isSafari = false;
                    $rootScope.userDetailsPopOut = false;
                    scope.userDetailsPopOut = false;
                    scope.savePasswordPopOut = false;
                };

                scope.closePopoutCard = function() {
                    $rootScope.modelParent.isPopOutViewActive = false;
                    $rootScope.popoutShow = false;
                    $timeout(function() {
                        $rootScope.modelParent.bringInPopOut = false;
                    }, 310);
                    scope.setToDefault();
                };

                scope.logout = function() {
                    scope.closePopoutCard();
                    var user;
                    if (authInfo.hasOwnProperty('auth')) {
                        user = authInfo.auth.role;
                    } else {
                        user = authInfo.role;
                    }
                    if (user === 'Learner') {
                        $rootScope.$broadcast('learner-logout-initiated');
                    } else if (user === 'L&D Manager' || user === 'Manager') {
                        $rootScope.$broadcast('logout-initiated');
                    }
                };

                scope.confirmApprovalPopOut = function() {
                    scope.$broadcast('approveRetake');
                    scope.closePopoutCard();
                };

                scope.passEvent = function($event) {
                    var ele1 = angular.element(".pop-outs-content.relative");
                    if (ele1[0] === $event.target || $(ele1).find($event.target).length > 0) {} else {
                        scope.closePopoutCard();
                    }
                }

                var logout = $rootScope.$on('logout-popout-initiated', function() {
                    scope.showPopUp();
                    scope.setToDefault();
                    scope.logoutPopOut = true;

                });

                scope.$on('$destroy', function() {
                    logout();
                });

                $rootScope.$on('userdetails-popout-initiated', function() {
                    scope.showPopUp();
                    scope.setToDefault();
                    scope.userDetailsPopOut = true;
                });

                $rootScope.$on('savepassword-popout-initiated', function() {
                    scope.setToDefault();
                    scope.showPopUp();
                    scope.savePasswordPopOut = true;
                });

                scope.showPopUp = function() {
                    $rootScope.popoutShow = true;
                    $rootScope.modelParent.isPopOutViewActive = true;
                    $rootScope.modelParent.bringInPopOut = true;
                }

                $rootScope.$on('module-popout-initiated', function() {
                    scope.showPopUp();
                    scope.setToDefault();
                    $rootScope.modulePopup = true;

                });




            },
            templateUrl: "app/Common/Directives/popout/popout.html"
        }
    }]);
'use strict';
angular
    .module('jigsawCorpLms')
    .directive('playlist', function($rootScope, $anchorScroll, $timeout, fetchData, $state, DataCache, $filter, FirebaseService) {
        return {
            restrict: 'E',

            templateUrl: 'app/Common/Directives/playlist_directive/playlist.html',

            link: function(scope) {

                scope.currentModuleData = DataCache.returnData('thisModuleData');
                scope.details = DataCache.returnData("details");
                scope.modulePlaylistItems = scope.details[scope.currentModuleData.moduleId];




                var ref = FirebaseService.ref.child($rootScope.events);

                scope.$on('playListUpdate', function(event, currentItem) {
                    scope.clickedPlaylistItem(currentItem.sequence_id, currentItem.type);
                });


                scope.activeModuleData = DataCache.returnData('thisModuleData');
                scope.filterPlaylist = function() {
                    scope.togglePlaylistFilter = !scope.togglePlaylistFilter;
                }

                scope.passEvent = function($event) {
                    var ele1 = angular.element(".vid-vidplaylist-filter.table-cell");
                    if (ele1[0] === $event.target || $(ele1).find($event.target).length > 0) {} else {
                        scope.togglePlaylistFilter = false;
                    }
                }

                scope.clickedPlaylistItem = function(bcId, resourceId, sequcenceID, type) {

                    var prevSeqId = $rootScope.currentSequenceId;

                    $rootScope.currentSequenceId = sequcenceID;
                    $rootScope.currentResourceId = resourceId;
                    $rootScope.currentBcId = bcId;

                    DataCache.saveRootScopeData('currentSequenceId', $rootScope.currentSequenceId)
                    DataCache.saveRootScopeData('currentResourceId', $rootScope.currentResourceId);
                    DataCache.saveRootScopeData('currentBcId', $rootScope.currentBcId);


                    var userData = DataCache.returnData("userData");

                    scope.eventObject = {
                        "group": "lprogress",
                        "type": "lresource",
                        "data": {
                            "action": "update",
                            "teamId": userData.teamId,
                            "clientId": userData.clientId,
                            "lpId": userData.lpId,
                            "lpTitle": userData.lpTitle,
                            "token": userData.token,
                            "moduleId": scope.activeModuleData.moduleId.toString(),
                            "resourceId": resourceId.toString(),
                            "moduleSeqId": scope.activeModuleData.sequenceId.toString(),
                            "resourceSeqId": sequcenceID.toString(),
                            "timestamp": $filter('date')(new Date(), 'yyyy-MM-dd HH:mm:ss')
                        }
                    };
                    
                    if (DataCache.returnLpData('currentLp') === 'active') {
                        ref.push().child(scope.authData.uid).set(scope.eventObject);
                    }



                    switch (type) {
                        case 'video':
                            if ($rootScope.currentSequenceId != prevSeqId)
                                $state.go('home.learn.video', { sequenceId: sequcenceID }, { reload: 'home.learn', inherit: false, notify: true });
                            break;
                        case 'quiz':
                            $state.go('home.learn.quiz', { sequenceId: sequcenceID }, { reload: 'home.learn', inherit: false, notify: true });
                            break;
                        case 'csa':
                            $state.go('home.learn.assessment', { sequenceId: sequcenceID }, { reload: 'home.learn', inherit: false, notify: true });
                            break;
                        case 'material':
                            $state.go('home.learn.resources', { sequenceId: sequcenceID }, { reload: 'home.learn', inherit: false, notify: true });
                            break;
                        case 'ytc':
                            $state.go('home.learn.ytc', { sequenceId: sequcenceID }, { reload: 'home.learn', inherit: false, notify: true });
                            break;
                    }
                }

                $rootScope.$broadcast('scrollPlaylist');

                $rootScope.$on('scrollPlaylist', function() {
                    $timeout(function() {
                        var curEl = angular.element(".scroll-bar.vid-other-video-wrp");
                        var scrollPos = $(curEl).find(".vid-vidplaylist-item-wrp.vid-item-current.current-playing-arrow");
                        curEl.animate({
                            scrollTop: scrollPos.position().top - 67
                        }, 700);
                        $anchorScroll(curEl);
                    }, 100);
                });


                scope.setPlaylistHeight = function() {
                    if ($state.current.url === ".video" || $state.current.url === ".quiz" || $state.current.url === ".assessment" || $state.current.url === ".resources" || $state.current.url === ".ytc") {
                        var hdngHeight = angular.element('.vid-vidplaylist-title-wrp')[0].offsetHeight;
                        var parentEle = angular.element('.learnerview-right')[0].offsetHeight;
                        var playListHeight, tempHeight;
                        tempHeight = 'calc(' + parentEle + 'px' + ' - ' + hdngHeight + 'px' + ')';
                        return {

                            height: tempHeight

                        }
                    }
                }
            }
        }
    });
'use strict';
angular
    .module( 'jigsawCorpLms' )
    .directive( 'overlay', function( $rootScope, fetchData, $state, DataCache, $filter ) {
        return {
            restrict: 'E',

            templateUrl: 'app/Common/Directives/overlay/overlay.html',

            link: function( scope ) {

                scope.modulePlaylistItems = DataCache.returnData("thisModuleDetails");
                scope.activeModule = DataCache.returnData( 'thisModuleData' );
                scope.details = DataCache.returnData( 'details' );
                scope.activeModuleData = scope.details[scope.activeModule.moduleId][$rootScope.currentSequenceId];

                scope.takeNotesToggle = true;
                scope.shwMobOptions = false;


                scope.bookmarkVideo = function ( ) {
                    $scope.bookmarked = !$scope.bookmarked;
                };

                fetchData.fetchClipboardData( ).then( function ( response ) {
                    scope.clipboardData = response.data.clipboardata;
                    scope.rearrangeDataClipboard( scope.clipboardData );
                } );

                scope.hideOverlay = function(){
                    document.getElementById("overlay").style.zIndex = -1;
                    document.getElementById("video").style.zIndex = 1;

                    document.getElementById("overlay").style.opacity = 0;
                    document.getElementById("video").style.opacity = 1;
                }


            }
        }
    } );

'use strict';
angular
    .module( 'jigsawCorpLms' )
    .directive( 'moduleProgressBar', function ( ) {
        return {
            restrict: 'E',
            scope: {
                progressbardata: '='
            },
            templateUrl: 'app/Common/Directives/moduleProgressBar/moduleProgressBar.html',
            link: function ( scope ) {

                scope.moveLeft = function ( left ) {
                    var temp = "calc("+left+"%"+" - "+"21.5px)"
                    return { left:temp }
                };
            }
        }
    } );

'use strict';
angular
    .module( 'jigsawCorpLms' )
    .directive( 'loadingState', function() {
        return {
            restrict: 'EA',
            templateUrl: 'app/Common/Directives/loadingState/loadingState.html'
        }

    } );

'use strict';
angular
    .module( 'jigsawCorpLms' )
    .directive( 'lineChartHoursExpandedTeam', function() {
        return {
            restrict: 'E',
            scope: {
                hourschartdata: '='
            },
            link: function( scope, element, attrs ) {
                scope.$watch( 'hourschartdata', function( newValue, oldValue ) {
                    if ( newValue )
                        scope.createChart();
                }, true );
                scope.createChart = function() {
                    var data = scope.hourschartdata;
                    //d3.selectAll( "#btotal-learning-section svg" ).remove();
                    var margin = {
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0
                    };
                    var xAxisMarkLines = [];
                    var yAxisMarkLines = [];
                    var width = $( '.graph-wrp' ).width(),
                        height = 100 - margin.top - margin.bottom;

                    var x = d3.scale.linear().domain( [ 0, 100 ] ).range( [ 1, width ] );
                    var y = d3.scale.linear().range( [ height, 0 ] );

                    var xAxis = d3.svg.axis().scale( x )
                        .orient( "bottom" );
                    if ( data.length < 5 && data.length > 1 ) {
                        xAxis.ticks( data.length - 1 );
                    } else if ( data.length >= 5 ) {
                        xAxis.ticks( 5 );
                    }
                    //var ticks = xAxis.ticks( 5 );
                    xAxis.tickSize( 0 );
                    var yAxis = d3.svg.axis().scale( y )
                        .orient( "left" ).ticks( 5 );

                    var valueline = d3.svg.line()
                        .x( function( d ) {
                            xAxisMarkLines.push( x( d.weekNum ) );
                            return x( d.weekNum );
                        } )
                        .y( function( d ) {
                            yAxisMarkLines.push( y( d.hours ) );
                            return y( d.hours );
                        } );

                    var svg = d3.select( element[ 0 ] )
                        .append( "svg" )
                        .attr( "width", '101%' )
                        .attr( "height", '100%' )
                        .append( "g" )
                        .attr( "width", '100%' )
                        .attr( "transform", "translate(30,25)" );

                    var focus = svg.append( "g" )
                        .style( "display", "none" );

                    /*var data = scope.hourschartdata;*/

                    data.forEach( function( d ) {
                        d.hours = +d.hours;
                        if ( d.percentageChange ) {
                            d.percentage = d.percentageChange;
                        }
                        //d.percentage = d.percentageChange;
                    } );

                    // Scale the range of the data
                    x.domain( d3.extent( data, function( d ) {
                        return d.weekNum;
                    } ) );
                    y.domain( [ 0, d3.max( data, function( d ) {
                        return d.hours;
                    } ) ] );

                    svg.append( "path" ) // Add the valueline path.
                        .attr( "d", valueline( data ) );

                    svg.append( "g" ) // Add the X Axis
                        .attr( "class", "x axis" )
                        .attr( "transform", "translate(0,100)" )
                        .style( 'fill', '#cccccc' )
                        .call( xAxis );

                        svg.append( "g" )
                            .attr("class", "y axis")
                            .attr( "transform", "translate(0,0)" )
                            .style("fill", "#cccccc")
                            .style("font-size","9px")
                            .call(yAxis);

                    data.forEach( function( val, i ) {
                        svg.append( "line" ).attr( "x1", xAxisMarkLines[ i ] ).attr( "y1", yAxisMarkLines[ i ] ).attr( "x2", xAxisMarkLines[ i ] ).attr( "y2", height ).style( {
                            'fill': 'transparent',
                            'stroke': '#efefef',
                            'stroke-width': 1
                        } );

                        svg.append( "circle" ).attr( "cx", xAxisMarkLines[ i ] ).attr( "cy", yAxisMarkLines[ i ] ).attr( "r", 2 ).style( 'fill', '#3696ed' );
                        if ( i < data.length - 1 ) {
                            var percentageToShow = parseFloat( val.percentage ) - parseFloat( data[ i + 1 ].percentage );
                            var targetLine = svg.append( "line" ).attr( "x1", xAxisMarkLines[ i ] ).attr( "y1", yAxisMarkLines[ i ] ).attr( "x2", xAxisMarkLines[ i + 1 ] ).attr( "y2", yAxisMarkLines[ i + 1 ] );
                            targetLine.style( {
                                'fill': 'transparent',
                                'stroke': 'transparent',
                                'stroke-width': 4
                            } );
                            if ( yAxisMarkLines[ i + 1 ] > yAxisMarkLines[ i ] ) {
                                targetLine.attr( "class", "line-indication is-falling" ); // as zero is top so moving up is decrease in value
                            } else {
                                targetLine.attr( "class", "line-indication is-rising" ); // as zero is top so moving down is increase in value
                            }
                            var descriptor = svg.append( "text" ).attr( "x", xAxisMarkLines[ i + 1 ] - 40 ).attr( "y", yAxisMarkLines[ i + 1 ] - 10 );
                            descriptor.text( Math.abs( percentageToShow ) + "%" ).style( {
                                'fill': 'transparent',
                                'stroke': 'transparent'
                            } );
                        }

                    } );

                    svg.selectAll( ".line-indication" )
                        .on( "mouseover", handleMouseOver )
                        .on( "mouseout", handleMouseOut );

                    function handleMouseOver( d, i ) {
                        if ( d3.select( this ).attr( 'class' ).indexOf( 'is-rising' ) >= 0 ) {
                            d3.select( this ).style( 'stroke', '#009900' );
                            $( ( d3.select( this )[ 0 ] )[ 0 ].nextElementSibling ).css( {
                                'stroke': '#009900',
                                'fill': '#009900'
                            } );
                        } else if ( d3.select( this ).attr( 'class' ).indexOf( 'is-falling' ) >= 0 ) {
                            d3.select( this ).style( 'stroke', '#990000' );
                            $( ( d3.select( this )[ 0 ] )[ 0 ].nextElementSibling ).css( {
                                'stroke': '#990000',
                                'fill': '#990000'
                            } );
                        }
                    };

                    function handleMouseOut( d, i ) {
                        d3.select( this ).style( 'stroke', 'transparent' );
                        $( ( d3.select( this )[ 0 ] )[ 0 ].nextElementSibling ).css( {
                            'stroke': 'transparent',
                            'fill': 'transparent'
                        } );
                    };
                };
            }
        }
    } );

'use strict';
angular
    .module( 'jigsawCorpLms' )
    .directive( 'lineChartHoursExpanded', function() {
        return {
            restrict: 'E',
            scope: {
                hourschartdata: '='
            },
            link: function( scope, element, attrs ) {
                scope.$watch( 'hourschartdata', function( newValue, oldValue ) {
                    if ( newValue )
                        scope.createChart();
                }, true );

                d3.select(window).on('resize.ehours', function() {
                    scope.createChart();
                });

                scope.createChart = function() {
                    var margin = {
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 30
                    };
                    var width = $( '.graph-wrp-chart' ).width(),
                        height = 100 - margin.top - margin.bottom;
                        var marginLeft=40;
                    var x = d3.scale.linear().domain( [ 0, 100 ] ).range( [ 1, width-50 ] );
                    var y = d3.scale.linear().range( [ height, 0 ] );

                                        var data = scope.hourschartdata;                      
                  /*  var xAxis = d3.svg.axis().scale( x )
                        .orient( "bottom" );

                    var yAxis = d3.svg.axis().scale( y )
                        .orient( "left" ).ticks( 5 );*/

                        var xAxis = d3.svg.axis().scale( x )
                            .orient( "bottom" );
                        if ( data.length < 5 && data.length > 1 ) {
                            xAxis.ticks( data.length - 1 );
                        } else if ( data.length >= 5 ) {
                            xAxis.ticks( 5 );
                        }
                        //var ticks = xAxis.ticks( 5 );
                        xAxis.tickSize( 0 );
                        var yAxis = d3.svg.axis().scale( y )
                            .orient( "left" ).ticks( 5 );

                    var valueline = d3.svg.line()
                        .x( function( d ) {
                            return x( d.weekNum );
                        } )
                        .y( function( d ) {
                            return y( d.hours );
                        } );

                    var svg = d3.select( element[ 0 ] )
                        .append( "svg" )
                        .attr( "width", '100%' )
                        .attr( "height", '100%' )
                        .append( "g" )
                        .attr( "width", '100%' )
                        .attr( "transform", "translate("+ marginLeft +",25)" );

                    var focus = svg.append( "g" )
                        .style( "display", "none" );


                    data.forEach( function( d ) {
                        d.hours = +d.hours;
                    } );

                    // Scale the range of the data
                    x.domain( d3.extent( data, function( d ) {
                        return d.weekNum;
                    } ) );
                    y.domain( [ 0, d3.max( data, function( d ) {
                        return d.hours;
                    } ) ] );

                    svg.append( "path" ) // Add the valueline path.
                        .attr( "d", valueline( data ) );

                    svg.append( "g" ) // Add the X Axis
                        .attr( "class", "x axis" )
                        .attr( "transform", "translate(0,100)" )
                        .call( xAxis );

                    //  svg.append( "g" ) // Add the Y Axis
                    //      .attr( "class", "y axis" )
                    //      .call( yAxis );

                         svg.append( "g" )
                             .attr("class", "y axis")
                             .attr( "transform", "translate(0,0)" )
                             .style("fill", "#cccccc")
                             .style("font-size","9px")
                             .call(yAxis);

                        //  svg.append("g").selectAll("circle")
                        //    .data(function(d){return d.values})
                        //    .enter()
                          // svg.append("circle")
                          //  .attr("r", 2)
                          //  .attr("cx", function(dd){return x(dd.date)})
                          //  .attr("cy", function(dd){return y(dd.temperature)})
                          //  .attr("fill", "blue")
                          //  .attr("stroke", "black");

                };
            }
        }
    } );

'use strict';
angular
    .module( 'jigsawCorpLms' )
    .directive( 'lineChartHours', function() {
        return {
            restrict: 'E',
            scope: {
                hourschartdata: '='
            },
            link: function( scope, element, attrs ) {
                scope.$watch( 'hourschartdata', function( newValue, oldValue ) {
                    if ( newValue )
                        scope.createChart();
                }, true );

                d3.select(window).on('resize.hours', function() {
                    scope.createChart();
                });

                scope.createChart = function() {
                    var data = scope.hourschartdata;

                    d3.selectAll( "#btotal-learning-section svg" ).remove();
                    var margin = {
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0
                    };
                    var xAxisMarkLines = [];
                    var yAxisMarkLines = [];
                    var width = $( '.graph-wrp' ).width(),
                        height = 100 - margin.top - margin.bottom;

                    var x = d3.scale.linear().domain( [ 0, 100 ] ).range( [ 1, width*8.8/10 ] );
                    var y = d3.scale.linear().range( [ height, 0 ] );

                    var xAxis = d3.svg.axis().scale( x )
                        .orient( "bottom" );
                    if ( data.length < 5 && data.length > 1 ) {
                        xAxis.ticks( data.length - 1 );
                    } else if ( data.length >= 5 ) {
                        xAxis.ticks( 5 );
                    }
                    //var ticks = xAxis.ticks( 5 );
                    xAxis.tickSize( 0 );
                    var yAxis = d3.svg.axis().scale( y )
                        .orient( "left" ).ticks( 5 );

                    var valueline = d3.svg.line()
                        .x( function( d ) {
                            xAxisMarkLines.push( x( d.weekNum ) );
                            return x( d.weekNum );
                        } )
                        .y( function( d ) {
                            yAxisMarkLines.push( y( d.hours ) );
                            return y( d.hours );
                        } );

                    var svg = d3.select( element[ 0 ] )
                        .append( "svg" )
                        .attr( "width", '101%' )
                        .attr( "height", '100%' )
                        .append( "g" )
                        .attr( "transform", "translate(30,25)" );

                    var focus = svg.append( "g" )
                        .style( "display", "none" );

                    /*var data = scope.hourschartdata;*/

                    data.forEach( function( d ) {
                        d.hours = +d.hours;
                        if ( d.percentageChange ) {
                            d.percentage = d.percentageChange;
                        }else{
                            d.percentage = d.hours;
                        }
                        //d.percentage = d.percentageChange;
                    } );

                    // Scale the range of the data
                    x.domain( d3.extent( data, function( d ) {
                        return d.weekNum;
                    } ) );
                    y.domain( [ 0, d3.max( data, function( d ) {
                        return d.hours;
                    } ) ] );

                    svg.append( "path" ) // Add the valueline path.
                        .attr( "d", valueline( data ) );

                    svg.append( "g" ) // Add the X Axis
                        .attr( "class", "x axis" )
                        .attr( "transform", "translate(0,100)" )
                        .style( 'fill', '#cccccc' )
                        .call( xAxis );

                        svg.append( "g" )
                            .attr("class", "y axis")
                            .attr( "transform", "translate(0,0)" )
                            .style("fill", "#cccccc")
                            .style("font-size","9px")
                            .call(yAxis);

                    data.forEach( function( val, i ) {
                        svg.append( "line" ).attr( "x1", xAxisMarkLines[ i ] ).attr( "y1", yAxisMarkLines[ i ] ).attr( "x2", xAxisMarkLines[ i ] ).attr( "y2", height ).style( {
                            'fill': 'transparent',
                            'stroke': '#efefef',
                            'stroke-width': 1
                        } );

                        svg.append( "circle" ).attr( "cx", xAxisMarkLines[ i ] ).attr( "cy", yAxisMarkLines[ i ] ).attr( "r", 2 ).style( 'fill', '#3696ed' );
                        if ( i < data.length - 1 ) {
                            var percentageToShow = parseFloat( val.percentage ) - parseFloat( data[ i + 1 ].percentage );
                            var targetLine = svg.append( "line" ).attr( "x1", xAxisMarkLines[ i ] ).attr( "y1", yAxisMarkLines[ i ] ).attr( "x2", xAxisMarkLines[ i + 1 ] ).attr( "y2", yAxisMarkLines[ i + 1 ] );
                            targetLine.style( {
                                'fill': 'transparent',
                                'stroke': 'transparent',
                                'stroke-width': 4
                            } );
                            if ( yAxisMarkLines[ i + 1 ] > yAxisMarkLines[ i ] ) {
                                targetLine.attr( "class", "line-indication is-falling" ); // as zero is top so moving up is decrease in value
                            } else {
                                targetLine.attr( "class", "line-indication is-rising" ); // as zero is top so moving down is increase in value
                            }
                            var descriptor = svg.append( "text" ).attr( "x", xAxisMarkLines[ i + 1 ] ).attr( "y", yAxisMarkLines[ i + 1 ] - 10 );
                            descriptor.text( Math.ceil( percentageToShow ) ).style( {
                                'fill': 'transparent',
                                'stroke': 'transparent'
                            } );
                        }

                    } );

                    svg.selectAll( ".line-indication" )
                        .on( "mouseover", handleMouseOver )
                        .on( "mouseout", handleMouseOut );

                    function handleMouseOver( d, i ) {
                        if ( d3.select( this ).attr( 'class' ).indexOf( 'is-rising' ) >= 0 ) {
                            d3.select( this ).style( 'stroke', '#990000' );
                            $( ( d3.select( this )[ 0 ] )[ 0 ].nextElementSibling ).css( {
                                'stroke': '#990000',
                                'fill': '#990000'
                            } );
                        } else if ( d3.select( this ).attr( 'class' ).indexOf( 'is-falling' ) >= 0 ) {
                            d3.select( this ).style( 'stroke', '#009900' );
                            $( ( d3.select( this )[ 0 ] )[ 0 ].nextElementSibling ).css( {
                                'stroke': '#009900',
                                'fill': '#009900'
                            } );
                        }
                    };

                    function handleMouseOut( d, i ) {
                        d3.select( this ).style( 'stroke', 'transparent' );
                        $( ( d3.select( this )[ 0 ] )[ 0 ].nextElementSibling ).css( {
                            'stroke': 'transparent',
                            'fill': 'transparent'
                        } );
                    };
                };
            }
        }
    } );

'use strict';
angular
    .module( 'jigsawCorpLms' )
    .directive( 'lineChartHealth', function() {
        return {
            restrict: 'E',
            scope: {
                healthchartdata: '='
            },
            link: function( scope, element, attrs ) {
                scope.$watch( 'healthchartdata', function( newValue, oldValue ) {
                    if ( newValue )
                        scope.createChart();
                }, true );

                d3.select(window).on('resize.health', function() {
                    scope.createChart();
                });
                scope.createChart = function() {
                    var data = scope.healthchartdata;
                    d3.selectAll( "#blearning-health-section svg" ).remove();

                    var margin = {
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0
                    };


                    var width = $( '.graph-wrp' ).width(),
                        height = 100 - margin.top - margin.bottom;

                    var x = d3.scale.linear().domain( [ 0, 100 ] ).range( [ 1, width*9.2/10 ] );

                    var y = d3.scale.linear().range( [ height, 0 ] );
                    var xAxis = d3.svg.axis().scale( x )
                        .orient( "bottom" );

                    if ( data.length < 5 && data.length > 1 ) {
                        xAxis.ticks( data.length - 1 );
                    } else if ( data.length >= 5 ) {
                        xAxis.ticks( 5 );
                    }

                    //var ticks = xAxis.ticks( 5 );
                    xAxis.tickSize( 0 );
                    //tickFormat = xAxis.tickFormat( 5, "+%" );
                    //ticks.map( tickFormat );

                    //xAxis.style( 'fill', '#cccccc' );
                    var yAxis = d3.svg.axis().scale( y )
                        .orient( "left" ).ticks( 5 );

                    var xAxisMarkLines = [];
                    var yAxisMarkLines = [];

                    var valueline = d3.svg.line()
                        .x( function( d ) {
                            xAxisMarkLines.push( x( d.weekNum ) );
                            return x( d.weekNum );
                        } )
                        .y( function( d ) {
                            yAxisMarkLines.push( y( d.percentage ) );
                            return y( d.percentage );
                        } );

                    var svg = d3.select( element[ 0 ] )
                        .append( "svg" )
                        .attr( "width", '100%' )
                        .attr( "height", '100%' )
                        .append( "g" )
                        .attr( "transform", "translate(20,25)" );

                    var focus = svg.append( "g" )
                        .style( "display", "none" );

                    /*var data = scope.healthchartdata;*/

                    /*data.forEach( function( d ) {
                        d.percentage = +d.percentage;
                    } );*/

                    // Scale the range of the data
                    //x.domain(data.map(function(d) { return d.weekNum; }));
                    x.domain( d3.extent( data, function( d ) {
                        return d.weekNum;
                    } ) );
                    y.domain( [ 0, d3.max( data, function( d ) {
                        return d.percentage;
                    } ) ] );


                    svg.append( "path" ) // Add the valueline path.
                        .attr( "d", valueline( data ) );

                    svg.append( "g" ) // Add the X Axis
                        .attr( "class", "x axis" )
                        .attr( "transform", "translate(0,100)" )
                        .style( 'fill', '#cccccc' )
                        .call( xAxis );
                    svg.append( "g" )
                        .attr("class", "y axis")
                        .attr( "transform", "translate(0,0)" )
                        .style("fill", "#cccccc")
                        .style("font-size","9px")
                        .call(yAxis);

                    data.forEach( function( val, i ) {
                        svg.append( "line" ).attr( "x1", xAxisMarkLines[ i ] ).attr( "y1", yAxisMarkLines[ i ] ).attr( "x2", xAxisMarkLines[ i ] ).attr( "y2", height ).style( {
                            'fill': 'transparent',
                            'stroke': '#efefef',
                            'stroke-width': 1
                        } );

                        svg.append( "circle" ).attr( "cx", xAxisMarkLines[ i ] ).attr( "cy", yAxisMarkLines[ i ] ).attr( "r", 2 ).style( 'fill', '#3696ed' );
                        if ( i < data.length - 1 ) {
                            var percentageToShow = parseFloat( val.percentage ) - parseFloat( data[ i + 1 ].percentage );
                            var targetLine = svg.append( "line" ).attr( "x1", xAxisMarkLines[ i ] ).attr( "y1", yAxisMarkLines[ i ] ).attr( "x2", xAxisMarkLines[ i + 1 ] ).attr( "y2", yAxisMarkLines[ i + 1 ] );
                            targetLine.style( {
                                'fill': 'transparent',
                                'stroke': 'transparent',
                                'stroke-width': 4
                            } );
                            if ( yAxisMarkLines[ i + 1 ] > yAxisMarkLines[ i ] ) {
                                targetLine.attr( "class", "line-indication is-falling" ); // as zero is top so moving up is decrease in value
                            } else {
                                targetLine.attr( "class", "line-indication is-rising" ); // as zero is top so moving down is increase in value
                            }
                            var descriptor = svg.append( "text" ).attr( "x", xAxisMarkLines[ i + 1 ] - 40 ).attr( "y", yAxisMarkLines[ i + 1 ] - 10 );
                            descriptor.text( Math.abs( percentageToShow ) + "%" ).style( {
                                'fill': 'transparent',
                                'stroke': 'transparent'
                            } );
                        }

                    } );

                    svg.selectAll( ".line-indication" )
                        .on( "mouseover", handleMouseOver )
                        .on( "mouseout", handleMouseOut );

                    function handleMouseOver( d, i ) {
                        if ( d3.select( this ).attr( 'class' ).indexOf( 'is-rising' ) >= 0 ) {
                            d3.select( this ).style( 'stroke', '#009900' );
                            $( ( d3.select( this )[ 0 ] )[ 0 ].nextElementSibling ).css( {
                                'stroke': '#009900',
                                'fill': '#009900'
                            } );
                        } else if ( d3.select( this ).attr( 'class' ).indexOf( 'is-falling' ) >= 0 ) {
                            d3.select( this ).style( 'stroke', '#990000' );
                            $( ( d3.select( this )[ 0 ] )[ 0 ].nextElementSibling ).css( {
                                'stroke': '#990000',
                                'fill': '#990000'
                            } );
                        }
                    };

                    function handleMouseOut( d, i ) {
                        d3.select( this ).style( 'stroke', 'transparent' );
                        $( ( d3.select( this )[ 0 ] )[ 0 ].nextElementSibling ).css( {
                            'stroke': 'transparent',
                            'fill': 'transparent'
                        } );
                    };
                };
            }
        }
    } );

'use strict';
angular
    .module( 'jigsawCorpLms' ).directive( 'libraryModuleTile', function( fetchData, $state, $timeout, $rootScope, DataCache ) {
        return {

            scope: {
                tileInfo: '=',
                index: '=',
                tilesInfo: '=',

            },
            templateUrl: 'app/Common/Directives/libraryTileModule/libraryModuleTile.html',
            link: function( scope, elem ) {
                var prevModLibIndex;
                fetchData.fetchPlaylistData().then( function( response ) {
                    scope.playlists = response.data.playlistData.userPlaylistData;
                } );
                scope.Tilestate = 'start';
                var prevOpenTile;
                scope.shwThreeMore = 3;

                var type;
                var tempArray = [];
                var j = 3;
                for ( var i = 0; i < 3; i++ ) {
                    tempArray[ i ] = ( scope.index + j ) / 3;

                    if ( tempArray[ i ] % 1 === 0 ) {
                        type = i;
                        switch ( type ) {
                            case 0:
                                scope.expandClass = 'first-tile-expand'
                                break;
                            case 1:
                                scope.expandClass = 'scnd-tile-expand'
                                break;
                            case 2:
                                scope.expandClass = 'thrd-tile-expand'
                                break;
                        }
                    }
                    j--;
                }

                scope.openTileOverlay = function() {
                    scope.shwOverlay = !scope.shwOverlay;
                };
                scope.openAddPlaylist = function() {
                    if ( scope.shwPlaylistItems ) {
                        scope.Tilestate = 'start';
                    } else {
                        scope.Tilestate = 'addToPlaylist';
                    }

                    scope.shwPlaylistItems = !scope.shwPlaylistItems
                };

                scope.addModuleToPlaylist = function( playlistID ) {
                    scope.Tilestate = 'start';
                    scope.shwOverlay = !scope.shwOverlay;
                    scope.shwPlaylistItems = !scope.shwPlaylistItems
                };
                scope.createPlaylist = function() {
                    scope.Tilestate = 'createPlaylist';
                };
                scope.closeCreatePlaylist = function() {
                    scope.shwOverlay = !scope.shwOverlay;
                    scope.Tilestate = 'start';

                };
                scope.closeAddPlaylist = function() {
                    scope.Tilestate = 'start';
                    scope.shwOverlay = !scope.shwOverlay;
                };

                scope.adjustHeightTab = function( index, isCliked ) {

                    var currentEle = elem[ 0 ].parentNode;

                    scope.resetHeight( type, index );
                    var i = 0;
                    if ( isCliked && screen.width > 1025 ) {
                        var expndELe = $( currentEle ).find( ".lib-cont-watching-wrp" );
                        var expndHeight = expndELe[ 0 ].clientHeight;
                        var addHeight = expndHeight + currentEle.clientHeight;
                        switch ( type ) {

                            case 0:
                                var j = index;
                                for ( i = 0; i < 3; i++ ) {
                                    if ( i == 0 ) {
                                        currentEle.style.height = addHeight + 'px';
                                    }
                                    if ( $( currentEle ).siblings()[ j ] ) {
                                        $( currentEle ).siblings()[ j ].style.height = addHeight + 'px';
                                    }
                                    j++
                                }
                                break;


                            case 1:
                                scope.expandClass = 'scnd-tile-expand'
                                var j = index - 1;
                                for ( i = 0; i < 2; i++ ) {
                                    if ( i == 0 ) {
                                        currentEle.style.height = addHeight + 'px';
                                    }

                                    if ( $( currentEle ).siblings()[ j ] ) {
                                        $( currentEle ).siblings()[ j ].style.height = addHeight + 'px';
                                    }

                                    j++

                                }
                                break;
                            case 2:
                                scope.expandClass = 'thrd-tile-expand'
                                var j = index - 2;

                                for ( i = 0; i < 2; i++ ) {
                                    if ( i == 0 ) {
                                        currentEle.style.height = addHeight + 'px';
                                    }
                                    if ( $( currentEle ).siblings()[ j ] ) {
                                        $( currentEle ).siblings()[ j ].style.height = addHeight + 'px';
                                    }

                                    j++
                                }
                                break;
                        }
                    } else if ( isCliked && screen.width < 1025 ) {
                        var expndELe = $( currentEle ).find( ".lib-cont-watching-wrp" );
                        var expndHeight = expndELe[ 0 ].clientHeight;
                        var addHeight = expndHeight + currentEle.clientHeight + 30;
                        currentEle.style.height = addHeight + 'px';
                    }
                };

                // Function resets the height of tile
                scope.resetHeight = function( type, index ) {
                    var i = 0;
                    var currentEle = elem[ 0 ].parentNode;
                    switch ( type ) {

                        case 0:
                            var j = index;
                            for ( i = 0; i < 3; i++ ) {
                                if ( i == 0 ) {
                                    currentEle.style.height = 'auto';
                                } else {
                                    if ( $( currentEle ).siblings()[ j ] ) {
                                        $( currentEle ).siblings()[ j ].style.height = 'auto';
                                    }
                                    j++
                                }
                            }
                            break;
                        case 1:
                            var j = index - 1;
                            for ( i = 0; i < 2; i++ ) {
                                if ( i == 0 ) {
                                    currentEle.style.height = 'auto';
                                }
                                if ( $( currentEle ).siblings()[ j ] ) {
                                    $( currentEle ).siblings()[ j ].style.height = 'auto';
                                }

                                j++

                            }
                            break;
                        case 2:

                            var j = index - 2;

                            for ( i = 0; i < 2; i++ ) {
                                if ( i == 0 ) {
                                    currentEle.style.height = 'auto';
                                }
                                if ( $( currentEle ).siblings()[ j ] ) {
                                    $( currentEle ).siblings()[ j ].style.height = 'auto';
                                }
                                j++
                            }
                            break;
                    }
                };
                // This Function Toggle the state of the tile ie Open and Close
                scope.toggleTileContent = function() {
                    scope.selectedModuleIndexLib = scope.index;
                    prevModLibIndex = scope.index;
                    scope.hideOtherTile( scope.tilesInfo );
                    setTimeout( function() {
                        scope.adjustHeightTab( scope.index, scope.tileInfo.isCliked );
                    }, 100 );
                };

                scope.hideOtherTile = function( tilesInfo ) {
                    for ( var i = 0; i < tilesInfo.length; i++ ) {
                        if ( i != scope.index ) {
                            tilesInfo[ i ].isCliked = false;
                        } else {
                            tilesInfo[ i ].isCliked = !tilesInfo[ i ].isCliked;
                        }
                    }

                };

                scope.openAddPlaylistVideo = function( video, index ) {
                    scope.currentVideoItem = index;
                    if ( prevOpenTile == index ) {
                        scope.shwVideoTileOpt = !scope.shwVideoTileOpt;
                    } else {
                        scope.shwVideoTileOpt = true;
                    }
                    prevOpenTile = index
                };
                scope.openAddPlaylistTile = function() {
                    scope.openTileOpt = !scope.openTileOpt;
                };
                scope.addVideoToPlaylist = function( playlist, video ) {
                    scope.openTileOpt = !scope.openTileOpt;
                    scope.shwVideoTileOpt = !scope.shwVideoTileOpt;
                };

                scope.createPlaylistTile = function() {
                    scope.toggleCreatePlaylist = !scope.toggleCreatePlaylist;
                };
                scope.closeCreatePlaylistTile = function() {
                    scope.toggleCreatePlaylist = !scope.toggleCreatePlaylist;
                    scope.openTileOpt = !scope.openTileOpt;
                    scope.shwVideoTileOpt = !scope.shwVideoTileOpt;
                };

                scope.goToLibVideo = function() {
                    $rootScope.modelParent.isFromLib = false;
                    DataCache.clearCache( 'thisModuleData' );
                    DataCache.saveGlobalData( 'thisModuleData', scope.tileInfo );
                    $state.go( "home.learn.video" );
                };

                scope.shwMoreContent = function( index ) {

                    var temp = scope.shwThreeMore + 3

                    if ( scope.tileInfo.module_resources.length < temp ) {
                        scope.shwThreeMore = scope.tileInfo.module_resources.length;
                    } else {
                        scope.shwThreeMore = temp;
                    }
                    setTimeout( function() {
                        scope.adjustHeightTab( scope.index, scope.tileInfo.isCliked );
                    }, 100 );


                };

                scope.shwLessContent = function( index ) {
                    scope.shwThreeMore = 3;
                    setTimeout( function() {
                        scope.adjustHeightTab( scope.index, scope.tileInfo.isCliked );
                    }, 100 );
                };

            }
        };

    } );

'use strict';
angular
    .module( 'jigsawCorpLms' ).directive( 'libraryTile', function( fetchData, $state, $timeout , $rootScope,DataCache) {
        return {

            scope: {
                tileInfo: '=',
                index: '=',
                tilesInfo: '=',

            },
            templateUrl: 'app/Common/Directives/libraryTile/libraryTile.html',
            link: function( scope, elem ) {
                var prevModLibIndex;
                fetchData.fetchPlaylistData().then(function(response){                   
                   scope.playlists = response.data.playlistData.userPlaylistData;
                });
                scope.Tilestate = 'start';
                var prevOpenTile;
                scope.shwThreeMore = 3;

                var type;
                var tempArray = [];
                var j = 3;
                for ( var i = 0; i < 3; i++ ) {
                    tempArray[ i ] = ( scope.index + j ) / 3;

                    if ( tempArray[ i ] % 1 === 0 ) {
                        type = i;
                        switch ( type ) {
                            case 0:
                                scope.expandClass = 'first-tile-expand'
                                break;
                            case 1:
                                scope.expandClass = 'scnd-tile-expand'
                                break;
                            case 2:
                                scope.expandClass = 'thrd-tile-expand'
                                break;
                        }
                    }
                    j--;
                }




                scope.openTileOverlay = function() {
                    scope.shwOverlay = !scope.shwOverlay;
                };
                scope.openAddPlaylist = function() {
                    if ( scope.shwPlaylistItems ) {
                        scope.Tilestate = 'start';
                    } else {
                        scope.Tilestate = 'addToPlaylist';
                    }

                    scope.shwPlaylistItems = !scope.shwPlaylistItems
                };

                scope.addModuleToPlaylist = function( playlistID ) {
                    scope.Tilestate = 'start';
                    scope.shwOverlay = !scope.shwOverlay;
                    scope.shwPlaylistItems = !scope.shwPlaylistItems
                };
                scope.createPlaylist = function() {
                    scope.Tilestate = 'createPlaylist';
                };
                scope.closeCreatePlaylist = function() {
                    scope.shwOverlay = !scope.shwOverlay;
                    scope.Tilestate = 'start';

                };
                scope.closeAddPlaylist = function() {
                    scope.Tilestate = 'start';
                    scope.shwOverlay = !scope.shwOverlay;

                };
   

                scope.adjustHeightTab = function( index, isCliked ) {

                    var currentEle = elem[ 0 ].parentNode;

                    scope.resetHeight( type, index );
                    var i = 0;
                    if ( isCliked && screen.width > 1025 ) {
                        var expndELe = $( currentEle ).find( ".lib-cont-watching-wrp" );
                        var expndHeight = expndELe[ 0 ].clientHeight;
                        var addHeight = expndHeight + currentEle.clientHeight;
                        switch ( type ) {

                            case 0:
                                var j = index;
                                for ( i = 0; i < 3; i++ ) {
                                    if ( i == 0 ) {
                                        currentEle.style.height = addHeight + 'px';
                                    }
                                    if ( $( currentEle ).siblings()[ j ] ) {
                                        $( currentEle ).siblings()[ j ].style.height = addHeight + 'px';
                                    }
                                    j++
                                }
                                break;


                            case 1:
                                scope.expandClass = 'scnd-tile-expand'
                                var j = index - 1;
                                for ( i = 0; i < 2; i++ ) {
                                    if ( i == 0 ) {
                                        currentEle.style.height = addHeight + 'px';
                                    }

                                    if ( $( currentEle ).siblings()[ j ] ) {
                                        $( currentEle ).siblings()[ j ].style.height = addHeight + 'px';
                                    }

                                    j++

                                }
                                break;
                            case 2:
                                scope.expandClass = 'thrd-tile-expand'
                                var j = index - 2;

                                for ( i = 0; i < 2; i++ ) {
                                    if ( i == 0 ) {
                                        currentEle.style.height = addHeight + 'px';
                                    }
                                    if ( $( currentEle ).siblings()[ j ] ) {
                                        $( currentEle ).siblings()[ j ].style.height = addHeight + 'px';
                                    }

                                    j++
                                }
                                break;
                        }
                    } else if ( isCliked && screen.width < 1025 ) {
                        var expndELe = $( currentEle ).find( ".lib-cont-watching-wrp" );
                        var expndHeight = expndELe[ 0 ].clientHeight;
                        var addHeight = expndHeight + currentEle.clientHeight + 30;
                        currentEle.style.height = addHeight + 'px';
                    }
                };

                // Function resets the height of tile
                scope.resetHeight = function( type, index ) {
                        var i = 0;
                        var currentEle = elem[ 0 ].parentNode;
                        switch ( type ) {

                            case 0:
                                var j = index;
                                for ( i = 0; i < 3; i++ ) {
                                    if ( i == 0 ) {
                                        currentEle.style.height = 'auto';
                                    } else {
                                        if ( $( currentEle ).siblings()[ j ] ) {
                                            $( currentEle ).siblings()[ j ].style.height = 'auto';
                                        }
                                        j++
                                    }
                                }
                                break;
                            case 1:
                                var j = index - 1;
                                for ( i = 0; i < 2; i++ ) {
                                    if ( i == 0 ) {
                                        currentEle.style.height = 'auto';
                                    }
                                    if ( $( currentEle ).siblings()[ j ] ) {
                                        $( currentEle ).siblings()[ j ].style.height = 'auto';
                                    }

                                    j++

                                }
                                break;
                            case 2:

                                var j = index - 2;

                                for ( i = 0; i < 2; i++ ) {
                                    if ( i == 0 ) {
                                        currentEle.style.height = 'auto';
                                    }
                                    if ( $( currentEle ).siblings()[ j ] ) {
                                        $( currentEle ).siblings()[ j ].style.height = 'auto';
                                    }
                                    j++
                                }
                                break;
                        }
                    }
                    // This Function Toggle the state of the tile ie Open and Close
                scope.toggleTileContent = function() {
                    scope.selectedModuleIndexLib = scope.index;
                    prevModLibIndex = scope.index;
                    scope.hideOtherTile( scope.tilesInfo );
                    setTimeout( function() {
                        scope.adjustHeightTab( scope.index, scope.tileInfo.isCliked );
                    }, 100 );
                }

                scope.hideOtherTile = function( tilesInfo ) {
                    for ( var i = 0; i < tilesInfo.length; i++ ) {
                        if ( i != scope.index ) {
                            tilesInfo[ i ].isCliked = false;
                        } else {
                            tilesInfo[ i ].isCliked = !tilesInfo[ i ].isCliked;
                        }
                    }

                };

                scope.openAddPlaylistVideo = function( video, index ) {
                    scope.currentVideoItem = index;
                    if ( prevOpenTile == index ) {
                        scope.shwVideoTileOpt = !scope.shwVideoTileOpt;
                    } else {
                        scope.shwVideoTileOpt = true;
                    }
                    prevOpenTile = index
                };
                scope.openAddPlaylistTile = function() {
                    scope.openTileOpt = !scope.openTileOpt;
                };
                scope.addVideoToPlaylist = function( playlist, video ) {
                    scope.openTileOpt = !scope.openTileOpt;
                    scope.shwVideoTileOpt = !scope.shwVideoTileOpt;
                };

                scope.createPlaylistTile = function() {
                    scope.toggleCreatePlaylist = !scope.toggleCreatePlaylist;
                };
                scope.closeCreatePlaylistTile = function() {
                    scope.toggleCreatePlaylist = !scope.toggleCreatePlaylist;
                    scope.openTileOpt = !scope.openTileOpt;
                    scope.shwVideoTileOpt = !scope.shwVideoTileOpt;
                };

                scope.goToLibVideo = function() {
                    $rootScope.modelParent.isFromLib = false;
                    DataCache.clearCache( 'thisModuleData' );
                    DataCache.saveGlobalData( 'thisModuleData', scope.tileInfo );
                    $state.go( "home.learn.video" );
                };

                scope.shwMoreContent = function( index ) {

                    var temp = scope.shwThreeMore + 3

                    if ( scope.tileInfo.module_resources.length < temp ) {
                        scope.shwThreeMore = scope.tileInfo.module_resources.length;
                    } else {
                        scope.shwThreeMore = temp;
                    }
                    setTimeout( function() {
                        scope.adjustHeightTab( scope.index, scope.tileInfo.isCliked );
                    }, 100 );


                };

                scope.shwLessContent = function( index ) {
                    scope.shwThreeMore = 3;
                    setTimeout( function() {
                        scope.adjustHeightTab( scope.index, scope.tileInfo.isCliked );
                    }, 100 );
                };

            }
        };

    } );

'use strict';
angular
    .module( 'jigsawCorpLms' )
    .directive( 'libPlaylist', function ( $rootScope, fetchData, $state, DataCache, $filter ) {
        return {
            restrict: 'E',

            templateUrl: 'app/Common/Directives/libPlaylist/libPlaylist.html',

            link: function ( scope ) {

                scope.openPlaylistModule = function ( videoIndex ) {
                    scope.openTilePlaylist = !scope.openTilePlaylist;
                    scope.crntPlyModule = videoIndex
                };
                scope.playlist = DataCache.returnData( 'thisPlaylist' );
            }
        }
    } );

'use strict';
( function() {
    angular
        .module( 'jigsawCorpLms' )
        .directive( 'header', [ '$rootScope','$window', 'fetchData', '$timeout','DataCache','FirebaseService','$firebaseObject','$http','$state','$cookies', '$anchorScroll', function( $rootScope,$window, fetchData, $timeout, DataCache,FirebaseService,$firebaseObject,$http,$state,$cookies, $anchorScroll ) {
            return {
                restrict: 'E',
                templateUrl: 'app/Common/Directives/header/header.html',
                link: function( scope ) {


                    //DataCache.loadFromWebstorage();

                    fetchData.fetchProfileData().then( function( response )
                    {
                        // update avatar level
                        scope.avatar =  $rootScope.baseimageurl+'/avatars/1/'+response.data.profile.profilePhotoUrl;
                        angular.element($(".scnd-hdr-userimg")).css("background","rgba(0, 0, 0, 0) url('"+scope.avatar+"') scroll 0px 0px / 100% 100% padding-box border-box");

                        var userFirstName = response.data.profile.firstname;

                        DataCache.saveGlobalData("userFirstName", userFirstName);
                        scope.updateLpMessage();
                    } );

                    scope.authData = DataCache.returnData("userData");
                    scope.lab = scope.authData.labNeeded;
                    //console.log(scope.lab);
                    $http.defaults.headers.common['Authorization'] = "Bearer "+scope.authData.jwttoken;
                    // $scope.idToken = DataCache.returnData("idToken");
                    // //console.log($scope.idToken);
                    //$http.defaults.headers.common['Authorization'] = "Bearer " + $scope.idToken;
                    $http.defaults.headers.common['Content-Type'] = "application/x-www-form-urlencoded";

                    $rootScope.modelParent.isPopOutViewActive = false;
                    $rootScope.modelParent.bringInPopOut = false;

                    scope.parentObj = {};
                    scope.scndhdrstate = false;
                    scope.libLearnpathstate = false;
                    scope.learnArrow = true;
                    scope.libArrow = false;
                    $rootScope.moduleHeader = true;
                    $rootScope.dashArrow = true;
                    scope.libActive = false;

                    var user_data=DataCache.returnData( 'userData' );
                    var userNotifications;
                    var notificationCount = 0;


                    scope.showLearnerProfile=function(){
                    $rootScope.scndHdr = false;
                    $state.go('home.progressInfoPage')
                    .then(function() {
                        $rootScope.$broadcast('profile');
                    })
                    
                    
                }
                
                scope.showAllLps = function() {
                    $state.go('home.allLps')
                    .then(function() {
                        $rootScope.$broadcast('allLps');
                    })
                    }
                    scope.expndProgressbar = function() {
                        scope.scndhdrstate = !scope.scndhdrstate;
                        scope.isClicked = true;
                    };




                    scope.toggleLearningPath = function() {
                        if ( $rootScope.modelParent.currentState === 'home.dashboard' ) {
                            return;
                        }
                        scope.libLearnpathstate = false;
                        scope.learnArrow = true;
                        scope.libArrow = false;
                        //scope.goToPrevState();
                        $rootScope.$broadcast( 'triggerDashboardState' );
                    };
                    scope.toggleLibrary = function() {
                        scope.scndhdrstate = false;
                        scope.learnArrow = false;
                        scope.libArrow = true;
                        scope.libLearnpathstate = true;
                        scope.goToLibrary();
                    };

                     scope.toggleLab = function() {
                        scope.scndhdrstate = false;
                        scope.learnArrow = false;
                        scope.libArrow = true;
                        scope.libLearnpathstate = true;
                        
                        scope.goToLab();
                    };

                    scope.learnerLogoutFunc=function(){
                      $rootScope.$broadcast('logout-popout-initiated');
                    };

                    var user;
                    if(scope.authData.hasOwnProperty('auth')){
                      user=scope.authData.auth.role;
                    }else{
                        user=scope.authData.role;
                    }
                    if(user === 'Learner'){

                      scope.summary = DataCache.returnData('summary');
                      scope.modulesData = scope.summary;
                      scope.lpAttr = DataCache.returnData("lpAttr");
                      scope.expectedCompletion = scope.lpAttr.expectedCompletionPerct;

                    }
                    scope.onGoingLp = DataCache.returnLpData("active");
                    // scope.CurrentLpTitle = scope.onGoingLp.summary.title;
                    scope.showCurrentLp = function () {
                        if (DataCache.returnLpData('currentLp') !== 'active') {
                            $rootScope.goToCurrentLp()
                            .then(function () {
                                if ($state.current.name === "home.dashboard") {
                                    $state.reload();
                                }else {
                                    $state.go("home.dashboard");
                                }
                            })
                        }else {
                            $state.go("home.dashboard");
                        }
                    };
                    $rootScope.goToCurrentLp = function () {
                        return new Promise(function (resolve,reject) {
                            var currentLp = DataCache.returnLpData('currentLp')
                        if (currentLp === 'active') {
                            resolve()
                        } else {
                            var uid = DataCache.returnData('uid')
                            var lpId = DataCache.returnData('lpid');
                            var ref = FirebaseService.ref
                            .child('/lp')
                            .child(uid)
                            .child(lpId);
                            ref.once('value', function (dataSnapshot) {
                                var mainObj = dataSnapshot.val();
                                DataCache.saveLpDetails('currentLp', 'active')
                                DataCache.saveGlobalData('details', mainObj.details);
                                $window.setData(mainObj)
                                // $state.go('home.dashboard')
                                // $state.reload()
                                resolve()
                            })
                        }
                        })
                    }
                    scope.libActivefunc = function() {
                        scope.libActive = !scope.libActive;
                    };
                    scope.goToInactiveState = function() {
                        if ( scope.activeState == 'Learning Path' ) {
                            scope.goToLibrary();
                            scope.activeState = 'Library';
                            scope.inactiveState = 'Learning Path';

                        } else {
                            scope.activeState = 'Learning Path';
                            scope.inactiveState = 'Library';
                            //scope.goToPrevState();
                            $rootScope.$broadcast( 'triggerDashboardState' );
                        }
                        scope.libActivefunc();
                    };


                    scope.bookmarksClicked = function() {
                        $rootScope.modelParent.isBookmarksActive = true;
                        $rootScope.modelParent.bringInBookmarks = true;
                    };
                    scope.notificationsClicked = function() {
                        $rootScope.modelParent.isNotificationsListActive = true;
                        $rootScope.modelParent.bringInNotifications = true;

                    };
                    scope.feedbackClicked = function() {
                        $rootScope.modelParent.isFeedbackViewActive = true;
                        $rootScope.modelParent.bringInFeedback = true;
                    };
                    scope.overviewClicked = function(){
                        $rootScope.goToCurrentLp()
                        .then(function () {
                            $state.go('welcome');
                        })
                    }

                    scope.certificatesClicked = function() {
                        $rootScope.certificateScroll = true;
                        $rootScope.goToCurrentLp()
                        .then(function () {
                            if($state.current.name === 'home.progressInfoPage'){
                                $state.reload();
                            } else {
                                $state.go('home.progressInfoPage');
                            }
                        })
                    }

                    scope.dashboardClicked = function() {
                        scope.showCurrentLp();
                        // $state.go('home.dashboard');

                    }



                    scope.updateLpMessage = function(){

                      if(user === 'Learner'){

                        // Learner Dynamic messages
                        var firstTimeLearnerMessage = "Today is a great day to learn something new. Welcome _name!";
                        var onTrackLearnerMessages = [
                          "You're making it look easy, _name. Great pace!",
                          "You're on a roll, _name! Keep up the pace.",
                          "Every day is a good day when you learn."
                        ];
                        var offTrackLearnerMessages = [
                          "It's tough. But you're tougher. You can do it, _name.",
                          "Time to pick up the pace, _name.",
                          "All it takes is all you got. Come on  _name, you can do it."
                        ];

                            var userFirstName = DataCache.returnData("userFirstName");


                            if ( $rootScope.firstTimeLogin )
                            {
                                scope.lpAttr.lpProgressMessage = firstTimeLearnerMessage.replace("_name", userFirstName);
                            }
                            else
                            {
                                if ((scope.lpAttr.actualProgress >= scope.lpAttr.expectedCompletionPerct || scope.lpAttr.expectedCompletionPerct - scope.lpAttr.actualProgress <= 20) && scope.lpAttr.actualProgress != 100)
                                {
                                    var randomMessageNo = Math.floor((Math.random() * 3) + 1);
                                    var message = onTrackLearnerMessages[randomMessageNo-1];
                                    scope.lpAttr.lpProgressMessage = message.replace("_name", userFirstName);
                                    if(scope.lpAttr.actualProgress >= scope.lpAttr.expectedCompletionPerct){
                                      scope.lpAttr.trackProgressMessage = "You are " + (scope.lpAttr.actualProgress - scope.lpAttr.expectedCompletionPerct) + "% ahead of schedule";
                                    } else{
                                      scope.lpAttr.trackProgressMessage = "You should be at " + scope.lpAttr.expectedCompletionPerct +"%";
                                    }
                                    if (scope.lpAttr.expectedCompletionPerct - scope.lpAttr.actualProgress <= 20) {
                                      scope.lpAttr.lpProgressMessage = firstTimeLearnerMessage.replace("_name", userFirstName);
                                    };
                                }
                                else if (scope.lpAttr.expectedCompletionPerct - scope.lpAttr.actualProgress > 20)
                                {
                                  var randomMessageNo = Math.floor((Math.random() * 3) + 1);
                                  var message = offTrackLearnerMessages[randomMessageNo-1];
                                  scope.lpAttr.lpProgressMessage = message.replace("_name", userFirstName);
                                  scope.lpAttr.trackProgressMessage = "You should be at " + scope.lpAttr.expectedCompletionPerct +"%";
                                }
                                else if (scope.lpAttr.actualProgress === 100)
                                {
                                  scope.lpAttr.lpProgressMessage = "Congratulations!! you have completed this course";
                                  scope.lpAttr.trackProgressMessage = "100% completed";
                                }
                            }


                      }
                    }















                      if(user === 'Learner'){
                        var ref = FirebaseService.ref.child("notifications").child(user_data.uid);
                        var obj = $firebaseObject(ref);

                        var unviewedList=[];
                        var unreadList=[];
                        var notificationTray=[];

                        ref.orderByChild('timestamp').once('value', function(newvalue){

                            var viewedNotifications=newvalue.val();
                            var updatedCount=0;
                            DataCache.saveGlobalData("userNotifications", viewedNotifications);

                        });

                        ref.orderByChild('timestamp').on('child_added', function(childSnapshot, prevChildKey) {

                             userNotifications= childSnapshot.val();
                             if(userNotifications.read == false){
                                 unreadList.push(childSnapshot.key);
                             }
                             if(userNotifications.view == false){
                                 unviewedList.push(childSnapshot.key);
                                 notificationCount++;

                             }
                             notificationTray.push(userNotifications);
                             $rootScope.notificationCount=notificationCount;

                             DataCache.saveGlobalData("userNotifications", notificationTray);
                             DataCache.saveGlobalData("userNotificationsCount", $rootScope.notificationCount);

                        });

                      }








                       var vCount=0;
                       scope.updateNotify=function(param)
                       {
                           $rootScope.notificationCount=0;
                           var viewedlist = {};
                            
                            if(param == 'view')
                           {
                             if(scope.modelParent.bringInNotifications)
                             {
                              $(".parent-ui-view").css({
                                'overflow-y': 'hidden'
                              });
                              vCount++;
                               for(var key in unviewedList)
                               {
                                   var key = unviewedList[key];
                                   viewedlist [ key ] = "";
                               }
                               //
                              var data = { "notificationsIds": viewedlist , "attr" : "view" };
                              fetchData.updateNotify(data).then(function(response){
                                ref.orderByChild('timestamp').once('value', function(newvalue){

                                    var viewedNotifications=newvalue.val();
                                    var updatedCount=0;
                                    DataCache.saveGlobalData("userNotifications", viewedNotifications);
                                });


                                if(vCount == 2){
                                  DataCache.saveGlobalData("userNotificationsCount", $rootScope.notificationCount);
                                  notificationCount=0;
                                    vCount=0;

                                }

                              });
                            } else if (scope.modelParent.bringInNotifications === false) {
                                $(".parent-ui-view").css({
                                  'overflow-y': 'auto'
                                });
                            };
                            }
                            else if (param == 'readAll')
                            {
                              var readlist= {};

                              for(var key in unreadList)
                              {
                                  var key=unreadList[key];
                                  readlist[key] = "";
                              }



                               var data = { "notificationsIds": readlist, "attr":"read" };

                               fetchData.updateNotify(data).then(function(response)
                               {

                                  var ref1 = FirebaseService.ref.child("notifications").child(user_data.uid);
                                  var obj = $firebaseObject(ref1);
                                  $timeout(function(){
                                      ref1.orderByChild('timestamp').once('value', function(newvalue){

                                          var viewedNotifications=newvalue.val();
                                          var updatedCount=0;
                                          DataCache.saveGlobalData("userNotifications", viewedNotifications);
                                          DataCache.saveGlobalData("userNotificationsCount", updatedCount);
                                      });
                                  },200);
                                  var updatedList=[];
                                  var updatedNotifications=[];

                                  for(var i=0;i<notificationTray.length;i++){

                                      if(notificationTray[i].read == false){
                                          notificationTray[i].read=true;
                                      }

                                  }

                               });
                            }
                            else if (param == 'readSelected')
                            {

                                var readlist= {};
                                var ele=scope.activeEle;
                                var data="";
                                var key=unreadList[ele];
                                    if(key != undefined){
                                      readlist[key] = "";
                                      data = { "notificationsIds": readlist, "attr":"read" };
                                    }

                               fetchData.updateNotify(data).then(function(response)
                               {

                                  var ref1 = FirebaseService.ref.child("notifications").child(user_data.uid);
                                  var obj = $firebaseObject(ref1);
                                  $timeout(function(){
                                      ref1.orderByChild('timestamp').once('value', function(newvalue){

                                          var viewedNotifications=newvalue.val();
                                          var updatedCount=0;
                                          DataCache.saveGlobalData("userNotifications", viewedNotifications);
                                          DataCache.saveGlobalData("userNotificationsCount", updatedCount);
                                      });
                                  },200);
                                  var updatedList=[];
                                  var updatedNotifications=[];

                                      if(notificationTray[ele].read == false){
                                          notificationTray[ele].read=true;
                                      }
                               });
                            }
                          }

                      $rootScope.$on('all-read',function(){
                          $rootScope.notificationCount=0;
                          scope.updateNotify("readAll");
                      });

                      $rootScope.$on('read-selected',function(events,args){
                          //$rootScope.notificationCount=0;
                          scope.activeEle=args;
                          scope.updateNotify("readSelected");
                      });

                      $rootScope.$on('progress-updated',function(){
                        //
                        //
                        scope.lpAttr = DataCache.returnData("lpAttr");
                        scope.updateLpMessage();
                        scope.summary = DataCache.returnData('summary');
                        scope.modulesData = scope.summary;
                        // scope.showProgress();
                      });

                      scope.showProgress=function(){
                          $rootScope.scndHdr = false;
                          $rootScope.goToCurrentLp()
                          .then(function () {
                              return $state.go('home.progressInfoPage')
                          })
                          .then( function () {
                              $rootScope.$broadcast('progress');
                          })
                        //   $state.go('home.progressInfoPage');
                        //   $timeout(function(){
                        //   },10);
                      };

                      if ( $rootScope.modelParent.currentState !== 'home.library' ) {
                          scope.activeState = 'Learning Path';
                          scope.inactiveState = 'Library';
                      } else {
                          scope.activeState = 'Library';
                          scope.inactiveState = 'Learning Path';

                      }







                    scope.applySchema = function() {
                        // console.log(,"domNode");
                        var node = document.getElementById( 'rhombusProfileImage' )
                        if (node) {
                            var maskew = new Maskew( document.getElementById( 'rhombusProfileImage' ), 28 );
                        }
                    };


                    //var gAuth=FirebaseService.ref.getAuth();
                    var gAuth = scope.authData;
                    var multiLoginref = FirebaseService.ref.child("login").child(gAuth.uid);
                    var obj1 = $firebaseObject(multiLoginref);

                    var unwatch = obj1.$watch(function()
                    {
                          multiLoginref.on('child_changed', function(childSnapshot, prevChildKey) {
                            var changedPost = childSnapshot.val();
                            var prevKey=DataCache.returnData('loginId');
                            if(DataCache.returnData('loginId') !== undefined){
                                if(changedPost !=  prevKey){
                                  DataCache.clearAll();
                                  $cookies.remove('userDetails');
                                  $state.go('login');
                                }
                            }

                          //  $scope.setData(changedPost);
                        });
                    });



                    $timeout( function() {
                        scope.applySchema();
                    }, 100 );

                    scope.helpClicked = function() {
                        scope.openHelp();

                    };

                    scope.initiateLogOut = function() {
                        $rootScope.$broadcast( 'logout-initiated' );
                    };



                    scope.usrImage = function() {
                        return {
                            'background-image': 'url(' + $rootScope.modelParent.userImage + ')'
                        }
                    }
                    scope.prevLpData = {}
                    scope.isActiveLp = function () {
                        var currentLp = DataCache.returnLpData('currentLp')
                        return currentLp === 'active';
                    }

                    scope.certificateStatus = 0
                    scope.NoOfSkillCertificates = 0
                    var LpId = DataCache.returnLpData('currentLp')
                    scope.prevLpData = LpId !== 'active' ? DataCache.returnLpData(DataCache.returnLpData('currentLp') + 'bkp') : { }
                    if (user === 'Learner') { // the below variables are always undefined of undefined for manager and thus cause an error
                    // if (scope.prevLpData && scope.prevLpData.summary) {
                        scope.currentLpTitle = DataCache.returnLpData('active').summary.title
                        scope.prevLpData = scope.prevLpData.summary ? scope.prevLpData.summary : { };
                        scope.NoOfSkillCertificates = scope.prevLpData.modules?scope.prevLpData.modules.filter(function(module) {
                                return module.actualStartTime !== ""
                        }).length:0
                        scope.lpCertificates = scope.prevLpData.status === 'Completed' ? 1 : 0;
                    // }
                    }

                    $rootScope.$on('progress-updated', function () {
                        // console.log('from header')
                        var LpId = DataCache.returnLpData('currentLp')
                        scope.prevLpData = LpId !== 'active' ? DataCache.returnLpData(DataCache.returnLpData('currentLp') + 'bkp') : { }
                        scope.prevLpData = scope.prevLpData.summary ? scope.prevLpData.summary : { };
                        console.log('prevLPdata',DataCache.returnLpData('currentLp'),scope.prevLpData)
                        scope.NoOfSkillCertificates = scope.prevLpData.modules ? scope.prevLpData.modules.filter(function(module) {
                            return module.actualStartTime !== ""
                        }).length : 0
                        scope.lpCertificates = scope.prevLpData.status === 'Completed' ? 1 : 0;
                    })
                    scope.formatTime = function (time) {
                        return moment(time).format('LL')
                    }

                }
            }
        } ] );

} )();
'use strict';
(function() {
    angular
        .module('jigsawCorpLms')
        .directive('bheader', ['$rootScope', 'fetchData', '$timeout', 'DataCache', '$state', function($rootScope, fetchData, $timeout, $cookies, $state, DataCache) {
            return {
                restrict: 'E',
                templateUrl: 'app/Common/Directives/header/bheader.html',
                link: function(scope) {

                    scope.parentObj = {};
                    scope.scndhdrstate = false;
                    scope.libLearnpathstate = false;
                    scope.learnArrow = true;
                    scope.libArrow = false;
                    $rootScope.moduleHeader = false;
                    $rootScope.dashArrow = true;
                    scope.expectedCompletion = 63;
                    scope.libActive = false;

                    scope.libActivefunc = function() {
                        scope.libActive = !scope.libActive;
                    };

                    scope.logoutFunc = function() {
                        $rootScope.$broadcast('logout-popout-initiated');
                    }
                    scope.showProfile = function() {
                        $rootScope.$broadcast('buyers-profile');
                    }

                    scope.approvalPopOut = function() {
                        $rootScope.modelParent.isPopOutViewActive = true;
                        $rootScope.modelParent.bringInPopOut = true;
                    };
                    scope.buyerFeedbackClicked = function() {
                        scope.buyerfeedback();
                    };


                    scope.buyerHelpClicked = function() {
                        scope.openHelp();
                    };
                }
            }
        }]);

})();
'use strict';
angular
    .module('jigsawCorpLms')
    .directive('errorScreen', function($rootScope) {
        return {
            restrict: 'E',
            templateUrl: 'app/Common/Directives/errorScreen/errorScreen.html',
            link: function(scope) {
                scope.initiateLogOut = function() {
                    $rootScope.$broadcast('logout-initiated');
                    return;
                };
                scope.goBackToNormalState = function() {
                    /*
                     * With an assumption that any service failure will
                     * Force user to navigate back to previous state.
                     * This can be changed.
                     */
                    var stateToNavigate =
                        ($rootScope.modelParent.previousState !== '' &&
                            $rootScope.modelParent.previousState) ? $rootScope.modelParent.previousState : scope.initiateLogOut();
                    $rootScope.$broadcast('navigateAfterErrorOccurs', stateToNavigate);
                }
            }
        }
    });
'use strict';
angular
    .module( 'jigsawCorpLms' )
    .directive( 'skillDonutChart', function() {
        return {
            restrict: 'E',
            scope: {
                chartdata: '=',
                mode: '='
            },
            link: function( scope, element, attrs ) {
                scope.$watch( 'chartdata', function( newValue, oldValue ) {
                    if ( newValue )
                        scope.createChart();
                }, true );

                scope.createChart = function() {

					var margin = {
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0
                    };

					if ( scope.mode == 'monthly' ) {
                        var data = scope.chartdata;
                    }
					//$(sel + " svg").remove();
					// compute total

					var tot = 0;
          var pos = 0;
					data.forEach(function(e){
            tot += e.learners;
          });

					var w = $('.graph-wrp').width();
					var h = 100 - margin.top - margin.bottom;
					var r = Math.min(w, h);

					var color = d3.scale.category20b();
          var ele=".graph-wrp";
					var vis = d3.select(element[0])
								.append("svg:svg")
                .attr("data-chart-context",ele)
								.data([data])
                .attr( "width", '100%' )
                .attr( "height", '100%' )
								.append("svg:g")
								.attr("transform", "translate(" + (w / 2) + "," + r + ")");

                var svgParent = d3.select("svg[data-chart-context='" + ele + "']");
          var pie = d3.layout.pie().value(function(d){
                    return d.learners;
                  });

          var arc = d3.svg.arc()
                      .outerRadius(r)
                      .innerRadius(r - 30);

          var arcs = vis.selectAll("g.slice")
                        .data(pie)
                        .enter()
                        .append("svg:g")
                        .attr("class","slice");

          arcs.append("svg:path")
              .attr("fill", function(d, i) {
              			return color(i);
              })
              .attr("stroke", "#fff")
              .attr("stroke-width", "1")
              .attr("d", function(d) {
              				return arc(d);
              })
              .attr("data-legend",function(d) {
                return d.data.skills; })
              .classed("slice",true)
              .on("mouseover",function(e){
                  $(this)
                  .attr("fill-opacity", ".8")
              	   .css({"stroke": "green", "stroke-width": "1px"});
                })
              .on("mouseout",function(e){
              		$(this)
              		.attr("fill-opacity", "1")
              		.css({"stroke-width": "0px"});
              	})
                .attr("style","cursor:pointer;")
                .append("svg:title")
              	 .text(function(d) {
              	      return d.data.skills;
              	     });


              arcs.append("svg:text").attr("transform", function(d){
       						d.innerRadius = 0;
       						d.outerRadius = r;
       						return "translate(" + arc.centroid(d) + ")";})
                    .attr("text-anchor", "middle")
                    .text( function(d, i) {
       						return (data[i].learners );
       						}
       					).attr("fill","#fff")
       					.classed("slice-label",true);

              //  var legendData=


            var legend1=d3.select(element[0]).append("foreignObject")
                  .attr('width', r+50)
                  .attr('height', '100%')
                  .attr('x', 0)
                  .append('xhtml:div').style('height','90%').style('width','37%')
                  .style("position","relative")
                  .style("bottom","220px")
                  .style("left","285px")
                  .style("overflow-y","auto")
                  .style("overflow-x","auto")


              var legend = legend1.append("svg")
                            .attr("class", "legend")
                            .attr("width", "100%")
                            .attr("height", '350')
                            .selectAll("g")
                            .data(data)
                            .enter().append("g")
                            .attr("transform", function(d, i) { return "translate(0," + i * 30 + ")"; });

              legend.append("rect")
                  .attr("width", 13)
                  .attr("height", 13)
                  .style("fill", function(d, i) { return color(i); });

              legend.append("text")
                  .attr("x", 24)
                  .attr("y", 9)
                  .attr("dy", ".35em")
                  .text(function(d) {
                    return d.skills; });

				}
            }
        }
    } );

'use strict';
angular
    .module( 'jigsawCorpLms' )
    .directive( 'donutChart', function() {
        return {
            restrict: 'E',
            scope: {
                data: '='
            },
            link: function( scope, element, attrs ) {
                var dataset = {
                    progress: [ scope.data.onTrackPerc, scope.data.behindTrackPerc, scope.data.notStartedPerc ]
                };

                var width = 240,
                    height = 240,
                    radius = Math.min( (width, height )-40) / 2;
                var color = [ "#4bb056", "#fdc128","#cc141f" ];

                var pie = d3.layout.pie()
                    .sort( null );

                var arc = d3.svg.arc()
                    .innerRadius( radius - 30 )
                    .outerRadius( radius - 50 );

                var svg = d3.select( element[ 0 ] ).append( "svg" )
                    .attr( "width", width )
                    .attr( "height", height )
                    .append( "g" )
                    .attr( "transform", "translate(" + width / 2 + "," + height / 2 + ")" )
                    .attr( "fill", "#ffffff" );

                var path = svg.selectAll( "path" )
                    .data( pie( dataset.progress ) )
                    .enter()
                    .append( "path" )
                    .attr( "fill", function( d, i ) {
                        return color[ i ];
                    } )
                    .attr( "d", arc );

                var g = svg.selectAll( 'arc' )
                    .data( pie( dataset.progress ) )
                    .enter().append( 'g' )
                    .attr( 'class', 'arc' );

                // g.append( 'path' )
                //     .attr( 'transform', function( d ) { //set the label's origin to the center of the arc
                //         //we have to make sure to set these before calling arc.centroid
                //         d.innerRadius = 0;
                //         d.outerRadius = radius;
                //         return 'translate(' + arc.centroid( d ) + ')';
                //     } );


                g.append( 'text' )
                    .attr( 'transform', function( d ) {
                        // return 'translate(' + arc.centroid( d ) + ')';
                        var c = arc.centroid( d );
                        var xPos = c[ 0 ] * 1.4;
                        var yPos = c[ 1 ] * 1.5;
                        if ( parseFloat( c[ 0 ] ) < 0 ) {
                            xPos = xPos - 20;
                        }
                        return "translate(" + xPos + "," + yPos + ")";
                    } )
                    .attr( 'dy', '.15em' )
                    .attr( 'dx', '-0.3em' )
                    .style( 'fill', '#333333' )
                    .text( function( d ) {
                      if(d.data !== 0){
                        return d.data + '%';
                      }
                    } );

            }
        }
    } );

'use strict';
(function() {
    angular
        .module('jigsawCorpLms')
        .directive('buyersProficiencyProgressBar', [ '$filter', function($filter) {
            return {
                restrict: 'E',
                scope: {
                    totalTests: '=',
                    testsTaken: '='
                },
                templateUrl: 'app/Common/Directives/buyers_proficiency_progress_bar/buyers_proficiency_progress_bar.html',
                link: function(scope, elem, attrs) {


                }
            }
        }  ] );

})();

'use strict';
(function() {
    angular
        .module('jigsawCorpLms')
        .directive('buyersPrimaryProgressBar', [ function() {
            return {
                restrict: 'E',
                scope: {
                    proposedCompletion: '=proposedCompletion',
                    actualCompletion: '=actualCompletion',
                    expectedCompletion:'=expectedCompletion',
                },
                templateUrl: 'app/Common/Directives/buyers_primary_progress_bar/buyers_primary_progress_bar.html',
                link: function(scope) {
                    scope.changePropseWidth = function() {

                        return { width: scope.proposedCompletion + '%' }
                    };
                    scope.changeActualWidth = function() {
                        return { width: scope.actualCompletion + '%' }

                    }
                    scope.expctedWidth = function() {
                         return { width: scope.expectedCompletion + '%' }
                    }
                }



            }
        } ]);

})();

'use strict';
angular
    .module( 'jigsawCorpLms' )
    .directive( 'verticalBarChart', function() {
        return {
            restrict: 'E',
            scope: {
                chartdata: '=',
                mode: '='
            },
            link: function( scope, element, attrs ) {
                scope.$watch( 'mode', function( newValue, oldValue ) {
                    if ( newValue )
                        scope.createChart();
                }, true );

                d3.select(window).on('resize', function() {
                    scope.createChart();
                });

                scope.createChart = function() {
                    d3.selectAll( "#bskills-section svg" ).remove();
                    var margin = {
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0
                    };

              		 if ( scope.mode == 'monthly' ) {
                        var cdata = scope.chartdata.learningSkills;
                    }/* else if ( scope.mode == 'quaterly' ) {
                        var data = scope.chartdata.quaterlyPurchase;
                    } else if ( scope.mode == 'yearly' ) {
                        var data = scope.chartdata.yearlyPurchase;
                    };*/

                    var data = [];

                    for(var i=0;i<cdata.length;i++){
                      var title;
                      if(cdata[i].skillCount > 0){
                        if(cdata[i].hasOwnProperty("lpTitle")){
                          title=cdata[i].lpTitle;
                          data.push([title,cdata[i].skillCount])
                        }else{
                          title=cdata[i].teamName;
                            data.push([title,cdata[i].skillCount])
                        }

                      }

                    }


                    var height = 100 - margin.top - margin.bottom;
                    var axisMargin = 20,
                    margin = 20,
                    valueMargin = 4,
                    width = $( '.graph-wrp' ).width(),
                    barHeight = (height-axisMargin-margin*2)* 0.8/data.length,
                    barPadding = (height-axisMargin-margin*1)*0.8/data.length,
                    bar, svg, scale, xAxis, labelWidth = 0;

                    var max = d3.max(data.map(function(i){
                          return i[1];
                        }));

                        svg = d3.select(element[ 0 ])
                          .append("svg")
                          .attr("width", '100%')
                          .attr("height", '100%');


                        bar = svg.selectAll("g")
                          .data(data)
                          .enter()
                          .append("g");

                        bar.attr("class", "bar")
                          .attr("cx",0)
                          .attr("transform", function(d, i) {
                             return "translate(" + 0 + "," + (i * (barHeight + barPadding) + barPadding) + ")";
                          });

                        bar.append("text")
                          .attr("class", "label")
                          .attr("y", barHeight / 2)
                          .attr("dy", ".35em") //vertical align middle
                          .text(function(d){
                            return d[0];
                          }).each(function() {
                            labelWidth = Math.ceil(Math.max(labelWidth, this.getBBox().width)+15);
                          });

                        scale = d3.scale.linear()
                          .domain([0, max])
                          .range([0, width - margin*2 - labelWidth]);

                      //  xAxis = d3.svg.axis();
                        var labelText;
                        bar.append("rect")
                          .attr("transform", "translate("+labelWidth+", 0)")
                          .attr("height", barHeight)
                          .attr("width", function(d){
                            return scale(d[1]);
                          });

                        bar.append("text")
                          .attr("class", "value")
                          .attr("y", barHeight / 2)
                          .attr("dx", -valueMargin + labelWidth+15) //margin right
                          .attr("dy", ".35em") //vertical align middle
                          .attr("text-anchor", "end")
                          .text(function(d){
                            return d[1];
                          })
                         .attr("x", function(d){
                            var width = this.getBBox().width;
                            return Math.max(width + valueMargin, scale(d[1]));
                          });

                        svg.insert("g",":first-child")
                         .attr("class", "axis")
                         .attr("transform", "translate(" + (margin + labelWidth) + ","+ (height - axisMargin - margin)+")");
                         //.call(xAxis);

}
            }
        }
    } );

'use strict';
angular
    .module( 'jigsawCorpLms' )
    .directive( 'skillBarChart', function() {
        return {
            restrict: 'E',
            scope: {
                chartdata: '=',
                mode: '='
            },
            link: function( scope, element, attrs ) {
                scope.$watch( 'chartdata', function( newValue, oldValue ) {
                    if ( newValue )
                        scope.createChart();
                }, true );
                scope.createChart = function() {
                    var margin = {
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0
                    };

                    var width = $( '.graph-wrp' ).width(),
                        height = 100 - margin.top - margin.bottom;


                    var svg = d3.select( element[ 0 ] )
                        .append( "svg" )
                        .attr( "width", '100%' )
                        .attr( "height", '100%' )
                        .append( "g" )
                        .attr( "transform", "translate(" + 2 + "," + 50 + ")" );

                    if ( scope.mode == 'monthly' ) {
                        var data = scope.chartdata;
                    }/* else if ( scope.mode == 'quaterly' ) {
                        var data = scope.chartdata.quaterlyPurchase;
                    } else if ( scope.mode == 'yearly' ) {
                        var data = scope.chartdata.yearlyPurchase;
                    };*/

                    // Transpose the data into layers
                    var dataset = d3.layout.stack()( [ "percentage"].map( function( stacked ) {
                        return data.map( function( d ) {
                            var name;
                            var lcount=d.learners;
                            if(d.hasOwnProperty("skills")){
                              name=d.skills;
                            }else{
                              name=d.skills;
                            }
                            return {
                                x: name,
                                y: +d[ stacked ],
                                x1:lcount
                            };
                        } );
                    } ) );


                    // Set x, y and colors
                    var x = d3.scale.ordinal()
                        .domain( dataset[ 0 ].map( function( d ) {
                            return d.x;
                        } ) )
                        .rangeRoundBands( [ 0, width + 130 ], 0.75 );

                    var y = d3.scale.linear()
                        .domain( [ 0, d3.max( dataset, function( d ) {
                            return d3.max( d, function( d ) {
                                return d.y0 + d.y;
                            } );
                        } ) ] )
                        .range( [ height, 0 ] );

                    var colors = [ "#90cc79"];

                    var xAxis = d3.svg.axis()
                        .scale( x )
                        .orient( "bottom" );

                    svg.append( "g" )
                        .attr( "class", "x axis" )
                        .attr( "transform", "translate(0," + height + ")" )
                        .call( xAxis );

                    // Create groups for each series, rects for each segment
                    var groups = svg.selectAll( "g.cost" )
                        .data( dataset )
                        .enter().append( "g" )
                        .attr( "class", "cost" )
                        .style( "fill", function( d, i ) {
                            return colors[ i ];
                        } );

                    var rect = groups.selectAll( "rect" )
                        .data( function( d ) {
                            return d;
                        } )
                        .enter()
                        .append( "rect" )

                        .attr( "x", function( d ) {
                            return x( d.x );
                        } )
                        .attr( "y", function( d ) {
                            return y( d.y0 + d.y );
                        } )
                        // bhanu
                    .attr( "data-type", function( d ) {
                            return;
                        } )
                        // end
                        .attr( "height", function( d ) {
                            return y( d.y0 ) - y( d.y0 + d.y );
                        } )
                        .attr( "width", x.rangeBand() )
                        .on( "mouseover", function() {
                            tooltip.style( "display", null );
                        } )
                        .on( "mouseout", function() {
                            tooltip.style( "display", "none" );
                        } )
                        .on( "mousemove", function( d ) {
                            var xPosition = d3.mouse( this )[ 0 ] - 15;
                            var yPosition = d3.mouse( this )[ 1 ] - 25;
                            tooltip.attr( "transform", "translate(" + xPosition + "," + yPosition + ")" );
                            if ( d.y0 == 0 )
                                tooltip.select( ".textone" ).text("Percentage completed " + d.y )
                        } )
                        groups.selectAll("text")
                        .data( function( d ) {
                            return d;
                        } )
                         .enter()
                         .append("text")
                         .text(function(d) {
                              return d.x1;
                         })
                         .attr("text-anchor", "middle")
                         .attr( "x", function( d ) {
                             return x( d.x)+10;
                         } )
                         .attr( "y", function( d ) {
                             return y( d.y0 + d.y) -10;
                         } )
                         .attr("font-family", "sans-serif")
                         .attr("font-size", "15px")
                         .attr("font-weight","bold")
                         .attr("fill", "black");


                    // Prep the tooltip bits, initial display is hidden


                    var tooltip = svg.append( "g" )
                        .attr( "class", "bar-chart-tooltip" )
                        .style( "display", "none" );

                    tooltip.append( "rect" )
                        .attr( "width", 30 )
                        .attr( "height", 20 )
                        .attr( "fill", "white" )
                        .style( "opacity", 0.5 );

                    tooltip.append( "text" )
                        .attr( "class", "textone" )
                        .attr( "x", 15 )
                        .attr( "dy", "1.2em" )
                        .style( "text-anchor", "middle" )
                        .attr( "font-size", "12px" )
                        .attr( "font-weight", "bold" );

                }

            }
        }
    } );

'use strict';
angular
    .module( 'jigsawCorpLms' )
    .directive( 'managerBarChart', function() {
        return {
            restrict: 'E',
            scope: {
                chartdata: '=',
                mode: '='
            },
            link: function( scope, element, attrs ) {
                scope.$watch( 'mode', function( newValue, oldValue ) {
                    if ( newValue )
                        scope.createChart();
                }, true );
                scope.createChart = function() {
                    d3.selectAll( "#blicense-management-section svg" ).remove();
                    var margin = {
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 20
                    };

                    var width = $( '.graph-wrp' ).width(),
                        height = 100 - margin.top - margin.bottom;


                    var svg = d3.select( element[ 0 ] )
                        .append( "svg" )
                        .attr( "width", '100%' )
                        .attr( "height", '100%' )
                        .append( "g" )
                        .attr( "transform", "translate(" + margin.left + "," + margin.top + ")" );

                    if ( scope.mode == 'monthly' ) {
                        var data;
                        if(scope.chartdata[0] == undefined){
                          data = scope.chartdata.licenceMgmtGraph;
                        }
                        else{
                          data = scope.chartdata[0].licenceMgmtGraph;
                        }
                    }/* else if ( scope.mode == 'quaterly' ) {
                        var data = scope.chartdata.quaterlyPurchase;
                    } else if ( scope.mode == 'yearly' ) {
                        var data = scope.chartdata.yearlyPurchase;
                    };*/

                    // Transpose the data into layers
                    var dataset = d3.layout.stack()( [ "usedLicences" ].map( function( stacked ) {
                        return data.map( function( d ) {
                            var name;
                            var str;
                            var licenseCount=d.usedLicences;
                            if(d.hasOwnProperty("lpTitle")){
                              if(d.lpTitle.length >11){
                                str = d.lpTitle.substring(0,11)+"...";
                              }else{
                                str = d.lpTitle;
                              }
                              name=str;
                            }else{
                              if(d.teamName.length >11){
                                str = d.teamName.substring(0,11)+"...";
                              }else{
                                str = d.teamName;
                              }
                              name=str;
                            }
                            return {
                                x: name,
                                y: +d[ stacked ],
                                x1:licenseCount
                            };
                        } );
                    } ) );


                    // Set x, y and colors
                    var x = d3.scale.ordinal()
                        .domain( dataset[ 0 ].map( function( d ) {
                            return d.x;
                        } ) )
                        .rangeRoundBands( [ 0, width*1.5 ], width/1000 );

                    var y = d3.scale.linear()
                        .domain( [ 0, d3.max( dataset, function( d ) {
                            return d3.max( d, function( d ) {
                                return d.y0 + d.y;
                            } );
                        } ) ] )
                        .range( [ height, 0 ] );

                    var colors = [ "#4bb056","#cc141f" ];

                    var xAxis = d3.svg.axis()
                        .scale( x )
                        .orient( "bottom" );

                    var yAxis = d3.svg.axis()
              					.scale(y)
              					.orient("left")
              					.ticks(5);


                    svg.append( "g" )
                        .attr( "class", "x axis" )
                        .attr( "transform", "translate(0," + height + ")" )
                        .call( xAxis );

                        svg.append( "g" )
                            .attr( "class", "y axis" )
                            .attr( "transform", "translate(0, 0 )" )
                            .call( yAxis );

                    // Create groups for each series, rects for each segment
                    var groups = svg.selectAll( "g.cost" )
                        .data( dataset )
                        .enter().append( "g" )
                        .attr( "class", "cost" )
                        .style( "fill", function( d, i ) {
                            return colors[ i ];
                        } );

                    var rect = groups.selectAll( "rect" )
                        .data( function( d ) {
                            return d;
                        } )
                        .enter()
                        .append( "rect" )
                        .attr( "x", function( d ) {
                            return x( d.x );
                        } )
                        .attr( "y", function( d ) {
                            return y( d.y0 + d.y );
                        } )
                        // bhanu
                    .attr( "data-type", function( d ) {
                            return;
                        } )
                        // end
                        .attr( "height", function( d ) {
                            return y( d.y0 ) - y( d.y0 + d.y );
                        } )
                        .attr( "width", x.rangeBand() )
                        .on( "mouseover", function() {
                            tooltip.style( "display", null );
                        } )
                        .on( "mouseout", function() {
                            tooltip.style( "display", "none" );
                        } )
                        .on( "mousemove", function( d ) {
                            var xPosition = d3.mouse( this )[ 0 ] - 15;
                            var yPosition = d3.mouse( this )[ 1 ] - 25;
                            tooltip.attr( "transform", "translate(" + xPosition + "," + yPosition + ")" );
                            if(d.x === "UnAllocated"){
                                tooltip.select( ".textone" ).text( "unallocated: " + d.y )
                            }else{
                            if ( d.y0 == 0 )
                                tooltip.select( ".textone" ).text( "license allocated : " + d.x1 )
                                else
                                  tooltip.select( ".textone" ).text( "license allocated : " + d.x1 )

                                }

                        })
                        groups.selectAll("text")
                        .data( function( d ) {
                            return d;
                        } )
                         .enter()
                         .append("text")
                         .text(function(d) {
                              return d.x1;
                         })
                         .attr("text-anchor", "middle")
                         .attr( "x", function( d ) {
                             return x( d.x)+30;
                         } )
                         .attr( "y", function( d ) {
                             return y( d.y0 + d.y) -10;
                         } )
                         .attr("font-family", "sans-serif")
                         .attr("font-size", "15px")
                         .attr("font-weight","bold")
                         .attr("fill", "black")


                    // Prep the tooltip bits, initial display is hidden
                    var tooltip = svg.append( "g" )
                        .attr( "class", "bar-chart-tooltip" )
                        .style( "display", "none" );

                    tooltip.append( "rect" )
                        .attr( "width", 30 )
                        .attr( "height", 20 )
                        .attr( "fill", "white" )
                        .style( "opacity", 0.5 );

                    tooltip.append( "text" )
                        .attr( "class", "textone" )
                        .attr( "x", 15 )
                        .attr( "dy", "1.2em" )
                        .style( "text-anchor", "middle" )
                        .attr( "font-size", "12px" )
                        .attr( "font-weight", "bold" );

                }

            }
        }
    } );

'use strict';
angular
    .module( 'jigsawCorpLms' )
    .directive( 'licenseBarChart', function() {
        return {
            restrict: 'E',
            scope: {
                chartdata: '=',
                mode: '='
            },
            link: function( scope, element, attrs ) {
                scope.$watch( 'mode', function( newValue, oldValue ) {
                    if ( newValue )
                        scope.createChart();
                }, true );
                scope.createChart = function() {
                    d3.selectAll( "#blicense-management-section svg" ).remove();

					//barchart data
          var margin = {top: 25, right: 40, bottom: 35, left: 85};
          var w = $( '.graph-wrp' ).width(),
              h = 200 - margin.top - margin.bottom;

				/*	var margin = {top: 25, right: 40, bottom: 35, left: 85},
									w = 500 - margin.left - margin.right,
									h = 350 - margin.top - margin.bottom;*/
					var padding = 10;

					var colors =	{0:	["unUsedLicences", "#aad688"],
									1:	["usedLicences", "#4bb056"]};

                  if ( scope.mode == 'monthly' ) {
                      var dataset = scope.chartdata.licenceMgmtGraph;
                  }/* else if ( scope.mode == 'quaterly' ) {
                      var data = scope.chartdata.quaterlyPurchase;
                  } else if ( scope.mode == 'yearly' ) {
                      var data = scope.chartdata.yearlyPurchase;
                  };*/
                  var dataset1 = d3.layout.stack()( [ "usedLicences", "unUsedLicences","unAllocatedLicences" ].map( function( stacked ) {
                      return dataset.map( function( d ) {
                          var name;
                          var licenseCount=d.usedLicences+d.unUsedLicences+d.unAllocatedLicences;
                          if(d.hasOwnProperty("lpName")){
                            name=d.lpName;
                          }else{
                            name=d.teamName;
                          }
                          return {
                              x: name,
                              y: +d[ stacked ],
                              x1:licenseCount
                          };
                      } );
                  } ) );


					var xScale = d3.scale.ordinal()
          .domain( dataset1[ 0 ].map( function( d ) {
              return d.x;
          } ) )
									.rangeRoundBands([0, w], 0.05);
					// ternary operator to determine if usedLicences or unUsedLicences has a larger scale

          var xScale1 = d3.scale.ordinal()
				.domain(d3.range(dataset.length))
				.rangeRoundBands([0, w], 0.05);

					var yScale = d3.scale.linear()
									.domain([0, d3.max(dataset, function(d) { return (d.unUsedLicences > d.usedLicences) ? d.unUsedLicences : d.usedLicences;})])
									.range([h, 0]);
					var xAxis = d3.svg.axis()
									.scale(xScale)
									.orient("bottom");
					var yAxis = d3.svg.axis()
									.scale(yScale)
									.orient("left")
									.ticks(5);

					var usedLicences = function(d) {
						return d.usedLicences;
					};
					var cpc = function(d) {
						return d.cpc;
					};

					var commaFormat = d3.format(',');

					//SVG element
					var svg = d3.select(element[ 0 ] )
								.append("svg")
								.attr("width", w + margin.left + margin.right)
								.attr("height", h + margin.top + margin.bottom)
								.append("g")
								.attr("transform", "translate(" + margin.left + "," + margin.top + ")");

					// Graph Bars
  					var sets = svg.selectAll(".set")
						.data(dataset)
						.enter()
						.append("g")
						.attr("class","set")
						.attr("transform",function(d,i){
							return "translate(" + (xScale1(i)) + ",0)";
						})
						;

					sets.append("rect")
						.attr("class","unUsedLicences")
						.attr("width", xScale.rangeBand()/2)
						.attr("y", function(d) {
							return yScale(d.unUsedLicences);
						})
						.attr("x", xScale.rangeBand()/2)
						.attr("height", function(d){
							return h - yScale(d.unUsedLicences);
						})
						.attr("fill", colors[0][1]);
						sets.append("text")
					  .text(function(d) {
							return d.unUsedLicences;
				 	      })
					  .attr("text-anchor", "middle")
					  .attr("x", function(d, i) {
							return xScale.rangeBand()/2+15;
					})
					.attr("y", function(d) {
							return yScale(d.unUsedLicences) - 14;
					})
					.attr("font-family", "sans-serif")
					.attr("font-size", "13px")
					.attr("fill", "black")
          .attr("font-weight","bold")
						;

					sets.append("rect")
						.attr("class","usedLicences")
						.attr("width", xScale.rangeBand()/2)
						.attr("y", function(d) {
							return yScale(d.usedLicences);
						})
						.attr("height", function(d){
							return h - yScale(d.usedLicences);
						})
						.attr("fill", colors[1][1]);

				 sets.append("text")
						.text(function(d) {
							return d.usedLicences;
						})
						.attr("text-anchor", "middle")
            .attr("x","25")
						.attr("y", function(d) {
							return yScale(d.usedLicences) - 14;
						})
						.attr("font-family", "sans-serif")
						.attr("font-size", "13px")
						.attr("fill", "black")
            .attr("font-weight","bold")
						;

					// xAxis
					svg.append("g") // Add the X Axis
						.attr("class", "x axis")
						.attr("transform", "translate(0," + (h) + ")")
						.call(xAxis)
							;
					// yAxis
					svg.append("g")
						.attr("class", "y axis")
						.attr("transform", "translate(0 ,0)")
						.call(yAxis)
						;
					// xAxis label
          svg.selectAll("text")
              .data(dataset)
              .enter()
              .append("text")
              .attr("x", w - 52)
              .attr("y", function(d, i) {
                return i * 20 + 9;
              })
              .text(function(d) {
                var text = d.teamName;
                return text;
              });
					//yAxis label
					svg.append("text")
							.attr("transform", "rotate(-90)")
							.attr("y", 0 - margin.left)
							.attr("x", 0 - (h / 2))
							.attr("dy", "1em")
							.style("text-anchor", "middle")

					// Title
					svg.append("text")
							.attr("x", (w / 2))
							.attr("y", 0 - (margin.top / 2))
							.attr("text-anchor", "middle")
							.style("font-size", "16px")
							.style("text-decoration", "underline");



					//bar chart data ends
				}

			}
		}
	});

'use strict';
angular
    .module( 'jigsawCorpLms' )
    .directive( 'barChart', function() {
        return {
            restrict: 'E',
            scope: {
                chartdata: '=',
                mode: '='
            },
            link: function( scope, element, attrs ) {
                scope.$watch( 'mode', function( newValue, oldValue ) {
                    if ( newValue )
                        scope.createChart();
                }, true );
                scope.createChart = function() {
                    d3.selectAll( "#blicense-management-section svg" ).remove();
                    var margin = {
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 20
                    };

                    var width = $( '.graph-wrp' ).width(),
                        height = 100 - margin.top - margin.bottom;


                    var svg = d3.select( element[ 0 ] )
                        .append( "svg" )
                        .attr( "width", '100%' )
                        .attr( "height", '100%' )
                        .append( "g" )
                        .attr( "transform", "translate(" + margin.left + "," + margin.top + ")" );

                    if ( scope.mode == 'monthly' ) {
                        var data = scope.chartdata.licenceMgmtGraph;

                    }/* else if ( scope.mode == 'quaterly' ) {
                        var data = scope.chartdata.quaterlyPurchase;
                    } else if ( scope.mode == 'yearly' ) {
                        var data = scope.chartdata.yearlyPurchase;
                    };*/

                    // Transpose the data into layers
                    var dataset = d3.layout.stack()( [ "usedLicences","unAllocated"].map( function( stacked ) {
                        return data.map( function( d ) {
                            var name;
                            var str;
                            var licenseCount=d.usedLicences+d.unAllocated;
                            if(d.hasOwnProperty("lpName")){
                              if(d.lpName.length >11){
                                str = d.lpName.substring(0,11)+"...";
                              }else{
                                str = d.lpName;
                              }
                              name=str;
                            }else{
                              if(d.teamName.length >11){
                                str = d.teamName.substring(0,11)+"...";
                              }else{
                                str = d.teamName;
                              }
                              name=str;
                            }
                            return {
                                x: name,
                                y: +d[ stacked ],
                                x1:licenseCount
                            };
                        } );
                    } ) );


                    // Set x, y and colors
                    var x = d3.scale.ordinal()
                        .domain( dataset[ 0 ].map( function( d ) {
                            return d.x;
                        } ) )
                        .rangeRoundBands( [ 0, width*1.5 ], width/1000 );
                        //.rangeRoundBands( [ 0, width-30 ], 0.60 );

                    var y = d3.scale.linear()
                        .domain( [ 0, d3.max( dataset, function( d ) {
                            return d3.max( d, function( d ) {
                                return d.y0 + d.y;
                            } );
                        } ) ] )
                        .range( [ height, 0 ] );

                    var colors = [ "#4bb056","#cc141f" ];

                    var xAxis = d3.svg.axis()
                        .scale( x )
                        .orient( "bottom" );

                    var yAxis = d3.svg.axis()
              					.scale(y)
              					.orient("left")
              					.ticks(5);


                    svg.append( "g" )
                        .attr( "class", "x axis" )
                        .attr( "transform", "translate(0," + height + ")" )
                        .call( xAxis );

                        svg.append( "g" )
                            .attr( "class", "y axis" )
                            .attr( "transform", "translate(0, 0 )" )
                            .call( yAxis );

                    // Create groups for each series, rects for each segment
                    var groups = svg.selectAll( "g.cost" )
                        .data( dataset )
                        .enter().append( "g" )
                        .attr( "class", "cost" )
                        .style( "fill", function( d, i ) {
                            return colors[i];
                        } );

                    var rect = groups.selectAll( "rect" )
                        .data( function( d ) {
                            return d;
                        } )
                        .enter()
                        .append( "rect" )
                        .attr( "x", function( d ) {
                            return x( d.x);
                        } )
                        .attr( "y", function( d ) {
                            return y( d.y0 + d.y );
                        } )

                    .attr( "data-type", function( d ) {
                            return;
                        } )

                        .attr( "height", function( d ) {
                            return y( d.y0 ) - y( d.y0 + d.y );
                        } )
                        .attr( "width", x.rangeBand() )
                        .on( "mouseover", function() {
                            tooltip.style( "display", null );
                        } )
                        .on( "mouseout", function() {
                            tooltip.style( "display", "none" );
                        } )
                        .on( "mousemove", function( d ) {
                            var xPosition = d3.mouse( this )[ 0 ] - 15;
                            var yPosition = d3.mouse( this )[ 1 ] - 25;
                            tooltip.attr( "transform", "translate(" + xPosition + "," + yPosition + ")" );
                            if(d.x === "UnAllocated"){
                                tooltip.select( ".textone" ).text( "unallocated: " + d.y )
                            }else{
                            if ( d.y0 == 0 )
                                tooltip.select( ".textone" ).text( "license allocated : " + d.x1 )
                                else
                                  tooltip.select( ".textone" ).text( "license allocated : " + d.x1 )

                                }

                        })
                        groups.selectAll("text")
                        .data( function( d ) {
                            return d;
                        } )
                         .enter()
                         .append("text")
                         .text(function(d) {

                              return d.x1;
                         })
                         .attr("text-anchor", "middle")
                         .attr( "x", function( d ) {
                             return x( d.x)+30;
                         } )
                         .attr( "y", function( d ) {
                             return y( d.y0 + d.y) -10;
                         } )
                         .attr("font-family", "sans-serif")
                         .attr("font-size", "15px")
                         .attr("font-weight","bold")
                         .attr("fill", "black")





                    // Prep the tooltip bits, initial display is hidden
                    var tooltip = svg.append( "g" )
                        .attr( "class", "bar-chart-tooltip" )
                        .style( "display", "none" );

                    tooltip.append( "rect" )
                        .attr( "width", 30 )
                        .attr( "height", 20 )
                        .attr( "fill", "white" )
                        .style( "opacity", 0.5 );

                    tooltip.append( "text" )
                        .attr( "class", "textone" )
                        .attr( "x", 15 )
                        .attr( "dy", "1.2em" )
                        .style( "text-anchor", "middle" )
                        .attr( "font-size", "12px" )
                        .attr( "font-weight", "bold" );

                }

            }
        }
    } );

'use strict';
angular
    .module('jigsawCorpLms')
    .directive('scrollOnClick', function() {
        return {
            restrict: 'A',
            link: function(scope, $elm) {
                $elm.on('click', function() {
                    $($elm).animate({ scrollTop: $elm.offset().down + 300 }, "slow");
                });
            }
        }
    });
// (function (root, factory) {
//     if (typeof define === 'function' && define.amd) {
//         define(["angular", "intro.js"], factory);
//     } else if (typeof exports === 'object') {
//         module.exports = factory(require('angular'), require('intro.js'));
//     } else {
//         root.angularIntroJs = factory(root.angular, root.introJs);
//     }
// }(this, function (angular, introJs) {
//
//     var ngHintDirective = angular.module('angular-intro', []);
//
//
//     // ngHintDirective.directive('ngHintOptions', ['$timeout', function ($timeout) {
//     //
//     //     return {
//     //         // restrict: 'A',
//     //         // scope: {
//     //         //     ngHintsMethod: "=",
//     //         //     ngHintOptions: '='
//     //         // },
//     //         // link: function(scope, element, attrs) {
//     //         //
//     //         //
//     //         //     //  scope.ngHintsMethod = function(step) {
//     //         //     //
//     //         //     //        introJs().addHints();
//     //         //     //
//     //         //      //};
//     //         //
//     //         //
//     //         // }
//     //     };
//     // }
//   //]);
//
//     return ngHintDirective;
//
// }));

'use strict';
angular
    .module( 'jigsawCorpLms' ).directive( 'resize', function( $window ) {
        return function( scope, element ) {
            var w = angular.element( $window );
            scope.getWindowDimensions = function() {
                return {
                    'h': $window.innerHeight,
                    'w': $window.innerWidth
                };
            };

            scope.setElementWidth = function() {
                return {
                    'width': element[ 0 ].offsetWidth + 'px'
                };
            };

            scope.setElementHeight = function() {
                return {
                    'height': element[ 0 ].offsetHeight + 'px'
                };
            };

            scope.$watch( scope.getWindowDimensions, function( newValue ) {
                scope.windowHeight = newValue.h;
                scope.windowWidth = newValue.w;
                scope.targetElementsWidth = element[ 0 ].offsetWidth + 'px';
                scope.targetElementsHeight = element[ 0 ].offsetHeight + 'px';
                scope.style = function() {
                    return {
                        'height': newValue.h + 'px',
                        'width': newValue.w + 'px'
                    };
                };

            }, true );

            w.bind( 'resize', function() {
                scope.$apply();
            } );
        };
    } );

'use strict';
/*
 * A directive to detect if error is fatal or not
 * Emit $checkFatalError event from your error handler
 * If error is fatal it will broadcast $fatalErrorFound event
 * which can be further used inside app to handle errors
 * Use directive at top most element
 */
angular
    .module( 'jigsawCorpLms' ).directive( 'fatalErrorFallback', function() {
        return {
            restrict: 'EA',
            link: function( scope, element ) {
                //Listen for $checkFatalError event
                scope.$on( '$checkFatalError', function() {
                    /*
                     * Regex /{{(.*?)}}/ will check for any uncompiled bindings in markup
                     * if it found any binding text it will broadcast $fatalErrorFound event
                     * which can be used in .run to handle the page break
                     */
                    if ( ( element[ 0 ].textContent ).match( /{{(.*?)}}/ ) !== null ) {
                        scope.$broadcast( '$fatalErrorFound' );
                    }
                } );
            }
        };
    } );

'use strict';
// jscs:disable maximumLineLength
angular
    .module( 'jigsawCorpLms' )
    .directive( 'dtouchStart', function() {
        return {
            link: function( scope, element, attr ) {
                element.on( 'touchstart', function( e ) {
                    scope.$apply( function() {
                        scope.$eval( attr.dtouchStart );
                    } );
                } );
            }
        };
    } ).directive( 'dtouchEnd', function() {
        return {
            link: function( scope, element, attr ) {
                element.on( 'touchend', function( e ) {
                    scope.$apply( function() {
                        scope.$eval( attr.dtouchEnd );
                    } );
                } );
            }
        };
    } ).directive( 'dtouchMove', function() {
        return {
            link: function( scope, element, attr ) {
                element.on( 'touchmove', function( e ) {
                    scope.$apply( function() {
                        scope.$eval( attr.dtouchMove );
                    } );
                } );
            }
        };
    } );

'use strict';
angular.module( 'jigsawCorpLms' )
    .constant( 'RestEndpoints', {
        // baseURL: 'http://192.168.2.221:1442',
        baseURL: 'https://monkeyapi.jigsawacademy.com',
        endpoints: [ {
            name: 'login',
            url: '/user/login',
            method: 'POST'
        },
        {
           name: 'testUrl',
           url: '/api/er/getertoken',
           method: 'POST'
        },{
            name: 'bookmarks',
            url: '/mockjson/bookmarks',
            method: 'POST'
        }, {
            name: 'menuHistory',
            url: '/mockjson/menuHistory',
            method: 'POST'
        }, {
            name: 'notifications',
            url: '/mockjson/notifications',
            method: 'POST'
        },  {
            name: 'updateNotify',
            url: '/api/notify/markasread',
            method: 'POST'
        }, {
            name: 'learnigPathLanding',
            url: '/mockjson/Dashboard/jigsawDash',
            method: 'POST'
        }, {
            name: 'moduleDetails',
            url: '/mockjson/moduleDetails',
            method: 'POST'
        }, {
            name: 'mappedTranscript',
            url: '/api/module/transcript',
            method: 'POST'
        }, {
            name: 'videoKeyframes',
            url: '/mockjson/keyframesTimestamp',
            method: 'POST'
        }, {
            name: 'askExpert',
            url: '/mockjson/askExpert',
            method: 'POST'
        }, {
            name: 'countryCodes',
            url: '/api/country/list',
            method: 'GET'
        }, {
            name: 'profileData',
            url: '/api/user.profile/getprofile',
            method: 'POST'
        },
        {
            name: 'uploadAvatarData',
            url: '/api/avatar/list',
            method: 'POST'
        }, {
            name: 'clipboardVideoPage',
            url: '/mockjson/clipboardVideoPageData',
            method: 'POST'
        }, {
            name: 'clipboardPage',
            url: '/mockjson/clipboardPageData',
            method: 'POST'
        }, {
            name: 'welcomeScreenData',
            url: '/mockjson/welcomeScreenService',
            method: 'POST'
        }, {
            name: 'learnersProfileData',
            url: '/api/leaderboard/topranks',
            method: 'POST'
        },{
            name: 'fetchUserRank',
            url: '/api/leaderboard/getrank',
            method: 'POST'
        }, {
            name: 'badgeData',
            url: '/api/leaderboard/getbadges',
            method: 'POST'
        }, {
            name: 'quizService',
            url: '/api/quiz/fetch',
            method: 'POST'
        },
        {
            name: 'quizUpdateService',
            url: '/api/quiz/update',
            method: 'POST'
        },
        {
            name: 'quizCompleteService',
            url: '/api/quiz/complete',
            method: 'POST'
        },
        {
            name: 'imageService',
            url: '/mockjson/imageService',
            method: 'POST'
        },
        {
            name: 'buyerContentService',
            url: '/mockjson/content',
            method: 'POST'
        }, {
            name: 'caseStudyService',
            url: '/api/csa/data',
            method: 'POST'
        }, {
            name: 'caseStudyExercise',
            url: '/api/csa/exercise',
            method: 'POST'
        }, {
            name: 'caseStudySolution',
            url: '/api/csa/solution',
            method: 'POST'
        }, {
            name: 'proficiencyTestService',
            url: '/mockjson/proficiencyTestData',
            method: 'POST'
        }, {
            name: 'profTestSummary',
            url: '/mockjson/profTestSummary',
            method: 'POST'
        }, {
            name: 'profTestQuestions',
            url: '/mockjson/profTestQuestions',
            method: 'POST'
        }, {
            name: 'quizQuestions',
            url: '/mockjson/quizQuestions',
            method: 'POST'
        }, {
            name: 'libraryData',
            url: '/mockjson/libraryData',
            method: 'POST'
        }, {
            name: 'resourceLinkPageData',
            url: '/api/material/data',
            method: 'POST'
        }, {
            name: 'performanceAnalyticsData',
            url: '/mockjson/performanceAnalytics',
            method: 'POST'
        }, {
            name: 'moduleSummaryPageData',
            url: '/mockjson/moduleSummaryPage',
            method: 'POST'
        }, {
            name: 'librarySearchData',
            url: '/mockjson/librarySearchData',
            method: 'POST'
        }, {
            name: 'globalHelpData',
            url: '/mockjson/globalHelpData',
            method: 'POST'
        }, {
            name: 'globalHelpDataManager',
            url: '/mockjson/globalHelpDataManager',
            method: 'POST'
        } ,
        {
            name: 'updateProfile',
            url: '/api/user.profile/update',
            method: 'POST'
        },
        {
            name: 'updateProfileMinimal',
            url: '/api/user.profile/updateminmal',
            method: 'POST'
        },
        {
            name: 'updatePassword',
            url: '/api/user.profile/updatepassword',
            method: 'POST'
        },
        {
            name: 'saveQuizQuestion',
            url: '/api/quiz/savequestion',
            method: 'POST'
        },
        {
            name: 'videoOtp',
            url: '/api/vdo/getotp',
            method: 'POST'
        },
        {
            name: 'playlistData',
            url: '/mockjson/playlistData',
            method: 'POST'
        },
        {
            name: 'retrievePassword',
            url: '/user/reset',
            method: 'POST'
        },
        {
            name: 'validateToken',
            url: '/api/user.profile/validate/token',
            method: 'POST'
        },
        {
            name: 'getPreviousLps',
            url: '/api/lp/completedlist',
            method: 'POST'
        },
        {//buyers related api's start here
            name: 'buyerHeadWSLicense',
            url: '/buyers/head/welcomescreen/license',
            method: 'POST'
        },
        {
          name:'buyerManagerWSLicense',
          url: '/buyers/manager/welcomeScreen/license',
          method:'POST'
        },  {
         name: 'buyerHeadWSLp',
         url: '/buyers/head/welcomescreen/lp',
         method: 'POST'
       },{
          name:'buyerManagerWSLp',
          url: '/buyers/manager/welcomeScreen/lp',
          method:'POST'
      },{
        name: 'getAvatar',
        url: '/api/get/avatars',
        method: 'POST'
      },{
          name: 'managerbuyersData',
          url: '/buyers/manager/dashboard/attributes',
          method: 'POST'
      },{
          name: 'buyersData',
          url: '/buyers/dashboard/attributes',
          method: 'POST'
      },{
          name: 'buyersLearningHealth',
          url: '/buyers/dashboard/LearningHealth',
          method: 'POST'
      },{
          name: 'buyersManagerLearningHealth',
          url: '/buyers/dashboard/manager/LearningHealth',
          method: 'POST'
      },{
            name: 'buyersRoi',
            url: '/buyers/dashboard/ROIGraph',
            method: 'POST'
        },{
            name: 'buyersSkills',
            url: '/buyers/dashboard/head/LearningSkillsInLp',
            method: 'POST'
        },{
            name: 'buyersManagerSkills',
            url: '/buyers/dashboard/manager/LearningSkillsInLp',
            method: 'POST'
        },{
            name: 'licenseMngHeadData',
            url: '/buyers/dashboard/head/LicenceMgmtGraph',
            method: 'POST'
        },{
            name: 'licenseMngManagerData',
            url: '/buyers/dashboard/manager/LicenceMgmtGraph',
            method: 'POST'
        },{
            name: 'buyerslhrs',
            url: '/buyers/dashboard/head/LearningHrs',
            method: 'POST'
        },{
            name: 'buyersManagerlhrs',
            url: '/buyers/dashboard/manager/LearningHrs',
            method: 'POST'
        },{
            name: 'buyerPurchaseHistory',
            url: '/buyers/purchaseHistory',
            method: 'POST'
        },{
            name: 'buyerWidgetsBar',
            url: '/mockjson/widgetsBar',
            method: 'POST'
        },{
            name: 'learners',
            url: '/buyers/learners/usersForLp',
            method: 'POST'
        },{
            name: 'Lretake',
            url: '//api/ptretake/list',
            method: 'POST'
        },{
            name: 'approveLearner',
            url: '//api/ptretake/approve',
            method: 'POST'
        },{
            name: 'rejectLearner',
            url: '//api/ptretake/reject',
            method: 'POST'
        },{
            name: 'buyersLHDrillDown',
            url: '/buyers/dashboard/LearningHealth/ByTeam',
            method: 'POST'
        },{
            name: 'buyersManagerLHDrillDown',
            url: '/buyers/dashboard/LearningHealth/manager/ByTeam',
            method: 'POST'
        },{
            name: 'buyersLHDrillDownByPath',
            url: '/buyers/dashboard/LearningHealth/ByPath',
            method: 'POST'
        }, {
            name: 'buyersManagerLHDrillDownByPath',
            url: '/buyers/dashboard/manager/LearningHealth/ByPath',
            method: 'POST'
        }, {
            name: 'lhByPathLD',
            url: '/buyers/dashboard/LearningHealth/ByPathDrillDown/ListUsers',
            method: 'POST'
        },{
            name: 'lhByPathLDManager',
            url: '/buyers/dashboard/manager/LearningHealth/ByPathDrillDown/ListUsers',
            method: 'POST'
        }, {
            name: 'lhByTeamLDManager',
            url: '/buyers/dashboard/manager/LearningHealth/ByTeamDrillDown/ListUsers',
            method: 'POST'
        },  {
            name: 'licenseMngByPath',
            url: '/buyers/dashboard/head/LicenceMgmtGraphByPath',
            method: 'POST'
        },
        {
            name: 'licenseMngByPathForManager',
            url: '/buyers/dashboard/manager/LicenceMgmtGraphByPath',
            method: 'POST'
        },  {
            name: 'licenseMngByTeam',
            url: '/buyers/dashboard/head/LicenceMgmtGraphByTeam',
            method: 'POST'
        },
        {
            name: 'licenseMngByTeamForManager',
            url: '/buyers/dashboard/manager/LicenceMgmtGraphByTeam',
            method: 'POST'
        },{
            name: 'buyersSkillsHeadDrillDownbyPath',
            url: '/buyers/dashboard/head/LearningSkillsInLpByPath',
            method: 'POST'
        },{
            name: 'buyersSkillsManagerDrillDownbyPath',
            url: '/buyers/dashboard/manager/LearningSkillsInLpByPath',
            method: 'POST'
        },{
            name: 'buyersSkillsHeadDrillDownbyTeam',
            url: '/buyers/dashboard/head/LearningSkillsInLpByTeam',
            method: 'POST'
        },{
            name: 'buyersSkillsManagerDrillDownbyTeam',
            url: '/buyers/dashboard/manager/LearningSkillsInLpByTeam',
            method: 'POST'
        },{
            name: 'SkillsDDExpandedView',
            url: '/buyers/dashboard/Skills/expandedView',
            method: 'POST'
        },{
            name: 'ManagerSkillsDDExpandedView',
            url: '/buyers/dashboard/skills/learnerdetails',
            method: 'POST'
        },{
            name: 'skillLevel2ByPath',
            url: '/buyers/dashboard/manager/skills/level2/bypath',
            method: 'POST'
        },  {
            name: 'skillLevel2ByTeam',
            url: '/buyers/dashboard/manager/skills/level2/byteam',
            method: 'POST'
        },{
            name: 'LearningHrsLevel1tableView',
            url: '/buyers/dashboard/head/learningHrs/level1/tableview/bypath',
            method: 'POST'
        },{
            name: 'LearningHrsLevel1tableViewManager',
            url: '/buyers/dashboard/manager/learningHrs/level1/tableview/bypath',
            method: 'POST'
        },{
            name: 'LearningHrsLevel2ByPath',
            url: '/buyers/dashboard/manager/learningHrs/level2/bypath',
            method: 'POST'
        },{
            name: 'LearningHrsLevel2ByTeam',
            url: '/buyers/dashboard/manager/learningHrs/level2/byteam',
            method: 'POST'
        },{
            name: 'LearningHrsLevel1tableViewByTeam',
            url: '/buyers/dashboard/head/learningHrs/level1/tableview/byteam',
            method: 'POST'
        },
        {
            name: 'LearningHrsLevel1tableViewByTeamManager',
            url: '/buyers/dashboard/manager/learningHrs/level1/tableview/byteam',
            method: 'POST'
        },{
            name: 'learningHrsDDByTeam',
            url: '/buyers/dashboard/head/TotalLearningHrs/ByTeamGraph',
            method: 'POST'
        }, {
            name: 'learningHrsDDManagerByTeam',
            url: '/buyers/dashboard/manager/TotalLearningHrs/ByTeamGraph',
            method: 'POST'
        },{
            name: 'learningHrsDDByPath',
            url: '/buyers/dashboard/head/TotalLearningHrs/ByPathGraph',
            method: 'POST'
        }, {
            name: 'learningHrsDDByPathManager',
            url: '/buyers/dashboard/manager/TotalLearningHrs/ByPathGraph',
            method: 'POST'
        },{
            name: 'updateProfileImage',
            url: '/api/avatar/updateAvatar',
            method: 'POST'
      }, {
            name: 'LBadgeData',
            url: '/buyers/learners/badges',
            method: 'POST'
        },{
              name: 'BadgeHead',
              url: '/buyers/learners/badges/head',
              method: 'POST'
          },{
              name: 'support',
              url: '/api/support/ticket',
              method: 'POST'
          },{
                name: 'feedback',
                url: '/api/support/feedback',
                method: 'POST'
            },{
                  name: 'getDownloadModuleData',
                  url: '/api/file/download',
                  method: 'POST'
              },
              {
                  name: 'getPtSummary',
                  url: '/api/ptretake/summary',
                  method: 'POST'
              },
              {
                  name: 'getLearningObjective',
                  url: '/api/module/lpobjective',
                  method: 'POST'
              },
              {
                  name: 'getTermsNconditions',
                  url: '/mockjson/terms',
                  method: 'POST'
              },
              {
                  name: 'authessTest',
                  url: '/api/authess/getAuthessAuth',
                  method: 'POST'
                },
                {
                name: 'fetchVideoAndAssessmentDuration',
                url: '/mockjson/terms',
                method: 'POST'
              },{
              name: 'fetchUserTotalCertificates',
              url: '/api/leaderboard/gettotalcertificates',
              method: 'POST'
            },{
              name: 'fetchUserCertificates',
              url: '/api/leaderboard/getcertificates',
              method: 'POST'
            },{
              name: 'fetchUserDownloadableCertificates',
              url: '/api/leaderboard/downloadcertificates',
              method: 'POST'
            },{
              name: 'fetchUserAllDownloadableCertificates',
              url: '/api/leaderboard/downloadallcertificates',
              method: 'POST'
            },{
              name: 'updateisNewLpForUser',
              url: '/api/user.profile/lpvisited',
              method: 'POST'
            },{
              name: 'getLabPassword',
              url: '/api/lab/createinstance',
              method: 'POST'
            },{
              name: 'getLabAccess',
              url: '/api/lab/startlab',
              method: 'POST'
            } ]
    } );

// jscs:disable
'use strict';
angular.module( 'jigsawCorpLms' )
    .constant( 'InputValidation', {
        'allowedPasswordSpecialChar': [ '@', '#', '$', '%', '^', '\\' ]
    } );

'use strict';
angular.module( 'jigsawCorpLms' )
    .constant( 'AppConstant', {
        'burgeMenuTitles': [ {
            'state': [ 'home.clipboard', 'home.dashboard', 'home.learn', 'home.moduleEnd.profTest', 'home.progressInfoPage', 'home.playlist' ],
            'title': 'Learning Path'
        }, {
            'state': [ 'home.library', 'home.libVideo' ],
            'title': 'library'
        } ]
    } );

(function(){var PI,abs,cos,css,getMetric,hasSupport,key,max,prefixList,rad,round,sin,testEl,testProp,transform,value,_ref,__bind=function(fn,me){return function(){return fn.apply(me,arguments)}};cos=Math.cos,sin=Math.sin,PI=Math.PI,abs=Math.abs,round=Math.round,max=Math.max;rad=function(deg){return deg*PI/180};getMetric=function(style,key){return parseInt(style[key],10)};transform=function(y,angle){return"translate3d(0, "+y+"px, 0) rotate3d(0, 0, 1, "+angle+"deg)"};testProp=function(prop){var key,prefix,_i,_len;if(prop in testEl.style){return prop}for(_i=0,_len=prefixList.length;_i<_len;_i++){prefix=prefixList[_i];if((key=prefix+prop.charAt(0).toUpperCase()+prop.slice(1))in testEl.style){return key}}return false};hasSupport=true;testEl=document.createElement("div");prefixList=["Webkit","Moz","ms"];css=new function(){var key,_i,_len,_ref;_ref="transform transformOrigin transformStyle".split(" ");for(_i=0,_len=_ref.length;_i<_len;_i++){key=_ref[_i];this[key]=key}return this};for(key in css){value=css[key];css[key]=testProp(value);if(!css[key]){hasSupport=false;break}}window.Maskew=function(){function Maskew(_el,angle,_options){var contents,elStyle,side,xMetrics,yMetrics,_base,_base1,_base2,_base3,_fn,_i,_j,_k,_len,_len1,_len2,_ref;this._el=_el;this.angle=angle;this._options=_options!=null?_options:{};this._onTouchLeave=__bind(this._onTouchLeave,this);this._onTouchEnd=__bind(this._onTouchEnd,this);this._onTouchMove=__bind(this._onTouchMove,this);this._onTouchStart=__bind(this._onTouchStart,this);this.destroy=__bind(this.destroy,this);this.skew=__bind(this.skew,this);if(!hasSupport){return}if(!(this instanceof Maskew)){return new Maskew(this._el,this.angle,this._options)}if(typeof this._el==="string"){this._el=document.querySelector(this._el)}(_base=this._options).touch||(_base.touch=false);(_base1=this._options).anchor||(_base1.anchor="top");(_base2=this._options).showElement||(_base2.showElement=false);(_base3=this._options).className||(_base3.className="maskew");contents=this._el.cloneNode(true);elStyle=window.getComputedStyle(this._el);xMetrics=["width","paddingLeft","paddingRight","borderLeftWidth","borderRightWidth"];yMetrics=["height","paddingTop","paddingBottom","borderTopWidth","borderBottomWidth"];this._width=this._height=0;for(_i=0,_len=xMetrics.length;_i<_len;_i++){key=xMetrics[_i];this._width+=getMetric(elStyle,key)}for(_j=0,_len1=yMetrics.length;_j<_len1;_j++){key=yMetrics[_j];this._height+=getMetric(elStyle,key)}this._outerMask=document.createElement("div");this._outerMask.style.padding="0";this._outerMask.style.width=this._width+"px";this._outerMask.style.height=this._height+"px";this._outerMask.style.overflow="hidden";if(this._options.showElement){this._el.style.display="block";this._outerMask.style.display=this._options.showElement}else{this._outerMask.style.display=elStyle.display}this._innerMask=this._outerMask.cloneNode(false);this._innerMask.style[css.transformOrigin]="bottom left";this._holder=this._outerMask.cloneNode(false);this._holder.style[css.transformOrigin]="inherit";_ref=["Top","Right","Bottom","Left"];_fn=function(_this){return function(key){return _this._outerMask.style[key]=elStyle[key]}}(this);for(_k=0,_len2=_ref.length;_k<_len2;_k++){side=_ref[_k];_fn("margin"+side)}this._el.style.margin="0";this._el.parentNode.insertBefore(this._outerMask,this._el);this._holder.appendChild(this._el);this._innerMask.appendChild(this._holder);this._outerMask.appendChild(this._innerMask);this._outerMask.className=this._options.className;if(this._options.touch){this.setTouch(true)}this.skew(this.angle)}Maskew.prototype.skew=function(angle){var adj,cosine,hyp,opp,rads,sine,tlX,tlY,yOffset;if(angle==null){angle=this._dragAngle||0}if(angle<0){angle=0}sine=sin(rads=rad(angle));cosine=cos(rads);tlX=this._height*sine;tlY=this._height*cosine;adj=max(0,this._width-tlX);hyp=adj/cosine;opp=sine*hyp;yOffset=round(this._height-tlY+opp);this._outerMask.style.height=round(tlY-opp)+"px";this._innerMask.style.width=round(hyp)+"px";this._innerMask.style[css.transform]=transform(-yOffset,angle);this._holder.style[css.transform]=transform(0,-angle);if(this._options.anchor==="bottom"){this._el.style[css.transform]=transform(yOffset,0)}return this};Maskew.prototype.setTouch=function(toggle){var eString,eventPair,eventPairs,listenFn,_fn,_i,_j,_len,_len1;if(toggle){if(this._touchEnabled){return}listenFn="addEventListener";this._outerMask.style.cursor="ew-resize";this._touchEnabled=true}else{if(!this._touchEnabled){return}listenFn="removeEventListener";this._outerMask.style.cursor="default";this._touchEnabled=false}eventPairs=[["TouchStart","MouseDown"],["TouchMove","MouseMove"],["TouchEnd","MouseUp"],["TouchLeave","MouseOut"]];for(_i=0,_len=eventPairs.length;_i<_len;_i++){eventPair=eventPairs[_i];_fn=function(_this){return function(fn){return _this._outerMask[listenFn](eString.toLowerCase(),_this[fn],false)}}(this);for(_j=0,_len1=eventPair.length;_j<_len1;_j++){eString=eventPair[_j];_fn("_on"+eventPair[0])}}return this};Maskew.prototype.destroy=function(){var k,parent;parent=this._outerMask.parentNode;parent.insertBefore(this._el,this._outerMask);parent.removeChild(this._outerMask);if($){$.data(this._el,"maskew",null)}for(k in this){this[k]=null}return null};Maskew.prototype._onTouchStart=function(e){e.preventDefault();this._touchStarted=true;if(e.type==="mousedown"){this._x1=e.pageX}else if(e.type==="touchstart"){this._x1=e.touches[0].pageX}return this._xDelta=0};Maskew.prototype._onTouchMove=function(e){if(!this._touchStarted){return}e.preventDefault();if(e.type==="mousemove"){this._xDelta=e.pageX-this._x1}else if(e.type==="touchmove"){this._xDelta=e.touches[0].pageX-this._x1}this._dragAngle=this.angle+this._xDelta/abs(3+this._xDelta/this._width);return this.skew()};Maskew.prototype._onTouchEnd=function(){this._touchStarted=false;return this.angle=this._dragAngle||this.angle};Maskew.prototype._onTouchLeave=function(){return this._onTouchEnd()};Maskew.VERSION="0.1.6";Maskew.isSupported=hasSupport;return Maskew}();if(window.jQuery!=null||((_ref=window.$)!=null?_ref.data:void 0)!=null){$.prototype.maskew=function(angle,options){var el,instance,_i,_j,_len,_len1;if(!hasSupport){return this}if(typeof angle==="object"){options=angle;angle=0}else if(typeof angle==="string"){for(_i=0,_len=this.length;_i<_len;_i++){el=this[_i];if(!(instance=$.data(el,"maskew"))){return this}if(typeof instance[angle]!=="function"){return this}instance[angle].call(instance,options)}return this}for(_j=0,_len1=this.length;_j<_len1;_j++){el=this[_j];if(instance=$.data(el,"maskew")){return instance}$.data(el,"maskew",new Maskew(el,angle,options))}return this}}}).call(this);

/*!
 * ui-select
 * http://github.com/angular-ui/ui-select
 * Version: 0.17.1 - 2016-06-09T20:41:58.363Z
 * License: MIT
 */


( function() {
    "use strict";
    var KEY = {
        TAB: 9,
        ENTER: 13,
        ESC: 27,
        SPACE: 32,
        LEFT: 37,
        UP: 38,
        RIGHT: 39,
        DOWN: 40,
        SHIFT: 16,
        CTRL: 17,
        ALT: 18,
        PAGE_UP: 33,
        PAGE_DOWN: 34,
        HOME: 36,
        END: 35,
        BACKSPACE: 8,
        DELETE: 46,
        COMMAND: 91,

        MAP: {
            91: "COMMAND",
            8: "BACKSPACE",
            9: "TAB",
            13: "ENTER",
            16: "SHIFT",
            17: "CTRL",
            18: "ALT",
            19: "PAUSEBREAK",
            20: "CAPSLOCK",
            27: "ESC",
            32: "SPACE",
            33: "PAGE_UP",
            34: "PAGE_DOWN",
            35: "END",
            36: "HOME",
            37: "LEFT",
            38: "UP",
            39: "RIGHT",
            40: "DOWN",
            43: "+",
            44: "PRINTSCREEN",
            45: "INSERT",
            46: "DELETE",
            48: "0",
            49: "1",
            50: "2",
            51: "3",
            52: "4",
            53: "5",
            54: "6",
            55: "7",
            56: "8",
            57: "9",
            59: ";",
            61: "=",
            65: "A",
            66: "B",
            67: "C",
            68: "D",
            69: "E",
            70: "F",
            71: "G",
            72: "H",
            73: "I",
            74: "J",
            75: "K",
            76: "L",
            77: "M",
            78: "N",
            79: "O",
            80: "P",
            81: "Q",
            82: "R",
            83: "S",
            84: "T",
            85: "U",
            86: "V",
            87: "W",
            88: "X",
            89: "Y",
            90: "Z",
            96: "0",
            97: "1",
            98: "2",
            99: "3",
            100: "4",
            101: "5",
            102: "6",
            103: "7",
            104: "8",
            105: "9",
            106: "*",
            107: "+",
            109: "-",
            110: ".",
            111: "/",
            112: "F1",
            113: "F2",
            114: "F3",
            115: "F4",
            116: "F5",
            117: "F6",
            118: "F7",
            119: "F8",
            120: "F9",
            121: "F10",
            122: "F11",
            123: "F12",
            144: "NUMLOCK",
            145: "SCROLLLOCK",
            186: ";",
            187: "=",
            188: ",",
            189: "-",
            190: ".",
            191: "/",
            192: "`",
            219: "[",
            220: "\\",
            221: "]",
            222: "'"
        },

        isControl: function( e ) {
            var k = e.which;
            switch ( k ) {
                case KEY.COMMAND:
                case KEY.SHIFT:
                case KEY.CTRL:
                case KEY.ALT:
                    return true;
            }

            if ( e.metaKey || e.ctrlKey || e.altKey ) return true;

            return false;
        },
        isFunctionKey: function( k ) {
            k = k.which ? k.which : k;
            return k >= 112 && k <= 123;
        },
        isVerticalMovement: function( k ) {
            return ~[ KEY.UP, KEY.DOWN ].indexOf( k );
        },
        isHorizontalMovement: function( k ) {
            return ~[ KEY.LEFT, KEY.RIGHT, KEY.BACKSPACE, KEY.DELETE ].indexOf( k );
        },
        toSeparator: function( k ) {
            var sep = {
                ENTER: "\n",
                TAB: "\t",
                SPACE: " "
            }[ k ];
            if ( sep ) return sep;
            // return undefined for special keys other than enter, tab or space.
            // no way to use them to cut strings.
            return KEY[ k ] ? undefined : k;
        }
    };

    /**
     * Add querySelectorAll() to jqLite.
     *
     * jqLite find() is limited to lookups by tag name.
     * TODO This will change with future versions of AngularJS, to be removed when this happens
     *
     * See jqLite.find - why not use querySelectorAll? https://github.com/angular/angular.js/issues/3586
     * See feat(jqLite): use querySelectorAll instead of getElementsByTagName in jqLite.find https://github.com/angular/angular.js/pull/3598
     */
    if ( angular.element.prototype.querySelectorAll === undefined ) {
        angular.element.prototype.querySelectorAll = function( selector ) {
            return angular.element( this[ 0 ].querySelectorAll( selector ) );
        };
    }

    /**
     * Add closest() to jqLite.
     */
    if ( angular.element.prototype.closest === undefined ) {
        angular.element.prototype.closest = function( selector ) {
            var elem = this[ 0 ];
            var matchesSelector = elem.matches || elem.webkitMatchesSelector || elem.mozMatchesSelector || elem.msMatchesSelector;

            while ( elem ) {
                if ( matchesSelector.bind( elem )( selector ) ) {
                    return elem;
                } else {
                    elem = elem.parentElement;
                }
            }
            return false;
        };
    }

    var latestId = 0;

    var uis = angular.module( 'ui.select', [] )

    .constant( 'uiSelectConfig', {
        theme: 'bootstrap',
        searchEnabled: true,
        sortable: false,
        placeholder: '', // Empty by default, like HTML tag <select>
        refreshDelay: 1000, // In milliseconds
        closeOnSelect: true,
        skipFocusser: false,
        dropdownPosition: 'auto',
        removeSelected: true,
        generateId: function() {
            return latestId++;
        },
        appendToBody: false
    } )

    // See Rename minErr and make it accessible from outside https://github.com/angular/angular.js/issues/6913
    .service( 'uiSelectMinErr', function() {
        var minErr = angular.$$minErr( 'ui.select' );
        return function() {
            var error = minErr.apply( this, arguments );
            var message = error.message.replace( new RegExp( '\nhttp://errors.angularjs.org/.*' ), '' );
            return new Error( message );
        };
    } )

    // Recreates old behavior of ng-transclude. Used internally.
    .directive( 'uisTranscludeAppend', function() {
        return {
            link: function( scope, element, attrs, ctrl, transclude ) {
                transclude( scope, function( clone ) {
                    element.append( clone );
                } );
            }
        };
    } )

    /**
     * Highlights text that matches $select.search.
     *
     * Taken from AngularUI Bootstrap Typeahead
     * See https://github.com/angular-ui/bootstrap/blob/0.10.0/src/typeahead/typeahead.js#L340
     */
    .filter( 'highlight', function() {
        function escapeRegexp( queryToEscape ) {
            return ( '' + queryToEscape ).replace( /([.?*+^$[\]\\(){}|-])/g, '\\$1' );
        }

        return function( matchItem, query ) {
            return query && matchItem ? ( '' + matchItem ).replace( new RegExp( escapeRegexp( query ), 'gi' ), '<span class="ui-select-highlight">$&</span>' ) : matchItem;
        };
    } )

    /**
     * A read-only equivalent of jQuery's offset function: http://api.jquery.com/offset/
     *
     * Taken from AngularUI Bootstrap Position:
     * See https://github.com/angular-ui/bootstrap/blob/master/src/position/position.js#L70
     */
    .factory( 'uisOffset', [ '$document', '$window',
        function( $document, $window ) {

            return function( element ) {
                var boundingClientRect = element[ 0 ].getBoundingClientRect();
                return {
                    width: boundingClientRect.width || element.prop( 'offsetWidth' ),
                    height: boundingClientRect.height || element.prop( 'offsetHeight' ),
                    top: boundingClientRect.top + ( $window.pageYOffset || $document[ 0 ].documentElement.scrollTop ),
                    left: boundingClientRect.left + ( $window.pageXOffset || $document[ 0 ].documentElement.scrollLeft )
                };
            };
        }
    ] );

    uis.directive( 'uiSelectChoices', [ 'uiSelectConfig', 'uisRepeatParser', 'uiSelectMinErr', '$compile', '$window',
        function( uiSelectConfig, RepeatParser, uiSelectMinErr, $compile, $window ) {

            return {
                restrict: 'EA',
                require: '^uiSelect',
                replace: true,
                transclude: true,
                templateUrl: function( tElement ) {
                    // Needed so the uiSelect can detect the transcluded content
                    tElement.addClass( 'ui-select-choices' );

                    // Gets theme attribute from parent (ui-select)
                    var theme = tElement.parent().attr( 'theme' ) || uiSelectConfig.theme;
                    return theme + '/choices.tpl.html';
                },

                compile: function( tElement, tAttrs ) {

                    if ( !tAttrs.repeat ) throw uiSelectMinErr( 'repeat', "Expected 'repeat' expression." );

                    // var repeat = RepeatParser.parse(attrs.repeat);
                    var groupByExp = tAttrs.groupBy;
                    var groupFilterExp = tAttrs.groupFilter;

                    if ( groupByExp ) {
                        var groups = tElement.querySelectorAll( '.ui-select-choices-group' );
                        if ( groups.length !== 1 ) throw uiSelectMinErr( 'rows', "Expected 1 .ui-select-choices-group but got '{0}'.", groups.length );
                        groups.attr( 'ng-repeat', RepeatParser.getGroupNgRepeatExpression() );
                    }

                    var parserResult = RepeatParser.parse( tAttrs.repeat );

                    var choices = tElement.querySelectorAll( '.ui-select-choices-row' );
                    if ( choices.length !== 1 ) {
                        throw uiSelectMinErr( 'rows', "Expected 1 .ui-select-choices-row but got '{0}'.", choices.length );
                    }

                    choices.attr( 'ng-repeat', parserResult.repeatExpression( groupByExp ) )
                        .attr( 'ng-if', '$select.open' ); //Prevent unnecessary watches when dropdown is closed


                    var rowsInner = tElement.querySelectorAll( '.ui-select-choices-row-inner' );
                    if ( rowsInner.length !== 1 ) {
                        throw uiSelectMinErr( 'rows', "Expected 1 .ui-select-choices-row-inner but got '{0}'.", rowsInner.length );
                    }
                    rowsInner.attr( 'uis-transclude-append', '' ); //Adding uisTranscludeAppend directive to row element after choices element has ngRepeat

                    // If IE8 then need to target rowsInner to apply the ng-click attr as choices will not capture the event. 
                    var clickTarget = $window.document.addEventListener ? choices : rowsInner;
                    clickTarget.attr( 'ng-click', '$select.select(' + parserResult.itemName + ',$select.skipFocusser,$event)' );

                    return function link( scope, element, attrs, $select ) {


                        $select.parseRepeatAttr( attrs.repeat, groupByExp, groupFilterExp ); //Result ready at $select.parserResult

                        $select.disableChoiceExpression = attrs.uiDisableChoice;
                        $select.onHighlightCallback = attrs.onHighlight;

                        $select.dropdownPosition = attrs.position ? attrs.position.toLowerCase() : uiSelectConfig.dropdownPosition;

                        scope.$on( '$destroy', function() {
                            choices.remove();
                        } );

                        scope.$watch( '$select.search', function( newValue ) {
                            if ( newValue && !$select.open && $select.multiple ) $select.activate( false, true );
                            $select.activeIndex = $select.tagging.isActivated ? -1 : 0;
                            if ( !attrs.minimumInputLength || $select.search.length >= attrs.minimumInputLength ) {
                                $select.refresh( attrs.refresh );
                            } else {
                                $select.items = [];
                            }
                        } );

                        attrs.$observe( 'refreshDelay', function() {
                            // $eval() is needed otherwise we get a string instead of a number
                            var refreshDelay = scope.$eval( attrs.refreshDelay );
                            $select.refreshDelay = refreshDelay !== undefined ? refreshDelay : uiSelectConfig.refreshDelay;
                        } );
                    };
                }
            };
        }
    ] );

    /**
     * Contains ui-select "intelligence".
     *
     * The goal is to limit dependency on the DOM whenever possible and
     * put as much logic in the controller (instead of the link functions) as possible so it can be easily tested.
     */
    uis.controller( 'uiSelectCtrl', [ '$scope', '$element', '$timeout', '$filter', '$$uisDebounce', 'uisRepeatParser', 'uiSelectMinErr', 'uiSelectConfig', '$parse', '$injector', '$window',
        function( $scope, $element, $timeout, $filter, $$uisDebounce, RepeatParser, uiSelectMinErr, uiSelectConfig, $parse, $injector, $window ) {

            var ctrl = this;

            var EMPTY_SEARCH = '';

            ctrl.placeholder = uiSelectConfig.placeholder;
            ctrl.searchEnabled = uiSelectConfig.searchEnabled;
            ctrl.sortable = uiSelectConfig.sortable;
            ctrl.refreshDelay = uiSelectConfig.refreshDelay;
            ctrl.paste = uiSelectConfig.paste;

            ctrl.removeSelected = uiSelectConfig.removeSelected; //If selected item(s) should be removed from dropdown list
            ctrl.closeOnSelect = true; //Initialized inside uiSelect directive link function
            ctrl.skipFocusser = false; //Set to true to avoid returning focus to ctrl when item is selected
            ctrl.search = EMPTY_SEARCH;

            ctrl.activeIndex = 0; //Dropdown of choices
            ctrl.items = []; //All available choices

            ctrl.open = false;
            ctrl.focus = false;
            ctrl.disabled = false;
            ctrl.selected = undefined;

            ctrl.dropdownPosition = 'auto';

            ctrl.focusser = undefined; //Reference to input element used to handle focus events
            ctrl.resetSearchInput = true;
            ctrl.multiple = undefined; // Initialized inside uiSelect directive link function
            ctrl.disableChoiceExpression = undefined; // Initialized inside uiSelectChoices directive link function
            ctrl.tagging = {
                isActivated: false,
                fct: undefined
            };
            ctrl.taggingTokens = {
                isActivated: false,
                tokens: undefined
            };
            ctrl.lockChoiceExpression = undefined; // Initialized inside uiSelectMatch directive link function
            ctrl.clickTriggeredSelect = false;
            ctrl.$filter = $filter;
            ctrl.$element = $element;

            // Use $injector to check for $animate and store a reference to it
            ctrl.$animate = ( function() {
                try {
                    return $injector.get( '$animate' );
                } catch ( err ) {
                    // $animate does not exist
                    return null;
                }
            } )();

            ctrl.searchInput = $element.querySelectorAll( 'input.ui-select-search' );
            if ( ctrl.searchInput.length !== 1 ) {
                throw uiSelectMinErr( 'searchInput', "Expected 1 input.ui-select-search but got '{0}'.", ctrl.searchInput.length );
            }

            ctrl.isEmpty = function() {
                return angular.isUndefined( ctrl.selected ) || ctrl.selected === null || ctrl.selected === '' || ( ctrl.multiple && ctrl.selected.length === 0 );
            };

            function _findIndex( collection, predicate, thisArg ) {
                if ( collection.findIndex ) {
                    return collection.findIndex( predicate, thisArg );
                } else {
                    var list = Object( collection );
                    var length = list.length >>> 0;
                    var value;

                    for ( var i = 0; i < length; i++ ) {
                        value = list[ i ];
                        if ( predicate.call( thisArg, value, i, list ) ) {
                            return i;
                        }
                    }
                    return -1;
                }
            }

            // Most of the time the user does not want to empty the search input when in typeahead mode
            function _resetSearchInput() {
                if ( ctrl.resetSearchInput || ( ctrl.resetSearchInput === undefined && uiSelectConfig.resetSearchInput ) ) {
                    ctrl.search = EMPTY_SEARCH;
                    //reset activeIndex
                    if ( ctrl.selected && ctrl.items.length && !ctrl.multiple ) {
                        ctrl.activeIndex = _findIndex( ctrl.items, function( item ) {
                            return angular.equals( this, item );
                        }, ctrl.selected );
                    }
                }
            }

            function _groupsFilter( groups, groupNames ) {
                var i, j, result = [];
                for ( i = 0; i < groupNames.length; i++ ) {
                    for ( j = 0; j < groups.length; j++ ) {
                        if ( groups[ j ].name == [ groupNames[ i ] ] ) {
                            result.push( groups[ j ] );
                        }
                    }
                }
                return result;
            }

            // When the user clicks on ui-select, displays the dropdown list
            ctrl.activate = function( initSearchValue, avoidReset ) {
                if ( !ctrl.disabled && !ctrl.open ) {
                    if ( !avoidReset ) _resetSearchInput();

                    $scope.$broadcast( 'uis:activate' );

                    ctrl.open = true;

                    ctrl.activeIndex = ctrl.activeIndex >= ctrl.items.length ? 0 : ctrl.activeIndex;

                    // ensure that the index is set to zero for tagging variants
                    // that where first option is auto-selected
                    if ( ctrl.activeIndex === -1 && ctrl.taggingLabel !== false ) {
                        ctrl.activeIndex = 0;
                    }

                    var container = $element.querySelectorAll( '.ui-select-choices-content' );
                    var searchInput = $element.querySelectorAll( '.ui-select-search' );
                    if ( ctrl.$animate && ctrl.$animate.on && ctrl.$animate.enabled( container[ 0 ] ) ) {
                        var animateHandler = function( elem, phase ) {
                            if ( phase === 'start' && ctrl.items.length === 0 ) {
                                // Only focus input after the animation has finished
                                ctrl.$animate.off( 'removeClass', searchInput[ 0 ], animateHandler );
                                $timeout( function() {
                                    ctrl.focusSearchInput( initSearchValue );
                                } );
                            } else if ( phase === 'close' ) {
                                // Only focus input after the animation has finished
                                ctrl.$animate.off( 'enter', container[ 0 ], animateHandler );
                                $timeout( function() {
                                    ctrl.focusSearchInput( initSearchValue );
                                } );
                            }
                        };

                        if ( ctrl.items.length > 0 ) {
                            ctrl.$animate.on( 'enter', container[ 0 ], animateHandler );
                        } else {
                            ctrl.$animate.on( 'removeClass', searchInput[ 0 ], animateHandler );
                        }
                    } else {
                        $timeout( function() {
                            ctrl.focusSearchInput( initSearchValue );
                            if ( !ctrl.tagging.isActivated && ctrl.items.length > 1 ) {
                                _ensureHighlightVisible();
                            }
                        } );
                    }
                }
            };

            ctrl.focusSearchInput = function( initSearchValue ) {
                ctrl.search = initSearchValue || ctrl.search;
                ctrl.searchInput[ 0 ].focus();
            };

            ctrl.findGroupByName = function( name ) {
                return ctrl.groups && ctrl.groups.filter( function( group ) {
                    return group.name === name;
                } )[ 0 ];
            };

            ctrl.parseRepeatAttr = function( repeatAttr, groupByExp, groupFilterExp ) {
                function updateGroups( items ) {
                    var groupFn = $scope.$eval( groupByExp );
                    ctrl.groups = [];
                    angular.forEach( items, function( item ) {
                        var groupName = angular.isFunction( groupFn ) ? groupFn( item ) : item[ groupFn ];
                        var group = ctrl.findGroupByName( groupName );
                        if ( group ) {
                            group.items.push( item );
                        } else {
                            ctrl.groups.push( {
                                name: groupName,
                                items: [ item ]
                            } );
                        }
                    } );
                    if ( groupFilterExp ) {
                        var groupFilterFn = $scope.$eval( groupFilterExp );
                        if ( angular.isFunction( groupFilterFn ) ) {
                            ctrl.groups = groupFilterFn( ctrl.groups );
                        } else if ( angular.isArray( groupFilterFn ) ) {
                            ctrl.groups = _groupsFilter( ctrl.groups, groupFilterFn );
                        }
                    }
                    ctrl.items = [];
                    ctrl.groups.forEach( function( group ) {
                        ctrl.items = ctrl.items.concat( group.items );
                    } );
                }

                function setPlainItems( items ) {
                    ctrl.items = items;
                }

                ctrl.setItemsFn = groupByExp ? updateGroups : setPlainItems;

                ctrl.parserResult = RepeatParser.parse( repeatAttr );

                ctrl.isGrouped = !!groupByExp;
                ctrl.itemProperty = ctrl.parserResult.itemName;

                //If collection is an Object, convert it to Array

                var originalSource = ctrl.parserResult.source;

                //When an object is used as source, we better create an array and use it as 'source'
                var createArrayFromObject = function() {
                    var origSrc = originalSource( $scope );
                    $scope.$uisSource = Object.keys( origSrc ).map( function( v ) {
                        var result = {};
                        result[ ctrl.parserResult.keyName ] = v;
                        result.value = origSrc[ v ];
                        return result;
                    } );
                };

                if ( ctrl.parserResult.keyName ) { // Check for (key,value) syntax
                    createArrayFromObject();
                    ctrl.parserResult.source = $parse( '$uisSource' + ctrl.parserResult.filters );
                    $scope.$watch( originalSource, function( newVal, oldVal ) {
                        if ( newVal !== oldVal ) createArrayFromObject();
                    }, true );
                }

                ctrl.refreshItems = function( data ) {
                    data = data || ctrl.parserResult.source( $scope );
                    var selectedItems = ctrl.selected;
                    //TODO should implement for single mode removeSelected
                    if ( ctrl.isEmpty() || ( angular.isArray( selectedItems ) && !selectedItems.length ) || !ctrl.removeSelected ) {
                        ctrl.setItemsFn( data );
                    } else {
                        if ( data !== undefined && data !== null ) {
                            var filteredItems = data.filter( function( i ) {
                                return angular.isArray( selectedItems ) ? selectedItems.every( function( selectedItem ) {
                                    return !angular.equals( i, selectedItem );
                                } ) : !angular.equals( i, selectedItems );
                            } );
                            ctrl.setItemsFn( filteredItems );
                        }
                    }
                    if ( ctrl.dropdownPosition === 'auto' || ctrl.dropdownPosition === 'up' ) {
                        $scope.calculateDropdownPos();
                    }

                    $scope.$broadcast( 'uis:refresh' );
                };

                // See https://github.com/angular/angular.js/blob/v1.2.15/src/ng/directive/ngRepeat.js#L259
                $scope.$watchCollection( ctrl.parserResult.source, function( items ) {
                    if ( items === undefined || items === null ) {
                        // If the user specifies undefined or null => reset the collection
                        // Special case: items can be undefined if the user did not initialized the collection on the scope
                        // i.e $scope.addresses = [] is missing
                        ctrl.items = [];
                    } else {
                        if ( !angular.isArray( items ) ) {
                            throw uiSelectMinErr( 'items', "Expected an array but got '{0}'.", items );
                        } else {
                            //Remove already selected items (ex: while searching)
                            //TODO Should add a test
                            ctrl.refreshItems( items );

                            //update the view value with fresh data from items, if there is a valid model value
                            if ( angular.isDefined( ctrl.ngModel.$modelValue ) ) {
                                ctrl.ngModel.$modelValue = null; //Force scope model value and ngModel value to be out of sync to re-run formatters
                            }
                        }
                    }
                } );

            };

            var _refreshDelayPromise;

            /**
             * Typeahead mode: lets the user refresh the collection using his own function.
             *
             * See Expose $select.search for external / remote filtering https://github.com/angular-ui/ui-select/pull/31
             */
            ctrl.refresh = function( refreshAttr ) {
                if ( refreshAttr !== undefined ) {

                    // Debounce
                    // See https://github.com/angular-ui/bootstrap/blob/0.10.0/src/typeahead/typeahead.js#L155
                    // FYI AngularStrap typeahead does not have debouncing: https://github.com/mgcrea/angular-strap/blob/v2.0.0-rc.4/src/typeahead/typeahead.js#L177
                    if ( _refreshDelayPromise ) {
                        $timeout.cancel( _refreshDelayPromise );
                    }
                    _refreshDelayPromise = $timeout( function() {
                        $scope.$eval( refreshAttr );
                    }, ctrl.refreshDelay );
                }
            };

            ctrl.isActive = function( itemScope ) {
                if ( !ctrl.open ) {
                    return false;
                }
                var itemIndex = ctrl.items.indexOf( itemScope[ ctrl.itemProperty ] );
                var isActive = itemIndex == ctrl.activeIndex;

                if ( !isActive || itemIndex < 0 ) {
                    return false;
                }

                if ( isActive && !angular.isUndefined( ctrl.onHighlightCallback ) ) {
                    itemScope.$eval( ctrl.onHighlightCallback );
                }

                return isActive;
            };

            var _isItemSelected = function( item ) {
                return ( ctrl.selected && angular.isArray( ctrl.selected ) &&
                    ctrl.selected.filter( function( selection ) {
                        return angular.equals( selection, item );
                    } ).length > 0 );
            };

            ctrl.isDisabled = function( itemScope ) {

                if ( !ctrl.open ) return;

                var itemIndex = ctrl.items.indexOf( itemScope[ ctrl.itemProperty ] );
                var isDisabled = false;
                var item;

                if ( itemIndex >= 0 && ( !angular.isUndefined( ctrl.disableChoiceExpression ) || ctrl.multiple ) ) {
                    item = ctrl.items[ itemIndex ];
                    isDisabled = !!( itemScope.$eval( ctrl.disableChoiceExpression ) ) || _isItemSelected( item ); // force the boolean value
                    item._uiSelectChoiceDisabled = isDisabled; // store this for later reference
                }

                return isDisabled;
            };


            // When the user selects an item with ENTER or clicks the dropdown
            ctrl.select = function( item, skipFocusser, $event ) {
                if ( item === undefined || !item._uiSelectChoiceDisabled ) {

                    if ( !ctrl.items && !ctrl.search && !ctrl.tagging.isActivated ) return;

                    if ( !item || !item._uiSelectChoiceDisabled ) {
                        if ( ctrl.tagging.isActivated ) {
                            // if taggingLabel is disabled, we pull from ctrl.search val
                            if ( ctrl.taggingLabel === false ) {
                                if ( ctrl.activeIndex < 0 ) {
                                    item = ctrl.tagging.fct !== undefined ? ctrl.tagging.fct( ctrl.search ) : ctrl.search;
                                    if ( !item || angular.equals( ctrl.items[ 0 ], item ) ) {
                                        return;
                                    }
                                } else {
                                    // keyboard nav happened first, user selected from dropdown
                                    item = ctrl.items[ ctrl.activeIndex ];
                                }
                            } else {
                                // tagging always operates at index zero, taggingLabel === false pushes
                                // the ctrl.search value without having it injected
                                if ( ctrl.activeIndex === 0 ) {
                                    // ctrl.tagging pushes items to ctrl.items, so we only have empty val
                                    // for `item` if it is a detected duplicate
                                    if ( item === undefined ) return;

                                    // create new item on the fly if we don't already have one;
                                    // use tagging function if we have one
                                    if ( ctrl.tagging.fct !== undefined && typeof item === 'string' ) {
                                        item = ctrl.tagging.fct( item );
                                        if ( !item ) return;
                                        // if item type is 'string', apply the tagging label
                                    } else if ( typeof item === 'string' ) {
                                        // trim the trailing space
                                        item = item.replace( ctrl.taggingLabel, '' ).trim();
                                    }
                                }
                            }
                            // search ctrl.selected for dupes potentially caused by tagging and return early if found
                            if ( _isItemSelected( item ) ) {
                                ctrl.close( skipFocusser );
                                return;
                            }
                        }

                        $scope.$broadcast( 'uis:select', item );

                        var locals = {};
                        locals[ ctrl.parserResult.itemName ] = item;

                        $timeout( function() {
                            ctrl.onSelectCallback( $scope, {
                                $item: item,
                                $model: ctrl.parserResult.modelMapper( $scope, locals )
                            } );
                        } );

                        if ( ctrl.closeOnSelect ) {
                            ctrl.close( skipFocusser );
                        }
                        if ( $event && $event.type === 'click' ) {
                            ctrl.clickTriggeredSelect = true;
                        }
                    }
                }
            };

            // Closes the dropdown
            ctrl.close = function( skipFocusser ) {
                if ( !ctrl.open ) return;
                if ( ctrl.ngModel && ctrl.ngModel.$setTouched ) ctrl.ngModel.$setTouched();
                _resetSearchInput();
                ctrl.open = false;

                $scope.$broadcast( 'uis:close', skipFocusser );

            };

            ctrl.setFocus = function() {
                if ( !ctrl.focus ) ctrl.focusInput[ 0 ].focus();
            };

            ctrl.clear = function( $event ) {
                ctrl.select( undefined );
                $event.stopPropagation();
                $timeout( function() {
                    ctrl.focusser[ 0 ].focus();
                }, 0, false );
            };

            // Toggle dropdown
            ctrl.toggle = function( e ) {
                if ( ctrl.open ) {
                    ctrl.close();
                    e.preventDefault();
                    e.stopPropagation();
                } else {
                    ctrl.activate();
                }
            };

            ctrl.isLocked = function( itemScope, itemIndex ) {
                var isLocked, item = ctrl.selected[ itemIndex ];

                if ( item && !angular.isUndefined( ctrl.lockChoiceExpression ) ) {
                    isLocked = !!( itemScope.$eval( ctrl.lockChoiceExpression ) ); // force the boolean value
                    item._uiSelectChoiceLocked = isLocked; // store this for later reference
                }

                return isLocked;
            };

            var sizeWatch = null;
            var updaterScheduled = false;
            ctrl.sizeSearchInput = function() {

                var input = ctrl.searchInput[ 0 ],
                    container = ctrl.searchInput.parent().parent()[ 0 ],
                    calculateContainerWidth = function() {
                        // Return the container width only if the search input is visible
                        return container.clientWidth * !!input.offsetParent;
                    },
                    updateIfVisible = function( containerWidth ) {
                        if ( containerWidth === 0 ) {
                            return false;
                        }
                        var inputWidth = containerWidth - input.offsetLeft - 10;
                        if ( inputWidth < 50 ) inputWidth = containerWidth;
                        ctrl.searchInput.css( 'width', inputWidth + 'px' );
                        return true;
                    };

                ctrl.searchInput.css( 'width', '10px' );
                $timeout( function() { //Give tags time to render correctly
                    if ( sizeWatch === null && !updateIfVisible( calculateContainerWidth() ) ) {
                        sizeWatch = $scope.$watch( function() {
                            if ( !updaterScheduled ) {
                                updaterScheduled = true;
                                $scope.$$postDigest( function() {
                                    updaterScheduled = false;
                                    if ( updateIfVisible( calculateContainerWidth() ) ) {
                                        sizeWatch();
                                        sizeWatch = null;
                                    }
                                } );
                            }
                        }, angular.noop );
                    }
                } );
            };

            function _handleDropDownSelection( key ) {
                var processed = true;
                switch ( key ) {
                    case KEY.DOWN:
                        if ( !ctrl.open && ctrl.multiple ) ctrl.activate( false, true ); //In case its the search input in 'multiple' mode
                        else if ( ctrl.activeIndex < ctrl.items.length - 1 ) {
                            ctrl.activeIndex++;
                        }
                        break;
                    case KEY.UP:
                        if ( !ctrl.open && ctrl.multiple ) ctrl.activate( false, true ); //In case its the search input in 'multiple' mode
                        else if ( ctrl.activeIndex > 0 || ( ctrl.search.length === 0 && ctrl.tagging.isActivated && ctrl.activeIndex > -1 ) ) {
                            ctrl.activeIndex--;
                        }
                        break;
                    case KEY.TAB:
                        if ( !ctrl.multiple || ctrl.open ) ctrl.select( ctrl.items[ ctrl.activeIndex ], true );
                        break;
                    case KEY.ENTER:
                        if ( ctrl.open && ( ctrl.tagging.isActivated || ctrl.activeIndex >= 0 ) ) {
                            ctrl.select( ctrl.items[ ctrl.activeIndex ], ctrl.skipFocusser ); // Make sure at least one dropdown item is highlighted before adding if not in tagging mode
                        } else {
                            ctrl.activate( false, true ); //In case its the search input in 'multiple' mode
                        }
                        break;
                    case KEY.ESC:
                        ctrl.close();
                        break;
                    default:
                        processed = false;
                }
                return processed;
            }

            // Bind to keyboard shortcuts
            ctrl.searchInput.on( 'keydown', function( e ) {

                var key = e.which;

                if ( ~[ KEY.ENTER, KEY.ESC ].indexOf( key ) ) {
                    e.preventDefault();
                    e.stopPropagation();
                }

                // if(~[KEY.ESC,KEY.TAB].indexOf(key)){
                //   //TODO: SEGURO?
                //   ctrl.close();
                // }

                $scope.$apply( function() {

                    var tagged = false;

                    if ( ctrl.items.length > 0 || ctrl.tagging.isActivated ) {
                        _handleDropDownSelection( key );
                        if ( ctrl.taggingTokens.isActivated ) {
                            for ( var i = 0; i < ctrl.taggingTokens.tokens.length; i++ ) {
                                if ( ctrl.taggingTokens.tokens[ i ] === KEY.MAP[ e.keyCode ] ) {
                                    // make sure there is a new value to push via tagging
                                    if ( ctrl.search.length > 0 ) {
                                        tagged = true;
                                    }
                                }
                            }
                            if ( tagged ) {
                                $timeout( function() {
                                    ctrl.searchInput.triggerHandler( 'tagged' );
                                    var newItem = ctrl.search.replace( KEY.MAP[ e.keyCode ], '' ).trim();
                                    if ( ctrl.tagging.fct ) {
                                        newItem = ctrl.tagging.fct( newItem );
                                    }
                                    if ( newItem ) ctrl.select( newItem, true );
                                } );
                            }
                        }
                    }

                } );

                if ( KEY.isVerticalMovement( key ) && ctrl.items.length > 0 ) {
                    _ensureHighlightVisible();
                }

                if ( key === KEY.ENTER || key === KEY.ESC ) {
                    e.preventDefault();
                    e.stopPropagation();
                }

            } );

            ctrl.searchInput.on( 'paste', function( e ) {
                var data;

                if ( window.clipboardData && window.clipboardData.getData ) { // IE
                    data = window.clipboardData.getData( 'Text' );
                } else {
                    data = ( e.originalEvent || e ).clipboardData.getData( 'text/plain' );
                }

                // Prepend the current input field text to the paste buffer.
                data = ctrl.search + data;

                if ( data && data.length > 0 ) {
                    // If tagging try to split by tokens and add items
                    if ( ctrl.taggingTokens.isActivated ) {
                        var items = [];
                        for ( var i = 0; i < ctrl.taggingTokens.tokens.length; i++ ) { // split by first token that is contained in data
                            var separator = KEY.toSeparator( ctrl.taggingTokens.tokens[ i ] ) || ctrl.taggingTokens.tokens[ i ];
                            if ( data.indexOf( separator ) > -1 ) {
                                items = data.split( separator );
                                break; // only split by one token
                            }
                        }
                        if ( items.length === 0 ) {
                            items = [ data ];
                        }
                        if ( items.length > 0 ) {
                            var oldsearch = ctrl.search;
                            angular.forEach( items, function( item ) {
                                var newItem = ctrl.tagging.fct ? ctrl.tagging.fct( item ) : item;
                                if ( newItem ) {
                                    ctrl.select( newItem, true );
                                }
                            } );
                            ctrl.search = oldsearch || EMPTY_SEARCH;
                            e.preventDefault();
                            e.stopPropagation();
                        }
                    } else if ( ctrl.paste ) {
                        ctrl.paste( data );
                        ctrl.search = EMPTY_SEARCH;
                        e.preventDefault();
                        e.stopPropagation();
                    }
                }
            } );

            ctrl.searchInput.on( 'tagged', function() {
                $timeout( function() {
                    _resetSearchInput();
                } );
            } );

            // See https://github.com/ivaynberg/select2/blob/3.4.6/select2.js#L1431
            function _ensureHighlightVisible() {
                var container = $element.querySelectorAll( '.ui-select-choices-content' );
                var choices = container.querySelectorAll( '.ui-select-choices-row' );
                if ( choices.length < 1 ) {
                    throw uiSelectMinErr( 'choices', "Expected multiple .ui-select-choices-row but got '{0}'.", choices.length );
                }

                if ( ctrl.activeIndex < 0 ) {
                    return;
                }

                var highlighted = choices[ ctrl.activeIndex ];
                var posY = highlighted.offsetTop + highlighted.clientHeight - container[ 0 ].scrollTop;
                var height = container[ 0 ].offsetHeight;

                if ( posY > height ) {
                    container[ 0 ].scrollTop += posY - height;
                } else if ( posY < highlighted.clientHeight ) {
                    if ( ctrl.isGrouped && ctrl.activeIndex === 0 )
                        container[ 0 ].scrollTop = 0; //To make group header visible when going all the way up
                    else
                        container[ 0 ].scrollTop -= highlighted.clientHeight - posY;
                }
            }

            var onResize = $$uisDebounce( function() {
                ctrl.sizeSearchInput();
            }, 50 );

            angular.element( $window ).bind( 'resize', onResize );

            $scope.$on( '$destroy', function() {
                ctrl.searchInput.off( 'keyup keydown tagged blur paste' );
                angular.element( $window ).off( 'resize', onResize );
            } );
        }
    ] );

    uis.directive( 'uiSelect', [ '$document', 'uiSelectConfig', 'uiSelectMinErr', 'uisOffset', '$compile', '$parse', '$timeout',
        function( $document, uiSelectConfig, uiSelectMinErr, uisOffset, $compile, $parse, $timeout ) {

            return {
                restrict: 'EA',
                templateUrl: function( tElement, tAttrs ) {
                    var theme = tAttrs.theme || uiSelectConfig.theme;
                    return theme + ( angular.isDefined( tAttrs.multiple ) ? '/select-multiple.tpl.html' : '/select.tpl.html' );
                },
                replace: true,
                transclude: true,
                require: [ 'uiSelect', '^ngModel' ],
                scope: true,

                controller: 'uiSelectCtrl',
                controllerAs: '$select',
                compile: function( tElement, tAttrs ) {

                    // Allow setting ngClass on uiSelect
                    var match = /{(.*)}\s*{(.*)}/.exec( tAttrs.ngClass );
                    if ( match ) {
                        var combined = '{' + match[ 1 ] + ', ' + match[ 2 ] + '}';
                        tAttrs.ngClass = combined;
                        tElement.attr( 'ng-class', combined );
                    }

                    //Multiple or Single depending if multiple attribute presence
                    if ( angular.isDefined( tAttrs.multiple ) )
                        tElement.append( '<ui-select-multiple/>' ).removeAttr( 'multiple' );
                    else
                        tElement.append( '<ui-select-single/>' );

                    if ( tAttrs.inputId )
                        tElement.querySelectorAll( 'input.ui-select-search' )[ 0 ].id = tAttrs.inputId;

                    return function( scope, element, attrs, ctrls, transcludeFn ) {

                        var $select = ctrls[ 0 ];
                        var ngModel = ctrls[ 1 ];

                        $select.generatedId = uiSelectConfig.generateId();
                        $select.baseTitle = attrs.title || 'Select box';
                        $select.focusserTitle = $select.baseTitle + ' focus';
                        $select.focusserId = 'focusser-' + $select.generatedId;

                        $select.closeOnSelect = function() {
                            if ( angular.isDefined( attrs.closeOnSelect ) ) {
                                return $parse( attrs.closeOnSelect )();
                            } else {
                                return uiSelectConfig.closeOnSelect;
                            }
                        }();

                        scope.$watch( 'skipFocusser', function() {
                            var skipFocusser = scope.$eval( attrs.skipFocusser );
                            $select.skipFocusser = skipFocusser !== undefined ? skipFocusser : uiSelectConfig.skipFocusser;
                        } );

                        $select.onSelectCallback = $parse( attrs.onSelect );
                        $select.onRemoveCallback = $parse( attrs.onRemove );

                        //Set reference to ngModel from uiSelectCtrl
                        $select.ngModel = ngModel;

                        $select.choiceGrouped = function( group ) {
                            return $select.isGrouped && group && group.name;
                        };

                        if ( attrs.tabindex ) {
                            attrs.$observe( 'tabindex', function( value ) {
                                $select.focusInput.attr( 'tabindex', value );
                                element.removeAttr( 'tabindex' );
                            } );
                        }

                        scope.$watch( 'searchEnabled', function() {
                            var searchEnabled = scope.$eval( attrs.searchEnabled );
                            $select.searchEnabled = searchEnabled !== undefined ? searchEnabled : uiSelectConfig.searchEnabled;
                        } );

                        scope.$watch( 'sortable', function() {
                            var sortable = scope.$eval( attrs.sortable );
                            $select.sortable = sortable !== undefined ? sortable : uiSelectConfig.sortable;
                        } );

                        attrs.$observe( 'limit', function() {
                            //Limit the number of selections allowed
                            $select.limit = ( angular.isDefined( attrs.limit ) ) ? parseInt( attrs.limit, 10 ) : undefined;
                        } );

                        scope.$watch( 'removeSelected', function() {
                            var removeSelected = scope.$eval( attrs.removeSelected );
                            $select.removeSelected = removeSelected !== undefined ? removeSelected : uiSelectConfig.removeSelected;
                        } );

                        attrs.$observe( 'disabled', function() {
                            // No need to use $eval() (thanks to ng-disabled) since we already get a boolean instead of a string
                            $select.disabled = attrs.disabled !== undefined ? attrs.disabled : false;
                        } );

                        attrs.$observe( 'resetSearchInput', function() {
                            // $eval() is needed otherwise we get a string instead of a boolean
                            var resetSearchInput = scope.$eval( attrs.resetSearchInput );
                            $select.resetSearchInput = resetSearchInput !== undefined ? resetSearchInput : true;
                        } );

                        attrs.$observe( 'paste', function() {
                            $select.paste = scope.$eval( attrs.paste );
                        } );

                        attrs.$observe( 'tagging', function() {
                            if ( attrs.tagging !== undefined ) {
                                // $eval() is needed otherwise we get a string instead of a boolean
                                var taggingEval = scope.$eval( attrs.tagging );
                                $select.tagging = {
                                    isActivated: true,
                                    fct: taggingEval !== true ? taggingEval : undefined
                                };
                            } else {
                                $select.tagging = {
                                    isActivated: false,
                                    fct: undefined
                                };
                            }
                        } );

                        attrs.$observe( 'taggingLabel', function() {
                            if ( attrs.tagging !== undefined ) {
                                // check eval for FALSE, in this case, we disable the labels
                                // associated with tagging
                                if ( attrs.taggingLabel === 'false' ) {
                                    $select.taggingLabel = false;
                                } else {
                                    $select.taggingLabel = attrs.taggingLabel !== undefined ? attrs.taggingLabel : '(new)';
                                }
                            }
                        } );

                        attrs.$observe( 'taggingTokens', function() {
                            if ( attrs.tagging !== undefined ) {
                                var tokens = attrs.taggingTokens !== undefined ? attrs.taggingTokens.split( '|' ) : [ ',', 'ENTER' ];
                                $select.taggingTokens = {
                                    isActivated: true,
                                    tokens: tokens
                                };
                            }
                        } );

                        //Automatically gets focus when loaded
                        if ( angular.isDefined( attrs.autofocus ) ) {
                            $timeout( function() {
                                $select.setFocus();
                            } );
                        }

                        //Gets focus based on scope event name (e.g. focus-on='SomeEventName')
                        if ( angular.isDefined( attrs.focusOn ) ) {
                            scope.$on( attrs.focusOn, function() {
                                $timeout( function() {
                                    $select.setFocus();
                                } );
                            } );
                        }

                        function onDocumentClick( e ) {
                            if ( !$select.open ) return; //Skip it if dropdown is close

                            var contains = false;

                            if ( window.jQuery ) {
                                // Firefox 3.6 does not support element.contains()
                                // See Node.contains https://developer.mozilla.org/en-US/docs/Web/API/Node.contains
                                contains = window.jQuery.contains( element[ 0 ], e.target );
                            } else {
                                contains = element[ 0 ].contains( e.target );
                            }

                            if ( !contains && !$select.clickTriggeredSelect ) {
                                var skipFocusser;
                                if ( !$select.skipFocusser ) {
                                    //Will lose focus only with certain targets
                                    var focusableControls = [ 'input', 'button', 'textarea', 'select' ];
                                    var targetController = angular.element( e.target ).controller( 'uiSelect' ); //To check if target is other ui-select
                                    skipFocusser = targetController && targetController !== $select; //To check if target is other ui-select
                                    if ( !skipFocusser ) skipFocusser = ~focusableControls.indexOf( e.target.tagName.toLowerCase() ); //Check if target is input, button or textarea
                                } else {
                                    skipFocusser = true;
                                }
                                $select.close( skipFocusser );
                                scope.$digest();
                            }
                            $select.clickTriggeredSelect = false;
                        }

                        // See Click everywhere but here event http://stackoverflow.com/questions/12931369
                        $document.on( 'click', onDocumentClick );

                        scope.$on( '$destroy', function() {
                            $document.off( 'click', onDocumentClick );
                        } );

                        // Move transcluded elements to their correct position in main template
                        transcludeFn( scope, function( clone ) {
                            // See Transclude in AngularJS http://blog.omkarpatil.com/2012/11/transclude-in-angularjs.html

                            // One day jqLite will be replaced by jQuery and we will be able to write:
                            // var transcludedElement = clone.filter('.my-class')
                            // instead of creating a hackish DOM element:
                            var transcluded = angular.element( '<div>' ).append( clone );

                            var transcludedMatch = transcluded.querySelectorAll( '.ui-select-match' );
                            transcludedMatch.removeAttr( 'ui-select-match' ); //To avoid loop in case directive as attr
                            transcludedMatch.removeAttr( 'data-ui-select-match' ); // Properly handle HTML5 data-attributes
                            if ( transcludedMatch.length !== 1 ) {
                                throw uiSelectMinErr( 'transcluded', "Expected 1 .ui-select-match but got '{0}'.", transcludedMatch.length );
                            }
                            element.querySelectorAll( '.ui-select-match' ).replaceWith( transcludedMatch );

                            var transcludedChoices = transcluded.querySelectorAll( '.ui-select-choices' );
                            transcludedChoices.removeAttr( 'ui-select-choices' ); //To avoid loop in case directive as attr
                            transcludedChoices.removeAttr( 'data-ui-select-choices' ); // Properly handle HTML5 data-attributes
                            if ( transcludedChoices.length !== 1 ) {
                                throw uiSelectMinErr( 'transcluded', "Expected 1 .ui-select-choices but got '{0}'.", transcludedChoices.length );
                            }
                            element.querySelectorAll( '.ui-select-choices' ).replaceWith( transcludedChoices );

                            var transcludedNoChoice = transcluded.querySelectorAll( '.ui-select-no-choice' );
                            transcludedNoChoice.removeAttr( 'ui-select-no-choice' ); //To avoid loop in case directive as attr
                            transcludedNoChoice.removeAttr( 'data-ui-select-no-choice' ); // Properly handle HTML5 data-attributes
                            if ( transcludedNoChoice.length == 1 ) {
                                element.querySelectorAll( '.ui-select-no-choice' ).replaceWith( transcludedNoChoice );
                            }
                        } );

                        // Support for appending the select field to the body when its open
                        var appendToBody = scope.$eval( attrs.appendToBody );
                        if ( appendToBody !== undefined ? appendToBody : uiSelectConfig.appendToBody ) {
                            scope.$watch( '$select.open', function( isOpen ) {
                                if ( isOpen ) {
                                    positionDropdown();
                                } else {
                                    resetDropdown();
                                }
                            } );

                            // Move the dropdown back to its original location when the scope is destroyed. Otherwise
                            // it might stick around when the user routes away or the select field is otherwise removed
                            scope.$on( '$destroy', function() {
                                resetDropdown();
                            } );
                        }

                        // Hold on to a reference to the .ui-select-container element for appendToBody support
                        var placeholder = null,
                            originalWidth = '';

                        function positionDropdown() {
                            // Remember the absolute position of the element
                            var offset = uisOffset( element );

                            // Clone the element into a placeholder element to take its original place in the DOM
                            placeholder = angular.element( '<div class="ui-select-placeholder"></div>' );
                            placeholder[ 0 ].style.width = offset.width + 'px';
                            placeholder[ 0 ].style.height = offset.height + 'px';
                            element.after( placeholder );

                            // Remember the original value of the element width inline style, so it can be restored
                            // when the dropdown is closed
                            originalWidth = element[ 0 ].style.width;

                            // Now move the actual dropdown element to the end of the body
                            $document.find( 'body' ).append( element );

                            element[ 0 ].style.position = 'absolute';
                            element[ 0 ].style.left = offset.left + 'px';
                            element[ 0 ].style.top = offset.top + 'px';
                            element[ 0 ].style.width = offset.width + 'px';
                        }

                        function resetDropdown() {
                            if ( placeholder === null ) {
                                // The dropdown has not actually been display yet, so there's nothing to reset
                                return;
                            }

                            // Move the dropdown element back to its original location in the DOM
                            placeholder.replaceWith( element );
                            placeholder = null;

                            element[ 0 ].style.position = '';
                            element[ 0 ].style.left = '';
                            element[ 0 ].style.top = '';
                            element[ 0 ].style.width = originalWidth;

                            // Set focus back on to the moved element
                            $select.setFocus();
                        }

                        // Hold on to a reference to the .ui-select-dropdown element for direction support.
                        var dropdown = null,
                            directionUpClassName = 'direction-up';

                        // Support changing the direction of the dropdown if there isn't enough space to render it.
                        scope.$watch( '$select.open', function() {

                            if ( $select.dropdownPosition === 'auto' || $select.dropdownPosition === 'up' ) {
                                scope.calculateDropdownPos();
                            }

                        } );

                        var setDropdownPosUp = function( offset, offsetDropdown ) {

                            offset = offset || uisOffset( element );
                            offsetDropdown = offsetDropdown || uisOffset( dropdown );

                            dropdown[ 0 ].style.position = 'absolute';
                            dropdown[ 0 ].style.top = ( offsetDropdown.height * -1 ) + 'px';
                            element.addClass( directionUpClassName );

                        };

                        var setDropdownPosDown = function( offset, offsetDropdown ) {

                            element.removeClass( directionUpClassName );

                            offset = offset || uisOffset( element );
                            offsetDropdown = offsetDropdown || uisOffset( dropdown );

                            dropdown[ 0 ].style.position = '';
                            dropdown[ 0 ].style.top = '';

                        };

                        var calculateDropdownPosAfterAnimation = function() {
                            // Delay positioning the dropdown until all choices have been added so its height is correct.
                            $timeout( function() {
                                if ( $select.dropdownPosition === 'up' ) {
                                    //Go UP
                                    setDropdownPosUp();
                                } else {
                                    //AUTO
                                    element.removeClass( directionUpClassName );

                                    var offset = uisOffset( element );
                                    var offsetDropdown = uisOffset( dropdown );

                                    //https://code.google.com/p/chromium/issues/detail?id=342307#c4
                                    var scrollTop = $document[ 0 ].documentElement.scrollTop || $document[ 0 ].body.scrollTop; //To make it cross browser (blink, webkit, IE, Firefox).

                                    // Determine if the direction of the dropdown needs to be changed.
                                    if ( offset.top + offset.height + offsetDropdown.height > scrollTop + $document[ 0 ].documentElement.clientHeight ) {
                                        //Go UP
                                        setDropdownPosUp( offset, offsetDropdown );
                                    } else {
                                        //Go DOWN
                                        setDropdownPosDown( offset, offsetDropdown );
                                    }
                                }

                                // Display the dropdown once it has been positioned.
                                dropdown[ 0 ].style.opacity = 1;
                            } );
                        };

                        scope.calculateDropdownPos = function() {
                            if ( $select.open ) {
                                dropdown = angular.element( element ).querySelectorAll( '.ui-select-dropdown' );

                                if ( dropdown.length === 0 ) {
                                    return;
                                }

                                // Hide the dropdown so there is no flicker until $timeout is done executing.
                                dropdown[ 0 ].style.opacity = 0;

                                if ( !uisOffset( dropdown ).height && $select.$animate && $select.$animate.on && $select.$animate.enabled( dropdown ) ) {
                                    var needsCalculated = true;

                                    $select.$animate.on( 'enter', dropdown, function( elem, phase ) {
                                        if ( phase === 'close' && needsCalculated ) {
                                            calculateDropdownPosAfterAnimation();
                                            needsCalculated = false;
                                        }
                                    } );
                                } else {
                                    calculateDropdownPosAfterAnimation();
                                }
                            } else {
                                if ( dropdown === null || dropdown.length === 0 ) {
                                    return;
                                }

                                // Reset the position of the dropdown.
                                dropdown[ 0 ].style.opacity = 0;
                                dropdown[ 0 ].style.position = '';
                                dropdown[ 0 ].style.top = '';
                                element.removeClass( directionUpClassName );
                            }
                        };
                    };
                }
            };
        }
    ] );

    uis.directive( 'uiSelectMatch', [ 'uiSelectConfig', function( uiSelectConfig ) {
        return {
            restrict: 'EA',
            require: '^uiSelect',
            replace: true,
            transclude: true,
            templateUrl: function( tElement ) {
                // Needed so the uiSelect can detect the transcluded content
                tElement.addClass( 'ui-select-match' );

                var parent = tElement.parent();
                // Gets theme attribute from parent (ui-select)
                var theme = getAttribute( parent, 'theme' ) || uiSelectConfig.theme;
                var multi = angular.isDefined( getAttribute( parent, 'multiple' ) );

                return theme + ( multi ? '/match-multiple.tpl.html' : '/match.tpl.html' );
            },
            link: function( scope, element, attrs, $select ) {
                $select.lockChoiceExpression = attrs.uiLockChoice;
                attrs.$observe( 'placeholder', function( placeholder ) {
                    $select.placeholder = placeholder !== undefined ? placeholder : uiSelectConfig.placeholder;
                } );

                function setAllowClear( allow ) {
                    $select.allowClear = ( angular.isDefined( allow ) ) ? ( allow === '' ) ? true : ( allow.toLowerCase() === 'true' ) : false;
                }

                attrs.$observe( 'allowClear', setAllowClear );
                setAllowClear( attrs.allowClear );

                if ( $select.multiple ) {
                    $select.sizeSearchInput();
                }

            }
        };

        function getAttribute( elem, attribute ) {
            if ( elem[ 0 ].hasAttribute( attribute ) )
                return elem.attr( attribute );

            if ( elem[ 0 ].hasAttribute( 'data-' + attribute ) )
                return elem.attr( 'data-' + attribute );

            if ( elem[ 0 ].hasAttribute( 'x-' + attribute ) )
                return elem.attr( 'x-' + attribute );
        }
    } ] );

    uis.directive( 'uiSelectMultiple', [ 'uiSelectMinErr', '$timeout', function( uiSelectMinErr, $timeout ) {
        return {
            restrict: 'EA',
            require: [ '^uiSelect', '^ngModel' ],

            controller: [ '$scope', '$timeout', function( $scope, $timeout ) {

                var ctrl = this,
                    $select = $scope.$select,
                    ngModel;

                if ( angular.isUndefined( $select.selected ) )
                    $select.selected = [];

                //Wait for link fn to inject it
                $scope.$evalAsync( function() {
                    ngModel = $scope.ngModel;
                } );

                ctrl.activeMatchIndex = -1;

                ctrl.updateModel = function() {
                    ngModel.$setViewValue( Date.now() ); //Set timestamp as a unique string to force changes
                    ctrl.refreshComponent();
                };

                ctrl.refreshComponent = function() {
                    //Remove already selected items
                    //e.g. When user clicks on a selection, the selected array changes and
                    //the dropdown should remove that item
                    $select.refreshItems();
                    $select.sizeSearchInput();
                };

                // Remove item from multiple select
                ctrl.removeChoice = function( index ) {

                    var removedChoice = $select.selected[ index ];

                    // if the choice is locked, can't remove it
                    if ( removedChoice._uiSelectChoiceLocked ) return;

                    var locals = {};
                    locals[ $select.parserResult.itemName ] = removedChoice;

                    $select.selected.splice( index, 1 );
                    ctrl.activeMatchIndex = -1;
                    $select.sizeSearchInput();

                    // Give some time for scope propagation.
                    $timeout( function() {
                        $select.onRemoveCallback( $scope, {
                            $item: removedChoice,
                            $model: $select.parserResult.modelMapper( $scope, locals )
                        } );
                    } );

                    ctrl.updateModel();

                };

                ctrl.getPlaceholder = function() {
                    //Refactor single?
                    if ( $select.selected && $select.selected.length ) return;
                    return $select.placeholder;
                };


            } ],
            controllerAs: '$selectMultiple',

            link: function( scope, element, attrs, ctrls ) {

                var $select = ctrls[ 0 ];
                var ngModel = scope.ngModel = ctrls[ 1 ];
                var $selectMultiple = scope.$selectMultiple;

                //$select.selected = raw selected objects (ignoring any property binding)

                $select.multiple = true;

                //Input that will handle focus
                $select.focusInput = $select.searchInput;

                //Properly check for empty if set to multiple
                ngModel.$isEmpty = function( value ) {
                    return !value || value.length === 0;
                };

                //From view --> model
                ngModel.$parsers.unshift( function() {
                    var locals = {},
                        result,
                        resultMultiple = [];
                    for ( var j = $select.selected.length - 1; j >= 0; j-- ) {
                        locals = {};
                        locals[ $select.parserResult.itemName ] = $select.selected[ j ];
                        result = $select.parserResult.modelMapper( scope, locals );
                        resultMultiple.unshift( result );
                    }
                    return resultMultiple;
                } );

                // From model --> view
                ngModel.$formatters.unshift( function( inputValue ) {
                    var data = $select.parserResult && $select.parserResult.source( scope, {
                            $select: {
                                search: ''
                            }
                        } ), //Overwrite $search
                        locals = {},
                        result;
                    if ( !data ) return inputValue;
                    var resultMultiple = [];
                    var checkFnMultiple = function( list, value ) {
                        if ( !list || !list.length ) return;
                        for ( var p = list.length - 1; p >= 0; p-- ) {
                            locals[ $select.parserResult.itemName ] = list[ p ];
                            result = $select.parserResult.modelMapper( scope, locals );
                            if ( $select.parserResult.trackByExp ) {
                                var propsItemNameMatches = /(\w*)\./.exec( $select.parserResult.trackByExp );
                                var matches = /\.([^\s]+)/.exec( $select.parserResult.trackByExp );
                                if ( propsItemNameMatches && propsItemNameMatches.length > 0 && propsItemNameMatches[ 1 ] == $select.parserResult.itemName ) {
                                    if ( matches && matches.length > 0 && result[ matches[ 1 ] ] == value[ matches[ 1 ] ] ) {
                                        resultMultiple.unshift( list[ p ] );
                                        return true;
                                    }
                                }
                            }
                            if ( angular.equals( result, value ) ) {
                                resultMultiple.unshift( list[ p ] );
                                return true;
                            }
                        }
                        return false;
                    };
                    if ( !inputValue ) return resultMultiple; //If ngModel was undefined
                    for ( var k = inputValue.length - 1; k >= 0; k-- ) {
                        //Check model array of currently selected items
                        if ( !checkFnMultiple( $select.selected, inputValue[ k ] ) ) {
                            //Check model array of all items available
                            if ( !checkFnMultiple( data, inputValue[ k ] ) ) {
                                //If not found on previous lists, just add it directly to resultMultiple
                                resultMultiple.unshift( inputValue[ k ] );
                            }
                        }
                    }
                    return resultMultiple;
                } );

                //Watch for external model changes
                scope.$watchCollection( function() {
                    return ngModel.$modelValue;
                }, function( newValue, oldValue ) {
                    if ( oldValue != newValue ) {
                        //update the view value with fresh data from items, if there is a valid model value
                        if ( angular.isDefined( ngModel.$modelValue ) ) {
                            ngModel.$modelValue = null; //Force scope model value and ngModel value to be out of sync to re-run formatters
                        }
                        $selectMultiple.refreshComponent();
                    }
                } );

                ngModel.$render = function() {
                    // Make sure that model value is array
                    if ( !angular.isArray( ngModel.$viewValue ) ) {
                        // Have tolerance for null or undefined values
                        if ( angular.isUndefined( ngModel.$viewValue ) || ngModel.$viewValue === null ) {
                            $select.selected = [];
                        } else {
                            throw uiSelectMinErr( 'multiarr', "Expected model value to be array but got '{0}'", ngModel.$viewValue );
                        }
                    }
                    $select.selected = ngModel.$viewValue;
                    $selectMultiple.refreshComponent();
                    scope.$evalAsync(); //To force $digest
                };

                scope.$on( 'uis:select', function( event, item ) {
                    if ( $select.selected.length >= $select.limit ) {
                        return;
                    }
                    $select.selected.push( item );
                    $selectMultiple.updateModel();
                } );

                scope.$on( 'uis:activate', function() {
                    $selectMultiple.activeMatchIndex = -1;
                } );

                scope.$watch( '$select.disabled', function( newValue, oldValue ) {
                    // As the search input field may now become visible, it may be necessary to recompute its size
                    if ( oldValue && !newValue ) $select.sizeSearchInput();
                } );

                $select.searchInput.on( 'keydown', function( e ) {
                    var key = e.which;
                    scope.$apply( function() {
                        var processed = false;
                        // var tagged = false; //Checkme
                        if ( KEY.isHorizontalMovement( key ) ) {
                            processed = _handleMatchSelection( key );
                        }
                        if ( processed && key != KEY.TAB ) {
                            //TODO Check si el tab selecciona aun correctamente
                            //Crear test
                            e.preventDefault();
                            e.stopPropagation();
                        }
                    } );
                } );

                function _getCaretPosition( el ) {
                    if ( angular.isNumber( el.selectionStart ) ) return el.selectionStart;
                    // selectionStart is not supported in IE8 and we don't want hacky workarounds so we compromise
                    else return el.value.length;
                }
                // Handles selected options in "multiple" mode
                function _handleMatchSelection( key ) {
                    var caretPosition = _getCaretPosition( $select.searchInput[ 0 ] ),
                        length = $select.selected.length,
                        // none  = -1,
                        first = 0,
                        last = length - 1,
                        curr = $selectMultiple.activeMatchIndex,
                        next = $selectMultiple.activeMatchIndex + 1,
                        prev = $selectMultiple.activeMatchIndex - 1,
                        newIndex = curr;

                    if ( caretPosition > 0 || ( $select.search.length && key == KEY.RIGHT ) ) return false;

                    $select.close();

                    function getNewActiveMatchIndex() {
                        switch ( key ) {
                            case KEY.LEFT:
                                // Select previous/first item
                                if ( ~$selectMultiple.activeMatchIndex ) return prev;
                                // Select last item
                                else return last;
                                break;
                            case KEY.RIGHT:
                                // Open drop-down
                                if ( !~$selectMultiple.activeMatchIndex || curr === last ) {
                                    $select.activate();
                                    return false;
                                }
                                // Select next/last item
                                else return next;
                                break;
                            case KEY.BACKSPACE:
                                // Remove selected item and select previous/first
                                if ( ~$selectMultiple.activeMatchIndex ) {
                                    $selectMultiple.removeChoice( curr );
                                    return prev;
                                }
                                // Select last item
                                else return last;
                                break;
                            case KEY.DELETE:
                                // Remove selected item and select next item
                                if ( ~$selectMultiple.activeMatchIndex ) {
                                    $selectMultiple.removeChoice( $selectMultiple.activeMatchIndex );
                                    return curr;
                                } else return false;
                        }
                    }

                    newIndex = getNewActiveMatchIndex();

                    if ( !$select.selected.length || newIndex === false ) $selectMultiple.activeMatchIndex = -1;
                    else $selectMultiple.activeMatchIndex = Math.min( last, Math.max( first, newIndex ) );

                    return true;
                }

                $select.searchInput.on( 'keyup', function( e ) {

                    if ( !KEY.isVerticalMovement( e.which ) ) {
                        scope.$evalAsync( function() {
                            $select.activeIndex = $select.taggingLabel === false ? -1 : 0;
                        } );
                    }
                    // Push a "create new" item into array if there is a search string
                    if ( $select.tagging.isActivated && $select.search.length > 0 ) {

                        // return early with these keys
                        if ( e.which === KEY.TAB || KEY.isControl( e ) || KEY.isFunctionKey( e ) || e.which === KEY.ESC || KEY.isVerticalMovement( e.which ) ) {
                            return;
                        }
                        // always reset the activeIndex to the first item when tagging
                        $select.activeIndex = $select.taggingLabel === false ? -1 : 0;
                        // taggingLabel === false bypasses all of this
                        if ( $select.taggingLabel === false ) return;

                        var items = angular.copy( $select.items );
                        var stashArr = angular.copy( $select.items );
                        var newItem;
                        var item;
                        var hasTag = false;
                        var dupeIndex = -1;
                        var tagItems;
                        var tagItem;

                        // case for object tagging via transform `$select.tagging.fct` function
                        if ( $select.tagging.fct !== undefined ) {
                            tagItems = $select.$filter( 'filter' )( items, {
                                'isTag': true
                            } );
                            if ( tagItems.length > 0 ) {
                                tagItem = tagItems[ 0 ];
                            }
                            // remove the first element, if it has the `isTag` prop we generate a new one with each keyup, shaving the previous
                            if ( items.length > 0 && tagItem ) {
                                hasTag = true;
                                items = items.slice( 1, items.length );
                                stashArr = stashArr.slice( 1, stashArr.length );
                            }
                            newItem = $select.tagging.fct( $select.search );
                            // verify the new tag doesn't match the value of a possible selection choice or an already selected item.
                            if (
                                stashArr.some( function( origItem ) {
                                    return angular.equals( origItem, newItem );
                                } ) ||
                                $select.selected.some( function( origItem ) {
                                    return angular.equals( origItem, newItem );
                                } )
                            ) {
                                scope.$evalAsync( function() {
                                    $select.activeIndex = 0;
                                    $select.items = items;
                                } );
                                return;
                            }
                            if ( newItem ) newItem.isTag = true;
                            // handle newItem string and stripping dupes in tagging string context
                        } else {
                            // find any tagging items already in the $select.items array and store them
                            tagItems = $select.$filter( 'filter' )( items, function( item ) {
                                return item.match( $select.taggingLabel );
                            } );
                            if ( tagItems.length > 0 ) {
                                tagItem = tagItems[ 0 ];
                            }
                            item = items[ 0 ];
                            // remove existing tag item if found (should only ever be one tag item)
                            if ( item !== undefined && items.length > 0 && tagItem ) {
                                hasTag = true;
                                items = items.slice( 1, items.length );
                                stashArr = stashArr.slice( 1, stashArr.length );
                            }
                            newItem = $select.search + ' ' + $select.taggingLabel;
                            if ( _findApproxDupe( $select.selected, $select.search ) > -1 ) {
                                return;
                            }
                            // verify the the tag doesn't match the value of an existing item from
                            // the searched data set or the items already selected
                            if ( _findCaseInsensitiveDupe( stashArr.concat( $select.selected ) ) ) {
                                // if there is a tag from prev iteration, strip it / queue the change
                                // and return early
                                if ( hasTag ) {
                                    items = stashArr;
                                    scope.$evalAsync( function() {
                                        $select.activeIndex = 0;
                                        $select.items = items;
                                    } );
                                }
                                return;
                            }
                            if ( _findCaseInsensitiveDupe( stashArr ) ) {
                                // if there is a tag from prev iteration, strip it
                                if ( hasTag ) {
                                    $select.items = stashArr.slice( 1, stashArr.length );
                                }
                                return;
                            }
                        }
                        if ( hasTag ) dupeIndex = _findApproxDupe( $select.selected, newItem );
                        // dupe found, shave the first item
                        if ( dupeIndex > -1 ) {
                            items = items.slice( dupeIndex + 1, items.length - 1 );
                        } else {
                            items = [];
                            if ( newItem ) items.push( newItem );
                            items = items.concat( stashArr );
                        }
                        scope.$evalAsync( function() {
                            $select.activeIndex = 0;
                            $select.items = items;

                            if ( $select.isGrouped ) {
                                // update item references in groups, so that indexOf will work after angular.copy
                                var itemsWithoutTag = newItem ? items.slice( 1 ) : items;
                                $select.setItemsFn( itemsWithoutTag );
                                if ( newItem ) {
                                    // add tag item as a new group
                                    $select.items.unshift( newItem );
                                    $select.groups.unshift( {
                                        name: '',
                                        items: [ newItem ],
                                        tagging: true
                                    } );
                                }
                            }
                        } );
                    }
                } );

                function _findCaseInsensitiveDupe( arr ) {
                    if ( arr === undefined || $select.search === undefined ) {
                        return false;
                    }
                    var hasDupe = arr.filter( function( origItem ) {
                        if ( $select.search.toUpperCase() === undefined || origItem === undefined ) {
                            return false;
                        }
                        return origItem.toUpperCase() === $select.search.toUpperCase();
                    } ).length > 0;

                    return hasDupe;
                }

                function _findApproxDupe( haystack, needle ) {
                    var dupeIndex = -1;
                    if ( angular.isArray( haystack ) ) {
                        var tempArr = angular.copy( haystack );
                        for ( var i = 0; i < tempArr.length; i++ ) {
                            // handle the simple string version of tagging
                            if ( $select.tagging.fct === undefined ) {
                                // search the array for the match
                                if ( tempArr[ i ] + ' ' + $select.taggingLabel === needle ) {
                                    dupeIndex = i;
                                }
                                // handle the object tagging implementation
                            } else {
                                var mockObj = tempArr[ i ];
                                if ( angular.isObject( mockObj ) ) {
                                    mockObj.isTag = true;
                                }
                                if ( angular.equals( mockObj, needle ) ) {
                                    dupeIndex = i;
                                }
                            }
                        }
                    }
                    return dupeIndex;
                }

                $select.searchInput.on( 'blur', function() {
                    $timeout( function() {
                        $selectMultiple.activeMatchIndex = -1;
                    } );
                } );

            }
        };
    } ] );

    uis.directive( 'uiSelectNoChoice', [ 'uiSelectConfig', function( uiSelectConfig ) {
        return {
            restrict: 'EA',
            require: '^uiSelect',
            replace: true,
            transclude: true,
            templateUrl: function( tElement ) {
                // Needed so the uiSelect can detect the transcluded content
                tElement.addClass( 'ui-select-no-choice' );

                // Gets theme attribute from parent (ui-select)
                var theme = tElement.parent().attr( 'theme' ) || uiSelectConfig.theme;
                return theme + '/no-choice.tpl.html';
            }
        };
    } ] );

    uis.directive( 'uiSelectSingle', [ '$timeout', '$compile', function( $timeout, $compile ) {
        return {
            restrict: 'EA',
            require: [ '^uiSelect', '^ngModel' ],
            link: function( scope, element, attrs, ctrls ) {

                var $select = ctrls[ 0 ];
                var ngModel = ctrls[ 1 ];

                //From view --> model
                ngModel.$parsers.unshift( function( inputValue ) {
                    var locals = {},
                        result;
                    locals[ $select.parserResult.itemName ] = inputValue;
                    result = $select.parserResult.modelMapper( scope, locals );
                    return result;
                } );

                //From model --> view
                ngModel.$formatters.unshift( function( inputValue ) {
                    var data = $select.parserResult && $select.parserResult.source( scope, {
                            $select: {
                                search: ''
                            }
                        } ), //Overwrite $search
                        locals = {},
                        result;
                    if ( data ) {
                        var checkFnSingle = function( d ) {
                            locals[ $select.parserResult.itemName ] = d;
                            result = $select.parserResult.modelMapper( scope, locals );
                            return result === inputValue;
                        };
                        //If possible pass same object stored in $select.selected
                        if ( $select.selected && checkFnSingle( $select.selected ) ) {
                            return $select.selected;
                        }
                        for ( var i = data.length - 1; i >= 0; i-- ) {
                            if ( checkFnSingle( data[ i ] ) ) return data[ i ];
                        }
                    }
                    return inputValue;
                } );

                //Update viewValue if model change
                scope.$watch( '$select.selected', function( newValue ) {
                    if ( ngModel.$viewValue !== newValue ) {
                        ngModel.$setViewValue( newValue );
                    }
                } );

                ngModel.$render = function() {
                    $select.selected = ngModel.$viewValue;
                };

                scope.$on( 'uis:select', function( event, item ) {
                    $select.selected = item;
                } );

                scope.$on( 'uis:close', function( event, skipFocusser ) {
                    $timeout( function() {
                        $select.focusser.prop( 'disabled', false );
                        if ( !skipFocusser ) $select.focusser[ 0 ].focus();
                    }, 0, false );
                } );

                scope.$on( 'uis:activate', function() {
                    focusser.prop( 'disabled', true ); //Will reactivate it on .close()
                } );

                //Idea from: https://github.com/ivaynberg/select2/blob/79b5bf6db918d7560bdd959109b7bcfb47edaf43/select2.js#L1954
                var focusser = angular.element( "<input ng-disabled='$select.disabled' class='ui-select-focusser ui-select-offscreen' type='text' id='{{ $select.focusserId }}' aria-label='{{ $select.focusserTitle }}' aria-haspopup='true' role='button' />" );
                $compile( focusser )( scope );
                $select.focusser = focusser;

                //Input that will handle focus
                $select.focusInput = focusser;

                element.parent().append( focusser );
                focusser.bind( "focus", function() {
                    scope.$evalAsync( function() {
                        $select.focus = true;
                    } );
                } );
                focusser.bind( "blur", function() {
                    scope.$evalAsync( function() {
                        $select.focus = false;
                    } );
                } );
                focusser.bind( "keydown", function( e ) {

                    if ( e.which === KEY.BACKSPACE ) {
                        e.preventDefault();
                        e.stopPropagation();
                        $select.select( undefined );
                        scope.$apply();
                        return;
                    }

                    if ( e.which === KEY.TAB || KEY.isControl( e ) || KEY.isFunctionKey( e ) || e.which === KEY.ESC ) {
                        return;
                    }

                    if ( e.which == KEY.DOWN || e.which == KEY.UP || e.which == KEY.ENTER || e.which == KEY.SPACE ) {
                        e.preventDefault();
                        e.stopPropagation();
                        $select.activate();
                    }

                    scope.$digest();
                } );

                focusser.bind( "keyup input", function( e ) {

                    if ( e.which === KEY.TAB || KEY.isControl( e ) || KEY.isFunctionKey( e ) || e.which === KEY.ESC || e.which == KEY.ENTER || e.which === KEY.BACKSPACE ) {
                        return;
                    }

                    $select.activate( focusser.val() ); //User pressed some regular key, so we pass it to the search input
                    focusser.val( '' );
                    scope.$digest();

                } );


            }
        };
    } ] );

    // Make multiple matches sortable
    uis.directive( 'uiSelectSort', [ '$timeout', 'uiSelectConfig', 'uiSelectMinErr', function( $timeout, uiSelectConfig, uiSelectMinErr ) {
        return {
            require: [ '^^uiSelect', '^ngModel' ],
            link: function( scope, element, attrs, ctrls ) {
                if ( scope[ attrs.uiSelectSort ] === null ) {
                    throw uiSelectMinErr( 'sort', 'Expected a list to sort' );
                }

                var $select = ctrls[ 0 ];
                var $ngModel = ctrls[ 1 ];

                var options = angular.extend( {
                        axis: 'horizontal'
                    },
                    scope.$eval( attrs.uiSelectSortOptions ) );

                var axis = options.axis;
                var draggingClassName = 'dragging';
                var droppingClassName = 'dropping';
                var droppingBeforeClassName = 'dropping-before';
                var droppingAfterClassName = 'dropping-after';

                scope.$watch( function() {
                    return $select.sortable;
                }, function( newValue ) {
                    if ( newValue ) {
                        element.attr( 'draggable', true );
                    } else {
                        element.removeAttr( 'draggable' );
                    }
                } );

                element.on( 'dragstart', function( event ) {
                    element.addClass( draggingClassName );

                    ( event.dataTransfer || event.originalEvent.dataTransfer ).setData( 'text', scope.$index.toString() );
                } );

                element.on( 'dragend', function() {
                    removeClass( draggingClassName );
                } );

                var move = function( from, to ) {
                    /*jshint validthis: true */
                    this.splice( to, 0, this.splice( from, 1 )[ 0 ] );
                };

                var removeClass = function( className ) {
                    angular.forEach( $select.$element.querySelectorAll( '.' + className ), function( el ) {
                        angular.element( el ).removeClass( className );
                    } );
                };

                var dragOverHandler = function( event ) {
                    event.preventDefault();

                    var offset = axis === 'vertical' ? event.offsetY || event.layerY || ( event.originalEvent ? event.originalEvent.offsetY : 0 ) : event.offsetX || event.layerX || ( event.originalEvent ? event.originalEvent.offsetX : 0 );

                    if ( offset < ( this[ axis === 'vertical' ? 'offsetHeight' : 'offsetWidth' ] / 2 ) ) {
                        removeClass( droppingAfterClassName );
                        element.addClass( droppingBeforeClassName );

                    } else {
                        removeClass( droppingBeforeClassName );
                        element.addClass( droppingAfterClassName );
                    }
                };

                var dropTimeout;

                var dropHandler = function( event ) {
                    event.preventDefault();

                    var droppedItemIndex = parseInt( ( event.dataTransfer || event.originalEvent.dataTransfer ).getData( 'text' ), 10 );

                    // prevent event firing multiple times in firefox
                    $timeout.cancel( dropTimeout );
                    dropTimeout = $timeout( function() {
                        _dropHandler( droppedItemIndex );
                    }, 20 );
                };

                var _dropHandler = function( droppedItemIndex ) {
                    var theList = scope.$eval( attrs.uiSelectSort );
                    var itemToMove = theList[ droppedItemIndex ];
                    var newIndex = null;

                    if ( element.hasClass( droppingBeforeClassName ) ) {
                        if ( droppedItemIndex < scope.$index ) {
                            newIndex = scope.$index - 1;
                        } else {
                            newIndex = scope.$index;
                        }
                    } else {
                        if ( droppedItemIndex < scope.$index ) {
                            newIndex = scope.$index;
                        } else {
                            newIndex = scope.$index + 1;
                        }
                    }

                    move.apply( theList, [ droppedItemIndex, newIndex ] );

                    $ngModel.$setViewValue( Date.now() );

                    scope.$apply( function() {
                        scope.$emit( 'uiSelectSort:change', {
                            array: theList,
                            item: itemToMove,
                            from: droppedItemIndex,
                            to: newIndex
                        } );
                    } );

                    removeClass( droppingClassName );
                    removeClass( droppingBeforeClassName );
                    removeClass( droppingAfterClassName );

                    element.off( 'drop', dropHandler );
                };

                element.on( 'dragenter', function() {
                    if ( element.hasClass( draggingClassName ) ) {
                        return;
                    }

                    element.addClass( droppingClassName );

                    element.on( 'dragover', dragOverHandler );
                    element.on( 'drop', dropHandler );
                } );

                element.on( 'dragleave', function( event ) {
                    if ( event.target != element ) {
                        return;
                    }

                    removeClass( droppingClassName );
                    removeClass( droppingBeforeClassName );
                    removeClass( droppingAfterClassName );

                    element.off( 'dragover', dragOverHandler );
                    element.off( 'drop', dropHandler );
                } );
            }
        };
    } ] );

    /**
     * Debounces functions
     *
     * Taken from UI Bootstrap $$debounce source code
     * See https://github.com/angular-ui/bootstrap/blob/master/src/debounce/debounce.js
     *
     */
    uis.factory( '$$uisDebounce', [ '$timeout', function( $timeout ) {
        return function( callback, debounceTime ) {
            var timeoutPromise;

            return function() {
                var self = this;
                var args = Array.prototype.slice.call( arguments );
                if ( timeoutPromise ) {
                    $timeout.cancel( timeoutPromise );
                }

                timeoutPromise = $timeout( function() {
                    callback.apply( self, args );
                }, debounceTime );
            };
        };
    } ] );

    /**
     * Parses "repeat" attribute.
     *
     * Taken from AngularJS ngRepeat source code
     * See https://github.com/angular/angular.js/blob/v1.2.15/src/ng/directive/ngRepeat.js#L211
     *
     * Original discussion about parsing "repeat" attribute instead of fully relying on ng-repeat:
     * https://github.com/angular-ui/ui-select/commit/5dd63ad#commitcomment-5504697
     */

    uis.service( 'uisRepeatParser', [ 'uiSelectMinErr', '$parse', function( uiSelectMinErr, $parse ) {
        var self = this;

        /**
         * Example:
         * expression = "address in addresses | filter: {street: $select.search} track by $index"
         * itemName = "address",
         * source = "addresses | filter: {street: $select.search}",
         * trackByExp = "$index",
         */
        self.parse = function( expression ) {


            var match;
            //var isObjectCollection = /\(\s*([\$\w][\$\w]*)\s*,\s*([\$\w][\$\w]*)\s*\)/.test(expression);
            // If an array is used as collection

            // if (isObjectCollection){
            // 000000000000000000000000000000111111111000000000000000222222222222220033333333333333333333330000444444444444444444000000000000000055555555555000000000000000000000066666666600000000
            match = expression.match( /^\s*(?:([\s\S]+?)\s+as\s+)?(?:([\$\w][\$\w]*)|(?:\(\s*([\$\w][\$\w]*)\s*,\s*([\$\w][\$\w]*)\s*\)))\s+in\s+(\s*[\s\S]+?)?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/ );

            // 1 Alias
            // 2 Item
            // 3 Key on (key,value)
            // 4 Value on (key,value)
            // 5 Source expression (including filters)
            // 6 Track by

            if ( !match ) {
                throw uiSelectMinErr( 'iexp', "Expected expression in form of '_item_ in _collection_[ track by _id_]' but got '{0}'.",
                    expression );
            }

            var source = match[ 5 ],
                filters = '';

            // When using (key,value) ui-select requires filters to be extracted, since the object
            // is converted to an array for $select.items 
            // (in which case the filters need to be reapplied)
            if ( match[ 3 ] ) {
                // Remove any enclosing parenthesis
                source = match[ 5 ].replace( /(^\()|(\)$)/g, '' );
                // match all after | but not after ||
                var filterMatch = match[ 5 ].match( /^\s*(?:[\s\S]+?)(?:[^\|]|\|\|)+([\s\S]*)\s*$/ );
                if ( filterMatch && filterMatch[ 1 ].trim() ) {
                    filters = filterMatch[ 1 ];
                    source = source.replace( filters, '' );
                }
            }

            return {
                itemName: match[ 4 ] || match[ 2 ], // (lhs) Left-hand side,
                keyName: match[ 3 ], //for (key, value) syntax
                source: $parse( source ),
                filters: filters,
                trackByExp: match[ 6 ],
                modelMapper: $parse( match[ 1 ] || match[ 4 ] || match[ 2 ] ),
                repeatExpression: function( grouped ) {
                    var expression = this.itemName + ' in ' + ( grouped ? '$group.items' : '$select.items' );
                    if ( this.trackByExp ) {
                        expression += ' track by ' + this.trackByExp;
                    }
                    return expression;
                }
            };

        };

        self.getGroupNgRepeatExpression = function() {
            return '$group in $select.groups';
        };

    } ] );

}() );
angular.module( "ui.select" ).run( [ "$templateCache", function( $templateCache ) {
    $templateCache.put( "select2/choices.tpl.html", "<ul tabindex=\"-1\" class=\"ui-select-choices ui-select-choices-content select2-results\"><li class=\"ui-select-choices-group\" ng-class=\"{\'select2-result-with-children\': $select.choiceGrouped($group) }\"><div ng-show=\"$select.choiceGrouped($group)\" class=\"ui-select-choices-group-label select2-result-label\" ng-bind=\"$group.name\"></div><ul role=\"listbox\" id=\"ui-select-choices-{{ $select.generatedId }}\" ng-class=\"{\'select2-result-sub\': $select.choiceGrouped($group), \'select2-result-single\': !$select.choiceGrouped($group) }\"><li role=\"option\" ng-attr-id=\"ui-select-choices-row-{{ $select.generatedId }}-{{$index}}\" class=\"ui-select-choices-row\" ng-class=\"{\'select2-highlighted\': $select.isActive(this), \'select2-disabled\': $select.isDisabled(this)}\"><div class=\"select2-result-label ui-select-choices-row-inner\"></div></li></ul></li></ul>" );
    $templateCache.put( "select2/match-multiple.tpl.html", "<span class=\"ui-select-match\"><li class=\"ui-select-match-item select2-search-choice\" ng-repeat=\"$item in $select.selected\" ng-class=\"{\'select2-search-choice-focus\':$selectMultiple.activeMatchIndex === $index, \'select2-locked\':$select.isLocked(this, $index)}\" ui-select-sort=\"$select.selected\"><span uis-transclude-append=\"\"></span> <a href=\"javascript:;\" class=\"ui-select-match-close select2-search-choice-close\" ng-click=\"$selectMultiple.removeChoice($index)\" tabindex=\"-1\"></a></li></span>" );
    $templateCache.put( "select2/match.tpl.html", "<a class=\"select2-choice ui-select-match\" ng-class=\"{\'select2-default\': $select.isEmpty()}\" ng-click=\"$select.toggle($event)\" aria-label=\"{{ $select.baseTitle }} select\"><span ng-show=\"$select.isEmpty()\" class=\"select2-chosen\">{{$select.placeholder}}</span> <span ng-hide=\"$select.isEmpty()\" class=\"select2-chosen\" ng-transclude=\"\"></span> <abbr ng-if=\"$select.allowClear && !$select.isEmpty()\" class=\"select2-search-choice-close\" ng-click=\"$select.clear($event)\"></abbr> <span class=\"select2-arrow ui-select-toggle\"><b></b></span></a>" );
    $templateCache.put( "select2/select-multiple.tpl.html", "<div class=\"ui-select-container ui-select-multiple select2 select2-container select2-container-multi\" ng-class=\"{\'select2-container-active select2-dropdown-open open\': $select.open, \'select2-container-disabled\': $select.disabled}\"><ul class=\"select2-choices\"><span class=\"ui-select-match\"></span><li class=\"select2-search-field\"><input type=\"search\" autocomplete=\"off\" autocorrect=\"off\" autocapitalize=\"off\" spellcheck=\"false\" role=\"combobox\" aria-expanded=\"true\" aria-owns=\"ui-select-choices-{{ $select.generatedId }}\" aria-label=\"{{ $select.baseTitle }}\" aria-activedescendant=\"ui-select-choices-row-{{ $select.generatedId }}-{{ $select.activeIndex }}\" class=\"select2-input ui-select-search\" placeholder=\"{{$selectMultiple.getPlaceholder()}}\" ng-disabled=\"$select.disabled\" ng-hide=\"$select.disabled\" ng-model=\"$select.search\" ng-click=\"$select.activate()\" style=\"width: 34px;\" ondrop=\"return false;\"></li></ul><div class=\"ui-select-dropdown select2-drop select2-with-searchbox select2-drop-active\" ng-class=\"{\'select2-display-none\': !$select.open || $select.items.length === 0}\"><div class=\"ui-select-choices\"></div></div></div>" );
    $templateCache.put( "select2/select.tpl.html", "<div class=\"ui-select-container select2 select2-container\" ng-class=\"{\'select2-container-active select2-dropdown-open open\': $select.open, \'select2-container-disabled\': $select.disabled, \'select2-container-active\': $select.focus, \'select2-allowclear\': $select.allowClear && !$select.isEmpty()}\"><div class=\"ui-select-match\"></div><div class=\"ui-select-dropdown select2-drop select2-with-searchbox select2-drop-active\" ng-class=\"{\'select2-display-none\': !$select.open}\"><div class=\"select2-search\" ng-show=\"$select.searchEnabled\"><input type=\"search\" autocomplete=\"off\" autocorrect=\"off\" autocapitalize=\"off\" spellcheck=\"false\" role=\"combobox\" aria-expanded=\"true\" aria-owns=\"ui-select-choices-{{ $select.generatedId }}\" aria-label=\"{{ $select.baseTitle }}\" aria-activedescendant=\"ui-select-choices-row-{{ $select.generatedId }}-{{ $select.activeIndex }}\" class=\"ui-select-search select2-input\" ng-model=\"$select.search\"></div><div class=\"ui-select-choices\"></div></div></div>" );
} ] );

'use strict';
( function() {
    angular
        .module( 'jigsawCorpLms' )
        .config( routerConfig );

    function routerConfig( $stateProvider ) {
        $stateProvider
            .state( 'welcome', {
                url: '/welcome',
                templateUrl: 'app/Features/welcomeScreen/welcomeScreen.html',
                controller: 'welcomeScreenCntrl'
            } );
    }

} )();

'use strict';
angular
    .module('jigsawCorpLms')
    .controller('welcomeScreenCntrl', function($scope, fetchData, $rootScope, $state, DataCache, $http, $timeout, $window) {

        $rootScope.activeController = "welcomeScreenCntrl";
        $rootScope.$broadcast('new-controller-loaded');

        var previousIndex;
        DataCache.loadFromWebstorage();

        var user_data = DataCache.returnData('userData');
//changes made for new SDK
            $scope.idToken = DataCache.returnData("idToken");
            //$http.defaults.headers.common['Authorization'] = "Bearer " + $scope.idToken;
        $http.defaults.headers.common['Authorization'] = "Bearer " + user_data.jwttoken;
        $http.defaults.headers.common['Content-Type'] = "application/x-www-form-urlencoded";


        // To show certificates for demo
        fetchData.fetchWelcomeScreenData().then(function(response) {
            $scope.certificates = response.data.certificates;
        });

        $scope.objectives = [];




        fetchData.getLearningObjective().then(function(response) {

            $scope.objectives = response.data.objectives[0].objective;
            // console.log(response.data.objectives);
            // $scope.objectives = [];
            // for(var e in learningObjective){
            //     $scope.objectives.push(learningObjective[e]);
            // }

        });





        $scope.getNumberOfWeeks = function(num) {
            return new Array(num);
        }

        $scope.moveLeft = function(item, currentIndex, totalItems) {
            var width = item.widthPercentByWeek;
            if (currentIndex == (totalItems - 1)) width = 0;
            return { width: width + '%' }
        };
        $scope.index = 0;

        $scope.toggleDetails = function(index) {
            $scope.index = index;
            $scope.activeIndex = index;
            if (index == previousIndex) $scope.tileOpen = !$scope.tileOpen;
            else $scope.tileOpen = true;
            previousIndex = index;
        };

        $scope.toggleDetailsClose = function() {
            $scope.activeIndex = null;
            $scope.tileOpen = !$scope.tileOpen;
        }

        $scope.nextPage = function() {
            //$rootScope.headerShow = false;
            $rootScope.$broadcast("cookie-updated");
            $rootScope.headerShow = true;
            $rootScope.dashArrow = true;
            $rootScope.moduleHeader = false;
            $rootScope.scndHdr = true;
            var payload = {
              'uid' : user_data.data,
              'lpId': user_data.lpId,
              'role': user_data.role
            };
            fetchData.updateisNewLpForUser(payload).then(function(response) {
                $state.go('home.dashboard');
            });
        }

        $scope.lpAttr = DataCache.returnData("lpAttr");
        $scope.companyName = DataCache.returnData("userData").clientName;
        $scope.lpDataSummary = $scope.lpAttr.summary;
        $scope.weekWidth = 100 / $scope.lpAttr.noOfWeeks + '%';

        // openClosetNCOverlay
        $scope.openClosetNCOverlay = function() {
            $scope.tNCOverlay = !$scope.tNCOverlay;
        };


        $scope.passEvent = function($event) {
            var ele1 = angular.element(".propses-item.remove-focus");
            if (ele1[$scope.index] === $event.target || $(ele1).find($event.target).length > 0) {} else {
                $scope.activeIndex = null;
                $scope.tileOpen = false;
                // $scope.toggleDetailsClose();
            }
        }

        $scope.closeOverlay = function($event) {
            var ele1 = angular.element(".upload-tnc-overlay");
            if (ele1[1] === $event.target || $(ele1).find($event.target).length > 0) {} else {
                $scope.openClosetNCOverlay();
            }
        }


        // changes for intro.js

        // $scope.IntroOptions = $rootScope.introData;
        // //$scope.ShouldAutoStart=true;
        // $scope.startIntro = DataCache.returnData("welcomeIntro");
        // if ($scope.startIntro === undefined || $scope.startIntro === null) {
        //     $scope.startIntro = true;
        // }



        // $timeout(function() {
        //     if ($rootScope.firstTimeLogin && $scope.startIntro) {
        //         $scope.CallMe();
        //         $scope.startIntro = false;
        //         DataCache.saveGlobalData("welcomeIntro", $scope.startIntro);
        //     }
        // }, 200);

        // $scope.hintFirstTime = true;

        // var showHelp = true;
        // var activeElem = document.activeElement;

        // if (activeElem && (activeElem.tagName.toLowerCase() == 'input' &&
        //         activeElem.type == 'text' ||
        //         activeElem.tagName.toLowerCase() == 'textarea')) showHelp = false;

        // $scope.IntroOptions = $rootScope.introData;

        // var codeset = { 72: false };
        // $window.onkeydown = function(e) {
        //     $scope.IntroOptions = $rootScope.introData;
        //     if (e.keyCode in codeset) {
        //         codeset[e.keyCode] = true;
        //         if (codeset[72] && showHelp) {
        //             if ($scope.hintFirstTime) {
        //                 introJs().setOptions($scope.IntroOptions);
        //                 introJs().addHints();
        //                 introJs().refresh();
        //                 $scope.hintFirstTime = false;
        //             } else {
        //                 introJs().showHints();
        //                 introJs().refresh();
        //             }
        //             codeset[72] = false;
        //         }
        //     }

        //     if (e.keyCode == 27) { introJs().hideHints(); }

        // };

        // $window.onkeyup = function(e) {
        //     if (e.keyCode in codeset) {
        //         codeset[e.keyCode] = false;
        //     }
        // };

        // intro changes ends here

    });

'use strict';
( function() {
    angular
        .module( 'jigsawCorpLms' )
        .config( routerConfig );

    /** @ngInject */
    function routerConfig( $stateProvider ) {
        $stateProvider
            .state( 'home.playlist', {
                url: '/playlist',
                templateUrl: 'app/Features/video_playlist_mobile/playlistMobile.html',
                controller: 'playlistMobileCtrl'
            } );
    }

} )();

'use strict';
angular
    .module( 'jigsawCorpLms' )
    .controller( 'playlistMobileCtrl', function( $scope, $state, $rootScope, fetchData, DataCache ) {
        $scope.togglePlaylistFilter = false;
        fetchData.fetchModuleDetails().then( function( response ) {
            $scope.modulesData = response.module_resources;
        } );
        $scope.libActive = false;
        $scope.showVideo = true;
        $scope.assessment = true;
        $scope.resources = true;
        $scope.caseStudy = true;
        $scope.activeModule = DataCache.returnData( 'thisModuleData' );

        $scope.showVideoFunc = function() {
            $scope.showVideo = !$scope.showVideo;
        };



        $scope.startLearnerView = function( module ) {
            $rootScope.headerShow = true;
            $rootScope.scndHdr = false;
            switch ( module.type ) {
                case 'video':
                    $state.go( 'home.learn.video' );
                    break;
                case 'quiz':
                    $state.go( 'home.learn.quiz' );
                    break;
                case 'caseStudy':
                    $state.go( 'home.learn.assessment' );
                    break;
                case 'ytc':
                    $state.go( 'home.learn.ytc' );
                    break;
            }
        };
    } );

'use strict';
( function() {
    angular
        .module( 'jigsawCorpLms' )
        .config( routerConfig );

    /** @ngInject */
    function routerConfig( $stateProvider ) {
        $stateProvider
            .state( 'buyer.dashboard.userProfile', {
                url: '/userProfile',
                templateUrl: 'app/Features/userProfile/userProfile.html',
                controller:'userProfileCtrl'
            } );
    }

} )();

'use strict';
( function() {
    angular
        .module( 'jigsawCorpLms' )
        .config( routerConfig );

    function routerConfig( $stateProvider ) {
        $stateProvider
            .state( 'setup', {
                url: '/setupProfile',
                templateUrl: 'app/Features/setupProfile/setupProfile.html',
                controller: 'setupProfileCtrl'
            } );
    }
} )();

'use strict';
angular
    .module('jigsawCorpLms')
    .controller('setupProfileCtrl', function($scope, $controller, fetchData, $state, $rootScope, AppUtilities, InputValidation, $timeout, $http, DataCache, $location, $anchorScroll, $cookies, $window) {

        $scope.authData = DataCache.returnData("userData");
        //changes made for new SDK
            $scope.idToken = DataCache.returnData("idToken");
            //$http.defaults.headers.common['Authorization'] = "Bearer " + $scope.idToken;
        $http.defaults.headers.common['Authorization'] = "Bearer " + $scope.authData.jwttoken;
        $http.defaults.headers.common['Content-Type'] = "application/x-www-form-urlencoded";

        angular.extend(this, $controller('rubricGuideCtrl', {
            $scope: $scope
        }));



        $rootScope.activeController = "setupProfileCtrl";
        $rootScope.$broadcast('new-controller-loaded');

        $scope.user_role;

        if ($scope.authData.hasOwnProperty('auth')) {
            $scope.user_role = $scope.authData.auth.role;
            $scope.firstTime = $scope.authData.auth.isVisited;
        } else {
            $scope.user_role = $scope.authData.role;
            $scope.firstTime = $scope.authData.isVisited;
        }
        var pattern = /^[\w@#$%^\\]+$/;
        var passwordValidationCriteria;
        $scope.parentObj = {};
        $scope.tNCOverlay = false;
        $scope.parentObj.trialVar = false;

        $scope.companyName = DataCache.returnData("userData").clientName;

        fetchData.fetchProfileData().then(function(response) {
            $scope.user = response.data.profile;
            $scope.user.companyName = response.data.profile.company;
            $scope.user.emailID = response.data.profile.fbUsername;
            $scope.parentObj.theUserName = response.data.profile.fbUsername;
            $scope.user.fullName = response.data.profile.firstname + " " + response.data.profile.lastname;

            $scope.avatar = $rootScope.baseimageurl + '/avatars/1/' + response.data.profile.profilePhotoUrl;
            angular.element($(".setup-profile-image")).css("background", "rgba(0, 0, 0, 0) url('" + $scope.avatar + "') scroll 0px 0px / 100% 100% padding-box border-box");

        });
        

        fetchData.fetchCountryCodes().then(function(response) {
            $scope.countryCodes = response.countryCodes;
            angular.forEach($scope.countryCodes, function(value, key) {
                if (value.code === "91") {
                    $scope.parentObj.countryCode = value;
                }
            }, this);
        });


        $scope.parentObj.countryCode = {
            "code": "91",
            "name": "India"
        };

        $scope.parentObj.termsnCondition = true;
        $scope.parentObj.resources = true;
        $scope.parentObj.activateAll = true;

        $scope.applySchema = function() {
            $timeout(function() {
                var maskew = new Maskew(document.getElementById("setupProfileImage"), 20);
            }, 100);

        };

        $scope.goToDashboard = function(isValid) {
            //var termsAndConditionCheckElem = document.getElementById("termsnConditionLabel");
            //console.log(termsAndConditionCheckElem.checked);
            if (isValid && $scope.isBothPwdSame) {
                var data = {
                    "linkedinUsername": "",
                    "linkedinUid": "",
                    "alternativeEmail": $scope.parentObj.altEmailId,
                    "countryPhoneCode": $scope.parentObj.countryCode.code,
                    "phoneNo": $scope.parentObj.phoneNumber,
                    "notifyChangeInLibrary": $scope.parentObj.libUpdate ? 'Y' : 'N',
                    "notifyProgress": $scope.parentObj.progressUpdate ? 'Y' : 'N',
                    "rewardsAndPoints": $scope.parentObj.pointsAndRewards ? 'Y' : 'N',
                    "new_password": $scope.parentObj.inputPassword,
                };

                if (!$scope.parentObj.selectedImage || null == $scope.parentObj.selectedImage) {
                    data['profilePhotoUrl'] = $scope.parentObj.selectedImage;
                }

                fetchData.updateSetupProfileScreenData(data).then(function(response) {
                    if (response.status === 200) {

                        if ($scope.user_role === "Learner") {
                            $rootScope.headerShow = false;
                            DataCache.saveGlobalData("setup-complete", true);

                            $state.go('welcome');
                        } else if ($scope.user_role === "L&D Manager" || $scope.user_role === "Manager") {
                            $rootScope.pwdUpdate = 'updated';
                            DataCache.saveRootScopeData('pwdUpdate', $rootScope.pwdUpdate);
                            $state.go('buyer.welcome');
                        }

                    }
                });
            } else {
                var termsAndConditionCheckElem = document.getElementById("termsnConditionLabel");
                if ($scope.form.$error.required && $scope.form.$error.required.length > 0) {
                    var errorElem = $scope.form.$error.required[0].$name;
                    $location.hash(errorElem);
                    $anchorScroll();
                } else if (!$scope.isBothPwdSame || !termsAndConditionCheckElem.checked) {
                    $location.hash("retypePassword");
                    $anchorScroll();
                }
            }
        };
    
        
        $scope.markTermsAndCondition = function() {
            var termsAndConditionCheckElem = document.getElementById("termsnConditionLabel");
            if (termsAndConditionCheckElem.checked) $scope.parentObj.termsnCondition = true;
            else $scope.parentObj.termsnCondition = false;
        }
        
        $scope.thisIsFocused = function() {
            $scope.pwdInputIsFocussed = true;
        };

        $scope.thisIsBlured = function() {
            $scope.pwdInputIsFocussed = false;
        };
        
        
        $scope.activateAllNotify = function(activateAll) {
            if (activateAll) {
                $scope.parentObj.libUpdate = true;
                $scope.parentObj.progressUpdate = true;
                $scope.parentObj.pointsAndRewards = true;
            } else {
                $scope.parentObj.libUpdate = false;
                $scope.parentObj.progressUpdate = false;
                $scope.parentObj.pointsAndRewards = false;
            }
        };
        
        $scope.activateAllNotify($scope.parentObj.activateAll); // All notifications - pre selected
       
        $scope.notifyOptionChanged = function() {
            $scope.parentObj.activateAll = $scope.parentObj.libUpdate && $scope.parentObj.progressUpdate && $scope.parentObj.pointsAndRewards;
        };
        $scope.openClosetNCOverlay = function() {
            $scope.tNCOverlay = !$scope.tNCOverlay;
        };

        $scope.retypePasswordChange = function() {
            $scope.isBothPwdSame = $scope.parentObj.inputConfirmPassword === $scope.parentObj.inputPassword;
        };

        $scope.passwordChange = function() {
            $scope.isBothPwdSame = $scope.parentObj.inputConfirmPassword === $scope.parentObj.inputPassword;
        };

        $scope.uploadNewAvatar = function() {
            // http call for selecting or uploading avatar goes here
        };
        
        
        $scope.$watch('parentObj.phoneNumber', function(newValue, oldValue) {
            if ($scope.parentObj.phoneNumber && isNaN(newValue)) {
                $scope.parentObj.phoneNumber = oldValue;
            }
        });

        //Password Watch
        $scope.$watch('parentObj.inputPassword', function(newValue, oldValue) {
            if (oldValue !== newValue) {
                if (newValue === undefined) {
                    $scope.parentObj.inputPassword = '';
                    newValue = '';
                }

                if (newValue.indexOf(' ') >= 0) {
                    $scope.parentObj.inputPassword = newValue.replace(/[' ']/g, '');
                }


                $scope.minPasswrdLength = ($scope.parentObj.inputPassword.length > 7);

                passwordValidationCriteria = /[0-9]/;
                $scope.min1Number = (passwordValidationCriteria.test($scope.parentObj.inputPassword));

                passwordValidationCriteria = /[a-zA-Z]/;
                $scope.lowercaseCharacters = (passwordValidationCriteria.test($scope.parentObj.inputPassword));

                $scope.enableChangePwdInput = ($scope.minPasswrdLength &&
                    $scope.min1Number && $scope.lowercaseCharacters);
            }
        });

        $scope.slickConfig = {
            enabled: true,
            autoplay: false,
            draggable: true,
            autoplaySpeed: 3000,
            infinite: false,
            variableWidth: true,
            method: {}
        };
        $scope.slideClipboardLeft = function() {
            $scope.slickConfig.method.slickNext();
        };
        $scope.slideClipboardRight = function() {
            $scope.slickConfig.method.slickPrev();
        };


        $scope.usrImage = function() {

            var temp = 'url("' + $rootScope.modelParent.userImage + '")';
            return {
                'background-image': temp
            }
        }

        $scope.applySchema();

        // changes for intro.js


        // $scope.IntroOptions = $rootScope.introData;
        // //$scope.ShouldAutoStart=true;
        // $scope.startIntro = DataCache.returnData("setupIntro");
        // if ($scope.startIntro === undefined || $scope.startIntro === null) {
        //     $scope.startIntro = true;
        // }

        
        // $scope.termsNCondition = function() {
        //     fetchData.getTermsNconditions().then(function(response) {
        //         $scope.terms = response.data.data;
        //     });
        // }
        

        // console.log($scope.IntroOptions);
        // $timeout(function () {
        //   //  if($rootScope.firstTimeLogin && $scope.startIntro){
        //       //$scope.CallMe();
        //       $scope.ShouldAutoStart=true;
        //       $scope.startIntro=false;
        //       DataCache.saveGlobalData("setupIntro",$scope.startIntro);
        //   //  }
        // }, 200);

        // intro changes ends here
    });
'use strict';
( function() {
    angular
        .module( 'jigsawCorpLms' )
        .config( routerConfig );

    /** @ngInject */
    function routerConfig( $stateProvider ) {
        $stateProvider
            .state( 'resetpassword', {
                url: '/resetpassword?token',
                templateUrl: 'app/Features/reset/reset.html',
                controller: 'ResetCtrl'
            } );
    }

} )();

'use strict';
angular
    .module('jigsawCorpLms')
    .controller('ResetCtrl', function($http, $stateParams, $scope, $state, fetchData, $rootScope, DataCache, $timeout, FirebaseService, $controller, $firebaseObject, $sce, $cookies) {

        $http.defaults.headers.common['Authorization'] = "Bearer " + $stateParams.token;
        $http.defaults.headers.common['Content-Type'] = "application/x-www-form-urlencoded";

        var pattern = /^[\w@#$%^\\]+$/;
        var passwordValidationCriteria;

        fetchData.validateToken().then(function(response) {
            console.log("valid token");
        });

        $scope.passwordChange = function() {
            $scope.isBothPwdSame = $scope.parentObj.inputConfirmPassword === $scope.parentObj.inputPassword;
        };
        $scope.$watch('parentObj.inputPassword', function(newValue, oldValue) {
            if (oldValue !== newValue) {
                if (newValue === undefined) {
                    $scope.parentObj.inputPassword = '';
                    newValue = '';
                }

                if (newValue.indexOf(' ') >= 0) {
                    $scope.parentObj.inputPassword = newValue.replace(/[' ']/g, '');
                }

                $scope.minPasswrdLength = ($scope.parentObj.inputPassword.length > 7);

                passwordValidationCriteria = /[0-9]/;
                $scope.min1Number = (passwordValidationCriteria.test($scope.parentObj.inputPassword));

                passwordValidationCriteria = /[a-zA-Z]/;
                $scope.lowercaseCharacters = (passwordValidationCriteria.test($scope.parentObj.inputPassword));

                $scope.enableChangePwdInput = ($scope.minPasswrdLength &&
                    $scope.min1Number && $scope.lowercaseCharacters);
            }
        });
        $scope.thisIsFocused = function() {
            $scope.pwdInputIsFocussed = true;
        };

        $scope.thisIsBlured = function() {
            $scope.pwdInputIsFocussed = false;
        };
        $scope.retypePasswordChange = function() {
            $scope.isBothPwdSame = $scope.parentObj.inputConfirmPassword === $scope.parentObj.inputPassword;
        };

        $scope.passwordChange = function() {
            $scope.isBothPwdSame = $scope.parentObj.inputConfirmPassword === $scope.parentObj.inputPassword;
        };
        $scope.passwordForm = true;
        $scope.resetSuccess = false;
        $scope.errorOccured = false;

        $scope.changePassword = function() {
            if ($scope.isBothPwdSame) {
                var cpData = { "new_password": $scope.parentObj.inputPassword };
                fetchData.changePassword(cpData).then(function(response) {
                    if (response.data.status === "success") {
                        $scope.passwordForm = false;
                        $scope.resetSuccess = true;
                        $timeout(function() {
                            $state.go('login');
                        }, 4000);
                    } else {
                        $scope.passwordForm = false;
                        $scope.errorOccured = true;
                    }

                });
            }
        }
    });
'use strict';
angular.module('jigsawCorpLms')
    .controller('ReportAnIssueCtrl', function($scope, $rootScope, $timeout, fetchData, DataCache, $http) {
        //console.log("inside ReportAnIssueCtrl");

        $scope.authData = DataCache.returnData("userData");

        //changes made for new SDK
            $scope.idToken = DataCache.returnData("idToken");
            //$http.defaults.headers.common['Authorization'] = "Bearer " + $scope.idToken;
        $http.defaults.headers.common['Authorization'] = "Bearer " + $scope.authData.jwttoken;
        $http.defaults.headers.common['Content-Type'] = "application/x-www-form-urlencoded";


        $scope.parentObj = {};
        $scope.supportTopics = [{
            'title': 'Ask Faculty',
            'iconClass': 'icon-learning'
        }, {
            'title': 'Issues & Bugs',
            'iconClass': 'icon-book'
        }, {
            'title': 'Others',
            'iconClass': 'icon-troubleshooting'
        }];
        $scope.currentSupportItem = $scope.supportTopics[0].title;

        $scope.takeNoteChange = function() {
            var ele1 = angular.element("textarea");
            var ele2 = angular.element("input");
            ele1.css('box-shadow', 'none');
            ele2.css('box-shadow', 'none');
        }

        $scope.passEvent = function($event) {
            var ele1 = angular.element(".report-an-issue-content.relative");
            if (ele1[0] === $event.target || $(ele1).find($event.target).length > 0) {} else {
                $scope.closeReportAnIssueCard();
            }
        }

        $scope.openTicket = function(subject, issue) {
            //console.log();
            $scope.activeModule = DataCache.returnData('thisModuleData');
            if ($scope.activeModule.current_resource) {
                var resourceTitle = $scope.activeModule.current_resource.metaData.title;
                var resourceType = $scope.activeModule.current_resource.type;
            } else {
                var resourceTitle = "";
                var resourceType = "";
            }
            var moduleTitle = $scope.activeModule.title;

            if (!subject || subject === "" || subject.trim().length === 0) {
                var sub = angular.element("input");
                sub.css({
                    'width': '99.7%',
                    'margin-left': '0.2%',
                    'box-shadow': '0px 0px 22px -3px rgba(209,71,0,1)'
                });
                sub.focus();
                return;
            }
            if (!issue || issue === "" || issue.trim().length === 0) {
                var sub = angular.element("textarea");
                console.log(sub);
                sub.css({
                    'box-shadow': '0px 0px 22px -3px rgba(209,71,0,1)'
                });
                sub.focus();
                return;
            }


            var data = { "requestType": $scope.currentSupportItem, "requestSubject": $scope.supportModel.subject, "requestDesc": $scope.supportModel.issue, "moduleTitle": moduleTitle, "resourceTitle": resourceTitle, "resourceType": resourceType };
            fetchData.supportTicket(data).then(function(response) {
                console.log(response.data);
                if (response.data.status !== 'error') {
                    $scope.closeReportAnIssueCard()
                        //$state.go('home.dashboard');
                }
            });
            // $scope.currentTicket = ticketIndex;
            // if ( prevTicket == ticketIndex ) {
            //     $scope.shwTicket = !$scope.shwTicket;
            // } else {
            //     $scope.shwTicket = true;
            // }
            // prevTicket = ticketIndex;
        };

        $scope.closeReportAnIssueCard = function() {
            $rootScope.modelParent.isReportAnIssueViewActive = false;
            $timeout(function() {
                $rootScope.modelParent.bringInReportAnIssue = false;
            }, 310);
            $rootScope.$broadcast("overlayClosed");
        };

        $scope.submitReportAnIssue = function() {
            $scope.closeReportAnIssueCard();
        };

        $scope.supportTopic = function(title) {
            $scope.currentSupportItem = title;
        };
    });
'use strict';
( function() {
    angular
        .module( 'jigsawCorpLms' )
        .config( routerConfig );

    function routerConfig( $stateProvider ) {
        $stateProvider
            .state( 'home.progressInfoPage', {
                url: '/progress',
                templateUrl: 'app/Features/progressInfoPage/progressInfoPage.html',
                controller: 'progressInfoCntrl'
            } );

    }

} )();

'use strict';
angular
    .module('jigsawCorpLms')
    .controller('progressInfoCntrl', function($scope, fetchData, $state, $rootScope, $filter, DataCache, $http, $controller, $timeout, $anchorScroll,$location) {


        $rootScope.activeController = "progressInfoCntrl";
        $rootScope.$on('$routeChangeStart', function() {
            alert('refresh');
        });

        $rootScope.scndHdr = false;
        $rootScope.$on('profile', function() {
            $scope.goToPrnslInfoDsktop();
        });

        $rootScope.$on('progress', function() {
            $scope.goToProgressDsktop();
        });

        angular.extend(this, $controller('userProfileCtrl', {
            $scope: $scope
        }));

        $rootScope.bheaderShow = false;
        $rootScope.headerShow = true;


        $scope.authData = DataCache.returnData("userData");
        //changes made for new SDK
            $scope.idToken = DataCache.returnData("idToken");
            //$http.defaults.headers.common['Authorization'] = "Bearer " + $scope.idToken;
        $http.defaults.headers.common['Authorization'] = "Bearer " + $scope.authData.jwttoken;
        $http.defaults.headers.common['Content-Type'] = "application/x-www-form-urlencoded";

        $scope.fetchLearnersProfilePageData = function() {
            $rootScope.showLoadingScreen = false;
            fetchData.fetchLearnersProfilePageData().then(function(response) {
                $scope.lrnsProfileData = response.data.topRank;
                for (var i = 0; i < $scope.lrnsProfileData.length; i++) {
                    $scope.lrnsProfileData[i].profilePhotoUrl = $rootScope.baseimageurl + '/avatars/' + $scope.lrnsProfileData[i].avatarLevel + '/' + $scope.lrnsProfileData[i].profilePhotoUrl;
                }

                if ($scope.lrnsProfileData.length >= 1) {
                    $scope.rearrangeData();
                } else {
                    angular.element('.leader-brd-wrp').addClass('icon-leaderboard-empty');
                }
                if ($rootScope.certificateScroll === true) {
                    $rootScope.certificateScroll = false;
                    $timeout(function() {
                        $location.hash('certificates');
                        $anchorScroll();
                        // try{
                        //   var page = angular.element("body");
                        //   var scrollPos = $(page).find(".prog-pg-badges-section");
                        //   page.animate({
                        //       scrollTop: scrollPos.position().top
                        //   }, 300);
                        // //   $anchorScroll(page);
                        // } catch(e){
                        //   console.error(e)
                        // }
                    }, 300);
                }
                $rootScope.$broadcast('top-rank-loaded');
            });
        }

        $scope.fetchLearnersProfilePageData();

        $rootScope.$on('avatarUpdated', function() {
            $scope.fetchLearnersProfilePageData();
            $rootScope.showLoadingScreen = false;
        });

        $scope.passEvent = function($event) {
            var ele1 = angular.element(".progress-timeline-arrow-box");
            var ele2 = angular.element(".progress-timeline-module");
            if (ele1[0] === $event.target || $(ele1).find($event.target).length > 0 || $(ele2).find($event.target).length > 0) {} else {
                $rootScope.$broadcast('closeTile');
            }
        }


        $rootScope.$on('top-rank-loaded', function() {


            fetchData.fetchUserRank().then(function(response) {
                $scope.userPosData = response.data.userRank[0];
                $scope.userPosData.profilePhotoUrl = $rootScope.baseimageurl + '/avatars/' + $scope.userPosData.avatarLevel + '/' + $scope.userPosData.profilePhotoUrl;
                $scope.userRank = "";

                for (var i = 0; i < $scope.leaderbrdDataSorted.length; i++) {

                    if ($scope.leaderbrdDataSorted[i].fbUserId == $scope.userPosData.fbUserId) {
                        $scope.userRank = i + 1;
                    }
                }
            });

        });


        fetchData.fetchProfileData().then(function(response) {
            $scope.user = response.data.profile;
            $scope.username = $scope.user.fbUsername;
            $scope.emailID = $scope.user.fbUsername;
            $scope.companyName = $scope.user.company;
            $scope.contactNumber = $scope.user.phoneNumber;

        });

        fetchData.fetchBadgeData().then(function(response) {
            $scope.badgeData = response.data.badges;
            $scope.badgesCount = $scope.badgeData.length;
            $scope.pendingBadges = 0;
            $scope.compeletedBadges = 0;
            $scope.completedBadgeData = [];
            for (var i = 0; i < $scope.badgesCount; i++) {
                if ($scope.badgeData[i].moduleStatus === "Completed" && $scope.badgeData[i].result === "PASS") {
                    $scope.compeletedBadges++;
                    $scope.completedBadgeData.push($scope.badgeData[i]);

                }
            }
            if ($rootScope.mCount == undefined) {
                $rootScope.mCount = DataCache.returnData("mCount");
            }
            $scope.pendingBadges = $rootScope.mCount - $scope.compeletedBadges;
            //  $scope.badgeLength = 0;
        });

        

        fetchData.fetchUserTotalCertificates().then(function(response){
          $scope.certificate=response.data
          //$scope.skillsByTeam = response.data;
                $scope.totalCompletedCertificates = 0;
                var certificateJsonArray = $scope.certificate.certificates;
                
                var certificateMap = [];

                for (var i = 0; i < certificateJsonArray.length; i++) {
                    var certificateObj = certificateJsonArray[i];
                    if (certificateMap[certificateObj.displayTitle] === undefined) {
                        var certificateArr = [];
                        certificateMap[certificateObj.displayTitle] = certificateArr;
                        certificateMap[certificateObj.displayTitle].push(certificateObj);
                    } else {
                        certificateMap[certificateObj.displayTitle].push(certificateObj);
                    }
                }
                $scope.certificationArray = [];
                for(var elem in certificateMap){
                    var completedCertificateCount = 0;
                    var a=certificateMap[elem];
                    for(var i=0;i<certificateMap[elem].length;i++){
                            if(a[i].moduleStatus == "Completed"){
                                completedCertificateCount = completedCertificateCount+1;
                            }
                    }
                    if(elem != "D3 Basics" && elem !="Tornado Framework"){
                        
                        $scope.totalCompletedCertificates = completedCertificateCount+$scope.totalCompletedCertificates;
                    }
                    
                    $scope.certificationArray.push({"lpId":a[0].lpId,"lptitle":elem,"totalcertificates":certificateMap[elem].length,"completedCerttificateCount":completedCertificateCount});
                }
                $scope.currentLpCertificates = $scope.certificationArray.filter(function (cert) {
                                 return cert.lpId === DataCache.returnData('summary')[ 'lpId' ]
                })
                $scope.oldLpCertificates = $scope.certificationArray.filter(function (cert) {
                                 return cert.lpId !== DataCache.returnData('summary')[ 'lpId' ]
                }).reverse()
                // console.log(certificateMap.map(function (cert) {
                //     return cert
                // }), "hello", JSON.stringify(certificateMap),)
                // console.log($scope.certificationArray)
                
        });
        // fetchData.fetchDashboardData().then( function( response ) {
        //     $scope.lpData = response.data;
        //     $scope.rearrangeTimelineData();
        // } );



        $scope.tabStateDesktop = 'progress';
        $scope.heightPerWeek = 120;
        $scope.hrsToDayRatio = 2.5;
        $scope.landingPageMob = true;
        var prevIndex;

        $scope.goToDashboard = function() {
            $rootScope.headerShow = true;
            $rootScope.scndHdr = true;
            $rootScope.dashArrow = true;
            $rootScope.moduleHeader = false;
            $state.go('home.dashboard');
        };

        $scope.applySchema = function(thisId, angle) {
            var maskew = new Maskew(document.getElementById(thisId), parseInt(angle));
        };

        $scope.rearrangeData = function() {
            $scope.leaderbrdData = $scope.lrnsProfileData;
            // for(var i=0;i<leaderbrdData.length;i++){
            //
            // }
            //  $scope.userPosData = $scope.lrnsProfileData.user_leaderboard_details;
            $scope.leaderbrdDataSorted = $filter('orderBy')($scope.leaderbrdData, 'grank', 'touchtime');
            $scope.objCompare();

        };

        $scope.rearrangeTimelineData = function() {
            $scope.totalTime = Math.ceil($scope.lpData.total_duration / 60);
            $scope.noOfWeeks = $scope.lpData.total_duration / ($scope.hrsToDayRatio * 7 * 60);
            $scope.totalNoWeeks = Math.ceil($scope.noOfWeeks);
            $scope.setWeekHeight();
            $scope.lpModulesData = $scope.lpData.modules;
            $scope.lpModulesData.push($scope.lpData.current_module);
            //$scope.lpModulesData[ $scope.lpModulesData.length - 1 ].current_item = true;

            var startDate = moment($scope.lpData.start_time);
            $scope.startDateofLp = {
                day: startDate.format('DD'),
                month: startDate.format('MMMM'),
                year: startDate.format('YYYY')
            }
            var lpDaysDuration = Math.ceil($scope.noOfWeeks * 7);
            var endDate = moment(startDate, "DD-MM-YYYY").add(lpDaysDuration, 'days');
            $scope.endDateofLp = {
                day: endDate.format('DD'),
                month: endDate.format('MMMM'),
                year: endDate.format('YYYY')
            }
        };

        $scope.setWeekHeight = function() {
            $scope.weekHeight = $scope.noOfWeeks * $scope.heightPerWeek;
            return {
                height: $scope.weekHeight + 'px'
            }
        };

        $scope.getModuleHeight = function(duration) {
            var height = (duration * 100) / $scope.lpData.total_duration;
            return {
                height: height + '%'
            }
        };

        $scope.getModuleCompletedHeight = function(percentage) {
            return (percentage);
        };


        $scope.getStyle = function(data) {
            var opacity = data / 200;
            return {
                'width': data + '%',
                'opacity': opacity
            };
        };

        $scope.objCompare = function() {
            var objCompare;
            $scope.leaderbrdData.forEach(function(val, ind) {
                objCompare = angular.equals(val, '10');
            });
            if (objCompare) {
                $scope.userInLdrBrd = true;
            }
        };

        $scope.badgeItemClick = function(index, id) {

        };

        $scope.goToProgressTab = function() {
            $scope.tabStateMobile = 'progress';
            $scope.landingPageMob = false;
            $scope.progTab = 'overview'
        };

        $scope.openOverviewTab = function() {
            $scope.progTabIndex = 0;
        };

        $scope.openLdrBrdTab = function() {
            $scope.progTab = 'leaderboard';
        };
        $scope.goToLandingpage = function() {
            $scope.tabStateMobile = null;
            $scope.landingPageMob = !$scope.landingPageMob;
        };

        $scope.goToPersonalInfo = function() {
            $scope.tabStateMobile = 'personalInfo';
            $scope.landingPageMob = false;
            $scope.progTab = 'overview'
        };

        $scope.goToProgressDsktop = function() {
            $scope.tabStateDesktop = 'progress';
        };


        $scope.goToPrnslInfoDsktop = function() {
            $scope.tabStateDesktop = 'prsnlInfo';
            //$state.go('userProfile');
        };

        $scope.goToPerformanceDsktop = function() {
            $scope.tabStateDesktop = 'prfmcAnalytics';
        };

        $scope.setheightOftile = function(elem) {
            var ind = 0;
            while (ind < elem.length) {
                elem[ind].style.height = 'auto';
                ind++;
            }

        }

        $scope.exportToPDF = function(id){
            var index = id;
            var fileId=$scope.certificate.certificates[index].encodedFile;
            var base64str = fileId;
            // decode base64 string, remove space for IE compatibility
            var binary = atob(base64str.replace(/\s/g, ''));
            var len = binary.length;
            var buffer = new ArrayBuffer(len);
 
            var view = new Uint8Array(buffer);

            for (var i = 0; i < len; i++) {
                 view[i] = binary.charCodeAt(i);
            }            
            var blob = new Blob( [view], { type: "application/pdf" });
            var filename = $scope.certificate.certificates[index].lpCertiticate+".pdf";
            saveAs(blob, filename);
        }


        $scope.downloadAll = function(id){

            
            var data = {"lpId":id};
             fetchData.fetchUserAllDownloadableCertificates(data).then(function(response){
                $scope.dCertificate=response.data

                for(var j=0;j<$scope.dCertificate.certificatesDownload.length;j++){


                     var cPrefix="";
               // for(var j=0;j<$scope.dCertificate.certificatesDownload.length;j++){
                    if($scope.dCertificate.certificatesDownload[j].certificateType == "SKILL"){
                        cPrefix="Skill_certificate-";
                    }else if($scope.dCertificate.certificatesDownload[j].certificateType == "LP"){
                        cPrefix="LearningPath_certificate-";
                    }

                    var fileName = cPrefix+$scope.dCertificate.certificatesDownload[j].lpCertiticate+".pdf";

                    var fileId=$scope.dCertificate.certificatesDownload[j].encodedFile;
                    var base64str = fileId;

     
                // decode base64 string, remove space for IE compatibility
                     var binary = atob(base64str.replace(/\s/g, ''));

                     var len = binary.length;
                     var buffer = new ArrayBuffer(len);
     
                     var view = new Uint8Array(buffer);

                     for (var i = 0; i < len; i++) {
                        view[i] = binary.charCodeAt(i);
                     }            
                    var blob = new Blob( [view], { type: "application/pdf" });
                    saveAs(blob, fileName);
                }
            });
            // for(var j=0;j<$scope.certificate.certificates.length;j++){
            //     var fileId=$scope.certificate.certificates[j].encodedFile;
            //     var base64str = fileId;
 
            // // decode base64 string, remove space for IE compatibility
            //      var binary = atob(base64str.replace(/\s/g, ''));

            //      var len = binary.length;
            //      var buffer = new ArrayBuffer(len);
 
            //      var view = new Uint8Array(buffer);

            //      for (var i = 0; i < len; i++) {
            //         view[i] = binary.charCodeAt(i);
            //      }            
            //     var blob = new Blob( [view], { type: "application/pdf" });
            //     var fileName = $scope.certificate.certificates[j].lpCertiticate+".pdf";
            //     saveAs(blob, fileName);
            //     }
            
        }


        $scope.showCertificateOverlay = function(certificate){
            document.getElementById("myNav").style.width = "75%";
            document.getElementById("myNav").style.padding = "20px";
            document.getElementById("myNav").style.border = "solid 1px";
           
            var data={"lpId":certificate.lpId};
                $rootScope.showLoadingScreen = false;
             fetchData.fetchUserCertificates(data).then(function(response){
                $scope.certificate=response.data

                
                $scope.cTitle=certificate.lptitle;
                $scope.cId = certificate.lpId;
                $scope.cTotal=certificate.totalcertificates;
                $scope.completedCert=certificate.completedCerttificateCount;
                $scope.lockedCert = certificate.totalcertificates -certificate.completedCerttificateCount;
                $scope.lockedCertArray = [];
                for(var i=0;i<$scope.lockedCert;i++){
                    $scope.lockedCertArray.push(i);
                }
            });
        }


        $scope.download = function(id,cNumber){

            var data={"lpId":id,"certificationNumber":cNumber};
            fetchData.fetchUserDownloadableCertificates(data).then(function(response){
                $scope.dCertificate=response.data
                
                    var cPrefix="";
               // for(var j=0;j<$scope.dCertificate.certificatesDownload.length;j++){
                    if($scope.dCertificate.certificatesDownload[0].certificateType == "SKILL"){
                        cPrefix="Skill_certificate-";
                    }else if($scope.dCertificate.certificatesDownload[0].certificateType == "LP"){
                        cPrefix="LearningPath_certificate-";
                    }


                    var fileName = cPrefix+$scope.dCertificate.certificatesDownload[0].lpCertiticate+".pdf";

                    var fileId=$scope.dCertificate.certificatesDownload[0].encodedFile;
                    var base64str = fileId;

     
                // decode base64 string, remove space for IE compatibility
                     var binary = atob(base64str.replace(/\s/g, ''));

                     var len = binary.length;
                     var buffer = new ArrayBuffer(len);
     
                     var view = new Uint8Array(buffer);

                     for (var i = 0; i < len; i++) {
                        view[i] = binary.charCodeAt(i);
                     }            
                    var blob = new Blob( [view], { type: "application/pdf" });
                    saveAs(blob, fileName);
                //}
            });

        }

        $scope.closeCertificateOverlay = function(){
            document.getElementById("myNav").style.width = "0%";
            document.getElementById("myNav").style.padding = "0px";
            document.getElementById("myNav").style.border = "solid 0px";
        }

        $scope.lpData = DataCache.returnData('summary');
        $scope.rearrangeTimelineData();

        //   var avatarData={"fbUsername":$scope.authData.auth.fbUsername};
        //  fetchData.getAvatar(avatarData).then( function( response ) {
        //
        //    if (response.data.status !== "error")
        //    {
        //      $scope.avatar=response.data.avatars[0].profilePhotoUrl;
        //    }else {
        //      console.log(response);
        //    }
        //  } );
    });

'use strict';
(function() {
    angular
        .module('jigsawCorpLms')
        .config(routerConfig);

    function routerConfig($stateProvider) {
        $stateProvider
            .state('home.profTest', {
                url: '/proficiencyTest',
                templateUrl: 'app/Features/proficiencyTest/proficiencyTest.html',
                controller: 'proficiencyTestCntrl'
            });
    }

})();

'use strict';
angular
    .module('jigsawCorpLms')
    .controller('proficiencyTestCntrl', function($scope, FirebaseService, $window, fetchData, $rootScope, $state, $filter, $sce, DataCache, DeviceDetector, $timeout, $http) {

        $scope.authData = DataCache.returnData("userData");
        //changes made for new SDK
            $scope.idToken = DataCache.returnData("idToken");
            //$http.defaults.headers.common['Authorization'] = "Bearer " + $scope.idToken;
        $http.defaults.headers.common['Authorization'] = "Bearer " + $scope.authData.jwttoken;
        $http.defaults.headers.common['Content-Type'] = "application/x-www-form-urlencoded";

        $scope.currentState = $state.current.name;
        $rootScope.moduleHeader = false;
        $rootScope.headerShow = true;
        $rootScope.scndHdr = false;


        var date = new Date();
        var ref = FirebaseService.ref.child($rootScope.events);



        $scope.error;

        $scope.currentModuleData = DataCache.returnData('thisModuleData');

        var userData = DataCache.returnData("userData");

        $scope.eventObject = {
            "group": "lprogress",
            "type": "lpt",
            "data": {
                "action": "start",
                "teamId": userData.teamId,
                "clientId": userData.clientId,
                "lpId": userData.lpId,
                "lpTitle": userData.lpTitle,
                "token": userData.token,
                "moduleId": $scope.currentModuleData.moduleId.toString(),
                "moduleSeqId": $scope.currentModuleData.sequenceId.toString(),
                "timestamp": $filter('date')(new Date(), 'yyyy-MM-dd HH:mm:ss')

            }
        };

        /*
        $scope.proficiencyTestData = response.data;
        $scope.noOfQuestions = $scope.proficiencyTestData.totalQuestions;
        $rootScope.countdownTime = $scope.proficiencyTestData.avgTime;
        */

        $scope.parentObj = [];
        $scope.footerState = 'launchScreen';
        $scope.answerObj = [];
        $scope.startTimer = false;
        $scope.activeModuleData = DataCache.returnData('thisModuleData');

        $scope.details = DataCache.returnData("details");
        $scope.modulePlaylistProf = $scope.details[$scope.currentModuleData.moduleId];


        $scope.filterPlaylist = function() {
            $scope.togglePlaylistFilter = !$scope.togglePlaylistFilter;
        }


        $scope.playListTemplateURL = $sce.trustAsResourceUrl('app/Features/proficiencyTest/template/profTestPlaylist.html');
        $scope.profTemplateUrl = $sce.trustAsResourceUrl('app/Features/proficiencyTest/template/profTestStart.html');



        $scope.submitAnswers = function() {
            $scope.footerState = 'summaryScreen';
            fetchData.fetchProficiencyTestSummaryData().then(function(response) {
                $scope.testReport = response.data;
                if ($scope.testReport.noCrctAnswer / $scope.noOfQuestions > 0.6) {
                    $scope.lowScrMsg = false;
                } else {
                    $scope.lowScrMsg = true;
                }
                $scope.answerReport = $scope.testReport.answerReport;
                $scope.attemptsLeft = $scope.testReport.attemptsLeft;
                $scope.topics = $scope.testReport.topicWiseReport;
            });

            var payload = {
                "ptId": parseInt($scope.currentModuleData.proficiencyTest)
            }


            fetchData.getPtSummary(payload).then(function(response) {
                $scope.ptTopics = [];
                $scope.ptsummary = response.data.ptsummary.request.method.parameters;
                $scope.ptSections = $scope.ptsummary.Section;
                for (var i = 0; i < $scope.ptSections.length; i++) {
                    for (var j = $scope.ptSections[i].Topics.length - 1; j >= 0; j--) {
                        $scope.ptTopics.push($scope.ptSections[i].Topics[j]);
                    };
                };
                var container = angular.element(".prof-content-section");
                container.css({
                    'overflow-y': 'auto'
                });
                var messageContainer = $(container).find(".prof-end-scrn-msg");
                messageContainer.css({
                    'padding': '30px 10px',
                    'height': '147px'
                });
                // $scope.certificates = response.data.certificates;
            });
            $scope.profTemplateUrl = $sce.trustAsResourceUrl('app/Features/proficiencyTest/template/profTestSummary.html');
            DataCache.clearCache('profTestQuestions');
            DataCache.clearCache('lastQuestion');
            $rootScope.countdownTime = null;
            $scope.startTimer = false;
            $scope.stopWatch = true;
        };

        if ($scope.currentModuleData.ptResult) {
            // console.log("should have worked");
            // $scope.profTemplateUrl = $sce.trustAsResourceUrl( 'app/Features/proficiencyTest/template/profTestSummary.html' );
            // submitAnswers();
            $scope.submitAnswers();
        }

        $scope.setPlaylistHeight = function() {
            if ($state.current.url !== "/Dashboard") {
                var hdngHeight = angular.element('.vid-vidplaylist-title-wrp')[0].offsetHeight;
                var crntItemHeight = angular.element('.current-video-wrp')[0].offsetHeight;
                var parentEle = angular.element('.learnerview-right')[0].offsetHeight;
                var subTitle = angular.element('.prof-playlist-title-wrp')[0].offsetHeight;
                var deductableHeight = crntItemHeight + hdngHeight + subTitle;
                var playListHeight, tempHeight;
                tempHeight = 'calc(' + parentEle + 'px' + ' - ' + deductableHeight + 'px' + ')';
                // console.log("temp height: " + tempHeight);
                return {

                    height: tempHeight

                }
            }
        };


        $scope.setQsHeight = function() {
            if ($state.current.url == "/proficiencyTest") {
                if ($scope.footerState === 'launchScreen') {
                    var parentEle = angular.element('.learnerview-left')[0].offsetHeight;
                    var footerHeight = angular.element('.quiz-footer-wrp.clearfix.hide-in-mobile')[0].offsetHeight;
                    var hdngHeight = angular.element('.quiz-pg-hdng-wrp')[0].offsetHeight + footerHeight;
                    var tempHeight;
                    tempHeight = 'calc(' + parentEle + 'px' + ' - ' + hdngHeight + 'px' + ')';
                    return {

                        'height': tempHeight,
                        'overflow-y': 'auto',
                        'padding-bottom': '2%'

                    }
                }
                var parentEle = angular.element('.learnerview-left')[0].offsetHeight;
                var hdngHeight = angular.element('.quiz-pg-hdng-wrp')[0].offsetHeight;
                var tempHeight;
                tempHeight = 'calc(' + parentEle + 'px' + ' - ' + hdngHeight + 'px' + ')';
                return {

                    height: tempHeight

                }
            }
        };




        /*
        fetchData.fetchProficiencyTestData().then( function( response ) {
            $scope.proficiencyTestData = response.data;
            $scope.noOfQuestions = $scope.proficiencyTestData.totalQuestions;
            $rootScope.countdownTime = $scope.proficiencyTestData.avgTime;
        } );
        */



        $scope.startQuiz = function(moduleId) {
            if (DeviceDetector.isSafari()) {
                $rootScope.$broadcast('isSafariBrowser');
                return;
            }
            var profPayload = {
                "moduleId": parseInt(moduleId)
            }
            fetchData.fetchTestUrl(profPayload).then(function(response) {
                if (!response.data["error"]) {
                    $scope.testurl = $sce.trustAsResourceUrl(response.data.url);
                    $scope.footerState = 'questionScreen';
                    $scope.currentIndex = 0;
                    $rootScope.profTestTitle = $scope.currentModuleData.pttitle;
                    DataCache.saveRootScopeData('profTestTitle', $rootScope.profTestTitle);
                    $rootScope.profTestAnswered = 0;
                    DataCache.saveRootScopeData('profTestAnswered', $rootScope.profTestAnswered);
                    if (DataCache.returnLpData('currentLp') === 'active') {
                        ref.push().child($scope.authData.uid).set($scope.eventObject);
                    }
                    $scope.profTemplateUrl = $sce.trustAsResourceUrl('app/Features/proficiencyTest/template/profTestQuestion.html');
                    // $("#theFrame").load($scope.testurl);
                } else {
                    $scope.error = response.data.error;
                    //$scope.error = $scope.error.replace('skill ','skill ' ).replace('. Please','". Please' );
                    return;
                }

            });

            $timeout(function() {
                var frame = angular.element("iframe");
                var timer = $(frame).find(".qz-qstn-section");
            }, 10000);


            // fetchData.fetchProficiencyTestQUestions().then( function( response ) {
            //     $scope.startTimer = true;
            //     if ( $rootScope.resumeProfTest ) {
            //         $scope.questionsData = response;
            //         if ( Number.isInteger( DataCache.returnData( 'lastQuestion' ) ) ) {
            //             $scope.currentIndex = DataCache.returnData( 'lastQuestion' );
            //         }
            //     } else {
            //         $scope.questionsData = response.questionsData;
            //         $scope.currentIndex = 0;
            //         console.log( $scope.questionsData );
            //         DataCache.saveGlobalData( 'profTestQuestions', $scope.questionsData );
            //         DataCache.saveGlobalData( 'lastQuestion', $scope.currentIndex );
            //     }
            // } );


        };

        $(function() {
            $("div iframe").on("load", function() {
                console.log("iframe loaded");
            });
        });

        if ($rootScope.resumeProfTest) {
            $rootScope.resumeProfTest = false;
            $scope.startQuiz($scope.currentModuleData.moduleId);
        }



        $scope.setWidthToQuestion = function(type) {
            return {
                width: 75 + '%',
                margin: 20 + 'px' + ' ' + 'auto'
            }
        };

        $scope.goToNextQuest = function() {

            if ($scope.currentIndex + 1 < $scope.noOfQuestions) {
                $scope.currentIndex = $scope.currentIndex + 1;
                $scope.sortQuestionStatus();
            } else {
                $scope.openSortPage();

            }
        };

        $scope.goToPrevQuest = function() {

            if ($scope.currentIndex - 1 >= 0) {
                $scope.currentIndex = $scope.currentIndex - 1;
                $scope.sortQuestionStatus();
            }
        };

        $scope.saveAnswer = function(index) {
            $scope.questionsData[index].status = "saved";
            $scope.answerObj[index] = $scope.questionsData[index].userAns;
            $scope.goToNextQuest();


            // saving the answers in Datacache
            DataCache.saveGlobalData('profTestQuestions', $scope.questionsData);
            DataCache.saveGlobalData('lastQuestion', index);

        };

        $scope.goToQuestion = function(index) {
            $scope.currentIndex = index;
            $scope.closeSidePanel();
        };

        $scope.flagQuestion = function(qNo) {
            $scope.questionsData[qNo].status = "flagged";
            $scope.goToNextQuest();
            DataCache.saveGlobalData('profTestQuestions', $scope.questionsData);
            DataCache.saveGlobalData('lastQuestion', qNo);
        };

        $scope.sortSmall = function() {
            $scope.sorted = !$scope.sorted;
            $scope.sortQuestionStatus();

        };


        $scope.sortQuestionStatus = function() {
            $scope.questionStatusSorted = {};
            $scope.questionStatusSorted.flagged = [];
            $scope.questionStatusSorted.saved = [];
            $scope.questionStatusSorted.skipped = [];
            $scope.questionStatusSorted.current = [];
            $scope.questionsData = $filter('orderBy')($scope.questionsData, 'questionID');

            $scope.questionsData.forEach(function(val, ind) {
                if (ind == $scope.currentIndex) {
                    $scope.questionStatusSorted.current.push(val);
                } else {
                    switch (val.status) {
                        case "flagged":
                            $scope.questionStatusSorted.flagged.push(val);
                            break;

                        case "saved":
                            $scope.questionStatusSorted.saved.push(val);
                            break;
                        default:
                            $scope.questionStatusSorted.skipped.push(val);
                            break;
                    }
                }
            })
        };

        $scope.topicWidth = function(no) {
            return {
                width: no + '%'
            }
        };

        $scope.openSortPage = function() {

            $scope.openSortPageToggle = true;
        };

        $scope.closeSidePanel = function() {
            $scope.openSortPageToggle = false;
            $scope.sorted = false;
        };


        $scope.openQuestion = function(questionID) {
            $scope.currentIndex = questionID - 1;
            $scope.sortQuestionStatus();
        };

        var initializing = true;
        $scope.$watch(
            function() {
                return $scope.startTimer;
            },
            function(newVal) {
                if (initializing) {
                    $timeout(function() {
                        initializing = false;
                    });
                } else {
                    if (!newVal) {
                        $scope.submitAnswers();
                    }
                }
            }
        );

        // report issue
        $scope.expandedReportIssue = false;
        $scope.rissuesObj = {
            "issues": [{
                "type": "Wrong answer labeled as right answer"
            }, {
                "type": "Question is not clear"
            }, {
                "type": "Need more help with an answer"
            }, {
                "type": "Answer options aren't showing up"
            }, {
                "type": "Question isn't showing up"
            }, {
                "type": "Unclear answer"
            }, {
                "type": "Question / answer not loading"
            }, {
                "type": "Broken timer"
            }, {
                "type": "System isn't allowing 2nd attempt"
            }]
        };

        $rootScope.reportIssueFunc = function() {
            //$scope.expandedReportIssue = !$scope.expandedReportIssue;

            $rootScope.modelParent.isReportAnIssueViewActive = true;
            $rootScope.modelParent.bringInReportAnIssue = true;
        };


        $scope.sendRIssue = function() {
            alert($scope.rissuesObj.issues.issueName);
            $scope.expandedReportIssue = false;
        };

        $scope.clickedPlaylistItem = function(bcId, resourceId, sequcenceID, type) {
            if ($scope.footerState === 'questionScreen') {
                $rootScope.$broadcast('profTestPaused');
                $rootScope.showProfTestBar = true;
            }
            $rootScope.currentSequenceId = sequcenceID;
            $rootScope.currentResourceId = resourceId;
            $rootScope.currentBcId = bcId;
            DataCache.saveRootScopeData('currentSequenceId', $rootScope.currentSequenceId);
            DataCache.saveRootScopeData('currentResourceId', $rootScope.currentResourceId);
            DataCache.saveRootScopeData('currentBcId', $rootScope.currentBcId);
            switch (type) {
                case 'video':
                    $state.go('home.learn.video');
                    break;
                case 'quiz':
                    $state.go('home.learn.quiz');
                    break;
                case 'csa':
                    $state.go('home.learn.assessment');
                    break;
                case 'material':
                    $state.go('home.learn.resources');
                    break;
                case 'ytc':
                    $state.go('home.learn.ytc');
                    break;
            }
        };


        $scope.repeat = function(num) {
            return new Array(num);
        }

        $scope.setColWidth = function(noOfCols) {
            var width = 100 / noOfCols;
            return {
                width: width + '%'
            }
        }


    });
'use strict';
angular.module('jigsawCorpLms')
    .controller('NotificationsCtrl', function($scope, fetchData, DataCache, $rootScope, $timeout, NavigationUtilities, $state, FirebaseService, $firebaseObject) {
        $scope.parentObject = {};
        $scope.notificationsResponse = {};
        $scope.notificationArray = [];
        var user_data = DataCache.returnData('userData');
        $scope.notification = DataCache.returnData('userNotifications');
        $rootScope.notificationCount = DataCache.returnData('userNotificationsCount');

        $scope.notificationArray = [];
        for (var key in $scope.notification) {
            $scope.notificationArray.push($scope.notification[key]);
        }

        $scope.allNotifications = $scope.notificationArray;

        var ref = FirebaseService.ref.child("notifications").child(user_data.uid);
        var obj = $firebaseObject(ref);

        //$scope.notificationArray=[];

        //  ref.on('child_added', function(childSnapshot, prevChildKey) {
        //
        //      var newNotificationData = childSnapshot.val();
        //      newNotificationData.key=childSnapshot.key();
        //      $scope.notificationArray.push(newNotificationData);
        //
        //  });

        // angular.copy( response, $scope.notificationsResponse );
        $scope.recentNotifications = $scope.notificationArray;
        $scope.allNotifications = $scope.notificationArray;
        //     $scope.notificationsResponse.recentNotifications.concat( $scope.notificationsResponse.notifications );
        //$scope.setNotificationModel( $scope.allNotifications );

        $scope.setNotificationModel = function(data, value) {
            var itrLength = data.length;
            for (var i = 0; i < itrLength; i++) {
                data[i].eachNotifications = value;
            }
        };

        $scope.triggerSelectAll = function(data, value) {
            $scope.setNotificationModel(data, value);
        };

        //  fetchData.notifications().then( function( response ) {
        // angular.copy( response, $scope.notificationsResponse );
        // $scope.recentNotifications = response.recentNotifications;
        // $scope.allNotifications =
        //     $scope.notificationsResponse.recentNotifications.concat( $scope.notificationsResponse.notifications );
        // $scope.setNotificationModel( $scope.allNotifications );
        //  } );

        $scope.closeNotificationsOverlay = function() {
            $(".parent-ui-view").css({
                'overflow-y': 'auto'
            });
            $rootScope.modelParent.isNotificationsListActive = false;
            $timeout(function() {
                $rootScope.modelParent.bringInNotifications = false;
            }, 210);
        };

        $scope.markThisNotificationRead = function(index) {
            //console.log($scope.allNotifications[ index ].isStatusSetActive);
            //$scope.allNotifications[ index ].isStatusSetActive = false; // only if notification update service responds successfully and update the notification status
            $scope.notificationArray[index].read = true; // only if notification mark service responds successfully
            $rootScope.$broadcast('read-selected', index);
        };

        $scope.markAllNotificationsRead = function() {

            if ($scope.allNotifications.length > 0) {
                $scope.allNotifications.filter(function(value) { // only if notification marking as read service responds successfully
                    value.read = true;
                });
            } else {
                for (var key in $scope.allNotifications) {
                    if ($scope.allNotifications[key].read == false) {
                        $scope.allNotifications[key].read = true;
                    }
                }
            }

            $rootScope.$broadcast('all-read');
            $rootScope.notificationCount = 0;
            DataCache.saveRootScopeData('notificationCount', $rootScope.notificationCount);

        };

        $scope.navigateByNotification = function(item) {
            // $scope.closeNotificationsOverlay();
            // var redirectState = NavigationUtilities.getRedirectState(item);
            // $state.go(redirectState);
        };

        $scope.callRemindFn = function(item) {
            item.eachNotifications = true;
            $scope.deleteNotifications();
        };

        $scope.deleteNotifications = function() {
            // only if notification delete service responds successfully with updated response
            var tempArray = [];
            $scope.allNotifications.filter(function(value, index) {
                if (value.eachNotifications !== true) {
                    tempArray.push(value);
                }
            });
            $scope.allNotifications = tempArray;
        };
    });
'use strict';
( function() {
    angular
        .module( 'jigsawCorpLms' )
        .config( routerConfig );

    /** @ngInject */
    function routerConfig( $stateProvider ) {
        $stateProvider
            .state( 'login', {
                url: '',
                templateUrl: 'app/Features/login/login.html',
                controller: 'LoginCtrl'
            } );
    }

} )();

'use strict';
angular
    .module('jigsawCorpLms')
    .controller('LoginCtrl', function($scope, $state, fetchData, $rootScope, DataCache, $timeout, FirebaseService, $controller, $firebaseObject, $sce, $cookies, $window) {


        //this condition is added to remove the local storage data when firebase websocket fails.
        localStorage.removeItem("firebase:previous_websocket_failure");

        if (!$rootScope.events || !$rootScope.baseimageurl) {
            $rootScope.$broadcast('initializeVariables');
        }

        $scope.showLogin = true;

        // $scope.closeOverlay = true;
        // $timeout(function() {
        //     $scope.closeOverlay = false;
        // }, 1000);

        angular.extend(this, $controller('rubricGuideCtrl', {
            $scope: $scope
        }));
        $rootScope.activeController = "LoginCtrl";
        $rootScope.pwdUpdate = null;

        // var userCookie = $cookies.getObject("userDetails");
        // if (userCookie) {
        //     $state.go('home.dashboard');
        // }


        $scope.parentObj = {
            'rememberMe': false
        };

        var userCookie = $cookies.getObject("userDetails");
            //console.log(userCookie);
        if (userCookie != null && userCookie != "undefined" && userCookie != "") {
            $scope.showLogin = false;
            $rootScope.firebaseLoaded = false;
            $rootScope.loginProcessing = true;
            var userRole = userCookie.role;

            DataCache.saveGlobalData("authData", userCookie);
            DataCache.saveGlobalData('userData', userCookie);


            if (userRole === "L&D Manager" || userRole === "Manager") {
                $rootScope.templateUrl = '';
                //  $rootScope.templateUrl='app/Common/Directives/popout/popout.html';
                $rootScope.loginProcessing = false;
                if (userCookie.fbUsername === "simon.chettiar@nokia.com") {
                    $state.go('ldashboard');
                } else{
                    $state.go('buyer');
                }
            } else if (userRole === "Learner") {
                $rootScope.templateUrl = '';
                var uid = userCookie.data;
                delete userCookie.token;

                // firebase.auth().currentUser.getIdToken(true).then(function(idToken) {
                //     DataCache.saveGlobalData('idToken', idToken);
                // }).catch(function(error) {
                //     console.log(error.message);
                // });
                $rootScope.$broadcast('connectToFirebase', userCookie);
                 //$state.go('home.dashboard');
            }
            // $state.go('home.dashboard');
        }

        $scope.loginAttempted = function(isValid) {
            $rootScope.firebaseLoaded = false;
            $rootScope.loginProcessing = true;
            $scope.loginErrorMessage = null;
            $scope.loginSuccessMessage = null;
            $scope.invalidLoginInput = null;
            if (isValid) {
                var trimmed_pwd = $scope.parentObj.password.replace(/\s*$/, "");
                var payload = {
                    'username': $scope.parentObj.theUserName,
                    'password': trimmed_pwd
                };
                fetchData.login(payload).then(function(response) {
                    if (response.data.status !== "error") {

                        var userData = JSON.parse(response.data.user_data);
                        $scope.userData = userData;
                        DataCache.saveGlobalData("userData", userData);
                        DataCache.saveGlobalData("authData", userData);
                        $cookies.putObject("userDetails", userData);

                        $rootScope.$broadcast('connectToFirebase', userData);
                    } else {
                        console.log("Authentication failed");
                        $scope.loginErrorMessage = response.data.error;
                        $rootScope.firebaseLoaded = true;
                        $rootScope.loginProcessing = false;
                    }
                });
            } else {
                console.log("Validation errors");
                $rootScope.firebaseLoaded = true;
                $rootScope.loginProcessing = false;
                $timeout(function() {
                    $scope.invalidLoginInput = true;
                }, 10);
            }
        };


        $scope.forgotscreen = function() {

            $timeout(function() {
                $scope.parentObj.password = "";
                $scope.parentObj.theUserName = "";
                $scope.loginErrorMessage = "";
                angular.element('.forgot-pwd-content').removeClass("l-hide");
                angular.element('.login-content').addClass("l-hide");
            }, 250);

        };

        $scope.unauthorizedMsg = "";
        if(DataCache.returnData("unauthorized") !== undefined){
                 $scope.unauthorizedMsg = DataCache.returnData("unauthorized");
                 DataCache.clearCache("unauthorized");
        }
       
        $scope.loginscreen = function() {

            $timeout(function() {
                $scope.parentObj.emailAddress = "";
                $scope.forgotErrorMessage = "";
                $scope.loginSuccessMessage = "";
                angular.element('.login-content').removeClass("l-hide");
                angular.element('.forgot-pwd-content').addClass("l-hide");
            }, 250);



        };



        $scope.retrievePassword = function(isValid) {

            $rootScope.forgotErrorMessage = null;
            $scope.invalidForgotInput = null;
            if (isValid) {
                var udata = { "username": $scope.parentObj.emailAddress };
                fetchData.retrievePassword(udata).then(function(response) {
                    if (response.data.status !== "error") {
                        $scope.loginSuccessMessage = response.data.message;
                    } else {
                        $rootScope.firebaseLoaded = true;
                        $rootScope.forgotErrorMessage = response.data.error;
                        $scope.forgotErrorMessage = $rootScope.forgotErrorMessage
                    }
                });
                $scope.form.$setPristine();
            } else {
                console.log("Validation errors");
                $rootScope.firebaseLoaded = true;
                $timeout(function() {
                    $scope.invalidForgotInput = true;
                }, 10);
            }
        }

    });
'use strict';
( function() {
    angular
        .module( 'jigsawCorpLms' )
        .config( routerConfig );

    /** @ngInject */
    function routerConfig( $stateProvider ) {
        $stateProvider
            .state( 'ldashboard', {
                url: 'ldashboard',
                templateUrl: 'app/Features/liteManagerDashboard/liteManagerDashboard.html',
                controller: 'liteManagerCtrl'
            } );
    }

} )();
'use strict';
angular
    .module('jigsawCorpLms')
    .controller('liteManagerCtrl', function($scope, $state, fetchData, $rootScope, DataCache, $timeout, $controller, $sce, $cookies, $window, $http) {

        var user_data = DataCache.returnData('userData');
        if (user_data == undefined) {
            $state.go("login");
        } else {
            $http.defaults.headers.common['Authorization'] = "Bearer " + user_data.jwttoken;
            $http.defaults.headers.common['Content-Type'] = "application/x-www-form-urlencoded";
        }

        $scope.bJourneyObj = {};

        var data;

        $rootScope.bheaderShow = true;
        $rootScope.popoutShow = false;

        $scope.bJourneyObj.isHead = user_data.role === 'L&D Manager';
        $scope.bJourneyObj.isManager = user_data.role === 'Manager';
        $scope.bJourneyObj.navBarShow = false;
        $scope.bJourneyObj.activeTab = 'dashboard';
        $rootScope.firstTimeLogin = false;
        $scope.bJourneyObj.navBarShow = true;

        $scope.role = user_data.role;
        $rootScope.firstTimeLogin = false;
        $scope.bJourneyObj.navBarShow = true;

        fetchData.fetchProfileData({}).then(function(response) {
            $scope.bJourneyObj.user = response.data.profile;
            $scope.avatar = $rootScope.baseimageurl + '/avatars/1/' + response.data.profile.profilePhotoUrl;
            angular.element($(".setup-profile-image")).css("background", "rgba(0, 0, 0, 0) url('" + $scope.avatar + "') scroll 0px 0px / 100% 100% padding-box border-box");
        });
        fetchData.testRetake().then(function(response) {
            if (response.data.status !== "error") {
                $scope.lretake = response.data;
            }
        });
        // $scope.applySchema = function() {
            var maskew = new Maskew(document.getElementById("setupProfileImage"), 20);
        // };

        if ($scope.bJourneyObj.isManager) {
            data = { "fbUsername": user_data.fbUsername };

            $scope.id = user_data.fbUsername;
            $scope.lpId = user_data.lpId;
        } else if ($scope.bJourneyObj.isHead) {
            data = { "clientId": user_data.clientId };
            $scope.id = user_data.clientId;
            $scope.lpId = user_data.lpId;
        }

        $rootScope.$on('buyer-help', function() {
            $state.go('home.help');
        });

        $rootScope.$on('help-close', function() {

            $state.go('ldashboard');
        });

        $scope.$on('approveRetake', function() {

            var aData = { "fbUSerId": $scope.learner, "lpId": $scope.lpId, "ptId": $scope.ptId, "moduleSeqId": $scope.moduleSeqId, "moduleTitle": $scope.moduleTitle }
            fetchData.approveLearner(aData).then(function(response) {
                $scope.learner = null;
                $scope.ptId = null;
                $scope.moduleSeqId = null;
                angular.element(".learner-view:eq(" + $scope.index + ")").css('display', 'none');
                angular.element(".approved-learner:eq(" + $scope.index + ")").css('display', 'block');
            });

        });

        $scope.approveLearner = function(learner, lpId, ptId, moduleSeqId, index, moduleTitle) {

            $rootScope.$broadcast('approval-popout');

            $scope.index = index;
            $scope.learner = learner;
            $scope.ptId = ptId;
            $scope.lpId = lpId;
            $scope.moduleSeqId = moduleSeqId;
            $scope.moduleTitle = moduleTitle;

        }

    });
'use strict';
(function() {
    angular
        .module('jigsawCorpLms')
        .config(routerConfig);

    function routerConfig($stateProvider) {
        $stateProvider
            .state('home.libVideo', {
                url: '/libraryVideoPlayer',
                templateUrl: 'app/Features/libraryPageVideoPlayer/libraryPageVideoPlayer.html',
                controller: 'libraryPageVideoCntrl'
            });
    }
})();

'use strict';
angular
    .module( 'jigsawCorpLms' )
    .controller( 'libraryPageVideoCntrl', function ($scope, $controller ,fetchData,$sce) {

        $scope.videoPage = $sce.trustAsResourceUrl( 'app/Features/learnerView/template/videoPlayerPage/videoPlayer.html' );
        $scope.videoPagePlaylist = $sce.trustAsResourceUrl( 'app/Features/libraryPageVideoPlayer/template/libVideoPlayList.html' );
        angular.extend( this, $controller( 'videoCommonCntrl', {
            $scope: $scope
        } ) );

        // Playlist New 
        $scope.openPlaylistModule = function( playlistItemIndex, videoIndex ) {
            $scope.openTilePlaylist = !$scope.openTilePlaylist;
            $scope.crntPlyNo = playlistItemIndex;
            $scope.crntPlyModule = videoIndex
        };

        fetchData.fetchLibraryData().then( function( response ) {
            $scope.playlists = response.data.playlistData.userPlaylistData;
        } );
    } );

'use strict';
angular
    .module( 'jigsawCorpLms' )
    .controller( 'libraryPageCntrl', function ( $scope, $window, $sce, fetchData, $rootScope, $state, DataCache, $timeout ) {

        // variables to add headers
        $rootScope.headerShow = true;
        $rootScope.scndHdr = true;
        $rootScope.libraryState = true;
        $scope.viewMoreList = [ ];
        $scope.lpViewMore = [ ];
        $scope.moreUsrPlaylist = 2;
        $scope.moreCurPlaylist = 2;
        $scope.exploreLib = true;
        $scope.skillPage = true;
        $scope.skilPageTab = '1';
        $scope.libPlaylistState = true;
        $scope.playListState = true;
        $scope.libTab = 1;
        $scope.contentURL = $sce.trustAsResourceUrl( 'app/Features/libraryPage/template/skillPageContent.html' );
        $scope.helpMePage = $sce.trustAsResourceUrl( 'app/Features/libraryPage/template/helpMePlan.html' );
        $scope.libSearchPage = $sce.trustAsResourceUrl( 'app/Features/libraryPage/template/libSearchPage.html' );
        $scope.playListDrawer = $sce.trustAsResourceUrl( 'app/Features/libraryPage/template/playlistNavDrawer.html' );
        var prevTrendingItem, prevNewItem, prevRecommendItem, prevLPxpndItem, prevModLibIndex;
        $scope.filters = [ "All", "Skills", "playlist", "learning Path", "Videos", "practice" ];
        $scope.srchResultFilter = [ 'relevance', 'type', "popular", "recent" ];
        $scope.filterParam = $scope.filters[ 0 ];
        $scope.srchResultFilterItem = $scope.srchResultFilter[ 0 ];

        fetchData.fetchLibraryData( ).then( function ( response ) {
            $scope.LibData = response.data;
            $scope.helpMePlanData = $scope.LibData.helpMePlanData;

            // $scope.helpMePlanData.lpEndDate = new Date( $scope.helpMePlanData.lpEndDate );

            $scope.lastThreeModules = $scope.LibData.recentModuleData;
            $scope.ToolData = $scope.LibData.toolsData;
            $scope.techniqueData = $scope.LibData.techniqueData;
            $scope.domainData = $scope.LibData.domainData;

            $scope.sortToolData( $scope.ToolData );
            $scope.sortTechniqueData( $scope.techniqueData );
            $scope.sortDomainData( $scope.domainData );

            $scope.lpData = $scope.LibData.lpData;
            $scope.initViewMore( );
            $scope.noOfHrsWeek = 10;

            for ( var i = 0; i < $scope.lpData.length - 1; i++ ) {
                $scope.lpViewMore[ i ] = 3;
            }
        } );

        fetchData.fetchPlaylistData( ).then( function ( response ) {
            $scope.playListData = response.data.playlistData;
            $scope.curatedPlaylistData = $scope.playListData.curatedPlaylistData;
            $scope.userPlaylistData = $scope.playListData.userPlaylistData;
            $scope.myQueData = response.data.queData;
            $scope.quedVideos = $scope.myQueData.quedVideos;
        } );

        // initializing variable for view more in Skills Page
        $scope.initViewMore = function ( ) {
            for ( var i = 0; i < 3; i++ ) {
                $scope.viewMoreList[ i ] = [ ];
                for ( var j = 0; j < 3; j++ ) {
                    $scope.viewMoreList[ i ][ j ] = 3;
                }
            }
        };
        // Skew Image in the Header
        $scope.applySchemaLib = function ( ) {
            $timeout( function ( ) {
                var maskew = new Maskew( document.getElementById( 'rhombusProfileImageLib' ), 28 );
            }, 200 );

        };
        // Sort The data for Tool Data
        $scope.sortToolData = function ( data ) {
            var i = 0
            var length = data.length;
            $scope.toolTrendData = [ ];
            $scope.toolNewData = [ ];
            $scope.toolRecomendData = [ ];
            for ( i = 0; i < length; i++ ) {
                switch ( data[ i ].type ) {
                case 'trending':
                    $scope.toolTrendData.push( data[ i ] );

                    break;

                case 'new':
                    $scope.toolNewData.push( data[ i ] );
                    break;
                case 'recommended':
                    $scope.toolRecomendData.push( data[ i ] );
                    break;
                }
            }

        };
        // Sort The data for Techiniques Data
        $scope.sortTechniqueData = function ( data ) {
            var i = 0
            var length = data.length;
            $scope.techniqueTrendData = [ ];
            $scope.techniqueNewData = [ ];
            $scope.techniqueRecomendData = [ ];
            for ( i = 0; i < length; i++ ) {

                switch ( data[ i ].type ) {
                case 'trending':
                    $scope.techniqueTrendData.push( data[ i ] );

                    break;

                case 'new':
                    $scope.techniqueNewData.push( data[ i ] );
                    break;
                case 'recommended':
                    $scope.techniqueRecomendData.push( data[ i ] );
                    break;
                }
            }

        };
        // Sort The data for Domain  Data
        $scope.sortDomainData = function ( data ) {
            var i = 0
            var length = data.length;
            $scope.DomainTrendData = [ ];
            $scope.DomainNewData = [ ];
            $scope.DomainRecomendData = [ ];
            for ( i = 0; i < length; i++ ) {

                switch ( data[ i ].type ) {
                case 'trending':
                    $scope.DomainTrendData.push( data[ i ] );

                    break;

                case 'new':
                    $scope.DomainNewData.push( data[ i ] );
                    break;
                case 'recommended':
                    $scope.DomainRecomendData.push( data[ i ] );
                    break;
                }
            }

        };

        // function to Explore Page Tab
        $scope.showLibContent = function ( ) {
            $scope.exploreLib = true;
            $scope.stickyClass = 'big-hdr';
            $scope.marginChangeSticky = 'remove-margin';
            $scope.sticky = false;
            $( '.lib-nav-draw-playlist' ).removeClass( 'lib-nav-draw-playlist-sticy-view' );
        };
        // function to Open CLipboard Page Tab
        $scope.showClipboardWrp = function ( ) {
            $scope.exploreLib = false;
            $scope.stickyClass = 'small-hdr';
            $scope.marginChangeSticky = 'add-margin';
            $scope.sticky = true;
            $( '.lib-nav-draw-playlist' ).addClass( 'lib-nav-draw-playlist-sticy-view' );
        };


        // This function opens the skills Page

        $scope.showSkillContent = function ( ) {
            $scope.skillPage = true;
        };


        // FUnction responsible for sticky header
        setTimeout( function ( ) {
            angular.element( '.lib-page-wrp' ).bind(
                "scroll",
                function ( ) {
                    if ( !$scope.srchPage ) {
                        var scrolled = angular.element( '.lib-page-wrp' )[ 0 ].scrollTop;
                        if ( scrolled > 10 ) {
                            $scope.stickyClass = 'small-hdr';
                            $scope.marginChangeSticky = 'add-margin';
                            $( '.lib-nav-draw-playlist' ).addClass( 'lib-nav-draw-playlist-sticy-view' );
                            $scope.sticky = true;


                        } else {

                            $scope.stickyClass = 'big-hdr';
                            $scope.marginChangeSticky = 'remove-margin';
                            $scope.sticky = false;
                            $( '.lib-nav-draw-playlist' ).removeClass( 'lib-nav-draw-playlist-sticy-view' )
                        }
                    }

                    $scope.$apply( );
                } );
        }, 300 );


        $scope.$watch(
            function ( ) {
                return $scope.sticky;
            },
            function ( newVal ) {
                if ( newVal ) {
                    $( '.lib-page-wrp' ).animate( {
                        scrollTop: 15
                    }, 400 );
                }
            }
        );

        $scope.openTileOverlay = function ( index ) {
            $scope.currentTrendingItem = index;
            if ( index == prevTrendingItem ) {
                $scope.shwOverlay = !$scope.shwOverlay;
            } else {
                $scope.shwOverlay = true;
            }
            prevTrendingItem = index;
        };

        $scope.openTileOverlayNewItem = function ( index ) {
            $scope.currentNewItem = index;
            if ( index == prevTrendingItem ) {
                $scope.shwOverlayNewItem = !$scope.shwOverlayNewItem;
            } else {
                $scope.shwOverlayNewItem = true;
            }
            prevTrendingItem = index;
        };

        $scope.openTileOverlayRecommend = function ( index ) {
            $scope.currentRecommendItem = index;
            if ( index == prevRecommendItem ) {
                $scope.shwOverlayRecomend = !$scope.shwOverlayRecomend;
            } else {
                $scope.shwOverlayRecomend = true;
            }
            prevRecommendItem = index;
        };


        // function to change between Three Tabs in Skills ie Techniques / Tools / Domains
        $scope.openSkillTab = function ( tabNo ) {
            switch ( tabNo ) {
            case 1:
                $scope.skilPageTab = '1';
                break;

            case 2:
                $scope.skilPageTab = '2';
                break;
            case 3:
                $scope.skilPageTab = '3';
                break;
            }
        };
        // function to change Tabs between Playlists, Learning Paths , and Skills
        $scope.tabChangeMain = function ( tabNo ) {
            switch ( tabNo ) {
            case 1:
                $scope.libTab = 1;
                $scope.contentURL = $sce.trustAsResourceUrl( 'app/Features/libraryPage/template/skillPageContent.html' );
                break;

            case 2:
                $scope.libTab = 2;
                $scope.contentURL = $sce.trustAsResourceUrl( 'app/Features/libraryPage/template/LibplaylistPage.html' );
                break;
            case 3:
                $scope.libTab = 3;
                $scope.contentURL = $sce.trustAsResourceUrl( 'app/Features/libraryPage/template/libLPpage.html' );
                break;
            }
        };

        // FUnction to Open
        $scope.openCuratedPlaylistTab = function ( ) {
            $scope.libPlaylistState = true;
        };

        $scope.openMyPlaylistTab = function ( ) {
            $scope.libPlaylistState = false;
        };

        $scope.openLibLPpath = function ( lpID ) {

            $scope.lpIndex = lpID;
            if ( lpID == prevLPxpndItem ) {
                $scope.shwLPxpand = !$scope.shwLPxpand;
            } else {
                $scope.shwLPxpand = true;
            }
            prevLPxpndItem = lpID;
        };

        $scope.openModuleExpand = function ( modIndex ) {
            $scope.selectedModuleIndexLib = modIndex;
            if ( modIndex == prevModLibIndex ) {
                $scope.shwexpandModule = !$scope.shwexpandModule;

            } else {
                $scope.shwexpandModule = true;

            }
            prevModLibIndex = modIndex;
            setTimeout( function ( ) {
                $scope.adjustHeightTab( );
            }, 100 );

        };

        $scope.adjustHeightTab = function ( index ) {
            var parentEle = angular.element( '.lib-page-last-three-wrp' )[ 0 ];
            parentEle.style.height = 'auto';
            var parentEleheight = parentEle.clientHeight;
            if ( angular.element( '.lib-cont-watching-wrp' ).length ) {
                var moduleExpndEle = angular.element( '.lib-cont-watching-wrp' )[ 0 ].clientHeight;
            }

            var tempHeight = moduleExpndEle + parentEleheight;
            tempHeight = tempHeight + 20;
            if ( index != prevModLibIndex && $scope.shwexpandModule ) {
                parentEle.style.height = tempHeight + 'px';
            } else {
                parentEle.style.height = 'auto';
            }
        };

        $scope.openMyQPlaylist = function ( ) {
            $scope.playListState = true;
        };

        $scope.openMyPlaylist = function ( ) {
            $scope.playListState = false;
        };

        $scope.togglePlaylist = function ( ) {
            $scope.libPlaylistToggle = !$scope.libPlaylistToggle;
            if ( $scope.libPlaylistToggle ) {
                $scope.plyListBarClass = 'plylist-anim-out';
                $scope.plyListClass = 'lib-panel-out'
            } else {
                $scope.plyListBarClass = 'plylist-anim-in';
                $scope.plyListClass = 'lib-panel-in';
            }

        };

        $scope.openPlaylistContent = function ( ) {
            $scope.shwExpndOfPlaylist = !$scope.shwExpndOfPlaylist;
        };

        $scope.toggleHelpScreen = function ( ) {
            $scope.shwHelpMePage = !$scope.shwHelpMePage;
        };

        $scope.myDate = new Date( );
        $scope.minDate = new Date(
            $scope.myDate.getFullYear( ),
            $scope.myDate.getMonth( ),
            $scope.myDate.getDate( ) );
        $scope.maxDate = new Date(
            $scope.myDate.getFullYear( ),
            $scope.myDate.getMonth( ) + 2,
            $scope.myDate.getDate( ) );
        $scope.onlyWeekendsPredicate = function ( date ) {
            var day = date.getDay( );
            return day === 0 || day === 6;
        }

        $scope.selectFilterParam = function ( index ) {
            $scope.shwSrchFilter = !$scope.shwSrchFilter;
            $scope.filterParam = $scope.filters[ index ];
        };

        $scope.toggleFilterState = function ( ) {
            $scope.shwSrchFilter = !$scope.shwSrchFilter;
        };

        $scope.srchPageInput = function ( value ) {
            if ( value ) {
                $scope.srchPage = true;
                $scope.stickyClass = 'small-hdr';
                $scope.marginChangeSticky = 'add-margin';
                $scope.sticky = true;
                fetchData.fetchLibrarySearchData( ).then( function ( response ) {
                    $scope.srchSuggestion = response.data.suggestionData;
                    $scope.srchResults = response.data.searchReslts;
                    $scope.sortFilterData( $scope.srchResults );
                } );
            }
        };

        $scope.sortFilterData = function ( data ) {

            $scope.srchFilteredData = {
                "video": [ ],
                'practice': [ ],
                'lp': [ ],
                'skill': [ ]
            }

            for ( var i = data.length - 1; i >= 0; i-- ) {
                switch ( data[ i ].type ) {
                case 'video':
                    $scope.srchFilteredData.video.push( data[ i ] );
                    break;
                case 'quiz':
                case 'assignment':
                    $scope.srchFilteredData.practice.push( data[ i ] );

                    break;
                case 'skill':
                    $scope.srchFilteredData.skill.push( data[ i ] );

                    break;
                case 'lp':
                    $scope.srchFilteredData.lp.push( data[ i ] );
                    break;
                }
            }
        };

        $scope.closeSrch = function ( ) {
            $scope.srchPage = false;
            $scope.stickyClass = 'big-hdr';
            $scope.marginChangeSticky = 'remove-margin';
            $scope.sticky = false;
            $scope.exploreLib = true;
        };

        $scope.srchFilterToggle = function ( ) {
            $scope.toggleSrchFilter = !$scope.toggleSrchFilter;
        };

        $scope.srchResultFilterParam = function ( index ) {
            $scope.toggleSrchFilter = !$scope.toggleSrchFilter;
            $scope.srchResultFilterItem = $scope.srchResultFilter[ index ];
            switch ( $scope.srchResultFilterItem ) {
            case 'relevance':
                $scope.shwDataByFilter = false;
                break;

            case 'type':
                $scope.shwDataByFilter = true;
                break;
            case 'popular':
                $scope.shwDataByFilter = false;
                break;
            case 'recent':
                $scope.shwDataByFilter = false;
                break;
            }

        };

        $scope.togglePlaylistMobile = function ( ) {
            $scope.playListMobile = !$scope.playListMobile;
        };

        $scope.openPlaylistModule = function ( playlistItemIndex, videoIndex ) {
            $scope.openTilePlaylist = !$scope.openTilePlaylist;
            $scope.crntPlyNo = playlistItemIndex;
            $scope.crntPlyModule = videoIndex
        };


        $scope.shwOvrlyLastPlayed = function ( index ) {
            $scope.shwOverlay = !$scope.shwOverlay;
            $scope.lastPlayedTileIndx = index;
        };

        $scope.Tilestate = 'start';



        $scope.openAddPlaylist = function ( ) {
            if ( $scope.shwPlaylistItems ) {
                $scope.Tilestate = 'start';
            } else {
                $scope.Tilestate = 'addToPlaylist';
            }

            $scope.shwPlaylistItems = !$scope.shwPlaylistItems
        };

        $scope.addModuleToPlaylist = function ( playlistID ) {
            $scope.Tilestate = 'start';
            $scope.shwOverlay = !$scope.shwOverlay;
            $scope.shwPlaylistItems = !$scope.shwPlaylistItems
        };
        $scope.createPlaylist = function ( ) {
            $scope.Tilestate = 'createPlaylist';
        };
        $scope.closeCreatePlaylist = function ( ) {
            $scope.shwOverlay = !$scope.shwOverlay;
            $scope.Tilestate = 'start';

        };


        $scope.openVideoPlayer = function ( ) {
            $rootScope.modelParent.isFromLib = true;
            $state.go( 'home.learn.video' );
        };

        $scope.SaveHelpScreen = function ( endDate ) {
            $scope.toggleHelpScreen( );
            $scope.coursePlanAvailable = true;
        };

        $scope.viewMoreItem = function ( tabNo, ItemNo ) {
            tabNo = tabNo - 1;
            ItemNo = ItemNo - 1;
            $scope.viewMoreList[ tabNo ][ ItemNo ] = $scope.viewMoreList[ tabNo ][ ItemNo ] + 3;
        };

        $scope.viewLessItem = function ( tabNo, ItemNo ) {
            tabNo = tabNo - 1;
            ItemNo = ItemNo - 1;
            $scope.viewMoreList[ tabNo ][ ItemNo ] = 3;
        };

        $scope.viewMoreUsrPlaylist = function ( ) {
            $scope.moreUsrPlaylist = $scope.moreUsrPlaylist + 3;
        };
        $scope.viewMoreCurPlaylist = function ( ) {
            $scope.moreCurPlaylist = $scope.moreCurPlaylist + 3;
        };
        $scope.viewMoreTileLp = function ( index ) {
            $scope.lpViewMore[ index ] = $scope.lpViewMore.index + 3;
        };

        $scope.playThisVideo = function ( data ) {
            DataCache.saveGlobalData( 'thisPlaylist', data );
            DataCache.saveGlobalData( 'thisModuleData', data );
            $scope.openVideoPlayer( );
        };

        $scope.usrImage = function ( ) {

            var temp = 'url("' + $rootScope.modelParent.userImage + '")';
            return {
                'background-image': temp
            }
        }

        $scope.applySchemaLib( );


    } );

'use strict';
(function() {
    angular
        .module('jigsawCorpLms')
        .config(routerConfig);

    function routerConfig($stateProvider) {
        $stateProvider
            .state('home.library', {
                url: '/library',
                templateUrl: 'app/Features/libraryPage/libraryPage.html',
                controller: 'libraryPageCntrl'
            });
    }
})();

'use strict';
( function() {
    angular
        .module( 'jigsawCorpLms' )
        .config( routerConfig );

    /** @ngInject */
    function routerConfig( $stateProvider ) {
        $stateProvider
            .state( 'home.learn', {
                url: '/learn',
                templateUrl: 'app/Features/learnerView/learnerView.html',
                controller: 'learnerViewController'
            } );
    }

} )();

'use strict';
(function() {


    angular
        .module('jigsawCorpLms')
        .controller('learnerViewController', learnerViewController);

    /** @ngInject */
    function learnerViewController($timeout, $state, $rootScope, $scope, fetchData, $filter, DataCache, $http, FirebaseService) {

        $scope.currentState = $state.current.name;
        $rootScope.moduleHeader = false;

        $rootScope.headerShow = true;
        $rootScope.scndHdr = false;

        $scope.modulePlaylistItems = DataCache.returnData('thisModuleDetails');

        $scope.authData = DataCache.returnData("userData");
        if ($scope.authData == undefined || $scope.authData == null || !$scope.authData) {
            $state.go("login");
            return;
        } else {
            //changes made for new SDK
            $scope.idToken = DataCache.returnData("idToken");
            //$http.defaults.headers.common['Authorization'] = "Bearer " + $scope.idToken;
            $http.defaults.headers.common['Authorization'] = "Bearer " + $scope.authData.jwttoken;
            $http.defaults.headers.common['Content-Type'] = "application/x-www-form-urlencoded";
        }
        // if($rootScope.events === undefined){
        //     $rootScope.events=DataCache.returnData("event");
        // }

        var ref = FirebaseService.ref.child($rootScope.events);

        /*
        fetchData.fetchClipboardData( ).then( function ( response ) {
            $scope.clipboardData = response.data.clipboardata;
            $scope.rearrangeDataClipboard( $scope.clipboardData );
        } );
        */

        $scope.reportIssueFunc = function() {
            var activeModule = DataCache.returnData('thisModuleData');
            var details = DataCache.returnData('details');
            var activeModuleData = details[activeModule.moduleId][$rootScope.currentSequenceId];
            if (activeModuleData.type === 'video'){
                $rootScope.pauseVideo();
            }
            //$scope.expandedReportIssue = !$scope.expandedReportIssue;

            $rootScope.modelParent.isReportAnIssueViewActive = true;
            $rootScope.modelParent.bringInReportAnIssue = true;
        };

        $scope.rearrangeDataClipboard = function(responseClipboard) {
            var uniqueDates = 0;
            $scope.clipboardataSorted = [];
            $scope.clipboardData = $filter('orderBy')($scope.clipboardData, 'date_created', true);
            var tempArray = [];
            tempArray.push($scope.clipboardData[0]);
            for (var i = 0; i < $scope.clipboardData.length; i++) {
                var tempDate = moment($scope.clipboardData[i].date_created).format('D MMM, YYYY');
                if (prevDate != tempDate) {
                    uniqueDates++
                    var temp = {
                        "date_created": tempDate,
                        'data': ""
                    }
                    $scope.clipboardataSorted[uniqueDates] = temp;
                    if (i !== 0) {
                        tempArray = [$scope.clipboardData[i]];
                    }

                } else {
                    tempArray.push($scope.clipboardData[i]);
                }
                $scope.clipboardataSorted[uniqueDates].data = tempArray;
                var prevDate = tempDate;
            }
            $scope.clipboardataSorted.shift();

            $scope.totalItemsClipboard = $scope.clipboardData.length;
            $scope.clipboardataLength = $scope.clipboardataSorted.length;

        };


        $scope.slickConfig = {
            enabled: true,
            autoplay: false,
            draggable: true,
            autoplaySpeed: 3000,
            infinite: false,
            variableWidth: true,
            method: {},
            event: {
                afterChange: function(event, slick, currentSlide, nextSlide) {
                    $scope.currentIndex = currentSlide; // save current index each time
                }
            }
        };
        $scope.slideClipboardLeft = function() {
            $scope.slickConfig.method.slickNext();
        }
        $scope.slideClipboardRight = function() {
            $scope.slickConfig.method.slickPrev();
        }


        $scope.onStateChange = function(state) {

            $scope.currentState = state;

        }

        $scope.$watch(
            function() {
                return $state.current.name;
            },
            function(newVal) {
                $scope.onStateChange(newVal);
            }
        );

        $scope.$on('takeScreenShot', function(event, activeTime) {
            var tempDate = new Date();
            var date = $filter('date')(tempDate, 'medium');
            var tempVidClipData = {
                "id": 1,
                "video_id": "",
                "date_created": date,
                "type": "screenshot",
                "title": "Important Point",
                "thumbnail": "assets/images/D5.png",
                "clipdata": {
                    "start_time": activeTime
                }
            }
            $scope.clipboardData.push(tempVidClipData);
            $scope.rearrangeDataClipboard($scope.clipboardData);
            $scope.setSlick();
        });

        $scope.setSlick = function() {
            $scope.slickConfig.enabled = false;
            $timeout(function() {
                $scope.slickConfig.enabled = true;
            }, 100);
        }

        $scope.$on('trimVideo', function(event, startTime, endTime) {
            var tempDate = new Date();
            var date = $filter('date')(tempDate, 'medium');
            var tempVidClipData = {
                "id": 1,
                "video_id": "",
                "date_created": date,
                "type": "trimmedvideo",
                "title": "Important Point",
                "thumbnail": "assets/images/D1.png",
                "clipdata": {
                    "start_time": startTime,
                    "end_time": endTime,
                    "video_url": "assets/IntroSASvideo1.mp4"

                }
            }
            $scope.clipboardData.push(tempVidClipData);
            $scope.rearrangeDataClipboard($scope.clipboardData);
            $scope.setSlick();
        });

        $scope.$on('takeScreenShot', function(event, activeTime) {
            var tempDate = new Date();
            var date = $filter('date')(tempDate, 'medium')

            var tempVidClipData = {
                "id": 1,
                "video_id": "",
                "date_created": date,
                "type": "screenshot",
                "title": "Important Point",
                "thumbnail": "assets/images/D5.png",
                "clipdata": {
                    "start_time": activeTime
                }
            }
            $scope.clipboardData.push(tempVidClipData);
            $scope.rearrangeDataClipboard($scope.clipboardData);
            $scope.setSlick();
        });


        $scope.playPrevItem = function() {
            if ($rootScope.currentSequenceId - 1 > 0) {
                $rootScope.currentSequenceId = $rootScope.currentSequenceId - 1;
                $scope.changeStatePlaylist();
            }
        };

        $scope.playNextItem = function() {
            var length = $scope.modulePlaylistItems.length;
            if ($rootScope.currentSequenceId + 1 <= length) {
                $rootScope.currentSequenceId = $rootScope.currentSequenceId + 1;
                $scope.changeStatePlaylist();
            }
        };



        $scope.changeStatePlaylist = function() {
            var length, i = 1;
            length = $scope.modulePlaylistItems.length;
            while (i < length) {
                if ($scope.modulePlaylistItems[i].sequenceId == $rootScope.currentSequenceId) {

                    $scope.activeModule = DataCache.returnData('thisModuleData');
                    $scope.activeModuleData = $scope.activeModule;
                    $scope.details = DataCache.returnData('details');
                    $scope.summaryData = DataCache.returnData("summary");
                    $scope.activeResourceData = $scope.details[$scope.activeModule.moduleId][$rootScope.currentSequenceId];


                    var userData = DataCache.returnData("userData");

                    $scope.eventObject = {
                        "group": "lprogress",
                        "type": "lresource",
                        "data": {
                            "action": "update",
                            "teamId": userData.teamId,
                            "clientId": userData.clientId,
                            "lpId": userData.lpId,
                            "lpTitle": userData.lpTitle,
                            "token": userData.token,
                            "moduleId": $scope.activeModule.moduleId.toString(),
                            "resourceId": $scope.activeResourceData.id.toString(),
                            "moduleSeqId": $scope.activeModule.sequenceId.toString(),
                            "resourceSeqId": $rootScope.currentSequenceId.toString(),
                            "timestamp": $filter('date')(new Date(), 'yyyy-MM-dd HH:mm:ss')
                        }
                    };
                    if (DataCache.returnLpData('currentLp') === 'active') {
                        ref.push().child($scope.authData.uid).set($scope.eventObject);
                    }
                    switch ($scope.modulePlaylistItems[i].type) {

                        case 'quiz':
                            $rootScope.headerShow = true;
                            $rootScope.scndHdr = false;
                            $state.go('home.learn.quiz', { sequenceId: $rootScope.currentSequenceId }, { reload: 'home.learn.quiz', inherit: false, notify: true });
                            break;
                        case 'video':
                            $rootScope.headerShow = true;
                            $rootScope.scndHdr = false;
                            $state.go('home.learn.video', { sequenceId: $rootScope.currentSequenceId }, { reload: 'home.learn.video', inherit: false, notify: true });
                            break;
                        case 'csa':
                            $rootScope.headerShow = true;
                            $rootScope.scndHdr = false;
                            $state.go('home.learn.assessment', { sequenceId: $rootScope.currentSequenceId }, { reload: 'home.learn.assessment', inherit: false, notify: true });
                            break;
                        case 'material':
                            $rootScope.headerShow = true;
                            $rootScope.scndHdr = false;
                            $state.go('home.learn.resources', { sequenceId: $rootScope.currentSequenceId }, { reload: 'home.learn.resources', inherit: false, notify: true });
                            break;
                        case 'ytc':
                            $rootScope.headerShow = true;
                            $rootScope.scndHdr = false;
                            $state.go('home.learn.ytc', { sequenceId: $rootScope.currentSequenceId }, { reload: 'home.learn.ytc', inherit: false, notify: true });
                            break;
                        default:
                            $rootScope.headerShow = true;
                            $rootScope.scndHdr = false;
                            $state.go('home.learn.video', { sequenceId: $rootScope.currentSequenceId }, { reload: 'home.learn.video', inherit: false, notify: true });
                            break;
                    }
                    break;
                } else {
                    i++;
                }
            }
            //$scope.$emit( 'playListUpdate', $scope.modulePlaylistItems[ $rootScope.currentSequenceId - 1 ] );
        };

        $scope.clipBrdOpen = function() {
            $scope.overlay = !$scope.overlay;
            $scope.isClipboardIconClicked = true
            $scope.ShwClipBrdTile = false;
        };

        $scope.profTestQuestions = DataCache.returnData('profTestQuestions');


        $scope.openClipBoardTile = function(event, thisElem) {
            $scope.ShwClipBrdTile = true;
            var p = $(event.currentTarget).offset();
            var OpentileEle = angular.element('.vid-ask-expert-overlay')[0];
            var tempLeft = p.left;
            OpentileEle.style.left = tempLeft + 'px';

        };

        $scope.repositionClipBrdTile = function() {

        };

        $scope.deleteFrmClipBrd = function(activeItem, ParentItem) {
            for (var i = $scope.clipboardataSorted.length - 1; i >= 0; i--) {
                if ($scope.clipboardataSorted[i] == ParentItem) {
                    var dateData = $scope.clipboardataSorted[i].data;
                    dateData.forEach(function(val, ind) {
                        if ($scope.clipboardataSorted[i].data[ind] === activeItem) {
                            $scope.clipboardataSorted[i].data.splice(ind, 1);
                            $scope.refreshClipboardArray();
                        }
                    })
                }
            }
        };

        $scope.refreshClipboardArray = function() {
            var totalItems = 0;
            $scope.totalItemsClipboard = $scope.totalItemsClipboard - 1;
            for (var i = 0; i < $scope.clipboardataSorted.length - 1; i++) {
                if ($scope.clipboardataSorted[i] && $scope.clipboardataSorted[i].data.length == 0) {
                    $scope.clipboardataSorted.splice(i, 1);

                    $scope.setSlick();

                }

            }

        };




    }
})();
'use strict';
( function() {
    angular
        .module( 'jigsawCorpLms' )
        .config( routerConfig );

    /** @ngInject */
    function routerConfig( $stateProvider ) {
        $stateProvider
            .state( 'home.help', {
                url: '/help',
                templateUrl: 'app/Features/helpPage/helpPage.html',
                controller: 'helpViewCntrl'
            } );
    }

} )();

'use strict';
(function() {
    angular
        .module('jigsawCorpLms')
        .controller('helpViewCntrl', helpViewCntrl);

    /** @ngInject */
    function helpViewCntrl($http, $timeout, $state, $rootScope, $scope, fetchData, $filter, DataCache) {

        var user_data = DataCache.returnData('userData');
        if (user_data == undefined) {
            $state.go('login');
        } else {
            //changes made for new SDK
            $scope.idToken = DataCache.returnData("idToken");
            //$http.defaults.headers.common['Authorization'] = "Bearer " + $scope.idToken;
            $http.defaults.headers.common['Authorization'] = "Bearer " + user_data.jwttoken;
            $http.defaults.headers.common['Content-Type'] = "application/x-www-form-urlencoded";
        }

        $rootScope.headerShow = false;
        $rootScope.scndHdr = false;
        $rootScope.libraryState = false;
        $state.go('home.help.faq');
        $scope.tabs = ['faq', 'support'];
        // $scope.tabs = [''];
        $scope.currentTabName = 0;
        $scope.hey = "heyejkhasjk";
        $scope.shwSupportTabs = true;
        $scope.toggleTickets = true;
        $scope.user_data = DataCache.returnData("userData");

        if ($scope.user_data.role === "Learner") {
            fetchData.fetchGlobalHelpData().then(function(response) {
                $scope.ticketsData = formatEachDate(response.data.ticketsData);
                $scope.ticketsDuplicate = [];
                angular.copy($scope.ticketsData, $scope.ticketsDuplicate);
                $scope.supportOptions = response.data.supportSuggestions;
                $scope.allQuestions = response.data.frequentlyAskedQuestions;
                $scope.sortAllQuestions($scope.allQuestions);
                $scope.takeAtourData = response.data.takeAtourData;
            });
        } else {
            fetchData.fetchGlobalHelpDataManager().then(function(response) {
                $scope.ticketsData = formatEachDate(response.data.ticketsData);
                $scope.ticketsDuplicate = [];
                angular.copy($scope.ticketsData, $scope.ticketsDuplicate);
                $scope.supportOptions = response.data.supportSuggestions;
                $scope.allQuestions = response.data.frequentlyAskedQuestions;
                $scope.sortAllQuestions($scope.allQuestions);
                $scope.takeAtourData = response.data.takeAtourData;
            });
        }




        var formatEachDate = function(value) {
            value.filter(function(value) {
                value.ticketDate = new Date(value.ticketDate);
            });
            return value;
        };

        $scope.sortAllQuestions = function(questions) {
            $scope.contentQuestions = [];
            $scope.faqQuestions = [];
            $scope.trblShtingQuestions = [];
            $scope.learningQuestions = [];
            for (var i = questions.length - 1; i >= 0; i--) {
                var item = questions[i];
                switch (item.type) {
                    case 'learning':
                        $scope.learningQuestions.push(item);
                        break;
                    case 'content':
                        $scope.contentQuestions.push(item);
                        break;
                    case 'troubleshooting':
                        $scope.trblShtingQuestions.push(item);
                        break;
                }
            }
            if ($scope.user_data.role !== "Learner") {
                for (var i = questions.length - 1; i >= 0; i--) {
                    var item = questions[i];
                    $scope.faqQuestions.push(item);
                }
            } else {
                $scope.faqQuestions = $scope.learningQuestions;
            }
        };
        $scope.changeTab = function(tabIndex) {
            $scope.shwSupportTabs = false;
            $scope.currentTabName = tabIndex;
            switch (tabIndex) {
                case 0:
                    $state.go('home.help.faq');
                    break;
                case 1:
                    $state.go('home.help.support');
                    $scope.shwSupportTabs = true;
                    break;
                case 2:
                    $state.go('home.help.takeTour');
                    break;
            }
        };

        $scope.currentState = $state.current.name;

        $scope.openNewTicket = function() {
            $scope.toggleTickets = true;
        };

        $scope.goToDashboard = function() {
            $scope.userDetails = DataCache.returnData("userData");
            var user;
            if ($scope.userDetails.hasOwnProperty('auth')) {
                user = $scope.userDetails.auth.role;
            } else {
                user = $scope.userDetails.role;
            }
            if (user === "Learner") {

                $rootScope.$broadcast('dashboard');
                // $rootScope.headerShow = true;
                // $rootScope.scndHdr = true;
                // $rootScope.dashArrow = true;
                // $rootScope.moduleHeader = false;
                // $state.go( 'home.dashboard' );
            } else if (user === "L&D Manager" || user === "Manager") {

                $rootScope.$broadcast('buyers-dashboard');
                //$state.go('buyer.dashboard.trackProgress');
                //$rootScope.$broadcast('help-close');
            } else {}
        };


        $scope.openMyTicket = function() {
            $scope.toggleTickets = false;
        };


    }
})();
'use strict';
angular.module('jigsawCorpLms')
    .controller('FeedbackCtrl', function($scope, $rootScope, $timeout, fetchData, $http, DataCache, $state) {

        $scope.authData = DataCache.returnData("userData");

        //changes made for new SDK
            $scope.idToken = DataCache.returnData("idToken");
            //$http.defaults.headers.common['Authorization'] = "Bearer " + $scope.idToken;
        $http.defaults.headers.common['Authorization'] = "Bearer " + $scope.authData.jwttoken;
        $http.defaults.headers.common['Content-Type'] = "application/x-www-form-urlencoded";

        $scope.parentObj = {};
        $scope.parentObj.radioOptions = [{
            'value': 'Excellent',
            'selectedModel': null
        }, {
            'value': 'Very good',
            'selectedModel': null
        }, {
            'value': 'Average',
            'selectedModel': null
        }, {
            'value': 'Bad',
            'selectedModel': null
        }, {
            'value': 'Poor',
            'selectedModel': null
        }];




        $scope.closeFeedbackCard = function() {
            $rootScope.modelParent.isFeedbackViewActive = false;
            $timeout(function() {
                $rootScope.modelParent.bringInFeedback = false;
            }, 100);
            if ($scope.authData.hasOwnProperty('auth')) {
                if ($scope.authData.auth.role === 'L&D Manager' || $scope.authData.auth.role === 'Manager') {
                    $state.go('login');
                }
            } else {
                if ($scope.authData.role === 'L&D Manager' || $scope.authData.role === 'Manager') {
                    $state.go('login');
                }
            }

        };

        $scope.takeNoteChange = function() {
            var ele = angular.element("textarea");
            ele.css('box-shadow', 'none');
        }

        $scope.passEvent = function($event) {
            var ele1 = angular.element(".feedback-content.relative");
            if (ele1[0] === $event.target || $(ele1).find($event.target).length > 0) {} else {
                $scope.closeFeedbackCard();
            }
        }

        $scope.submitFeedback = function() {
            if (!$scope.feedbackTxt || $scope.feedbackTxt === "" || $scope.feedbackTxt.trim().length === 0) {
                var ele = angular.element("textarea");
                ele.css('box-shadow', '0px 0px 22px -3px rgba(209,71,0,1)');
                ele.focus();
                return;
            };
            var data = { "feedbackRating": $scope.parentObj.thisSelectedModel, "feedbackDesc": $scope.feedbackTxt };
            fetchData.feedback(data).then(function(response) {
                if (response.data["error"]) {
                    console.log("inside error");
                } else {
                    $rootScope.modelParent.isFeedbackViewActive = false;
                    $timeout(function() {
                        $rootScope.modelParent.bringInFeedback = false;
                    }, 100);

                }

                if ($scope.authData.hasOwnProperty('auth')) {
                    if ($scope.authData.auth.role === 'L&D Manager' || $scope.authData.auth.role === 'Manager') {
                        $state.go('buyer');
                    }
                } else {
                    if ($scope.authData.role === 'L&D Manager' || $scope.authData.role === 'Manager') {
                        $state.go('buyer');
                    }
                }
                //$scope.success=true;
                //  $scope.closeFeedbackCard();
            });
        };

        $rootScope.$on('feedback', function() {
            console.log("feedback ctrl called through broadcast");
        });
    });
'use strict';
( function() {
    angular
        .module( 'jigsawCorpLms' )
        .config( routerConfig );

    /** @ngInject */
    function routerConfig( $stateProvider ) {
        $stateProvider
            .state( 'home.dashboard', {
                url: '/Dashboard',
                templateUrl: 'app/Features/dashboard/dashboardIndex.html',
                controller: 'DashboardCtrl'
            } );
    }
} )();

'use strict';
angular
    .module('jigsawCorpLms')
    .controller('DashboardCtrl', function($scope, $state, $rootScope, fetchData, DataCache, FirebaseService, $firebaseObject, $http, $window, $timeout, RestEndpoints) {


        var user_data = DataCache.returnData('userData');


        angular.element('#p-hints').removeAttr("data-hint");

        //DataCache.loadFromWebstorage();

        if (user_data == undefined) {
            $state.go('login');
        } else {
            //changes made for new SDK
            $scope.idToken = DataCache.returnData("idToken");
            //$http.defaults.headers.common['Authorization'] = "Bearer " + $scope.idToken;
            $http.defaults.headers.common['Authorization'] = "Bearer " + user_data.jwttoken;
            $http.defaults.headers.common['Content-Type'] = "application/x-www-form-urlencoded";
        }


        $rootScope.modelParent.isPopOutViewActive = false;
        $rootScope.modelParent.bringInPopOut = false;

        $rootScope.bheaderShow = false;
        $rootScope.headerShow = true;
        $rootScope.scndHdr = true;
        $rootScope.libraryState = false;


       

        if (screen.width > 640) {
            $scope.mobilefilter = true;
        } else {
            $scope.mobilefilter = false;
        }


        $scope.showDashboard = true;



        // changes for notifications


        $scope.downloadModuleData = function(document, sequenceId) {
            //console.log(" $scope.downloadModuleData ##########################################");
            $scope.baseUrl = RestEndpoints.baseURL + "/file"; // "http://localhost:1442/reports";
            $.get($scope.baseUrl + "/filecheck/" + user_data.jwttoken + "/" + sequenceId + "/" + sequenceId + "_all.zip", function(response) {
                $timeout(function() {
                    if (response.status === "error") {
                        $rootScope.$broadcast('noContentPopout');
                    } else {
                        $window.open($scope.baseUrl + "/download/" + user_data.jwttoken + "/" + sequenceId + "/" + sequenceId + "_all.zip", "_blank");
                    }
                }, 10);
            });
        }

        $scope.completedModules = function() {

            $scope.lpData = DataCache.returnData("summary");
            $scope.details = DataCache.returnData("details");
            $scope.completedModulesNum = 0;
            var fModules = [];
            var moduleSeqMap = [];
            for (var i = 0; i < $scope.lpData.modules.length; i++) {
                fModules.push($scope.lpData.modules[i]);
                if ($scope.lpData.modules[i].status == 'Completed') {
                    $scope.completedModulesNum++;
                }
                moduleSeqMap[$scope.lpData.modules[i].moduleId] = $scope.lpData.modules[i].sequenceId;
            }

            $scope.lpData.fModules = fModules;
            $scope.lpData.moduleSeqMap = moduleSeqMap;
            console.log($scope.lpData);

            if ($scope.lpData.currentModule !== "") {
                var selectedModuleSeqId = $scope.lpData.moduleSeqMap[$scope.lpData.currentModule];
                $scope.lpData.current_module = $scope.lpData.modules[selectedModuleSeqId - 1];
                if ($scope.lpData.current_module.currentResource !== "" && $scope.lpData.current_module.currentResource !== null) {
                    $scope.lpData.current_module.current_resource = $scope.details[$scope.lpData.currentModule][$scope.lpData.current_module.currentResource];
                } else {
                    $scope.lpData.current_module.current_resource = null;
                }

            }
            $scope.toComplete = $scope.lpData.modules.length - $scope.completedModulesNum + 1;
        };



        $rootScope.goToProfile = function(thisModule) {
            $rootScope.headerShow = true;
            $rootScope.scndHdr = false;
            $state.go('home.progressInfoPage');
        };

        $window.onclick = function(event) {
            $(".module-list-discription").addClass("display-none");
            $(".dash-menu-options.menu-arrow").addClass("display-none");
        }

        $scope.showDesc = function(openDesc, event) {
            $(event.target.nextElementSibling).removeClass("display-none");
            return true;
        }

        $scope.showMenu = function(openDesc, event) {
            $(event.target.nextElementSibling).removeClass("display-none");
            return true;
        }



        $scope.showPathWrp = function() {
            $scope.showDashboard = true;
            $scope.showClipboard = false;

        };
        $scope.showClipboardWrp = function() {
            $rootScope.headerShow = true;

            $state.go('home.clipboard');
            $scope.showDashboard = false;
            $scope.showClipboard = true;
        };

        $scope.goToSummary = function() {
            $state.go('home.modulesummary');
        };

        $scope.goToProfTest = function(thisModule) {
            DataCache.saveGlobalData('thisModuleData', thisModule);
            //$rootScope.headerShow = true;
            //$scope.lpData = DataCache.returnData("summary");
            if ($scope.isActiveLp()) {
            $scope.getDepMessage = function(moduleMap) {
                var depMessage = [];
                for (var e in moduleMap)
                    depMessage.push(moduleMap[e]);
                return depMessage.join(',');
            }

            if (thisModule.dependency) {
                $rootScope.dependencies = [];
                for (var dependency in thisModule.dependency) {
                    if (thisModule.dependency[dependency])
                        $rootScope.dependencies[dependency] = thisModule.dependency[dependency];
                }

                var moduleSeqMap = [];

                for (var i = 1; i < $scope.lpData.modules.length; i++) {
                    if ($scope.lpData.modules[i].status !== 'Completed' && $rootScope.dependencies[$scope.lpData.modules[i].moduleId]) {
                        $scope.completedModulesNum++;
                        moduleSeqMap[$scope.lpData.modules[i].moduleId] = $scope.lpData.modules[i].sequenceId;
                    }
                }

                var totalModuleSeqMap = [];
                for (var i = 1; i < $scope.lpData.modules.length; i++) {
                    totalModuleSeqMap[$scope.lpData.modules[i].moduleId] = $scope.lpData.modules[i].sequenceId;
                }
                var locked = false;

                $rootScope.message = " ";
                // for(var dependent in $rootScope.dependencies){
                // locked = true;
                for (var moduleMap in moduleSeqMap) {
                    // if (moduleMap === dependent){
                    locked = true;
                    $rootScope.message += "" + $scope.getDepMessage(moduleSeqMap) + " ";
                    break;
                    // }
                }
                // }
                if (locked === true) {
                    $rootScope.$broadcast('module-popout-initiated');
                    //alert('Module locked');
                    return;
                }
            }
            $rootScope.scndHdr = false;
            $state.go('home.profTest');
            } else {
                $scope.startVideo(thisModule);
            }
        };

        try{
            $scope.completedModules();
        } catch(e){
            console.error(e);
        }
        $scope.authData = DataCache.returnData('userData');
        $scope.summaryData = DataCache.returnData('summary');
        $scope.details = DataCache.returnData('details');


        $scope.addTopToBadge = function(index, status) {
            console.log(index);
            var ele = angular.element(".dash-modules-tile-wrp-cont");
            var completed = ele[index];
            if (!completed) {
                completed = ele[index - 1];
            }
            var eleA = $(completed).find(".video-progress-bar-wrp");
            var eleB = $(completed).find(".dash-modules-no-wrp");
            $timeout(function() {
                var topPos = eleA.position();
                eleB.css({
                    top: topPos.top - 15.1,
                    position: 'absolute'
                });
            }, 10);

        };

        $scope.closeTile = function() {
            $rootScope.$broadcast('closeTile');
        }
        

        $scope.isActiveLp = function () {
            var currentLp = DataCache.returnLpData('currentLp')
            return currentLp ? currentLp === 'active':true;
        }
        $scope.showCurrentLp = function () {
        var uid = DataCache.returnData('uid')
        $scope.lpId = DataCache.returnData('lpid');
		var ref = FirebaseService.ref
        .child('/lp')
        .child(uid)
        .child($scope.lpId);

			ref.once('value', function (dataSnapshot) {
				var mainObj = dataSnapshot.val();
				DataCache.saveLpDetails('currentLp', 'active')
				DataCache.saveGlobalData('details', mainObj.details);
				$window.setData(mainObj)
                $state.go('home.dashboard')
                $state.reload()
			})
		}
        // $scope.activeClass = $scope.isActiveLP();
        // changes for intro.js

        // $rootScope.activeController = "DashboardCtrl";
        // $rootScope.$broadcast('new-controller-loaded');



        // $scope.startIntro = DataCache.returnData("dashboardIntro");
        // if ($scope.startIntro === undefined || $scope.startIntro === null) {
        //     $scope.startIntro = true;
        // }

        // if (user_data.isVisited === "N" && $scope.startIntro) {
        //     $scope.ShouldAutoStart = true;
        //     $scope.startIntro = false;
        //     DataCache.saveGlobalData("dashboardIntro", $scope.startIntro);
        // }


        //  $scope.hintFirstTime = true;


        //  var showHelp = true;
        // var activeElem = document.activeElement;

        // if (activeElem && (activeElem.tagName.toLowerCase() == 'input' &&
        //         activeElem.type == 'text' ||
        //         activeElem.tagName.toLowerCase() == 'textarea')) showHelp = false;

        // $scope.IntroOptions = $rootScope.introData;

        // var codeset = { 72: false };
        // $window.onkeydown = function(e) {
        //     $scope.IntroOptions = $rootScope.introData;
        //     if (e.keyCode in codeset) {
        //         codeset[e.keyCode] = true;
        //         if (codeset[72] && showHelp) {

        //             if (!angular.element('.d-hints').hasOwnProperty('data-hint')) {
        //                 angular.element('#d-point').attr("data-hint", "Earn points while you learn! You’re already up by 20 points by simply setting up your profile.");
        //                 angular.element('#d-burger').attr("data-hint", "Want help? Want to report an issue? Or do you simply want to change your settings? Access your entire menu options here.");
        //                 angular.element('#d-status').attr("data-hint", "Track the overall status of your learning here. Click on your Avatar on the left for a closer look at your activity, progress and where you stand on the Leaderboard.");
        //             }
        //             if ($rootScope.activeController === "DashboardCtrl") {
        //                 if ($scope.hintFirstTime) {
        //                     introJs().setOptions($scope.IntroOptions);
        //                     introJs().addHints();
        //                     $scope.hintFirstTime = false;
        //                 } else {
        //                     introJs().showHints();
        //                 }
        //                 codeset[72] = false;
        //             }
        //         }
        //     }

        //     if (e.keyCode == 27) {
        //         //angular.element('.d-hints').css('display','none');

        //         introJs().hideHints();
        //     }

        // };

        // $window.onkeyup = function(e) {
        //     if (e.keyCode in codeset) {
        //         codeset[e.keyCode] = false;
        //     }
        // };

        // intro changes ends here
    });

'use strict';
( function() {
    angular
        .module( 'jigsawCorpLms' )
        .config( routerConfig );

    function routerConfig( $stateProvider ) {
        $stateProvider
            .state( 'home.clipboard', {
                url: '/clipboard',
                templateUrl: 'app/Features/clipboard/clipboard.html',
                controller: 'clipboardCtrl'
            } )
            .state( 'home.clipboard.module', {
                url: '/clipboard_module',
                templateUrl: 'app/Features/clipboard/templates/module-extended-mob.html'
            } )
            .state( 'home.clipboard.type', {
                url: '/clipboard_module_type',
                templateUrl: 'app/Features/clipboard/templates/selected-type-view.html'
            } )
            .state( 'home.clipboard.type_video', {
                url: '/clipboard_module_typevideo',
                templateUrl: 'app/Features/clipboard/templates/selected-type-video-view.html'
            } )
            .state( 'home.clipboard.overlay', {
                url: '/clipboard_module_overlay',
                templateUrl: 'app/Features/clipboard/templates/selected-type-overlay.html'
            } );

    }

} )();

'use strict';
angular
    .module( 'jigsawCorpLms' )
    .controller( 'clipboardCtrl', function( $scope, fetchData, DataCache, $state, $anchorScroll, $location, $rootScope,
        $sce, $filter, videoUtilities, $window, clipboardUtilities ) {
        $scope.currentModule = [];
        $scope.showOptions = false;
        $scope.initialLength = 3;
        $scope.showClipboard = true;
        $scope.editNotes = false;
        $scope.showMore = true;
        $scope.initialLimit = 4;
        $scope.parentObj = {};

        $rootScope.headerShow = true;
        $scope.showDashboard = false;
        $rootScope.scndHdr = true;

        fetchData.fetchClipboardPageData().then( function( response ) {
            $scope.clipboard = response.data;
            $scope.lastPlayedModule();
        } );

        $scope.highlightTextMarkup = function( markupData ) {
            return $sce.trustAsHtml( markupData );
        };
        $scope.lastPlayedModule = function() {
            for ( var i = 0; i < $scope.clipboard.clipboardData.length; i++ ) {
                if ( $scope.clipboard.clipboardData[ i ].lastPlayed == true ) {
                    $scope.currentModule = $scope.clipboard.clipboardData[ i ].clipboard;
                    $scope.selectedIndex = i;
                }
            }
            $scope.prioritySort();
            $scope.currentModule = clipboardUtilities.sortClipData( $scope.currentModule );
            $scope.parentObj.threshold = $scope.currentModule.length;

        };
        $scope.sortOnVideoTime = function() {
            var itrLength = $scope.clipboard.clipboardData.length;
            for ( var k = 0; k < itrLength; k++ ) {
                $scope.clipboard.clipboardData[ k ].clipboard.sort( function( a, b ) {
                    return a.clipdata.start_time - b.clipdata.start_time;
                } );
            }
        };
        $scope.currentModuleFunc = function( module, pos ) {
            $scope.selectedTitle = module.title;
            $scope.currentModule = module.clipboard;
            $scope.prioritySort();
            $scope.currentModule = clipboardUtilities.sortClipData( $scope.currentModule );
            $scope.selectedIndex = pos;
            if ( screen.width < 1025 ) {
                $state.go( 'home.clipboard.module' );
            }
        };
        $scope.goToClipboard = function() {
            $state.go( 'home.clipboard' );
        };
        $scope.showMoreTopics = function( module ) {
            $scope.showMore = !$scope.showMore;
            $scope.initialLength = module.length;
        };
        $scope.showLessTopics = function() {
            $scope.showMore = !$scope.showMore;
            $scope.initialLength = 3;
        };
        $scope.editTitleActive = function( pos ) {
            $scope.titleSelectedIndex = pos;
        };
        $scope.changeIndex = function() {
            $scope.titleSelectedIndex = -1;
        };

        $scope.prioritySort = function() {
            var itrLength = $scope.currentModule.length;
            for ( var i = 0; i < itrLength; i++ ) {
                if ( $scope.currentModule[ i ].type == 'trimmedvideo' ) {
                    $scope.currentModule[ i ][ "priority" ] = 1;
                } else if ( $scope.currentModule[ i ].type == 'notes' ) {
                    $scope.currentModule[ i ][ "priority" ] = 2;
                } else if ( $scope.currentModule[ i ].type == 'askanexpert' ) {
                    $scope.currentModule[ i ][ "priority" ] = 3;
                } else if ( $scope.currentModule[ i ].type == 'screenshot' ) {
                    $scope.currentModule[ i ][ "priority" ] = 4;
                } else if ( $scope.currentModule[ i ].type == 'highlightedTranscript' ) {
                    $scope.currentModule[ i ][ "priority" ] = 5;
                }
            }

        };

        $scope.testData = [];

        $scope.listData = function() {
            if ( $scope.initialLimit <= $scope.parentObj.threshold )
                $scope.initialLimit = $scope.initialLimit + 2;
        };


        $scope.startVideo = function() {
            $rootScope.dashArrow = false;
            if ( screen.width < 1025 ) {
                $rootScope.scndHdr = true;
                $state.go( 'home.playlist' );
            } else {
                $rootScope.scndHdr = false;
                $rootScope.modelParent.isFromLib = false;
                $state.go( 'home.learn.video' );
            }
        };

        $scope.sortBySelectedType = function( module ) {
            $scope.titleSelectedIndex = -1;
            if ( screen.width < 1025 ) {
                $rootScope.scndHdr = false;
                if ( module.type == 'trimmedvideo' ) {
                    $scope.selectedVideo = module.clipdata.video_url;
                    $state.go( 'home.clipboard.type_video' );
                } else {
                    $scope.focusedElementType = module.type;
                    $state.go( 'home.clipboard.type' );
                }
            } else {
                $scope.focusedElement = module;
                if ( module.type == 'trimmedvideo' ) {
                    return;
                }
                $rootScope.headerShow = false;
                $rootScope.scndHdr = false;
                $state.go( 'home.clipboard.overlay' );
            }
        };
        $scope.previousFocusedItemType = function() {
            $scope.sortedArray = clipboardUtilities.sortClipData( $scope.currentModule );
            var itrLength = $scope.sortedArray.length;
            for ( var i = itrLength - 1; i >= 0; i-- ) {
                if ( $scope.focusedElement == $scope.sortedArray[ i ] ) {
                    break;
                }
            }
            for ( var j = i - 1; j >= 0; j-- ) {
                if ( $scope.focusedElement.type == $scope.sortedArray[ j ].type ) {
                    $scope.focusedElement = $scope.sortedArray[ j ];
                    break;
                }
            }
            if ( $scope.focusedElement.type == 'trimmedvideo' ) {
                $scope.selectedVideo = $scope.focusedElement.clipdata.video_url;
            }
        };
        $scope.nextFocusedItemType = function() {
            $scope.sortedArray = clipboardUtilities.sortClipData( $scope.currentModule );
            var itrLength = $scope.sortedArray.length;
            for ( var i = 0; i < itrLength; i++ ) {
                if ( $scope.focusedElement == $scope.sortedArray[ i ] ) {
                    break;
                }
            }
            for ( var j = i + 1; j < itrLength; j++ ) {
                if ( $scope.focusedElement.type == $scope.sortedArray[ j ].type ) {
                    $scope.focusedElement = $scope.sortedArray[ j ];
                    break;
                }
            }
            if ( $scope.focusedElement.type == 'trimmedvideo' ) {
                $scope.selectedVideo = $scope.focusedElement.clipdata.video_url;
            }
        };
        $scope.onPlayerReady = function( API ) {
            $scope.API = API;
            $scope.Videoconfig = {
                sources: [ {
                    src: $sce.trustAsResourceUrl( $scope.selectedVideo ),
                    type: 'video/mp4'
                } ],
                plugins: {
                    poster: 'http://n1.sdlcdn.com/imgs/a/p/7/Become-A-Data-Scientist-Certified-SDL737299275-1-3b986.jpg'
                }
            };
        };
        $scope.closeSortBySelectedType = function() {
            if ( screen.width < 1025 ) {
                $rootScope.scndHdr = true;
                $state.go( 'home.clipboard.module' );
            } else {
                $rootScope.headerShow = true;
                $rootScope.scndHdr = true;
                $state.go( 'home.clipboard' );
            }
        };

        $scope.scrollToClicked = function( item ) {
            $location.hash( item );
            $anchorScroll();
        };
        $scope.goToDashboard = function() {
            $rootScope.dashArrow = true;
            $rootScope.moduleHeader = false;
            $rootScope.noscroll = false;
            $state.go( 'home.dashboard' );

        };
        $scope.showPathWrp = function() {
            $scope.showDashboard = true;
            $scope.showClipboard = false;
            $rootScope.dashArrow = true;
            $rootScope.moduleHeader = false;
            $rootScope.noscroll = false;
            $state.go( 'home.dashboard' );

        };
        $scope.editNotesFunc = function() {
            this.editNotes = !this.editNotes;
        };
        $scope.goToSummary = function() {
            $state.go( 'home.moduleEnd.modulesummary' );
        };
        $scope.goToProfTest = function( thisModule ) {
            DataCache.saveGlobalData( 'thisModuleData', thisModule );
            $rootScope.headerShow = true;
            $rootScope.scndHdr = false;
            $scope.goToSummary();
        };
    } );
angular.module( 'jigsawCorpLms' ).filter( 'unique', function() {

    return function( items, filterOn ) {

        if ( filterOn === false ) {
            return items;
        }

        if ( ( filterOn || angular.isUndefined( filterOn ) ) && angular.isArray( items ) ) {
            var newItems = [];

            var extractValueToCompare = function( item ) {
                if ( angular.isObject( item ) && angular.isString( filterOn ) ) {
                    return item[ filterOn ];
                } else {
                    return item;
                }
            };

            angular.forEach( items, function( item ) {
                var isDuplicate = false;
                // var valueToCheck

                for ( var i = 0; i < newItems.length; i++ ) {
                    if ( angular.equals( extractValueToCompare( newItems[ i ] ), extractValueToCompare( item ) ) ) {
                        isDuplicate = true;
                        break;
                    }
                }
                if ( !isDuplicate ) {
                    newItems.push( item );
                }

            } );
            items = newItems;
        }
        return items;
    };
} );
angular.module( 'jigsawCorpLms' ).directive( "scroll", function( $window ) {
    return {
        restrict: 'A',
        link: function( scope, element, attrs ) {
            var raw = element[ 0 ];

            element.bind( 'scroll', function() {
                if ( raw.scrollTop + raw.offsetHeight > raw.scrollHeight ) {
                    scope.$apply( attrs.scroll );
                }
            } );
        }
    };
} );

'use strict';
( function() {
    angular
        .module( 'jigsawCorpLms' )
        .config( routerConfig );

    /** @ngInject */
    function routerConfig( $stateProvider, $urlRouterProvider ) {
        $stateProvider
            .state( 'buyer', {
                url: '/buyer',
                templateUrl: 'app/Features/buyerJourney/buyerJourney.html',
                controller: 'buyerJourneyCtrl'
            } );
    }

} )();

'use strict';
angular
    .module('jigsawCorpLms')
    .controller('buyerJourneyCtrl', function($scope, $state, fetchData, DataCache, $http, $cookies, $controller, $rootScope, $timeout, $window, rubricGuide, FirebaseService, $firebaseObject) {

        $rootScope.bheaderShow = true;
        $rootScope.popoutShow = false;

        var user_data = DataCache.returnData('userData');
        if (user_data == undefined) {
            $state.go("login");
        } else {
            $http.defaults.headers.common['Authorization'] = "Bearer " + user_data.jwttoken;
            $http.defaults.headers.common['Content-Type'] = "application/x-www-form-urlencoded";
        }
        //DataCache.loadFromWebstorage();

        angular.extend(this, $controller('rubricGuideCtrl', {
            $scope: $scope
        }));

        //var uid=DataCache.returnData('user_data');
        //var gAuth = FirebaseService.ref.getAuth();
        //console.log(gAuth);
        var multiLoginref = FirebaseService.ref.child("login").child(user_data.uid);
        var obj1 = $firebaseObject(multiLoginref);

        var unwatch = obj1.$watch(function() {
            multiLoginref.on('child_changed', function(childSnapshot, prevChildKey) {
                var changedPost = childSnapshot.val();
                var prevKey = DataCache.returnData('loginId');
                if (DataCache.returnData('loginId') !== undefined) {
                    if (changedPost != prevKey) {
                        DataCache.clearAll();

                        $cookies.remove('userDetails');
                        $state.go('login');
                    }
                }

                //  $scope.setData(changedPost);
            });
        });




        var data;

        // $timeout(function(){
        //   console.log(angular.element(document.querySelector('.bnavigation-bar-wrp')).prop('offsetTop'));
        // },300);

        $scope.id;
        $scope.lpId;
        $scope.fbId = user_data.fbUsername;
        $scope.bJourneyObj = {};

        $scope.bJourneyObj.isHead = user_data.role === 'L&D Manager';
        $scope.bJourneyObj.isManager = user_data.role === 'Manager';
        $scope.bJourneyObj.navBarShow = false;
        $scope.bJourneyObj.activeTab = 'dashboard';

        $scope.role = user_data.role;
        var pwdUpdate = DataCache.returnRootData('pwdUpdate');
        if ((pwdUpdate === 'updated' || $rootScope.pwdUpdate === 'updated') && user_data.isVisited != 'Y') {
            $state.go('buyer.welcome');
        } else {
            if (user_data.isVisited == 'Y') {
                $rootScope.firstTimeLogin = false;
                $scope.bJourneyObj.navBarShow = true;
                $state.go('buyer.dashboard');
            } else {
                $rootScope.firstTimeLogin = true;
                $state.go('setup');
            }
        }


        // $scope.goToDashboard=function(){
        //     $state.go('buyer.dashboard.trackProgress');
        //     $scope.userProfile = false;
        //     $rootScope.userProfile= false;
        // }

        $scope.goToDashboard = function() {
            $rootScope.$broadcast("setting-to-dashboard");
        }

        $rootScope.$on('logout-initiated', function() {
            DataCache.clearAll();
            $cookies.remove('userDetails');
            FirebaseService.ref.unauth();
            $state.go('login');
        });


        $scope.approveLearner = function(learner, ptId) {
            $rootScope.popoutShow = true;
            $rootScope.modelParent.isPopOutViewActive = true;
            $rootScope.modelParent.bringInPopOut = true;
            //$rootScope.$broadcast('show-popout');
        }

        $scope.activeTabFunc = function(tab) {
            $scope.bJourneyObj.activeTab = tab;
        };
        // $scope.goToAllocation = function() {
        //     if ( !$scope.isMediumScrennDevice && !$scope.isMobilePhoneDevice ) {
        //
        //         $scope.bJourneyObj.navBarShow = true;
        //         $state.go( 'buyer.allocation' );
        //
        //     } else {
        //
        //         window.alert( 'This view is available in desktop only' );
        //
        //     }
        // };

        $scope.applySchema = function() {
            var maskew = new Maskew(document.getElementById("setupProfileImage"), 20);
        };


        fetchData.fetchProfileData({}).then(function(response) {
            $scope.bJourneyObj.user = response.data.profile;
        });


        if ($scope.bJourneyObj.isManager) {
            data = { "fbUsername": user_data.fbUsername };

            $scope.id = user_data.fbUsername;
            $scope.lpId = user_data.lpId;
        } else if ($scope.bJourneyObj.isHead) {
            data = { "clientId": user_data.clientId };
            $scope.id = user_data.clientId;
            $scope.lpId = user_data.lpId;
        }



        fetchData.fetchBuyerWelcomeScreenLicense(data, user_data.role).then(function(response) {
            $scope.bJourneyObj.WelcomeLicense = response.data;
        });


        fetchData.fetchBuyerWelcomeScreenLp(data, user_data.role).then(function(response) {
            $scope.bJourneyObj.WelcomeLp = response.data;
        });

        /*else if ($scope.bJourneyObj.isHead) {
          fetchData.fetchBuyerLearnerPathManager(data).then( function( response ) {
             $scope.bJourneyObj.managerlp = response.data.buyersLearningPath;
          } );
        }*/

        $scope.goToLearnerDash = function() {
            $state.go('home.dashboard');
        };

        $rootScope.$on('buyers-dashboard', function() {
            $state.go('buyer.dashboard');
        });


        // $rootScope.$on('logout-initiated', function()
        // {
        //   $rootScope.popoutShow=true;
        //   $rootScope.modelParent.isPopOutViewActive = true;
        //   $rootScope.modelParent.bringInPopOut = true;
        //   $rootScope.logoutPopOut = true;
        //
        //     // $cookies.remove("userDetails");
        //     // $state.go("login");
        // });


        $rootScope.$on("buyers-profile", function() {
            $scope.userProfile = true;
        });

        $rootScope.$on('buyer-help', function() {
            $state.go('home.help');
        });

        $rootScope.$on('help-close', function() {

            $state.go('buyer');
        });


        fetchData.fetchProfileData().then(function(response) {
            // update avatar level
            $scope.avatar = $rootScope.baseimageurl + '/avatars/1/' + response.data.profile.profilePhotoUrl;
            angular.element($(".setup-profile-image")).css("background", "rgba(0, 0, 0, 0) url('" + $scope.avatar + "') scroll 0px 0px / 100% 100% padding-box border-box");

        });


        //  $rootScope.$on("avatar_fetched",function(){
        //    $scope.avatarImage={
        //      background:'url($scope.avatar.profilePhotoUrl)',
        //      width:'200px',
        //      height:'170px',
        //      'background-size':'100% 100%',
        //      left:'-68px'
        //    };
        //  });


        // $rootScope.$on('feedback',function(){
        //   console.log("broadcast feedback");
        //   $rootScope.modelParent.isFeedbackViewActive=true;
        //   $rootScope.modelParent.bringInFeedback=true;
        // });
    });
'use strict';
angular.module('jigsawCorpLms')
    .controller('BookmarksCtrl', function($scope, fetchData, $rootScope, $timeout) {
        $scope.topNavPanel = [{
            'title': 'videos',
            'type': 'video',
            'iconClass': 'icon-video'
        }, {
            'title': 'practice',
            'type': 'practice',
            'iconClass': 'icon-casestudy'
        }];
        $scope.parentObject = {};
        $scope.parentObject.modelForAll = true;
        var allBookmarks;

        var formatEachDate = function(value) {
            value.filter(function(value) {
                value.date = new Date(moment(value.date));
            });
            return value;
        };

        fetchData.bookmarks().then(function(response) {
            allBookmarks = formatEachDate(response.bookmarks);
            $scope.filterItemType('video');
        });
        $scope.selectedTab = function(item, index) {
            $scope.thisIndex = index;
            $scope.selectedTabText = item.title;
            $scope.filterItemType(item.type);
        };
        $scope.filterItemType = function(item) {
            $scope.selectedBookmarkType = item;
            var filteredItems = allBookmarks.filter(function(value) {
                return value.type === item;
            });
            $scope.bookmarkedItems = filteredItems;
        };
        $scope.navigateToSelected = function() {
            $scope.closeBookmarksCard();
        };
        $scope.closeBookmarksCard = function() {
            $rootScope.modelParent.isBookmarksActive = false;
            $timeout(function() {
                $rootScope.modelParent.bringInBookmarks = false;
            }, 210);
        };
        $scope.removeThisBookmark = function(data) {
            var tempArray = [];
            allBookmarks.filter(function(value) {
                if (value !== data) {
                    tempArray.push(value);
                }
            });
            allBookmarks = tempArray;
            $scope.filterItemType($scope.selectedBookmarkType);
        };
    });
'use strict';
( function() {
    angular
        .module( 'jigsawCorpLms' )
        .config( routerConfig );

    /** @ngInject */
    function routerConfig( $stateProvider ) {
        $stateProvider
            .state( 'authess', {
                url: '/authess',
                templateUrl: 'app/Features/authess/authess.html',
                controller: 'authessCtrl'
            } );
    }

} )();

'use strict';
angular
  .module('jigsawCorpLms')
  .controller('authessCtrl', function($scope, fetchData, $rootScope, $timeout, $window, $controller, $sce, $http, $httpParamSerializerJQLike) {
    $http.defaults.headers.common['Content-Type'] = "application/x-www-form-urlencoded";
    $scope.authorized = false;
    $scope.payload2 = {};
    $scope.resources = {
      'option1': '/',
      'option2': '/t/S2',
      'option3': '/t/S1',
      'option4': '/t/S3',
      'option5': '/t/S4',
      'option6': '/t/report'
    }
    $scope.getAuthParams = function() {
      var payload = {
        'UID': $scope.parentObj.theUID,
        'Name': $scope.parentObj.theName,
        'Resource': '/'
      };
      fetchData.authessTest(payload).then(function(response) {
        response.data.roles = "Instructor";
        $scope.payload2 = {
          'lis_person_name_full': response.data.lis_person_name_full,
	'lti_version': response.data.lti_version,
          'lti_message_type': response.data.lti_message_type,
          'oauth_consumer_key': response.data.oauth_consumer_key,
          'oauth_nonce': response.data.oauth_nonce,
          'oauth_signature': response.data.oauth_signature,
          'oauth_signature_method': response.data.oauth_signature_method,
          'oauth_timestamp': response.data.oauth_timestamp,
          'oauth_version': response.data.oauth_version,
          'resource_link_id': response.data.resource_link_id,
          'lis_outcome_service_url': response.data.lis_outcome_service_url,
          'lis_result_sourcedid': response.data.lis_result_sourcedid,
          'roles': response.data.roles,
          'user_id': response.data.user_id
        }
        $scope.authorized = true;
        $timeout(function() {
          document.getElementById("ltiform").submit();
        }, 100);
      });
    }
  });


'use strict';
( function() {
    angular
        .module( 'jigsawCorpLms' )
        .config( routerConfig );

    function routerConfig( $stateProvider ) {
        $stateProvider
            .state( 'home.audio', {
                url: '/audio',
                templateUrl: 'app/Features/audioPlayer/audioPlayer.html',
                controller: 'audioPlayerCntrl'
            } );
    }

} )();

'use strict';
angular
    .module( 'jigsawCorpLms' )
    .controller( 'audioPlayerCntrl', function ( $scope, fetchData, $rootScope, $state, DataCache, $sce ) {
        $scope.activeModule = DataCache.returnData( 'thisModuleData' );
        $scope.audioConfig = {};
        $scope.playPauseIcon = "icon-play3";

        $scope.bookmarked = false;
        $scope.activeItem = DataCache.returnData( 'currentItem' );
        $scope.modulePlaylistItems = DataCache.returnData( 'thisModuleDetails' );

        $scope.onPlayerReady = function ( API ) {
            $scope.API = API;
            $scope.audioConfig.sources = [ {
                src: $sce.trustAsResourceUrl( "assets/IntroSASvideo1.mp4" ),
                type: 'video/mp4'
                    } ];
        };

        $scope.bookmarkAudio = function ( ) {
            $scope.bookmarked = !$scope.bookmarked;
        };

        $scope.goToVideoPlayer = function ( ) {
            $rootScope.modelParent.isFromLib = false;
            $state.go( 'home.learn.video' );
        };

        $scope.onUpdateState = function ( state ) {

            switch ( state ) {
            case "play":
                $scope.playPauseIcon = "icon-play3";
                break;

            case "pause":
                $scope.playPauseIcon = "icon-play3";
                break;

            case "stop":
                $scope.playPauseIcon = "icon-play3";
                break;
            }
        };

        $scope.playPrevItem = function ( ) {
            if ( $rootScope.currentSequenceId - 1 > 0 ) {
                $rootScope.currentSequenceId = $rootScope.currentSequenceId - 1;
                $scope.changeStatePlaylist( );
            }
        };

        $scope.playNextItem = function ( ) {
            var length = $scope.modulePlaylistItems.length;
            if ( $rootScope.currentSequenceId + 1 <= length ) {
                $rootScope.currentSequenceId = $rootScope.currentSequenceId + 1;
                $scope.changeStatePlaylist( );
            }
        };

        $scope.changeStatePlaylist = function ( ) {
            var length, i = 0;
            length = $scope.modulePlaylistItems.length;
            while ( i < length ) {
                if ( $scope.modulePlaylistItems[ i ].sequence_id == $rootScope.currentSequenceId ) {
                    switch ( $scope.modulePlaylistItems[ i ].type ) {

                    case 'quiz':
                        $rootScope.headerShow = true;
                        $rootScope.scndHdr = false;
                        $state.go( 'home.learn.quiz' );
                        break;

                    case 'video':
                        $rootScope.headerShow = true;
                        $rootScope.scndHdr = false;
                        $state.go( 'home.learn.video' );
                        break;
                    case 'caseStudy':
                        $rootScope.headerShow = true;
                        $rootScope.scndHdr = false;
                        $state.go( 'home.learn.assessment' );
                        break;
                    case 'resources':
                        $state.go( 'home.learn.resources' );
                        break;
                    case 'ytc':
                        $state.go( 'home.learn.ytc' );
                        break;
                    default:
                        $rootScope.headerShow = true;
                        $rootScope.scndHdr = false;
                        $state.go( 'home.learn.video' );
                        break;
                    }
                    break;
                } else {
                    i++;
                }
            }
            $scope.$emit( 'playListUpdate', $scope.modulePlaylistItems[ $rootScope.currentSequenceId - 1 ] );
        };

        $scope.goToPlaylist = function ( ) {

            $rootScope.scndHdr = true;
            $state.go( 'home.playlist' );
        }

    } );

'use strict';
angular
	.module('jigsawCorpLms')
	.controller('allLpsPlayerCntrl', function ($scope, fetchData, $rootScope, $state, DataCache, $sce, FirebaseService,$window) {
		$rootScope.scndHdr = false;
		$rootScope.$on('allLp', function () {
			$scope.tabStateDesktop = 'allLpsScreen';
		})
		var uid = DataCache.returnData('uid')
		// var activeLpId = activeL.lpId;
		// activeLpId = activeLpId.
		$scope.lpId = DataCache.returnData('lpid');
		$scope.showCurrentLp = function () {
			// var activeL =
			var ref = FirebaseService.ref
        .child('/lp')
        .child(uid)
        .child($scope.lpId);

			ref.once('value', function (dataSnapshot) {
				var mainObj = dataSnapshot.val();
				DataCache.saveLpDetails('currentLp', 'active')
				DataCache.saveGlobalData('details', mainObj.details);
				DataCache.saveGlobalData('summary', mainObj.summary);
				$window.setData(mainObj)
				$state.go('home.dashboard')
			})
		}
		$scope.isDataFetched = false;
		$scope.prevLps = []
		fetchData
		.fetchAllLps()
		.then(function (response) {
			var data = response.data
			$scope.isDataFetched = true
			if (data.status === 'success') {
				$scope.prevLps = JSON.parse(data.message)
				console.log($scope.prevLps)
				console.log($scope.prevLps)
				$scope.prevLps = $scope.prevLps.values
			}
		})
		.catch(function(e) {
			console.log("Yo dawgs, you've got an error",e)
		})
		$scope.changeLp = function (lpid) {
			var lpDetails = DataCache.returnLpData(lpid);
			function switchLp() {
				DataCache.saveLpDetails('currentLp', lpid)
				DataCache.saveLpDetails(lpid + 'bkp', lpDetails)
				var newLp = Object.assign(lpDetails)
				console.log("newLP", newLp,'summary', DataCache.returnData('summary'),'details',DataCache.returnData('details'))
				DataCache.saveGlobalData('details', newLp.details);
				DataCache.saveGlobalData('summary', newLp.summary);
				$window.setData(lpDetails)
				$state.go('home.dashboard')
			}
			// if (lpDetails) {
			// 	switchLp();
			// } else {
				var ref = FirebaseService.ref.child('/lp').child(uid).child(lpid)
				ref.once('value',
					function (dataSnapshot) {
						lpDetails = dataSnapshot.val();
						DataCache.saveGlobalData('details',lpDetails.details)
						switchLp()
						DataCache.saveLpDetails(lpid, lpDetails)
					},
					function (lpFetchError) {
						console.error('Error in fetching lp data for user',lpFetchError);
					}
				);
			// }
		}
		$scope.DoesLpsExist = function() {
			return $scope.prevLps.length > 0;
			// return false
		}
		$scope.FormatDate = function (date) {
			return moment(date).format('LL')
		}
	})
'use strict';
(function () {
	angular
		.module('jigsawCorpLms')
		.config(routerConfig);

	function routerConfig($stateProvider) {
		$stateProvider
			.state('home.allLps', {
				url: '/old-lps',
				templateUrl: 'app/Features/allLps/allLps.html',
				controller: 'allLpsPlayerCntrl'
			});
	}

})();
'use strict';
( function() {
    angular
        .module( 'jigsawCorpLms' )
        .config( routerConfig );

    /** @ngInject */
    function routerConfig( $stateProvider ) {
        $stateProvider
            .state( 'home.jigsawlab', {
                url: '/jigsawLab',
                templateUrl: 'app/Features/jigsawLab/jigsawLab.html',
                controller: 'jigsawLabCtrl'
            } );
    }

} )();

'use strict';
angular
    .module('jigsawCorpLms')
    .controller('jigsawLabCtrl', function($http, $stateParams, $scope, $state, fetchData, $rootScope, DataCache, $timeout, FirebaseService, $controller, $firebaseObject, $sce, $cookies) {

        console.log("inside jigsaw lab controller");
        $scope.userData = DataCache.returnData("userData");
        $http.defaults.headers.common['Authorization'] = "Bearer "+$scope.userData.jwttoken;
        $http.defaults.headers.common['Content-Type'] = "application/x-www-form-urlencoded";

        $rootScope.bheaderShow = false;
        $rootScope.headerShow = true;
        $rootScope.scndHdr = false;
        $rootScope.libraryState = false;

        angular.element('#p-hints').removeAttr("data-hint");
        $scope.showLabInfoPage = true;
        $scope.launchLab = false;
        console.log("inside jigsaw lab controller");
         fetchData.getLabPassword().then(function(response) {
                console.log(response);
                $scope.labData = response.data;
                $scope.labPassword = response.data.password;

        });


         $scope.loadLab = function(){
            console.log("inside loadLab");
             fetchData.getLabAccess($scope.labData).then(function(response) {
                console.log(response);
               $scope.labUrl = response.data.lab_url;
               console.log($scope.labUrl);
               //angular.element(".lab-iframe");
               console.log(angular.element(".lab-iframe").attr("src",$scope.labUrl));
               $timeout(function(){
                    $scope.launchLab = true;
                    $scope.showLabInfoPage = false;
               },100);
               
               // window.open($scope.labUrl, '_blank');
            });
           
         }

        // $rootScope.activeController = "jigsawLabCtrl";
        // $rootScope.$broadcast('new-controller-loaded');



        // $scope.startIntro = DataCache.returnData("jigsawLabIntro");
        // if ($scope.startIntro === undefined || $scope.startIntro === null) {
        //     $scope.startIntro = true;
        // }

        // console.log
        // if (userData.isVisited === "N" && $scope.startIntro) {
        //     $scope.ShouldAutoStart = true;
        //     $scope.startIntro = false;
        //     DataCache.saveGlobalData("jigsawLabIntro", $scope.startIntro);
        // }


        //  $scope.hintFirstTime = true;


        //  var showHelp = true;
        // var activeElem = document.activeElement;

        // if (activeElem && (activeElem.tagName.toLowerCase() == 'input' &&
        //         activeElem.type == 'text' ||
        //         activeElem.tagName.toLowerCase() == 'textarea')) showHelp = false;

        // $scope.IntroOptions = $rootScope.introData;

        // var codeset = { 72: false };
        // $window.onkeydown = function(e) {
        //     $scope.IntroOptions = $rootScope.introData;
        //     if (e.keyCode in codeset) {
        //         codeset[e.keyCode] = true;
        //         if (codeset[72] && showHelp) {

        //             if (!angular.element('.d-hints').hasOwnProperty('data-hint')) {
        //                 angular.element('#d-point').attr("data-hint", "Earn points while you learn! You’re already up by 20 points by simply setting up your profile.");
        //                 angular.element('#d-burger').attr("data-hint", "Want help? Want to report an issue? Or do you simply want to change your settings? Access your entire menu options here.");
        //                 angular.element('#d-status').attr("data-hint", "Track the overall status of your learning here. Click on your Avatar on the left for a closer look at your activity, progress and where you stand on the Leaderboard.");
        //             }
        //             if ($rootScope.activeController === "DashboardCtrl") {
        //                 if ($scope.hintFirstTime) {
        //                     introJs().setOptions($scope.IntroOptions);
        //                     introJs().addHints();
        //                     $scope.hintFirstTime = false;
        //                 } else {
        //                     introJs().showHints();
        //                 }
        //                 codeset[72] = false;
        //             }
        //         }
        //     }

            // if (e.keyCode == 27) {
            //     //angular.element('.d-hints').css('display','none');

            //     introJs().hideHints();
            // }

        //};

        // $window.onkeyup = function(e) {
        //     if (e.keyCode in codeset) {
        //         codeset[e.keyCode] = false;
        //     }
        // };

    });
'use strict';
angular.module('jigsawCorpLms')
  .controller('videoCommonCntrl', function($scope, $rootScope, DeviceDetector, fetchData, $location, $state, $sce, $http, $filter,
    $timeout, videoUtilities, DataCache, $interval, FirebaseService, $compile, $window, $document, RestEndpoints) {

    //DataCache.loadFromWebstorage();

    // try {} catch (e) {}

        var user_data = DataCache.returnData('userData');
        //changes made for new SDK
        $scope.idToken = DataCache.returnData("idToken");
        //$http.defaults.headers.common['Authorization'] = "Bearer " + $scope.idToken;
        $http.defaults.headers.common['Authorization'] = "Bearer " + user_data.jwttoken;
        $http.defaults.headers.common['Content-Type'] = "application/x-www-form-urlencoded";

        if ($rootScope.events === undefined) {
          $rootScope.events = DataCache.returnData("event");
        }

        var ref = FirebaseService.ref.child($rootScope.events);
        var vdoplayer;

        if ($location.path() === '//video') {
          $rootScope.moduleHeader = true;
        }

        $scope.noTranscript = false;

        $rootScope.libraryState = false;
        $rootScope.headerShow = true;
        $rootScope.scndHdr = false;

        $scope.API = null;
        $scope.settingsOpt = false;
        $scope.qualityOpt = false;
        $scope.speedOpt = false;
        $scope.subtitlesOpt = false;
        $scope.speedVal = '1x';
        $scope.subtitlesVal = 'On';
        $scope.qualityVal = 240;
        $scope.subtitles = ['on', 'off'];
        $scope.quality = ['1080', '480', '240'];
        $scope.speed = ['1.5x', '1x', '0.5x'];
        $scope.videos = {};
        $scope.videosData = {};
        // Dummy Data Variable
        $scope.videosDummy = {};


        $scope.takeNotesToggle = false;
        $scope.overlayPlayIcon = {
          show: true
        };
        $scope.isSeeking = false;
        $scope.parentObj = {};
        $scope.parentObj.isVideoDragging = false;
        $scope.togglePlaylistFilter = false;
        $scope.shwMobOptions = false;
        $scope.showTrimScreen = false;
        var isMuted = false;
        $scope.dataFetched = false;
        $scope.leftPos = 0;
        $scope.currentVolume = 100;
        $scope.toggleVolume = false;
        $scope.bookmarked = false;
        var highlightDataset = {
          'selectionArray': [],
          'selectionNode': [],
          'activeNodes': [],
          'focusNodes': [],
          'rangeCounts': []
        };
        var selectionEndTimeout = null;
        $scope.trimBegin = 0;
        $scope.trimEnd = 0;
        var count = 0;
        var counter = 0;
        var counterTranscript = 0;
        var countTranscript = 0;

        var lastTimeStamp = 0;

        $scope.askExpertOpt = false;
        $scope.notesOpt = false;
        $scope.trimOpt = true;
        $scope.modelData = {
          'askedQuestion': ''
        };
        $scope.askingQuestion = false;
        $scope.editTitle = false;
        $scope.showSelectedFAQ = false;
        $scope.editTitleTakeNotesToggle = false;
        $scope.askExpertMobSearch = true;

        // trim
        $scope.sliderMin = 0;
        $scope.sliderMax = 100;

        $scope.sliderModelMin = 0;
        $scope.sliderModelMax = 100;
        $scope.sliderModelMaxMob = 0;
        $scope.sliderModelMinMob = 0;
        $scope.vidTrimSaveMob = false;

        $scope.slidierTimeRatio;


        var viewportTrim;
        var carouselLimit;
        var leftBlurEle;
        var rightOverlayEle;
        var viewportTrimMob;
        var carouselLimitMob;
        var SecondsperPxMob = 141 / 20;
        var SecondsperPx = 0;

        var video;

        // variable for Ask an Expert in Mobile
        $scope.askExpertMob = false;

        // Take Notes Model
        $scope.takeNoteModel;
        $scope.takeNoteTitle = 'Take Note Title';
        $scope.titleAskAnExpert = $scope.takeNoteTitle;
        $scope.ShwEditAskexprtTitle = false;
        $scope.ShwEditTakeNotesTitle = false;
        $scope.inclTrscptTakeNotes = true;
        $scope.inclTrscptTakeNotesMob = true;
        // to be deleted

        // clipboard Data
        $scope.clipboardArray = {};

        $scope.currentIndex = 0;

        $scope.videoTitle = 'Introduction';
        if ($rootScope.currentSequenceId === undefined) {
          $rootScope.currentSequenceId = DataCache.returnData('currentSequenceId');
        }
        if ($rootScope.currentResourceId === undefined) {
          $rootScope.currentResourceId = DataCache.returnData('currentResourceId');
        }

        $scope.activeModule = DataCache.returnData('thisModuleData');
        if (DataCache.returnLpData('currentLp') === 'active'){
          $scope.details = DataCache.returnData('details');
        } else {
          $scope.details = DataCache.returnLpData(DataCache.returnLpData('currentLp')).details
        }

        $scope.activeModuleData = $scope.details[$scope.activeModule.moduleId][$rootScope.currentSequenceId];


        if ($scope.activeModuleData.type === 'ytc') {
          $scope.yturl = $sce.trustAsResourceUrl($scope.activeModuleData.metaData.videoUrl);
        }



        fetchData.fetchAskExpert().then(function(response) {
          $scope.askExpertData = response.data;
        });



        var videoId = {
          videoId: $scope.details[$scope.activeModule.moduleId][$rootScope.currentSequenceId].id
          // videoId : "7236576"
        };


        fetchData.fetchTranscript(videoId).then(function(response) {
          if (response.data["error"]) {
            $scope.noTranscript = true;
          } else {
            var transcriptDataCopy = {};
            $scope.actualTranscriptData = response;
            angular.copy(response, transcriptDataCopy);
            var highlightMappedTranscript = videoUtilities.mapHighlightData(transcriptDataCopy, response);
            $scope.thumbnailsImages = transcriptDataCopy.data.thumbnails;
            $scope.videoItemData = transcriptDataCopy.data;
            $scope.rearrangeData(transcriptDataCopy);
            $scope.dataFetched = true;
            $scope.rearrangeDataTranscript(response.data.video_transcript);
          }
        });



        $scope.summaryData = DataCache.returnData("summary");

        var userData = DataCache.returnData("userData");

        $scope.eventObject = {
          "group": "lprogress",
          "type": "lvideo",
          "data": {
            "action": "",
            "teamId": userData.teamId,
            "clientId": userData.clientId,
            "lpId": userData.lpId,
            "lpTitle": userData.lpTitle,
            "token": userData.token,
            "currentVideoTime": "",
            "timeSpent": 0,
            "moduleId": $scope.activeModule.moduleId.toString(),
            "resourceId": angular.copy($rootScope.currentResourceId).toString(),
            "moduleSeqId": $scope.activeModule.sequenceId.toString(),
            "resourceSeqId": $rootScope.currentSequenceId + '',
            "timestamp": ""
          }
        };

        $scope.videoId = "";

        $scope.playerState = "FirstPlay";
        var videoId = $scope.activeModuleData.metaData.idForVideo; //$rootScope.currentBcId;//'5006870718001';
        $scope.videoId = videoId;

        /*
        var videoHTML = '<video id="video" data-account="4893168693001" data-player="HyZQO1KDf" data-embed="default" data-video-id="'+videoId +'" height="100%" width="100%" style="position:relative;z-index:0;opacity:1;" autoplay=true class="video-js" data-setup='+JSON.stringify({ playbackRates: [0.5, 1, 1.5, 2] })+' preload="auto" controls></video>'
        + '<div id="overlay" class="vid-player-section row" style="z-index:-1;opacity:0;">test</div>';
        document.getElementById("video-container").innerHTML = videoHTML;
        */

        // document.getElementById("overlay").innerHTML=document.getElementById("overlay").innerHTML +'<overlay></overlay>';//+ $("#overlay").load('app/Common/Directives/playlist_directive/playlist.html' );
        // $compile( document.getElementById('overlay') )($scope);
        videoId = videoId.replace(/\s+/g, '');
        var otpPayoad = {
          // "videoId":"71ccdea24f70c3fed2cf0e88f5e7f7f8"
          "videoId": videoId

        };

        fetchData.fetchOtp(otpPayoad).then(function(response) {

          $scope.title = response.data.title;
          $scope.otp = response.data.otp;

          // (function(v,i,d,e,o){v[o]=v[o]||{}; v[o].add = v[o].add || function V(a){ (v[o].d=v[o].d||[]).push(a);};
          //  if(!v[o].l) { v[o].l=1*new Date(); a=i.createElement(d), m=i.getElementsByTagName(d)[0];
          //  a.async=1; a.src=e; m.parentNode.insertBefore(a,m);}
          // })(window,document,"script","//de122v0opjemw.cloudfront.net/vdo.js","vdo");
          // vdo.add({o: otp,
          //   container: document.getElementById("video-container"),
          //  autoplay: false});

          // $timeout(
          // function() {

          try {
            var video = new VdoPlayer({
              otp: $scope.otp,
              playbackInfo: btoa(JSON.stringify({
                videoId: $scope.videoId
              })),
              theme: "9ae8bbe8dd964ddc9bdb932cca1cb59a",
              // the container can be any DOM element on website
              container: document.querySelector("#video-container"),
            });
            var endFlag = false;
          } catch (e) {
            console.error(e);
          }

          // vdo.initPlayer(window);
          // });

          // var isFirstTime = false;
          // window.onVdoCipherAPIReady = function() {
          //     var videos = $window.vdo.getObjects();
          //     video = videos[0];
          //     vdoplayer = video;
          //     isFirstTime = true;
          // };


          $timeout(function() {
            // if (!isFirstTime) {
            // var allVideos = $window.vdo.getObjects();
            // video = allVideos[allVideos.length - 1];
            vdoplayer = video;
            // }

            // video.start();

            $rootScope.pauseVideo = function() {
              try {
                video.pause();
              } catch (e) {
                console.error(e);
              }
            }

            // $rootScope.$on('overlayClosed', function(){
            //   video.resume();
            // });

            // video.setCustomEvents(["toggleVidNext", "toggleVidPrev"]);
            // video.addEventListener('toggleVidNext', function() {
            //     $scope.playNextItem();
            // });

            // video.addEventListener('toggleVidPrev', function() {
            //     $scope.playPrevItem();
            // });

            // var timeupdate = $scope.activeModuleData.durationCompleted * 60;

            // if (timeupdate > 0) {
            //     video.start();
            // };
            // video.addEventListener('load', function() {
            //     $window.ga('send', {
            //         hitType: 'event',
            //         eventCategory: 'Videos',
            //         eventAction: 'viewed',
            //         eventLabel: $scope.activeModuleData.metaData.title,
            //         hitCallback: function() {
            //             $window.ga('send', 'pageview', { page: $location.url() });
            //         }
            //     });
            // });

            // video.addEventListener('mpmlLoad', function(){
            //     $timeout(function() {
            //         video.injectThemeHtml('<button mpml-show=\"currentTime | inrange \'10-50,130-135\'\" mpml-on-click=\"myCustomEvent\">Buy now</button>');
            //     }, 1000);
            // });

            try {
              video.addEventListener('pause', function() {
                $scope.playerState = 'pause';
                $scope.eventObject.data.action = "pause";
                $scope.eventObject.data.timeSpent = 0.00;
                $scope.eventObject.data.currentVideoTime = (video.currentTime / 60);
                $scope.eventObject.data.resourceId = $rootScope.currentResourceId.toString();
                $scope.eventObject.data.resourceSeqId = $rootScope.currentSequenceId.toString();
                $scope.eventObject.data.timestamp = $filter('date')(new Date(), 'yyyy-MM-dd HH:mm:ss');
                if (DataCache.returnLpData('currentLp') === 'active') {
                  ref.push().child($scope.authData.uid).set($scope.eventObject);
                }
                // $window.ga('send', {
                //     hitType: 'event',
                //     eventCategory: 'Videos',
                //     eventAction: 'pause',
                //     eventLabel: $scope.activeModuleData.metaData.title,
                //     hitCallback: function() {
                //         $window.ga('send', 'pageview', { page: $location.url() });
                //     }
                // });
              });
            } catch (e) {
              console.error(e);
            }

            try {
              video.addEventListener('play', function() {
                if ((video.duration - video.totalCovered) < 10) {
                  $scope.eventObject.data.action = "complete";
                  $scope.eventObject.data.timeSpent = 0.00;
                } else {
                  $scope.playerState = 'play';
                  $scope.eventObject.data.action = "play";
                  $scope.eventObject.data.timeSpent = 10 / 60;
                }
                $scope.eventObject.data.currentVideoTime = (video.currentTime / 60);
                $scope.eventObject.data.resourceId = $rootScope.currentResourceId.toString();
                $scope.eventObject.data.resourceSeqId = $rootScope.currentSequenceId.toString();
                $scope.eventObject.data.timestamp = $filter('date')(new Date(), 'yyyy-MM-dd HH:mm:ss');
                if (DataCache.returnLpData('currentLp') === 'active') {
                  ref.push().child($scope.authData.uid).set($scope.eventObject);
                }
                $window.ga('send', {
                  hitType: 'event',
                  eventCategory: 'Videos',
                  eventAction: 'play',
                  eventLabel: $scope.activeModuleData.metaData.title,
                  hitCallback: function() {
                    $window.ga('send', 'pageview', { page: $location.url() });
                  }
                });
              });
            } catch (e) {
              console.error(e);
            }

            try {
              video.addEventListener('seeking', function() {
                $scope.playerState = 'seeked';
                $scope.eventObject.data.action = "forward";
                $scope.eventObject.data.timeSpent = 0.00;
                $scope.eventObject.data.currentVideoTime = (video.currentTime / 60);
                $scope.eventObject.data.resourceId = $rootScope.currentResourceId.toString();
                $scope.eventObject.data.resourceSeqId = $rootScope.currentSequenceId.toString();
                $scope.eventObject.data.timestamp = $filter('date')(new Date(), 'yyyy-MM-dd HH:mm:ss');
                if (DataCache.returnLpData('currentLp') === 'active') {
                  ref.push().child($scope.authData.uid).set($scope.eventObject);
                }
                // $window.ga('send', {
                //     hitType: 'event',
                //     eventCategory: 'Videos',
                //     eventAction: 'seeked',
                //     eventLabel: $scope.activeModuleData.metaData.title,
                //     hitCallback: function() {
                //         $window.ga('send', 'pageview', { page: $location.url() });
                //     }
                // });
              });
            } catch (e) {
              console.error(e);
            }

            // video.addEventListener('ended', function() {
            //     $scope.playerState = 'complete';
            //     $scope.eventObject.data.action = "complete";
            //     $scope.eventObject.data.timeSpent = 0.00;
            //     $scope.eventObject.data.currentVideoTime = (video.currentTime / 60);
            //     $scope.eventObject.data.resourceId = $rootScope.currentResourceId.toString();
            //     $scope.eventObject.data.resourceSeqId = $rootScope.currentSequenceId.toString();
            //     $scope.eventObject.data.timestamp = $filter('date')(new Date(), 'yyyy-MM-dd HH:mm:ss');
            //     ref.push().child($scope.authData.uid).set($scope.eventObject);
            //     $window.ga('send', {
            //         hitType: 'event',
            //         eventCategory: 'Videos',
            //         eventAction: 'completed',
            //         eventLabel: $scope.activeModuleData.metaData.title,
            //         hitCallback: function() {
            //             $window.ga('send', 'pageview', { page: $location.url() });
            //         }
            //     });
            //     // $scope.playNextItem();
            // });

            try {
              video.addEventListener('progress', function() {
                var currentTime = video.currentTime;
                lastTimeStamp = currentTime;
                if (video.duration - video.currentTime < 30 && !endFlag) {
                  endFlag = true;
                  console.log('Video ended');
                  $scope.playerState = 'complete';
                  $scope.eventObject.data.action = "complete";
                  $scope.eventObject.data.timeSpent = 0.00;
                  $scope.eventObject.data.currentVideoTime = (video.currentTime / 60);
                  $scope.eventObject.data.resourceId = $rootScope.currentResourceId.toString();
                  $scope.eventObject.data.resourceSeqId = $rootScope.currentSequenceId.toString();
                  $scope.eventObject.data.timestamp = $filter('date')(new Date(), 'yyyy-MM-dd HH:mm:ss');
                  if (DataCache.returnLpData('currentLp') === 'active') {
                    ref.push().child($scope.authData.uid).set($scope.eventObject);
                  }

                  $window.ga('send', {
                    hitType: 'event',
                    eventCategory: 'Videos',
                    eventAction: 'completed',
                    eventLabel: $scope.activeModuleData.metaData.title,
                    hitCallback: function() {
                      $window.ga('send', 'pageview', { page: $location.url() });
                    }
                  });
                };
                var currentTime = video.currentTime;
                lastTimeStamp = currentTime;
                // console.log(video.duration);
                // console.log(video.currentTime);
                $timeout($scope.updateTime(currentTime), 100);
              });
            } catch (e) {
              console.error(e);
            }



          }, 10);

        }); // fetchotp call



        $scope.$on('$stateChangeStart', function(evt) {
          $scope.isStateChange = true;
        });

        // $scope.stateChange = function() {
        //     document.getElementById("overlay").style.zIndex = -1;
        //     document.getElementById("vdo").style.zIndex = 0;

        //     document.getElementById("overlay").style.opacity = 0;
        //     document.getElementById("vdo").style.opacity = 1;
        // };


        // var readHighlighted = function() {
        //     if (window.getSelection) {
        //         highlightDataset.selObj = window.getSelection();
        //     } else {
        //         highlightDataset.selObj = document.getSelection();
        //     }
        //     highlightDataset.selRange = highlightDataset.selObj.getRangeAt(0);
        // };

        // var getHighlightedData = function() {
        //     var transcriptDataCopy = {};
        //     angular.copy($scope.actualTranscriptData, transcriptDataCopy);
        //     try {

        //         readHighlighted();

        //         var activeRange = highlightDataset.selObj.getRangeAt(0);
        //         var organisedData =
        //             videoUtilities.createHighlightData(transcriptDataCopy, activeRange, $scope.actualTranscriptData);
        //         $scope.rearrangeData(organisedData);
        //     } catch (e) {

        //     }
        // }

        // function userSelectionChanged() {
        //     if (selectionEndTimeout) {
        //         $timeout.cancel(selectionEndTimeout);
        //     }
        //     selectionEndTimeout = $timeout($scope.selectionEnded, 1500);
        // }

        // document.onselectionchange = userSelectionChanged;

        // $scope.selectionEnded = function(index, parentIndex, lastSelected) {
        //     selectionEndTimeout = null;
        //     readHighlighted();
        //     if ($scope.highlightActive && highlightDataset.selRange.toString().length >= 1 && highlightDataset.selRange.toString() !== ' ') {

        //         getHighlightedData();
        //     }
        // };

        // $scope.flipHighlight = function() {
        //     $scope.highlightActive = !$scope.highlightActive;
        // }


        // fetchData.fetchClipboardData().then(function(response) {
        //     $scope.clipboardData = response.data.clipboardata;
        //     $scope.rearrangeDataClipboard($scope.clipboardData);
        // });

        // $scope.rearrangeDataClipboard = function(responseClipboard) {
        //     var uniqueDates = 0;
        //     $scope.clipboardataSorted = [];
        //     $scope.clipboardData = $filter('orderBy')($scope.clipboardData, 'date_created', true);
        //     var tempArray = [];
        //     tempArray.push($scope.clipboardData[0]);
        //     for (var i = 0; i < $scope.clipboardData.length; i++) {
        //         var tempDate = moment($scope.clipboardData[i].date_created).format('D MMM, YYYY');
        //         if (prevDate != tempDate) {
        //             uniqueDates++
        //             var temp = {
        //                 "date_created": tempDate,
        //                 'data': ""
        //             }
        //             $scope.clipboardataSorted[uniqueDates] = temp;
        //             if (i !== 0) {
        //                 tempArray = [$scope.clipboardData[i]];
        //             }

        //         } else {
        //             tempArray.push($scope.clipboardData[i]);
        //         }
        //         $scope.clipboardataSorted[uniqueDates].data = tempArray;
        //         var prevDate = tempDate;
        //     }
        //     $scope.totalItemsClipboard = $scope.clipboardData.length;
        //     $scope.clipboardataLength = $scope.clipboardataSorted.length;

        // };



        $scope.downloadTranscript = function() {
          $scope.baseUrl = RestEndpoints.baseURL + "/file"; // "http://localhost:1442/reports";
          var codesnippet_url = $scope.activeModuleData.metaData.trascriptUrl.replace(".pdf", ".zip");
          $window.open($scope.baseUrl + "/download/" + user_data.token + "/" + $scope.activeModule.sequenceId + "/" + $scope.activeModuleData.metaData.trascriptUrl, "_blank");

        }

        //method for downloading code snippet
        $scope.downloadCodeSnippet = function() {
          $scope.baseUrl = RestEndpoints.baseURL + "/file"; // "http://localhost:1442/reports";
          //var codesnippet_url = $scope.activeModuleData.metaData.trascriptUrl.replace(".pdf",".zip");
          $window.open($scope.baseUrl + "/download/" + user_data.token + "/" + $scope.activeModule.sequenceId + "/" + $scope.activeModuleData.metaData.codeSnippetUrl, "_blank");

        }


        $scope.checkCodeSnippet = function() {
          $scope.baseUrl = RestEndpoints.baseURL + "/file";
          //var codesnippet_url = $scope.activeModuleData.metaData.trascriptUrl.replace(".pdf",".zip");   
          $http({
            method: 'GET',
            url: $scope.baseUrl + "/filecheck/" + user_data.jwttoken + "/" + $scope.activeModule.sequenceId + "/" + $scope.activeModuleData.metaData.codeSnippetUrl
          }).then(function successCallback(response) {
            if (response.data.status != "error") {
              $scope.codeSnippet = true;
            } else {
              $scope.codeSnippet = false;
            }
          }, function errorCallback(response) {
            console.log("error");
            $scope.codeSnippet = false;
          });
        }


        $scope.rearrangeData = function(response) {
          $scope.videoData = response.data.video_transcript;
          $scope.videos[count.toString()] = [];
          $scope.videoData.forEach(function(val, ind) {
            if (val.startOfParagraph) {
              $scope.videos[count.toString()].push(val);
              counter++;
            } else {
              $scope.videos[count.toString()].push(val);
              counter++;
            }
            if ($scope.videoData[(ind + 1)] && $scope.videoData[(ind + 1)].startOfParagraph) {
              count++;
              counter = 0;
              $scope.videos[count.toString()] = [];
            }
          });
          count = 0;
          var length = Object.keys($scope.videos).length;
          var i = 0;
          var temp = {};
          while (i < length) {
            var tempLen = $scope.videos[i].length;
            var end = $scope.videos[i][tempLen - 1].endTime;
            var start = $scope.videos[i][0].startTime;
            temp = {
              'start': start,
              'end': end,
              'val': $scope.videos[i]
            };
            $scope.videosData[i] = temp;
            i++;
          }
        }



        $scope.rearrangeDataTranscript = function(response) {

          $scope.videosDummy[countTranscript.toString()] = [];
          response.forEach(function(val, ind) {
            if (val.startOfParagraph) {
              $scope.videosDummy[countTranscript.toString()].push(val);
              counterTranscript++;
            } else {
              $scope.videosDummy[countTranscript.toString()].push(val);
              counterTranscript++;
            }
            if (response[(ind + 1)] && response[(ind + 1)].startOfParagraph) {
              countTranscript++;
              counterTranscript = 0;
              $scope.videosDummy[countTranscript.toString()] = [];
            }
          });
          countTranscript = 0;
          var length = Object.keys($scope.videosDummy).length;
          var i = 0;
          var temp = {};
          while (i < length) {
            var tempLen = $scope.videosDummy[i].length;
            var end = $scope.videosDummy[i][tempLen - 1].end;
            var start = $scope.videosDummy[i][0].start;
            temp = {
              'start': start,
              'end': end,
              'val': $scope.videosDummy[i]
            };
            response = temp;
            i++;
          }
        }

        $scope.onPlayerReady = function(API) {
          $scope.API = API;
          $scope.setVideoDefaultValues();
        };

        $scope.setVideoDefaultValues = function() {
          $scope.API.volume = 100;
          $scope.updateVolumeView($scope.API.volume);
          $scope.Videoconfig = {
            preload: 'preload',

            thumbnails: "assets/thumbnail.jpg",

            tracks: [{
              src: "assets/test2.vtt",
              kind: "captions",
              srclang: "en",
              label: "English",
              default: "default"
            }, {
              src: "assets/test2.vtt",
              kind: "captions",
              srclang: "es",
              label: "Spanish",
              default: null
            }]
          };

        };

        // Settings Button

        $scope.settingsOptWrp = function() {
          $scope.settingsOpt = !$scope.settingsOpt;
          $scope.qualityOpt = false;
          $scope.speedOpt = false;
          $scope.subtitlesOpt = false;
        }
        $scope.onMouseLeave = function() {
          $scope.settingsOpt = !$scope.settingsOpt;
        }
        $scope.qualityOptWrp = function() {
          $scope.settingsOpt = !$scope.settingsOpt;
          $scope.qualityOpt = true;
          $scope.speedOpt = false;
          $scope.subtitlesOpt = false;
        }
        $scope.speedOptWrp = function() {
          $scope.settingsOpt = !$scope.settingsOpt;
          $scope.speedOpt = true;
          $scope.qualityOpt = false;
          $scope.subtitlesOpt = false;
        }
        $scope.subtitlesOptWrp = function() {
          $scope.settingsOpt = !$scope.settingsOpt;
          $scope.subtitlesOpt = true;
          $scope.qualityOpt = false;
          $scope.speedOpt = false;
        }
        $scope.subtitleIndex = function(pos) {

          switch (pos) {
            case 0:
              $scope.Videoconfig.tracks = [{
                label: 'English subtitles',
                kind: 'subtitles',
                srclang: 'en',
                src: '../assets/test2.vtt',
                'default': ''
              }]
              break;

            case 1:
              $scope.Videoconfig.tracks = [{
                label: 'English subtitles',
                kind: 'subtitles',
                srclang: 'en',
                src: '../assets/test1.vtt',
                'default': ''
              }]
              break;

            default:
              $scope.Videoconfig.tracks = [{
                label: 'English subtitles',
                kind: 'subtitles',
                srclang: 'en',
                src: '../assets/test1.vtt',
                'default': ''
              }]
              break;
          }

          $scope.subtitlesVal = $scope.subtitles[pos];
          $scope.settingsOpt = true;
          $scope.subtitlesOpt = false;
        }

        $scope.qualityIndex = function(pos) {
          switch (pos) {
            case 0:
              $scope.API.stop();

              $scope.Videoconfig.sources = [{
                src: $sce.trustAsResourceUrl($scope.videoItemData.url_720),
                type: 'video/mp4'
              }];
              $timeout($scope.API.play.bind($scope.API), 100);
              break;

            case 1:
              $scope.API.stop();
              $scope.Videoconfig.sources = [{
                src: $sce.trustAsResourceUrl($scope.videoItemData.url),
                type: 'video/mp4'
              }];
              $timeout($scope.API.play.bind($scope.API), 100);
              break;

            case 2:
              $scope.API.stop();
              $scope.Videoconfig.sources = [{
                src: $sce.trustAsResourceUrl($scope.videoItemData.url_320),
                type: 'video/mp4'
              }];
              $timeout($scope.API.play.bind($scope.API), 100);
              break;
          }
          $scope.qualityVal = $scope.quality[pos];
          $scope.settingsOpt = true;
          $scope.qualityOpt = false;
          $scope.showQualOpt = false;
          $scope.shwMobOptions = false;
        }
        $scope.speedIndex = function(pos) {
          switch (pos) {
            case 0:

              $scope.API.mediaElement[0].playbackRate = 1.5;
              $timeout($scope.API.play.bind($scope.API), 100);
              break;

            case 1:

              $scope.API.mediaElement[0].playbackRate = 1;
              $timeout($scope.API.play.bind($scope.API), 100);
              break;

            case 2:
              $scope.API.mediaElement[0].playbackRate = 0.5;
              $timeout($scope.API.play.bind($scope.API), 100);
              break;

          }
          $scope.speedVal = $scope.speed[pos];
          $scope.settingsOpt = true;
          $scope.speedOpt = false;
          $scope.showVidOpt = false;
          $scope.shwMobOptions = false;
        }
        $scope.goToTime = function(item) {
          var seekTime = parseFloat(item);
          if (vdoplayer) {
            try {
              vdoplayer.seek(seekTime);
            } catch (e) {
              console.error(e);
            }
            var vCurrenTime = vdoplayer.time;
            var errorTime = seekTime - vCurrenTime;
          };
          // vdoplayer.seek(seekTime);

        };

        // report issue
        $scope.expandedReportIssue = false;
        var rissuesObj = {
          "issues": {
            "video": [{
              "type": "blurry"
            }, {
              "type": "cuts out"
            }, {
              "type": "looks strange"
            }],
            "sound": [{
              "type": "hard to hear"
            }, {
              "type": "not matched with video"
            }, {
              "type": "missing in some parts"
            }],
            "transcript": [{
              "type": "missing"
            }, {
              "type": "hard to read"
            }, {
              "type": "not matched with audio"
            }, {
              "type": "misspellings"
            }],
            "labelling": [{
              "type": "wrong title or summary"
            }, {
              "type": "video out of order"
            }],
            "buffering": [{
              "type": "other problem"
            }, {
              "type": "playback won't start"
            }, {
              "type": "looks strange"
            }]
          }
        };


        $scope.showRIssuesExpanded = function(problem) {
          $scope.riFullView = true;
          $scope.problemSelected = problem;
          $scope.selectedIssue = rissuesObj.issues[problem];
        };
        $scope.sendRIssue = function() {
          alert($scope.selectedIssue.issueName);
          $scope.expandedReportIssue = false;
        };

        // report issue mobile
        $scope.expandedReportIssueMob = false;
        $scope.reportIssueMobFunc = function() {
          // $scope.showTrimScreen = true;
          $scope.expandedReportIssueMob = !$scope.expandedReportIssueMob;
        };

        //  Overlay Container
        $scope.overlayToggle = true;
        $scope.onClickOverlayPlay = function() {
          $scope.API.playPause();
        };

        $scope.onUpdateState = function($state) {
          var videoStarttime = $scope.videos[0];
          var currentTime = ($scope.API.currentTime / 1000);

          switch ($state) {
            case 'play':
              $scope.overlayPlayIcon = {
                hide: true
              };
              $scope.takeNotesToggle = false;
              break;

            case 'pause':

              $scope.overlayPlayIcon = {
                show: true
              };
              if (currentTime > videoStarttime[0].start) {
                $scope.takeNotesToggle = true;
                $scope.getParaDetails();
                $timeout(function() {
                  $scope.positionTrimImage()
                }, 100);

              }
              break;

            case 'stop':
              $scope.overlayPlayIcon = {
                show: true
              };
              $scope.takeNotesToggle = false;
              break;
          }
        }

        $scope.getParaDetails = function() {
          var length = Object.keys($scope.videosData).length;
          var currentTime = $filter('number')(($scope.API.currentTime / 1000), 2);
          var i, j, paragraphIndex, childIndex, end, tempLen;
          i = 0;
          j = 0;
          $scope.paragraph = [];
          paragraphIndex = 0;
          childIndex = 0;
          while (i < length) {
            tempLen = $scope.videos[i].length;
            end = $filter('number')($scope.videos[i][tempLen - 1].end, 2);
            if (end >= $scope.activeTime) {
              paragraphIndex = i;
              break;
            } else {
              i++;
            }
          }

          tempLen = $scope.videos[paragraphIndex].length;
          while (j < tempLen) {
            end = $scope.videos[paragraphIndex][j].end;
            if (currentTime < end) {

              childIndex = j;
              break;
            } else {
              j++;
            }
          }


          childIndex--;
          var tempIndex = 0;
          if (childIndex < 0) {
            while (tempIndex < 2) {
              if (angular.isDefined($scope.videosDummy[paragraphIndex][tempIndex])) {
                $scope.paragraph[tempIndex] = $scope.videosDummy[paragraphIndex][tempIndex].text;
              }
              tempIndex++;
            }
            $scope.takeNoteTitle = $scope.paragraph[0];
            $scope.titleAskAnExpert = $scope.takeNoteTitle;
          } else {

            while (tempIndex < 3) {
              if (angular.isDefined($scope.videosDummy[paragraphIndex][childIndex])) {
                $scope.paragraph[tempIndex] = $scope.videosDummy[paragraphIndex][childIndex].text;
              }
              childIndex++;
              tempIndex++;
            }
            $scope.takeNoteTitle = $scope.paragraph[1];
            $scope.titleAskAnExpert = $scope.takeNoteTitle;
          }
          $scope.questionTitle = $scope.paragraph[0];
        }


        $scope.saveNotes = function() {
          $scope.takeNotesToggle = false;
          $scope.API.play();
        }

        $scope.updateTime = function($currentTime) {
          $scope.activeTime = $currentTime;
          $scope.autoScroll();

        }

        $rootScope.$on('textSizeChanged', function() {
          $scope.autoScroll('textSizeChanged');
        });
        var currnrtElemTrack = [];
        $scope.autoScroll = function(param) {
          var element = angular.element('.vid-text-active');
          var myElem = $('.vid-text-active');

          var thisElemId = myElem.attr('id');
          if (param) {
            currnrtElemTrack[0] = null;
            $scope.autoScroll();
          }
          if (element.length !== 0 && myElem && (currnrtElemTrack[0] !== thisElemId)) {
            currnrtElemTrack[0] = thisElemId;
            var pos = myElem.position();
            angular.element('#scroll').animate({
              scrollTop: pos.top
            });
            //TODO: Need to enhance this call
            if (param) {
              $scope.autoScroll();
            }
          }

        };

        $scope.onSeeking = function() {
          $scope.isSeeking = true;
          // $scope.takeNotesToggle = false;
        };

        $scope.onSeeked = function() {
          $scope.isSeeking = !$scope.isSeeking;
          $scope.takeNotesToggle = true;
          $scope.getParaDetails();
          $timeout(function() {
            $scope.positionTrimImage()
          }, 100);
        };



        $scope.takeScreenshot = function() {
          $scope.$emit('takeScreenShot', $scope.activeTime);
        }




        $scope.mobileVideoOptions = function() {
          $scope.shwMobOptions = !$scope.shwMobOptions;

        }
        $scope.mobileTrimNotes = function() {
          $scope.showTrimScreen = !$scope.showTrimScreen;
          $scope.showMobTrim = false;
          $scope.takeNoteModel = '';
          $scope.vidTrimSaveMob = false
        }
        $scope.mobileTrimVideo = function() {
          $scope.showTrimScreen = !$scope.showTrimScreen;
          $timeout(function() {
            $scope.setCarouselLimtMobile();
          }, 200);
          $scope.showMobTrim = true;
        }
        $scope.closeTakeNoteMob = function() {
          $scope.showTrimScreen = !$scope.showTrimScreen;
          $scope.showMobTrim = !$scope.showMobTrim;
          $scope.editTitleTakeNotesToggle = false;
        }

        //  Carousel Thing
        // $scope.getCarouselLimit = function() {


        //     return(uiEleWidth)
        // }



        // Volume control Part
        $scope.volumeBartoggle = function() {
          $scope.toggleVolume = !$scope.toggleVolume;
        }
        $scope.videoMute = function() {

          if (isMuted) {
            $scope.currentVolume = $scope.defaultVolume;
          } else {
            $scope.currentVolume = 0;
            $scope.muteIcon = {
              mute: true
            };
          }

          isMuted = !isMuted;

          $scope.updateVolumeView($scope.currentVolume);
        }

        $scope.updateVolumeView = function updateVolumeView(value) {

          if (!isMuted) {
            $scope.defaultVolume = value;
          } else {
            if (value > 0) {
              $scope.defaultVolume = value;
            }
          }

          var volValue = value / 100;
          $scope.currentVolume = value;
          $scope.API.setVolume(volValue);
          var percentValue = Math.round(volValue * 100);
          if (percentValue === 0) {
            $scope.muteIcon = {
              mute: true
            };
          } else if (percentValue > 0 && percentValue < 25) {
            $scope.muteIcon = {
              level0: true
            };
          } else if (percentValue >= 25 && percentValue < 50) {
            $scope.muteIcon = {
              level1: true
            };
          } else if (percentValue >= 50 && percentValue < 75) {
            $scope.muteIcon = {
              level2: true
            };
          } else if (percentValue >= 75) {
            $scope.muteIcon = {
              level3: true
            };
          }
        };





        $scope.bookmarkVideo = function() {
          $scope.bookmarked = !$scope.bookmarked;
        };

        // Highlight
        $scope.highlightTextMarkup = function(markupData) {
          return $sce.trustAsHtml(markupData);
        };
        $scope.trimOption = function() {
          $scope.askExpertOpt = false;
          $scope.notesOpt = false;
          $scope.trimOpt = true;
        };
        $scope.notesOption = function() {
          $scope.askExpertOpt = false;
          $scope.trimOpt = false;
          $scope.notesOpt = true;
        };
        $scope.askExpertOption = function() {
          $scope.trimOpt = false;
          $scope.notesOpt = false;
          $scope.askExpertOpt = true;
        };
        $scope.askingQuestionFunc = function() {
          $scope.askingQuestion = true;
        };

        $scope.selectedQuestion = function(questionObj) {
          if (questionObj.answered) {
            $scope.selectedFQ = questionObj;
            $scope.showSelectedFAQ = true;
            $scope.askingQuestion = false;
            $scope.askExpertMobSearch = true;
          } else {
            $scope.modelData.askedQuestion = questionObj.question;
            $scope.askingQuestion = false;
            $scope.askExpertMobSearch = true;
          }
        };
        $scope.editTitleFunc = function() {
          $scope.editTitle = !$scope.editTitle;
        };

        $scope.unableEditFunc = function() {
          $scope.editTitle = false;
        };
        $scope.selectedFAQ = function(questionObj) {
          if (questionObj.answered) {
            $scope.selectedFQ = questionObj;
            $scope.showSelectedFAQ = true;
          } else {
            $scope.modelData.askedQuestion = questionObj.question;
          }
        };
        $scope.hideSelectedFAQFunc = function() {
          $scope.modelData.askedQuestion = '';
          $scope.showSelectedFAQ = false;
        };
        $scope.clearFieldFunc = function() {
          $scope.modelData.askedQuestion = '';
          $scope.askingQuestion = false;
        };




        // Change the value of slider for trim

        // Trim Carosuel

        $scope.positionTrimImage = function() {
          var trimBgEle = angular.element('.trim-bg-img');
          var trimBgMobEle = angular.element('.trim-bg-img-mob');

          var totalTime = $scope.API.totalTime / 1000;
          $scope.sliderDisabled = false;

          // THIS SETS THE EXTREME vALUES OF THE SLIDER
          $scope.sliderMax = Math.ceil($scope.API.totalTime / 1000);

          // Slider to px seconds Ratio
          $scope.slidierTimeRatio = 20;

          var timeStartTrim = $scope.activeTime - 20;
          $scope.sliderMaxValue = ($scope.API.totalTime / 1000);

          // This function moves the background Image based on current Time
          $scope.setCarouselLimt();

          // Sets the intial Position of the slider Model
          if ($scope.activeTime + 20 >= $scope.sliderMax) {
            $scope.sliderModelMin = $scope.sliderMax - 20;
            $scope.sliderModelMax = $scope.sliderMax;
          } else {
            $scope.sliderModelMin = $scope.activeTime + 20;
            $scope.sliderModelMax = $scope.activeTime + 60;
          }

          $scope.sliderModelMinMob = $scope.activeTime + 10;
          $scope.sliderModelMaxMob = $scope.activeTime + 15;

          $timeout(function() {
            $scope.setTrimOverlay()
          }, 100);
          if (trimBgMobEle.length > 0) {
            $timeout(function() {
              $scope.setTrimOverlayMobile()
            }, 100);
          }

        }

        // function to set overlay black on the trim section

        $scope.setTrimOverlay = function() {
          var trimBgEle = angular.element('.trim-bg-img');
          var leftHandle = angular.element('.ngrs-handle-min');
          var rightHandle = angular.element('.ngrs-handle-max');
          leftBlurEle = angular.element('.slider-left-blurred');
          rightOverlayEle = angular.element('.slider-right-blurred');
          var parentWidth = trimBgEle[0].style.width.split('px');
          var tempHandleMin = leftHandle[0].style.left.split('%');
          var tempHAndleMax = rightHandle[0].style.left.split('%');

          var leftoverlayWidth = (tempHandleMin[0] * parentWidth[0] / 100);

          var rightoverlayWidth = parentWidth[0] - (tempHAndleMax[0] * parentWidth[0] / 100);
          rightoverlayWidth = rightoverlayWidth - 3;
          leftBlurEle[0].style.width = leftoverlayWidth + 'px';
          rightOverlayEle[0].style.width = rightoverlayWidth + 'px';
        }

        // function to move the image to match video current time

        $scope.setCarouselLimt = function() {
          var trimBgEle = angular.element('.trim-bg-img');
          viewportTrim = trimBgEle[0].clientWidth;
          var viewEle = angular.element('.vid-overlay-slider-img-wrp');
          carouselLimit = viewportTrim - viewEle[0].clientWidth;
          SecondsperPx = 141 / 20;
          var tempMoveTo = (SecondsperPx * $scope.activeTime);
          if (tempMoveTo < carouselLimit) {
            trimBgEle[0].style.left = "-" + tempMoveTo + 'px';
          } else {
            trimBgEle[0].style.left = "-" + carouselLimit + 'px';
          }


        }



        // function to move the carousel
        $scope.trimMoveAhead = function() {
          var trimBgEle = angular.element('.trim-bg-img');
          var TempLeft = trimBgEle[0].style.left.split('px');
          var eleLeft = parseInt(TempLeft[0]);
          if (eleLeft > -carouselLimit) {
            trimBgEle[0].style.left = (eleLeft - 40) + "px";
          } else if (!eleLeft) {
            trimBgEle[0].style.left = -40 + "px";
          }
        }

        // function to move the carousel
        $scope.trimRewind = function() {
          var viewEle = angular.element('.vid-overlay-slider-img-wrp');
          var trimBgEle = angular.element('.trim-bg-img');
          var TempLeft = trimBgEle[0].style.left.split('px');
          var eleLeft = parseInt(TempLeft[0]);
          if (eleLeft < 0) {
            trimBgEle[0].style.left = (eleLeft + 40) + "px";
          }
        }




        // watch slider upperLimt
        $scope.$watch(
          function() {
            return $scope.sliderModelMin;
          },
          function(newVal) {
            //$scope.onUpdateMinTrim( newVal );
          }
        );

        // watch slider upperLimt

        $scope.$watch(
          function() {
            return $scope.sliderModelMax;
          },
          function(newVal) {
            //$scope.onUpdateMaxTrim( newVal );
          }
        );

        // function called when the slider is dragging
        $scope.sliderHandleGrab = function() {
          var timeDiff = $scope.sliderModelMax - $scope.sliderModelMin;
          if (timeDiff > 178) {
            $scope.sliderDisabled = true;
            window.alert("hey you exceeded the limit");
          } else {
            $scope.sliderDisabled = false;
          }
        };

        // function called when the slider is released
        $scope.sliderHandleRelease = function() {
          if ($scope.sliderDisabled) {
            $scope.sliderDisabled = false;
          }
        }

        // function on click of save button on Trim
        $scope.trimVideoCall = function() {
          $scope.$emit('trimVideo', $scope.sliderModelMin, $scope.sliderModelMax);
        }



        // trim functionality in Mobile

        $scope.setCarouselLimtMobile = function() {
          //  FOr Mobile Trim
          var viewMobEle = angular.element('.vid-overlay-slider-img-wrp-mob');
          var trimBgEleMob = angular.element('.trim-bg-img-mob');
          viewportTrimMob = trimBgEleMob[0].clientWidth;
          var tempMoveTo = (SecondsperPxMob * $scope.activeTime);
          tempMoveTo = tempMoveTo + 20;
          if (viewMobEle.length > 0) {

            carouselLimitMob = viewportTrimMob - viewMobEle[0].clientWidth;
            if (tempMoveTo < carouselLimitMob) {
              $(".trim-bg-img-mob").animate({
                left: '-' + tempMoveTo + 'px'
              });
            } else {
              $(".trim-bg-img-mob").animate({
                left: '-' + carouselLimitMob + 'px'
              });
            }
          }
        }

        $scope.trimRewindMob = function() {
          var viewEle = angular.element('.vid-overlay-slider-img-wrp-mob');
          var trimBgEle = angular.element('.trim-bg-img-mob');
          var TempLeft = trimBgEle[0].style.left.split('px');
          var eleLeft = parseInt(TempLeft[0]);
          if (eleLeft < 0) {
            $(".trim-bg-img-mob").animate({
              left: (eleLeft + 40) + 'px'
            });
          }
        }

        $scope.trimMoveAheadMob = function() {
          var trimBgEle = angular.element('.trim-bg-img-mob');
          var TempLeft = trimBgEle[0].style.left.split('px');
          var eleLeft = parseInt(TempLeft[0]);
          if (eleLeft > -carouselLimitMob) {
            $(".trim-bg-img-mob").animate({
              left: (eleLeft - 40) + 'px'
            });
          } else if (!eleLeft) {
            $(".trim-bg-img-mob").animate({
              left: -40 + 'px'
            });
          }
        }

        $scope.setTrimOverlayMobile = function() {
          var trimBgEle = angular.element('.trim-bg-img-mob');
          var leftHandle = angular.element('.ngrs-handle-min');
          var rightHandle = angular.element('.ngrs-handle-max');
          leftBlurEle = angular.element('.slider-left-blurred-mob');
          rightOverlayEle = angular.element('.slider-right-blurred-mob');
          var parentWidth = trimBgEle[0].style.width.split('px');
          var tempHandleMin = leftHandle[1].style.left.split('%');
          var tempHAndleMax = rightHandle[1].style.left.split('%');
          var leftoverlayWidth = (tempHandleMin[0] * parentWidth[0] / 100);
          var rightoverlayWidth = parentWidth[0] - (tempHAndleMax[0] * parentWidth[0] / 100);
          leftBlurEle[0].style.width = leftoverlayWidth + 'px';
          rightOverlayEle[0].style.width = rightoverlayWidth + 'px';

        }

        // watch slider upperLimt
        $scope.$watch(
          function() {
            return $scope.sliderModelMinMob;
          },
          function(newVal) {
            // $scope.onUpdateMinTrimMobile( newVal );
          }
        );

        // watch slider upperLimt

        $scope.$watch(
          function() {
            return $scope.sliderModelMaxMob;
          },
          function(newVal) {
            //$scope.onUpdateMaxTrimMobile( newVal );
          }
        );


        $scope.saveMobileTrim = function() {
          $scope.vidTrimSaveMob = true;
        }

        // Take note Change

        $scope.takeNoteChange = function() {

        }
        $scope.saveNotesMob = function() {
          $scope.shwMobOptions = false;
          $scope.showTrimScreen = !$scope.showTrimScreen;
        };

        // Ask an Expert in Mobile

        $scope.shwAskExpertMob = function() {
          $scope.askExpertMob = true;
          $scope.showTrimScreen = true;
          $scope.ShwEditAskexprtTitle = false;
          $scope.showSelectedFAQ = false;
          $scope.askExpertMobSearch = true;
          $scope.askingQuestion = false;
          $scope.modelData.askedQuestion = '';
        };

        $scope.closeAskExprtMob = function() {
          $scope.askExpertMob = !$scope.askExpertMob;
          $scope.showTrimScreen = false;

        };
        $scope.clearAskAnExpert = function() {
          $scope.modelData.askedQuestion = '';
        };

        $scope.clearTakeNotes = function() {
          $scope.takeNoteModel = '';
        };
        $scope.clearAskExpertTitleMob = function() {
          $scope.titleAskAnExpert = '';
        };
        $scope.clearAskExpertTitle = function() {
          $scope.questionTitle = '';
          $scope.titleAskAnExpert = '';
        };
        $scope.cleartakeNoteTitle = function() {
          $scope.takeNoteTitle = '';
        };

        $scope.editAskAnexprtTitle = function() {
          $scope.ShwEditAskexprtTitle = !$scope.ShwEditAskexprtTitle;
          $scope.newtitleAskAnExpert = $scope.titleAskAnExpert;
        };

        $scope.editTakeNotesTitle = function() {
          $scope.titleAskAnExpert = $scope.takeNoteTitle;
          $scope.ShwEditTakeNotesTitle = !$scope.ShwEditTakeNotesTitle;
        };




        $scope.cancelSaveTrimMob = function() {
          $scope.vidTrimSaveMob = !$scope.vidTrimSaveMob;
        };

        $scope.SaveTrimMob = function() {
          $scope.vidTrimSaveMob = !$scope.vidTrimSaveMob;
          $scope.showTrimScreen = !$scope.showTrimScreen;

        };

        $scope.editTitleTakeNotes = function() {
          $scope.editTitleTakeNotesToggle = !$scope.editTitleTakeNotesToggle;
        };


        $scope.askExpertMobSearchFunc = function() {
          $scope.askExpertMobSearch = false;
          $scope.askingQuestion = true;
        };
        $scope.cancelAskExpertMobSearch = function() {
          $scope.askExpertMobSearch = true;
          $scope.askingQuestion = false;
        };
        $scope.suggestQuestions = function(data) {
          var returnData = -1;
          $scope.modelData.askedQuestion = $scope.modelData.askedQuestion.toLowerCase();
          returnData = (data.question).toLowerCase().indexOf($scope.modelData.askedQuestion);
          if (returnData >= 0) {
            data.duplicateQues = data.question.replace(new RegExp($scope.modelData.askedQuestion, "gi"), function(match) {

              return '<span class="searched-text">' + match + '</span>';

            });
          }
          return returnData >= 0;
        };
  });

'use strict';
angular
    .module('jigsawCorpLms')
    .controller('userProfileCtrl', function($scope, fetchData, $state, $rootScope, AppUtilities, InputValidation, $timeout, $http, DataCache, $location, $anchorScroll) {

        //DataCache.loadFromWebstorage();
        $scope.authData = DataCache.returnData("userData");

        if ($scope.authData == null || $scope.authData == undefined || !$scope.authData) {
            return;
        }

//changes made for new SDK
        $scope.idToken = DataCache.returnData("idToken");
        //$http.defaults.headers.common['Authorization'] = "Bearer " + $scope.idToken;
        $http.defaults.headers.common['Authorization'] = "Bearer " + $scope.authData.jwttoken;
        $http.defaults.headers.common['Content-Type'] = "application/x-www-form-urlencoded";

        var pattern = /^[\w@#$%^\\]+$/;
        var passwordValidationCriteria;

        $scope.parentObj = {};
        $scope.tNCOverlay = false;
        $scope.parentObj.trialVar = false;



        fetchData.fetchProfileData().then(function(response) {
            $scope.profile = response.data.profile;
            $scope.companyName = $scope.profile.company;
            $scope.emailID = $scope.profile.fbUsername;
            $scope.designation = $scope.profile.designation;
            $scope.parentObj.theUserName = $scope.profile.fbUsername;
            $scope.parentObj.altEmailId = $scope.profile.alternativeEmail;
            $scope.parentObj.phoneNumber = $scope.profile.phoneNo;
            $scope.fullName = $scope.profile.firstname + " " + $scope.profile.lastname;
            $scope.parentObj.libUpdate = ($scope.profile.notifyChangeInLibrary === 'Y') ? true : false;
            $scope.parentObj.progressUpdate = ($scope.profile.notifyProgress === 'Y') ? true : false;
            $scope.parentObj.pointsAndRewards = ($scope.profile.rewardsAndPoints === 'Y') ? true : false;

            $scope.parentObj.activateAll = ($scope.parentObj.libUpdate && $scope.parentObj.progressUpdate && $scope.parentObj.pointsAndRewards) ? true : false;
            //$scope.parentObj.resources = true;
            $scope.loadCountryCodes($scope.profile.countryPhoneCode);
            // update avatar level
            $scope.avatar = $rootScope.baseimageurl + '/avatars/1/' + $scope.profile.profilePhotoUrl;
            angular.element($(".prog-pg-hdr-userimg")).css("background", "rgba(0, 0, 0, 0) url('" + $scope.avatar + "') scroll 0px 0px / 100% 100% padding-box border-box");
            DataCache.saveGlobalData('avatar', $scope.profile.profilePhotoUrl);
        });

        $scope.loadCountryCodes = function(userCountryCode) {
            fetchData.fetchCountryCodes().then(function(response) {
                $scope.countryCodes = response.countryCodes;
                angular.forEach($scope.countryCodes, function(value, key) {
                    if (value.code === userCountryCode) {
                        $scope.parentObj.countryCode = value;
                    }
                }, this);
            });
        }

        $scope.parentObj.termsnCondition = true;
        $scope.applySchema = function() {
            $timeout(function() {
                var maskew = new Maskew(document.getElementById("setupProfileImage"), 20);
            }, 100);

        };

        var userData = DataCache.returnData("userData");
        var role = userData.role;
        $scope.updateProfile = function(isValid) {
            if (isValid) {
                var avatarImg = DataCache.returnData('avatar');
                var data = {
                    "linkedinUsername": "",
                    "linkedinUid": "",
                    "alternativeEmail": $scope.parentObj.altEmailId,
                    "countryPhoneCode": $scope.parentObj.countryCode.code,
                    "phoneNo": $scope.parentObj.phoneNumber,
                    "notifyChangeInLibrary": $scope.parentObj.libUpdate ? 'Y' : 'N',
                    "notifyProgress": $scope.parentObj.progressUpdate ? 'Y' : 'N',
                    "rewardsAndPoints": $scope.parentObj.pointsAndRewards ? 'Y' : 'N',
                    "profilePhotoUrl": avatarImg
                };

                fetchData.updateProfileScreenData(data).then(function(response) {
                    if (response.data.status === "success") {
                        $rootScope.$broadcast("userdetails-popout-initiated");
                        // $rootScope.headerShow = true;
                        // $rootScope.dashArrow = true;
                        // $rootScope.moduleHeader = false;
                        // $rootScope.scndHdr = true;

                        //$scope.cancelFunction();
                    }
                });
            }
        };

        $scope.markTermsAndCondition = function() {
            var termsAndConditionCheckElem = document.getElementById("termsnConditionLabel");
            if (termsAndConditionCheckElem.checked) $scope.parentObj.termsnCondition = true;
            else $scope.parentObj.termsnCondition = false;
        }

        $scope.thisIsFocused = function() {
            $scope.pwdInputIsFocussed = true;
        };

        $scope.thisIsBlured = function() {
            $scope.pwdInputIsFocussed = false;
        };

        $scope.activateAllNotify = function(activateAll) {
            if (activateAll) {
                $scope.parentObj.libUpdate = true;
                $scope.parentObj.progressUpdate = true;
                $scope.parentObj.pointsAndRewards = true;
            } else {
                $scope.parentObj.libUpdate = false;
                $scope.parentObj.progressUpdate = false;
                $scope.parentObj.pointsAndRewards = false;
            }
        };

        $scope.activateAllNotify($scope.parentObj.activateAll); // All notifications - pre selected

        $scope.notifyOptionChanged = function() {
            $scope.parentObj.activateAll = $scope.parentObj.libUpdate && $scope.parentObj.progressUpdate && $scope.parentObj.pointsAndRewards;
        };

        $scope.openClosetNCOverlay = function() {
            $scope.tNCOverlay = !$scope.tNCOverlay;
        };

        $scope.retypePasswordChange = function() {
            $scope.isBothPwdSame = $scope.parentObj.inputConfirmPassword === $scope.parentObj.inputPassword;
        };

        $scope.passwordChange = function() {
            $scope.isBothPwdSame = $scope.parentObj.inputConfirmPassword === $scope.parentObj.inputPassword;
        };

        $scope.uploadNewAvatar = function() {
            // http call for selecting or uploading avatar goes here
        };

        $scope.$watch('parentObj.phoneNumber', function(newValue, oldValue) {
            if ($scope.parentObj.phoneNumber && isNaN(newValue)) {
                $scope.parentObj.phoneNumber = oldValue;
            }
        });

        //Password Watch
        $scope.$watch('parentObj.inputPassword', function(newValue, oldValue) {
            if (oldValue !== newValue) {
                if (newValue === undefined) {
                    $scope.parentObj.inputPassword = '';
                    newValue = '';
                }

                if (newValue.indexOf(' ') >= 0) {
                    $scope.parentObj.inputPassword = newValue.replace(/[' ']/g, '');
                }

                $scope.minPasswrdLength = ($scope.parentObj.inputPassword.length > 7);

                passwordValidationCriteria = /[0-9]/;
                $scope.min1Number = (passwordValidationCriteria.test($scope.parentObj.inputPassword));

                passwordValidationCriteria = /[a-zA-Z]/;
                $scope.lowercaseCharacters = (passwordValidationCriteria.test($scope.parentObj.inputPassword));

                $scope.enableChangePwdInput = ($scope.minPasswrdLength &&
                    $scope.min1Number && $scope.lowercaseCharacters);
            }
        });

        $scope.slickConfig = {
            enabled: true,
            autoplay: false,
            draggable: true,
            autoplaySpeed: 3000,
            infinite: false,
            variableWidth: true,
            method: {}
        };
        $scope.slideClipboardLeft = function() {
            $scope.slickConfig.method.slickNext();
        };
        $scope.slideClipboardRight = function() {
            $scope.slickConfig.method.slickPrev();
        };

        $scope.usrImage = function() {
            var temp = 'url("' + $rootScope.modelParent.userImage + '")';
            return {
                'background-image': temp
            }
        }
        $scope.cancelFunction = function() {
            if (role === 'Learner') {
                $state.go('home.dashboard');
            } else if (role === 'Manager' || role === 'L&D Manager') {
                $rootScope.userProfile = !$rootScope.userProfile;
                $scope.userProfile = !$scope.userProfile;
                $state.go('buyer.dashboard.trackProgress');
            }
        }

        $rootScope.$on("goToDashboard", function() {
            $scope.cancelFunction();
        });
        //  $scope.applySchema();


        $scope.changePassword = function(isValid) {
            if (isValid && $scope.isBothPwdSame) {
                var cpData = { "new_password": $scope.parentObj.inputPassword };
                fetchData.changePassword(cpData).then(function(response) {
                    if (response.data.status === "success") {
                        $rootScope.$broadcast("clear-text-field");
                        $rootScope.$broadcast("savepassword-popout-initiated");
                    } else {
                        console.log(response);
                    }

                });
            }
            $rootScope.$on("clear-text-field", function() {
                $scope.parentObj.inputPassword = "";
                $scope.parentObj.inputConfirmPassword = "";
                $timeout(function() {
                    angular.element('.uprofile-email-error').addClass('p-hide');
                }, 10);

            });
        }
    });
'use strict';
angular.module('jigsawCorpLms')
    .controller('rubricGuideCtrl', function($scope, $rootScope, DeviceDetector, DataCache, $state, fetchData,
        $location, AppConstant, UncaughtErrors, ErrorConstant, ErrorMessage, $timeout, RefreshHandler, $filter, FirebaseService, $window) {

        //changes made for intro.js
        $rootScope.activeController = "";
        $scope.learnersViewCtrl = [{}];
        $scope.welcomeScreenCntrl = [{
            element: '#lwstep1',
            intro: "This is the course assigned to you. We call it the ‘Learning Path’, and the modules within it, ‘Skills’.",
            //hint : "This is the course assigned to you. We call it the ‘Learning Path’, and the modules within it, ‘Skills’.",
            poistion: 'right'
        }, {
            element: '#lwstep2',
            intro: "This is your ‘Timeline’. Click on the numbers to learn more about each of the Skills to be learned.",
            //hint : "This is your ‘Timeline’. Click on the numbers to learn more about each of the Skills to be learned.",
            position: 'top'
        }, {
            //element: '#vstep3',
            intro: "We’re always happy to help. Press H to see these tips again and Esc to quit.",
            poistion: 'top-right'
        }];

        $scope.setupProfileCtrl = [{
            intro: "Please reset your password and add your contact details to get started.",
            poistion: 'middle'
        }];


        $scope.DashboardCtrl = [{
            intro: "This is your Dashboard. All you want to know about your learning journey in one place."
        }, {
            element: '#dstep1',
            intro: "Track the overall status of your learning here. Click on your Avatar on the left for a progress overview and your position on the leaderboard.",
            //hint : "Track the overall status of your learning here. Click on your Avatar on the left for a closer look at your activity, progress and where you stand on the Leaderboard.",
            position: 'bottom'
        }, {
            element: '#dstep2',
            intro: "Earn points while you learn! You have already gained points by just setting up your profile.",
            //hint : "Earn points while you learn! You’re already up by 20 points by simply setting up your profile.",
            position: 'left'
        }, {
            element: '#dstep3',
            intro: "This is the complete list of ‘Skills’ you will learn in this Learning Path. Click anywhere on the box to start learning.",
            //hint : "This is the complete list of ‘Skills’ you will learn in this Learning Path. Click anywhere on the box to start learning. When you come back, you can resume from where you last left off. ",
            position: 'top'
        },{
            element: '#dstep4',
            intro: "Click to download the datasets and code snippets related to the Skill.",
            //hint : "This is the complete list of ‘Skills’ you will learn in this Learning Path. Click anywhere on the box to start learning. When you come back, you can resume from where you last left off. ",
            position: 'top'
        }, {
            element: '#hintprof0',
            intro: "Test what you’ve learnt by taking a Proficiency Test. Remember, passing the test is compulsory for certification.",
            //hint : "Test what you’ve learnt by taking a Proficiency Test.",
            position: 'left'
        }, {
            element: '#dstep5',
            intro: "Want help? Want to report an issue? Or do you simply want to change your settings? Access your entire menu options here.",
            //hint : "Want help? Want to report an issue? Or do you simply want to change your settings? Access your entire menu options here. ",
            position: 'left'
        }];



        $scope.youTubePlayerctrl = [{
            intro: "This is your Classroom. This is where your actual learning happens.",
            position: 'top'
        }, {
            element: '#ytstep1',
            intro: "This is the Playlist for the Skill you are learning currently. A playlist covers the entire learning content including videos, assessments, case studies and other resources.",
            //hint : "This is the Playlist for the Skill you are learning currently. A playlist covers the entire learning content including videos, assessments, case studies and other resources.",
            position: 'top'
        }];

        $scope.videoPlayerctrl = [{
            intro: "This is your Classroom. This is where your actual learning happens.",
            position: 'top'
        }, {
            element: '#vpstep1',
            intro: "This is the Playlist for the Skill you are learning currently. A playlist covers the entire learning content including videos, assessments, case studies and other resources.",
            //hint : "This is the Playlist for the Skill you are learning currently. A playlist covers the entire learning content including videos, assessments, case studies and other resources.",
            position: 'left'
        }, {
            element: '#vpstep2',
            intro: "Follow the video content with interactive transcripts.",
            //hint : "Follow the video content with interactive transcripts. Download the transcript using the orange download button.",
            position: 'top'
        }];

        $scope.buyerDashboardCtrl = [{
                intro: "Hello there! It’s your first time here and we’d love to show you around.",
                position: 'top'
            }, {
                element: '#step1',
                intro: "This is your Dashboard. All you want to know about your team’s learning journey in one snapshot view. Click on each widget for more details.",
                //hint : "This is your Dashboard. All you want to know about your team’s/ organization’s learning journey in one snapshot view. Click on each widget for more details.",
                position: 'top'
            },
            //  {
            //      element: '#step2',
            //      intro: "This is your drilled down view. Change your perspective to view by the individual learners / teams or by the Learning Paths. You can also switch to table mode.",
            //      hint : "This is your drilled down view. Change your perspective to view by the individual learners / teams or by the Learning Paths. You can also switch to table mode.",
            //      position:'bottom'
            //  },
            {
                element: "#step4",
                intro: "Click here to select and download the reports.",
                //hint: "Click here to select and download the reports.",
                position: 'top'
            }, {
                element: "#step5",
                intro: "Want help? Want to report an issue? Or do you simply want to change your settings? Access your entire menu options here.",
                //hint: "Want help? Want to report an issue? Or do you simply want to change your settings? Access your entire menu options here.",
                position: 'left'
            }, {
                intro: "We’re always happy to help. Press H to see these tips again and Esc to quit.",
                //hint: "We’re always happy to help. Press H to see these tips again and Esc to quit.",
                position: 'bottom'
            }
        ];


        $rootScope.introData = "";

        $rootScope.$on('new-controller-loaded', function() {
            if ($rootScope.activeController !== "noIntro") {

                angular.element('.introjs-hints').removeClass('introjs-hints');
                angular.element('.introjs-hint').removeClass('introjs-hint');
                angular.element('.introjs-hint-dot').removeClass('introjs-hint-dot');
                angular.element('.introjs-hint-pulse').removeClass('introjs-hint-pulse');


                introJs().exit();
                introJs().hideHints();
                introJs().refresh();

                $rootScope.introData = {
                    steps: $scope[$rootScope.activeController],
                    //hints:$scope[$rootScope.activeController],
                    showStepNumbers: false,
                    exitOnOverlayClick: true,
                    exitOnEsc: true,
                    nextLabel: '<span id="next" style="color:white">Next &rarr;</span>',
                    prevLabel: '<span>&larr; Back</span>',
                    skipLabel: '<span>Exit</span>',
                    doneLabel: 'Got it',
                    hideNext: true,
                    hidePrev: true,
                    hintPosition: 'top-middle'
                };

            } else {
                $rootScope.introData = "";
            }
        });


        $rootScope.CompletedEvent = function(scope) {};
        $rootScope.ExitEvent = function(scope) {};
        $rootScope.ChangeEvent = function(targetElement, scope) {
            //   if(targetElement.id === "step3"){
            //     //introJs().setOption('doneLabel', 'Next page').start().oncomplete(function() {
            //   //  window.location.href = 'second.html?multipage=true';
            // //  });
            //   }
        };

        $rootScope.BeforeChangeEvent = function(targetElement, scope) {};
        $rootScope.AfterChangeEvent = function(targetElement, scope) {


        };




        //$rootScope.ShouldAutoStart = true;




    });
'use strict';
angular.module('jigsawCorpLms')
    .controller('appCtrl', function($scope, $rootScope, DeviceDetector, DataCache, $state, fetchData,
        $location, AppConstant, UncaughtErrors, $controller, ErrorConstant, ErrorMessage, $cookies, 
        $timeout, RefreshHandler, $filter, FirebaseService, $firebaseObject, $window, $http) {


        // $rootScope.modelParent.isPopOutViewActive = false;
        // $rootScope.modelParent.bringInPopOut = false;
        angular.extend(this, $controller('rubricGuideCtrl', {
            $scope: $scope
        }));


        $rootScope.$on("$locationChangeStart", function(event, next, current) {
            $window.ga('send', 'pageview', { page: $location.url() });
        });


        $rootScope.$on('initializeVariables', function() {
            $rootScope.baseimageurl = "https://rubric.jigsawacademy.com/images";
            DataCache.saveRootScopeData('baseimageurl', $rootScope.baseimageurl);
            DataCache.loadFromWebstorage();
            $rootScope.$broadcast('new-controller-loaded');
            $rootScope.events = "gCloudEvents";
            $rootScope.popoutShow = false;
            DataCache.saveRootScopeData('events', $rootScope.events);
        });

        DataCache.loadFromWebstorage();
        $rootScope.$broadcast('initializeVariables');


        $scope.firebaseWatch = function(uid) {
            var ref = FirebaseService.ref.child("/lp").child(uid);
            var obj = $firebaseObject(ref);
            var unwatch = obj.$watch(function() {
                console.log(ref);
                ref.on('child_changed', function(childSnapshot, prevChildKey) {
                    if (DataCache.returnLpData('currentLp') === 'active') {
                        var changedPost = childSnapshot.val();
                        $window.setData(changedPost);
                        DataCache.saveGlobalData("summary", changedPost.summary);
                        DataCache.saveGlobalData("details", changedPost.details);
                    }
                });
            });
        };

        $scope.connectToFirebase = function(userData) {

            var object = $cookies.getObject("userDetails");
            object.data = userData.uid;
            $rootScope.fbUsername = userData.fbUsername;
            DataCache.saveGlobalData('uid', userData.uid);
            $cookies.putObject('userDetails', object);
            DataCache.saveGlobalData("userDetails", object);
            $window.ga('set', 'userId', userData.fbUsername); // Set the user ID using signed-in user_id.

            if (userData.hasOwnProperty('token')) {
                $scope.FirebaseCustomTokenLogin(userData);
            } else {
                $scope.loadDashboardData(userData);
            }
        }

        $scope.FirebaseCustomTokenLogin = function(userData) {
            FirebaseService.loginWithCustomToken(userData.token).then(function(data) {
                DataCache.saveGlobalData("authData", data);

                // method to refresh IdTokens
                firebase.auth().currentUser.getIdToken(true).then(function(idToken) {
                    DataCache.saveGlobalData('idToken', idToken);
                }).catch(function(error) {
                    console.error(error.message);
                    $rootScope.loginProcessing = false;
                });

                var multiLoginref = FirebaseService.ref.child("login").child(data.uid);
                var obj1 = $firebaseObject(multiLoginref);
                multiLoginref.once('value', function(dataSnapshot) {
                    DataCache.saveGlobalData('loginId', dataSnapshot.val());
                });
                $scope.loadDashboardData(userData);
            }, function(fbLoginError) {
                $rootScope.loginProcessing = false;
                $rootScope.firebaseLoaded = true;
                localStorage.clear();
                sessionStorage.clear();
                $cookies.remove('userDetails');
                console.error("Error in login to firebase");
                $scope.loginErrorMessage = "Error in login";
                console.error(fbLoginError.message);
                DataCache.clearAll();
                FirebaseService.ref.unauth();
                $cookies.remove('userDetails');
                $state.go('login');
            });

        };

        $scope.loadDashboardData = function(userData) {

            if (userData.role === "Learner") {

                $rootScope.templateUrl = '';
                var ref = FirebaseService.ref.child("/lp").child(userData.uid).child(userData.lpId);

                ref.once('value', function(dataSnapshot) {
                    var mainObj = dataSnapshot.val();
                    DataCache.saveGlobalData("summary", mainObj.summary);
                    DataCache.saveGlobalData("details", mainObj.details);
                    DataCache.saveLpDetails('active',  Object.assign(mainObj));
                    DataCache.saveGlobalData('lpid', userData.lpId);
                    DataCache.saveLpDetails('currentLp', 'active');
                    $window.setData(mainObj);
                    $rootScope.firebaseLoaded = true;
                    $rootScope.loginProcessing = false;

                    if (userData.isVisited == 'Y' && userData.isNewLP == "N") {
                        $rootScope.firstTimeLogin = false;
                        $rootScope.headerShow = true;
                        $rootScope.scndHdr = true;
                        //$timeout(function() {
                        $state.go('home.dashboard');
                        //}, 100);

                    } else if (userData.isVisited == "Y" && userData.isNewLP == "Y") {
                        $state.go('welcome');
                    } else {
                        var setup = DataCache.returnData("setup-complete");
                        if (setup == true) {
                            $state.go('welcome');
                        } else {
                            $state.go('setup');
                        }
                    }
                }, function(lpFetchError) {
                    console.error("Error in fetching lp data for user");
                    $rootScope.loginProcessing = false;
                    localStorage.clear();
                    sessionStorage.clear();
                    $cookies.remove('userDetails');
                    $state.go('login', { reload: 'login', inherit: false, notify: true });
                    console.error(lpFetchError);
                });
                $scope.firebaseWatch(userData.uid);
                // var obj = $firebaseObject(ref);
            } else if (userData.role === "L&D Manager" || userData.role === "Manager") {

                $rootScope.bheaderShow = true;
                $rootScope.templateUrl = '';
                //$rootScope.templateUrl='app/Common/Directives/popout/popout.html';
                DataCache.saveGlobalData('templateUrl', $rootScope.templateUrl);
                $cookies.putObject("userDetails", userData);
                //httpInterceptor.setHeader();
                $rootScope.loginProcessing = false;
                $rootScope.showLoadingScreen = true;
                if (userData.fbUsername === "simon.chettiar@nokia.com") {
                    $state.go('ldashboard');
                } else{
                    $state.go('buyer');
                }
            }
        }

        $scope.userData = "";

        $rootScope.$on('cookie-updated', function() {

            var updatedCookie = $cookies.getObject("userDetails");
            updatedCookie.isVisited = 'Y';
            updatedCookie.isNewLP = 'N';

            $cookies.remove('userDetails');
            $cookies.putObject('userDetails', updatedCookie);
        });

        $rootScope.$on('connectToFirebase', function(event, args) {
            try {
                $scope.connectToFirebase(args);
            } catch (e) {
                console.error(e);
            }
        });

        $window.setData = function(lpDataObj) {

            /*
            $scope.summary = mainObj.summary;
            var startDate = moment($scope.summary.expectedStartTime);
            var endDate = moment($scope.summary.expectedEndTime);//moment(startDate, "DD-MM-YYYY").add(lpDaysDuration, 'days');
            $scope.totalTime = Math.ceil( $scope.summary.totalDuration / 60 );
            $scope.noOfWeeks = Math.round(moment(endDate).diff(moment(startDate), 'days', true) / 7 ) ;
            DataCache.saveGlobalData("perWeekHrs",( $scope.summary.totalDuration / $scope.noOfWeeks )) ;
            DataCache.saveGlobalData("totalWeeks",$scope.noOfWeeks) ;

            // current week

            var currentDate = moment(new Date());
            DataCache.saveGlobalData("currentWeek",Math.round(moment(currentDate).diff(moment(startDate), 'days', true) / 7 ) );
            */

            var lpAttr = {};

            lpAttr.modules = [];
            lpAttr.capstones = [];
            lpAttr.allData = [];
            lpAttr.capstone = false;
            lpAttr.capstoneDuration = 0;
            lpDataObj.summary.capstones = [];
            lpDataObj.summary.capstone = false;

            for (var m in lpDataObj.summary.modules)
                if (typeof lpDataObj.summary.modules[m] !== 'undefined') {
                    if (lpDataObj.summary.modules[m]["sequenceId"]) lpAttr.allData.push(lpDataObj.summary.modules[m]);
                    if (lpDataObj.summary.modules[m].type === "Capstone") {
                        lpAttr.capstone = true;
                        lpAttr.capstoneDuration = lpAttr.capstoneDuration + Math.ceil(lpDataObj.summary.modules[m].duration / 60);
                        if (lpDataObj.summary.modules[m]["sequenceId"]) lpAttr.capstones.push(lpDataObj.summary.modules[m]);
                        lpDataObj.summary.capstone = true;
                    } else {
                        if (lpDataObj.summary.modules[m]["sequenceId"]) lpAttr.modules.push(lpDataObj.summary.modules[m]);
                    }

                }

            lpDataObj.summary.modules = lpAttr.modules;
            lpDataObj.summary.capstones = lpAttr.capstones;


            lpAttr.summary = lpDataObj.summary;
            lpAttr.details = lpDataObj.details;

            DataCache.saveGlobalData("summary", lpAttr.summary);
            //DataCache.saveGlobalData("summary", lpAttr);

            var lpTotalPointsReminder = (lpAttr.summary.totalPoints % 50);
            lpAttr.summary.totalPoints = lpAttr.summary.totalPoints + (50 - lpTotalPointsReminder);
            lpAttr.lpDuration = lpDataObj.summary.totalDuration;
            lpAttr.lpExpStartDate = moment(lpDataObj.summary.expectedStartTime);
            lpAttr.lpExpEndDate = moment(lpDataObj.summary.expectedEndTime);
            lpAttr.lpStartsOn = moment(lpDataObj.summary.expectedStartTime).format("Do MMMM YYYY");
            lpAttr.lpEndsOn = moment(lpDataObj.summary.expectedEndTime).format("Do MMMM YYYY");

            lpAttr.noOfActualMonths = lpAttr.lpExpEndDate.diff(lpAttr.lpExpStartDate, "months");
            lpAttr.noOfMonths = lpAttr.lpExpEndDate.diff(lpAttr.lpExpStartDate, "months") + 1;
            lpAttr.noOfWeeks = lpAttr.lpExpEndDate.diff(lpAttr.lpExpStartDate, "weeks");
            lpAttr.noOfDays = lpAttr.lpExpEndDate.diff(lpAttr.lpExpStartDate, "days") + 1;

            lpAttr.lpPerWeekDuration = (lpAttr.lpDuration / lpAttr.noOfWeeks);
            lpAttr.lpPerDayDuration = (lpAttr.lpDuration / lpAttr.noOfDays);
            lpAttr.lpDayDurationHrs = Math.ceil(lpAttr.lpDuration / 60);

            var dateDayNumberMap = [];
            var dayNumberDateMap = [];

            dayNumberDateMap.push(lpAttr.lpExpStartDate);
            dateDayNumberMap[lpAttr.lpExpStartDate.format("YYYY-MM-DD")] = 1;

            for (var d = 1; d < lpAttr.noOfDays; d++) {
                var newDate = lpAttr.lpExpStartDate;
                var newDate = newDate.add(1, "days").format("YYYY-MM-DD");
                dayNumberDateMap.push(newDate);
                dateDayNumberMap[newDate] = dayNumberDateMap.length;
            }

            lpAttr.currentDate = moment().format("YYYY-MM-DD");
            lpAttr.currentDayNumber = dateDayNumberMap[lpAttr.currentDate];
            lpAttr.currentWeekNumber = Math.ceil(lpAttr.currentDayNumber / 7);
            var noOfWeeks = lpAttr.noOfWeeks - lpAttr.currentWeekNumber;
            lpAttr.weeksLeft = isNaN(noOfWeeks) ? 0 : noOfWeeks;
            lpAttr.expectedCompletionPerct = Math.ceil(lpAttr.currentDayNumber * 100 / lpAttr.noOfDays);


            lpAttr.actualProgress = Math.ceil(lpDataObj.summary.progress);

            // if ( lpAttr.expectedCompletionPerct > lpAttr.actualProgress)
            // {
            //     lpAttr.trackProgressMessage = "You should be at " + lpAttr.expectedCompletionPerct +"%";
            //     if (lpDataObj.summary.progressMessage === '')
            //     {
            //         if ( (lpAttr.expectedCompletionPerct - lpAttr.actualProgress) >= 20)
            //             lpAttr.lpProgressMessage = "Need to push yourself hard!!!";
            //         else
            //             lpAttr.lpProgressMessage = "You are doing good, Need to buckle up!";
            //     }
            // }
            // else
            // {
            //     lpAttr.trackProgressMessage = "You are " + (lpAttr.actualProgress - lpAttr.expectedCompletionPerct) + "% ahead of schedule";
            //     if (lpDataObj.summary.progressMessage === '')
            //         lpAttr.lpProgressMessage = "You are doing good, Keep it Up!";
            // }
            DataCache.saveGlobalData('lpAttr', lpAttr);
            //DataCache.saveGlobalData('$rootScope',$rootScope);

            var totalDaysCovered = 0;
            var totalWeeksCovered = 0;
            var finalModules = [];
            for (var i in lpAttr.modules) {
                var module = lpAttr.modules[i];

                var moduleWeeks = module.duration / lpAttr.lpPerWeekDuration;
                // if(moduleWeeks === 0){
                //     moduleWeeks = 1;
                // }
                totalWeeksCovered = totalWeeksCovered + moduleWeeks;

                var moduleDays = Math.round(module.duration / lpAttr.lpPerDayDuration);
                totalDaysCovered = totalDaysCovered + moduleDays;

                var expectedEndDate = dayNumberDateMap[totalDaysCovered - 1];
                var expectedEndWeek = totalWeeksCovered;
                var widthPercentByWeek = moduleWeeks * 100 / lpAttr.noOfWeeks;
                // if (widthPercentByWeek < 3)
                //     widthPercentByWeek = 5;
                var widthPercentByDay = moduleDays * 100 / lpAttr.noOfDays;

                module.expectedEndDate = moment(expectedEndDate).format('Do MMM YYYY');
                module.expectedEndWeek = expectedEndWeek;
                module.widthPercentByWeek = widthPercentByWeek;
                module.widthPercentByDay = widthPercentByDay;
                finalModules.push(module);
            }
            lpAttr.finalModules = finalModules;
            $rootScope.newLpAttr = lpAttr;
            DataCache.saveGlobalData("lpAttr", lpAttr);
            $rootScope.$broadcast('progress-updated');
        };


        if (DataCache.returnData("userData")) {
            $scope.userDetails = DataCache.returnData("userData");
            var users;
            if ($scope.userDetails.hasOwnProperty('auth')) {
                users = $scope.userDetails.auth.role;
            } else {
                users = $scope.userDetails.role;
            }
            if (users === 'Learner') {
                $scope.firebaseWatch(DataCache.returnData("userData").uid);
                $rootScope.templateUrl = '';
                DataCache.saveRootScopeData('templateUrl', $rootScope.templateUrl);
            } else {
                $rootScope.templateUrl = 'app/Common/Directives/popout/popout.html';
                DataCache.saveRootScopeData('templateUrl', $rootScope.templateUrl);
            }
        }



        $rootScope.modelParent = {};
        $rootScope.popoutShow = false;


        $scope.isMobilePhoneDevice = DeviceDetector.checkDevice() === 'small';
        $scope.isMediumScrennDevice = DeviceDetector.checkDevice() === 'medium';
        $scope.isLandscape = DeviceDetector.isLandscape();
        $scope.isIphoneDevice = DeviceDetector.isIphone();
        $scope.isIpadDevice = DeviceDetector.isIpad();
        $scope.isIOSPortableDevice = DeviceDetector.isIphone() || DeviceDetector.isIpad();

        var currentState, prevState;

        $scope.getDepMessage = function(moduleMap) {
            var depMessage = [];
            for (var e in moduleMap)
                depMessage.push(moduleMap[e]);
            return depMessage.join(',');
        }

        $scope.launchCapstone = function(module) {
            try {
                var user_data = DataCache.returnData('userData');
                $http.defaults.headers.common['Authorization'] = "Bearer " + user_data.jwttoken;
                $http.defaults.headers.common['Content-Type'] = "application/x-www-form-urlencoded";
                $scope.details = DataCache.returnData('details');
                if (module.status == 'Completed' || module.status == 'Finished') {
                    return;
                }
                var id = module.moduleId;
                var userData = DataCache.returnData("userDetails");
                var payload = {
                    'Resource': $scope.details[id][1].metaData.resourceId,
                    'CapstoneId': $scope.details[id][1].id,
                    'moduleId': id,
                    'sequenceId' : module.sequenceId
                };
                fetchData.authessTest(payload).then(function(response) {
                    response.data.roles = "Instructor";
                    $scope.payload2 = {
                        'lis_person_name_full': response.data.lis_person_name_full,
                        'lti_version': response.data.lti_version,
                        'lti_message_type': response.data.lti_message_type,
                        'oauth_consumer_key': response.data.oauth_consumer_key,
                        'oauth_nonce': response.data.oauth_nonce,
                        'oauth_signature': response.data.oauth_signature,
                        'oauth_signature_method': response.data.oauth_signature_method,
                        'oauth_timestamp': response.data.oauth_timestamp,
                        'oauth_version': response.data.oauth_version,
                        'resource_link_id': response.data.resource_link_id,
                        'lis_outcome_service_url': response.data.lis_outcome_service_url,
                        'lis_result_sourcedid': response.data.lis_result_sourcedid,
                        'roles': response.data.roles,
                        'user_id': response.data.user_id
                    }
                    $scope.authorized = true;
                    $timeout(function() {
                        document.getElementById("ltiform").submit();
                    }, 100);
                });
            } catch (e) {
                console.error(e);
            }
        }


        $scope.startVideo = function(thisModule) {


            $scope.lpData = DataCache.returnData("summary");

            $rootScope.dependencies = [];
            for (var dependency in thisModule.dependency) {
                if (thisModule.dependency[dependency])
                    $rootScope.dependencies[dependency] = thisModule.dependency[dependency];
            }

            var moduleSeqMap = [];

            for (var i = 1; i < $scope.lpData.modules.length; i++) {
                if ($scope.lpData.modules[i].status !== 'Completed' && $rootScope.dependencies[$scope.lpData.modules[i].moduleId]) {
                    $scope.completedModulesNum++;
                    moduleSeqMap[$scope.lpData.modules[i].moduleId] = $scope.lpData.modules[i].sequenceId;
                }
            }

            var totalModuleSeqMap = [];
            for (var i = 1; i < $scope.lpData.modules.length; i++) {
                totalModuleSeqMap[$scope.lpData.modules[i].moduleId] = $scope.lpData.modules[i].sequenceId;
            }
            $rootScope.locked = false;

            $rootScope.message = " ";

            if (thisModule.dependency) {
                // for(var dependent in $rootScope.dependencies){
                // locked = true;
                for (var moduleMap in moduleSeqMap) {
                    // if (moduleMap === dependent){
                    $rootScope.locked = true;
                    $rootScope.message += "" + $scope.getDepMessage(moduleSeqMap) + " ";
                    break;
                    // }
                }
                // }
                if ($rootScope.locked === true) {
                    $rootScope.$broadcast('module-popout-initiated');
                    return;
                }
            }




            $rootScope.dashArrow = false;
            DataCache.saveGlobalData('thisModuleData', thisModule);

            // if($rootScope.currentSequenceId === undefined){
            //     $rootScope.currentSequenceId =  DataCache.returnData( 'currentSequenceId' );
            // }
            //
            // if($rootScope.currentResourceId === undefined){
            //     $rootScope.currentResourceId = DataCache.returnData('currentResourceId');
            // }

            var currentResourceType = "";

            if (thisModule.currentResource !== "") {
                $scope.details = DataCache.returnData('details');
                thisModule.current_resource = $scope.details[thisModule.moduleId][thisModule.currentResource];
                currentResourceType = thisModule.current_resource.type;
            }

            $scope.details = DataCache.returnData("details");
            $scope.moduleDetailData = $scope.details[thisModule.moduleId];
            DataCache.saveGlobalData('thisModuleDetails', $scope.moduleDetailData);


            if (screen.width < 1025) {
                $rootScope.scndHdr = true;
                $state.go('home.playlist');
            } else if (screen.width > 1025 && currentResourceType && currentResourceType !== "") {
                $scope.navStateSelector(currentResourceType);
            } else if (screen.width > 1025 && (!currentResourceType || currentResourceType === "") && $scope.moduleDetailData) {
                $scope.navStateSelector($scope.moduleDetailData[1].type);
            }

            // fetchData.fetchModuleDetails( ).then( function ( response ) {
            //     $scope.moduleDetailData = response.module_resources;
            //     DataCache.saveGlobalData( 'thisModuleDetails', $scope.moduleDetailData );
            //     if ( screen.width < 1025 ) {
            //         $rootScope.scndHdr = true;
            //         $state.go( 'home.playlist' );
            //     } else if ( screen.width > 1025 && currentResource ) {
            //         $scope.navStateSelector( currentResource );
            //     } else if ( screen.width > 1025 && !currentResource ) {
            //         $scope.navStateSelector( $scope.moduleDetailData[ 0 ].type );
            //     }
            // } );
            // var error;

            // if ( error ) {
            //     $rootScope.errorState = true;
            // }
        };

        fetchData.fetchImageService().then(function(response) {
            $rootScope.modelParent.userImage = response.data.displayPic;
        });

        $rootScope.$on('navigateAfterErrorOccurs', function(event, value) {
            $timeout(function() {
                $rootScope.showExceptionPage = false;
                $state.go(value);
            }, 600);
        });
        $rootScope.$on('genericServiceError', function(event, value) {
            if ($rootScope.modelParent.currentState !== 'login') {

                $rootScope.showExceptionPage = true;
                $rootScope.exceptionMessage = value.message || ErrorConstant.GENERIC_ERROR;
            } else {
                $rootScope.loginErrorMessage = value.message;
            }
        });

        $rootScope.$on('logout-initiated', function() {
            DataCache.clearAll();
            $cookies.remove('userDetails');
            // FirebaseService.ref.unauth();
            $state.go('login');
        });

        $scope.$watch(function() {
                return UncaughtErrors.errorPolice();

            },
            function(newVal) {
                if (newVal !== undefined) {
                    // exception Message
                    $scope.errorMsg = UncaughtErrors.delegateMsg();
                    console.error($scope.errorMsg);
                    $scope.$emit('$checkFatalError');
                    //$rootScope.$broadcast('$fatalErrorFound');
                }
            }, false);
        $rootScope.$on('$fatalErrorFound', function() {
            ErrorMessage.showExceptionModal(ErrorConstant.UI_FATAL_ERROR, 'goToDashboard');
        });

        $scope.setBurgerMenuTitle = function() {
            AppConstant.burgeMenuTitles.filter(function(value) {
                value.state.forEach(function(stateList) {
                    if ($rootScope.modelParent.currentState.indexOf(stateList) >= 0) {
                        $rootScope.modelParent.burgerTitle = value.title;
                    }
                });
            });
        };
        $rootScope.$on('$stateChangeStart', function(ev, to, toParams, from) {
            $rootScope.modelParent.previousState = from.name;
            $rootScope.modelParent.currentState = to.name;

            $scope.setBurgerMenuTitle();
        });
        $rootScope.$on('triggerDashboardState', function() {
            $scope.goToDashboard();
        });

        $scope.navStateSelector = function(state) {
            var foundCurrent = false;
            $scope.modulePlaylistItems = DataCache.returnData("thisModuleDetails");
            $scope.lpData = DataCache.returnData("summary");
            // $rootScope.currentSequenceId =  $scope.lpData.modules[$scope.lpData.currentModule].currentResource;

            var thisModule = DataCache.returnData('thisModuleData');

            var moduleSeqMap = [];
            for (var i = 0; i < $scope.lpData.modules.length; i++) {
                moduleSeqMap[$scope.lpData.modules[i].moduleId] = $scope.lpData.modules[i].sequenceId;
            }
            var selectedModuleSeqId = moduleSeqMap[thisModule.moduleId];

            try {
                $rootScope.currentSequenceId = $scope.lpData.modules[selectedModuleSeqId - 1].currentResource;
                DataCache.saveRootScopeData('currentSequenceId', $rootScope.currentSequenceId);
            } catch (e) {
                console.error(e);
            }


            var resourceType = "";

            $scope.modulePlaylistItems = $filter('orderBy')($scope.modulePlaylistItems, 'sequenceId', false);

            $scope.modulePlaylistItems.forEach(function(val, ind) {
                if (val != undefined) {
                    if ($scope.modulePlaylistItems.length !== (ind + 1)) {
                        if (val.sequenceId == $rootScope.currentSequenceId) {
                            $rootScope.currentSequenceId = val.sequenceId;
                            $rootScope.currentResourceId = val.id;
                            $rootScope.currentBcId = val.metaData.bcId;
                            foundCurrent = true;
                            resourceType = val.type;
                        }
                    }
                } else {
                    $scope.modulePlaylistItems.splice(ind, 1);
                }
            });
            if (!foundCurrent) {
                // $rootScope.currentSequenceId = 1;
                // $rootScope.currentResourceId =  $scope.modulePlaylistItems[0].id;
                // $rootScope.currentBcId = $scope.modulePlaylistItems[0].metaData.bcId;
                $rootScope.currentSequenceId = 1;
                $rootScope.currentResourceId = $scope.modulePlaylistItems[0].id;
                $rootScope.currentBcId = $scope.modulePlaylistItems[0].metaData.bcId;
                resourceType = $scope.modulePlaylistItems[0].type;
            }
            //Ravi remove this if type is material default to first video
            // if ( resourceType === 'material' )
            // {
            //   $rootScope.currentSequenceId = 1;
            //   $rootScope.currentResourceId =  $scope.modulePlaylistItems[0].id;
            //   $rootScope.currentBcId = $scope.modulePlaylistItems[0].metaData.bcId;
            //   resourceType = "video";
            // }

            $rootScope.headerShow = true;
            $rootScope.dashArrow = false;
            $rootScope.moduleHeader = true;
            $rootScope.scndHdr = false;


            DataCache.saveRootScopeData("currentResourceId", $rootScope.currentResourceId);

            // if($rootScope.events === undefined){
            //
            //   $rootScope.events=DataCache.returnData("event");
            //
            // }
            var ref = FirebaseService.ref.child($rootScope.events);

            var userData = DataCache.returnData("userDetails");
            $scope.eventObject = {
                "group": "lprogress",
                "type": "lresource",
                "data": {
                    "action": "update",
                    "teamId": userData.teamId,
                    "clientId": userData.clientId,
                    "lpId": userData.lpId,
                    "lpTitle": userData.lpTitle,
                    "token": userData.token,
                    "resourceId": $rootScope.currentResourceId.toString(),
                    "moduleId": thisModule.moduleId.toString(),
                    "moduleSeqId": thisModule.sequenceId.toString(),
                    "resourceSeqId": $rootScope.currentSequenceId.toString(),
                    "timestamp": $filter('date')(new Date(), 'yyyy-MM-dd HH:mm:ss')
                }
            };
            if (DataCache.returnLpData('currentLp') === 'active') {
                ref.push().child(userData.data).set($scope.eventObject);
            }


            switch (state) {
                case 'video':
                    $state.go('home.learn.video');
                    break;
                case 'quiz':
                    $state.go('home.learn.quiz');
                    break;
                case 'csa':
                    $state.go('home.learn.assessment');
                    break;
                case 'material':
                    $state.go('home.learn.resources');
                    break;
                case 'ytc':
                    $state.go('home.learn.ytc');
                    break;
            }
        };



        $scope.goToDashboard = function() {

            $scope.userDetails = DataCache.returnData("userData");

            if ($scope.userDetails.hasOwnProperty('auth')) {
                users = $scope.userDetails.auth.role;
            } else {
                users = $scope.userDetails.role;
            }
            if (users === "Learner") {
                $rootScope.headerShow = true;
                $rootScope.scndHdr = true;
                $rootScope.dashArrow = true;
                $rootScope.moduleHeader = false;
                $state.go('home.dashboard');
            } else if (users === "L&D Manager" || users === "Manager") {
                $state.go('buyer.dashboard.trackProgress');
                //$rootScope.$broadcast('help-close');
            } else {}

        };

        $rootScope.$on('dashboard', function() {

            $rootScope.headerShow = true;
            $rootScope.scndHdr = true;
            $rootScope.dashArrow = true;
            $rootScope.moduleHeader = false;
            $state.go('home.dashboard');
        });

        $scope.goBackToTest = function() {
            $rootScope.showProfTestBar = !$rootScope.showProfTestBar;
            $rootScope.headerShow = true;
            $rootScope.scndHdr = false;
            $rootScope.resumeProfTest = true;
            $scope.ptPaused = false;
            $state.go('home.profTest');
        };

        $scope.goBackToQuiz = function() {
            $rootScope.showProfTestBar = !$rootScope.showProfTestBar;
            $rootScope.headerShow = true;
            $rootScope.scndHdr = false;
            $rootScope.currentSequenceId = $rootScope.quizSequenceId;
            $rootScope.currentResourceId = $rootScope.quizResourceId;
            $scope.quizPaused = false;
            $rootScope.relatedVideo = false;
            $state.go('home.learn.quiz', { sequenceId: $rootScope.quizSequenceId }, { reload: 'home.learn.quiz', inherit: false, notify: true });
            $rootScope.$broadcast('scrollPlaylist');
        }

        $scope.goToLibrary = function() {
            $state.go('home.library');
        };

        $scope.goToLab = function() {
            $state.go('home.jigsawlab');
        };


        $scope.openHelp = function() {
            $rootScope.headerShow = false;
            $rootScope.scndHdr = false;
            $rootScope.libraryState = false;
            $state.go('home.help');
        };

        $scope.buyerfeedback = function() {
            $rootScope.headerShow = false;
            $rootScope.scndHdr = false;
            $rootScope.libraryState = false;
            $state.go('home');
            $rootScope.modelParent.isFeedbackViewActive = true;
            $rootScope.modelParent.bringInFeedback = true;
        };

        $scope.$watch(
            function() {
                return $state.current.name;
            },
            function(newVal, oldVal) {
                currentState = newVal;
                prevState = oldVal;
            }
        );

        $scope.goToPrevState = function() {
            /*if ( prevState && currentState != prevState ) {
                $rootScope.libraryState = false;
                $rootScope.scndHdr = false;
                $state.go( prevState );

            } else {
                $scope.goToDashboard();
            }*/
            $state.go($rootScope.modelParent.previousState);
            // $window.history.back();
        };

        $scope.openClipboard = function() {
            $rootScope.headerShow = true;
            $scope.showDashboard = false;
            $scope.showClipboard = true;
            $rootScope.scndHdr = true;
            $state.go('home.clipboard');

        };

        $rootScope.$on('learner-logout-initiated', function() {

            DataCache.clearAll();
            $cookies.remove('userDetails');
            $state.go('login');
        });



    });
'use strict';
( function() {
    angular
        .module( 'jigsawCorpLms' )
        .config( routerConfig );

    /** @ngInject */
    function routerConfig( $stateProvider ) {
        $stateProvider
            .state( 'home', {
                url: '/home',
                templateUrl: 'app/main/main.html',
                controller: 'MainController'
            } );
    }

} )();

'use strict';
(function() {
    angular
        .module('jigsawCorpLms')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($timeout, $state, $rootScope, $scope, DataCache, $controller, $window, $location) {
        // $scope.showProfTestBar = false;
        $scope.ptPaused = false;
        $scope.quizPaused = false;
        $rootScope.$on('profTestPaused', function() {
            $scope.currentModuleData = DataCache.returnData('thisModuleData');
            $scope.titleMessage = $scope.currentModuleData.pttitle;
            $scope.headMessage = "Ongoing Proficiency Test";
            $scope.ptPaused = true;
            $scope.quizPaused = false;
        });
        $rootScope.$on('quizPaused', function() {
            $scope.lpData = DataCache.returnData('thisModuleDetails');
            $scope.currentModuleData = $scope.lpData[$rootScope.quizSequenceId];
            $scope.titleMessage = $scope.currentModuleData.metaData.title;
            $scope.headMessage = "Ongoing Quiz";
            $scope.ptPaused = false;
            $scope.quizPaused = true;
        });
        angular.extend(this, $controller('rubricGuideCtrl', {
            $scope: $scope
        }));
    }
})();
/*! modernizr 3.0.0 (Custom Build) | MIT *
 * http://modernizr.com/download/?-cssfilters-sessionstorage !*/
! function( e, n, t ) {
    function r( e ) {
        var n = C.className,
            t = Modernizr._config.classPrefix || "";
        if ( w && ( n = n.baseVal ), Modernizr._config.enableJSClass ) {
            var r = new RegExp( "(^|\\s)" + t + "no-js(\\s|$)" );
            n = n.replace( r, "$1" + t + "js$2" )
        }
        Modernizr._config.enableClasses && ( n += " " + t + e.join( " " + t ), w ? C.className.baseVal = n : C.className = n )
    }

    function s() {
        return "function" != typeof n.createElement ? n.createElement( arguments[ 0 ] ) : w ? n.createElementNS.call( n, "http://www.w3.org/2000/svg", arguments[ 0 ] ) : n.createElement.apply( n, arguments )
    }

    function o( e, n ) {
        return typeof e === n
    }

    function i() {
        var e, n, t, r, s, i, a;
        for ( var l in S ) {
            if ( e = [], n = S[ l ], n.name && ( e.push( n.name.toLowerCase() ), n.options && n.options.aliases && n.options.aliases.length ) )
                for ( t = 0; t < n.options.aliases.length; t++ ) e.push( n.options.aliases[ t ].toLowerCase() );
            for ( r = o( n.fn, "function" ) ? n.fn() : n.fn, s = 0; s < e.length; s++ ) i = e[ s ], a = i.split( "." ), 1 === a.length ? Modernizr[ a[ 0 ] ] = r : ( !Modernizr[ a[ 0 ] ] || Modernizr[ a[ 0 ] ] instanceof Boolean || ( Modernizr[ a[ 0 ] ] = new Boolean( Modernizr[ a[ 0 ] ] ) ), Modernizr[ a[ 0 ] ][ a[ 1 ] ] = r ), g.push( ( r ? "" : "no-" ) + a.join( "-" ) )
        }
    }

    function a( e, n ) {
        return function() {
            return e.apply( n, arguments )
        }
    }

    function l( e, n, t ) {
        var r;
        for ( var s in e )
            if ( e[ s ] in n ) return t === !1 ? e[ s ] : ( r = n[ e[ s ] ], o( r, "function" ) ? a( r, t || n ) : r );
        return !1
    }

    function f( e, n ) {
        return !!~( "" + e ).indexOf( n )
    }

    function u( e ) {
        return e.replace( /([a-z])-([a-z])/g, function( e, n, t ) {
            return n + t.toUpperCase()
        } ).replace( /^-/, "" )
    }

    function d( e ) {
        return e.replace( /([A-Z])/g, function( e, n ) {
            return "-" + n.toLowerCase()
        } ).replace( /^ms-/, "-ms-" )
    }

    function p() {
        var e = n.body;
        return e || ( e = s( w ? "svg" : "body" ), e.fake = !0 ), e
    }

    function c( e, t, r, o ) {
        var i, a, l, f, u = "modernizr",
            d = s( "div" ),
            c = p();
        if ( parseInt( r, 10 ) )
            for ( ; r--; ) l = s( "div" ), l.id = o ? o[ r ] : u + ( r + 1 ), d.appendChild( l );
        return i = s( "style" ), i.type = "text/css", i.id = "s" + u, ( c.fake ? c : d ).appendChild( i ), c.appendChild( d ), i.styleSheet ? i.styleSheet.cssText = e : i.appendChild( n.createTextNode( e ) ), d.id = u, c.fake && ( c.style.background = "", c.style.overflow = "hidden", f = C.style.overflow, C.style.overflow = "hidden", C.appendChild( c ) ), a = t( d, e ), c.fake ? ( c.parentNode.removeChild( c ), C.style.overflow = f, C.offsetHeight ) : d.parentNode.removeChild( d ), !!a
    }

    function m( n, r ) {
        var s = n.length;
        if ( "CSS" in e && "supports" in e.CSS ) {
            for ( ; s--; )
                if ( e.CSS.supports( d( n[ s ] ), r ) ) return !0;
            return !1
        }
        if ( "CSSSupportsRule" in e ) {
            for ( var o = []; s--; ) o.push( "(" + d( n[ s ] ) + ":" + r + ")" );
            return o = o.join( " or " ), c( "@supports (" + o + ") { #modernizr { position: absolute; } }", function( e ) {
                return "absolute" == getComputedStyle( e, null ).position
            } )
        }
        return t
    }

    function v( e, n, r, i ) {
        function a() {
            d && ( delete j.style, delete j.modElem )
        }
        if ( i = o( i, "undefined" ) ? !1 : i, !o( r, "undefined" ) ) {
            var l = m( e, r );
            if ( !o( l, "undefined" ) ) return l
        }
        for ( var d, p, c, v, h, y = [ "modernizr", "tspan" ]; !j.style; ) d = !0, j.modElem = s( y.shift() ), j.style = j.modElem.style;
        for ( c = e.length, p = 0; c > p; p++ )
            if ( v = e[ p ], h = j.style[ v ], f( v, "-" ) && ( v = u( v ) ), j.style[ v ] !== t ) {
                if ( i || o( r, "undefined" ) ) return a(), "pfx" == n ? v : !0;
                try {
                    j.style[ v ] = r
                } catch ( g ) {}
                if ( j.style[ v ] != h ) return a(), "pfx" == n ? v : !0
            }
        return a(), !1
    }

    function h( e, n, t, r, s ) {
        var i = e.charAt( 0 ).toUpperCase() + e.slice( 1 ),
            a = ( e + " " + E.join( i + " " ) + i ).split( " " );
        return o( n, "string" ) || o( n, "undefined" ) ? v( a, n, r, s ) : ( a = ( e + " " + P.join( i + " " ) + i ).split( " " ), l( a, n, t ) )
    }

    function y( e, n, r ) {
        return h( e, t, t, n, r )
    }
    var g = [],
        C = n.documentElement,
        S = [],
        _ = {
            _version: "3.0.0",
            _config: {
                classPrefix: "",
                enableClasses: !0,
                enableJSClass: !0,
                usePrefixes: !0
            },
            _q: [],
            on: function( e, n ) {
                var t = this;
                setTimeout( function() {
                    n( t[ e ] )
                }, 0 )
            },
            addTest: function( e, n, t ) {
                S.push( {
                    name: e,
                    fn: n,
                    options: t
                } )
            },
            addAsyncTest: function( e ) {
                S.push( {
                    name: null,
                    fn: e
                } )
            }
        },
        Modernizr = function() {};
    Modernizr.prototype = _, Modernizr = new Modernizr, Modernizr.addTest( "sessionstorage", function() {
        var e = "modernizr";
        try {
            return sessionStorage.setItem( e, e ), sessionStorage.removeItem( e ), !0
        } catch ( n ) {
            return !1
        }
    } );
    var w = "svg" === C.nodeName.toLowerCase(),
        x = "CSS" in e && "supports" in e.CSS,
        b = "supportsCSS" in e;
    Modernizr.addTest( "supports", x || b );
    var z = _._config.usePrefixes ? " -webkit- -moz- -o- -ms- ".split( " " ) : [];
    _._prefixes = z;
    var T = "Moz O ms Webkit",
        E = _._config.usePrefixes ? T.split( " " ) : [];
    _._cssomPrefixes = E;
    var P = _._config.usePrefixes ? T.toLowerCase().split( " " ) : [];
    _._domPrefixes = P;
    var N = {
        elem: s( "modernizr" )
    };
    Modernizr._q.push( function() {
        delete N.elem
    } );
    var j = {
        style: N.elem.style
    };
    Modernizr._q.unshift( function() {
        delete j.style
    } ), _.testAllProps = h, _.testAllProps = y, Modernizr.addTest( "cssfilters", function() {
        if ( Modernizr.supports ) return y( "filter", "blur(2px)" );
        var e = s( "a" );
        return e.style.cssText = z.join( "filter:blur(2px); " ), !!e.style.length && ( n.documentMode === t || n.documentMode > 9 )
    } ), i(), r( g ), delete _.addTest, delete _.addAsyncTest;
    for ( var k = 0; k < Modernizr._q.length; k++ ) Modernizr._q[ k ]();
    e.Modernizr = Modernizr
}( window, document );

/*
 ** lazy-scroll v1.00
 ** (c) shabeeb
 ** mail@shabeebk.com
 * shabeebk.com/blog/lazy-scroll-infinite-scrolling-angularjs
 *
 */
angular.module( "lazy-scroll", [] )
    .directive( 'lazyScroll', [
        '$rootScope',
        '$window',
        function( $rootScope, $window ) {
            return {
                link: function( scope, elem, attrs ) {

                    var scrollEnabled, loadData, scrollTrigger = .90,
                        scrollEnabled = true;;
                    $window = angular.element( $window );
                    var thisElement = angular.element( elem );

                    if ( attrs.lazyNoScroll != null ) {
                        scope.$watch( attrs.lazyNoScroll, function( value ) {
                            scrollEnabled = ( value == true ) ? false : true;
                        } );
                    }

                    if ( ( attrs.lazyScrollTrigger != undefined ) && ( attrs.lazyScrollTrigger > 0 && attrs.lazyScrollTrigger < 100 ) ) {
                        scrollTrigger = attrs.lazyScrollTrigger / 100;
                    }

                    loadData = function() {

                        return scope.$apply( attrs.lazyScroll );

                    };

                    thisElement.on( 'scroll', loadData );
                    scope.$on( '$destroy', function() {
                        return thisElement.off( 'scroll', loadData );
                    } );
                }
            };
        }
    ] );

'use strict';

var errorUtils = angular.module( 'errorUtils', [] );
var HandleExceptions = function( exception ) {
    var errorOb = {};
    var isError = exception instanceof Error;
    errorOb.isError = !!isError;
    errorOb.errorStack = exception.stack || exception.message;
    return errorOb;
};
errorUtils.provider( 'ErrorHandler', function() {
    this.$get = function( exception, UncaughtErrors ) {
        var fnc = new HandleExceptions( exception );
        return UncaughtErrors.handleThem( fnc );

    };
} );
errorUtils.config( function( $provide, ErrorHandlerProvider ) {
    $provide.decorator( '$exceptionHandler', function( $delegate, $injector ) {
        return function( exception ) {
            var errorService = $injector.get( 'UncaughtErrors' );
            errorService.handleThem(exception);
            //ErrorHandlerProvider.$get( exception, errorService );
        };
    } );
} );
errorUtils.factory( 'UncaughtErrors', function($state,$rootScope) {
    var message;
    var lastError;

    return {
        handleThem: function( error ) {
            //SEVENSJS.sendToDev();
            //log a new date and time for every exception
            lastError = new Date();
            if ( error.isError ) {
                message = error.errorStack;
                return message;
            }
            $rootScope.showLoadingScreen = false;
            $state.go('login');
        }, //method to return error constant to a modal
        delegateMsg: function() {
            return message;
        }, //method used by a watcher.
        errorPolice: function() {
            return lastError;
        }
    };
} );

//Handles all known errors
errorUtils.factory( 'ErrorFactory', function() {
    return {
        catchError: function( err ) {
            var errUnknown = 'We dont know what happened';
            //if error message is not known, show message with and ID that we can identify as'
            //'we requested an error message that does not exist'
            var message = err.message || errUnknown;
            //handle DOM Errors here
            return message;
        }
    };
} );

//DEFINE ERRORS HERE
errorUtils.constant( 'ErrorConstant', {
    GENERIC_ERROR: 'Your request cannot be completed at the moment due to a technical error',
    UI_FATAL_ERROR: 'We got an unexpected error'
} );

'use strict';
(function() {
  angular
    .module('jigsawCorpLms')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log) {

    $log.debug('runBlock end');
  }

})();

'use strict';
(function() {
    angular
        .module('jigsawCorpLms')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider, $urlRouterProvider) {
        /*$stateProvider
            .state( 'home', {
                url: '/',
                templateUrl: 'app/main/main.html',
                controller: 'MainController'
            } );*/
        /*var urlMatcher = $urlMatcherFactory.compile( '/loginType?firstTime' );
        console.log( urlMatcher );*/
        // console.log($urlRouterProvider.rule);

        $urlRouterProvider.when(/firstTime/i, function($location, $state) {
            $state.go('welcome');
        });
        $urlRouterProvider.when('/resetpassword?token', function($location, $state) {
            $state.go('resetpassword');
        });
        $urlRouterProvider.when(/home/i, function($location, $state) {
            $state.go('login');
        });
        $urlRouterProvider.when('/authess', function($location, $state) {
            $state.go('login');
        });
        $urlRouterProvider.when('*', function($location, $state) {
            $state.go('login');
        });
        $urlRouterProvider.when('/', function($location, $state) {
            $state.go('login');
        });
        $urlRouterProvider.otherwise(function($injector) {
            var state = $injector.get('$state');
            state.go('login');
        });
    }

})();
 'use strict';
 ( function() {
     angular
         .module( 'jigsawCorpLms' )
         .constant( 'moment', moment );
 } )();

'use strict';
( function() {
    angular
        .module( 'jigsawCorpLms' )
        .config( function( uiSelectConfig ) {
            uiSelectConfig.theme = 'select2';
            uiSelectConfig.resetSearchInput = true;
            Raven.config('https://8236df96ac22412898b6464877f36b63@sentry.io/127607').install();
        } );
} )();

angular.module("jigsawCorpLms").run(["$templateCache", function($templateCache) {$templateCache.put("app/components/DropDown/DropDown.html"," ");
$templateCache.put("app/main/main.html"," <header></header> <bheader></bheader> <div ui-view=\"\"></div> <popout></popout> <div ng-if=\"showProfTestBar\" class=\"prof-test-bottom-menu-section clearfix\"> <image src=\"../assets/Icons/Alert_icon.svg\" style=\"width: 3em;\" class=\"left\"></image> <div class=\"prof-test-timer-footer-title left\"> <div class=\"head\">{{headMessage}}</div> <div style=\"padding-top: 0.5em;\" class=\"title\">{{titleMessage}}</div> </div> <button ng-click=\"goBackToTest()\" ng-if=\"ptPaused\" style=\"padding: 1% 2%;\" class=\"primary_btn table-cell right remove-focus\"><span class=\"text\">GO BACK TO TEST</span></button> <button ng-click=\"goBackToQuiz()\" ng-if=\"quizPaused\" style=\"padding: 1% 2%;\" class=\"primary_btn table-cell right remove-focus\"><span class=\"text\">GO BACK TO Quiz</span></button> </div> <div ng-include=\"\" src=\"\'app/Features/bookmarks/bookmarks.html\'\" ng-if=\"modelParent.bringInBookmarks\" class=\"bookmark-overlay\"></div> <div ng-include=\"\" src=\"\'app/Features/feedback/feedback.html\'\" ng-if=\"modelParent.bringInFeedback\" class=\"feedback-overlay\"></div> <div ng-include=\"\" src=\"\'app/Common/Directives/popout/popout.html\'\" ng-if=\"modelParent.bringInPopOut\" class=\"popout-overlay\"></div> <div ng-include=\"\" src=\"\'app/Features/reportAnIssue/reportAnIssue.html\'\" ng-if=\"modelParent.bringInReportAnIssue\" class=\"report-an-issue-overlay\"></div> <div ng-include=\"\" src=\"\'app/Features/notifications/notifications.html\'\" ng-if=\"modelParent.bringInNotifications &amp;&amp; isMobilePhoneDevice\" class=\"notifications-main-overlay\"></div>");
$templateCache.put("app/Features/JigsawLab/jigsawLab.html"," <div ng-show=\"showLabInfoPage\" ng-hints-method=\"startHint\" ng-intro-options=\"IntroOptions\" ng-intro-method=\"CallMe\" ng-intro-oncomplete=\"CompletedEvent\" ng-intro-onexit=\"ExitEvent\" ng-intro-onchange=\"ChangeEvent\" ng-intro-onbeforechange=\"BeforeChangeEvent\" ng-intro-onafterchange=\"AfterChangeEvent\" ng-intro-autostart=\"ShouldAutoStart\" class=\"jigsawlab body\"> <div class=\"jigsawlab-container\"> <div class=\"jigsawlab-content\"> <div class=\"jigsawlab-content-head\"> <div class=\"jigsawlab-text heading\"><span>Welcome to Jigsaw Lab</span></div> <div class=\"jigsawlab-text discription-content\"><span>Access practice material, data sets to improve your skills.</span></div> </div> <div class=\"jigsawlab-content-body\"> <div style=\"font-size:14px;padding-top:10%\" class=\"jigsawlab-text heading\"><span>Your temporary password</span></div> <div style=\"margin-left: 8%;padding: 2%;border: 1px solid black;width:64%\" class=\"jigsawlab-password-box\"><span style=\"font-size: 15px;font-family: Montserrat;\">{{labPassword}}</span></div> </div> <div style=\"padding:6% 8%\" class=\"jigsawlab-button\"> <div ng-click=\"loadLab();\" class=\"lg-submit-button-con\"> <button style=\"padding: 3% 22%;font-size: 14px;\" class=\"primary_btn table-cell remove-focus\"><span class=\"text\">Copy and Login</span></button> </div> </div> </div> </div> <div class=\"jigsawlab-page-footer\"><span style=\"font-family: montserrat;font-weight: 500;color:#3696ed\">How does jigsaw lab work?</span></div> </div> <div ng-show=\"launchLab\" style=\"height:92vh;width:100%\" class=\"jigsawLab-frame\"> <iframe style=\"height:100%;min-height: 100%\" width=\"100%\" scrolling=\"no\" frameborder=\"no\" class=\"lab-iframe\"></iframe> </div>");
$templateCache.put("app/Features/allLps/allLps.html"," <div class=\"allLps\"> <div ng-if=\"DoesLpsExist()\" class=\"title\">OLD LEARNING PATHS</div><loading-state ng-show=\"!isDataFetched\"></loading-state> <div ng-if=\"DoesLpsExist()\" class=\"lps\"> <div ng-repeat=\"lp in prevLps\" ng-click=\"changeLp(lp.lpId)\" class=\"lp-box col-xs6 col-md3 lp-bg-img d-flex\"> <div class=\"top\"> <div class=\"box-text\">{{lp.displayTitle}}</div> <div class=\"star\"><span class=\"icon-star\"></span><span class=\"star-text\">&nbsp;&nbsp;{{lp.pointsEarned}}</span></div> </div> <div class=\"bottom\"> <div class=\"button-bar d-flex\"><span class=\"left-d\">Archived on {{FormatDate(lp.lpActualEndDate)}} </span><span ng-click=\"changeLp(lp.lpId)\" class=\"right-d\">VIEW</span></div> <div style=\"width:{{lp.progress}}%\" class=\"progress-bar\"></div> <div style=\"left:{{lp.progress}}%\" class=\"progress-icon\"><img src=\"../../../assets/images/Man.png\"></div> </div> </div> </div> <div ng-if=\"!DoesLpsExist()\" ng-show=\"isDataFetched\" class=\"no-lps\"> <h2>No Old Learning Paths Yet.</h2> <div class=\"span-div\"><span>Once you complete a learning path, you can access it here for reference.</span> </div><img src=\"../../../assets/images/no-lps.png\"> </div> <div ng-click=\"showCurrentLp()\" class=\"active-lp-container\"><span class=\"icon-back\"></span><span class=\"active-lp\">BACK TO ACTIVE LEARNING PATH</span></div> </div>");
$templateCache.put("app/Features/audioPlayer/audioPlayer.html"," <div class=\"vid-player-mob-hdng-wrp hide-in-tablet-up\"> <div ng-click=\"goToPlaylist();$event.stopPropagation();\" class=\"vid-player-mob-hdng-back remove-focus\"><span class=\"icon-back\"></span></div> <div class=\"vid-player-mob-hdng\"><span class=\"vid-play-mob-txt-no\">{{activeModule.sequence_id}}.</span><span class=\"vid-play-mob-txt\">{{activeModule.title}}</span></div> </div> <div class=\"aud-play-wrp\"> <div class=\"aud-play-info-wrp\"> <div ng-click=\"bookmarkAudio();$event.stopPropagation();\" class=\"aud-bookmark-wrp remove-focus\"><span ng-class=\"{\'active\': bookmarked}\" class=\"icon-bookmark\"></span></div> <div class=\"aud-title\"><span>{{activeItem.data.title}}</span></div> <div class=\"aud-time-wrp\"> <div class=\"icon icon-clock\"></div> <div class=\"txt\"> <span>{{activeItem.duration_completed | transcriptTime}} / {{activeItem.total_time_taken | transcriptTime}} </span></div> </div> </div> <div class=\"aud-player-wrp\"> <videogular vg-player-ready=\"onPlayerReady($API)\" vg-update-state=\"onUpdateState($state)\" class=\"videogular-container audio relative\"> <vg-media vg-src=\"audioConfig.sources\" vg-type=\"audio\"></vg-media> <vg-controls> <vg-scrub-bar> <seek-bar></seek-bar> </vg-scrub-bar> </vg-controls> <div class=\"aud-player-time-wrp table full-width\"> <div class=\"time text-left table-cell\">{{ API.currentTime | timeFormat}} </div> <div class=\"time text-right table-cell\"> {{ API.totalTime | timeFormat}}</div> </div> <div class=\"aud-player-cntrl-wrp\"> <rewind-ten></rewind-ten> <div class=\"audio-rewind\"> <div ng-click=\"playPrevItem()\" class=\"icon icon-previousvideo\"></div> </div> <div class=\"audio-rewind\"> <div ng-click=\"API.playPause()\" ng-class=\"playPauseIcon\" class=\"icon\"></div> </div> <div class=\"audio-rewind\"> <div ng-click=\"playNextItem()\" class=\"icon icon-nextvideo\"></div> </div> <div class=\"audio-menu\"> <div class=\"icon icon-menu\"> </div> </div> </div> <div class=\"aud-player-video\"> <div ng-click=\"goToVideoPlayer()\" class=\"txt\">Watch Video </div> </div> </videogular> </div> </div>");
$templateCache.put("app/Features/authess/authess.html"," <div class=\"header row\"> <div class=\"header-left-logo-wrp columns large-3 medium-2\"></div> <div class=\"header-logo-img\"></div> </div> <div class=\"authess-form-container\"><span class=\"heading\">Capstone Project Demo</span> <form name=\"form\" ng-submit=\"getAuthParams()\" class=\"Form-style\"> <input name=\"UID\" type=\"text\" placeholder=\"Username\" ng-model=\"parentObj.theUID\" required=\"\"> <input name=\"Name\" type=\"text\" placeholder=\"Full Name\" ng-model=\"parentObj.theName\" required=\"\"> <button class=\"but-style\"><span class=\"text\">Launch test</span></button> </form> <form id=\"ltiform\" target=\"_blank\" method=\"POST\" action=\"https://jigsaw.authess.com/auth/lti\" enctype=\"application/x-www-form-urlencoded\" ng-if=\"authorized\"> <input type=\"hidden\" name=\"lti_version\" value=\"LTI-1p0\"> <input type=\"hidden\" name=\"oauth_nonce\" value=\"{{payload2.oauth_nonce}}\"> <input type=\"hidden\" name=\"oauth_signature\" value=\"{{payload2.oauth_signature}}\"> <input type=\"hidden\" name=\"user_id\" value=\"{{payload2.user_id}}\"> <input type=\"hidden\" name=\"lti_message_type\" value=\"{{payload2.lti_message_type}}\"> <input type=\"hidden\" name=\"oauth_consumer_key\" value=\"{{payload2.oauth_consumer_key}}\"> <input type=\"hidden\" name=\"resource_link_id\" value=\"{{payload2.resource_link_id}}\"> <input type=\"hidden\" name=\"lis_outcome_service_url\" value=\"{{payload2.lis_outcome_service_url}}\"> <input type=\"hidden\" name=\"lis_result_sourcedid\" value=\"{{payload2.lis_result_sourcedid}}\"> <input type=\"hidden\" name=\"oauth_signature_method\" value=\"{{payload2.oauth_signature_method}}\"> <input type=\"hidden\" name=\"oauth_timestamp\" value=\"{{payload2.oauth_timestamp}}\"> <input type=\"hidden\" name=\"oauth_version\" value=\"{{payload2.oauth_version}}\"> <input type=\"hidden\" name=\"lis_person_name_full\" value=\"{{payload2.lis_person_name_full}}\"> </form> </div> <iframe name=\"my_iframe\" ng-if=\"authorized\" class=\"myFrame\"></iframe>");
$templateCache.put("app/Features/bookmarks/bookmarks.html"," <div ng-controller=\"BookmarksCtrl\" ng-class=\"{\'start-cards-show\':modelParent.isBookmarksActive, \'stop-cards-show\':!modelParent.isBookmarksActive}\" class=\"bookmarks-container\"> <div class=\"bookmarks-header relative\"> <div class=\"logo-con absolute hide-for-small\"> <div class=\"logo-bg-wrap table-cell\"> <div class=\"logo-bg\"></div> </div> </div> <div class=\"page-title inline-block\"> <div class=\"page-title-text\">Bookmarks</div> </div> <div ng-click=\"closeBookmarksCard();\" class=\"close-btn-con absolute\"><span class=\"icon-close\"></span></div> </div> <div class=\"bookmarks-body\"> <div class=\"bk-nav-pane-con relative\"> <div class=\"bk-nav-panel inline-block\"> <div ng-init=\"thisIndex = 0; selectedTabText = \'videos\'\" class=\"bk-nav-panel-wrap table\"> <div ng-repeat=\"navItems in topNavPanel\" ng-class=\"{\'is-active\':$index===thisIndex}\" ng-click=\"selectedTab(navItems,$index);\" class=\"bk-each-nav-item remove-focus table-cell\"><span class=\"icon-nav-panel {{navItems.iconClass}}\"></span><span class=\"text-nav-panel\">{{navItems.title}}</span></div> </div> </div> <div ng-click=\"showFilterOptions = !showFilterOptions\" class=\"bk-filter-con absolute\"> <div class=\"bk-filter-icon icon-filter\"></div> <div ng-if=\"showFilterOptions\" ng-click=\"$event.stopPropagation();\" class=\"bk-arrow-box-con absolute\"> <div class=\"bk-arrow-box\"> <div class=\"each-filter-type\"> <div class=\"bk-chkbox-con inline-block\"> <input type=\"checkbox\" id=\"allFilter\" checked=\"parentObject.modelForAll\" ng-model=\"parentObject.modelForAll\"> <label for=\"allFilter\" ng-class=\"{&quot;icon-checkbox_inactive&quot;:!parentObject.modelForAll,&quot;icon-checkbox_selected&quot;:parentObject.modelForAll}\" class=\"label-checkbox\"></label><span class=\"label-text\">All</span> </div> </div> <div class=\"each-filter-type\"> <div class=\"bk-chkbox-con inline-block\"> <input type=\"checkbox\" id=\"lpFilter\" checked=\"parentObject.modelForLP\" ng-model=\"parentObject.modelForLP\"> <label for=\"lpFilter\" ng-class=\"{&quot;icon-checkbox_inactive&quot;:!parentObject.modelForLP,&quot;icon-checkbox_selected&quot;:parentObject.modelForLP}\" class=\"label-checkbox\"></label><span class=\"label-text\">LEARNING PATH</span> </div> </div> <div class=\"each-filter-type\"> <div class=\"bk-chkbox-con inline-block\"> <input type=\"checkbox\" id=\"libraryFilter\" checked=\"parentObject.modelForLibrary\" ng-model=\"parentObject.modelForLibrary\"> <label for=\"libraryFilter\" ng-class=\"{&quot;icon-checkbox_inactive&quot;:!parentObject.modelForLibrary,&quot;icon-checkbox_selected&quot;:parentObject.modelForLibrary}\" class=\"label-checkbox\"></label><span class=\"label-text\">LIBRARY</span> </div> </div> </div> </div> </div> </div> <div class=\"bk-contents\"> <div class=\"bk-title\">BOOKMARKED {{selectedTabText}}</div> <div class=\"bk-content-wrap\"> <div ng-repeat=\"item in bookmarkedItems\" ng-click=\"navigateToSelected();\" ng-if=\"(parentObject.modelForLP &amp;&amp; item.category===\'learning path\') || (parentObject.modelForLibrary &amp;&amp; item.category===\'library\') || parentObject.modelForAll\" class=\"bk-each-content\"> <div class=\"bk-each-content-in-wrap table\"> <div ng-click=\"$event.stopPropagation(); item.isSelected = !item.isSelected\" title=\"Remove this bookmark\" class=\"left-icon-con table-cell relative\"><span class=\"icon-bookmark\"></span> <div ng-if=\"item.isSelected\" ng-click=\"$event.stopPropagation(); removeThisBookmark(item);\" class=\"bk-each-arrow-box-con absolute\"> <div class=\"bk-each-arrow-box\">Remove this bookmark</div> </div> </div> <div class=\"text-con table-cell\"> <div class=\"each-title-text\">{{item.title}}</div> <div class=\"each-semi-title-text-con\"> <div class=\"each-semi-title-text inline-block left-side\">{{item.learningPath}}</div> <div class=\"each-semi-title-text inline-block right-side\">| {{item.date| date:\'dd MMM yyyy\'}}</div> </div> </div> </div> </div> </div> </div> </div> </div>");
$templateCache.put("app/Features/buyerJourney/buyerJourney.html"," <div class=\"header-section-buyer\"> <bheader></bheader> </div> <popout></popout> <div ng-init=\"applySchema();\" class=\"clearfix\"> <div ng-show=\"bJourneyObj.navBarShow\" style=\"padding-top:50px\" scroll-to-top=\"\" ng-init=\"showOption=false\" ng-class=\"{min:boolChangeClass}\" class=\"bnavigation-bar-wrp left\"> <div class=\"setup-profile-image-con relative\"> <div id=\"setupProfileImage\" style=\"background-size:100% 100% !important\" class=\"setup-profile-image\"></div> </div> <div class=\"upload-avatar-wrp\"> <div class=\"upload-image table\"> <label ng-click=\"parentObj.uploadAvatar=true\" class=\"table-cell remove-focus\"><span class=\"icon-notes\"></span></label> </div> </div> <div ng-click=\"showOption=!showOption\" class=\"buser-manager-wrp relative table remove-focus\"> </div> <div class=\"buser-info-wrp\"> <div style=\"padding-top:20px\" class=\"buser-name table\"> <div class=\"table-cell\">{{bJourneyObj.user.firstname}}</div> </div> <div class=\"buser-designation\"><span>{{bJourneyObj.user.designation}}</span></div> </div> <div class=\"bnavigation-tiles-wrp\"> <div ng-class=\"{&quot;active&quot;:bJourneyObj.activeTab === &quot;dashboard&quot; &amp;&amp; bJourneyObj.currentTab === &quot;trackProgress&quot;}\" ng-click=\"activeTabFunc(&quot;dashboard&quot;);goToDashboard();trackProgressTab()\" class=\"bnavigation-tiles table remove-focus\"><span ng-show=\"bJourneyObj.activeTab === &quot;dashboard&quot;\" class=\"table-cell\">DASHBOARD</span><span class=\"icon-dashboard table-cell\"></span></div>      </div> </div> <div ui-view=\"\" ng-class=\"{&quot;full-width&quot;:!bJourneyObj.navBarShow,&quot;buyer-right-portion&quot;:bJourneyObj.navBarShow,&quot;right&quot;:bJourneyObj.navBarShow}\" class=\"dashboard-ui-view\"></div> <upload-avatar> <div ng-if=\"tNCOverlay\" class=\"upload-tnc-overlay\"> <div ng-click=\"openClosetNCOverlay()\" class=\"upload-tnc-overlay-close remove-focus\"><span class=\"icon-close\"></span></div> <div class=\"upload-tnc-section\"> <div class=\"upload-tnc-heading\"><span>Terms and Conditions:</span></div> <div class=\"upload-tnc-text\"> <ul> <li>The Intellectual Property disclosure will inform users that your website, logo and visuals and other content you created is your property and protected by copyright laws</li> <li>A Termination clause will inform users that their accounts on your website (or their access to your website, if they don�t have an account) can be terminated in case of abuses</li> <li>A Governing Law informs users which country�s laws governs the agreement. This is the country in which your company is headquartered or the country from which you operate your web site.</li> <li>A Links To Other Web Sites clause informs users that you are not responsible for any third party web sites that you link to from your website, and that users are responsible for reading these third parties� own Terms and Conditions or Privacy Policies.</li> <li>The Intellectual Property disclosure will inform users that your website, logo and visuals and other content you created is your property and protected by copyright laws</li> <li>A Termination clause will inform users that their accounts on your website (or their access to your website, if they don�t have an account) can be terminated in case of abuses</li> <li>A Governing Law informs users which country�s laws governs the agreement. This is the country in which your company is headquartered or the country from which you operate your web site.</li> <li>A Links To Other Web Sites clause informs users that you are not responsible for any third party web sites that you link to from your website, and that users are responsible for reading these third parties� own Terms and Conditions or Privacy Policies.</li> </ul> </div> </div> </div> </upload-avatar> </div>");
$templateCache.put("app/Features/clipboard/clipboard.html"," <div class=\"dash-pg-wrp clipbrd-pg-wrp row\"> <div class=\"dash-pg-select-wrp large-6 medium-8 columns\"> <div title=\"Learning path\" ng-click=\"showPathWrp()\" ng-class=\"{\'active\': showDashboard}\" class=\"dash-select-item-wrp table remove-focus\"> <div ng-show=\"showDashboard ==\'showDashboard\'\" class=\"dash-select-item-txt table-cell\">Path</div> <div class=\"dash-select-item-img table-cell\"><span class=\"icon-path\"></span></div> </div> <div ng-click=\"showClipboardWrp()\" ng-class=\"{\'active\': showClipboard}\" class=\"dash-select-item-wrp table remove-focus\"> <div ng-show=\"showClipboard\" class=\"dash-select-item-txt table-cell\">Clipboard</div> <div class=\"dash-select-item-img table-cell\"><span class=\"icon-clipboard\"></span></div> </div> </div> </div> <div ui-view=\"\"> <div ng-class=\"{\'library-opt\': libActive}\" class=\"clipboard-page-wrp clearfix\"> <div class=\"clipboard-modules-wrp left\"> <div class=\"clipboard-module-head\"><span>List of modules</span></div> <div ng-class=\"{\'scnd-header-active\': scndhdrstate}\" class=\"clipboard-body-wrp\"> <div ng-repeat=\"module in clipboard.clipboardData\" class=\"clipboard-module-body relative\"> <div ng-click=\"currentModuleFunc(module, this.$index)\" class=\"clipboard-module-wrp remove-focus\"> <div ng-init=\"menuOpt = false\" class=\"header-wrp\"> <div class=\"clearfix\"> <div class=\"left\"> <div class=\"module-name\">{{module.title}} </div> </div> <div ng-click=\"menuOpt = !menuOpt;$event.stopPropagation();\" class=\"right remove-focus\"><span ng-class=\"{\'active\': menuOpt}\" class=\"icon-menu\"></span></div> </div> <div class=\"clearfix\"> <div class=\"left\"> <div class=\"items-num\">{{module.clipboard.length}} items</div> </div> <div class=\"right hide-for-small-only\"> <div ng-click=\"goToProfTest(module);$event.stopPropagation();\" class=\"proficiency-test-link remove-focus\"><span>proficiency test</span></div> </div> </div> </div> <div ng-class=\"{\'selected\': selectedIndex == this.$index}\" class=\"options-section\"> <div class=\"options-wrp clearfix\"> <div class=\"topics-option-wrp left remove-focus\"> <div class=\"topics-option table active\"> <div class=\"table-cell\"><span class=\"icon-quiz\"></span><span class=\"text\">Topics</span></div> </div> </div> </div> <div class=\"topics-list-wrp\"> <div ng-repeat=\"topic in module.clipboard | unique : \'title\' | orderBy: \'priority\' | orderBy : \'clipdata.start_time\' | orderBy : \'video_id\'\" class=\"title-wrp\"><span ng-if=\"topic.title != \'bookmark\'\" ng-click=\"scrollToClicked(topic.title);$event.stopPropagation();\" class=\"remove-focus\">{{topic.title}}</span></div> </div> </div> </div> <div class=\"clipboard-modules-no-wrp table absolute\"> <div ng-class=\"{\'completed\': module.status == \'completed\', \'started\': module.status == \'in progress\', \'not-started\': module.status == \'not started\'}\" class=\"clipboard-modules-no table-cell\"><span>{{module.sequence_id | twoDigit}}</span></div> </div> <div ng-show=\"menuOpt\" class=\"clipboard-menu-options absolute\"> <div class=\"clipboard-menu-arrow\"> <div class=\"clipboard-menu-options-item-wrp\"><span>SET REMINDER TO RECAP</span></div> <div class=\"clipboard-menu-options-item-wrp hide-for-small-only\"><span>DOWNLOAD ALL</span></div> <div class=\"clipboard-menu-options-item-wrp\"><span>DELETE</span></div> </div> </div> </div> </div> </div> <div lazy-scroll=\"listData()\" lazy-scroll-trigger=\"40\" lazy-no-scroll=\"false\" scroll=\"\" id=\"clipboardListItems\" ng-include=\"\" src=\"\'app/Features/clipboard/templates/module_items.html\'\" ng-class=\"{\'scnd-header-active\': scndhdrstate}\" class=\"clipboard-items-wrp right desktop relative\"></div> <div ng-click=\"showPathWrp();$event.stopPropagation();\" class=\"clipboard-dash-mobile remove-focus\"><span class=\"icon-home\"></span></div> </div> <div ng-if=\"clipboardEmpty\" class=\"clipboard-empty-state\"> <div class=\"empty-state-wrp\"> <div class=\"gif-wrp\"><img src=\"assets/images/error.gif\"></div> <div class=\"error-msg-wrp\"> <div class=\"notify-msg\">There are no items added to the clipboard</div> <div class=\"start-clip-msg\">Start your clipboard by taking notes, videos etc.</div> <div class=\"learning-link\">learn how to make clipboard</div> </div> <div ng-click=\"goBack()\" class=\"btn-wrp remove-focus\"> <button class=\"primary_btn\"><span>go to dashboard</span></button> </div> </div> </div> </div>");
$templateCache.put("app/Features/dashboard/dashboardIndex.html"," <div ng-hints-method=\"startHint\" ng-intro-options=\"IntroOptions\" ng-intro-method=\"CallMe\" ng-intro-oncomplete=\"CompletedEvent\" ng-intro-onexit=\"ExitEvent\" ng-intro-onchange=\"ChangeEvent\" ng-intro-onbeforechange=\"BeforeChangeEvent\" ng-intro-onafterchange=\"AfterChangeEvent\" ng-intro-autostart=\"ShouldAutoStart\" ng-if=\"!errorState\" ng-click=\"closeTile()\" class=\"dashboard-section\"> <div ng-class=\"{\'library-opt\': libActive}\" class=\"dash-pg-wrp row\"> <div class=\"dash-pg-select-wrp large-6 medium-8 columns\"> <div ng-click=\"showPathWrp()\" ng-class=\"{\'active\': showDashboard}\" style=\"cursor: default;\" class=\"dash-select-item-wrp table remove-focus\"> <div ng-show=\"showDashboard\" class=\"dash-select-item-txt table-cell\">Learning Path</div> <div class=\"dash-select-item-img table-cell\"><span class=\"icon-path\"></span></div> </div> <div class=\"dash-select-item-wrp display-none\"> <div class=\"dash-select-item-img\"><span class=\"icon-forum\"></span></div> </div> </div> </div> <div ng-class=\"{\'library-opt\': libActive}\" class=\"dash-pg-wrp\"> <div class=\"dash-module-details-wrp\"> <div ng-show=\"lpData.currentModule !== \'\'\" class=\"dash-last-play-section\"> <div ng-if=\"lpData.current_module.status == \'In Progress\'\" style=\"cursor: default;\" class=\"dash-last-play-title remove-focus\">Last Played</div> <div ng-click=\"startVideo(lpData.current_module)\" ng-if=\"lpData.current_module.status == \'Not Started\'\" class=\"dash-last-play-title remove-focus\">up next</div> <div class=\"dash-last-play-title-mobile\"><span class=\"icon-analytics\"></span><span class=\"dash-module-mob\">Data Science</span></div> <div class=\"dash-last-play-container\"> <div class=\"dash-last-play-content-wrp\"> <div class=\"learing-path-mob remove-focus\">Last Played</div> <div class=\"dash-last-play-num-wrp\"> <div class=\"dash-last-play-num\"><span>{{lpData.current_module.sequenceId | twoDigit}}</span></div> </div> <div ng-click=\"startVideo(lpData.current_module)\" class=\"dash-last-play-content remove-focus\"> <div class=\"dash-last-play-item-wrp table full-width\"> <div class=\"dash-last-play-item-det-wrp table-cell\"> <div class=\"dash-last-play-det-txt\">{{lpData.current_module.title}} <div class=\"dash-last-play-det-info-wrp relative\"><span style=\"color:#fc792c\" ng-click=\"module.openDiscription = showDesc(module.openDiscription, $event);$event.stopPropagation();\" title=\"Description\" class=\"icon-info\"></span> <div ng-class=\"{&quot;display-none&quot;:!module.openDiscription}\" ng-click=\"$event.stopPropagation();\" class=\"module-list-discription absolute\"> <div ng-class=\"{&quot;discription-box-arrow-mob&quot;:isMobilePhoneDevice}\" class=\"discription-content-wrap relative discription-box-arrow\"> <div ng-click=\"module.openDiscription = false;$event.stopPropagation();\" class=\"close-discription absolute\"><span class=\"icon-close\"></span></div> <div class=\"discription-content\">{{lpData.current_module.description}}</div> </div> </div> </div> </div> </div> <div class=\"dash-last-play-prog-section table-cell\"> <div class=\"dash-last-play-score-wrp clearfix\"><span class=\"icon-star\"></span><span ng-if=\"pData.current_module.ptResult == \'FAIL\'\" title=\"You need to pass the proficiency test in order to complete this module, please contact your manager for retake approval\" class=\"module-test-status icon-warning\"></span> <div class=\"dash-last-play-score clearfix\"><span ng-if=\"lpData.current_module.status == \'In Progress\'\"></span><span>{{lpData.current_module.totalPointsEarned}}</span></div> </div> <div ng-click=\"menuOpt = showMenu(menuOpt, $event);$event.stopPropagation();\" class=\"dash-last-play-menu-wrp relative remove-focus\"><span id=\"dstep4\" data-hint=\"Click to download the datasets and code snippets related to the Skill\" class=\"icon-menu\"></span> <div ng-class=\"{&quot;display-none&quot;:!menuOpt}\" class=\"dash-menu-options menu-arrow\"> <div class=\"dash-menu-options-item-con\"> <div ng-click=\"downloadModuleData(document, lpData.current_module.sequenceId)\" class=\"dash-menu-options-item-wrp\"> <div class=\"dash-item-txt\">Download</div><span class=\"icon-download\"></span> </div> </div> </div> </div> </div> </div> <div class=\"video-progress-bar-wrp\"> <div class=\"vid-progress-container\"> <div class=\"vid-progres-buffer\"></div> <div class=\"vid-progres-current-wrp\"> <div ng-style=\"{ \'width\' : lpData.current_module.progress + \'%\'}\" class=\"vid-progres-current\"></div> <div ng-style=\"{ \'left\' : \'calc(\'+{{lpData.current_module.progress}}+\'% \' + \'- 12.5px\'+\')\'}\" ng-if=\"lpData.current_module.status == \'In Progress\'\" class=\"vid-play-btn\"> <div class=\"play2-icon\"></div> </div> <div ng-style=\"{\'left\' : 1 + \'%\'}\" ng-if=\"lpData.current_module.status == \'Not Started\'\" class=\"vid-play-btn\"> <div class=\"play2-icon\"></div> </div> <div ng-style=\"{ \'left\' : \'calc(\'+{{lpData.current_module.progress}}+\'% \' + \'+ 24px\'+\')\'}\" ng-if=\"lpData.current_module.status == \'In Progress\'\" class=\"video-progress-bar-tool-tip\"> <div class=\"tool-tip-arrow\"></div> <div class=\"video-icon-wrp\"><span ng-if=\"lpData.current_module.current_resource.type == \'video\'\" class=\"icon-video\"></span><span ng-if=\"lpData.current_module.current_resource.type == \'assignment\'\" class=\"icon-assignment\"></span></div> <div ng-if=\"lpData.current_module.current_resource\" class=\"module\"> <div class=\"name\">{{lpData.current_module.current_resource.metaData.title}}</div> <div class=\"time\"></div><span ng-if=\"lpData.current_module.current_resource.type != \'material\'\">{{lpData.current_module.current_resource.metaData.duration | minutesHours}}</span><span ng-if=\"lpData.current_module.current_resource.type == \'video\'\"> video</span><span ng-if=\"lpData.current_module.current_resource.type == \'assignment\'\"> assessment</span> </div> </div> </div> </div> </div> <div class=\"dash-last-play-item-wrp\"> <div class=\"left\"> <div class=\"dash-last-play-video-det-wrp last-video remove-focus\"> <div ng-if=\"lpData.current_module.videoDuration != 0\" class=\"dash-links-container\"><span class=\"icon-video\"></span><span ng-if=\"lpData.current_module.status == \'In Progress\'\" class=\"watched\">{{lpData.current_module.videoDurationCompleted | minutesHours}} /</span><span ng-if=\"lpData.current_module.status === \'Completed\'\" class=\"watched\">{{lpData.current_module.videoDuration | minutesHours}} /</span><span class=\"total-duration\">{{lpData.current_module.videoDuration | minutesHours}}</span><span class=\"text\">Videos</span></div> </div> <div class=\"dash-last-play-video-det-wrp\"> <div ng-if=\"lpData.current_module.assignmentDuration != 0\" class=\"dash-links-container\"><span class=\"icon-assignment\"></span><span ng-if=\"lpData.current_module.status === \'In Progress\'\" class=\"watched\">{{lpData.current_module.assignmentDurationCompleted | minutesHours}} /</span><span ng-if=\"lpData.current_module.status === \'Completed\'\" class=\"watched\">{{lpData.current_module.assignmentDuration | minutesHours}} /</span><span class=\"total-duration\">{{lpData.current_module.assignmentDuration | minutesHours}}</span><span class=\"text\">Assessments</span></div> </div> </div> <div ng-click=\"goToProfTest(lpData.current_module);$event.stopPropagation();\" style=\";top: 51%;left: 77%;border: 25px solid transparent;\" ng-if=\"lpData.current_module.proficiencyTest !== 0 &amp;&amp; lpData.current_module.proficiencyTest !== null\" class=\"right dash-last-play-test remove-focus\"><span style=\"margin-right:25px\" data-hint=\"Test what you’ve learnt by taking a Proficiency Test.\" data-hintposition=\"middle\"></span><span ng-if=\"isActiveLp()\">proficiency test</span><span ng-if=\"!isActiveLp()\">view</span></div> </div> </div> </div> </div> </div> <div ng-if=\"lpData.fModules.length &gt; 0\" class=\"dash-modules-section\"> <div class=\"dash-modules-head\"> <div id=\"dstep3\" class=\"dash-modules-txt\"><span>List of Skills</span><span style=\"margin-left:5px\" data-hint=\"This is the complete list of ‘Skills’ you will learn in this Learning Path. Click anywhere on the box to start learning. When you come back, you can resume from where you last left off.\" data-hintposition=\"middle\"></span></div> <div ng-click=\"mobilefilter=!mobilefilter\" class=\"dash-mob-filter remove-focus\"><span class=\"icon-filter\"></span></div> <div ng-init=\"completed=true;started=true;notStarted=true\" ng-show=\"mobilefilter\" class=\"dash-modules-index-wrp\"> <div class=\"dash-modules-index-item\"><span ng-click=\"started = !started\" class=\"background remove-focus\"><span ng-show=\"started\" class=\"icon-check\"></span></span><span>In progress</span></div> <div class=\"dash-modules-index-item\"><span ng-click=\"notStarted = !notStarted\" class=\"background remove-focus\"><span ng-show=\"notStarted\" class=\"icon-check\"></span></span><span>To be Done</span></div> <div class=\"dash-modules-index-item\"><span ng-click=\"completed = !completed\" class=\"background remove-focus\"><span ng-show=\"completed\" class=\"icon-check\"></span></span><span>Completed</span></div> </div> </div> <div class=\"dash-modules-body\"> <div ng-repeat=\"module in lpData.fModules | orderBy:\'sequenceId\'\" class=\"dash-modules-tile-wrp\"> <div ng-if=\"(lpData.currentModule == \'\' || (lpData.currentModule != \'\' &amp;&amp; module.moduleId != lpData.currentModule)) &amp;&amp; ((started &amp;&amp; module.status == \'In Progress\')||(notStarted &amp;&amp; module.status == \'Not Started\')||(completed &amp;&amp; module.status == \'Completed\'))\" ng-class=\"{\'completed\': module.status == \'Completed\', \'started\': module.status == \'In Progress\', \'not-started\': module.status == \'Not Started\'}\" class=\"dash-modules-tile-wrp-cont\"> <div ng-if=\"module.status != \'Completed\'\" ng-init=\"addTopToBadge($index ,module.status)\" class=\"dash-modules-no-wrp table\"> <div class=\"dash-modules-no table-cell\"><span>{{module.sequenceId | twoDigit}}</span></div> <div class=\"table-cell order-connect-container\"> <div class=\"dash-modules-index-indicator\"></div> </div> </div> <div ng-if=\"module.status == \'Completed\'\" ng-init=\"addTopToBadge($index ,module.status)\" class=\"dash-modules-no-wrp table\"> <div class=\"dash-modules-no completed table-cell\"> <div class=\"badge-icon-img\"><span>{{module.sequenceId | twoDigit}}</span></div> </div> <div class=\"table-cell order-connect-container\"> <div class=\"dash-modules-index-indicator\"></div> </div> </div> <div id=\"introModule{{index}}\" ng-click=\"startVideo(module);$event.stopPropagation();\" class=\"dash-modules-content-wrp remove-focus\"> <div ng-init=\"menuOpt = false\" ng-class=\"{&quot;module-not-started&quot;:module.status === &quot;Not Started&quot;}\" class=\"dash-modules-tile-progress-det table each-non-active-module\"> <div class=\"dash-last-play-item-det-wrp table-cell\"> <div class=\"dash-last-play-det-txt\">{{module.title}} <div class=\"dash-last-play-det-info-wrp relative\"><span style=\"color:#fc792c\" ng-click=\"module.openDiscription = showDesc(module.openDiscription, $event);$event.stopPropagation();\" title=\"Description\" class=\"icon-info\"></span> <div ng-class=\"{&quot;display-none&quot;:!module.openDiscription}\" ng-click=\"$event.stopPropagation();\" class=\"module-list-discription absolute\"> <div ng-class=\"{&quot;discription-box-arrow-mob&quot;:isMobilePhoneDevice}\" class=\"discription-content-wrap relative discription-box-arrow\"> <div ng-click=\"module.openDiscription = !module.openDiscription;$event.stopPropagation();\" class=\"close-discription absolute\"><span class=\"icon-close\"></span></div> <div class=\"discription-content\">{{module.description}}</div> </div> </div> </div> </div> </div> <div class=\"table-cell module-title-right\"><span ng-if=\"module.status == \'Completed\'\" class=\"icon-check2\"></span><span ng-if=\"module.status == \'Completed\'\" class=\"check-completed\">Completed</span><span ng-if=\"module.ptResult == \'FAIL\'\" title=\"You need to pass the proficiency test in order to complete this module, please contact your manager for retake approval\" class=\"module-test-status icon-warning\"></span><span ng-if=\"module.ptResult == \'FAIL\'\" class=\"module-test-text\"> Failed</span> <div class=\"dash-last-play-score-wrp clearfix\"><span class=\"icon-star\"></span> <div class=\"dash-last-play-score clearfix\"><span ng-if=\"module.status == \'In Progress\'\"></span><span>{{module.totalPointsEarned}}</span></div> </div> <div ng-click=\"menuOpt = showMenu(menuOpt, $event);$event.stopPropagation();\" class=\"dash-last-play-menu-wrp remove-focus relative\"><span id=\"dstep4\" data-hint=\"Click to download the datasets and code snippets related to the Skill\" class=\"icon-menu\"></span> <div ng-class=\"{&quot;display-none&quot;:!menuOpt}\" id=\"dstep4\" data-hint=\"Click to download the datasets and code snippets related to the Skill\" class=\"dash-menu-options menu-arrow\"> <div class=\"dash-menu-options-item-con\"> <div ng-click=\"downloadModuleData(document, module.sequenceId);$event.stopPropagation();\" class=\"dash-menu-options-item-wrp\"> <div class=\"dash-item-txt\">Download</div><span class=\"icon-download\"></span> </div> </div> </div> </div> </div> </div> <div ng-class=\"{&quot;display-none&quot;:module.status === &quot;Completed&quot; || module.status === &quot;In Progress&quot;}\" class=\"dash-modules-tile-module-det-wrp table hide-for-small\"> <div class=\"dash-modules-tile-module-det-title table-cell\">{{module.title}}</div> <div class=\"dash-modules-tile-module-det-desc table-cell\"> <p>{{module.description}}</p> </div> </div> <div class=\"video-progress-bar-wrp\"> <div class=\"vid-progress-container\"> <div class=\"vid-progres-buffer\"></div> <div class=\"vid-progres-current-wrp\"> <div ng-style=\"{ \'width\' : module.progress + \'%\'}\" class=\"vid-progres-current\"> </div> <div ng-style=\"{\'right\' : 8 + \'%\'}\" ng-if=\"module.status == \'Completed\'\" class=\"vid-play-btn rplay\"><span class=\"icon-replay\"></span></div> <div ng-style=\"{ \'left\' : \'calc(\'+{{module.progress}}+\'% \' + \'- 12.5px\'+\')\'}\" ng-if=\"module.status == \'In Progress\'\" class=\"vid-play-btn\"> <div class=\"play2-icon\"></div> </div> <div ng-style=\"{\'left\' : 1 + \'%\'}\" ng-if=\"module.status == \'Not Started\'\" class=\"vid-play-btn strt\"> <div class=\"play2-icon\"></div> </div> </div> </div> </div> <div class=\"dash-last-play-item-wrp\"> <div class=\"left\"> <div class=\"dash-last-play-video-det-wrp video\"></div> <div ng-if=\"module.videoDuration != 0\" class=\"dash-links-container\"><span class=\"icon-video\"></span><span ng-if=\"module.status === \'In Progress\'\" class=\"watched\">{{module.videoDurationCompleted | minutesHours}} /</span><span ng-if=\"module.status === \'Completed\'\" class=\"watched\">{{module.videoDuration | minutesHours}} /</span><span class=\"total-duration\">{{module.videoDuration | minutesHours}}</span><span class=\"text\">Videos</span></div> <div class=\"dash-last-play-video-det-wrp\"></div> <div ng-if=\"module.assignmentDuration != 0\" class=\"dash-links-container\"><span class=\"icon-assignment\"></span><span ng-if=\"module.status === \'In Progress\'\" class=\"watched\">{{module.assignmentDurationCompleted | minutesHours}} /</span><span ng-if=\"module.status === \'Completed\'\" class=\"watched\">{{module.assignmentDuration | minutesHours}} /</span><span class=\"total-duration\">{{module.assignmentDuration | minutesHours}}</span><span class=\"text\">Assessments</span></div> </div> <div id=\"hintprof{{$index}}\" ng-click=\"goToProfTest(module);$event.stopPropagation();\" ng-if=\"module.proficiencyTest !== 0 &amp;&amp; lpData.current_module.proficiencyTest !== null\" ng-class=\"{ptNotStarted: module.status === \'Not Started\', ptStarted: module.status !== \'Not Started\'}\" class=\"right dash-last-play-test\"><span ng-if=\"isActiveLp()\">proficiency test</span><span ng-if=\"!isActiveLp()\">view</span></div> </div> </div> </div> </div> </div> </div> <div ng-if=\"lpData.capstones.length &gt; 0\" class=\"dash-modules-section\"> <div class=\"dash-modules-head\"> <div id=\"dstep34\" class=\"dash-modules-txt\"><span>Capstone Project</span><span style=\"margin-left:5px\" data-hint=\"\" data-hintposition=\"middle\"></span></div> </div> <div class=\"dash-modules-body\"> <div ng-repeat=\"module in lpData.capstones | orderBy:\'sequenceId\'\" class=\"dash-modules-tile-wrp\"> <div ng-class=\"{\'completed\': module.status == \'Completed\' || module.status == \'Finished\', \'started\': module.status == \'In Progress\', \'not-started\': module.status == \'Not Started\'}\" class=\"dash-modules-tile-wrp-cont\"> <div ng-if=\"module.status != \'Completed\' &amp;&amp; module.status != \'Finished\'\" ng-init=\"addTopToBadge($index ,module.status)\" class=\"dash-modules-no-wrp table\"> <div class=\"dash-modules-no table-cell\"><span>{{module.sequenceId | twoDigit}}</span></div> <div class=\"table-cell order-connect-container\"> <div class=\"dash-modules-index-indicator\"></div> </div> </div> <div ng-if=\"module.status == \'Completed\' || module.status == \'Finished\'\" ng-init=\"addTopToBadge($index ,module.status)\" class=\"dash-modules-no-wrp table\"> <div class=\"dash-modules-no completed table-cell\"> <div class=\"badge-icon-img\"><span>{{module.sequenceId | twoDigit}}</span></div> </div> <div class=\"table-cell order-connect-container\"> <div class=\"dash-modules-index-indicator\"></div> </div> </div> <div ng-click=\"launchCapstone(module);$event.stopPropagation();\" class=\"dash-modules-content-wrp remove-focus\"> <div ng-init=\"menuOpt = false\" ng-class=\"{&quot;module-not-started&quot;:module.status === &quot;Not Started&quot;}\" class=\"dash-modules-tile-progress-det table each-non-active-module\"> <div class=\"dash-last-play-item-det-wrp table-cell\"> <div class=\"dash-last-play-det-txt\">{{module.title}} <div class=\"dash-last-play-det-info-wrp relative\"><span style=\"color:#fc792c\" ng-click=\"module.openDiscription = showDesc(module.openDiscription, $event);$event.stopPropagation();\" title=\"Description\" class=\"icon-info\"></span> <div ng-class=\"{&quot;display-none&quot;:!module.openDiscription}\" ng-click=\"$event.stopPropagation();\" class=\"module-list-discription absolute\"> <div ng-class=\"{&quot;discription-box-arrow-mob&quot;:isMobilePhoneDevice}\" class=\"discription-content-wrap relative discription-box-arrow\"> <div ng-click=\"module.openDiscription = !module.openDiscription;$event.stopPropagation();\" class=\"close-discription absolute\"><span class=\"icon-close\"></span></div> <div class=\"discription-content\">{{module.description}}</div> </div> </div> </div> </div> </div> <div class=\"table-cell module-title-right\"><span ng-if=\"module.status == \'Completed\' || module.status == \'Finished\'\" class=\"icon-check2\"></span><span ng-if=\"module.status == \'Completed\'\" class=\"check-completed\">Completed</span><span ng-if=\"module.status == \'Finished\'\" class=\"check-completed\">Finished</span> <div class=\"dash-last-play-score-wrp clearfix\"><span class=\"icon-star\"></span> <div class=\"dash-last-play-score clearfix\"><span ng-if=\"module.status == \'In Progress\'\"></span><span>{{module.totalPointsEarned}}</span></div> </div> </div> </div> <div ng-class=\"{&quot;display-none&quot;:module.status === &quot;Completed&quot; || module.status === &quot;In Progress&quot; || module.status === &quot;Finished&quot;}\" class=\"dash-modules-tile-module-det-wrp table hide-for-small\"> <div class=\"dash-modules-tile-module-det-title table-cell\">{{module.title}}</div> <div class=\"dash-modules-tile-module-det-desc table-cell\"> <p>{{module.description}}</p> </div> </div> <div class=\"video-progress-bar-wrp\"> <div class=\"vid-progress-container\"> <div class=\"vid-progres-buffer\"></div> <div class=\"vid-progres-current-wrp\"> <div ng-style=\"{ \'width\' : module.progress + \'%\'}\" class=\"vid-progres-current\"> </div> <div ng-style=\"{\'right\' : 8 + \'%\'}\" ng-if=\"module.status == \'Completed\' || module.status == \'Finished\'\" class=\"vid-play-btn rplay\"><span class=\"icon-replay\"></span></div> <div ng-style=\"{ \'left\' : \'calc(\'+{{module.progress}}+\'% \' + \'- 12.5px\'+\')\'}\" ng-if=\"module.status == \'In Progress\'\" class=\"vid-play-btn\"> <div class=\"play2-icon\"></div> </div> <div ng-style=\"{\'left\' : 1 + \'%\'}\" ng-if=\"module.status == \'Not Started\'\" class=\"vid-play-btn strt\"> <div class=\"play2-icon\"></div> </div> </div> </div> </div> <div class=\"dash-last-play-item-wrp\"> <div class=\"dash-last-play-video-det-wrp video\"> <div class=\"dash-links-container\"><span class=\"icon-assignment\"></span><span class=\"total-duration\">{{module.duration | minutesHours}}</span> <image src=\"../assets/Icons/Alert_icon.svg\" style=\"position: relative;margin-left: 2em;\" ng-if=\"module.status == \'In Progress\' || module.status == \'Not Started\'\" class=\"left\"></image><span style=\"color: #2f343b;padding-left: 2%;font-family: MontserratLight;\" ng-if=\"module.status == \'In Progress\' || module.status == \'Not Started\'\" class=\"text\">Disable the browser popup blocker to launch capstone</span> </div> </div> <div ng-click=\"launchCapstone(module);$event.stopPropagation();\" ng-if=\"module.status === &quot;Not Started&quot;\" class=\"dash-last-play-test\"><span>Start Project</span></div> <div ng-click=\"launchCapstone(module);$event.stopPropagation();\" ng-if=\"module.status === &quot;In Progress&quot;\" class=\"dash-last-play-test\"><span>Continue</span></div> <div ng-click=\"launchCapstone(module);$event.stopPropagation();\" ng-if=\"module.status === &quot;Completed&quot;\" class=\"dash-last-play-test\"><span>View Results</span></div> <div ng-click=\"launchCapstone(module);$event.stopPropagation();\" ng-if=\"module.status === &quot;Finished&quot;\" class=\"dash-last-play-test\"><span>Awaiting Results</span></div> </div> </div> </div> </div> </div> <form id=\"ltiform\" target=\"_blank\" method=\"POST\" action=\"https://jigsaw.authess.com/auth/lti\" enctype=\"application/x-www-form-urlencoded\" ng-if=\"authorized\"> <input type=\"hidden\" name=\"lti_version\" value=\"LTI-1p0\"> <input type=\"hidden\" name=\"oauth_nonce\" value=\"{{payload2.oauth_nonce}}\"> <input type=\"hidden\" name=\"oauth_signature\" value=\"{{payload2.oauth_signature}}\"> <input type=\"hidden\" name=\"user_id\" value=\"{{payload2.user_id}}\"> <input type=\"hidden\" name=\"lti_message_type\" value=\"{{payload2.lti_message_type}}\"> <input type=\"hidden\" name=\"oauth_consumer_key\" value=\"{{payload2.oauth_consumer_key}}\"> <input type=\"hidden\" name=\"resource_link_id\" value=\"{{payload2.resource_link_id}}\"> <input type=\"hidden\" name=\"lis_outcome_service_url\" value=\"{{payload2.lis_outcome_service_url}}\"> <input type=\"hidden\" name=\"lis_result_sourcedid\" value=\"{{payload2.lis_result_sourcedid}}\"> <input type=\"hidden\" name=\"oauth_signature_method\" value=\"{{payload2.oauth_signature_method}}\"> <input type=\"hidden\" name=\"oauth_timestamp\" value=\"{{payload2.oauth_timestamp}}\"> <input type=\"hidden\" name=\"oauth_version\" value=\"{{payload2.oauth_version}}\"> <input type=\"hidden\" name=\"lis_person_name_full\" value=\"{{payload2.lis_person_name_full}}\"> </form> </div> <div ng-class=\"{\'hide\':isActiveLp(),\'offset-row\':!isActiveLp()}\" class=\"active-lp-placeholder\"></div> </div> </div> </div> <div ng-class=\"{\'hide\':isActiveLp(),\'show\':!isActiveLp()}\" class=\"active-lp-link\"> <div ng-click=\"showCurrentLp()\" class=\"activelp-row\"><span class=\"icon-back\"></span><span class=\"active-lp\">BACK TO ACTIVE LEARNING PATH</span></div> </div> <error-screen ng-if=\"errorState\"></error-screen>");
$templateCache.put("app/Features/feedback/feedback.html"," <div ng-controller=\"FeedbackCtrl\" ng-click=\"passEvent($event)\" class=\"feedback-container\"> <div ng-class=\"{\'animate-fadeIn\':modelParent.isFeedbackViewActive, \'animate-fadeOut\':!modelParent.isFeedbackViewActive}\" class=\"feedback-inner-overlay\"></div> <div class=\"feedback-wrapper\"> <div class=\"feedback-content-wrap table-cell\"> <div ng-click=\"feedbackClicked()\" class=\"feedback-content relative\"> <div class=\"fd-bck-top\"> <div class=\"fd-bck-hdng-wrp\"> <div class=\"icon icon-composemessage\"></div> <div class=\"title\">Help us improve <div ng-if=\"success\" class=\"success\">Feedback has been successfully sent</div> </div>  </div> <div class=\"fd-bck-qst-section\"> <div class=\"fd-bck-qst-wrp\"> <div class=\"txt\">How was your learning experience?</div> <div class=\"fd-bck-radio-wrp clearfix\"> <div ng-repeat=\"option in parentObj.radioOptions\" class=\"fd-bck-radio-item\"> <input type=\"radio\" id=\"option{{$index}}\" ng-init=\"parentObj.thisSelectedModel = parentObj.radioOptions[0].value\" ng-model=\"parentObj.thisSelectedModel\" value=\"{{option.value}}\" checked=\"parentObj.thisSelectedModel === option.value\" name=\"feedbackRadio\" selected=\"\"> <label for=\"option{{$index}}\" class=\"remove-focus\"></label><span>{{option.value}}</span> </div> </div> </div> <div class=\"fd-bck-qst-wrp\"> <div class=\"txt\">Any other comments and suggestions?</div> <div class=\"fd-bck-txt-area relative\"> <textarea type=\"text\" placeholder=\"Feedback\" ng-model=\"feedbackTxt\" ng-change=\"takeNoteChange()\"></textarea>  </div> </div> </div> <div class=\"fd-bck-instrction\"> <div class=\"txt\">* The information given using this feedback form is strictly confidential and will only be used for improving our products and services.</div> </div> </div> <div class=\"fd-bck-footer\"> <div class=\"fd-bck-submit-btn\"> <div ng-click=\"submitFeedback()\" class=\"primary_btn\">submit</div> </div> </div> <div ng-click=\"closeFeedbackCard();\" class=\"close-btn-con absolute\"><span class=\"icon-close\"></span></div> </div> </div> </div> </div>");
$templateCache.put("app/Features/helpPage/helpPage.html"," <div class=\"bookmarks-container\"> <div class=\"gb-help-header\"> <div class=\"gb-icon-wrp hide-in-mobile\"><img ng-src=\"assets/images/header_logo.png\" class=\"logo\"></div> <div class=\"gb-hdr top-wrp clearfix text-center\"> <div class=\"gb-hdr-msg inline-block\">How can we help you? </div> <div ng-click=\"goToDashboard()\" class=\"gb-pg-close right remove-focus\"> <div class=\"icon icon-close\"></div> </div> </div> <div class=\"gb-tabs-switch-wrp row clearfix\"> <div class=\"gb-tabs-switch text-center large-6 medium-12 small-12 columns\"> <div class=\"gb-tabs-dummy row\"> <div ng-click=\"changeTab($index)\" ng-repeat=\"tab in tabs\" ng-class=\"{&quot;is-active&quot;:currentTabName == $index }\" class=\"gb-pg-tab large-6 medium-6 small-6 columns remove-focus\">{{tab}}</div> </div> </div> </div> </div> <div ui-view=\"\"></div> </div>");
$templateCache.put("app/Features/learnerView/learnerView.html"," <div class=\"learnerview-section row\"> <div class=\"learnerview-left large-8 columns\"> <div ui-view=\"\"></div> </div> <div id=\"vstep1\" class=\"learnerview-right large-4 columns hide-for-small-only hide-for-medium-only\"> <playlist></playlist> </div> </div>");
$templateCache.put("app/Features/libraryPage/libraryPage.html"," <div class=\"lib-page-wrp\"> <div ng-class=\"stickyClass\" class=\"lib-page-header-section is-lteIE9\"> <div ng-show=\"!sticky\" class=\"lib-hdr-full-view\"> <div class=\"lib-header-top clearfix hide-in-mobile\"> <div class=\"scnd-hdr-dpwrp clearfix left\"> <div class=\"scnd-hdr-userimg-con\"> <div ng-style=\"usrImage()\" id=\"rhombusProfileImageLib\" class=\"scnd-hdr-userimg\"></div> </div> </div> <div class=\"lib-hdr-plan-section left\"> <div class=\"help-msg\">{{helpMePlanData.message}}</div> <div class=\"help-progress-bar relative\"> <div ng-if=\"coursePlanAvailable\" class=\"help-me-plan-info-wrpt\"> <primary-progress-bar proposed-completion=\"helpMePlanData.proposedCompletion\" expected-completion=\"helpMePlanData.actualCompletion\"></primary-progress-bar> <div ng-click=\"toggleHelpScreen()\" class=\"help-edit\"> <div class=\"icon icon-edit\"></div> </div> </div> <div class=\"help-progress-bar-stat-wrp\"> <div class=\"help-stat-item\"><span class=\"bold\">{{helpMePlanData.itemQued}}</span><span>items queued in Library</span></div> <div class=\"help-stat-item\"> <span>Subscription ends</span><span class=\"bold\">{{helpMePlanData.lpEndDate | dateFilter}}</span></div> <div ng-click=\"toggleHelpScreen()\" ng-if=\"!coursePlanAvailable\" class=\"help-me-start-btn\">Help ME PLAN</div> </div> </div> </div> <div class=\"lib-hdr-points-wrp left\"><span class=\"icon-star\"></span> <div class=\"scnd-hdr-points\">{{LibData.userPonits}} </div> </div> </div> <div class=\"lib-search-wrp\"> <div class=\"title\">{{LibData.landingMsg}}</div> <div class=\"lib-srch-bar-wrp clearfix row table hide-in-mobile hide-in-tablet\"> <div class=\"icon icon-search table-cell\"></div> <div class=\"search-bar table-cell height100\"> <div class=\"search-bar-dummy clearfix height100 clearfix\"> <div ng-click=\"toggleFilterState()\" class=\"filter-wrp left relative\"> <div class=\"txt\">{{filterParam}}</div> <div class=\"icon icon-back\"></div> <ul ng-if=\"shwSrchFilter\" class=\"filter-drp-dwn\"> <li ng-repeat=\"i in filters\" ng-if=\"filterParam != i\" ng-click=\"selectFilterParam($index);$event.stopPropagation()\">{{i}} </li> </ul> </div> <div class=\"srch-input-wrp left height100\"> <input placeholder=\"skills, practice, topics, quizzes &amp; case studies in the Library\" ng-model=\"srchParam\" ng-focus=\"srchPageInput(true)\" ng-blur=\"srchPageInput(false)\"> </div> </div> </div> </div> <div class=\"lib-srch-bar-mob-wrp\"> <div class=\"icon icon-search\"></div> <div class=\"lib-srch-bar-mob-inp\"> <input placeholder=\"skills, practice, topics, quizzes &amp; case studies in the Library\" ng-model=\"srchParam\" ng-focus=\"srchPageInput(true)\" ng-blur=\"srchPageInput(false)\"> </div> </div> </div> </div> <div ng-show=\"sticky\" class=\"lib-sticky-header-wrp clearfix table full-width\"> <div ng-click=\"toggleFilterState()\" class=\"sticky-scrch-opt-wrp table-cell relative\"> <div class=\"txt\">{{filterParam}}</div> <div class=\"icon icon-back\"></div> <ul ng-if=\"shwSrchFilter\" class=\"stky-filter-drp-dwn\"> <li ng-repeat=\"i in filters\" ng-if=\"filterParam != i\" ng-click=\"selectFilterParam($index);$event.stopPropagation()\">{{i}} </li> </ul> </div> <div class=\"sticky-scrch-bar-wrp table-cell\"> <div class=\"sticky-scrch-dummy table full-width\"> <div class=\"sticky-scrch-icon table-cell\"> <div class=\"icon icon-search\"></div> </div> <div class=\"sticky-scrch-input table-cell\"> <input placeholder=\"skills, practice, topics, quizzes &amp; case studies in the Library\" ng-model=\"srchParam\" ng-focus=\"srchPageInput(true)\"> </div> <div ng-click=\"closeSrch()\" ng-show=\"srchPage\" class=\"icon icon-remove\"> </div> </div> </div> </div> </div> <div ng-if=\"!srchPage\" class=\"page-content-wrp\"> <div ng-class=\"marginChangeSticky\" class=\"lib-page-dummy is-lteIE9\"> <div class=\"lib-page-tab-section\"> <div class=\"row hide-in-mobile\"> <div class=\"dash-pg-select-wrp large-4 medium-8 columns lib-tab-pg-select small-12\"> <div ng-click=\"showLibContent()\" ng-class=\"{\'active\': exploreLib}\" class=\"dash-select-item-wrp table remove-focus lib-tab-item\"> <div ng-show=\"exploreLib\" class=\"dash-select-item-txt table-cell\">Explore</div> <div class=\"dash-select-item-img table-cell\"><span class=\"icon-library-explore\"></span></div> </div> <div ng-click=\"showClipboardWrp()\" ng-class=\"{\'active\': !exploreLib}\" class=\"dash-select-item-wrp table remove-focus\"> <div ng-show=\"!exploreLib\" class=\"dash-select-item-txt table-cell\">Clipboard</div> <div class=\"dash-select-item-img table-cell\"><span class=\"icon-clipboard\"></span></div> </div> </div> </div> </div> <div ng-if=\"exploreLib\" class=\"lib-explore-pg-wrp\"> <div class=\"lib-page-last-three-wrp\"> <div class=\"title\">CONTINUE WATCHING</div> <div class=\"lib-page-history-wrp row\"> <div ng-repeat=\"module in lastThreeModules\" class=\"large-4 medium-4 small-12 item lib-module-item\"> <library-module-tile tile-info=\"module\" index=\"$index\" tiles-info=\"lastThreeModules\"></library-module-tile> </div> </div> </div> <div class=\"lib-content-wrp\"> <div class=\"lib-content-tab\"> <div class=\"dash-pg-select-wrp large-6 medium-8 small-12 columns lib-tab-pg-select\"> <div ng-click=\"tabChangeMain(1)\" ng-class=\"{\'active\': libTab == 1}\" class=\"dash-select-item-wrp table remove-focus\"> <div class=\"dash-select-item-txt\">SKills </div> </div> <div ng-click=\"tabChangeMain(2)\" ng-class=\"{\'active\': libTab == 2}\" class=\"dash-select-item-wrp table remove-focus\"> <div class=\"dash-select-item-txt\">Playlists</div> </div> <div ng-click=\"tabChangeMain(3)\" ng-class=\"{\'active\': libTab == 3}\" class=\"dash-select-item-wrp table remove-focus\"> <div class=\"dash-select-item-txt\">Learning Paths </div> </div> </div> </div> <div class=\"lib-main-wrp\"> <div ng-include=\"\" src=\"contentURL\" class=\"lib-main-skill-wrp\"> </div> </div> </div> </div> <div ng-if=\"!exploreLib\" class=\"lib-clipborad-pg-wrp\"></div> </div> <div ng-include=\"\" src=\"helpMePage\" class=\"lib-help-page\"></div> <div ng-class=\"{&quot;lib-hdr-plylist-sticy-view&quot; :sticky}\" class=\"lib-hdr-playlist-btn hide-in-mobile\"> <div ng-click=\"togglePlaylist()\" ng-class=\"plyListBarClass\" class=\"lib-hdr-playlist-wrp clearfix remove-focus\"> <div ng-class=\"{&quot;arrow-anti-clockwise&quot;:!libPlaylistToggle ,&quot;arrow-clockwise&quot;:libPlaylistToggle}\" class=\"icon icon-expand left\"></div> <div class=\"txt-wrp left\"> <div class=\"title\">PLAYER</div> <div class=\"items\">{{quedVideos.length}}</div> </div> </div> <div ng-include=\"\" src=\"playListDrawer\" ng-class=\"plyListClass\" class=\"lib-nav-draw-playlist\"> </div> </div> <div ng-click=\"showClipboardWrp()\" class=\"dash-clipboard-mobile remove-focus\"><span class=\"icon-clipboard\"></span></div> <div ng-click=\"togglePlaylistMobile()\" ng-class=\"{\'playlist-mob-open \':playListMobile ,\'playlist-mob-close\':!playListMobile}\" class=\"lib-mob-playlist-wrp remove-focus\"> <div class=\"lib-mob-playlist-info-wrp clearfix\"> <div class=\"lib-mob-playlist-title-wrp left\"> <div class=\"txt\">Player</div> <div class=\"play-q-info\">{{quedVideos.length}} </div> </div> <div class=\"lib-mob-playlist-icon right\"> <div ng-class=\"{\'playlist-mob-icon-rotate \':!playListMobile ,\'playlist-mob-icon-rotate-clock\':playListMobile}\" class=\"icon icon-expand\"></div> </div> </div> <div ng-include=\"\" src=\"playListDrawer\" ng-click=\"$event.stopPropagation();\" class=\"lib-mob-playlist-content\"></div> </div> </div> <div ng-include=\"\" src=\"libSearchPage\" ng-if=\"srchPage\" class=\"lib-page-data-srch\"> </div> </div>");
$templateCache.put("app/Features/libraryPageVideoPlayer/libraryPageVideoPlayer.html"," <div class=\"learnerview-section row\"> <div ng-include=\"\" src=\"videoPage\" class=\"learnerview-left large-8 columns\"></div> <div ng-include=\"\" src=\"videoPagePlaylist\" class=\"lib-vid-playlist large-4 columns hide-for-small-only hide-for-medium-only\"></div> <div ng-class=\"{\'clipboard-animate-up\': overlay,\'clipboard-animate-down\': !overlay}\" class=\"vid-clipboard-section absolute\"> <div class=\"vid-clipboard-con relative\"> <div ng-click=\"clipBrdOpen()\" ng-class=\"{\'clipboard-button-front\':!overlay &amp;&amp; isClipboardIconClicked,\'clipboard-button-behind\': overlay &amp;&amp; isClipboardIconClicked}\" class=\"vid-clipboard-icon-wrp inline-block remove-focus relative\"> <div class=\"vid-clipboard-icon\"><span class=\"icon-clipboard2\"></span></div> </div> <div class=\"vid-overlay-section\"> <div ng-click=\"clipBrdOpen()\" class=\"overlay-close absolute remove-focus\"><span class=\"icon-close\"></span></div> <div class=\"vid-clipboard-overlay-wrp\"> <div class=\"vid-clipboard-contents-con large-centered medium-centered small-centered\"> <div class=\"overlay-heading-wrp clearfix\"> <div class=\"overlay-heading left\"><span>{{totalItemsClipboard}} ITEMS ADDED</span></div> <div class=\"overlay-clipboard-link right\"><span class=\"icon-clipboard\"></span><span class=\"nav-link-text\">MY CLIPBOARD</span></div> </div> <div class=\"vid-overlay-clipboard-section clearfix row\"> <div ng-click=\"slideClipboardRight()\" ng-class=\"{\'vid-clip-arrow-disable\' : !currentIndex}\" class=\"vid-overlay-clip-cntrl-wrp remove-focus columns large-1 medium-2 small-3\"><span class=\"icon-back\"> </span></div> <div class=\"vid-overlay-clip-ul columns large-10 medium-8 small-6\"> <div class=\"lcl-clipbrd-wrp\"> <ul slick=\"\" settings=\"slickConfig\" ng-if=\"slickConfig.enabled\" class=\"clearfix\"> <li ng-repeat=\"ClipboardItem in clipboardataSorted\" ng-if=\"$index &gt; 0\" class=\"vid-clipbrd-inner-date-list\"> <div class=\"vid-clipbrd-item-wrp\"> <div class=\"vid-clipbrd-item-date\">{{ClipboardItem.date_created | date:\'shortDate\'}}</div> <div class=\"vid-clipbrd-date-list\"> <div ng-repeat=\"item in ClipboardItem.data\" class=\"vid-clipbrd-date-list-item\"> <div ng-style=\"{\'background-image\':\'url({{item.thumbnail}})\'}\" class=\"vid-clipbrd-img-wrp\"> <div class=\"vid-clipbrd-item-time\">{{item.clipdata.start_time | transcriptTime}}<span class=\"icon-cloc\"></span></div> <div class=\"vid-icon-type\"><span ng-class=\"{\'icon-play\' : item.type == \'trimmedvideo\' , \'icon-screenshot\' : item.type == \'screenshot\' , \'icon-notes\' : item.type == \'notes\' , \'icon-questionanswer\' : item.type == \'askanexpert\' }\"></span></div> <div class=\"vid-minus\"> <div class=\"minus\"></div> </div> </div> </div> </div> </div> </li> </ul> </div> </div> <div ng-click=\"slideClipboardLeft()\" class=\"vid-overlay-clip-cntrl-wrp remove-focus columns large-1 medium-2 small-3\"><span class=\"icon-next\"></span></div> </div> </div> </div> </div> </div> </div> </div>");
$templateCache.put("app/Features/liteManagerDashboard/liteManagerDashboard.html"," <div class=\"header-section-buyer\"> <bheader></bheader> </div> <popout></popout> <div class=\"clearfix\"> <div style=\"padding-top:50px\" scroll-to-top=\"\" ng-init=\"showOption=false\" ng-class=\"{min:boolChangeClass}\" class=\"bnavigation-bar-wrp left\"> <div class=\"setup-profile-image-con relative\"> <div id=\"setupProfileImage\" style=\"background-size:100% 100% !important\" class=\"setup-profile-image\"></div> </div> <div class=\"upload-avatar-wrp\"> <div class=\"upload-image table\"> <label ng-click=\"parentObj.uploadAvatar=true\" class=\"table-cell remove-focus\"><span class=\"icon-notes\"></span></label> </div> </div> <div ng-click=\"showOption=!showOption\" class=\"buser-manager-wrp relative table remove-focus\"> </div> <div class=\"buser-info-wrp\"> <div style=\"padding-top:20px\" class=\"buser-name table\"> <div class=\"table-cell\">{{bJourneyObj.user.firstname}}</div> </div> <div class=\"buser-designation\"><span>{{bJourneyObj.user.designation}}</span></div> </div> <div class=\"bnavigation-tiles-wrp\"> <div ng-class=\"{&quot;active&quot;:bJourneyObj.activeTab === &quot;dashboard&quot;}\" class=\"bnavigation-tiles table remove-focus\"><span ng-show=\"bJourneyObj.activeTab === &quot;dashboard&quot;\" class=\"table-cell\">DASHBOARD</span><span class=\"icon-dashboard table-cell\"></span></div> </div> </div> <div ui-view=\"\" ng-class=\"{&quot;full-width&quot;:!bJourneyObj.navBarShow,&quot;buyer-right-portion&quot;:bJourneyObj.navBarShow,&quot;right&quot;:bJourneyObj.navBarShow}\" style=\"padding: 6%\" class=\"dashboard-ui-view\"> <div ng-init=\"showRetakeRequest=false\" class=\"blearners-retake-wrp\"> <div class=\"blearners-retake-heading-wrp\"> <div class=\"clearfix\"> <div class=\"left\"><span ng-if=\"lretake.retaketest.length != 1\" class=\"heading\">{{lretake.retaketest.length}} Learners have requested for retake of Proficiency Test</span><span ng-if=\"lretake.retaketest.length == 1\" class=\"heading\">{{lretake.retaketest.length}} Learner has requested for retake of Proficiency Test</span></div> <div ng-click=\"showRetakeRequest = !showRetakeRequest\" ng-class=\"{\'is-active\':showRetakeRequest}\" class=\"right remove-focus bview-btn-wrp\"><span ng-if=\"!showRetakeRequest\">Hide</span><span ng-if=\"showRetakeRequest\">View</span><span ng-class=\"{\'icon-down\': showRetakeRequest, \'icon-up\': !showRetakeRequest}\"></span></div> </div> </div> <table ng-show=\"!showRetakeRequest\" class=\"bjourney-primary-table blearners-table\"> <thead> <tr> <th>name</th> <th>module title</th> <th>proficiency test score</th> <th>date</th> <th>action</th> </tr> </thead> <tbody> <tr ng-repeat=\"retake in lretake.retaketest\"> <td><span class=\"name\">{{retake.firstname}}</span></td> <td>{{retake.moduleTitle}}</td> <td>{{retake.securedScore}}</td> <td>{{retake.endTime | dateFilter}}</td> <td ng-init=\"menuOpt = false\"><span ng-if=\"testApproved\">approved</span><span ng-click=\"approveLearner(\'{{retake.fbUserId}}\', \'{{retake.lpId}}\', \'{{retake.ptId}}\',\'{{retake.moduleSeqId}}\',\'{{$index}}\',\'{{retake.moduleTitle}}\')\" class=\"primary_btn learner-view\">approve</span><span style=\"display:none\" class=\"approved-learner\">approved</span></td> </tr> </tbody> </table> </div> </div><span class=\"button secondary_btn\">Report</span> <upload-avatar> <div ng-if=\"tNCOverlay\" class=\"upload-tnc-overlay\"> <div ng-click=\"openClosetNCOverlay()\" class=\"upload-tnc-overlay-close remove-focus\"><span class=\"icon-close\"></span></div> <div class=\"upload-tnc-section\"> <div class=\"upload-tnc-heading\"><span>Terms and Conditions:</span></div> <div class=\"upload-tnc-text\"> <ul> <li>The Intellectual Property disclosure will inform users that your website, logo and visuals and other content you created is your property and protected by copyright laws</li> <li>A Termination clause will inform users that their accounts on your website (or their access to your website, if they don�t have an account) can be terminated in case of abuses</li> <li>A Governing Law informs users which country�s laws governs the agreement. This is the country in which your company is headquartered or the country from which you operate your web site.</li> <li>A Links To Other Web Sites clause informs users that you are not responsible for any third party web sites that you link to from your website, and that users are responsible for reading these third parties� own Terms and Conditions or Privacy Policies.</li> <li>The Intellectual Property disclosure will inform users that your website, logo and visuals and other content you created is your property and protected by copyright laws</li> <li>A Termination clause will inform users that their accounts on your website (or their access to your website, if they don�t have an account) can be terminated in case of abuses</li> <li>A Governing Law informs users which country�s laws governs the agreement. This is the country in which your company is headquartered or the country from which you operate your web site.</li> <li>A Links To Other Web Sites clause informs users that you are not responsible for any third party web sites that you link to from your website, and that users are responsible for reading these third parties� own Terms and Conditions or Privacy Policies.</li> </ul> </div> </div> </div> </upload-avatar> </div>");
$templateCache.put("app/Features/login/login.html"," <div ng-if=\"showLogin\" class=\"login-container\"> <div class=\"login-bg-con table\">  <div class=\"login-bg-large table-cell\"></div> </div> <div class=\"login-content-container flip\"> <div ng-class=\"{\'flipped\':isFlipped}\" class=\"login-content-wrapper table-cell card\"> <div ng-class=\"{\'login-failure\':loginErrorMessage,\'invalid-inputs\':invalidLoginInput}\" class=\"login-content front\">  <div class=\"lg-org-logo-con\"> <div class=\"lg-org-logo inline-block\"></div> </div> <div class=\"lg-content-inner-wrap\"> <form name=\"form\" ng-submit=\"formSubmitted=true;form.$setPristine();loginAttempted(form.$valid);\" novalidate=\"\" class=\"lg-input-fields\"> <div class=\"input-field-wrp username-section\"> <div class=\"username-wrp relative\"> <input name=\"thisUsername\" type=\"email\" ng-focus=\"formSubmitted=false\" placeholder=\"Corporate e-mail address\" ng-model=\"parentObj.theUserName\" required=\"\"><span class=\"icon-con icon-username\"></span> </div> </div> <div class=\"input-field-wrp password-section\"> <div class=\"username-wrp relative\"> <input name=\"thisPassword\" type=\"password\" ng-focus=\"formSubmitted=false\" placeholder=\"Password\" ng-model=\"parentObj.password\" required=\"\"><span class=\"icon-con icon-password\"></span> </div> </div> <div class=\"lg-user-options clearfix\"> <div class=\"lg-bottom-link\"><a ng-click=\"isFlipped=!isFlipped;forgotscreen();formSubmitted=false\" class=\"forgot-password\">FORGOT PASSWORD?</a></div> </div> <div class=\"login-error-msg-con error-text\"><span ng-if=\"formSubmitted &amp;&amp; form.thisPassword.$invalid &amp;&amp; form.thisUsername.$invalid\" class=\"profile-email-error\">Invalid E-mail or password</span><span ng-if=\"formSubmitted &amp;&amp; form.thisPassword.$invalid &amp;&amp; !form.thisUsername.$invalid\" class=\"profile-email-error\">Provide a password</span><span ng-if=\"formSubmitted &amp;&amp; form.thisUsername.$invalid &amp;&amp; !form.thisPassword.$invalid\" class=\"profile-email-error\">Provide valid E-mail Address</span><span ng-if=\"formSubmitted &amp;&amp; loginErrorMessage &amp;&amp; !form.thisUsername.$invalid &amp;&amp; !form.thisPassword.$invalid\">{{loginErrorMessage}}</span><span ng-if=\"unauthorizedMsg\">{{unauthorizedMsg}}</span></div> <div class=\"lg-submit-button-con\"> <button class=\"primary_btn table-cell remove-focus\"><span class=\"text\">LOGIN</span></button> </div> </form> </div> </div> <div ng-class=\"{\'invalid-inputs\':invalidForgotInput}\" class=\"forgot-pwd-content back l-hide\"> <div class=\"lg-top-logo-con\"><span>FORGOT YOUR PASSWORD?</span></div> <div style=\"text-align: center;\" class=\"lg-org-logo-con\"><span>Don\'t worry! Just fill in your corporate email ID and we will help you reset your password.</span></div> <div class=\"lg-content-inner-wrap\"> <form name=\"form1\" ng-submit=\"form1Submitted=true;retrievePassword(form1.$valid);form1.$setPristine()\" novalidate=\"\" class=\"lg-input-fields\"> <div class=\"email-address\"> </div> <div class=\"input-field-wrp username-section\"> <div class=\"username-wrp relative\"> <input name=\"thisEmail\" ng-keypress=\"forgotErrorMessage=&quot;&quot;\" ng-keyup=\"loginSuccessMessage=\'\'\" type=\"email\" placeholder=\"Enter your e-mail address\" ng-model=\"parentObj.emailAddress\" required=\"\"> </div> </div> <div ng-if=\"form1Submitted &amp;&amp; form1.thisEmail.$invalid\" class=\"login-error-msg-con error-text\">Provide a valid e-mail address</div> <div ng-if=\"forgotErrorMessage &amp;&amp; !form1.thisEmail.$invalid\" class=\"login-error-msg-con error-text\"><span>{{forgotErrorMessage}}</span></div> <div ng-if=\"loginSuccessMessage &amp;&amp; !form1.thisEmail.$invalid &amp;&amp; !forgotErrorMessage\" class=\"login-error-msg-con error-text\"><span>{{loginSuccessMessage}}</span></div> <div class=\"lg-submit-button-con\"> <button class=\"primary_btn table-cell remove-focus\"><span class=\"text\">RESET PASSWORD</span></button> </div> <div style=\"padding:3.8vh 1vh;text-align:center\" class=\"lg-bottom-link\"><a ng-click=\"loginscreen();isFlipped=!isFlipped;form1Submitted=false\" class=\"forgot-password\">BACK TO LOGIN</a></div> </form> </div> </div> </div> <div class=\"footer-text-help\"><span class=\"light\">Need help?</span><span class=\"bold\"> Mail us at help.rubric@jigsawacademy.com</span></div> </div> <div class=\"login-right-text\"><span class=\"heading\">Your analytics journey</span><br><span class=\"heading\">starts now.</span><br><span class=\"foot-text\">Welcome to<span class=\"bold\"> Rubric.</span></span></div> </div>");
$templateCache.put("app/Features/notifications/notifications.html"," <div ng-controller=\"NotificationsCtrl\" ng-class=\"{\'start-notifications-show\':modelParent.isNotificationsListActive, \'stop-notifications-show\':!modelParent.isNotificationsListActive}\" class=\"notifications-container\"> <div ng-click=\"closeNotificationsOverlay();\" class=\"notification-inner-invisible-overlay\"></div> <div ng-click=\"$event.stopPropagation()\" class=\"notification-wrapper\"> <div ng-if=\"notification != null\" class=\"notificatio-header\"> <div class=\"nf-icon-bell-con\"><span class=\"icon-bell\"></span></div> <div class=\"nf-head-title\"><span class=\"nf-head-title-text\">Recent</span><span class=\"nf-head-title-indicator\">({{notificationCount}})</span></div> <div ng-click=\"closeNotificationsOverlay();\" class=\"nf-close-icon-con\"><span class=\"icon-close\"></span></div> </div> <div ng-if=\"notification != null\" class=\"notification-action-panel clearfix\">  <div ng-if=\"parentObject.showDeletionCheckboxes\" class=\"nf-action-select-all-con left\"> <input type=\"checkbox\" id=\"selectAllNotification\" checked=\"parentObject.selectAllNotification\" ng-model=\"parentObject.selectAllNotification\" ng-change=\"triggerSelectAll(allNotifications,parentObject.selectAllNotification)\"> <label for=\"selectAllNotification\" ng-class=\"{&quot;icon-checkbox_inactive&quot;:!parentObject.selectAllNotification,&quot;icon-checkbox_selected&quot;:parentObject.selectAllNotification}\" class=\"label-checkbox\">Select All</label> </div> <div ng-if=\"parentObject.showDeletionCheckboxes\" ng-click=\"deleteNotifications();\" class=\"nf-action-delete-con left\"><span class=\"nf-delete-icon icon-trash\"></span></div> <div ng-click=\"markAllNotificationsRead();\" class=\"nf-action-mark-all-con right\"><span class=\"nf-action-right-text\">MARK ALL AS READ</span></div> </div> <div ng-if=\"notification == null\" style=\"text-align:center;background:url(\'/assets/Icons/notification_empty.svg\')no-repeat;background-size: 30vh;background-position: center;\" class=\"notification-list-items-con\"><span style=\"color:#999999;font-size:24px\"></span></div> <div ng-if=\"notification != null\" class=\"notification-list-items-con\"> <div ng-repeat=\"item in notificationArray | orderBy:item.timestamp:&quot;-&quot;\" ng-class=\"{\'nf-unread\':!item.read}\" ng-click=\"navigateByNotification(item);$event.stopPropagation();\" class=\"nf-each-list-item-con\"> <div ng-click=\"$event.stopPropagation();\" class=\"nf-each-content-inner-wrap table\"> <div ng-if=\"parentObject.showDeletionCheckboxes\" ng-click=\"$event.stopPropagation()\" class=\"nf-each-item-check-box-con table-cell\"> <input type=\"checkbox\" id=\"notification{{$index}}\" checked=\"item.eachNotifications\" ng-model=\"item.eachNotifications\"> <label for=\"notification{{$index}}\" ng-class=\"{&quot;icon-checkbox_inactive&quot;:!item.eachNotifications,&quot;icon-checkbox_selected&quot;:item.eachNotifications}\" class=\"label-checkbox\"></label> </div> <div class=\"nf-each-item-icon-con table-cell\"> <div ng-if=\"item.subtype === \'ticket\' &amp;&amp; item.status === \'open\'\" class=\"nf-each-icon icon-TicketStatus\"></div> <div ng-if=\"item.subtype === \'ticket\' &amp;&amp; item.status === \'closed\'\" class=\"nf-each-icon icon-success\"></div> <div ng-if=\"item.subtype === \'lp-completion\' &amp;&amp; item.status === \'Completed\'\" class=\"nf-each-icon icon-success\"></div> <div ng-if=\"item.subtype === \'clock\'\" class=\"nf-each-icon icon-reminder\"></div> <div ng-if=\"item.subtype === \'warning\'\" class=\"nf-each-icon nf-warning icon-warning\"></div> <div ng-if=\"item.subtype === \'result\' &amp;&amp; item.status === \'PASS\'\" class=\"nf-each-icon nf-green icon-assignment\"></div> <div ng-if=\"item.subtype === \'result\' &amp;&amp; item.status === \'FAIL\'\" class=\"nf-each-icon nf-warning icon-proficiencytestfail\"></div> <div ng-if=\"item.type === \'notification\' &amp;&amp; item.mode === \'newVideo\'\" class=\"nf-each-icon icon-video\"></div> <div ng-if=\"item.type === \'notification\' &amp;&amp; item.mode === \'questionAnswered\'\" class=\"nf-each-icon icon-username\"></div> <div ng-if=\"item.type === \'notification\' &amp;&amp; item.mode === \'earnedPoints\'\" class=\"nf-each-icon icon-star\"></div> <div ng-if=\"item.type === \'notification\' &amp;&amp; item.mode === \'Idle\'\" class=\"nf-each-icon icon-consistentonleaderboard\"></div> <div ng-if=\"item.type === \'notification\' &amp;&amp; item.mode === \'trending\'\" class=\"nf-each-icon icon-trendingvideo\"></div> <div ng-if=\"item.type === \'Congratulations\' &amp;&amp; item.mode === \'moduleCompletion\'\" class=\"nf-each-icon nf-green icon-success\"></div> <div ng-if=\"item.type === \'Congratulations\' &amp;&amp; item.mode === \'badgeEarned\'\" class=\"nf-each-icon nf-blue icon-badge\"></div> <div ng-if=\"item.type === \'Cheers\' &amp;&amp; item.mode === \'achievement\'\" class=\"nf-each-icon nf-green icon-top3\"></div> <div ng-if=\"item.type === \'Cheers\' &amp;&amp; item.mode === \'excellence\'\" class=\"nf-each-icon nf-blue icon-aheadofschedule\"></div> <div ng-if=\"item.type === \'goodToGo\'\" class=\"nf-each-icon nf-green icon-top3\"></div> <div ng-if=\"item.subtype === \'result\' &amp;&amp; item.status == undefined\" class=\"nf-each-icon nf-green icon-success\"></div> <div ng-if=\"item.type === \'goodJob\'\" class=\"nf-each-icon nf-green icon-top10\"></div> </div> <div class=\"nf-each-item-text-con table-cell relative\"> <div ng-if=\"item.title\" class=\"nf-each-title\">{{item.title}}</div> <div ng-if=\"item.description\" class=\"nf-each-description\">{{item.description}}</div> <div ng-if=\"item.timestamp\" class=\"nf-each-description\">{{item.timestamp | dateFilter}}</div> <div ng-if=\"item.type === \'ticket\'\" class=\"nf-each-additional-link\">CHECK STATUS</div> <div ng-if=\"item.type === \'reminder\'\" ng-click=\"callRemindFn(item);$event.stopPropagation()\" class=\"nf-each-additional-link\">REMIND LATER</div> <div ng-if=\"!item.read\" ng-click=\"item.isStatusSetActive=!item.isStatusSetActive; $event.stopPropagation();\" ng-class=\"{\'is-active\':item.isStatusSetActive,\'nf-unread\':!item.read}\" class=\"nf-each-right-check-con absolute\"> <div class=\"nf-each-right-check\"> <div ng-click=\"$event.stopPropagation(); markThisNotificationRead($index);item.read=!item.read\" class=\"nf-arrow-box-con absolute\"> <div class=\"nf-arrow-box\">Mark as read</div> </div> </div> </div> </div> </div> </div> </div> </div> </div>");
$templateCache.put("app/Features/proficiencyTest/proficiencyTest.html"," <div class=\"prof-pg-wrp row learnerview-section\"> <div class=\"prof-pg-right-wrp learnerview-left large-8 columns\"> <div class=\"quiz-page-wrp row\"> <div class=\"quiz-content-wrp\"> <div class=\"quiz-pg-hdng-wrp clearfix\"> <div ng-click=\"goToDashboard()\" class=\"quiz-pg-hdng-back-wrp left\"><span class=\"icon-back\"></span></div> <div class=\"quiz-pg-hdng-report-wrp right\"> <div class=\"prof-timer-dummy-wrp clearfix\"> <div ng-click=\"reportIssueFunc();$event.stopPropagation();\" class=\"qz-title-mob-report-issue-wrp left relative\"><span class=\"icon-reportissue\"></span> <div ng-show=\"expandedReportIssue\" class=\"qz-ri-wrp absolute\"> <div class=\"ri-arrow relative\"> <div class=\"clearfix ri-header-wrp\"> <div class=\"left\">report an issue</div> <div ng-click=\"reportIssueFunc();$event.stopPropagation();\" class=\"right remove-focus\"><span class=\"icon-close\"></span></div> </div> <div class=\"ri-options-wrp\"> <div ng-repeat=\"issue in rissuesObj.issues\" class=\"ri-options\"> <input type=\"radio\" id=\"opt{{$index}}\" ng-model=\"rissuesObj.issues.issueName\" value=\"{{issue.type}}\" checked=\"rissuesObj.issues.issueName === issue.type\" name=\"issueName\"> <label for=\"opt{{$index}}\" class=\"remove-focus\"></label><span>{{issue.type}}</span> </div> </div> <div class=\"ri-send-button-wrp\"><span ng-click=\"sendRIssue();$event.stopPropagation();\" class=\"primary_btn remove-focus\">send</span></div> </div> </div> </div> </div> </div> </div> <div ng-include=\"\" src=\"profTemplateUrl\" ng-style=\"setQsHeight()\" class=\"prof-content-section\"></div> </div> </div> </div> <div class=\"learnerview-right large-4 columns hide-for-small-only hide-for-medium-only\"> <div ng-include=\"playListTemplateURL\" class=\"prof-playlist-wrp\"></div> </div> </div>");
$templateCache.put("app/Features/progressInfoPage/progressInfoPage.html"," <div ng-click=\"passEvent($event)\" class=\"prog-page-wrp hide-in-mobile\"> <div class=\"prog-pg-hdr-wrp clearfix\"> <div class=\"prog-pg-hdr-back-wrp left remove-focus\"><span ng-click=\"goToDashboard()\" class=\"icon-back\"></span><span style=\"cursor: default\" class=\"back-txt\"> My Profile</span></div> <div class=\"prog-pg-hdr-user-info-wrp clearfix\"> <div class=\"prog-pg-hdr-user-img-wrp left\"> <div ng-init=\"applySchema(\'rhombusImageProfile\',\'28\');\" class=\"prog-pg-hdr-userimg-con\"> <div id=\"rhombusImageProfile\" class=\"prog-pg-hdr-userimg\"></div> </div> <div ng-click=\"parentObj.uploadAvatar=true\" title=\"Edit profile image\" class=\"icon icon-edit\"></div> </div> <div class=\"prog-pg-hdr-user-section left\"> <div class=\"user-name-wrp\"> <div class=\"name\">{{user.firstname}}</div> <div class=\"role\">({{user.designation}})</div> </div> <div class=\"user-email-id\">{{ user.fbUsername }}</div> </div> </div> <div class=\"prog-pg-hdr-user-score right\"><span class=\"icon-star\"></span><span class=\"txt\">{{lpAttr.summary.totalPointsEarned}}</span></div> </div> <div class=\"prog-pg-options-wrp row\"> <div ng-class=\"{\'active\': tabStateDesktop ==\'progress\'}\" ng-click=\"goToProgressDsktop()\" class=\"prog-pg-options-item columns large-6 medium-6 remove-focus\">Progress</div>  <div ng-class=\"{\'active\': tabStateDesktop ==\'prsnlInfo\'}\" ng-click=\"goToPrnslInfoDsktop()\" class=\"prog-pg-options-item columns large-6 medium-6 remove-focus\">Settings</div> </div> <div ng-if=\"tabStateDesktop ==\'progress\'\" class=\"prog-pg-progress-section\"> <div class=\"prog-pg-weeks-left-wrp\"> <div class=\"title\">Progress Overview</div> <div class=\"weeks-left\">{{lpAttr.weeksLeft}} Weeks Left</div> </div> <div class=\"lrn-prof-progress-section\"> <div class=\"lrn-prof-progress-bar-section\"> <proficiency-progress-bar total-tests=\"10\" proposed-completion=\"3\" actual-completion=\"2\"></proficiency-progress-bar> <primary-progress-bar proposed-completion=\"expectedCompletion\" actual-completion=\"modulesData.progress\"></primary-progress-bar> </div> <div class=\"progress-user-progress\"> <user-progress-bar lp-data=\"modulesData\" open-next-flow=\"startVideo(module);\"></user-progress-bar> </div> </div> <div ng-include=\"\" src=\"\'app/Features/progressInfoPage/template/leaderBoard.html\'\" class=\"prog-pg-leaderboard-section\"></div> <div ng-include=\"\" src=\"\'app/Features/progressInfoPage/template/badgesSection.html\'\" style=\"margin-top:-5px\" class=\"prog-pg-leaderboard-section\"></div> </div> <div ng-if=\"tabStateDesktop ==\'prsnlInfo\'\" class=\"prog-pg-progress-section personal-info\"> <div ng-include=\"\" src=\"\'app/Features/userProfile/userProfile.html\'\" class=\"user-profile\"></div> </div> <div ng-if=\"tabStateDesktop ==\'prfmcAnalytics\'\" class=\"prog-pg-progress-section\"> <div ng-include=\"\" src=\"\'app/Features/progressInfoPage/template/performanceAnalytics/performanceAnalytics.html\'\" class=\"prog-prfmc-wrp\"></div> </div> </div> <div ng-click=\"passEvent($event)\" class=\"prog-page-wrp-mob hide-in-tablet-up\"> <div ng-include=\"\" src=\"\'app/Features/progressInfoPage/template/mobile_landing_page.html\'\" ng-show=\"landingPageMob\" class=\"prog-pg-leaderboard-section\"></div> <div ng-if=\"tabStateMobile ==\'progress\'\" class=\"prog-pg-progress-section-mob\"> <div class=\"progress-hdng-wrp clearfix\"> <div ng-click=\"goToLandingpage()\" class=\"progress-hdng-back-wrp left\"><span class=\"icon-back\"></span></div> <div class=\"progress-hdng-title left\">Progress</div> <div ng-click=\"goToDashboard()\" class=\"progress-hdng-close right remove-focus\"><span class=\"icon-close\"></span></div> </div> <div class=\"prog-pg-mob-content-wrp\"> <div class=\"prog-pg-mob-tabs-wrp row\"> <div ng-click=\"openOverviewTab()\" ng-class=\"{\'tab-active-mob\': progTabIndex == 0 }\" class=\"prog-pg-mob-tabs-item column small-4 remove-focus\"> <div class=\"tab-title\">overview</div> </div> <div ng-click=\"openLdrBrdTab()\" ng-class=\"{\'tab-active-mob\': progTabIndex == 1}\" class=\"prog-pg-mob-tabs-item column small-4 remove-focus\"> <div class=\"tab-title\">leaderboard</div> </div>  </div> <ul rn-carousel=\"\" rn-carousel-index=\"progTabIndex\" class=\"prog-mob-tabs-wrp\"> <li class=\"prog-pg-leaderboard-section\"> <div ng-include=\"\" src=\"\'app/Features/progressInfoPage/template/overviewMobile.html\'\" class=\"prog-pg-leaderboard-wrp\"></div> </li> <li class=\"prog-pg-leaderboard-section\"> <div ng-include=\"\" src=\"\'app/Features/progressInfoPage/template/leaderBoard.html\'\" class=\"prog-pg-leaderboard-wrp\"></div> </li>  </ul> </div> </div> <div ng-if=\"tabStateMobile ==\'personalInfo\'\" class=\"prog-pg-progress-section-mob\"> <div class=\"progress-hdng-wrp clearfix\"> <div ng-click=\"goToLandingpage()\" class=\"progress-hdng-back-wrp left\"><span class=\"icon-back\"></span></div> <div class=\"progress-hdng-title left\">Personal Info</div> <div ng-click=\"goToDashboard()\" class=\"progress-hdng-close right remove-focus\"><span class=\"icon-close\"></span></div> </div> <div class=\"prog-mob-personal-wrp\"> <div ng-include=\"\" src=\"\'app/Features/progressInfoPage/template/personalInfo.html\'\" class=\"prog-pg-leaderboard-wrp\"></div> </div> </div> </div> <upload-avatar></upload-avatar>");
$templateCache.put("app/Features/reportAnIssue/reportAnIssue.html"," <div ng-controller=\"ReportAnIssueCtrl\" ng-click=\"passEvent($event)\" class=\"report-an-issue-container\"> <div ng-class=\"{\'animate-fadeIn\':modelParent.isReportAnIssueViewActive, \'animate-fadeOut\':!modelParent.isReportAnIssueViewActive}\" class=\"report-an-issue-inner-overlay\"></div> <div class=\"report-an-issue-wrapper\"> <div class=\"report-an-issue-content-wrap table-cell\"> <div class=\"report-an-issue-content relative\"> <div class=\"support-content row suport-tickets-mob\"> <div class=\"hlp-faq-tabs-switch clearfix\"> <div ng-repeat=\"item in supportTopics\" class=\"hlp-faq-tab-dummy left remove-focus\"> <div style=\"height:80px\" ng-class=\"{&quot;tile-active&quot;:currentSupportItem == item.title}\" ng-click=\"supportTopic(item.title)\" class=\"hlp-support-tab\"> <div ng-class=\"item.iconClass\" class=\"icon hide-in-mobile\"></div> <div style=\"font-size:18px;position:relative;bottom:2vh;margin-left:0px\" class=\"txt\">{{item.title}}</div> </div> </div> </div> <div class=\"hlp-sprt-wrp\"> <div class=\"hlp-sprt-input\"> <input type=\"text\" ng-model=\"supportModel.subject\" placeholder=\"subject:\" ng-click=\"$event.stopPropagation();\" ng-change=\"takeNoteChange()\" class=\"remove-focus\"> </div>  <div class=\"report-an-issue-txt-area relative\"> <textarea type=\"text\" placeholder=\"Please give us more details\" ng-model=\"supportModel.issue\" ng-change=\"takeNoteChange()\"></textarea> </div> <div class=\"hlp-attach-section clearfix hide-in-mobile\">  <div class=\"hlp-sprt-snd-wrp right\">  <div ng-click=\"openTicket(supportModel.subject,supportModel.issue)\" class=\"primary_btn\"> <div class=\"txt-dktp\">send</div> </div> </div> </div> </div> <div class=\"hlp-suprt-mob-btn hide-in-tablet-up\">  <div class=\"icon-close\">  </div> </div> </div> <div ng-click=\"closeReportAnIssueCard();\" class=\"close-btn-con absolute\"><span class=\"icon-close\"></span></div> </div> </div> </div> </div>");
$templateCache.put("app/Features/reset/reset.html"," <div class=\"header row\"> <div class=\"header-left-logo-wrp columns large-3 medium-2\"> <div class=\"header-logo-img\"></div> </div> </div> <div class=\"reset body\"> <div ng-show=\"passwordForm\" class=\"password-reset-container\"> <div class=\"reset-password-text\">RESET YOUR PASSWORD</div> <div class=\"new-password-container\"> <form name=\"form1\" ng-submit=\"form1Submitted=true;changePassword(form1.$valid);\" novalidate=\"validate\" style=\"background: #ffffff;height: 60%;width: 90%;margin: 0% 5%;padding-top: 8%;\" class=\"user-profile-wrp clearfix change-pwd-wrp\"> <div class=\"input-wrp\"> <div style=\"width: 100%;padding: 10px 5% 10px 15px;\" class=\"password-wrp cm-right-input-wrp table\"> <div style=\"width: 32%;font-size: 13px;color: #000;padding-right: 4%;font-family: Montserratlight;\" class=\"type table-cell\"><span>New Password:</span><span class=\"mandatory-field\">*</span></div> <div style=\"margin-left: 10px;width: 100%;\" class=\"input-field-wrp relative table-cell\"> <input id=\"typePassword\" name=\"typePassword\" type=\"password\" placeholder=\"Password\" ng-model=\"parentObj.inputPassword\" ng-focus=\"thisIsFocused();\" ng-blur=\"thisIsBlured();\" ng-change=\"passwordChange(parentObj.inputPassword);\" required=\"required\"><span ng-if=\"form1Submitted &amp;&amp; form1.typePassword.$invalid\" class=\"absolute error-text profile-email-error uprofile-email-error\">Please type your password</span> <div ng-if=\"pwdInputIsFocussed\" class=\"pwd-validation-check-box absolute\"> <div class=\"pwd-validation-check\"> <div class=\"changepwd-validation-wrap\"> <div class=\"changepwd-validation table\"><i ng-class=\"{\'pwd-valid-icon-active\':minPasswrdLength}\" class=\"icon-check pwd-valid-icon table-cell\"></i><span class=\"table-cell\">8 or more characters</span></div> <div class=\"changepwd-validation table\"><i ng-class=\"{\'pwd-valid-icon-active\':min1Number}\" class=\"icon-check pwd-valid-icon table-cell\"></i><span class=\"table-cell\">1 or more numbers</span></div> <div class=\"changepwd-validation table\"><i ng-class=\"{\'pwd-valid-icon-active\':lowercaseCharacters}\" class=\"icon-check pwd-valid-icon table-cell\"></i><span class=\"table-cell\">1 or more alphabets</span></div> </div> </div> </div> </div> </div> <div ng-class=\"{&quot;input-disabled&quot;:!enableChangePwdInput}\" style=\"width: 100%;padding: 10px 5% 10px 15px;\" class=\"password-wrp cm-right-input-wrp table\"> <div style=\"width: 32%;font-size: 13px;color: #000;padding-right: 4%;font-family: Montserratlight;\" class=\"type table-cell\"><span>Confirm Password</span><span class=\"mandatory-field\">*</span></div> <div style=\"margin-left: 10px;width: 100%;\" class=\"input-field-wrp relative table-cell\"> <input id=\"retypePassword\" name=\"retypePassword\" type=\"password\" placeholder=\"Re-type Password\" ng-model=\"parentObj.inputConfirmPassword\" ng-change=\"retypePasswordChange(parentObj.inputConfirmPassword);\" ng-disabled=\"!enableChangePwdInput\" required=\"required\"><span ng-if=\"isBothPwdSame === false &amp;&amp; parentObj.inputConfirmPassword\" class=\"error-text pwd-mismatch-error absolute\">Above two password doesn\'t match</span><span ng-if=\"form1Submitted &amp;&amp; form1.retypePassword.$invalid\" class=\"absolute error-text profile-email-error uprofile-email-error\">Please confirm your password</span> </div> </div> </div> <div style=\"float: right;margin-right: 5%;margin-top: 5%;\" class=\"start-lp-btn-wrp destp-btn table hide-for-small-only save-pwd-btn\"> <button class=\"primary_btn table-cell remove-focus\"><span style=\"padding: 0px;\" class=\"text\">Save changes</span></button> </div> </form> </div> </div> <div ng-show=\"resetSuccess\" class=\"success-state-screen w3-animate-zoom\"> <div class=\"head-message\">Your password was reset successfully</div> <div class=\"sub-head-message\">Login with your new password</div> </div> <div ng-show=\"errorOccured\" class=\"error-state-screen w3-animate-zoom\"> <div class=\"head-message\">Oops! Something went wrong.</div> <div class=\"sub-head-message\">We suggest, you try again later.</div> </div> <div class=\"reset-page-footer\"><span style=\"font-family: montserratLight;\">Need Help? </span><span style=\"font-family: montserrat;font-weight: 500;\">Mail us at help.rubric@jigsawacademy.com</span></div> </div>");
$templateCache.put("app/Features/setupProfile/setupProfile.html"," <form name=\"form\" ng-submit=\"formSubmitted=true;goToDashboard(form.$valid);\" novalidate=\"novalidate\" class=\"setup-profile-wrp clearfix\"> <div ng-hints-method=\"startHint\" ng-intro-options=\"IntroOptions\" ng-intro-method=\"CallMe\" ng-intro-oncomplete=\"CompletedEvent\" ng-intro-onexit=\"ExitEvent\" ng-intro-onchange=\"ChangeEvent\" ng-intro-onbeforechange=\"BeforeChangeEvent\" ng-intro-onafterchange=\"AfterChangeEvent\" ng-intro-autostart=\"true\" ng-if=\"!errorState\" ng-click=\"closeTile()\" class=\"left login-credentials-wrp\"> <div class=\"upload-avatar-wrp\"> <div class=\"setup-profile-image-con relative\"> <div id=\"setupProfileImage\" class=\"setup-profile-image upload-state-picture\"></div> </div> <div class=\"set-up-logo show-for-small-only\"><img ng-src=\"assets/images/Jigsaw_logo_light.png\" class=\"logo\"></div> <div class=\"upload-image table\"> <label ng-click=\"parentObj.uploadAvatar=true\" class=\"table-cell remove-focus\"><span class=\"text\">Select avatar</span><span class=\"icon-notes\"></span></label> </div> </div> <div class=\"welcome-wrp\"> <div class=\"welcome-msg-wrp\"> <div class=\"primary-heading\"><span>Set up your profile</span></div> </div> </div> </div> <div class=\"right profile-info-wrp\"> <div class=\"heading-wrp\"> <div class=\"primary-heading\"><span>USER DETAILS</span></div> <div class=\"secondary-heading\"><span>Please contact your manager if you wish to edit any details.</span></div> </div> <div class=\"info-wrp relative\"> <div class=\"full-name\"><span>{{user.fullName}}</span></div> <div class=\"other-info-wrp\"> <div class=\"email-wrp table\"> <div class=\"email-head table-cell\"><span>Email ID</span></div> <div class=\"email-value table-cell\"><span>{{user.emailID}}</span></div> </div> <div class=\"company-wrp table\"> <div class=\"company-name-head table-cell\"><span>Company</span></div> <div class=\"company-name-value table-cell\"><span>{{user.companyName}}</span></div> </div> <div class=\"designation-wrp table\"> <div class=\"designation-head table-cell\"><span>Designation</span></div> <div class=\"designation-value table-cell\"><span>{{user.designation}}</span></div> </div> </div> </div> <div class=\"input-wrp\"> <div class=\"heading-wrp\"> <div class=\"primary-heading\"><span>USERNAME &amp; PASSWORD</span></div> <div class=\"secondary-heading\"><span>Your corporate email ID is your username by default. Keep your account secure by setting up your own password.</span></div> </div> <div class=\"reset-password-section\"> <div class=\"username-wrp cm-right-input-wrp table\"> <div class=\"type table-cell\"><span>Username</span></div> <div class=\"input-field-wrp relative table-cell\"> <input name=\"thisUsername\" type=\"text\" placeholder=\"Username\" ng-model=\"parentObj.theUserName\" required=\"required\" ng-disabled=\"true\"><span ng-if=\"formSubmitted &amp;&amp; form.thisUsername.$invalid\" class=\"absolute error-text profile-email-error\">Provide a username</span> </div> </div> <div class=\"password-wrp cm-right-input-wrp table\"> <div class=\"type table-cell\"><span>Password</span><span class=\"mandatory-field\">*</span></div> <div class=\"input-field-wrp relative table-cell\"> <input id=\"typePassword\" name=\"typePassword\" type=\"password\" placeholder=\"Password\" ng-model=\"parentObj.inputPassword\" ng-focus=\"thisIsFocused();\" ng-blur=\"thisIsBlured();\" ng-change=\"passwordChange(parentObj.inputPassword);\" required=\"required\"><span ng-if=\"formSubmitted &amp;&amp; form.typePassword.$invalid\" class=\"absolute error-text profile-email-error\">Please type your password</span> <div ng-if=\"pwdInputIsFocussed\" class=\"pwd-validation-check-box absolute\"> <div class=\"pwd-validation-check\"> <div class=\"changepwd-validation-wrap\"> <div class=\"changepwd-validation table\"><i ng-class=\"{\'pwd-valid-icon-active\':minPasswrdLength}\" class=\"icon-check pwd-valid-icon table-cell\"></i><span class=\"table-cell\">8 or more characters</span></div> <div class=\"changepwd-validation table\"><i ng-class=\"{\'pwd-valid-icon-active\':min1Number}\" class=\"icon-check pwd-valid-icon table-cell\"></i><span class=\"table-cell\">1 or more numbers</span></div> <div class=\"changepwd-validation table\"><i ng-class=\"{\'pwd-valid-icon-active\':lowercaseCharacters}\" class=\"icon-check pwd-valid-icon table-cell\"></i><span class=\"table-cell\">1 or more alphabets</span></div> </div> </div> </div> </div> </div> <div ng-class=\"{&quot;input-disabled&quot;:!enableChangePwdInput}\" class=\"password-wrp cm-right-input-wrp table\"> <div class=\"type table-cell\"><span>Re-type password</span><span class=\"mandatory-field\">*</span></div> <div class=\"input-field-wrp relative table-cell\"> <input id=\"retypePassword\" name=\"retypePassword\" type=\"password\" placeholder=\"Re-type Password\" ng-model=\"parentObj.inputConfirmPassword\" ng-change=\"retypePasswordChange(parentObj.inputConfirmPassword);\" ng-disabled=\"!enableChangePwdInput\" required=\"required\"><span ng-if=\"isBothPwdSame === false &amp;&amp; parentObj.inputConfirmPassword\" class=\"error-text pwd-mismatch-error absolute\">Above two password doesn\'t match</span><span ng-if=\"formSubmitted &amp;&amp; form.retypePassword.$invalid\" class=\"absolute error-text profile-email-error\">Please confirm your password</span> </div> </div> <div class=\"checkbox-con-setup\"> </div> </div> <div class=\"heading-wrp\"> <div class=\"primary-heading\"><span>ADDITIONAL CONTACT DETAILS</span></div> <div class=\"secondary-heading\"><span></span></div> </div> <div class=\"further-details-section\"> <div class=\"alternate-email-wrp table\"> <div class=\"type table-cell\"><span>Alternate Email ID</span></div> <div class=\"input-field-wrp relative table-cell\"> <input name=\"alternateEmail\" type=\"email\" placeholder=\"Email Id\" ng-model=\"parentObj.altEmailId\"><span ng-if=\"formSubmitted &amp;&amp; form.alternateEmail.$invalid\" class=\"absolute error-text profile-email-error\">Provide a valid email id</span> </div> </div> <div class=\"contact-num-wrp table\"> <div class=\"type table-cell\"><span>Contact Number</span><span class=\"mandatory-field\">*</span></div> <div class=\"select-box-con table-cell\"> <ui-select name=\"countryCode\" search-enabled=\"searchEnabled\" ng-model=\"parentObj.countryCode\" ng-disabled=\"disabled\"> <ui-select-match placeholder=\"Country code\">+{{$select.selected.code}}</ui-select-match> <ui-select-choices repeat=\"country in countryCodes | filter: $select.search.replace(\'+\',\'\')\"><small>{{country.name}} (+{{country.code}})</small></ui-select-choices> </ui-select> </div> <div class=\"input-field-wrp table-cell\"> <input id=\"contactNumber\" name=\"contactNumber\" type=\"tel\" ng-model=\"parentObj.phoneNumber\" placeholder=\"Mobile Number\" required=\"required\"><span ng-if=\"formSubmitted &amp;&amp; form.contactNumber.$invalid\" class=\"absolute error-text profile-email-error\">Mobile no. is required</span> </div> </div> </div> </div> <div ng-if=\"authData.auth.role === \'Learner\'\" class=\"notify-wrp\"> <div class=\"notify-heading-wrp clearfix\"> <div class=\"notify-heading left\">NOTIFY ME</div> <div class=\"notify-checkbox right remember-me-checkbox\"> <input id=\"activateAllLabel\" type=\"checkbox\" checked=\"parentObj.activateAll\" ng-model=\"parentObj.activateAll\" ng-change=\"activateAllNotify(parentObj.activateAll)\"> <label for=\"activateAllLabel\" ng-class=\"{&quot;icon-checkbox_inactive&quot;:!parentObj.activateAll,&quot;icon-checkbox_selected&quot;:parentObj.activateAll}\"></label><span> Activate All</span> </div>  </div> <div class=\"notify-box\"> <div class=\"my-progress-wrp clearfix\"> <div class=\"text-wrp left\"> <div class=\"heading\">Progress Report</div> <div class=\"heading-description\">Notify me about my progress and activities related to my learning path</div> </div> <div class=\"checkbox-wrp right\"> <input id=\"check-toggle-2\" type=\"checkbox\" checked=\"parentObj.progressUpdate\" ng-model=\"parentObj.progressUpdate\" ng-change=\"notifyOptionChanged();\" class=\"checkbox-toggle checkbox-toggle-round\"> <label for=\"check-toggle-2\"></label> </div> </div> <div class=\"my-progress-wrp clearfix\"> <div class=\"text-wrp left\"> <div class=\"heading\">Points &amp; Rewards</div> <div class=\"heading-description\">Update me about my leaderboard rank, milestones achieved, points earned, and rewards.</div> </div> <div class=\"checkbox-wrp right\"> <input id=\"check-toggle-3\" type=\"checkbox\" checked=\"parentObj.pointsAndRewards\" ng-model=\"parentObj.pointsAndRewards\" ng-change=\"notifyOptionChanged();\" class=\"checkbox-toggle checkbox-toggle-round\"> <label for=\"check-toggle-3\"></label> </div> </div> </div> </div> <div class=\"start-lp-btn-wrp destp-btn table hide-for-small-only\"> <button class=\"primary_btn table-cell remove-focus\"><span ng-if=\"user_role === \'Learner\'\" class=\"text\">START LEARNING</span><span ng-if=\"user_role === \'L&amp;D Manager\' || user_role === \'Manager\'\" style=\"font-size: 12px;\" class=\"text\">LET\'S GO</span><span class=\"icon-next\"></span></button><span style=\"font-size: 12px;font-weight: 100;margin-left: 10px;\">By clicking this button, you agree to Jigsaw’s<span style=\"font-size: 12px;margin-left: 2px;color: #FC792F;cursor: pointer;\" ng-click=\"tNCOverlay=true;termsNCondition();\">Terms &amp; Conditions</span></span> </div> </div> <div class=\"start-lp-btn-wrp table remove-focus\"> <button class=\"primary_btn table-cell\"><span class=\"text\">START LEARNING</span><span class=\"icon-next\"></span></button> </div> <upload-avatar></upload-avatar> <div ng-if=\"tNCOverlay\" class=\"upload-tnc-overlay\"> <div ng-click=\"openClosetNCOverlay()\" class=\"upload-tnc-overlay-close remove-focus\"><span class=\"icon-close\"></span></div> <div class=\"upload-tnc-section\"> <div style=\"padding-left: 0px;\" class=\"upload-tnc-heading\"><span>Terms of Use</span></div> <div ng-bind-html=\"terms | trustAsHtml\" class=\"upload-tnc-text\">{{terms}}</div> </div> </div> </form>");
$templateCache.put("app/Features/userProfile/userProfile.html"," <form name=\"form\" ng-submit=\"formSubmitted=true;updateProfile(form.$valid);\" novalidate=\"novalidate\" class=\"user-profile-wrp clearfix\"> <div class=\"back-to-dashboard\"><a ng-click=\"cancelFunction()\"><span class=\"icon-back\"></span><span class=\"btg-text\">back to dashboard</span></a></div> <div class=\"buyers-profile-info-wrp\"> <div class=\"heading-wrp\"> <div class=\"primary-heading\"><span>USER DETAILS</span></div> <div class=\"secondary-heading\"><span>This info helps us keep you updated. If it’s incorrect, please contact your manager.</span></div> </div> <div class=\"info-wrp relative\"> <div class=\"full-name\"><span>{{fullName}}</span></div> <div class=\"other-info-wrp\"> <div class=\"email-wrp table\"> <div class=\"email-head table-cell\"><span>Email ID</span></div> <div class=\"email-value table-cell\"><span>{{emailID}}</span></div> </div> <div class=\"company-wrp table\"> <div class=\"company-name-head table-cell\"><span>Company Name</span></div> <div class=\"company-name-value table-cell\"><span>{{companyName}}</span></div> </div> <div class=\"designation-wrp table\"> <div class=\"designation-head table-cell\"><span>Designation</span></div> <div class=\"designation-value table-cell\"><span>{{designation}}</span></div> </div> </div> </div> <div class=\"input-wrp\"> <div class=\"heading-wrp\"> <div class=\"primary-heading\"><span>ADDITIONAL CONTACT DETAILS</span></div> <div class=\"secondary-heading\"><span></span></div> </div> <div class=\"further-details-section\"> <div class=\"alternate-email-wrp table\"> <div class=\"type table-cell\"><span>Alternate Email ID</span></div> <div class=\"input-field-wrp relative table-cell\"> <input name=\"alternateEmail\" type=\"email\" placeholder=\"Email Id\" ng-model=\"parentObj.altEmailId\"><span ng-if=\"formSubmitted &amp;&amp; form.alternateEmail.$invalid\" class=\"absolute error-text profile-email-error\">Provide a valid email id</span> </div> </div> <div class=\"contact-num-wrp table\"> <div class=\"type table-cell\"><span>Contact Number</span><span class=\"mandatory-field\">*</span></div> <div class=\"select-box-con table-cell\"> <ui-select name=\"countryCode\" search-enabled=\"searchEnabled\" ng-model=\"parentObj.countryCode\" ng-disabled=\"disabled\"> <ui-select-match placeholder=\"Country code\">+{{$select.selected.code}}</ui-select-match> <ui-select-choices repeat=\"country in countryCodes | filter: $select.search.replace(\'+\',\'\')\"><small>{{country.name}} (+{{country.code}})</small></ui-select-choices> </ui-select> </div> <div class=\"input-field-wrp table-cell\"> <input id=\"contactNumber\" name=\"contactNumber\" type=\"tel\" ng-model=\"parentObj.phoneNumber\" placeholder=\"Mobile Number\" maxlength=\"10\" ng-minlength=\"10\" ng-maxlength=\"10\" required=\"required\"><span ng-if=\"formSubmitted &amp;&amp; form.contactNumber.$invalid\" class=\"absolute error-text profile-email-error\">Mobile no. is required</span> </div> </div> </div> </div> <div ng-if=\"authData.auth.role === \'Learner\'\" class=\"notify-wrp\"> <div class=\"notify-heading-wrp clearfix\"> <div class=\"notify-heading left\">NOTIFY ME</div> <div class=\"notify-checkbox right remember-me-checkbox\"><span>Activate All</span> <input id=\"activateAllLabel\" type=\"checkbox\" checked=\"parentObj.activateAll\" ng-model=\"parentObj.activateAll\" ng-change=\"activateAllNotify(parentObj.activateAll)\"> <label for=\"activateAllLabel\" ng-class=\"{&quot;icon-checkbox_inactive&quot;:!parentObj.activateAll,&quot;icon-checkbox_selected&quot;:parentObj.activateAll}\"></label> </div>  </div> <div class=\"notify-box\"> <div class=\"my-progress-wrp clearfix\"> <div class=\"text-wrp left\"> <div class=\"heading\">Progress Report</div> <div class=\"heading-description\">Notify me about my progress and activities related to my learning path</div> </div> <div class=\"checkbox-wrp right\"> <input id=\"check-toggle-2\" type=\"checkbox\" checked=\"parentObj.progressUpdate\" ng-model=\"parentObj.progressUpdate\" ng-change=\"notifyOptionChanged();\" class=\"checkbox-toggle checkbox-toggle-round\"> <label for=\"check-toggle-2\"></label> </div> </div> <div class=\"my-progress-wrp clearfix\"> <div class=\"text-wrp left\"> <div class=\"heading\">Points & Rewards</div> <div class=\"heading-description\">Update me about my leaderboard rank, milestones achieved, points earned, and rewards.</div> </div> <div class=\"checkbox-wrp right\"> <input id=\"check-toggle-3\" type=\"checkbox\" checked=\"parentObj.pointsAndRewards\" ng-model=\"parentObj.pointsAndRewards\" ng-change=\"notifyOptionChanged();\" class=\"checkbox-toggle checkbox-toggle-round\"> <label for=\"check-toggle-3\"></label> </div> </div> </div> </div> <div class=\"start-lp-btn-wrp destp-btn table hide-for-small-only\"> <button class=\"primary_btn table-cell remove-focus\"><span class=\"text\">Save changes</span></button>  </div>   </div> <div class=\"start-lp-btn-wrp table remove-focus\"> <button class=\"primary_btn table-cell\"><span class=\"text\">Save changes</span></button>  </div> <upload-avatar></upload-avatar> </form> <form name=\"form1\" ng-submit=\"form1Submitted=true;changePassword(form1.$valid);\" novalidate=\"validate\" class=\"user-profile-wrp clearfix change-pwd-wrp\"> <div class=\"buyers-profile-info-wrp change-pwd\"> <div class=\"input-wrp\"> <div class=\"heading-wrp\"> <div class=\"primary-heading\"><span>USERNAME & PASSWORD</span></div> <div class=\"secondary-heading\"><span>Keep your account secured by setting up your own password. Your corporate email ID is your username by default.</span></div> </div> <div class=\"reset-password-section\"> <div class=\"username-wrp cm-right-input-wrp table\"> <div class=\"type table-cell\"><span>Username</span></div> <div class=\"input-field-wrp relative table-cell\"> <input name=\"thisUsername\" type=\"text\" placeholder=\"Username\" ng-model=\"parentObj.theUserName\" required=\"required\" ng-disabled=\"true\"><span ng-if=\"form1Submitted &amp;&amp; form1.thisUsername.$invalid\" class=\"absolute error-text profile-email-error\">Provide a username</span> </div> </div> <div class=\"password-wrp cm-right-input-wrp table\"> <div class=\"type table-cell\"><span>Password</span><span class=\"mandatory-field\">*</span></div> <div class=\"input-field-wrp relative table-cell\"> <input id=\"typePassword\" name=\"typePassword\" type=\"password\" placeholder=\"Password\" ng-model=\"parentObj.inputPassword\" ng-focus=\"thisIsFocused();\" ng-blur=\"thisIsBlured();\" ng-change=\"passwordChange(parentObj.inputPassword);\" required=\"required\"><span ng-if=\"form1Submitted &amp;&amp; form1.typePassword.$invalid\" class=\"absolute error-text profile-email-error uprofile-email-error\">Please type your password</span> <div ng-if=\"pwdInputIsFocussed\" class=\"pwd-validation-check-box absolute\"> <div class=\"pwd-validation-check\"> <div class=\"changepwd-validation-wrap\"> <div class=\"changepwd-validation table\"><i ng-class=\"{\'pwd-valid-icon-active\':minPasswrdLength}\" class=\"icon-check pwd-valid-icon table-cell\"></i><span class=\"table-cell\">8 or more characters</span></div> <div class=\"changepwd-validation table\"><i ng-class=\"{\'pwd-valid-icon-active\':min1Number}\" class=\"icon-check pwd-valid-icon table-cell\"></i><span class=\"table-cell\">1 or more numbers</span></div> <div class=\"changepwd-validation table\"><i ng-class=\"{\'pwd-valid-icon-active\':lowercaseCharacters}\" class=\"icon-check pwd-valid-icon table-cell\"></i><span class=\"table-cell\">1 or more alphabets</span></div> </div> </div> </div> </div> </div> <div ng-class=\"{&quot;input-disabled&quot;:!enableChangePwdInput}\" class=\"password-wrp cm-right-input-wrp table\"> <div class=\"type table-cell\"><span>Re-type password</span><span class=\"mandatory-field\">*</span></div> <div class=\"input-field-wrp relative table-cell\"> <input id=\"retypePassword\" name=\"retypePassword\" type=\"password\" placeholder=\"Re-type Password\" ng-model=\"parentObj.inputConfirmPassword\" ng-change=\"retypePasswordChange(parentObj.inputConfirmPassword);\" ng-disabled=\"!enableChangePwdInput\" required=\"required\"><span ng-if=\"isBothPwdSame === false &amp;&amp; parentObj.inputConfirmPassword\" class=\"error-text pwd-mismatch-error absolute\">Above two password doesn\'t match</span><span ng-if=\"form1Submitted &amp;&amp; form1.retypePassword.$invalid\" class=\"absolute error-text profile-email-error uprofile-email-error\">Please confirm your password</span> </div> </div> </div> </div> <div class=\"start-lp-btn-wrp destp-btn table hide-for-small-only save-pwd-btn\"> <button class=\"primary_btn table-cell remove-focus\"><span class=\"text\">Save password</span></button>  </div> </div> </form>");
$templateCache.put("app/Features/video_playlist_mobile/playlistMobile.html"," <div ng-class=\"{\'library-opt\': libActive}\" class=\"video-mob-wrp\"> <div ng-init=\"blur_msg = false\" class=\"module-overview\"> <div ng-class=\"{\'message-mobile-blur\': blur_msg}\" class=\"module-overview-wrp\"> <div class=\"module-header clearfix\"> <div class=\"back left\"><span ng-click=\"goDashboard()\" class=\"icon-back remove-focus\"></span></div> <div class=\"module-name left\">{{activeModule.title}}</div> <div class=\"points right\"><span class=\"icon-star\"></span><span ng-if=\"activeModule.status == \'in progress\'\" class=\"text\">{{activeModule.total_points_earned}} / </span><span class=\"text\">{{activeModule.total_points}}</span></div> </div> <div class=\"option-bar\"> <div class=\"video\"><span class=\"icon-video\"></span><span class=\"text\">{{activeModule.duration_completed | minutesHours}} / {{activeModule.duration | minutesHours}} video</span></div> <div class=\"assignment\"><span class=\"icon-assignment\"></span><span class=\"text\">{{activeModule.assignment_duration_completed | minutesHours}} / {{activeModule.assignment_duration | minutesHours}} assignment</span></div> </div> <div class=\"module-progress-bar\"> <div class=\"vid-progress-container\"> <div class=\"vid-progres-buffer\"></div> <div class=\"vid-progres-current-wrp\"> <div ng-style=\"{ \'width\' : activeModule.progress + \'%\'}\" class=\"vid-progres-current\"></div> <div ng-style=\"{ \'left\' : activeModule.progress + \'%\'}\" ng-if=\"activeModule.status == \'in progress\'\" class=\"vid-play-btn\"> <div class=\"play2-icon\"></div> </div> <div ng-style=\"{\'left\' : 1 + \'%\'}\" ng-if=\"activeModule.status == \'not started\'\" class=\"vid-play-btn\"> <div class=\"play2-icon\"></div> </div> </div> </div> </div> <div class=\"links\"><span ng-click=\"blur_msg = true\" class=\"test remove-focus\">PROFICIENCY TEST</span><span class=\"expert\">ASK AN EXPERT</span></div> </div> <div ng-show=\"blur_msg\" class=\"blur-overlay absolute\"> <div class=\"relative\"> <div class=\"message-mobile absolute\"><span>Proficiency Test can only be taken on Web!</span></div> <div class=\"close-blur absolute\"><span ng-click=\"blur_msg = false\" class=\"icon-close remove-focus\"></span></div> </div> </div> </div> <div class=\"playlist-section\"> <div class=\"filter-bar clearfix\"> <div ng-click=\"togglePlaylistFilter = !togglePlaylistFilter\" class=\"show-filter left remove-focus\"><span class=\"text\">Showing All</span><span class=\"icon-filter\"></span></div> <div ng-show=\"togglePlaylistFilter\" class=\"playlist-filter-wrp\"> <div class=\"playlist-filter-item\"> <input type=\"checkbox\" id=\"videoLabel\" checked=\"showVideo\" ng-model=\"showVideo\" ng-change=\"filterItemType(showVideo)\"> <label for=\"videoLabel\" ng-class=\"{&quot;icon-checkbox_inactive&quot;:!showVideo,&quot;icon-checkbox_selected&quot;:showVideo}\" class=\"remove-focus\"></label><span>videos</span> </div> <div class=\"playlist-filter-item\"> <input type=\"checkbox\" id=\"assessmentLabel\" checked=\"assessment\" ng-model=\"assessment\" ng-change=\"filterItemType(assessment)\"> <label for=\"assessmentLabel\" ng-class=\"{&quot;icon-checkbox_inactive&quot;:!assessment,&quot;icon-checkbox_selected&quot;:assessment}\" class=\"remove-focus\"></label><span>assessment</span> </div> <div class=\"playlist-filter-item\"> <input type=\"checkbox\" id=\"resourcesLabel\" checked=\"resources\" ng-model=\"resources\" ng-change=\"filterItemType(resources)\"> <label for=\"resourcesLabel\" ng-class=\"{&quot;icon-checkbox_inactive&quot;:!resources,&quot;icon-checkbox_selected&quot;:resources}\"></label><span>resources</span> </div> <div class=\"playlist-filter-item\"> <input type=\"checkbox\" id=\"caseStudy\" checked=\"caseStudy\" ng-model=\"caseStudy\" ng-change=\"filterItemType(caseStudy)\"> <label for=\"caseStudy\" ng-class=\"{&quot;icon-checkbox_inactive&quot;:!caseStudy,&quot;icon-checkbox_selected&quot;:caseStudy}\"></label><span>case study</span> </div> </div> <div class=\"audio-filter right\"><span>Audio Only</span> <input id=\"cmn-toggle-1\" type=\"checkbox\" class=\"cmn-toggle cmn-toggle-round\"> <label for=\"cmn-toggle-1\"></label> </div> </div> <div ng-repeat=\"item in modulesData | orderBy:\'sequence_id\'\" class=\"playlist-wrp\"> <div ng-if=\"((showVideo &amp;&amp; item.type == \'video\')|| (assessment &amp;&amp; item.type == \'quiz\')||(resources &amp;&amp; item.type == \'resources\')||(caseStudy &amp;&amp; item.type == \'caseStudy\'))\" ng-class=\"{\'playlist-item-completed\': item.status == \'completed\'}\" ng-click=\"startLearnerView(item)\" class=\"playlist-item-wrp remove-focus\"> <div ng-if=\"item.type == \'video\'\" class=\"playlist-item-context\"><span class=\"icon-video\"></span></div> <div ng-if=\"item.type == \'quiz\'\" class=\"playlist-item-context\"><span class=\"icon-quiz\"></span></div> <div ng-if=\"item.type == \'resources\'\" class=\"playlist-item-context\"><span class=\"icon-resources\"></span></div> <div ng-if=\"item.type == \'caseStudy\'\" class=\"playlist-item-context\"><span class=\"icon-assignment\"></span></div> <div class=\"playlist-item-det-wrp\"> <div class=\"playlist-item-title\">{{item.data.title}}</div> <div class=\"playlist-item-time-wrp\"> <div class=\"playlist-item-time-icon\"><span class=\"icon-clock\"></span></div> <div class=\"playlist-item-time-det\">{{item.data.duration}} m</div> </div> </div> <div ng-if=\"item.status == \'completed\'\" class=\"playlist-check-wrp table-cell\"><span class=\"icon-check\"></span></div> </div> <div ng-if=\"((item.status == \'in progress\')&amp;&amp; (showVideo || assessment))\" ng-style=\"{ \'width\' : item.progress + \'%\'}\" class=\"progress-bar\"></div> </div> </div> </div>");
$templateCache.put("app/Features/welcomeScreen/welcomeScreen.html"," <div ng-intro-options=\"IntroOptions\" ng-hints-method=\"startHint\" ng-intro-method=\"CallMe\" ng-intro-oncomplete=\"CompletedEvent\" ng-intro-onexit=\"ExitEvent\" ng-intro-onchange=\"ChangeEvent\" ng-intro-onbeforechange=\"BeforeChangeEvent\" ng-intro-onafterchange=\"AfterChangeEvent\" ng-intro-autostart=\"false\" ng-click=\"passEvent($event)\" class=\"welcome-scrn-page\"> <div class=\"welcome-scrn-hdng-section\"> <div class=\"welcome-scrn-primary-hdng-wrp\"> <div class=\"welcome-scrn-primary-hdng\">Welcome to Rubric</div> </div> <div class=\"welcome-scrn-scnd-hdng-wrp\"> <div class=\"welcome-scrn-scnd-hdng\">by Jigsaw Academy</div> </div> </div> <div class=\"welcome-scrn-det-top-wrp\"> <div class=\"welcome-scrn-det-right-title-wrp table full-width row\"><span class=\"icon-analytics table-cell\"></span><span id=\"lwstep1\">{{lpDataSummary.title}}</span><span style=\"margin-left:5px\" data-hint=\"This is the course assigned to you. We call it the ‘Learning Path’, and the modules within it, ‘Skills’.\" data-hintposition=\"middle\"></span></div> </div> <div class=\"welcome-scrn-det-section row\"> <div class=\"welcome-scrn-det-right-wrp large-8 columns medium-12 small-12\"> <div class=\"welcome-scrn-det-right-content-wrp\"> <div class=\"welcome-scrn-det-right\">{{lpDataSummary.description}}</div> <div class=\"welcome-content-right\"> <div class=\"welcome-scrn-det-deadline-wrp\"><span>Learning Path due date is</span><span ng-if=\"lpAttr.noOfActualMonths &gt;1\" class=\"deadline\">{{lpAttr.lpEndsOn}} ({{lpAttr.noOfMonths | twoDigit}} Months)</span><span ng-if=\"lpAttr.noOfActualMonths &lt;=1\" class=\"deadline\">{{lpAttr.lpEndsOn}} ({{lpAttr.noOfWeeks | twoDigit}} Weeks)</span></div> <div ng-click=\"tNCOverlay=true\" class=\"welcome-scrn-explore-wrp\"><span id=\"vstep1\">Learn What this course can Do for you?</span></div> <div ng-if=\"tNCOverlay\" ng-click=\"closeOverlay($event)\" class=\"upload-tnc-overlay\"> <div ng-click=\"openClosetNCOverlay()\" class=\"upload-tnc-overlay-close remove-focus\"><span class=\"icon-close\"></span></div> <div class=\"upload-tnc-section\"> <div class=\"upload-tnc-heading\"><span>Learning objectives:</span></div> <div ng-bind-html=\"objectives\" style=\"line-height: 19px;text-align:justify;word-break: break-word;padding-left: 17px;\" class=\"upload-tnc-text\"></div> </div> </div> </div> </div> </div> <div class=\"welcome-scrn-det-left-wrp large-4 columns medium-12 small-12\"> <div class=\"welcome-scrn-det-wrp row\"> <div class=\"welcome-scrn-det-item-wrp large-4 columns medium-4 small-4\"> <div class=\"welcome-scrn-det-item\"> <div class=\"welcome-scrn-det-item-inner\"><span>{{lpDataSummary.totalModules}}</span></div> </div> <div class=\"welcome-scrn-det-item-title\">Skills</div> </div> <div class=\"welcome-scrn-det-item-wrp large-4 columns medium-4 small-4\"> <div class=\"welcome-scrn-det-item\"> <div class=\"welcome-scrn-det-item-inner\"><span>{{lpDataSummary.totalVideos}}</span></div> </div> <div class=\"welcome-scrn-det-item-title\">Videos</div> </div> <div class=\"welcome-scrn-det-item-wrp large-4 columns medium-4 small-4\"> <div class=\"welcome-scrn-det-item\"> <div class=\"welcome-scrn-det-item-inner\"><span>{{lpAttr.capstoneDuration}}</span><span class=\"scndtxt\">H</span></div> </div> <div class=\"welcome-scrn-det-item-title\">Capstone Project</div> </div> <div class=\"welcome-scrn-det-item-wrp large-4 columns medium-4 small-4\"> <div class=\"welcome-scrn-det-item\"> <div class=\"welcome-scrn-det-item-inner\"><span>{{lpAttr.lpDayDurationHrs}}</span><span class=\"scndtxt\">H</span></div> </div> <div class=\"welcome-scrn-det-item-title\">LP Duration</div> </div> <div class=\"welcome-scrn columns large-12 medium-12 small-12\"> <div class=\"weclome-txt\">Points earned on average</div> <div class=\"weclome-score-wrp\"><span class=\"icon-star\"></span><span>{{lpDataSummary.totalPoints}}</span></div> </div> </div> </div> </div> <div class=\"welcome-scrn-timeline-wrp\"> <div class=\"welcome-scrn-timeline-wrp-title\">LEARNING PATH TIMELINE</div> <div id=\"lwstep2\" class=\"welcome-scrn-timeline-section\"> <div class=\"welcome-scrn-timeline-dummy clearfix\"> <div class=\"welcome-timeline-commence-wrp left\"> <div class=\"welcome-timeline-commence-hdng\"><span>Learning Path Start Date</span><span style=\"margin-left:5px\" data-hint=\"This is your ‘Timeline’. Click on the numbers to learn more about each of the Skills to be learned.\" data-hintposition=\"middle\"></span></div> <div class=\"welcome-timeline-commence-scnd\">{{lpAttr.lpStartsOn}} (Week 1)</div> </div> <div class=\"welcome-timeline-commence-wrp right\"> <div class=\"welcome-timeline-commence-hdng\">Learning Path Completion Date</div> <div style=\"text-align:right\" class=\"welcome-timeline-commence-scnd\">{{lpAttr.lpEndsOn}} (Week {{lpAttr.noOfWeeks}})</div> </div> </div> <div class=\"welocme-timeline-content-wrp\"> <div class=\"start-buffer\"><span class=\"icon-begin\"></span></div> <ul class=\"week-wrp\"> <li ng-init=\"k=lpAttr.noOfWeeks\" ng-repeat=\"i in getNumberOfWeeks(lpAttr.noOfWeeks) track by $index\" ng-style=\"{ \'width\' : weekWidth}\" class=\"week-strip\"><span ng-if=\"$index == 0\">START</span><span ng-if=\"$index &gt; 1 &amp;&amp; $index % 4 == 0\">W {{$index+1}}</span><span ng-if=\"$index === k-1\" style=\"left: 106%;\">END</span></li> </ul> <div class=\"end-buffer\"><span class=\"icon-finishflag\"></span></div> <div class=\"prposed-timeline-wrp\"> <div ng-style=\"moveLeft(item, $index, lpAttr.allData.length)\" ng-repeat=\"item in lpAttr.allData | orderBy:\'sequenceId\'\" class=\"propses-item-wrp\"> <div ng-click=\"toggleDetails($index);$event.stopPropogation();\" class=\"propses-item remove-focus\"><span>{{item.sequenceId}}</span> <div ng-if=\"$index === activeIndex &amp;&amp; tileOpen\" class=\"propsed-item-details-wrp\"> <div class=\"proposed-tile-arrow\"> <div class=\"proposed-details-wrp\"> <div ng-click=\"toggleDetailsClose();$event.stopPropagation();\" class=\"proposed-close remove-focus\"><span class=\"icon-close\"></span></div> <div ng-if=\"item.type !== &quot;Capstone&quot;\" class=\"proposed-details-wrp-title\">{{item.title}}</div> <div ng-if=\"item.type === &quot;Capstone&quot;\" class=\"proposed-details-wrp-title\">Capstone project</div> <div ng-if=\"item.type !== &quot;Capstone&quot;\" class=\"item-details-wrp\"><span class=\"icon-video\"></span><span>{{item.duration | minutesHours}}</span><span class=\"icon-assignment\"></span><span>{{item.assignmentDuration | minutesHours}}</span></div> <div ng-if=\"item.type === &quot;Capstone&quot;\" class=\"item-details-wrp\"><span class=\"icon-assignment\"></span><span>{{item.duration | minutesHours}}</span></div> <div ng-if=\"item.type !== &quot;Capstone&quot;\" class=\"item-details-msg\">Complete the skill by {{item.expectedEndDate}}</div> <div ng-if=\"item.type === &quot;Capstone&quot;\" class=\"item-details-msg\">Complete the Capstone project by {{lpAttr.lpEndsOn}}</div> </div> </div> </div> </div> </div> </div> </div> </div> </div> <div class=\"welcome-scrn-btn-wrp\"> <div ng-click=\"nextPage()\" class=\"primary_btn\"> <div class=\"txt\">LET’S GO</div> <div class=\"icon-next\"></div> </div> </div> </div>");
$templateCache.put("app/Common/Directives/buyers_primary_progress_bar/buyers_primary_progress_bar.html"," <div class=\"scnd-hdr-progress-bar-wrp\"> <div class=\"primary-bar-hdr-top-wrp table full-width\"> <div class=\"scnd-hdr-progress-bar-current-txt table-cell\"> <div class=\"main\">{{actualCompletion | number:0}} %</div> </div> <div class=\"primary-prog-bar-wrp table-cell\"> <div class=\"scnd-hdr-progress-bar-wrp-outer\"> <div ng-style=\"changePropseWidth()\" class=\"scnd-hdr-progress-bar-wrp-buffer\"></div> <div ng-style=\"changeActualWidth()\" class=\"scnd-hdr-progress-bar-wrp-current\"></div> <div ng-style=\"expctedWidth()\" class=\"progress-bar-wrp-expected\"></div> </div> <div class=\"primary-prog-bar-msg-wrp\"> <div class=\"msg\">You should have been at {{expectedCompletion | number:0}}%</div> </div> </div> </div> </div>");
$templateCache.put("app/Common/Directives/buyers_proficiency_progress_bar/buyers_proficiency_progress_bar.html"," <div class=\"scnd-hdr-progress-bar-wrp\"> <div class=\"prof-bar-current-txt\"> <div class=\"main\">{{testsTaken}} / {{totalTests}} </div> <div class=\"secondary\">Proficiency Tests Passed</div> </div> </div>");
$templateCache.put("app/Common/Directives/errorScreen/errorScreen.html"," <div class=\"error-state-con\"> <div class=\"error-state\"> <div class=\"error-state-wrp\"> <div class=\"gif-wrp\"><img src=\"assets/images/error.gif\"></div> <div class=\"error-msg-wrp\"><span>{{exceptionMessage}}</span></div> <div ng-click=\"goBackToNormalState()\" class=\"btn-wrp remove-focus\"> <button class=\"primary_btn\"><span>go back</span></button> </div> </div> </div> </div>");
$templateCache.put("app/Common/Directives/header/bheader.html"," <div ng-show=\"bheaderShow\" ng-class=\"{\'arrow_box\': $state.name === \'home.library\',\'hdr-lib-color\': libraryState}\" class=\"bheader row\"> <div class=\"bheader-left-logo-wrp columns large-3 medium-2\"> <div class=\"bheader-logo-img\"></div> </div> <div ng-show=\"moduleHeader\" ng-class=\"{\'hdr-lib-color\': libraryState}\" class=\"bheader-module-wrp columns large-3 medium-2\"></div> <div class=\"bheader-right-wrp columns large-5 row cf medium-7\"> <div class=\"bheader-options-wrp\">    <div id=\"step5\" ng-class=\"{&quot;active&quot;: parentObj.isBuyerBurgerMenuActive}\" ng-click=\"parentObj.isBuyerBurgerMenuActive = !parentObj.isBuyerBurgerMenuActive; parentObj.isHammIconClicked = true;\" class=\"bheader-settings-icon burger-menu-icon\"> <ul class=\"bm-icon-con\"> <li class=\"bm-each-bar\"></li> <li class=\"bm-each-bar\"></li> <li class=\"bm-each-bar\"></li> </ul> </div> <div ng-include=\"\" src=\"\'app/Common/Directives/header/templates/buyerBurgerMenu.html\'\" class=\"obela-foo\"></div> </div> </div> </div>");
$templateCache.put("app/Common/Directives/header/header.html"," <div ng-show=\"headerShow\" class=\"header row\"> <div class=\"header-left-logo-wrp columns large-3 medium-2\"> <div ng-click=\"goToDashboard();$event.stopPropagation();\" style=\"cursor: pointer;\" class=\"header-logo-img\"></div> </div> <div ng-show=\"moduleHeader\" ng-class=\"{\'hdr-lib-color\': libraryState}\" style=\"width:50% !important\" class=\"header-module-wrp columns large-4 medium-2\"><span class=\"icon-analytics\"></span> <div ng-class=\"{\'hdr-lib-color\': libraryState}\" ng-click=\"showCurrentLp()\" class=\"scnd-hdr-points module\">Active LP - {{currentLpTitle}}</div> </div> <div class=\"header-right-wrp columns large-5 row cf medium-7\"> <div class=\"header-options-wrp\">  <div ng-if=\"lab == \'yes\'\" ng-click=\"toggleLab()\" ng-class=\"{\'arrow_box\': libraryState &amp;&amp; dashArrow, \'hdr-clr-lib\': libraryState}\" class=\"header-options-txt remove-focus\">Jigsaw Lab</div> </div> <div class=\"header-options-wrp\"> <div ng-click=\"modelParent.bringInNotifications = !modelParent.bringInNotifications;updateNotify(&quot;view&quot;)\" ng-class=\"{\'notification-list-active\': modelParent.bringInNotifications}\" class=\"header-settings-icon\"> <div ng-if=\"notificationCount &gt;0\" class=\"header-notif-count\"><span>{{notificationCount}}</span></div><span ng-class=\"{\'hdr-lib-active\':libraryState}\" class=\"icon-bell\"></span> <div ng-include=\"\" src=\"\'app/Features/notifications/notifications.html\'\" ng-if=\"modelParent.bringInNotifications\" class=\"notifications-overlay\"></div> </div> <div id=\"dstep5\" ng-class=\"{&quot;active&quot;: parentObj.isBurgerMenuActive || libraryState}\" ng-click=\"parentObj.isBurgerMenuActive = !parentObj.isBurgerMenuActive; parentObj.isHammIconClicked = true; fetchMenuHistory();\" class=\"header-settings-icon burger-menu-icon\"> <ul class=\"bm-icon-con\"> <li class=\"bm-each-bar\"></li> <li class=\"bm-each-bar\"></li> <li class=\"bm-each-bar\"></li> </ul><span style=\"margin-top:700px;\" id=\"d-burger\" data-hint=\"Want help? Want to report an issue? Or do you simply want to change your settings? Access your entire menu options here.\" data-hintposition=\"middle\" class=\"d-hints\"></span> </div> <div ng-include=\"\" src=\"\'app/Common/Directives/header/templates/burgerMenu.html\'\" class=\"obela-foo\"></div> </div> </div> </div> <div ng-show=\"scndHdr\" ng-class=\"{\'lib-mob-hdr\':libraryState}\" class=\"scn-hdr-section\"> <div ng-show=\"!libLearnpathstate\" ng-class=\"{\'expand-header\':scndhdrstate &amp;&amp; isClicked, \'collapse-header\':!scndhdrstate &amp;&amp; isClicked}\" class=\"scnd-hdr-wrp row\"> <div id=\"dstep1\" ng-if=\"isActiveLp()\" class=\"scnd-header-content-wrapper\"> <div class=\"scnd-hdr-prof-det clearfix\"> <div class=\"scnd-hdr-dpwrp clearfix\"> <div ng-click=\"goToProfile()\" class=\"scnd-hdr-imgframe left remove-focus\"> <div class=\"scnd-hdr-userimg-con\"> <div id=\"rhombusProfileImage\" class=\"scnd-hdr-userimg\"></div> </div> </div> </div> <div class=\"scnd-hdr-progress-wrp hide-in-mobile\"> <div class=\"scnd-hdr-progress-wrp-dummy\"><span class=\"scnd-hdr-progress-msg\">{{lpAttr.lpProgressMessage}}</span><span ng-if=\"lpAttr.weeksLeft &gt;0\" class=\"scnd-hdr-progress-status\">{{lpAttr.weeksLeft+1}} weeks left</span><span ng-if=\"lpAttr.weeksLeft &lt;1\" class=\"scnd-hdr-progress-status\">{{lpAttr.weeksLeft+1}} week left</span><span style=\"margin-left:5px\" id=\"d-status\" data-hint=\"Track the overall status of your learning here. Click on your Avatar on the left for a closer look at your activity, progress and where you stand on the Leaderboard.\" data-hintposition=\"middle\" class=\"d-hints\"></span></div> <div class=\"scnd-hdr-progress-bar-section\"> <proficiency-progress-bar total-tests=\"10\" proposed-completion=\"3\" actual-completion=\"2\"></proficiency-progress-bar> <primary-progress-bar proposed-completion=\"expectedCompletion\" actual-completion=\"progressDisplay\" expected-completion=\"80\"></primary-progress-bar> </div> </div> </div> <div class=\"scnd-hdr-progress-det-mobile-wrp hide-in-tablet-up\"> <div class=\"scnd-hdr-prog-det-main\"><span ng-click=\"libActivefunc()\" class=\"remove-focus\"><span>{{activeState}}</span><span class=\"icon-dropdown\"></span></span><span ng-show=\"libActive\" ng-click=\"goToInactiveState()\" class=\"library\">{{inactiveState}}</span></div> <div class=\"scnd-hdr-prog-det-sub\">{{modulesData.title}}</div> </div> <div class=\"scnd-hdr-progress-det-mobile-wrp hide-in-tablet-up ham-scnd-hdr\"> <div ng-class=\"{&quot;active&quot;: parentObj.isBurgerMenuActive}\" ng-click=\"parentObj.isBurgerMenuActive = !parentObj.isBurgerMenuActive; parentObj.isHammIconClicked = true; parentObj.isSearchBoxFocussed = false;fetchMenuHistory();\" class=\"scnd-hdr-prog-mob-ham-menu\"> <ul class=\"bm-icon-con\"> <li class=\"bm-each-bar\"></li> <li class=\"bm-each-bar\"></li> <li class=\"bm-each-bar\"></li> </ul> <div class=\"scnd-hdr-notif-mobile\"><span>3</span></div> </div> <div ng-include=\"\" src=\"\'app/Common/Directives/header/templates/burgerMenu.html\'\" class=\"obela-foo\"></div> </div> <div class=\"scnd-hdr-progress-det hide-for-small-only right\"> <div class=\"scnd-hdr-dummy\"> <div ng-click=\"expndProgressbar()\" class=\"scnd-hdr-points-wrp clearfix remove-focus\"> <div class=\"scnd-hdr-expnd-dwnwrp\"><span ng-class=\"scndhdrstate ? \'icon-collapse\' : \'icon-expand\'\"></span></div> </div> <div class=\"scnd-hdr-points-wrp module-wrp\">  <div class=\"scnd-hdr-points module\"><span>TIMELINE VIEW</span></div> </div> <div class=\"scnd-hdr-points-wrp\"><span style=\"margin-right:25px\" id=\"d-point\" data-hint=\"Earn points while you learn! You have already gained points by just setting up your profile.\" data-hintposition=\"middle\" class=\"d-hints\"></span><span class=\"icon-star\"></span> <div class=\"scnd-hdr-points\"><span id=\"dstep2\">{{lpAttr.summary.totalPointsEarned}}</span></div> </div> </div> </div> <div ng-show=\"scndhdrstate\" ng-class=\"{\'adjust-to-bottom\':scndhdrstate}\" class=\"scnd-hdr-wrp-expand\"> <user-progress-bar lp-data=\"modulesData\" open-next-flow=\"startVideo(module);\"></user-progress-bar> </div> </div> <div id=\"dstep1\" ng-if=\"!isActiveLp()\" class=\"scnd-header-old-lp\"> <div class=\"clearfix\"> <div class=\"first-div\"><span class=\"title\">{{prevLpData.title}}</span><span class=\"lp-progress\">{{prevLpData.progress.toFixed(2)}}% COMPLETED</span></div> <div class=\"right-div\"><span class=\"status\"><img ng-if=\"lpCertificates!==1\" src=\"../assets/Icons/Alert_icon.svg\"><img ng-if=\"lpCertificates===1\" src=\"../assets/Icons/check.svg\">{{prevLpData.status}}</span><span class=\"points\"> <span class=\"icon-star\"></span>{{prevLpData.totalPointsEarned}}</span></div> <div class=\"second-div\"><span>SKILLS CERTIFICATES EARNED - <span class=\"fraction\">{{NoOfSkillCertificates}} / {{prevLpData.totalModules}}</span></span><span class=\"lp-cert\">LEARNING PATH CERTIFICATE - <span class=\"fraction\">{{lpCertificates}} / 1 </span></span></div> <div class=\"header-bottom\"><span>Archived on {{formatTime(prevLpData.actualEndTime)}}</span></div> </div> </div> </div> <div ng-if=\"libLearnpathstate\" class=\"scnd-hdr-wrp row\"></div> </div>");
$templateCache.put("app/Common/Directives/libPlaylist/libPlaylist.html"," <div class=\"vid-vidplaylist-title-wrp table full-width\"> <div class=\"vid-vidplaylist-top-wrp table-cell\"> <div class=\"vid-vidplaylist-title-dummy table full-width\"> <div class=\"vid-vidplaylist-title-no table-cell\">{{playlist.playlistDataID | twoDigit}}.</div> <div class=\"vid-vidplaylist-title-txt table-cell\">{{playlist.title}}</div> </div> </div> </div> <div class=\"lib-playlist-scroll\"> <div class=\"lib-dummy-wrp\"> <div class=\"lib-exs-playlist-content-wrp\"> <div ng-repeat=\"item in playlist.playlistData\" class=\"lib-item-dummy\"> <div ng-if=\"item.type === &quot;module&quot;\" ng-click=\"openPlaylistModule($index)\" class=\"lib-exs-playlist-content-item\"> <div class=\"lib-exs-playlist-type\"> <div class=\"lib-exs-playlist-video\"> <div class=\"title\">{{item.moduleName}} </div> </div> <div ng-if=\"$index == crntPlyModule &amp;&amp; openTilePlaylist\" class=\"lib-plylist-cntnt-wrp\"> <div ng-repeat=\"Videos in item.moduleVideos\" ng-click=\"$event.stopPropagation();\" class=\"lib-plylist-cntnt-item table full-width relative\"> <div class=\"vid-vidplaylist-item-context\"><span class=\"icon-video\"></span></div> <div class=\"vid-vidplaylist-item-det-wrp\"> <div class=\"vid-vidplaylist-item-title\">{{Videos.videoTitle}}</div> <div class=\"vid-vidplaylist-item-time-wrp\"> <div class=\"vid-vidplaylist-item-time-img\"><span class=\"icon-clock\"></span></div> <div class=\"vid-vidplaylist-item-time-det\">22 m </div> </div> </div> <div ng-style=\"{ \'width\' :{{Videos.progress}} + \'%\'}\" class=\"lib-plyitem-progress-bar\"></div> </div> </div> </div> </div> <div ng-if=\"item.type === &quot;video&quot;\" class=\"lib-exs-playlist-video-type\"> <div class=\"lib-vid-name\">{{item.videoTitle}}</div> <div class=\"lib-tile-mod-name\">{{item.moduleName}}</div> </div> </div> </div> </div> </div>");
$templateCache.put("app/Common/Directives/libraryTile/libraryTile.html"," <div ng-click=\"toggleTileContent()\" ng-class=\"expandClass\" class=\"lib-page-history-item remove-focus\"> <div ng-class=\"{&quot;prog-badge-active&quot;: tileInfo.isCliked}\" class=\"lib-tile-dummy\"> <div class=\"skill-pg-tile-top lib-page-history-item-top\"> <div class=\"clearfix relative\"> <div title=\"{{tileInfo.title}}\" class=\"item-title left\"> {{tileInfo.title}}</div> <div class=\"skill-tile-view-info clearfix absolute\"> <div class=\"txt right\">{{tileInfo.moduleViews}}</div> <div class=\"icon icon-view right\"></div> </div> </div> <div class=\"item-info\"><span class=\"icon icon-clock\"></span><span class=\"txt\">{{tileInfo.duration | minutesHours}}</span></div> </div> <div class=\"vid-progress-container lib-page-item-progress-wrp\"> <div class=\"vid-progres-buffer\"></div> </div> <div class=\"lib-page-hist-bottom-wrp clearfix\"> <div ng-click=\"goToLibVideo()\" class=\"view-info left\"> <div class=\"icon play2-icon\"></div> </div> <div ng-click=\"openTileOverlay();$event.stopPropagation();\" class=\"view-info right remove-focus\"> <div title=\"Show Playlist options\" class=\"icon icon-add\"></div> </div> </div> </div> <div ng-if=\"shwOverlay\" ng-click=\"$event.stopPropagation();\" class=\"skill-tile-overlay-wrp\"> <div class=\"skill-tile-overlay-blur\"> </div> <div ng-if=\"Tilestate != &quot;createPlaylist&quot;\" class=\"skill-tile-overlay-content\"> <div ng-click=\"openAddPlaylist()\" class=\"skill-tile-overlay-item clearfix\"> <div class=\"txt left\">Add to Playlist</div> <div ng-class=\"{\'icon-up\':shwPlaylistItems,\'icon-down\':!shwPlaylistItems}\" class=\"icon right\"></div> <ul ng-if=\"shwPlaylistItems\"> <li ng-repeat=\"playlist in playlists\" ng-click=\"addModuleToPlaylist(playlist.playlistDataID);$event.stopPropagation();\" class=\"remove-focus\"> <div class=\"skill-tile-play-item-wrp\"> <div class=\"txt\">{{playlist.title}} </div> </div> </li> </ul> </div> <div ng-click=\"createPlaylist();$event.stopPropagation();\" ng-if=\"Tilestate != &quot;addToPlaylist&quot;\" class=\"skill-tile-overlay-item clearfix\"> <div class=\"txt left\">Create New Playlist</div> </div> <div ng-click=\"openTileOverlay();$event.stopPropagation();\" ng-if=\"Tilestate != &quot;addToPlaylist&quot;\" class=\"skil-close-overlay remove-focus\"> <div title=\"Hide Playlist options\" class=\"icon icon-delete2\"></div> </div> </div> <div ng-if=\"Tilestate == &quot;createPlaylist&quot;\" class=\"skill-tile-overlay-content\"> <div class=\"create-playlist-tile-wrp\"> <div ng-click=\"closeCreatePlaylist();$event.stopPropagation();\" class=\"create-playlist-icon clearfix\"> <div class=\"icon-close right\"></div> </div> <div class=\"create-playlist-input\"> <input ng-model=\"playlistName\" placeholder=\"playlist name\"> </div> <div class=\"create-playlist-btn-wrp text-center absolute\"> <div class=\"create-playlist-btn\"> <div ng-click=\"closeCreatePlaylist();$event.stopPropagation();\" class=\"tertiary_color remove-focus\">Cancel</div> </div> <div class=\"create-playlist-btn\"> <div class=\"primary_btn\">Save </div> </div> </div> </div> </div> </div> <div ng-if=\"tileInfo.isCliked\" class=\"lib-tile-arrow-wrp\"><img ng-src=\"assets/images/icon_down.png\" class=\"icon\"></div> <div ng-show=\"tileInfo.isCliked\" ng-click=\"$event.stopPropagation()\" class=\"lib-cont-watching-wrp\"> <div class=\"lib-tile-bg clearfix\"> <div class=\"module-title-wrp clearfix\"> <div ng-click=\"goToLibVideo()\" class=\"icon\"> <div class=\"play2-icon\"></div> </div> <div class=\"info-wrp\"> <div class=\"module-title\">{{tileInfo.title}}</div> <div class=\"module-desc hide-in-mobile\">{{tileInfo.description}}</div> </div> <div class=\"mod-points-wrp\"> <div class=\"dummy-wrp clearfix\"> <div class=\"score-wrp table left\"> <div class=\"icon-star table-cell\"></div> <div class=\"score table-cell\">{{tileInfo.total_points}}</div> </div> <div ng-click=\"openTileOverlay();$event.stopPropagation();\" class=\"icon-add right\"></div> </div> </div> </div> <div class=\"lib-module-content-wrp\"> <div class=\"skil-pg-title\"> {{tileInfo.module_resources.length}} Videos</div> <div class=\"lib-module-list-section\"> <div ng-repeat=\"video in tileInfo.module_resources\" ng-show=\"shwThreeMore &gt; $index\" class=\"lib-module-table-item table full-width\"> <div ng-click=\"goToLibVideo()\" class=\"lib-icon table-cell\"> <div class=\"icon play2-icon\"></div> </div> <div class=\"lib-item-module-name table-cell\">{{video.title}}</div> <div class=\"lib-item-time-wrp table-cell hide-in-mobile\"> <div class=\"icon icon-clock\"></div> <div class=\"time-wrp\">{{video.duration_completed | minutesHours}} / {{video.duration | minutesHours}}</div> </div> <div ng-click=\"openAddPlaylistVideo(video ,$index)\" class=\"lib-item-add-wrp table-cell remove-focus relative\"> <div class=\"icon icon-add\"></div> <div ng-if=\"currentVideoItem == $index &amp;&amp; shwVideoTileOpt\" class=\"add-to-plylist-wrp\"> <div class=\"add-to-plylist-tile-arrow\"> <div class=\"dummy-container\"> <div ng-if=\"!toggleCreatePlaylist\" class=\"add-plylist-section\"> <div ng-click=\"openAddPlaylistTile();$event.stopPropagation();\" class=\"add-plylist-tile-item clearfix\"> <div class=\"txt left\">Add to Playlist</div> <div class=\"icon icon-next right\"></div> <ul ng-if=\"openTileOpt\"> <li ng-repeat=\"playlist in playlists\" ng-click=\"addVideoToPlaylist(playlist.playlistDataID ,video);$event.stopPropagation();\" class=\"remove-focus\"> <div class=\"skill-tile-play-item-wrp\"> <div class=\"txt\">{{playlist.title}} </div> </div> </li> </ul> </div> <div ng-click=\"createPlaylistTile();$event.stopPropagation();\" class=\"add-plylist-tile-item clearfix\"> <div class=\"txt left\">Create Playlist</div> <div class=\"icon icon-next right\"></div> </div> </div> <div ng-if=\"toggleCreatePlaylist\" class=\"add-plylist-section\"> <div class=\"create-playlist-tile-wrp\"> <div ng-click=\"closeCreatePlaylistTile();$event.stopPropagation();\" class=\"create-playlist-icon clearfix\"> <div class=\"icon-close right\"></div> </div> <div class=\"create-playlist-input\"> <input ng-model=\"playlistName\" placeholder=\"playlist name\"> </div> <div class=\"create-playlist-btn-wrp text-center absolute\"> <div class=\"create-playlist-btn\"> <div ng-click=\"closeCreatePlaylistTile();$event.stopPropagation();\" class=\"tertiary_color remove-focus\">Cancel</div> </div> <div class=\"create-playlist-btn\"> <div class=\"primary_btn\">Save </div> </div> </div> </div> </div> </div> </div> </div> </div> </div> <div ng-click=\"shwMoreContent()\" ng-if=\"tileInfo.module_resources.length &gt; shwThreeMore\" class=\"lib-module-list-link remove-focus\"> <div class=\"txt\">View More</div> </div> <div ng-click=\"shwLessContent()\" ng-if=\"tileInfo.module_resources.length &lt;= shwThreeMore\" class=\"lib-module-list-link remove-focus\"> <div class=\"txt\">View Less </div> </div> </div> </div> </div> </div> <div ng-if=\"tileInfo.isCliked\" class=\"lib-tile-trnsprnt\"></div> </div>");
$templateCache.put("app/Common/Directives/libraryTileModule/libraryModuleTile.html"," <div ng-click=\"toggleTileContent()\" ng-class=\"expandClass\" class=\"lib-page-history-item remove-focus\"> <div ng-class=\"{&quot;prog-badge-active&quot;: tileInfo.isCliked}\" class=\"lib-mod-tile-dummy\"> <div class=\"skill-pg-tile-top lib-page-history-item-top\"> <div class=\"clearfix relative\"> <div title=\"{{tileInfo.title}}\" class=\"item-title left\"> {{tileInfo.title}}</div> </div> <div class=\"item-info\"><span class=\"icon icon-clock\"></span><span class=\"txt\">{{tileInfo.duration | minutesHours}}</span></div> </div> <module-progress-bar progressbardata=\"tileInfo.progress\"></module-progress-bar> <div class=\"lib-page-hist-bottom-wrp clearfix\"> <div class=\"view-info left\"> <div class=\"icon icon-view\"></div> <div class=\"txt\">{{tileInfo.moduleViews}}</div> </div> <div ng-click=\"openTileOverlay();$event.stopPropagation();\" class=\"view-info right remove-focus\"> <div title=\"Show Playlist options\" class=\"icon icon-add\"></div> </div> </div> <div ng-if=\"shwOverlay\" ng-click=\"$event.stopPropagation();\" class=\"skill-tile-overlay-wrp\"> <div class=\"skill-tile-overlay-blur\"> </div> <div ng-if=\"Tilestate != &quot;createPlaylist&quot;\" class=\"skill-tile-overlay-content\"> <div ng-click=\"openAddPlaylist()\" class=\"skill-tile-overlay-item clearfix\"> <div class=\"txt left\">Add to Playlist</div> <div ng-class=\"{\'icon-up\':shwPlaylistItems,\'icon-down\':!shwPlaylistItems}\" class=\"icon right\"></div> <ul ng-if=\"shwPlaylistItems\"> <li ng-repeat=\"playlist in playlists\" ng-click=\"addModuleToPlaylist(playlist.playlistDataID);$event.stopPropagation();\" class=\"remove-focus\"> <div class=\"skill-tile-play-item-wrp\"> <div class=\"txt\">{{playlist.title}} </div> </div> </li> </ul> </div> <div ng-click=\"createPlaylist();$event.stopPropagation();\" ng-if=\"Tilestate != &quot;addToPlaylist&quot;\" class=\"skill-tile-overlay-item clearfix\"> <div class=\"txt left\">Create New Playlist</div> </div> <div ng-click=\"openTileOverlay();$event.stopPropagation();\" ng-if=\"Tilestate != &quot;addToPlaylist&quot;\" class=\"skil-close-overlay remove-focus\"> <div title=\"Hide Playlist options\" class=\"icon icon-delete2\"></div> </div> </div> <div ng-if=\"Tilestate == &quot;createPlaylist&quot;\" class=\"skill-tile-overlay-content\"> <div class=\"create-playlist-tile-wrp\"> <div ng-click=\"closeCreatePlaylist();$event.stopPropagation();\" class=\"create-playlist-icon clearfix\"> <div class=\"icon-close right\"></div> </div> <div class=\"create-playlist-input\"> <input ng-model=\"playlistName\" placeholder=\"playlist name\"> </div> <div class=\"create-playlist-btn-wrp text-center absolute\"> <div class=\"create-playlist-btn\"> <div ng-click=\"closeCreatePlaylist();$event.stopPropagation();\" class=\"tertiary_color remove-focus\">Cancel</div> </div> <div class=\"create-playlist-btn\"> <div class=\"primary_btn\">Save </div> </div> </div> </div> </div> </div> </div> <div ng-if=\"tileInfo.isCliked\" class=\"lib-tile-arrow-wrp\"><img ng-src=\"assets/images/icon_down.png\" class=\"icon\"></div> <div ng-show=\"tileInfo.isCliked\" ng-click=\"$event.stopPropagation()\" class=\"lib-cont-watching-wrp\"> <div class=\"lib-cont-module-section\"> <div class=\"clearfix\"> <div class=\"module-title-wrp clearfix\"> <div ng-click=\"goToLibVideo()\" class=\"icon\"> <div class=\"play2-icon\"></div> </div> <div class=\"info-wrp\"> <div class=\"module-title\">{{tileInfo.title}}</div> <div class=\"module-desc hide-in-mobile\">{{tileInfo.description}}</div> </div> <div class=\"mod-points-wrp\"> <div class=\"dummy-wrp clearfix\"> <div class=\"score-wrp table left\"> <div class=\"icon-star table-cell\"></div> <div class=\"score table-cell\">{{tileInfo.total_points}}</div> </div> <div ng-click=\"openTileOverlay();$event.stopPropagation();\" class=\"icon-add right\"></div> </div> </div> </div> <div class=\"lib-module-content-wrp\"> <div class=\"skil-pg-title\"> {{tileInfo.module_resources.length}} Videos</div> <div class=\"lib-module-list-section\"> <div ng-repeat=\"video in tileInfo.module_resources\" ng-show=\"shwThreeMore &gt; $index\" class=\"lib-module-table-item table full-width\"> <div ng-click=\"goToLibVideo()\" class=\"lib-icon table-cell\"> <div class=\"icon play2-icon\"></div> </div> <div class=\"lib-item-module-name table-cell\">{{video.title}}</div> <div class=\"lib-item-time-wrp table-cell hide-in-mobile\"> <div class=\"icon icon-clock\"></div> <div class=\"time-wrp\">{{video.duration_completed | minutesHours}} / {{video.duration | minutesHours}}</div> </div> <div ng-click=\"openAddPlaylistVideo(video ,$index)\" class=\"lib-item-add-wrp table-cell remove-focus relative\"> <div class=\"icon icon-add\"></div> <div ng-if=\"currentVideoItem == $index &amp;&amp; shwVideoTileOpt\" class=\"add-to-plylist-wrp\"> <div class=\"add-to-plylist-tile-arrow\"> <div class=\"dummy-container\"> <div ng-if=\"!toggleCreatePlaylist\" class=\"add-plylist-section\"> <div ng-click=\"openAddPlaylistTile();$event.stopPropagation();\" class=\"add-plylist-tile-item clearfix\"> <div class=\"txt left\">Add to Playlist</div> <div class=\"icon icon-next right\"></div> <ul ng-if=\"openTileOpt\"> <li ng-repeat=\"playlist in playlists\" ng-click=\"addVideoToPlaylist(playlist.playlistDataID ,video);$event.stopPropagation();\" class=\"remove-focus\"> <div class=\"skill-tile-play-item-wrp\"> <div class=\"txt\">{{playlist.title}} </div> </div> </li> </ul> </div> <div ng-click=\"createPlaylistTile();$event.stopPropagation();\" class=\"add-plylist-tile-item clearfix\"> <div class=\"txt left\">Create Playlist</div> <div class=\"icon icon-next right\"></div> </div> </div> <div ng-if=\"toggleCreatePlaylist\" class=\"add-plylist-section\"> <div class=\"create-playlist-tile-wrp\"> <div ng-click=\"closeCreatePlaylistTile();$event.stopPropagation();\" class=\"create-playlist-icon clearfix\"> <div class=\"icon-close right\"></div> </div> <div class=\"create-playlist-input\"> <input ng-model=\"playlistName\" placeholder=\"playlist name\"> </div> <div class=\"create-playlist-btn-wrp text-center absolute\"> <div class=\"create-playlist-btn\"> <div ng-click=\"closeCreatePlaylistTile();$event.stopPropagation();\" class=\"tertiary_color remove-focus\">Cancel</div> </div> <div class=\"create-playlist-btn\"> <div class=\"primary_btn\">Save </div> </div> </div> </div> </div> </div> </div> </div> </div> </div> <div ng-click=\"shwMoreContent()\" ng-if=\"tileInfo.module_resources.length &gt; shwThreeMore\" class=\"lib-module-list-link remove-focus\"> <div class=\"txt\">View More</div> </div> <div ng-click=\"shwLessContent()\" ng-if=\"tileInfo.module_resources.length &lt;= shwThreeMore\" class=\"lib-module-list-link remove-focus\"> <div class=\"txt\">View Less </div> </div> </div> </div> </div> </div> </div> <div ng-if=\"tileInfo.isCliked\" class=\"lib-cont-dummy\"></div> </div>");
$templateCache.put("app/Common/Directives/loadingState/loadingState.html"," <div class=\"loading-state-con\"> <div class=\"loading-state\"> <div class=\"loading-state-wrp\"> <div class=\"gif-wrp\"><img src=\"assets/images/loading.gif\"></div> </div> </div> </div>");
$templateCache.put("app/Common/Directives/moduleProgressBar/moduleProgressBar.html"," <div class=\"vid-progress-container lib-page-item-progress-wrp\"> <div class=\"vid-progres-buffer\"></div> <div class=\"vid-progres-current-wrp\"> <div ng-style=\"{ \'width\' : {{progressbardata}} + \'%\'}\" ng-class=\"{\'played-full\' :progressbardata == 100}\" class=\"vid-progres-current\"></div> <div ng-style=\"{\'right\' : 8 + \'%\'}\" ng-if=\"progressbardata == 100\" class=\"vid-play-btn rplay played-full\"><span class=\"icon-replay\"></span></div> <div ng-style=\"{ \'left\' : \'calc(\'+{{progressbardata}}+\'% \' + \'- 12.5px\'+\')\'}\" ng-if=\"progressbardata &lt;= 90 &amp;&amp; progressbardata &gt;= 0\" class=\"vid-play-btn\"> <div class=\"play2-icon\"></div> </div> <div ng-style=\"moveLeft(progressbardata)\" ng-if=\"progressbardata &gt; 90 &amp;&amp; progressbardata != 100\" class=\"vid-play-btn\"> <div class=\"play2-icon\"> </div> </div> </div> </div>");
$templateCache.put("app/Common/Directives/overlay/overlay.html"," <div ng-class=\"overlayPlayIcon\" class=\"vid-player-overlay-section remove-focus\"> <div class=\"vid-player-overlay-default\"> <div class=\"vid-player-overlay-hdng-wrp table\"> <div ng-click=\"goToDashboard();$event.stopPropagation();\" class=\"vid-player-overlay-back table-cell remove-focus hide-in-mobile\"><span class=\"icon-back\"></span></div> <div ng-click=\"bookmarkVideo();$event.stopPropagation();\" class=\"vid-player-overlay-bookmark table-cell remove-focus\"><span ng-class=\"{\'active\': bookmarked}\" class=\"icon-bookmark\"></span></div> <div class=\"vid-player-overlay-title table-cell hide-in-mobile\">{{activeModuleData.metaData.title}}</div> <div ng-show=\"!takeNotesToggle\" class=\"vid-player-overlay-title table-cell hide-in-tablet-up\">{{activeModuleData.metaData.title}}</div> <div ng-show=\"takeNotesToggle &amp;&amp; !shwMobOptions || isSeeking\" class=\"vid-trim-mob-wrp table-cell hide-in-tablet-up\"> <div class=\"vid-player-overlay-ftns-wrp\"> <div ng-click=\"mobileTrimVideo();$event.stopPropagation();\" class=\"vid-player-overlay-ftns\"><span class=\"icon-trim\"></span></div> <div ng-click=\"mobileTrimNotes();$event.stopPropagation();\" class=\"vid-player-overlay-ftns\"><span class=\"icon-takenotes\"></span></div> </div> </div> <div class=\"vid-player-right-optns-wrp table-cell\"> <div ng-click=\"mobileVideoOptions();$event.stopPropagation();\" ng-show=\"takeNotesToggle\" class=\"vid-player-default-opt-item hide-in-tablet-up remove-focus\"><span ng-class=\"{\'active\': shwMobOptions}\" class=\"icon-menu\"></span></div> <div ng-click=\"reportIssueFunc();$event.stopPropagation();\" class=\"vid-player-default-opt-item relative hide-in-mobile remove-focus\"><span ng-class=\"{\'active\': shwMobOptions}\" class=\"icon-reportissue\"></span> <div ng-show=\"expandedReportIssue\" ng-init=\"riFullView=false\" class=\"vid-report-issue-expanded-wrp absolute\"> <div class=\"ri-vid-arrow relative\"> <div class=\"clearfix ri-header-wrp\"> <div class=\"left\">report an issue</div> <div ng-click=\"reportIssueFunc();$event.stopPropagation();\" class=\"right remove-focus\"><span class=\"icon-close\"></span></div> </div> <div ng-hide=\"riFullView\" class=\"ri-options-wrp\"> <div ng-click=\"showRIssuesExpanded(&quot;video&quot;);$event.stopPropagation();\" class=\"clearfix ri-options remove-focus\"> <div class=\"left\">Video problem</div> <div class=\"right\"><span class=\"icon-next\"></span></div> </div> <div ng-click=\"showRIssuesExpanded(&quot;sound&quot;);$event.stopPropagation();\" class=\"clearfix ri-options remove-focus\"> <div class=\"left\">Sound problem</div> <div class=\"right\"><span class=\"icon-next\"></span></div> </div> <div ng-click=\"showRIssuesExpanded(&quot;transcript&quot;);$event.stopPropagation();\" class=\"clearfix ri-options remove-focus\"> <div class=\"left\">Transcript problem</div> <div class=\"right\"><span class=\"icon-next\"></span></div> </div> <div ng-click=\"showRIssuesExpanded(&quot;labelling&quot;);$event.stopPropagation();\" class=\"clearfix ri-options remove-focus\"> <div class=\"left\">Labelling problem</div> <div class=\"right\"><span class=\"icon-next\"></span></div> </div> <div ng-click=\"showRIssuesExpanded(&quot;buffering&quot;);$event.stopPropagation();\" class=\"clearfix ri-options remove-focus\"> <div class=\"left\">Buffering or Connection problem</div> <div class=\"right\"><span class=\"icon-next\"></span></div> </div> </div> <div ng-show=\"riFullView\" class=\"ri-options-full-view-wrp\"> <div ng-click=\"resetRadioModel();$event.stopPropagation();\" class=\"ri-full-view-header\"><span class=\"icon-back\"></span><span>{{problemSelected}} problem</span></div> <div ng-repeat=\"issue in selectedIssue\" class=\"ri-full-view-issues\"> <input type=\"radio\" id=\"issue{{issue.type}}\" ng-model=\"selectedIssue.issueName\" value=\"{{issue.type}}\" checked=\"selectedIssue.issueName === issue.type\"> <label for=\"issue{{issue.type}}\" class=\"remove-focus\"></label><span>{{issue.type}}</span> </div> <div class=\"ri-send-button-wrp\"><span ng-click=\"sendRIssue();$event.stopPropagation();\" class=\"primary_btn remove-focus\">send</span></div> </div> </div> </div> </div> </div> </div> <div ng-class=\"overlayPlayIcon\" ng-show=\"!takeNotesToggle || isSeeking\" class=\"vid-player-overlay-dummy hide-in-mobile\"> <div class=\"vid-player-overlay-play\"><span class=\"icon-play\"></span></div> </div> <div ng-class=\"overlayPlayIcon\" ng-show=\"!takeNotesToggle || isSeeking\" class=\"vid-player-overlay-dummy hide-in-tablet-up\"> <div class=\"vid-player-overlay-play\"><span class=\"icon-play\"></span></div> </div> <div ng-show=\"takeNotesToggle &amp;&amp; !isSeeking\" class=\"vid-player-overlay-ftns-section table hide-in-mobile\"> <div class=\"vid-takenot-dummy table-cell\"> <div class=\"vid-player-overlay-ftns-wrp\"> <div ng-class=\"{\'ftns-active\': trimOpt}\" ng-click=\"trimOption();$event.stopPropagation();\" class=\"vid-player-overlay-ftns\"><span class=\"icon-trim\"></span></div> <div ng-class=\"{\'ftns-active\': notesOpt}\" ng-click=\"notesOption();$event.stopPropagation();\" class=\"vid-player-overlay-ftns\"><span class=\"icon-takenotes\"></span></div> <div ng-class=\"{\'ftns-active\': askExpertOpt}\" ng-click=\"askExpertOption();$event.stopPropagation();\" class=\"vid-player-overlay-ftns\"><span class=\"icon-askanexpert\"></span></div> </div> <div ng-click=\"$event.stopPropagation();\" ng-show=\"trimOpt\" class=\"vid-player-overlay-optns-wrp remove-focus\"> <div class=\"vid-play-overlay-feature-wrp\"> <div class=\"vid-player-incl-trsncrpt-wrp table\"> <div class=\"vid-player-incl-trscrpt-chkbox table-cell\"> <input id=\"inclTrscpt\" type=\"checkbox\" ng-model=\"inclTrscpt\" checked=\"inclTrscpt\"> <label for=\"inclTrscpt\" ng-class=\"{&quot;icon-checkbox_inactive&quot;:!inclTrscpt,&quot;icon-checkbox_selected&quot;:inclTrscpt}\" class=\"remove-focus\"></label><span>Include Transcript</span> </div> <div ng-click=\"trimVideoCall()\" class=\"primary_btn table-cell\">Save</div> </div> <div class=\"vid-overlay-trim-wrp\"> <div class=\"vid-overlay-slider-section table full-width\"> <div ng-click=\"trimRewind();$event.stopPropagation();\" class=\"vid-overlay-slider-cntrl-wrp table-cell remove-focus\"><span class=\"icon-back\"></span></div> <div class=\"vid-overlay-slider-img-wrp table-cell\"> <div class=\"trim-bg-img\"><img img-width-thumbnail=\"img-width-thumbnail\" ng-src=\"assets/strip.jpg\" class=\"thumbnails-img\"> <div range-slider=\"range-slider\" min=\"sliderMin\" max=\"sliderMax\" model-max=\"sliderModelMax\" model-min=\"sliderModelMin\" disabled=\"sliderDisabled\" on-handle-down=\"sliderHandleGrab()\" on-handle-up=\"sliderHandleRelease()\" class=\"slider-dummy\"></div> <div class=\"slider-left-blurred\"> <div class=\"video-slider-min\"><span>{{sliderModelMin | transcriptTime}}</span></div> </div> <div class=\"slider-right-blurred\"> <div class=\"video-slider-max\"><span>{{sliderModelMax | transcriptTime}} </span></div> </div> </div> </div> <div ng-click=\"trimMoveAhead();$event.stopPropagation();\" class=\"vid-overlay-slider-cntrl-wrp table-cell remove-focus\"><span class=\"icon-next\"> </span></div> </div> </div> </div> <div class=\"vid-play-overlay-feature-wrp\"></div> <div class=\"vid-play-overlay-feature-wrp\"></div> </div> <div ng-show=\"notesOpt\" ng-click=\"$event.stopPropagation();\" class=\"vid-player-overlay-optns-wrp remove-focus\"> <div class=\"vid-take-note-wrp clearfix full-width\"> <div class=\"left width-fifty-percent vertical-align-top notes-wrp\"> <div class=\"vid-take-note-title-wrp\"> <div contenteditable=\"true\" ng-hide=\"ShwEditTakeNotesTitle\" ng-model=\"takeNoteTitle\" class=\"vid-take-note-title remove-focus\">{{ takeNoteTitle }}</div> <div ng-show=\"ShwEditTakeNotesTitle\" class=\"input-field-container inline-block\"> <input type=\"text\" ng-model=\"takeNoteTitle\"><span ng-if=\"takeNoteTitle.length &gt; 0\" ng-click=\"cleartakeNoteTitle()\" class=\"icon-remove remove-focus\"></span> </div> <div ng-click=\"editTakeNotesTitle()\" class=\"vid-take-note-title-edit remove-focus\"><span class=\"icon-notes\"></span></div> </div> <div class=\"vid-take-notes-edit-wrp relative\"> <textarea type=\"text\" placeholder=\"Take notes\" ng-model=\"takeNoteModel\" ng-change=\"takeNoteChange()\"></textarea><span ng-if=\"takeNoteModel.length &gt; 0\" ng-click=\"clearTakeNotes()\" class=\"icon-remove remove-focus\"></span> </div> </div> <div class=\"left width-fifty-percent transcript-section\"> <div class=\"vid-take-note-save\"> <div ng-click=\"takeNoteSave()\" class=\"primary_btn\">Save</div> </div> <div class=\"vid-take-note-preload-section\"> <div class=\"vid-player-incl-trsncrpt-wrp table\"> <div class=\"vid-player-incl-trscrpt-chkbox table-cell\"> <input id=\"inclTrscptTakeNotes\" type=\"checkbox\" ng-model=\"inclTrscptTakeNotes\" checked=\"inclTrscptTakeNotes\"> <label for=\"inclTrscptTakeNotes\" ng-class=\"{&quot;icon-checkbox_inactive&quot;:!inclTrscptTakeNotes,&quot;icon-checkbox_selected&quot;:inclTrscptTakeNotes}\" class=\"remove-focus\"></label><span>Include Transcript</span> </div> </div> <div ng-show=\"inclTrscptTakeNotes\" class=\"vid-take-note-preload-wrp table\"> <div class=\"vid-take-note-time-wrp table-cell\"> <div class=\"vid-time-take-note-dummy table\"><span class=\"icon-clock table-cell\"></span> <div class=\"vid-take-note-time table-cell\">{{activeTime | transcriptTime}} </div> </div> </div> <div class=\"vid-take-note-preload-text table-cell\"><span ng-repeat=\"sentence in paragraph\">{{sentence}}</span></div> </div> </div> </div> </div> </div> <div ng-show=\"askExpertOpt\" ng-click=\"$event.stopPropagation();\" class=\"vid-player-overlay-optns-wrp remove-focus\"> <div class=\"vid-player-ask-expert-wrp\"> <div class=\"vid-player-ask-expert-faq-wrp remove-focus\"> <div class=\"vid-player-faq-heading-wrp\"><span>FREQUENTLY ASKED QUESTIONS</span></div> <div class=\"vid-player-faq-ques-wrp\"> <div ng-repeat=\"question in askExpertData.frequentlyAskedQuestions\" class=\"vid-player-faq\"> <div ng-click=\"selectedFAQ(question)\" class=\"vid-player-faq-ques remove-focus clearfix\"><span class=\"left\">Q - {{question.question}}</span><span ng-if=\"question.answered\" class=\"right icon-check\"></span><span ng-if=\"!question.answered\" class=\"right icon-repost\"></span></div> </div> </div> </div> <div class=\"vid-player-ask-expert-question-wrp relative\"> <div ng-click=\"unableEditFunc()\" class=\"ask-expert-wrp remove-focus\"> <div class=\"transcript-title-wrp clearfix\"> <div ng-hide=\"editTitle\" class=\"transcript-wrp left\"><span>{{questionTitle}}</span></div> <div ng-show=\"editTitle\" ng-click=\"$event.stopPropagation();\" class=\"transcript-new-tilte-wrp input-field-container left\"> <input type=\"text\" ng-model=\"questionTitle\" ng-change=\"$event.stopPropagation();\"><span ng-if=\"questionTitle.length &gt; 0\" ng-click=\"clearAskExpertTitle()\" class=\"icon-remove remove-focus\"></span> </div> <div ng-click=\"editTitleFunc();$event.stopPropagation();\" class=\"transcript-title-edit left remove-focus\"><span class=\"icon-notes\"> </span></div> </div> <div ng-hide=\"showSelectedFAQ\" class=\"search-question-wrp\"> <div class=\"search-bar-wrp relative\"> <div class=\"show-filter\"> <input type=\"text\" placeholder=\"Ask an expert\" ng-model=\"modelData.askedQuestion\" ng-change=\"askingQuestionFunc()\" ng-class=\"{\'active\':modelData.askedQuestion.length &gt; 0}\"><span ng-if=\"modelData.askedQuestion.length &gt; 0\" ng-click=\"clearFieldFunc()\" class=\"icon-remove absolute remove-focus\"></span> </div> </div> <div ng-show=\"modelData.askedQuestion.length &gt; 0 &amp;&amp; askingQuestion\" class=\"search-suggestions-wrp\"> <div ng-repeat=\"question in askExpertData.suggestedQuestions | filter:suggestQuestions\" class=\"search-suggestions remove-focus\"> <div class=\"each-suggested-items clearfix\"><span ng-bind-html=\"highlightTextMarkup(question.duplicateQues)\" ng-click=\"selectedQuestion(question)\" class=\"left\">{{question.duplicateQues}} </span><span ng-if=\"question.answered\" class=\"right icon-check\"></span><span ng-if=\"!question.answered\" class=\"right icon-repost\"> </span></div> </div> </div> <div ng-hide=\"modelData.askedQuestion.length &gt; 0 &amp;&amp; askingQuestion\" class=\"post-btn-wrp clearfix\"> <div class=\"primary_btn\">POST</div> </div> </div> <div ng-show=\"showSelectedFAQ\" class=\"selected-faq-wrp\"> <div class=\"selected-question-answer-wrp\"> <div class=\"selected-question-wrp\"><span class=\"question-symbol\">Q - </span><span class=\"question\">{{selectedFQ.question}} </span></div> <div class=\"selected-answer-wrp\"><span class=\"answer-symbol\">Ans - </span><span class=\"answer\">{{selectedFQ.answer}}</span></div> </div> <div ng-click=\"hideSelectedFAQFunc()\" class=\"cancel-btn absolute remove-focus\"><span>CANCEL </span></div> </div> </div> </div> </div> </div> </div> </div> <div ng-show=\"takeNotesToggle &amp;&amp; !shwMobOptions\" class=\"vid-player-overlay-notes-mob table full-width hide-in-tablet-up\"> <div class=\"vid-player-overlay-mob-btn-wrp table-cell\"> <div class=\"vid-overlay-dummy table margin-zero\"> <div ng-click=\"$event.stopPropagation();\" class=\"vid-player-overlay-mob-playbtn table-cell remove-focus\"><span class=\"icon-previousvideo\"> </span></div> <div ng-click=\"API.playPause();$event.stopPropagation();\" class=\"vid-player-overlay-mob-playbtn table-cell remove-focus\"><span class=\"icon-play3\"></span></div> <div ng-click=\"$event.stopPropagation();\" class=\"vid-player-overlay-mob-playbtn table-cell remove-focus\"><span class=\"icon-nextvideo\"></span></div> </div> </div> </div> <div ng-show=\"shwMobOptions &amp;&amp; !isSeeking\" class=\"vid-player-mob-options-wrp table full-width show-for-small-only\"> <div class=\"vid-mob-optns-wrp table-cell\"> <div class=\"vid-options-wrp table full-width vid-opt-arrow\"> <div ng-click=\"shwAskExpertMob();$event.stopPropagation();\" class=\"vid-options table-cell remove-focus\"><span class=\"icon-askanexpert\"></span></div> <div ng-click=\"reportIssueMobFunc();$event.stopPropagation();\" class=\"vid-options table-cell remove-focus\"><span class=\"icon-reportissue2\"></span></div> </div> <div ng-init=\"showQualOpt = false\" class=\"vid-options table-cell\"><span ng-click=\"showQualOpt = !showQualOpt;$event.stopPropagation();\" class=\"videoquality remove-focus\"> {{qualityVal}}p</span></div> <div ng-show=\"showQualOpt\" class=\"quality-opt-wrp absolute\"> <div class=\"quality-opt\"> <div ng-repeat=\"quality in quality\" class=\"quality-value\"><span ng-click=\"qualityIndex(this.$index)\" class=\"remove-focus\">{{quality}}p</span></div> </div> </div> <div ng-show=\"showVidOpt\" class=\"speed-opt-wrp absolute\"> <div class=\"speed-wrp\"> <div ng-repeat=\"speed in speed\" class=\"speed-value\"><span ng-click=\"speedIndex(this.$index)\" class=\"remove-focus\">{{speed}}</span></div> </div> </div> </div> </div> </div> </div>");
$templateCache.put("app/Common/Directives/playlist_directive/playlist.html"," <div ng-click=\"passEvent($event)\" class=\"vid-vidplaylist-title-wrp table full-width\"> <div class=\"vid-vidplaylist-top-wrp table-cell\"> <div class=\"vid-vidplaylist-title-dummy table full-width\"> <div class=\"vid-vidplaylist-title-no table-cell\">{{activeModuleData.sequenceId | twoDigit}}.</div> <div class=\"vid-vidplaylist-title-txt table-cell\"><span>{{activeModuleData.title}}</span><span style=\"margin-left:5px\" id=\"p-hints\" data-hint=\"This is the Playlist for the Skill you are learning currently. A playlist covers the entire learning content including videos, assessments, case studies and other resources.\" data-hintposition=\"middle\"></span></div> </div> </div> <div ng-click=\"filterPlaylist();$event.stopPropogation();\" ng-class=\"{\'vid-filter-active\':togglePlaylistFilter}\" class=\"vid-vidplaylist-filter table-cell\"><span class=\"icon-filter\"></span></div> <div ng-show=\"togglePlaylistFilter\" class=\"vid-playlist-filter-wrp\"> <div ng-init=\"video=true\" class=\"vid-playlist-filter-item\"> <input id=\"video\" type=\"checkbox\" checked=\"video\"> <label for=\"video\" ng-click=\"video=!video\" ng-class=\"{&quot;icon-checkbox_inactive&quot;:!video,&quot;icon-checkbox_selected&quot;:video}\" class=\"remove-focus\"></label><span>videos</span> </div> <div ng-init=\"assessment=true\" class=\"vid-playlist-filter-item\"> <input id=\"assessment\" type=\"checkbox\" checked=\"assessment\"> <label for=\"assessment\" ng-click=\"assessment=!assessment\" ng-class=\"{&quot;icon-checkbox_inactive&quot;:!assessment,&quot;icon-checkbox_selected&quot;:assessment}\" class=\"remove-focus\"></label><span>assessment</span> </div> <div ng-init=\"resources=true\" class=\"vid-playlist-filter-item\"> <input id=\"resources\" type=\"checkbox\" checked=\"resources\"> <label for=\"resources\" ng-click=\"resources=!resources\" ng-class=\"{&quot;icon-checkbox_inactive&quot;:!resources,&quot;icon-checkbox_selected&quot;:resources}\" class=\"remove-focus\"></label><span>resources</span> </div> <div ng-init=\"caseStudy=true\" class=\"vid-playlist-filter-item\"> <input id=\"caseStudy\" type=\"checkbox\" checked=\"caseStudy\"> <label for=\"caseStudy\" ng-click=\"caseStudy=!caseStudy\" ng-class=\"{&quot;icon-checkbox_inactive&quot;:!caseStudy,&quot;icon-checkbox_selected&quot;:caseStudy}\" class=\"remove-focus\"></label><span>case study</span> </div> </div> </div> <div id=\"vpstep1\" class=\"vid-vidplaylist-items-wrp\"> <div class=\"vid-playlist-wrp\">               <div ng-style=\"setPlaylistHeight()\" id=\"ytstep1\" class=\"scroll-bar vid-other-video-wrp\"> <div ng-repeat=\"item in modulePlaylistItems\" ng-click=\"clickedPlaylistItem(item.metaData.bcId,item.id,item.sequenceId,item.type)\"> <div ng-if=\"((video &amp;&amp;item.type == \'ytc\')||(video &amp;&amp;item.type == \'video\')|| (assessment &amp;&amp; item.type == \'quiz\')||(resources &amp;&amp; item.type == \'material\')||(caseStudy &amp;&amp; item.type == \'csa\'))\" ng-class=\"{\'vid-item-current\': item.sequenceId === currentSequenceId, \'current-playing-arrow\': item.sequenceId === currentSequenceId, \'vid-item-completed\': item.status == \'Completed\'}\" class=\"vid-vidplaylist-item-wrp\"> <div id=\"cur\" item.sequenceid=\"\" class=\"vid-playlist-tab table\"> <div ng-if=\"item.type == \'ytc\' &amp;&amp; item.metaData.videoType == \'videolink\'\" class=\"vid-vidplaylist-item-context\"><span class=\"icon-video\"></span></div> <div ng-if=\"item.type == \'video\'\" class=\"vid-vidplaylist-item-context\"><span class=\"icon-video\"></span></div> <div ng-if=\"item.type == \'quiz\'\" class=\"vid-vidplaylist-item-context\"><span class=\"icon-quiz\"></span></div> <div ng-if=\"item.type == \'material\'\" class=\"vid-vidplaylist-item-context\"><span class=\"icon-resources\"></span></div> <div ng-if=\"item.type == \'ytc\' &amp;&amp; item.metaData.videoType == \'weblink\'\" class=\"vid-vidplaylist-item-context\"><span class=\"icon-resources\"></span></div> <div ng-if=\"item.type == \'csa\'\" class=\"vid-vidplaylist-item-context\"><span class=\"icon-assignment\"></span></div> <div class=\"vid-vidplaylist-item-det-wrp\"> <div class=\"vid-vidplaylist-item-title\">{{item.sequenceId | twoDigit}}. {{item.metaData.title}}</div> <div ng-if=\"item.type !== \'material\' &amp;&amp; item.metadata.videoType !== \'weblink\'\" class=\"vid-vidplaylist-item-time-wrp\"> <div class=\"vid-vidplaylist-item-time-img\"><span class=\"icon-clock\"></span></div> <div class=\"vid-vidplaylist-item-time-det\">{{item.metaData.duration | minutesHours}}</div> </div> </div> </div> <div ng-if=\"((item.status == \'In Progress\') &amp;&amp; (video || assessment))\" ng-style=\"{ \'width\' : item.progress + \'%\'}\" class=\"progress-bar\"></div> </div> </div> </div> </div> </div>");
$templateCache.put("app/Common/Directives/popout/popout.html"," <div ng-show=\"popoutShow\" class=\"pop-outs-container-main\"> <div ng-click=\"passEvent($event)\" ng-class=\"{\'popout-fadeIn\':modelParent.isPopOutViewActive, \'popout-fadeOut\':!modelParent.isPopOutViewActive}\" class=\"pop-outs-container\"> <div ng-class=\"{\'animate-fadeIn\':modelParent.isPopOutViewActive, \'animate-fadeOut\':!modelParent.isPopOutViewActive}\" class=\"pop-outs-inner-overlay\"></div> <div ng-click=\"passEvent($event)\" class=\"pop-outs-wrapper\"> <div class=\"pop-outs-content-wrap table-cell\"> <div class=\"pop-outs-content relative\"> <div class=\"support-content row suport-tickets-mob\"> <div ng-show=\"userDetailsPopOut\" ng-class=\"{\'popout-fadeIn\':userDetailsPopOut, \'popout-fadeOut\':!userDetailsPopOut}\" class=\"confirmation\"> <div class=\"secondary-title-blue\"><span style=\"padding-right:5px\" class=\"icon-check2\"></span><span>Your changes have been saved.</span></div> <div class=\"btn-wrp destp-btn table hide-for-small-only\"> <button ng-click=\"closePopoutCard()\" class=\"primary_btn table-cell remove-focus ok-confirmation\"><span class=\"text\">OK</span></button> </div> </div> <div ng-show=\"savePasswordPopOut\" ng-class=\"{\'popout-fadeIn\':savePasswordPopOut, \'popout-fadeOut\':!savePasswordPopOut}\" class=\"confirmation\"> <div class=\"secondary-title-blue\"><span style=\"padding-right:5px\" class=\"icon-check2\"></span><span>Your new password has been saved.</span></div> <div class=\"btn-wrp destp-btn table hide-for-small-only\"> <button ng-click=\"closePopoutCard()\" class=\"primary_btn table-cell remove-focus ok-confirmation\"><span class=\"text\">OK</span></button> </div> </div> <div ng-show=\"logoutPopOut\" ng-class=\"{\'popout-fadeIn\':logoutPopOut, \'popout-fadeOut\':!logoutPopOut}\" class=\"logout\"> <div class=\"secondary-title\"><span>Are you sure you want to logout?</span></div> <div class=\"btn-wrp destp-btn table hide-for-small-only\"> <button ng-click=\"closePopoutCard()\" class=\"secondary_btn table-cell remove-focus gtd-button\"><span class=\"text\">GO BACK</span></button> <button ng-click=\"logout()\" class=\"primary_btn table-cell remove-focus explore-course\"><span class=\"text\">LOGOUT</span></button> </div> </div> <div ng-show=\"approvalPopOut\" ng-class=\"{\'popout-fadeIn\':approvalPopOut, \'popout-fadeOut\':!approvalPopOut}\" class=\"approval\"> <div class=\"secondary-title\"><span>Confirm approval</span></div> <div class=\"btn-wrp destp-btn table hide-for-small-only\"> <button ng-click=\"closePopoutCard()\" class=\"secondary_btn table-cell remove-focus gtd-button\"><span class=\"text\">CANCEL</span></button> <button ng-click=\"confirmApprovalPopOut()\" class=\"primary_btn table-cell remove-focus explore-course\"><span class=\"text\">APPROVE</span></button> </div> </div> <div ng-show=\"noContentPopout\" class=\"approval\"> <div class=\"secondary-title\"><span>This module does not have downloadable contents</span></div> <div class=\"btn-wrp destp-btn table hide-for-small-only\"> <button ng-click=\"closePopoutCard()\" class=\"primary_btn table-cell remove-focus ok-confirmation\"><span class=\"text\">OK</span></button> </div> </div> <div ng-show=\"isSafari\" class=\"approval\"> <div class=\"secondary-title\"><span>Proficiency tests do not work with Safari, please use Chrome for a better experience.</span></div> <div class=\"btn-wrp destp-btn table hide-for-small-only\"> <button ng-click=\"closePopoutCard()\" class=\"primary_btn table-cell remove-focus ok-confirmation\"><span class=\"text\">OK</span></button> </div> </div> <div ng-if=\"congratulations-popout\" class=\"congratulation\"> <div class=\"primary-title-blue\"><span>Congratulations!</span></div> <div class=\"secondary-title\"><span>You made that look easy</span><span class=\"user\">user name</span></div> <div class=\"body-text\"><span>You just earned a certification for</span> <div class=\"certification-name\"><span>certification name</span></div> </div> <div class=\"secondary-btn-wrp destp-btn table hide-for-small-only\"> <button ng-click=\"toggleLogoutConfirmationScreen()\" class=\"secondary_btn table-cell remove-focus gtd-button\"><span class=\"text\">GO TO DASHBOARD</span></button> <button ng-click=\"toggleLogoutConfirmationScreen()\" class=\"primary_btn table-cell remove-focus explore-course\"><span class=\"text\">EXPLORE COURSES</span></button> </div> </div> <div ng-if=\"userLoginWelcome\" class=\"user-login-welcome\"> <div class=\"secondary-title\"><span>Welcome back</span><span class=\"user\">user</span></div> <div class=\"body-text\"><span>Due date for the current module is</span><span class=\"user\">date</span></div> <div class=\"body-text\"><span>Due date for the learning path is</span><span class=\"user\">date</span></div> <div class=\"btn-wrp destp-btn table hide-for-small-only\"> <button ng-click=\"toggleLogoutConfirmationScreen()\" class=\"primary_btn table-cell remove-focus\"><span class=\"text\">START LEARNING</span></button> </div> </div> <div ng-if=\"attempt-prof-popout\" class=\"attempt-proficiency-test\"> <div class=\"secondary-title\"><span>You can attempt a proficiency test only once</span></div> <div class=\"body-text\"><span>please complete the skill content before you start the test.</span></div> </div> <div ng-if=\"complete-prof-popout\" class=\"complete-proficiency-test\"> <div class=\"secondary-title-blue\"><span>Good job Varun</span></div> <div class=\"body-text\"><span>You just earned a proficiency badge for</span></div> <div class=\"certification-name\"><span>badge name</span></div> </div> <div ng-if=\"modulePopup\" class=\"logout\"> <div class=\"secondary-title\"><span>Please complete modules</span><span>{{message}}</span><span> to start with this module.</span></div> <div class=\"btn-wrp destp-btn table hide-for-small-only\"> <button ng-click=\"closePopoutCard()\" class=\"primary_btn table-cell remove-focus ok-confirmation\"><span class=\"text\">OK</span></button> </div> </div> </div> <div ng-click=\"closePopoutCard();\" class=\"close-btn-con absolute\"><span class=\"icon-close\"></span></div> </div> </div> </div> </div> </div>");
$templateCache.put("app/Common/Directives/primary_progress_bar/primary_progress_bar.html"," <div class=\"scnd-hdr-progress-bar-wrp\"> <div class=\"primary-bar-hdr-top-wrp table full-width\"> <div class=\"scnd-hdr-progress-bar-current-txt table-cell\"> <div class=\"main\">{{lpAttr.actualProgress}}%</div> </div> <div class=\"primary-prog-bar-wrp table-cell\"> <div class=\"scnd-hdr-progress-bar-wrp-outer\"> <div ng-style=\"changePropseWidth()\" class=\"scnd-hdr-progress-bar-wrp-buffer\"></div> <div ng-style=\"changeActualWidth()\" class=\"scnd-hdr-progress-bar-wrp-current\"></div> <div ng-style=\"expctedWidth()\" class=\"progress-bar-wrp-expected\"></div> </div> <div class=\"primary-prog-bar-msg-wrp\"> <div class=\"msg\">{{trackProgressMessage}}</div> </div> </div> </div> </div>");
$templateCache.put("app/Common/Directives/proficiency_progress_bar/proficiency_progress_bar.html"," <div class=\"scnd-hdr-progress-bar-wrp\"> <div class=\"prof-bar-current-txt\"> <div class=\"main\">{{completedTest}} / {{totalTests}} </div> <div class=\"secondary\">Proficiency tests passed</div> </div> </div>");
$templateCache.put("app/Common/Directives/quizTimer/quizTimer.html"," <div ng-show=\"timeInSec\" class=\"timer-wrp\"> <div class=\"timer-img-wrp\"><img ng-src=\"assets/images/timer.png\"></div> <div class=\"time-wrp\">{{ timeInSec | transcriptTime }} </div> </div>");
$templateCache.put("app/Common/Directives/uploadAvatar/uploadAvatar.html"," <div ng-if=\"parentObj.uploadAvatar\" class=\"upload-avatar-overlay\"> <div ng-click=\"closeUploadAvatar()\" class=\"upload-avatar-overlay-close remove-focus\"><span class=\"icon-close\"></span></div> <div class=\"upload-avatar-section\"> <div class=\"upload-avatar-wrp clearfix\"> <div class=\"upload-heading\"><span>Choose Avatar</span></div> <div class=\"upload-image-section\"> <div ng-repeat=\"source in avatars\" ng-click=\"selectedAvatarChange(this.$index)\" ng-class=\"{\'left\': $even, \'right\': $odd}\" class=\"upload width-fifty-percent\"> <div class=\"avatar-image-wrp relative\"><img ng-src=\"{{source.imageUrl}}\"></div> </div> </div> </div>   </div> <div ng-if=\"parentObj.selectedOverlay\" class=\"upload-selected-overlay\"><loading-state ng-show=\"!allOptionsLoaded\"></loading-state> <div ng-show=\"allOptionsLoaded\" class=\"selected-avatar-wrp relative\"> <div class=\"profile-image-option-con text-center\"> <div class=\"profile-image-option-wrap inline-block\"> <div ng-init=\"applySchemaOption(\'trapeziumProfileImageOption\',20);\" class=\"profile-img-option-con option-trapezium inline-block\"> <div class=\"profile-img-option-wrp relative\"> <div id=\"trapeziumProfileImageOption\" ng-style=\"{\'background-image\':\'url({{parentObj.selectedImage}})\'}\" class=\"profile-img-option\"></div> </div> </div> <div ng-init=\"applySchemaOption(\'squareProfileImageOption\',0);\" class=\"profile-img-option-con option-square inline-block\"> <div class=\"profile-img-option-wrp relative\"> <div id=\"squareProfileImageOption\" ng-style=\"{\'background-image\':\'url({{parentObj.selectedImage}})\'}\" class=\"profile-img-option\"></div> </div> </div> <div ng-init=\"applySchemaOption(\'rhombusProfileImageOption\',28);\" class=\"profile-img-option-con option-rhombus inline-block\"> <div class=\"profile-img-option-wrp relative\"> <div id=\"rhombusProfileImageOption\" ng-style=\"{\'background-image\':\'url({{parentObj.selectedImage}})\'}\" class=\"profile-img-option\"></div> </div> </div> </div> <div class=\"profile-image-confirmation-message inline-block\">Your profile image/avatar will be displayed as above three shapes through out the Learning platform. To upload, press the save button below.</div> </div> <div class=\"buttons-wrp clearfix absolute\"> <div ng-click=\"uploadDisplayPicture();\" class=\"right primary_btn\">save</div> <div ng-click=\"closeUploadAvatarOverlay()\" class=\"right tertiary_color\">cancel</div> </div> </div> </div> </div>");
$templateCache.put("app/Common/Directives/user_progress_bar/userProgressBar.html"," <div ng-click=\"passEvent($event)\" class=\"user-prog-wrp clearfix relative\"> <div ng-click=\"moveCarouselRight()\" ng-class=\"{&quot;inactive-btn&quot;:leftMaxReached}\" class=\"usr-prog-bar-cntrl left\"> </div> <div data-ng-swipe-left=\"swipeLeft()\" data-ng-swipe-right=\"swipeRight()\" class=\"progress-bar-wrp left\"> <div ng-style=\"{ \'width\' : weekWidth}\" id=\"progCarousel\" class=\"progress-bar-wrp-dummy\"> <div class=\"progress-info-wrp\"> <div class=\"progress-info-hdng-wrp\"> <div class=\"hdng\">Learning Path Start Date</div> <div class=\"scnd-hdng\">{{lpAttr.lpStartsOn}} (Week 1)</div> </div> <div class=\"progress-info-hdng-wrp\"> <div class=\"hdng\">LEARNING PATH COMPLETION DATE</div> <div style=\"text-align:right\" class=\"scnd-hdng\">{{lpAttr.lpEndsOn}} (Week {{lpAttr.noOfWeeks}})</div> </div> </div> <div class=\"progress-info-wrp progress-bar\"> <div class=\"progress-bar-section\"> <div class=\"progress-timeline-wrp\"> <div class=\"progress-begin-det-wrp\"><span class=\"icon-begin\"></span></div> <div class=\"progress-timeline-dummy clearfix\"> <div ng-repeat=\"module in lpAttr.allData | orderBy:\'sequenceId\'\" ng-style=\"moveLeft(module, $index, lpAttr.allData.length)\" ng-class=\"{&quot;active-item&quot;:progressTimelineIndex == $index}\" class=\"progress-timeline-module\"> <div ng-class=\"{\'started\' : module.status == \'In Progress\' , \'completed\' : module.status == \'Completed\' || module.status == \'Finished\' , \'not-started\' : module.status == \'Not Started\', \'progress-tile-current\' : module.current_module }\" ng-click=\"openInfoTab($index);$event.stopPropogation();\" class=\"progress-timeline-tile remove-focus\"> <div ng-show=\"progressTimelineIndex == $index\" class=\"progress-timeline-tile-info-wrp\"> <div class=\"progress-timeline-arrow-box\"> <div class=\"tile-hdng-wrp table full-width\"> <div class=\"tile-hdng table-cell\">{{module.title}}</div> <div ng-click=\"closeTile();$event.stopPropagation();\" class=\"tile-close table-cell remove-focus\"><span class=\"icon-close\"></span></div> </div> <div ng-if=\"module.status === \'In Progress\'\" class=\"tile-info-wrp table\"> <div class=\"tile-info-vid-wrp table-cell\"> <div class=\"tile-info-dummy table\"><span class=\"icon-video table-cell\"></span><span class=\"table-cell\">{{module.videoDuration | minutesHours}} Video</span></div> </div> <div class=\"tile-info-vid-wrp table-cell\"> <div class=\"tile-info-dummy table full-width\"><span class=\"icon-assignment table-cell\"></span><span class=\"table-cell\">{{module.assignmentDuration | minutesHours}} Assignment</span></div> </div> </div> <div ng-if=\"module.status === \'Not Started\'\" class=\"tile-info-wrp\"> </div> <div ng-if=\"module.status === \'Completed\' || module.ptResult || module.status === \'Finished\'\" class=\"tile-info-wrp cm-popup-test-text\"> <div class=\"badge-related-msg cm-progress-popup-txt\"> </div> <div class=\"highest-module-score-msg cm-progress-popup-txt\"> <div class=\"tile-info-dummy\"><span ng-if=\"module.ptResult === &quot;PASS&quot;\">Proficiency test result: Passed</span><span ng-if=\"module.ptResult === &quot;FAIL&quot;\">Proficiency test result: Failed</span> </div> </div> </div> <div class=\"tile-bottom-wrp table full-width\"> <div ng-click=\"startVideo(module);\" ng-if=\"module.status === \'In Progress\' &amp;&amp; !module.ptResult\" class=\"tile-continue table-cell remove-focus\">Resume</div> <div ng-click=\"startVideo(module)\" ng-if=\"module.status ===&quot;Not Started&quot;\" class=\"tile-continue table-cell remove-focus\">Begin Module</div> <div ng-if=\"module.ptResult\" class=\"tile-proficiency-test-score table-cell\"><span>Proficiency test Score: {{module.ptScore}}%</span> </div> <div class=\"tile-score table-cell\"> <div ng-if=\"module.status === \'Not Started\'\" class=\"tile-score-dummy table\"><span class=\"icon-star table-cell\"></span><span class=\"points table-cell\">{{module.totalPointsEarned}}</span></div> <div ng-if=\"module.status === \'In Progress\'\" class=\"tile-score-dummy table\"><span class=\"icon-star table-cell\"></span><span class=\"points table-cell\">{{module.totalPointsEarned}}</span></div> <div ng-if=\"(module.status === \'Completed\' || module.status === \'Finished\') &amp;&amp; !module.proficiency_test_taken\" class=\"tile-score-dummy table\"><span class=\"icon-star table-cell\"></span><span class=\"points table-cell\">{{module.totalPointsEarned}}</span></div> </div> </div> </div> </div><span>{{module.sequenceId}}</span> </div> <div ng-if=\"(module.status == \'Completed\' || module.status == \'Finished\') &amp;&amp; (module.ptStatus === \'Completed\' || (module.proficiencyTest === 0 || module.proficiencyTest))\" title=\"You have finished this module\" class=\"progress-test-status icon-check\"></div> <div ng-if=\"module.status == \'In Progress\' &amp;&amp; module.ptResult === \'FAIL\'\" title=\"You need to pass the proficiency test in order to complete this module, please contact your manager for retake approval\" class=\"progress-test-status icon-warning\"></div> <div ng-class=\"{\'started\' : module.status == \'In Progress\' , \'completed\' : module.status == \'Completed\' || module.status == \'Finished\'}\" ng-style=\"completedwidth(module.progress);\" class=\"progress-timeline-completed\"> <div ng-if=\"module.moduleId === summary.currentModule\" class=\"progress-timeline-curnt-mod-wrp\"> <div class=\"progress-timeline-icon\"><span class=\"icon-man\"></span></div> <div class=\"progress-timeline-speech-bubble\"><span>You are here</span></div> </div> </div> </div> </div> <div class=\"progress-end-det-wrp\"><span class=\"icon-finishflag\"></span></div> </div> </div> </div> </div> </div> <div ng-click=\"moveCarouselLeft()\" ng-class=\"{&quot;inactive-btn&quot;:rightMaxReached}\" class=\"usr-prog-bar-cntrl left\"> </div> </div>");
$templateCache.put("app/Common/Directives/video_player/video_player.html"," <div class=\"clip-video-player-wrp\"> <videogular vg-player-ready=\"onPlayerReady($API)\" class=\"remove-focus\"> <vg-media vg-src=\"Videoconfig.sources\" ng-click=\"API.playPause();$event.stopPropagation();\" class=\"remove-focus\"></vg-media> <vg-controls> <div ng-click=\"$event.stopPropagation();\" class=\"time remove-focus table-cell\"><span class=\"icon-clock\"></span><span class=\"time-stamp\">{{clipData.end_time - clipData.start_time | transcriptTime}}</span></div> <div ng-click=\"startVideo();$event.stopPropagation();\" class=\"original-content-link table-cell remove-focus\"><span>visit content</span></div> <div ng-click=\"API.toggleFullScreen();$event.stopPropagation();\" class=\"full-screen full-screen-icon-wrp remove-focus table-cell\"><span class=\"icon-fullscreen\"></span></div> </vg-controls> </videogular> </div>");
$templateCache.put("app/Common/Directives/video_progressbar_list/videoProgressBar.html"," <div class=\"vid-progress-container\"> <div class=\"vid-progres-buffer\"></div> <div class=\"vid-progres-current-wrp\"> <div ng-style=\"{ \'width\' : current + \'%\'}\" class=\"vid-progres-current\"></div> <div ng-style=\"{ \'left\' : current + \'%\'}\" class=\"vid-play-btn\"><span class=\"icon-play2\"></span></div> </div> </div>");
$templateCache.put("app/Features/clipboard/templates/clips.html"," <clip-video-player clip-data=\"item.clipdata\"></clip-video-player>");
$templateCache.put("app/Features/clipboard/templates/module-extended-mob.html"," <div ng-init=\"blur_msg = false\" class=\"module-extended-view\"> <div class=\"module-header\"> <div class=\"clipbrd-module-heading table\"> <div ng-click=\"goToClipboard()\" class=\"back-icon table-cell remove-focus\"><span class=\"icon-back\"></span></div> <div class=\"module-name table-cell\"><span>{{selectedTitle}}</span></div> </div> <div class=\"test-link\"><span ng-click=\"blur_msg = true\" class=\"remove-focus\">PROFICIENCY TEST</span></div> </div> <div ng-show=\"blur_msg\" class=\"blur-overlay absolute\"> <div class=\"message-mobile\"><span>Proficiency Test can only be taken on Web!</span></div> <div class=\"close-blur\"><span ng-click=\"blur_msg = false\" class=\"icon-close remove-focus\"></span></div> </div> <div lazy-scroll=\"listData()\" lazy-scroll-trigger=\"40\" lazy-no-scroll=\"false\" ng-class=\"{\'selected\': selectedIndex == this.$index}\" class=\"options-section-mob\"> <div class=\"options-wrp clearfix\"> <div class=\"topics-option-wrp left\"> <div class=\"topics-option table active\"> <div class=\"table-cell\"><span class=\"icon-quiz\"></span><span class=\"text\">Topics</span></div> </div> </div> </div> <div class=\"topics-list-wrp\"> <div ng-repeat=\"topic in currentModule | unique : \'title\' | orderBy: \'priority\' | orderBy : \'clipdata.start_time\' | orderBy : \'video_id\' | limitTo:initialLength\" class=\"title-wrp\"><span ng-if=\"topic.title != \'bookmark\'\" ng-click=\"scrollToClicked(topic.title);$event.stopPropagation();\" class=\"remove-focus\">{{topic.title}}</span></div> <div ng-if=\"currentModule.length &gt; 3\" class=\"show-more-option clearfix\"><span ng-click=\"showMoreTopics(currentModule)\" ng-show=\"showMore\" class=\"right remove-focus\">view more</span><span ng-click=\"showLessTopics(currentModule)\" ng-hide=\"showMore\" class=\"right remove-focus\">view less</span></div> </div> <div ng-include=\"\" src=\"\'app/Features/clipboard/templates/module_items.html\'\" class=\"clipboard-items-wrp right\"></div> </div> </div>");
$templateCache.put("app/Features/clipboard/templates/module_items.html"," <div ng-repeat=\"item in currentModule | orderBy: \'priority\' | orderBy : \'clipdata.start_time\' | orderBy : \'video_id\' | limitTo:initialLimit\" ng-click=\"sortBySelectedType(item)\" ng-attr-id=\"{{ item.title }}\" scroll-att=\"{{item.title}}\" class=\"clipboard-item-wrp relative remove-focus portfolio-item\"> <div ng-click=\"changeIndex();$event.stopPropagation();\" class=\"clipboard-item-header clearfix remove-focus\"> <div ng-class=\"{\'selected\': titleSelectedIndex == this.$index}\" class=\"clipbrd-item-title left\"><span>{{item.title}}</span></div> <div ng-class=\"{\'selected\': titleSelectedIndex == this.$index}\" class=\"input-field-container left\"> <input type=\"text\" ng-model=\"item.title\" ng-click=\"$event.stopPropagation();\" class=\"remove-focus\"><span ng-if=\"item.title.length &gt; 0\" ng-click=\"item.title = \'\';$event.stopPropagation();\" class=\"icon-remove remove-focus\"></span> </div> <div class=\"clipbrd-item-icons-wrp right\"> <span title=\"Edit\" ng-if=\"item.title.length &gt; 0\" ng-click=\"editTitleActive(this.$index);$event.stopPropagation();\" class=\"icon-notes remove-focus\"></span><span ng-if=\"item.title.length == 0\" ng-click=\"editTitleActive(this.$index);$event.stopPropagation();\" class=\"icon-add remove-focus\"></span><span title=\"Delete\" class=\"icon-trash hide-for-small-only remove-focus\"></span> </div> </div> <div class=\"clipboard-item-body relative\"> <div ng-if=\"item.type==\'screenshot\'\" ng-include=\"\" src=\"\'app/Features/clipboard/templates/screenshot.html\'\" class=\"screenshot-wrp\"></div> <div ng-if=\"item.type==\'highlightedTranscript\'\" ng-include=\"\" src=\"\'app/Features/clipboard/templates/transcript.html\'\" class=\"highlighted-transcript-wrp\"></div> <div ng-if=\"item.type==\'notes\'\" ng-include=\"\" src=\"\'app/Features/clipboard/templates/notes.html\'\" class=\"notes-wrp\"></div> <div ng-if=\"item.type==\'trimmedvideo\'\" ng-include=\"\" src=\"\'app/Features/clipboard/templates/clips.html\'\" class=\"video-clips-wrp\"></div> <div ng-if=\"item.type==\'askanexpert\'\" ng-include=\"\" src=\"\'app/Features/clipboard/templates/qna.html\'\" class=\"question-answer-wrp\"></div> </div> <div ng-click=\"showPathWrp();$event.stopPropagation();\" class=\"clipboard-dash-mobile remove-focus\"><span class=\"icon-home\"></span></div> </div>");
$templateCache.put("app/Features/clipboard/templates/notes.html"," <div class=\"notes-section relative\"> <div class=\"heading\"><span>my note:</span></div> <div class=\"text\"> <p ng-hide=\"editNotes\">{{item.clipdata.user_notes}}</p> <div ng-show=\"editNotes\" ng-click=\"$event.stopPropagation();\"> <textarea type=\"text\" ng-focus=\"$event.stopPropagation();\" ng-model=\"item.clipdata.user_notes\"></textarea> </div> </div> <div class=\"secondary-heading heading\"><span>transcript:</span></div> <div class=\"text\"> <p>{{item.clipdata.transcript}}</p> </div> <div ng-click=\"editNotesFunc();$event.stopPropagation();\" class=\"absolute edit-notes-btn remove-focus\"> <div ng-hide=\"editNotes\" class=\"primary_btn\">EDIT NOTE</div> <div ng-show=\"editNotes\" class=\"primary_btn\">SAVE</div> </div> </div> <div class=\"clip-board-item-link absolute full-width\"> <div class=\"clearfix\"> <div class=\"left\"> <div ng-click=\"$event.stopPropagation();\" class=\"time remove-focus\"><span class=\"icon-clock\"></span><span class=\"time-stamp\">{{item.clipdata.start_time | transcriptTime}}</span></div> </div> <div class=\"right\"> <div ng-click=\"startVideo();$event.stopPropagation();\" class=\"original-content-link left remove-focus\"><span>visit content</span></div> <div class=\"full-screen left\"><span class=\"icon-fullscreen\"></span></div> </div> </div> </div>");
$templateCache.put("app/Features/clipboard/templates/qna.html"," <div class=\"notes-section\"> <div class=\"heading\"><span>Question:</span></div> <div class=\"text\"> <p>{{item.clipdata.question}}</p> </div> <div class=\"secondary-heading heading\"><span>Answer:</span></div> <div class=\"text\"> <p>{{item.clipdata.answer}}</p> </div> </div> <div class=\"clip-board-item-link absolute full-width\"> <div class=\"clearfix\"> <div class=\"left\"> <div ng-click=\"$event.stopPropagation();\" class=\"time remove-focus\"><span class=\"icon-clock\"></span><span class=\"time-stamp\">{{item.clipdata.start_time | transcriptTime}}</span></div> </div> <div class=\"right\"> <div ng-click=\"startVideo();$event.stopPropagation();\" class=\"original-content-link left remove-focus\"><span>visit content</span></div> <div class=\"full-screen left\"><span class=\"icon-fullscreen\"></span></div> </div> </div> </div>");
$templateCache.put("app/Features/clipboard/templates/screenshot.html","<img ng-src=\"{{item.thumbnail}}\"> <div class=\"clip-board-item-link absolute full-width\"> <div class=\"clearfix\"> <div class=\"left\"> <div ng-click=\"$event.stopPropagation();\" class=\"time remove-focus\"><span class=\"icon-clock\"></span><span class=\"time-stamp\">{{item.clipdata.start_time | transcriptTime}}</span></div> </div> <div class=\"right\"> <div ng-click=\"startVideo();$event.stopPropagation();\" class=\"original-content-link left remove-focus\"><span>visit content</span></div> <div class=\"full-screen left\"><span class=\"icon-fullscreen\"></span></div> </div> </div> </div>");
$templateCache.put("app/Features/clipboard/templates/selected-type-overlay.html"," <div class=\"clipboard-type-view-close-btn clearfix\"> <div ng-click=\"closeSortBySelectedType()\" class=\"right remove-focus\"><span class=\"icon-close\"></span></div> </div> <div class=\"selected-overlay-desktop relative\"> <div ng-click=\"previousFocusedItemType()\" class=\"previous-item absolute remove-focus\"><span class=\"icon-back\"></span></div> <div ng-click=\"changeIndex()\" class=\"clipboard-item-header clearfix remove-focus\"> <div ng-class=\"{\'selected\': titleSelectedIndex == this.$index}\" class=\"clipbrd-item-title left\"><span>{{focusedElement.title}}</span></div> <div ng-class=\"{\'selected\': titleSelectedIndex == this.$index}\" class=\"input-field-container left\"> <input type=\"text\" ng-model=\"focusedElement.title\" ng-click=\"$event.stopPropagation();\" class=\"remove-focus\"><span ng-if=\"focusedElement.title.length &gt; 0\" ng-click=\"focusedElement.title = \'\';$event.stopPropagation();\" class=\"icon-remove remove-focus\"></span> </div> <div class=\"clipbrd-item-icons-wrp right\"> <span ng-if=\"focusedElement.title.length &gt; 0\" ng-click=\"editTitleActive(this.$index);$event.stopPropagation();\" class=\"icon-notes remove-focus\"></span><span ng-if=\"focusedElement.title.length == 0\" class=\"icon-plus remove-focus\"></span></div> </div> <div ng-if=\"focusedElement.type==\'notes\'\" class=\"selected-type-data-overlay table\"> <div class=\"notes-section table-cell relative\"> <div class=\"heading\"><span>my note:</span></div> <div class=\"text\"> <p ng-hide=\"editNotes\">{{focusedElement.clipdata.user_notes}}</p> <textarea type=\"text\" ng-show=\"editNotes\" ng-click=\"$event.stopPropagation();\" ng-model=\"focusedElement.clipdata.user_notes\" class=\"remove-focus\"></textarea> </div> <div class=\"secondary-heading heading\"><span>transcript:</span></div> <div class=\"text\"> <p>{{focusedElement.clipdata.transcript}}</p> </div> <div ng-click=\"editNotesFunc();$event.stopPropagation();\" class=\"absolute edit-notes-btn remove-focus\"> <div ng-hide=\"editNotes\" class=\"primary_btn\">EDIT NOTE</div> <div ng-show=\"editNotes\" class=\"primary_btn\">SAVE</div> </div> </div> </div> <div ng-if=\"focusedElement.type==\'askanexpert\'\" class=\"selected-type-data-overlay table\"> <div class=\"notes-section table-cell\"> <div class=\"heading\"><span>Question:</span></div> <div class=\"text\"> <p>{{focusedElement.clipdata.question}}</p> </div> <div class=\"secondary-heading heading\"><span>Answer:</span></div> <div class=\"text\"> <p>{{focusedElement.clipdata.answer}}</p> </div> </div> </div> <div ng-if=\"focusedElement.type==\'highlightedTranscript\'\" class=\"selected-type-data-overlay table\"> <div class=\"notes-section table-cell\"> <div class=\"heading\"><span>highlighted Transcript:</span></div> <div class=\"text clipboard-view highlight-clip-con\"> <div ng-repeat=\"para in focusedElement.transcript\" ng-init=\"parentIndex = $index\" class=\"vid-trscript-para-wrp\"> <div class=\"vid-trscript-dummy-wrp\"> <div class=\"vid-trscript-para-txt-wrp vid-trscript-para-txt-size\"><span ng-repeat=\"entity in para.val\"><span id=\"t-{{entity.start}}\" data-time=\"{{entity.start}}\" para-no=\"{{parentIndex}}\" sent-no=\"{{$index}}\" ng-bind-html=\"highlightTextMarkup(entity.text)\" class=\"remove-focus\">{{entity.text}}</span></span></div> </div> </div> </div> </div> </div> <div ng-if=\"focusedElement.type==\'screenshot\'\" class=\"selected-type-data-overlay table\"> <div class=\"table-cell\"><img ng-src=\"{{focusedElement.thumbnail}}\" class=\"full-width\"></div> </div> <div ng-if=\"focusedElement.type==\'trimmedvideo\'\" class=\"selected-type-data-overlay\"> <videogular vg-player-ready=\"onPlayerReady($API)\" class=\"remove-focus\"> <vg-media vg-src=\"Videoconfig.sources\" ng-click=\"API.playPause()\" class=\"remove-focus\"></vg-media> </videogular> </div> <div ng-click=\"nextFocusedItemType()\" class=\"next-item absolute remove-focus\"><span class=\"icon-next\"></span></div> </div>");
$templateCache.put("app/Features/clipboard/templates/selected-type-video-view.html"," <div class=\"clipboard-type-view-close-btn clearfix\"> <div ng-click=\"closeSortBySelectedType()\" class=\"right remove-focus\"><span class=\"icon-close\"></span></div> </div> <div class=\"clip-type-only-wrp\"> <videogular vg-player-ready=\"onPlayerReady($API)\" class=\"remove-focus\"> <vg-media vg-src=\"Videoconfig.sources\" ng-click=\"API.playPause()\" class=\"remove-focus\"></vg-media> </videogular> </div>");
$templateCache.put("app/Features/clipboard/templates/selected-type-view.html"," <div class=\"clipboard-type-view-close-btn clearfix\"> <div ng-click=\"closeSortBySelectedType()\" class=\"right remove-focus\"><span class=\"icon-close\"></span></div> </div> <div class=\"clip-type-only-wrp\"> <div ng-repeat=\"item in currentModule | filter: {type :focusedElementType} | orderBy: \'priority\' | orderBy : \'clipdata.start_time\' | orderBy : \'video_id\'\" class=\"clip-type-only\"> <div ng-click=\"changeIndex()\" class=\"clipboard-item-header clearfix\"> <div ng-class=\"{\'selected\': titleSelectedIndex == this.$index}\" class=\"clipbrd-item-title left\"><span>{{item.title}}</span></div> <div ng-class=\"{\'selected\': titleSelectedIndex == this.$index}\" class=\"input-field-container left\"> <input type=\"text\" ng-model=\"item.title\" ng-click=\"$event.stopPropagation();\" class=\"remove-focus\"><span ng-if=\"item.title.length &gt; 0\" ng-click=\"item.title = \'\';$event.stopPropagation();\" class=\"icon-remove remove-focus\"></span> </div> <div class=\"clipbrd-item-icons-wrp right\"><span class=\"icon-trash remove-focus\"></span><span ng-if=\"item.title.length &gt; 0\" ng-click=\"editTitleActive(this.$index);$event.stopPropagation();\" class=\"icon-notes remove-focus\"></span><span ng-if=\"item.title.length == 0\" class=\"icon-secback\"></span></div> </div> <div ng-attr-id=\"{{ item.title }}\" class=\"clipboard-item-body relative\"> <div ng-if=\"item.type==\'screenshot\'\" ng-include=\"\" src=\"\'app/Features/clipboard/templates/screenshot.html\'\" class=\"screenshot-wrp\"></div> <div ng-if=\"item.type==\'highlightedTranscript\'\" ng-include=\"\" src=\"\'app/Features/clipboard/templates/transcript.html\'\" class=\"highlighted-transcript-wrp\"></div> <div ng-if=\"item.type==\'notes\'\" ng-include=\"\" src=\"\'app/Features/clipboard/templates/notes.html\'\" class=\"notes-wrp\"></div> <div ng-if=\"item.type==\'askanexpert\'\" ng-include=\"\" src=\"\'app/Features/clipboard/templates/qna.html\'\" class=\"question-answer-wrp\"></div> </div> </div> <div ng-click=\"showPathWrp();$event.stopPropagation();\" class=\"clipboard-dash-mobile remove-focus\"><span class=\"icon-home\"></span></div> </div>");
$templateCache.put("app/Features/clipboard/templates/transcript.html"," <div class=\"notes-section\"> <div class=\"heading\"><span>highlighted Transcript:</span></div> <div class=\"text clipboard-view\"> <div ng-repeat=\"para in item.transcript\" ng-init=\"parentIndex = $index\" class=\"vid-trscript-para-wrp\"> <div class=\"vid-trscript-dummy-wrp\"> <div class=\"vid-trscript-para-txt-wrp vid-trscript-para-txt-size\"><span ng-repeat=\"entity in para.val\"><span id=\"t-{{entity.start}}\" data-time=\"{{entity.start}}\" para-no=\"{{parentIndex}}\" sent-no=\"{{$index}}\" ng-bind-html=\"highlightTextMarkup(entity.text)\" class=\"remove-focus\">{{entity.text}}</span></span></div> </div> </div> </div> </div> <div class=\"clip-board-item-link absolute full-width\"> <div class=\"clearfix\"> <div class=\"left\"> <div ng-click=\"$event.stopPropagation();\" class=\"time remove-focus\"><span class=\"icon-clock\"></span><span class=\"time-stamp\">{{item.clipdata.start_time | transcriptTime}}</span></div> </div> <div class=\"right\"> <div ng-click=\"startVideo();$event.stopPropagation();\" class=\"original-content-link left remove-focus\"><span>visit content</span></div> <div class=\"full-screen left\"><span class=\"icon-fullscreen\"></span></div> </div> </div> </div>");
$templateCache.put("app/Features/libraryPage/template/LibplaylistPage.html"," <div class=\"lib-playlist-pg-wrp skil-pg-wrp\"> <div class=\"lib-playlist-tab-wrp\"> <div ng-click=\"openCuratedPlaylistTab()\" ng-class=\"{&quot;active&quot;:libPlaylistState }\" class=\"lib-playlist-tab-item skil-pg-tabs-item remove-focus\"> <div class=\"txt\">Curated Playlist</div> <div ng-if=\"libPlaylistState\" class=\"icon icon-next\"></div> </div> <div ng-click=\"openMyPlaylistTab()\" ng-class=\"{&quot;active&quot;:!libPlaylistState }\" class=\"lib-playlist-tab-item skil-pg-tabs-item remove-focus\"> <div class=\"txt\">My Playlist</div> <div ng-if=\"!libPlaylistState\" class=\"icon icon-next\"></div> </div> </div> <div class=\"skil-pg-tab-content\"> <div ng-if=\"!libPlaylistState\" class=\"skil-pg-trend-wrp\"> <div class=\"skill-pg-tile-wrp-section row\"> <div ng-repeat=\"item in userPlaylistData\" ng-click=\"openVideoPlayer()\" ng-show=\"$index &lt;= moreUsrPlaylist\" class=\"large-4 medium-4 small-12 columns skill-pg-tile-wrp\"> <div class=\"lib-page-history-item\"> <div class=\"skill-pg-tile-top lib-page-history-item-top\"> <div class=\"clearfix relative\"> <div class=\"item-title left\"> {{item.title}}</div> <div class=\"skill-tile-view-info clearfix absolute\"> <div class=\"txt right\">{{item.views}}</div> <div class=\"icon icon-view right\"></div> </div> </div> <div class=\"item-info\"><span class=\"icon icon-clock\"></span><span class=\"txt\">{{item.duration_completed | minutesHours}} / {{item.totalDuration | minutesHours}}</span></div> </div> <div class=\"vid-progress-container lib-page-item-progress-wrp\"> <div class=\"vid-progres-buffer\"></div> <div class=\"vid-progres-current-wrp\"> <div ng-style=\"{ \'width\' : {{item.progress}} + \'%\'}\" class=\"vid-progres-current\"> </div> <div ng-style=\"{ \'left\' : \'calc(\'+ {{item.progress}} +\'% \' + \'- 12.5px\'+\')\'}\" class=\"vid-play-btn\"> <div class=\"play2-icon\"></div> </div> </div> </div> <div class=\"lib-page-hist-bottom-wrp clearfix\"> <div class=\"view-info left\"> <div class=\"plylist-date\">created on {{item.plalistCreatedDate}}</div> </div> </div> </div> </div> </div> <div ng-if=\"userPlaylistData.length &gt; 3\" ng-click=\"viewMoreUsrPlaylist()\" class=\"skil-trend-view-btn dash-last-play-test remove-focus\"> <div class=\"txt\">View More</div> </div> </div> <div ng-if=\"libPlaylistState\" class=\"skil-pg-trend-wrp\"> <div class=\"skil-pg-title\">TRENDING</div> <div class=\"skill-pg-tile-wrp-section row\"> <div ng-repeat=\"item in curatedPlaylistData\" ng-if=\"moreCurPlaylist &gt;= $index\" class=\"large-4 medium-4 small-12 columns skill-pg-tile-wrp\"> <div class=\"curated-playlist-wrp\"> <div class=\"curated-playlist-top\"> <div class=\"curated-playlist-title\">{{item.title}}</div> <div class=\"item-info\"><span class=\"icon icon-clock\"></span><span class=\"txt\">{{item.duration_completed | minutesHours}} / {{item.totalDuration | minutesHours}}</span></div> </div> <div class=\"vid-progress-container lib-page-item-progress-wrp\"> <div class=\"vid-progres-buffer\"></div> <div class=\"vid-progres-current-wrp\"> <div ng-style=\"{ \'width\' : {{item.progress}} + \'%\'}\" class=\"vid-progres-current\"> </div> <div ng-style=\"{ \'left\' : \'calc(\'+{{item.progress}} +\'% \' + \'- 12.5px\'+\')\'}\" class=\"vid-play-btn\"> <div class=\"play2-icon\"></div> </div> </div> </div> <div class=\"lib-page-hist-bottom-wrp clearfix\"> <div class=\"view-info left\"> <div class=\"icon icon-view\"></div> <div class=\"txt\">{{item.views}}</div> </div> <div class=\"plylist-date right\">published on {{item.plalistCreatedDate}}</div> </div> </div> </div> </div> <div ng-if=\"curatedPlaylistData.length &gt; 3\" ng-click=\"viewMoreCurPlaylist()\" class=\"skil-trend-view-btn dash-last-play-test remove-focus\"> <div class=\"txt\">View More </div> </div> </div> </div> </div>");
$templateCache.put("app/Features/libraryPage/template/helpMePlan.html"," <div ng-if=\"shwHelpMePage\" class=\"help-me-pg-wrp\"> <div class=\"help-me-bg-opcity\"></div> <div class=\"help-me-cntnt-pg\"> <div class=\"help-me-cntnt-pg-dummy relative\"> <div ng-click=\"toggleHelpScreen()\" class=\"icon icon-close remove-focus\"></div> <div class=\"help-me-options-sctn\"> <div class=\"help-me-options-top-wrp table full-width\"> <div class=\"msg table-cell\">{{helpMePlanData.itemQued}} Items queued in Player</div> <div class=\"help-me-sbscrptin-wrp table-cell\"><span>Subscription ends </span><span class=\"bold\">{{helpMePlanData.lpEndDate | dateFilter}}</span></div> </div> <div class=\"help-me-lp-duration\"> <div class=\"icon-clock\"></div> <div class=\"time\">{{helpMePlanData.queDuration | minutesHours}}</div> </div> <div class=\"help-me-content-wrp\"> <div class=\"help-me-content-item table full-width\"> <div class=\"item-left table-cell\"> When do you wish to finish</div> <div class=\"item-right table-cell\"> <md-content> <md-datepicker ng-model=\"myDate\" md-placeholder=\"Enter date\" md-min-date=\"minDate\" md-max-date=\"maxDate\"></md-datepicker> </md-content> </div> </div> <div class=\"help-me-content-item table full-width\"> <div class=\"item-left table-cell\">When do you wish to finish</div> <div class=\"item-right table-cell\"> <div class=\"text-size-slider\"> <div class=\"slider-functional-area table\"> <div class=\"table-cell slider-bar-con relative\"> <input type=\"range\" min=\"5\" max=\"40\" value=\"noOfHrsWeek\" step=\"5\" ng-model=\"noOfHrsWeek\" ng-change=\"scheduleChange(noOfHrsWeek)\" class=\"slider\"> <ul class=\"hrs-p-week-slider-steps\"> <li></li> <li></li> <li></li> <li></li> <li></li> <li></li> </ul> </div> <div class=\"table-cell\"><span class=\"hrs-per-week-txt\">{{noOfHrsWeek}}h / WEEK</span></div> </div> </div> </div> </div> </div> <div class=\"help-me-content-btn-wrp\"> <div class=\"help-me-save-btn\"> <div ng-click=\"toggleHelpScreen()\" class=\"tertiary_color remove-focus\">Cancel</div> </div> <div class=\"help-me-save-btn\"> <div ng-click=\"SaveHelpScreen(myDate)\" class=\"primary_btn\">Save </div> </div> </div> </div> </div> </div> </div>");
$templateCache.put("app/Features/libraryPage/template/libLPpage.html"," <div class=\"skil-pg-wrp\"> <div ng-repeat=\"lp in lpData\" class=\"lib-lp-wrp\"> <div ng-click=\"openLibLPpath($index)\" class=\"lib-lp-section row remove-focus\"> <div ng-class=\"{\'lib-lp-active\': lpIndex == $index &amp;&amp; shwLPxpand}\" class=\"lib-lp-item\"> <div class=\"lib-lp-top-wrp clearfix\"> <div class=\"lib-lp-info-section\"> <div class=\"title\">{{lp.title}}</div> <div class=\"lib-lp-info hide-in-mobile\"> <div class=\"info\">SKILLS:{{lp.totalSkills}}</div> <div class=\"info\">VIDEOS: {{lp.totalVideos}}</div> <div class=\"info\">DURATION: {{lp.duration | minutesHours}}</div> </div> </div> <div class=\"lib-lp-desc\"> <div class=\"txt\">{{lp.description}}</div> </div> </div> <div class=\"vid-progress-container lib-page-item-progress-wrp hide-in-mobile\"> <div class=\"vid-progres-buffer\"></div> </div> <div class=\"lib-lp-bottom-wrp hide-in-mobile\"><span class=\"bold\">{{lp.totalLearnes}} Learners</span><span>have been certified on this</span></div> <div class=\"lib-lp-mob-info hide-in-tablet-up\"> <div class=\"lib-lp-info\"> <div class=\"info\">SKILLS:{{lp.totalSkills}}</div> <div class=\"info\">VIDEOS: {{lp.totalVideos}}</div> <div class=\"info\">DURATION: {{lp.duration | minutesHours}}</div> </div> <div class=\"lib-lp-bottom-wrp\"><span class=\"bold\">{{lp.totalLearnes}} Learners</span><span>have been certified on this</span></div> <div class=\"lib-next-lp-btn-wrp remove-focus\"> <div class=\"primary_btn\"> <div class=\"txt\">Load Learning Path </div> <div class=\"icon icon-next\"></div> </div> </div> </div> </div> <div ng-if=\"lpIndex == $index &amp;&amp; shwLPxpand\" class=\"lib-tile-arrow-wrp\"><img ng-src=\"assets/images/icon_down.png\" class=\"lp-icon\"></div> </div> <div ng-if=\"lpIndex == $index &amp;&amp; shwLPxpand\" class=\"lib-lp-expand hide-in-mobile\"> <div class=\"skil-pg-trend-wrp\"> <div class=\"skil-pg-title\">{{lp.moduleDetails.length}} Items</div> <div class=\"skill-pg-tile-wrp-section row\"> <div ng-repeat=\"module in lp.moduleDetails\" class=\"large-4 medium-4 small-12 columns skill-pg-tile-wrp\"> <library-tile tile-info=\"module\"> </library-tile> </div> </div> <div ng-if=\"lp.moduleDetails.length &gt; 3\" ng-click=\"viewMoreTileLp($index)\" class=\"skil-trend-view-btn dash-last-play-test remove-focus\"> <div class=\"txt\">View More</div> </div> <div class=\"lib-load-lp-btn clearfix\"> <div class=\"primary_btn left remove-focus\"> <div class=\"btn-inner-clearfix\"> <div class=\"txt left\">Load Learning Path</div> <div class=\"icon icon-next left\"></div> </div> </div> </div> <div class=\"lib-load-lp-note-wrp\"> <div class=\"lib-lp-bottom-wrp\"><span class=\"bold\">*NOTE: </span><span>You can load a Learning Path once you finish the learning path assigned to you.</span></div> </div> </div> </div> </div> </div>");
$templateCache.put("app/Features/libraryPage/template/libSearchPage.html"," <div class=\"lib-srch-pg\"> <div class=\"srch-sugest-wrp hide-in-mobile\"> <div ng-repeat=\"item in srchSuggestion\" class=\"suggestion-txt\"><span>{{item}} </span><span ng-if=\"!$last\">, </span></div> </div> <div class=\"srch-hdr-wrp clearfix\"> <div class=\"hdng left\">{{srchResults.length}} Results found</div> <div ng-click=\"srchFilterToggle()\" class=\"srch-hdr-optins-wrp right remove-focus relative\"> <div class=\"optn\">{{srchResultFilterItem}}</div> <div class=\"icon icon-filter\"></div> <ul ng-if=\"toggleSrchFilter\" class=\"srch-filter-content\"> <li ng-repeat=\"i in srchResultFilter\" ng-if=\"srchResultFilterItem != i\" ng-click=\"srchResultFilterParam($index);$event.stopPropagation()\" class=\"remove-focus\">{{i}} </li> </ul> </div> </div> <div ng-if=\"!shwDataByFilter\" class=\"srch-results-section-all\"> <div ng-repeat=\"result in srchResults | orderBy: &quot;result.relevenceID&quot;\" class=\"srch-results-item-wrp\"> <div class=\"srch-results-item-top-wrp clearfix\"> <div ng-class=\"{&quot;icon-video&quot;:result.type == &quot;video&quot; ,&quot;icon-quiz&quot; :result.type == &quot;quiz&quot; ,&quot;icon-skills&quot;:result.type== &quot;skill&quot; , &quot;icon-path&quot;:result.type === &quot;lp&quot;,&quot;icon-casestudy&quot; :result.type == &quot;assignment&quot; }\" class=\"icon left\"></div> <div class=\"title left\"> <div class=\"txt\">{{result.title}}</div> <div class=\"srch-module-title\">{{result.moduleName}} </div> </div> <div ng-if=\"result.type != &quot;lp&quot; &amp;&amp; result.type != &quot;skill&quot;\" class=\"time-wrp left\"> <div class=\"icon-clock\"></div> <div class=\"time\">{{result.duration | minutesHours}} </div> </div> </div> <div class=\"srch-results-desc\">{{result.description}}</div> <div ng-if=\"result.type == &quot;skill&quot;\" class=\"srch-results-time-info\"> <div class=\"item-details-wrp\"><span class=\"icon-video\"></span><span>{{result.duration | minutesHours}} / {{result.duration_completed | minutesHours}}</span><span class=\"icon-assignment\"></span><span>{{result.assignment_duration | minutesHours}} / {{result.assignment_duration_completed | minutesHours}}</span></div> </div> <div ng-if=\"result.type == &quot;lp&quot;\" class=\"modules-info-wrp\"><span>modules: </span><span>7</span><span class=\"heading\">videos: </span><span>34</span><span class=\"heading\">duration: </span><span>60h</span></div> </div> </div> <div ng-if=\"shwDataByFilter\" class=\"srch-results-section-filtered\"> <div ng-repeat=\"(key, value) in srchFilteredData\" class=\"srch-filter\"> <div class=\"srch-filter-title\">{{key}}</div> <div ng-repeat=\"result in value\" class=\"srch-results-item-wrp\"> <div class=\"srch-results-item-top-wrp clearfix\"> <div ng-class=\"{&quot;icon-video&quot;:result.type == &quot;video&quot; ,&quot;icon-quiz&quot; :result.type == &quot;quiz&quot; ,&quot;icon-skills&quot;:result.type== &quot;skill&quot; , &quot;icon-path&quot;:result.type === &quot;lp&quot;,&quot;icon-casestudy&quot; :result.type == &quot;assignment&quot; }\" class=\"icon left\"></div> <div class=\"title left\"> <div class=\"txt\">{{result.title}}</div> <div class=\"srch-module-title\">{{result.moduleName}} </div> </div> <div ng-if=\"result.type != &quot;lp&quot; &amp;&amp; result.type != &quot;skill&quot;\" class=\"time-wrp left\"> <div class=\"icon-clock\"></div> <div class=\"time\">{{result.duration | minutesHours}} </div> </div> </div> <div class=\"srch-results-desc\">{{result.description}}</div> <div ng-if=\"result.type == &quot;skill&quot;\" class=\"srch-results-time-info\"> <div class=\"item-details-wrp\"><span class=\"icon-video\"></span><span>{{result.duration | minutesHours}} / {{result.duration_completed | minutesHours}}</span><span class=\"icon-assignment\"></span><span>{{result.assignment_duration | minutesHours}} / {{result.assignment_duration_completed | minutesHours}}</span></div> </div> <div ng-if=\"result.type == &quot;lp&quot;\" class=\"modules-info-wrp\"><span>modules: </span><span>7</span><span class=\"heading\">videos: </span><span>34</span><span class=\"heading\">duration: </span><span>60h</span></div> </div> </div> </div> </div>");
$templateCache.put("app/Features/libraryPage/template/playlistNavDrawer.html"," <div class=\"lib-playlist-drawer-wrp\"> <div class=\"playlist-drawer-tabs-wrp clearfix\"> <div ng-click=\"openMyQPlaylist()\" ng-class=\"{&quot;active&quot;:playListState}\" class=\"playlist-drawer-tab remove-focus\">MY QUEUE <div ng-if=\"playListState\" class=\"icon icon-next\"></div> </div> <div ng-click=\"openMyPlaylist()\" ng-class=\"{&quot;active&quot;:!playListState}\" class=\"playlist-drawer-tab remove-focus\">PLAYLISTS <div ng-if=\"!playListState\" class=\"icon icon-next\"></div> </div> </div> <div ng-if=\"playListState\" class=\"lib-play-my-q-wrp\"> <div class=\"playlist-lib-last-played-wrp\"> <div class=\"txt\">LAST PLAYED</div> <div class=\"lib-play-last-wrp relative\"> <div class=\"vid-vidplaylist-items-wrp\"> <div class=\"current-video-wrp\"> <div class=\"lib-playlist-lst-item vid-item-current\"> <div class=\"vid-vidplaylist-item-context\"><span class=\"icon-video\"></span></div> <div class=\"vid-vidplaylist-item-det-wrp\"> <div class=\"vid-vidplaylist-item-title\">{{myQueData.lastplayedVideo.title}}</div> <div class=\"vid-vidplaylist-item-time-wrp\"> <div class=\"vid-vidplaylist-item-time-img\"><span class=\"icon-clock\"></span></div> <div class=\"vid-vidplaylist-item-time-det\">{{myQueData.lastplayedVideo.duration_completed | minutesHours}} / {{myQueData.lastplayedVideo.duration | minutesHours}}</div> </div> </div> </div> </div> </div> <div ng-style=\"{ \'width\' : myQueData.lastplayedVideo.progress + \'%\'}\" class=\"lib-progress-bar\"></div> </div> <div class=\"txt\">Recently PLAYED</div> <div class=\"lib-play-rcnt-wrp\"> <div class=\"vid-vidplaylist-items-wrp\"> <div class=\"vid-playlist-wrp\"> <div class=\"current-video-wrp\"> <div ng-repeat=\"video in quedVideos\" ng-class=\"{\'lib-plylist-completed\': video.progress === 100}\" class=\"lib-playlist-item-wrp\"> <div class=\"vid-vidplaylist-item-context\"><span class=\"icon-video\"></span></div> <div class=\"vid-vidplaylist-item-det-wrp\"> <div class=\"vid-vidplaylist-item-title\">{{video.title}}</div> <div class=\"vid-vidplaylist-item-time-wrp\"> <div class=\"vid-vidplaylist-item-time-img\"><span class=\"icon-clock\"></span></div> <div class=\"vid-vidplaylist-item-time-det\">{{video.duration_completed | minutesHours}} / {{video.duration | minutesHours}}</div> </div> </div> <div ng-style=\"{ \'width\' : video.progress + \'%\'}\" class=\"lib-plyitem-progress-bar\"></div> </div> </div> <div class=\"scroll-bar vid-other-video-wrp\"> <div ng-repeat=\"item in modulePlaylistItems\" ng-click=\"clickedPlaylistItem(item.sequence_id,item.type)\"> <div ng-class=\"{\'vid-item-completed\': item.status == \'completed\'}\" class=\"vid-vidplaylist-item-wrp\"> <div class=\"playlist-cmplt-icon\"> <div class=\"icon icon-next\"></div> </div> <div class=\"vid-playlist-tab table\"> <div class=\"vid-vidplaylist-item-context\"><span class=\"icon-video\"> </span></div> <div class=\"vid-vidplaylist-item-det-wrp\"> <div class=\"vid-vidplaylist-item-title\">{{item.data.title}}</div> <div class=\"vid-vidplaylist-item-time-wrp\"> <div class=\"vid-vidplaylist-item-time-img\"><span class=\"icon-clock\"></span></div> <div class=\"vid-vidplaylist-item-time-det\">{{item.data.duration | minutesHours}}</div> </div> </div> </div> <div ng-style=\"{ \'width\' : item.progress + \'%\'}\" class=\"lib-plyitem-progress-bar\"></div> </div> </div> </div> </div> </div> </div> </div> </div> <div ng-if=\"!playListState\" class=\"lib-palylist-menu-wrp height100\"> <div ng-if=\"shwExpndOfPlaylist\" class=\"lib-playlist-menu-section\"> <div ng-click=\"openPlaylistContent()\" class=\"close-view remove-focus\"> <div class=\"icon-close\"></div> </div> <div class=\"user-playlist-section\"> <div class=\"user-playlist-wrp\"> <div class=\"title\">My Playlist</div> <div class=\"user-playlist-items\"> <div ng-repeat=\"item in userPlaylistData\" class=\"user-playlist-item table full-width\"> <div class=\"user-playlist-left table-cell\"> <div class=\"txt\"> {{item.title}}</div> <div class=\"usr-plylist-info-wrp\"> <div class=\"usr-plylist-no-vid\">{{item.playlistData.length}} Videos</div> <div class=\"usr-plylist-time-wrp\"><span class=\"icon-clock\"></span><span>{{item.totalDuration | minutesHours}}</span></div> </div> </div> <div class=\"user-playlist-right table-cell\"> <div class=\"icon icon-delete\"></div> </div> </div> </div> </div> <div class=\"user-playlist-wrp\"> <div class=\"title\">Curated Playlist</div> <div class=\"user-playlist-items\"> <div ng-repeat=\"item in curatedPlaylistData\" class=\"user-playlist-item table full-width\"> <div class=\"user-playlist-left table-cell\"> <div class=\"txt\"> {{item.title}}</div> <div class=\"usr-plylist-info-wrp\"> <div class=\"usr-plylist-no-vid\">{{item.playlistData.length}} Videos</div> <div class=\"usr-plylist-time-wrp\"><span class=\"icon-clock\"></span><span>{{item.totalDuration | minutesHours}}</span></div> </div> </div> <div class=\"user-playlist-right table-cell\"> <div class=\"icon icon-delete\"> </div> </div> </div> </div> </div> </div> </div> <div ng-if=\"!shwExpndOfPlaylist\" class=\"lib-plylist-menu-xpnd-section\"> <div ng-repeat=\"playlist in userPlaylistData\" ng-init=\"playlistNo = $index\" class=\"lib-dummy-wrp\"> <div class=\"lib-exs-playlist-wrp-title clearfix\"> <div class=\"txt left\">{{playlist.title}}</div> <div ng-click=\"openPlaylistContent()\" class=\"icon right icon-menu remove-focus\"></div> </div> <div class=\"lib-exs-playlist-content-wrp\"> <div ng-repeat=\"item in playlist.playlistData\" class=\"lib-item-dummy\"> <div ng-if=\"item.type === &quot;module&quot;\" ng-click=\"openPlaylistModule(playlistNo , $index)\" ng-class=\"{&quot;prog-badge-active&quot;:$index == crntPlyModule &amp;&amp; crntPlyNo == playlistNo &amp;&amp; openTilePlaylist}\" class=\"lib-exs-playlist-content-item\"> <div class=\"lib-exs-playlist-type\"> <div title=\"{{item.moduleName}}\" class=\"lib-exs-playlist-video\"> <div class=\"title\">{{item.moduleName}} </div> </div> <div ng-if=\"$index == crntPlyModule &amp;&amp; crntPlyNo == playlistNo &amp;&amp; openTilePlaylist\" class=\"lib-plylist-cntnt-wrp\"> <div ng-repeat=\"Videos in item.moduleVideos\" ng-click=\"playThisVideo(playlist);$event.stopPropagation();\" class=\"lib-plylist-cntnt-item table full-width relative\"> <div class=\"vid-vidplaylist-item-context\"><span class=\"icon-video\"></span></div> <div title=\"{{Videos.videoTitle}}\" class=\"vid-vidplaylist-item-det-wrp\"> <div class=\"vid-vidplaylist-item-title\">{{Videos.videoTitle}}</div> <div class=\"vid-vidplaylist-item-time-wrp\"> <div class=\"vid-vidplaylist-item-time-img\"><span class=\"icon-clock\"></span></div> <div class=\"vid-vidplaylist-item-time-det\">22 m </div> </div> </div> <div ng-style=\"{ \'width\' :{{Videos.progress}} + \'%\'}\" class=\"lib-plyitem-progress-bar\"></div> </div> </div> </div> </div> <div ng-if=\"item.type === &quot;video&quot;\" title=\"{{item.videoTitle}}\" ng-click=\"playThisVideo(playlist);$event.stopPropagation();\" class=\"lib-exs-playlist-video-type\"> <div class=\"lib-vid-name\">{{item.videoTitle}}</div> <div class=\"lib-tile-mod-name\">{{item.moduleName}}</div> </div> </div> </div> </div> <div ng-repeat=\"playlist in curatedPlaylistData\" ng-init=\"playlistNo = $index\" class=\"lib-dummy-wrp\"> </div> </div> </div> </div>");
$templateCache.put("app/Features/libraryPage/template/skillPageContent.html"," <div class=\"skil-pg-wrp\"> <div class=\"skil-pg-tabs\"> <div ng-click=\"openSkillTab(1)\" ng-class=\"{active: skilPageTab === &quot;1&quot;}\" class=\"skil-pg-tabs-item remove-focus\">Tools</div> <div ng-click=\"openSkillTab(2)\" ng-class=\"{active: skilPageTab === &quot;2&quot;}\" class=\"skil-pg-tabs-item remove-focus\">TECHNIQUES</div> <div ng-click=\"openSkillTab(3)\" ng-class=\"{active: skilPageTab === &quot;3&quot;}\" class=\"skil-pg-tabs-item remove-focus\">DOMAINS</div> </div> <div ng-if=\"skilPageTab == \'1\'\" class=\"skil-pg-tab-content\"> <div class=\"skil-pg-trend-wrp\"> <div class=\"skil-pg-title\">TRENDING</div> <div class=\"skill-pg-tile-wrp-section row\"> <div ng-repeat=\"item in toolTrendData\" ng-if=\"$index &lt;= viewMoreList[0][0]-1\" ng-init=\"item.isClicked = false\" class=\"large-4 medium-4 small-12 skill-pg-tile-wrp\"> <library-tile tile-info=\"item\" index=\"$index\" tiles-info=\"toolTrendData\"> </library-tile> </div> </div> <div ng-if=\"toolTrendData.length &gt; 3 &amp;&amp; toolTrendData.length != viewMoreList[0][0]\" ng-click=\"viewMoreItem(skilPageTab , 1 )\" class=\"skil-trend-view-btn dash-last-play-test remove-focus\"> <div class=\"txt\">View More</div> </div> <div ng-if=\"toolTrendData.length == (viewMoreList[0][0])\" ng-click=\"viewLessItem(skilPageTab , 1 )\" class=\"skil-trend-view-btn dash-last-play-test remove-focus\"> <div class=\"txt\">View Less </div> </div> </div> <div class=\"skil-pg-trend-wrp\"> <div class=\"skil-pg-title\">RECOMMENDED</div> <div class=\"skill-pg-tile-wrp-section row\"> <div ng-repeat=\"item in toolRecomendData\" ng-if=\"$index &lt;= viewMoreList[0][1]-1\" ng-init=\"innerIndex = $index\" class=\"large-4 medium-4 small-12 skill-pg-tile-wrp\"> <library-tile tile-info=\"item\" index=\"$index\" tiles-info=\"toolRecomendData\"> </library-tile> </div> </div> <div ng-if=\"toolRecomendData.length &gt; 3 &amp;&amp; toolTrendData.length != viewMoreList[0][1]\" ng-click=\"viewMoreItem(skilPageTab , 2 )\" class=\"skil-trend-view-btn dash-last-play-test remove-focus\"> <div class=\"txt\">View More</div> </div> <div ng-if=\"toolRecomendData.length == viewMoreList[0][1]\" ng-click=\"viewLessItem(skilPageTab , 2 )\" class=\"skil-trend-view-btn dash-last-play-test remove-focus\"> <div class=\"txt\">View Less </div> </div> </div> <div class=\"skil-pg-trend-wrp\"> <div class=\"skil-pg-title\">NEW</div> <div class=\"skill-pg-tile-wrp-section row\"> <div ng-repeat=\"item in toolNewData\" ng-if=\"$index &lt;= viewMoreList[0][2]-1\" ng-init=\"innerIndex = $index\" class=\"large-4 medium-4 small-12 skill-pg-tile-wrp\"> <library-tile tile-info=\"item\" index=\"$index\" tiles-info=\"toolNewData\"> </library-tile> </div> </div> <div ng-if=\"toolNewData.length &gt;3 &amp;&amp; toolNewData.length != (viewMoreList[0][2])\" ng-click=\"viewMoreItem(skilPageTab , 3 )\" class=\"skil-trend-view-btn dash-last-play-test remove-focus\"> <div class=\"txt\">View More</div> </div> <div ng-if=\"toolNewData.length == (viewMoreList[0][2])\" ng-click=\"viewLessItem(skilPageTab , 3 )\" class=\"skil-trend-view-btn dash-last-play-test remove-focus\"> <div class=\"txt\">View Less </div> </div> </div> </div> <div ng-if=\"skilPageTab == \'2\'\" class=\"skil-pg-tab-content\"> <div class=\"skil-pg-trend-wrp\"> <div class=\"skil-pg-title\">TRENDING</div> <div class=\"skill-pg-tile-wrp-section row\"> <div ng-repeat=\"item in techniqueTrendData\" ng-if=\"$index &lt;= viewMoreList[1][0]-1\" class=\"large-4 medium-4 small-12 skill-pg-tile-wrp\"> <library-tile tile-info=\"item\" index=\"$index\" tiles-info=\"techniqueTrendData\"> </library-tile> </div> </div> <div ng-if=\"techniqueTrendData.length &gt;3 &amp;&amp; toolTrendData.length != viewMoreList[1][0]\" ng-click=\"viewMoreItem(skilPageTab , 1 )\" class=\"skil-trend-view-btn dash-last-play-test remove-focus\"> <div class=\"txt\">View More</div> </div> <div ng-if=\"techniqueTrendData.length == viewMoreList[1][0]\" ng-click=\"viewLessItem(skilPageTab , 1 )\" class=\"skil-trend-view-btn dash-last-play-test remove-focus\"> <div class=\"txt\">View Less </div> </div> </div> <div class=\"skil-pg-trend-wrp\"> <div class=\"skil-pg-title\">RECOMMENDED</div> <div class=\"skill-pg-tile-wrp-section row\"> <div ng-repeat=\"item in techniqueRecomendData\" ng-if=\"$index &lt;= viewMoreList[1][1]-1\" class=\"large-4 medium-4 small-12 skill-pg-tile-wrp\"> <library-tile tile-info=\"item\" index=\"$index\" tiles-info=\"techniqueRecomendData\"> </library-tile> </div> </div> <div ng-if=\"techniqueRecomendData.length &gt; 3 &amp;&amp; toolTrendData.length != viewMoreList[1][1]\" ng-click=\"viewMoreItem(skilPageTab , 2)\" class=\"skil-trend-view-btn dash-last-play-test remove-focus\"> <div class=\"txt\">View More</div> </div> <div ng-if=\"techniqueRecomendData.length == viewMoreList[1][1]\" ng-click=\"viewLessItem(skilPageTab , 2)\" class=\"skil-trend-view-btn dash-last-play-test remove-focus\"> <div class=\"txt\">View Less </div> </div> </div> <div class=\"skil-pg-trend-wrp\"> <div class=\"skil-pg-title\">NEW</div> <div class=\"skill-pg-tile-wrp-section row\"> <div ng-repeat=\"item in techniqueNewData\" ng-if=\"$index &lt;= viewMoreList[1][2]-1\" class=\"large-4 medium-4 small-12 skill-pg-tile-wrp\"> <library-tile tile-info=\"item\" index=\"$index\" tiles-info=\"techniqueNewData\"> </library-tile> </div> </div> <div ng-if=\"techniqueNewData.length &gt;3 &amp;&amp; toolTrendData.length != viewMoreList[1][2]\" ng-click=\"viewMoreItem(skilPageTab , 3)\" class=\"skil-trend-view-btn dash-last-play-test remove-focus\"> <div class=\"txt\">View More</div> </div> <div ng-if=\"techniqueNewData.length == viewMoreList[1][2]\" ng-click=\"viewLessItem(skilPageTab , 3)\" class=\"skil-trend-view-btn dash-last-play-test remove-focus\"> <div class=\"txt\">View Less </div> </div> </div> </div> <div ng-if=\"skilPageTab == \'3\'\" class=\"skil-pg-tab-content\"> <div class=\"skil-pg-trend-wrp\"> <div class=\"skil-pg-title\">TRENDING</div> <div vertilizecontainer=\"\" class=\"skill-pg-tile-wrp-section row\"> <div ng-repeat=\"item in DomainTrendData\" ng-if=\"$index &lt;= viewMoreList[2][0]-1\" class=\"large-4 medium-4 small-12 skill-pg-tile-wrp\"> <library-tile tile-info=\"item\" index=\"$index\" tiles-info=\"DomainTrendData\"> </library-tile> </div> </div> <div ng-if=\"DomainTrendData.length &gt;3 &amp;&amp; DomainTrendData.length != viewMoreList[2][0]\" ng-click=\"viewMoreItem(skilPageTab , 1 )\" class=\"skil-trend-view-btn dash-last-play-test remove-focus\"> <div class=\"txt\">View More</div> </div> <div ng-if=\"DomainTrendData.length == viewMoreList[2][0]\" ng-click=\"viewLessItem(skilPageTab , 1)\" class=\"skil-trend-view-btn dash-last-play-test remove-focus\"> <div class=\"txt\">View Less </div> </div> </div> <div class=\"skil-pg-trend-wrp\"> <div class=\"skil-pg-title\">RECOMMENDED</div> <div class=\"skill-pg-tile-wrp-section row\"> <div ng-repeat=\"item in DomainRecomendData\" ng-if=\"$index &lt;= viewMoreList[2][1]-1\" class=\"large-4 medium-4 small-12 skill-pg-tile-wrp\"> <library-tile tile-info=\"item\" index=\"$index\" tiles-info=\"DomainRecomendData\"> </library-tile> </div> </div> <div ng-if=\"DomainRecomendData.length &gt;3 &amp;&amp; DomainRecomendData.length != viewMoreList[2][1]\" ng-click=\"viewMoreItem(skilPageTab , 2 )\" class=\"skil-trend-view-btn dash-last-play-test remove-focus\"> <div class=\"txt\">View More</div> </div> <div ng-if=\"DomainRecomendData.length == viewMoreList[2][1]\" ng-click=\"viewLessItem(skilPageTab , 2)\" class=\"skil-trend-view-btn dash-last-play-test remove-focus\"> <div class=\"txt\">View Less </div> </div> </div> <div class=\"skil-pg-trend-wrp\"> <div class=\"skil-pg-title\">NEW {{DomainNewData.length }} {{viewMoreList[2][2]}}</div> <div class=\"skill-pg-tile-wrp-section row\"> <div ng-repeat=\"item in DomainNewData\" ng-if=\"$index &lt;= viewMoreList[2][2]-1\" class=\"large-4 medium-4 small-12 skill-pg-tile-wrp\"> <library-tile tile-info=\"item\" index=\"$index\" tiles-info=\"DomainNewData\"></library-tile> </div> </div> <div ng-if=\"DomainNewData.length &gt; 3 &amp;&amp; DomainNewData.length != viewMoreList[2][2]\" ng-click=\"viewMoreItem(skilPageTab , 3)\" class=\"skil-trend-view-btn dash-last-play-test remove-focus\"> <div class=\"txt\">View More</div> </div> <div ng-if=\"DomainNewData.length == viewMoreList[2][2]\" ng-click=\"viewLessItem(skilPageTab , 3)\" class=\"skil-trend-view-btn dash-last-play-test remove-focus\"> <div class=\"txt\">View Less </div> </div> </div> </div> </div>");
$templateCache.put("app/Features/libraryPageVideoPlayer/template/libVideoPlayList.html"," <div class=\"vid-vidplaylist-title-wrp table full-width\"> <div class=\"vid-vidplaylist-top-wrp table-cell\"> <div class=\"vid-vidplaylist-title-dummy table full-width\"> <div class=\"vid-vidplaylist-title-no table-cell\">02.</div> <div class=\"vid-vidplaylist-title-txt table-cell\">heyjhasjh</div> </div> </div> <div ng-click=\"filterPlaylist()\" ng-class=\"{\'vid-filter-active\':togglePlaylistFilter}\" class=\"vid-vidplaylist-filter table-cell\"><span class=\"icon-filter\"></span></div> </div> <div class=\"lib-playlist-scroll\"> <div ng-repeat=\"playlist in playlists\" ng-init=\"playlistNo = $index\" class=\"lib-dummy-wrp\"> <div class=\"lib-exs-playlist-content-wrp\"> <div ng-repeat=\"item in playlist.playlistData\" class=\"lib-item-dummy\"> <div ng-if=\"item.type === &quot;module&quot;\" ng-click=\"openPlaylistModule(playlistNo , $index)\" class=\"lib-exs-playlist-content-item\"> <div class=\"lib-exs-playlist-type\"> <div class=\"lib-exs-playlist-video\"> <div class=\"title\">{{item.moduleName}} </div> </div> <div ng-if=\"$index == crntPlyModule &amp;&amp; crntPlyNo == playlistNo &amp;&amp; openTilePlaylist\" class=\"lib-plylist-cntnt-wrp\"> <div ng-repeat=\"Videos in item.moduleVideos\" class=\"lib-plylist-cntnt-item table full-width relative\"> <div class=\"vid-vidplaylist-item-context\"><span class=\"icon-video\"></span></div> <div class=\"vid-vidplaylist-item-det-wrp\"> <div class=\"vid-vidplaylist-item-title\">{{Videos.videoTitle}}</div> <div class=\"vid-vidplaylist-item-time-wrp\"> <div class=\"vid-vidplaylist-item-time-img\"><span class=\"icon-clock\"></span></div> <div class=\"vid-vidplaylist-item-time-det\">22 m </div> </div> </div> <div ng-style=\"{ \'width\' :{{Videos.progress}} + \'%\'}\" class=\"lib-plyitem-progress-bar\"></div> </div> </div> </div> </div> <div ng-if=\"item.type === &quot;video&quot;\" class=\"lib-exs-playlist-video\"> <div class=\"lib-vid-name\">{{item.videoTitle}}</div> <div class=\"lib-tile-mod-name\">{{item.moduleName}} </div> </div> </div> </div> </div> </div>");
$templateCache.put("app/Features/libraryPageVideoPlayer/template/libVideoPlayer.html"," <div ng-show=\"!showTrimScreen\" class=\"vid-player-page-wrp\"> <div class=\"vid-player-mob-hdng-wrp hide-in-tablet-up\"> <div ng-click=\"goToDashboard();$event.stopPropagation();\" class=\"vid-player-mob-hdng-back remove-focus\"><span class=\"icon-back\"></span></div> <div txt-resize=\"\" maxwidth=\"300\" class=\"vid-player-mob-hdng\"><span class=\"vid-play-mob-txt-no\">{{activeModuleData.sequence_id}}.</span><span class=\"vid-play-mob-txt\">{{activeModuleData.title}}</span></div> </div> <div class=\"vid-player-section row\"> <div class=\"vid-player-wrp large-12 columns\"> <div class=\"video-player-container\"> <div class=\"vid-player-screenshot\"> <div ng-click=\"takeScreenshot();$event.stopPropagation();\" ng-show=\"!takeNotesToggle\" class=\"vid-player-default-opt-item remove-focus hide-in-tablet-up\"><span class=\"icon-capture2\"></span></div> </div> <videogular vg-update-time=\"updateTime($currentTime)\" vg-player-ready=\"onPlayerReady($API)\" vg-update-state=\"onUpdateState($state)\" vg-seeking=\"onSeeking()\" vg-seeked=\"onSeeked()\" class=\"remove-focus\"> <vg-media vg-src=\"Videoconfig.sources\" vg-tracks=\"Videoconfig.tracks\" ng-click=\"API.playPause()\" class=\"remove-focus\"></vg-media> <vg-controls vg-autohide=\"false\" vg-autohide-time=\"2000\"> <div ng-click=\"playPrevItem()\" class=\"vid-controls-item-wrp vid-time-mob remove-focus\"> <div class=\"vid-controls-item\"><span class=\"icon-previousvideo\"> </span></div> </div> <vg-play-pause-button></vg-play-pause-button> <div ng-click=\"playNextItem()\" class=\"vid-controls-item-wrp vid-time-mob remove-focus\"> <div class=\"vid-controls-item\"><span class=\"icon-nextvideo\"></span></div> </div> <rewind-ten></rewind-ten> <div ng-click=\"volumeBartoggle()\" ng-class=\"muteIcon\" class=\"volume-control-wrp remove-focus\"> <div ng-if=\"toggleVolume\" class=\"volume-slider-wrp volume-arrow remove-focus\"> <div ng-class=\"muteIcon\" ng-click=\"videoMute();$event.stopPropagation();\" class=\"vid-mute-btn remove-focus\"></div> <md-slider flex=\"\" min=\"0\" max=\"100\" ng-model=\"currentVolume\" ng-change=\"updateVolumeView(currentVolume)\" aria-label=\"volume\" class=\"volume-slider\"></md-slider> </div> </div> <vg-scrub-bar> <seek-bar></seek-bar> <vg-scrub-bar-thumbnails vg-thumbnails=\"Videoconfig.thumbnails\"></vg-scrub-bar-thumbnails> <vg-scrub-bar-buffer></vg-scrub-bar-buffer> <vid-cuepoints vg-cuepoints-config=\"Videoconfig.plugins.cuePoints\" vg-cuepoints-weight=\"Videoconfig.plugins.cuePoints\"> </vid-cuepoints> </vg-scrub-bar> <vg-time-display class=\"hide-in-mobile\">{{ currentTime | timeFormat}} / {{ totalTime | timeFormat}}</vg-time-display> <vg-time-display class=\"hide-in-tablet hide-in-desktop-up vid-time-mob\">{{ currentTime | timeFormat}}</vg-time-display> <div class=\"settings-wrp\"> <div class=\"settings-icon\"><span ng-click=\"settingsOptWrp()\" ng-class=\"{\'active\': settingsOpt}\" class=\"icon-videosettings remove-focus\"></span></div> <div ng-show=\"settingsOpt\" ng-mouseleave=\"onMouseLeave()\" class=\"settings-options-wrp settings-arrow\"> <div ng-click=\"subtitlesOptWrp()\" class=\"settings-subtitles remove-focus clearfix\"><span class=\"heading\">Subtitles</span><span class=\"icon-subtitles\"></span><span class=\"icon-next\"></span><span class=\"forward-arrow\">{{subtitlesVal}}</span></div> <div ng-click=\"qualityOptWrp()\" class=\"settings-quality clearfix remove-focus\"><span class=\"heading\">Quality</span><span class=\"icon-next\"></span><span class=\"forward-arrow\">{{qualityVal}}p</span></div> <div ng-click=\"speedOptWrp()\" class=\"settings-speed clearfix remove-focus\"><span class=\"heading\">Speed</span><span class=\"icon-next\"></span><span class=\"forward-arrow\">{{speedVal}}</span></div> </div> <div ng-show=\"qualityOpt\" class=\"settings-quality-wrp\"> <div ng-click=\"settingsOptWrp()\" class=\"settings-quality-heading heading remove-focus\"> <span class=\"icon-back\"></span><span>Quality</span></div> <div ng-repeat=\"quality in quality\" class=\"settings-quality-options value\"><span ng-click=\"qualityIndex(this.$index)\" class=\"remove-focus\">{{quality}}p</span></div> </div> <div ng-show=\"speedOpt\" class=\"settings-speed-wrp\"> <div ng-click=\"settingsOptWrp()\" class=\"settings-speed-heading heading remove-focus\"> <span class=\"icon-back\"></span><span>Speed</span></div> <div ng-repeat=\"speed in speed\" class=\"settings-speed-options value\"><span ng-click=\"speedIndex(this.$index)\">{{speed}}</span></div> </div> <div ng-show=\"subtitlesOpt\" class=\"settings-subtitles-wrp\"> <div ng-click=\"settingsOptWrp()\" class=\"settings-subtitles-heading heading remove-focus\"> <span class=\"icon-back\"></span><span>Subtitles</span></div> <div ng-repeat=\"sub in subtitles\" class=\"settings-subtitles-options value\"><span ng-click=\"subtitleIndex(this.$index)\">{{sub}}</span></div> </div> </div> <div ng-click=\"API.toggleFullScreen()\" class=\"full-screen-icon-wrp remove-focus\"><span class=\"icon-fullscreen\"></span></div> </vg-controls> <div ng-class=\"overlayPlayIcon\" class=\"vid-player-overlay-section-dummy\"> </div> <div ng-class=\"overlayPlayIcon\" ng-click=\"API.playPause()\" class=\"vid-player-overlay-section remove-focus\"> <div class=\"vid-player-overlay-default\"> <div class=\"vid-player-overlay-hdng-wrp table\"> <div ng-click=\"goToDashboard();$event.stopPropagation();\" class=\"vid-player-overlay-back table-cell remove-focus hide-in-mobile\"><span class=\"icon-back\"></span></div> <div ng-click=\"bookmarkVideo();$event.stopPropagation();\" class=\"vid-player-overlay-bookmark table-cell remove-focus\"><span ng-class=\"{\'active\': bookmarked}\" class=\"icon-bookmark\"> </span></div> <div class=\"vid-player-overlay-title table-cell hide-in-mobile\">{{videoTitle}}</div> <div ng-show=\"!takeNotesToggle\" class=\"vid-player-overlay-title table-cell hide-in-tablet-up\">{{videoTitle}}</div> <div ng-show=\"takeNotesToggle &amp;&amp; !shwMobOptions || isSeeking\" class=\"vid-trim-mob-wrp table-cell hide-in-tablet-up\"> <div class=\"vid-player-overlay-ftns-wrp\"> <div ng-click=\"mobileTrimVideo();$event.stopPropagation();\" class=\"vid-player-overlay-ftns\"><span class=\"icon-trim\"> </span></div> <div ng-click=\"mobileTrimNotes();$event.stopPropagation();\" class=\"vid-player-overlay-ftns\"><span class=\"icon-takenotes\"> </span></div> </div> </div> <div class=\"vid-player-right-optns-wrp table-cell\"> <div ng-click=\"takeScreenshot();$event.stopPropagation();\" class=\"vid-player-default-opt-item remove-focus hide-in-mobile\"><span class=\"icon-capture\"></span></div> <div ng-click=\"mobileVideoOptions();$event.stopPropagation();\" ng-show=\"takeNotesToggle\" class=\"vid-player-default-opt-item hide-in-tablet-up remove-focus\"><span ng-class=\"{\'active\': shwMobOptions}\" class=\"icon-menu\"></span></div> <div ng-click=\"$event.stopPropagation();\" class=\"vid-player-default-opt-item hide-in-mobile remove-focus\"><span class=\"icon-reportissue\"> </span></div> </div> </div> <div ng-class=\"overlayPlayIcon\" ng-show=\"!takeNotesToggle || isSeeking\" class=\"vid-player-overlay-dummy hide-in-mobile\"> <div class=\"vid-player-overlay-play\"><span class=\"icon-play\"></span></div> </div> <div ng-class=\"overlayPlayIcon\" ng-show=\"!takeNotesToggle || isSeeking\" class=\"vid-player-overlay-dummy hide-in-tablet-up\"> <div class=\"vid-player-overlay-play\"><span class=\"icon-play\"> </span></div> </div> <div ng-show=\"takeNotesToggle &amp;&amp; !isSeeking\" class=\"vid-player-overlay-ftns-section table hide-in-mobile\"> <div class=\"vid-takenot-dummy table-cell\"> <div class=\"vid-player-overlay-ftns-wrp\"> <div ng-class=\"{\'ftns-active\': trimOpt}\" ng-click=\"trimOption();$event.stopPropagation();\" class=\"vid-player-overlay-ftns\"><span class=\"icon-trim\"> </span></div> <div ng-class=\"{\'ftns-active\': notesOpt}\" ng-click=\"notesOption();$event.stopPropagation();\" class=\"vid-player-overlay-ftns\"><span class=\"icon-takenotes\"></span></div> <div ng-class=\"{\'ftns-active\': askExpertOpt}\" ng-click=\"askExpertOption();$event.stopPropagation();\" class=\"vid-player-overlay-ftns\"><span class=\"icon-askanexpert\"></span></div> </div> <div ng-click=\"$event.stopPropagation();\" ng-show=\"trimOpt\" class=\"vid-player-overlay-optns-wrp remove-focus\"> <div class=\"vid-play-overlay-feature-wrp\"> <div class=\"vid-player-incl-trsncrpt-wrp table\"> <div class=\"vid-player-incl-trscrpt-chkbox table-cell\"> <input type=\"checkbox\" id=\"inclTrscpt\" ng-model=\"inclTrscpt\" checked=\"inclTrscpt\"> <label for=\"inclTrscpt\" ng-class=\"{&quot;icon-checkbox_inactive&quot;:!inclTrscpt,&quot;icon-checkbox_selected&quot;:inclTrscpt}\" class=\"remove-focus\"></label><span>Include Transcript</span> </div> <div ng-click=\"trimVideoCall()\" class=\"primary_btn table-cell\">Save</div> </div> <div class=\"vid-overlay-trim-wrp\"> <div class=\"vid-overlay-slider-section table full-width\"> <div ng-click=\"trimRewind();$event.stopPropagation();\" class=\"vid-overlay-slider-cntrl-wrp table-cell remove-focus\"><span class=\"icon-back\"></span></div> <div class=\"vid-overlay-slider-img-wrp table-cell\"> <div class=\"trim-bg-img\"><img img-width-thumbnail=\"\" ng-src=\"assets/strip.jpg\" class=\"thumbnails-img\"> <div range-slider=\"\" min=\"sliderMin\" max=\"sliderMax\" model-max=\"sliderModelMax\" model-min=\"sliderModelMin\" disabled=\"sliderDisabled\" on-handle-down=\"sliderHandleGrab()\" on-handle-up=\"sliderHandleRelease()\" class=\"slider-dummy\"></div> <div class=\"slider-left-blurred\"> <div class=\"video-slider-min\"><span>{{sliderModelMin | transcriptTime}}</span></div> </div> <div class=\"slider-right-blurred\"> <div class=\"video-slider-max\"><span>{{sliderModelMax | transcriptTime}} </span></div> </div> </div> </div> <div ng-click=\"trimMoveAhead();$event.stopPropagation();\" class=\"vid-overlay-slider-cntrl-wrp table-cell remove-focus\"><span class=\"icon-next\"> </span></div> </div> </div> </div> <div class=\"vid-play-overlay-feature-wrp\"></div> <div class=\"vid-play-overlay-feature-wrp\"></div> </div> <div ng-show=\"notesOpt\" ng-click=\"$event.stopPropagation();\" class=\"vid-player-overlay-optns-wrp remove-focus\"> <div class=\"vid-take-note-wrp\"> <div class=\"vid-take-note-title-wrp table\"> <div contenteditable=\"true\" ng-hide=\"ShwEditTakeNotesTitle\" ng-model=\"takeNoteTitle\" class=\"vid-take-note-title remove-focus\">{{ takeNoteTitle }}</div> <div ng-show=\"ShwEditTakeNotesTitle\" class=\"input-field-container inline-block\"> <input type=\"text\" ng-model=\"takeNoteTitle\"><span ng-if=\"takeNoteTitle.length &gt; 0\" ng-click=\"cleartakeNoteTitle()\" class=\"icon-remove remove-focus\"></span> </div> <div ng-click=\"editTakeNotesTitle()\" class=\"vid-take-note-title-edit remove-focus\"><span class=\"icon-notes\"></span></div> </div> <div class=\"vid-take-notes-edit-wrp\"> <div class=\"show-filter\"> <input type=\"text\" placeholder=\"Take notes\" ng-model=\"takeNoteModel\" ng-change=\"takeNoteChange()\"><span ng-if=\"takeNoteModel.length &gt; 0\" ng-click=\"clearTakeNotes()\" class=\"icon-remove remove-focus\"></span> </div> </div> <div class=\"vid-take-note-preload-section\"> <div class=\"vid-player-incl-trsncrpt-wrp table\"> <div class=\"vid-player-incl-trscrpt-chkbox table-cell\"> <input type=\"checkbox\" id=\"inclTrscptTakeNotes\" ng-model=\"inclTrscptTakeNotes\" checked=\"inclTrscptTakeNotes\"> <label for=\"inclTrscptTakeNotes\" ng-class=\"{&quot;icon-checkbox_inactive&quot;:!inclTrscptTakeNotes,&quot;icon-checkbox_selected&quot;:inclTrscptTakeNotes}\" class=\"remove-focus\"></label><span>Include Transcript</span> </div> </div> <div ng-show=\"inclTrscptTakeNotes\" class=\"vid-take-note-preload-wrp table\"> <div class=\"vid-take-note-time-wrp table-cell\"> <div class=\"vid-time-take-note-dummy table\"><span class=\"icon-clock table-cell\"></span> <div class=\"vid-take-note-time table-cell\">{{activeTime | transcriptTime}} </div> </div> </div> <div class=\"vid-take-note-preload-text table-cell\"><span ng-repeat=\"sentence in paragraph\">{{sentence}}</span></div> <div class=\"vid-take-note-save table-cell\"> <div ng-click=\"takeNoteSave()\" class=\"primary_btn table-cell\">Save </div> </div> </div> </div> </div> </div> <div ng-show=\"askExpertOpt\" ng-click=\"$event.stopPropagation();\" class=\"vid-player-overlay-optns-wrp remove-focus\"> <div class=\"vid-player-ask-expert-wrp\"> <div class=\"vid-player-ask-expert-faq-wrp remove-focus\"> <div class=\"vid-player-faq-heading-wrp\"><span>FREQUENTLY ASKED QUESTIONS</span></div> <div class=\"vid-player-faq-ques-wrp\"> <div ng-repeat=\"question in askExpertData.frequentlyAskedQuestions\" class=\"vid-player-faq\"> <div ng-click=\"selectedFAQ(question)\" class=\"vid-player-faq-ques remove-focus clearfix\"><span class=\"left\">Q - {{question.question}}</span><span ng-if=\"question.answered\" class=\"right icon-check\"></span><span ng-if=\"!question.answered\" class=\"right icon-repost\"></span></div> </div> </div> </div> <div class=\"vid-player-ask-expert-question-wrp relative\"> <div ng-click=\"unableEditFunc()\" class=\"ask-expert-wrp remove-focus\"> <div class=\"transcript-title-wrp clearfix\"> <div ng-hide=\"editTitle\" class=\"transcript-wrp left\"><span>{{questionTitle}}</span></div> <div ng-show=\"editTitle\" ng-click=\"$event.stopPropagation();\" class=\"transcript-new-tilte-wrp input-field-container left\"> <input type=\"text\" ng-model=\"questionTitle\" ng-change=\"$event.stopPropagation();\"><span ng-if=\"questionTitle.length &gt; 0\" ng-click=\"clearAskExpertTitle()\" class=\"icon-remove remove-focus\"></span> </div> <div ng-click=\"editTitleFunc();$event.stopPropagation();\" class=\"transcript-title-edit left remove-focus\"><span class=\"icon-notes\"> </span></div> </div> <div ng-hide=\"showSelectedFAQ\" class=\"search-question-wrp\"> <div class=\"search-bar-wrp relative\"> <div class=\"show-filter\"> <input type=\"text\" placeholder=\"Ask an expert\" ng-model=\"modelData.askedQuestion\" ng-change=\"askingQuestionFunc()\" ng-class=\"{\'active\':modelData.askedQuestion.length &gt; 0}\"><span ng-if=\"modelData.askedQuestion.length &gt; 0\" ng-click=\"clearFieldFunc()\" class=\"icon-remove absolute remove-focus\"></span> </div> </div> <div ng-show=\"modelData.askedQuestion.length &gt; 0 &amp;&amp; askingQuestion\" class=\"search-suggestions-wrp\"> <div ng-repeat=\"question in askExpertData.suggestedQuestions | filter:suggestQuestions\" class=\"search-suggestions remove-focus\"> <div class=\"each-suggested-items clearfix\"><span ng-bind-html=\"highlightTextMarkup(question.duplicateQues)\" ng-click=\"selectedQuestion(question)\" class=\"left\">{{question.duplicateQues}} </span><span ng-if=\"question.answered\" class=\"right icon-check\"></span><span ng-if=\"!question.answered\" class=\"right icon-repost\"> </span></div> </div> </div> <div ng-hide=\"modelData.askedQuestion.length &gt; 0 &amp;&amp; askingQuestion\" class=\"post-btn-wrp clearfix\"> <div class=\"primary_btn\">POST</div> </div> </div> <div ng-show=\"showSelectedFAQ\" class=\"selected-faq-wrp\"> <div class=\"selected-question-answer-wrp\"> <div class=\"selected-question-wrp\"><span class=\"question-symbol\">Q -&nbsp;</span><span class=\"question\">{{selectedFQ.question}} </span></div> <div class=\"selected-answer-wrp\"><span class=\"answer-symbol\">Ans -&nbsp; </span><span class=\"answer\">{{selectedFQ.answer}}</span></div> </div> <div ng-click=\"hideSelectedFAQFunc()\" class=\"cancel-btn absolute remove-focus\"><span>CANCEL </span></div> </div> </div> </div> </div> </div> </div> </div> <div ng-show=\"takeNotesToggle &amp;&amp; !shwMobOptions\" class=\"vid-player-overlay-notes-mob table full-width hide-in-tablet-up\"> <div class=\"vid-player-overlay-mob-btn-wrp table-cell\"> <div class=\"vid-overlay-dummy table margin-zero\"> <div ng-click=\"$event.stopPropagation();\" class=\"vid-player-overlay-mob-playbtn table-cell remove-focus\"><span class=\"icon-previousvideo\"> </span></div> <div ng-click=\"API.playPause();$event.stopPropagation();\" class=\"vid-player-overlay-mob-playbtn table-cell remove-focus\"><span class=\"icon-play3\"></span></div> <div ng-click=\"$event.stopPropagation();\" class=\"vid-player-overlay-mob-playbtn table-cell remove-focus\"><span class=\"icon-nextvideo\"></span></div> </div> </div> </div> <div ng-show=\"shwMobOptions &amp;&amp; !isSeeking\" class=\"vid-player-mob-options-wrp table full-width show-for-small-only\"> <div class=\"vid-mob-optns-wrp table-cell\"> <div class=\"vid-options-wrp table full-width vid-opt-arrow\"> <div ng-click=\"shwAskExpertMob();$event.stopPropagation();\" class=\"vid-options table-cell remove-focus\"><span class=\"icon-askanexpert\"></span></div> <div class=\"vid-options table-cell\"><span class=\"icon-reportissue2\"></span></div> </div> <div ng-init=\"showQualOpt = false\" class=\"vid-options table-cell\"><span ng-click=\"showQualOpt = !showQualOpt;$event.stopPropagation();\" class=\"videoquality remove-focus\"> {{qualityVal}}p</span></div> <div ng-show=\"showQualOpt\" class=\"quality-opt-wrp absolute\"> <div class=\"quality-opt\"> <div ng-repeat=\"quality in quality\" class=\"quality-value\"><span ng-click=\"qualityIndex(this.$index)\" class=\"remove-focus\">{{quality}}p</span></div> </div> </div> <div ng-show=\"showVidOpt\" class=\"speed-opt-wrp absolute\"> <div class=\"speed-wrp\"> <div ng-repeat=\"speed in speed\" class=\"speed-value\"><span ng-click=\"speedIndex(this.$index)\" class=\"remove-focus\">{{speed}}</span></div> </div> </div> </div> </div> </div> </div> </videogular> </div> </div> </div> <div class=\"vid-trscript-dummy-hdng-wrp row\"> <div class=\"vid-trscript-highlight\"><span ng-click=\"highlightActive = !highlightActive\" ng-class=\"{\'active\':highlightActive}\" class=\"icon-highlight2\"></span></div> </div> <div class=\"vid-trscript-options\"> <div class=\"vid-trscript-opt-wrp\"> <text-size-slider min=\"12\" max=\"18\" unit=\"px\" value=\"14\" step=\"2\"></text-size-slider> <div ng-init=\"highlightActive = false;downloadActive = false;\" class=\"vid-higlighter-download-wrp\"> <div ng-click=\"highlightActive = !highlightActive; highlightSelected( highlightActive );\" ng-class=\"{\'active\':highlightActive}\" class=\"vid-highlighter-wrp remove-focus cm-clickable-btn\"> <div class=\"table-cell cm-btn-inner-wrap\"><span class=\"icon-highlight2\"></span></div> </div> <div ng-click=\"downloadActive = !downloadActive\" ng-class=\"{\'active\':downloadActive}\" class=\"vid-download-wrp remove-focus cm-clickable-btn\"> <div class=\"table-cell cm-btn-inner-wrap\"><span class=\"icon-download\"></span></div> </div> </div> </div> </div> <div class=\"vid-trscript-options-hdng large-12 medium-12 small-12 columns\">Interactive Transcript</div> <div class=\"below-player-section relative\"> <div ng-class=\"{\'animate-fadeIn\': overlay,\'animate-fadeOut\': !overlay &amp;&amp; isClipboardIconClicked}\" class=\"absolute below-player-section-blur\"> </div> <div id=\"scroll\" class=\"vid-trscript-section row scroll-bar clearfix\"> <div id=\"transcriptContainer\" class=\"vid-trscript-txt-section large-12 columns\"> <div ng-if=\"downloadActive\" class=\"golMal\">{{videosData[0]}} </div> <div ng-repeat=\"video in videosData\" ng-init=\"parentIndex = $index\" class=\"vid-trscript-para-wrp\"> <div class=\"vid-trscript-dummy-wrp\"> <div ng-class=\"{&quot;vid-para-active&quot;:activeTime &gt;= video.start &amp;&amp; activeTime &lt; video.end}\" class=\"vid-trscript-para-time-wrp\"><span class=\"icon-clock\"> </span> <div class=\"vid-trscript-para-time\">{{video.start | transcriptTime}}</div> </div> <div class=\"vid-trscript-para-txt-wrp vid-trscript-para-txt-size\"><span ng-repeat=\"items in video.val\"><span id=\"t-{{items.start}}\" data-time=\"{{items.start}}\" para-no=\"{{parentIndex}}\" sent-no=\"{{$index}}\" ng-click=\"goToTime(items.start)\" ng-class=\"{&quot;vid-text-active &quot;:activeTime &gt;= items.start &amp;&amp; activeTime &lt; items.end}\" ng-bind-html=\"highlightTextMarkup(items.text)\" ng-mousedown=\"selectionStarted($index, parentIndex)\" dtouch-start=\"touchSelectionStart($index, parentIndex)\" dtouch-end=\"touchSelectionEnd($index, parentIndex,items)\" dtouch-move=\"touchMove()\" class=\"remove-focus\">{{items.text}} </span></span></div> </div> </div> </div> </div> </div> </div> <div ng-show=\"showTrimScreen\" class=\"vid-pg-trim-wrp show\"> <div ng-show=\"showMobTrim &amp;&amp; !askExpertMob\" class=\"vid-pg-mob-trim-section\"> <div ng-show=\"!vidTrimSaveMob\" class=\"vid-trim-function\"> <div class=\"vid-trim-pg-top-wrp clearfix\"> <div class=\"vid-trim-mob-hdng\">TRIM</div> <div ng-click=\"mobileTrimNotes()\" class=\"vid-trim-mob-close remove-focus\"><span class=\"icon-close\"></span></div> </div> <div class=\"vid-trim-video-trim-wrp\"> <div class=\"vid-overlay-slider-section-mob table full-width\"> <div ng-click=\"trimRewindMob();$event.stopPropagation();\" class=\"vid-overlay-slider-cntrl-wrp table-cell remove-focus\"><span class=\"icon-back\"></span></div> <div class=\"vid-overlay-slider-img-wrp-mob table-cell\"> <div class=\"trim-bg-img-mob\"><img img-width-thumbnail=\"\" ng-src=\"assets/strip.jpg\" class=\"thumbnails-img\"> <div range-slider=\"\" min=\"sliderMin\" max=\"sliderMax\" model-max=\"sliderModelMaxMob\" model-min=\"sliderModelMinMob\" disabled=\"sliderDisabled\" on-handle-down=\"sliderHandleGrab()\" on-handle-up=\"sliderHandleRelease()\" class=\"slider-dummy\"></div> <div class=\"slider-left-blurred-mob\"> <div class=\"video-slider-min\"><span>{{sliderModelMinMob | transcriptTime}}</span></div> </div> <div class=\"slider-right-blurred-mob\"> <div class=\"video-slider-max\"><span>{{sliderModelMaxMob | transcriptTime}} </span></div> </div> </div> </div> <div ng-click=\"trimMoveAheadMob();$event.stopPropagation();\" class=\"vid-overlay-slider-cntrl-wrp table-cell remove-focus\"><span class=\"icon-next\"></span></div> </div> </div> <div class=\"vid-trim-transcript-wrp scroll-bar\"> <div class=\"vid-trim-transcript-hdng\">Interactive Transcript</div> <div class=\"vid-trim-transcript-text-wrp\"> <div class=\"vid-trim-trscript-para-wrp\"><span ng-repeat=\"sentence in paragraph\">{{sentence}} </span></div> </div> <div class=\"vid-trim-transcript-btn-wrp\"> <div class=\"tertiary_color\">Clear</div> <div ng-click=\"saveMobileTrim()\" class=\"primary_btn\">Ok</div> </div> </div> </div> <div ng-show=\"vidTrimSaveMob\" class=\"vid-trim-mob-save-section\"> <div class=\"vid-trim-pg-top-wrp clearfix\"> <div class=\"vid-trim-mob-hdng\">Save Video</div> <div ng-click=\"mobileTrimNotes()\" class=\"vid-trim-mob-close remove-focus\"><span class=\"icon-close\"></span></div> </div> <div class=\"vid-trim-mob-save-img-wrp\"> <div class=\"vid-trim-mob-save-img\"><img img-width-thumbnail=\"\" ng-src=\"assets/strip.jpg\"></div><span class=\"icon-play\"></span> </div> <div class=\"vid-trim-mob-time table\"> <div class=\"vid-trim-mob-start table-cell\">{{ sliderModelMinMob | transcriptTime }} </div> <div class=\"vid-trim-mob-end table-cell\">{{ sliderModelMaxMob | transcriptTime }}</div> </div> <div class=\"vid-save-video-edit-wrp-mob\"> <div class=\"show-filter\"> <input type=\"text\" placeholder=\"Take notes\" ng-model=\"takeNoteModel\" ng-change=\"takeNoteChange()\"> </div> </div> <div class=\"vid-trim-save-mob-btns\"> <div ng-click=\"cancelSaveTrimMob()\" class=\"tertiary_color\">Cancel</div> <div ng-click=\"SaveTrimMob()\" class=\"primary_btn\">Save</div> </div> </div> </div> <div ng-show=\"!showMobTrim &amp;&amp; !askExpertMob\" class=\"vid-pg-mob-take-notes-wrp\"> <div class=\"vid-mob-take-notes-title-wrp full-width\"> <div class=\"vid-mob-take-note-pg-title table-cell full-width\">Take Notes</div> <div ng-click=\"closeTakeNoteMob()\" class=\"vid-mob-take-note-mob-close table-cell remove-focus\"><span class=\"icon-close\"></span></div> </div> <div class=\"vid-take-note-mob-content\"> <div class=\"vid-mob-preload-title-wrp table full-width\"> <div ng-hide=\"editTitleTakeNotesToggle\" contenteditable=\"true\" ng-model=\"takeNoteTitle\" class=\"vid-mob-takenote-title table-cell\">{{ takeNoteTitle }}</div> <div ng-show=\"editTitleTakeNotesToggle\" class=\"vid-mob-takenote-title table-cell\"> <div class=\"input-field-container dark-border\"> <input type=\"text\" ng-model=\"takeNoteTitle\" class=\"edit-title-field\"><span ng-if=\"takeNoteTitle.length&gt;0\" ng-click=\"cleartakeNoteTitle()\" class=\"icon-remove remove-focus\"></span> </div> </div> <div ng-click=\"editTitleTakeNotes()\" class=\"vid-mob-takenote-title-edit table-cell remove-focus\"><span class=\"icon-notes\"></span></div> </div> <div class=\"vid-take-notes-edit-wrp-mob\"> <div class=\"show-filter\"> <input type=\"text\" placeholder=\"Take notes\" ng-model=\"takeNoteModel\" ng-change=\"takeNoteChange()\"><span ng-if=\"takeNoteModel.length &gt; 0\" ng-click=\"clearTakeNotes()\" class=\"icon-remove absolute remove-focus\"></span> </div> </div> <div class=\"vid-take-note-preload-section\"> <div class=\"vid-player-incl-trsncrpt-wrp table\"> <div class=\"vid-player-incl-trscrpt-chkbox table-cell\"> <input type=\"checkbox\" id=\"inclTrscptTakeNotesMob\" ng-model=\"inclTrscptTakeNotesMob\" checked=\"inclTrscptTakeNotesMob\"> <label for=\"inclTrscptTakeNotesMob\" ng-class=\"{&quot;icon-checkbox_inactive&quot;:!inclTrscptTakeNotesMob,&quot;icon-checkbox_selected&quot;:inclTrscptTakeNotesMob}\" class=\"remove-focus\"></label><span>Include Transcript</span> </div> </div> <div ng-show=\"inclTrscptTakeNotesMob\" class=\"vid-take-note-preload-wrp table\"> <div class=\"vid-take-note-preload-text table-cell\"><span ng-repeat=\"sentence in paragraph\">{{sentence}} </span></div> </div> </div> <div class=\"vid-take-note-save-mob full-width\"> <div ng-click=\"saveNotesMob()\" class=\"primary_btn table-cell\">Save To Clipboard </div> </div> </div> </div> <div ng-show=\"askExpertMob\" ng-class=\"{\'relative\': !askExpertMobSearch}\" class=\"vid-pg-mob-take-notes-wrp\"> <div ng-show=\"askExpertMobSearch\" class=\"vid-mob-take-notes-title-wrp full-width\"> <div class=\"vid-ask-expert-mob-title table-cell\"><span class=\"icon-askanexpert\"></span></div> <div class=\"vid-mob-take-note-pg-title table-cell full-width\">Ask An Expert</div> <div ng-click=\"closeAskExprtMob()\" class=\"vid-mob-take-note-mob-close table-cell remove-focus\"><span class=\"icon-close\"></span></div> </div> <div class=\"vid-mob-preload-title-wrp table full-width\"> <div ng-hide=\"ShwEditAskexprtTitle\" ng-bind=\"titleAskAnExpert\" class=\"vid-mob-takenote-title table-cell\">{{ titleAskAnExpert }}</div> <div ng-show=\"ShwEditAskexprtTitle\" class=\"vid-mob-takenote-title table-cell\"> <div class=\"input-field-container dark-border\"> <input type=\"text\" ng-model=\"titleAskAnExpert\" class=\"edit-title-field\"><span ng-if=\"titleAskAnExpert.length&gt;0\" ng-click=\"clearAskExpertTitleMob()\" class=\"icon-remove remove-focus\"></span> </div> </div> <div ng-click=\"editAskAnexprtTitle()\" class=\"vid-mob-takenote-title-edit table-cell remove-focus\"><span class=\"icon-notes\"> </span></div> </div> <div ng-hide=\"showSelectedFAQ\" class=\"vid-ask-exprt-content\"> <div class=\"search-input-ask\"> <div class=\"vid-take-notes-edit-wrp-mob remove-focus table full-width\"> <div ng-hide=\"askExpertMobSearch\" ng-click=\"cancelAskExpertMobSearch()\" class=\"back-btn table-cell remove-focus\"><span class=\"icon-back\"></span></div> <div ng-class=\"{\'full-width\': !askExpertMobSearch}\" class=\"show-filter table-cell\"> <input type=\"text\" placeholder=\"Ask an Expert\" ng-model=\"modelData.askedQuestion\" ng-focus=\"askExpertMobSearchFunc()\"><span ng-if=\"modelData.askedQuestion.length &gt; 0\" ng-click=\"clearAskAnExpert()\" class=\"icon-remove remove-focus\"></span> </div> </div> <div ng-hide=\"askExpertMobSearch\" class=\"vid-blur-overlay absolute\"></div> </div> <div ng-show=\"modelData.askedQuestion.length &gt; 0 &amp;&amp; askingQuestion\" class=\"vid-ask-exprt-suggested-ques\"> <div ng-repeat=\"question in askExpertData.suggestedQuestions | filter:suggestQuestions\" class=\"search-suggestions remove-focus\"> <div class=\"each-suggested-items clearfix\"><span ng-bind-html=\"highlightTextMarkup(question.duplicateQues)\" ng-click=\"selectedQuestion(question)\" class=\"left\">{{question.duplicateQues}} </span><span ng-if=\"question.answered\" class=\"right icon-check\"></span><span ng-if=\"!question.answered\" class=\"right icon-repost\"> </span></div> </div> </div> <div class=\"vid-ask-exprt-frq-wrp\"> <div class=\"vid-ask-exprt-frq-title\">Frequently Asked Questions</div> <div class=\"vid-ask-exprt-frq-quest-wrp\"> <div ng-repeat=\"question in askExpertData.frequentlyAskedQuestions\" ng-click=\"selectedFAQ(question)\" class=\"vid-ask-exprt-frq-quest-item table remove-focus full-width\"> <div class=\"vid-ask-exprt-frq-quest table-cell\">{{question.question}}</div> <div class=\"vid-ask-exprt-frq-quest-status table-cell\"><span ng-if=\"question.answered === false\" class=\"icon-repost\"></span><span ng-if=\"question.answered === true\" class=\"icon-check\"> </span></div> </div> </div> </div> <div ng-show=\"askExpertMobSearch\" ng-click=\"postQuestion()\" class=\"vid-take-note-save-mob table full-width\">post </div> </div> <div ng-show=\"showSelectedFAQ\" class=\"vid-ask-exprt-content\"> <div class=\"vid-question-answered-wrp\"> <div class=\"vid-question-answered-item\"> <div class=\"vid-question\">Q - {{selectedFQ.question}}</div> <div class=\"vid-answer-wrp table\"> <div class=\"vid-answer-title vid-question table-cell\">Ans&nbsp;</div> <div class=\"vid-ask-expert-answer table-cell\">-&nbsp;{{selectedFQ.answer}}</div> </div> </div> </div> <div class=\"vid-answered-wrp table full-width\"> <div ng-click=\"shwAskExpertMob()\" class=\"secondary_btn cancel-btn remove-focus table-cell\">cancel</div> </div> </div> </div> </div>");
$templateCache.put("app/Features/proficiencyTest/template/profTestPlaylist.html"," <div class=\"vid-vidplaylist-title-wrp table full-width\"> <div class=\"vid-vidplaylist-top-wrp table-cell\"> <div class=\"vid-vidplaylist-title-dummy table full-width\"> <div class=\"vid-vidplaylist-title-no table-cell\">{{activeModuleData.sequenceId | twoDigit}}.</div> <div class=\"vid-vidplaylist-title-txt table-cell\">{{activeModuleData.title}}</div> </div> </div> <div ng-click=\"filterPlaylist()\" ng-class=\"{\'vid-filter-active\':togglePlaylistFilter}\" class=\"vid-vidplaylist-filter table-cell\"><span class=\"icon-filter\"></span></div> <div ng-show=\"togglePlaylistFilter\" class=\"vid-playlist-filter-wrp\"> <div ng-init=\"video=true\" class=\"vid-playlist-filter-item\"> <input type=\"checkbox\" id=\"video\" checked=\"video\"> <label for=\"video\" ng-click=\"video=!video\" ng-class=\"{&quot;icon-checkbox_inactive&quot;:!video,&quot;icon-checkbox_selected&quot;:video}\" class=\"remove-focus\"></label><span>videos</span> </div> <div ng-init=\"assessment=true\" class=\"vid-playlist-filter-item\"> <input type=\"checkbox\" id=\"assessment\" checked=\"assessment\"> <label for=\"assessment\" ng-click=\"assessment=!assessment\" ng-class=\"{&quot;icon-checkbox_inactive&quot;:!assessment,&quot;icon-checkbox_selected&quot;:assessment}\" class=\"remove-focus\"></label><span>assessment</span> </div> <div ng-init=\"resources=true\" class=\"vid-playlist-filter-item\"> <input type=\"checkbox\" id=\"resources\" checked=\"resources\"> <label for=\"resources\" ng-click=\"resources=!resources\" ng-class=\"{&quot;icon-checkbox_inactive&quot;:!resources,&quot;icon-checkbox_selected&quot;:resources}\" class=\"remove-focus\"></label><span>resources</span> </div> <div ng-init=\"caseStudy=true\" class=\"vid-playlist-filter-item\"> <input type=\"checkbox\" id=\"caseStudy\" checked=\"caseStudy\"> <label for=\"caseStudy\" ng-click=\"caseStudy=!caseStudy\" ng-class=\"{&quot;icon-checkbox_inactive&quot;:!caseStudy,&quot;icon-checkbox_selected&quot;:caseStudy}\" class=\"remove-focus\"></label><span>case study</span> </div> </div> </div> <div class=\"vid-vidplaylist-items-wrp\"> <div class=\"vid-playlist-wrp\"> <div class=\"current-video-wrp\"> <div ng-class=\"current-playing-arrow\" class=\"vid-vidplaylist-item-wrp vid-item-current\"> <div class=\"vid-vidplaylist-item-det-wrp\"> </div> <div class=\"vid-vidplaylist-item-title\">{{activeModuleData.pttitle}} <div class=\"vid-vidplaylist-item-time-wrp\"> <div class=\"vid-vidplaylist-item-time-img\"><span class=\"icon-clock\"></span></div> <div class=\"vid-vidplaylist-item-time-det\">{{activeModuleData.ptDuration | minutesHours}}</div> </div> </div> </div> </div> <div class=\"prof-playlist-title-wrp\"> <div class=\"title\">Module Items</div> </div> <div ng-style=\"setPlaylistHeight()\" class=\"scroll-bar vid-other-video-wrp\"> <div ng-repeat=\"item in modulePlaylistProf\" ng-click=\"clickedPlaylistItem(item.metaData.bcId,item.id,item.sequenceId,item.type)\"> <div ng-if=\"(item.status !== \'current\')&amp;&amp;((video &amp;&amp;item.type == \'ytc\')||(video &amp;&amp;item.type == \'video\')|| (assessment &amp;&amp; item.type == \'quiz\')||(resources &amp;&amp; item.type == \'material\')||(caseStudy &amp;&amp; item.type == \'csa\'))\" ng-class=\"{\'vid-item-completed\': item.status == \'Completed\'}\" class=\"vid-vidplaylist-item-wrp\"> <div class=\"vid-playlist-tab table\"> <div ng-if=\"item.type == \'ytc\'\" class=\"vid-vidplaylist-item-context\"><span class=\"icon-video\"></span></div> <div ng-if=\"item.type == \'video\'\" class=\"vid-vidplaylist-item-context\"><span class=\"icon-video\"></span></div> <div ng-if=\"item.type == \'quiz\'\" class=\"vid-vidplaylist-item-context\"><span class=\"icon-quiz\"></span></div> <div ng-if=\"item.type == \'material\'\" class=\"vid-vidplaylist-item-context\"><span class=\"icon-resources\"></span></div> <div ng-if=\"item.type == \'csa\'\" class=\"vid-vidplaylist-item-context\"><span class=\"icon-assignment\"></span></div> <div class=\"vid-vidplaylist-item-det-wrp\"> <div class=\"vid-vidplaylist-item-title\">{{item.sequenceId | twoDigit}}. {{item.metaData.title}}</div> <div ng-if=\"item.type !== \'material\'\" class=\"vid-vidplaylist-item-time-wrp\"> <div class=\"vid-vidplaylist-item-time-img\"><span class=\"icon-clock\"></span></div> <div class=\"vid-vidplaylist-item-time-det\">{{item.metaData.duration | minutesHours}}</div> </div> </div> </div> <div ng-if=\"((item.status == \'In Progress\') &amp;&amp; (video || assessment))\" ng-style=\"{ \'width\' : item.progress + \'%\'}\" class=\"progress-bar\"></div> </div> </div> </div> </div> </div>");
$templateCache.put("app/Features/proficiencyTest/template/profTestQuestion.html"," <iframe id=\"theFrame\" src=\"{{testurl}}\" frameborder=\"0\" style=\"width: 121.3%; height: 121%; border: 0; -ms-transform: scale(0.825); -moz-transform: scale(0.825); -o-transform: scale(0.825); -webkit-transform: scale(0.825); transform: scale(0.825); -ms-transform-origin: 0 0; -moz-transform-origin: 0 0; -o-transform-origin: 0 0; -webkit-transform-origin: 0 0; transform-origin: 0 0;\"></iframe>");
$templateCache.put("app/Features/proficiencyTest/template/profTestStart.html"," <div ng-show=\"!error\" class=\"quiz_launch_info-section\"> <div class=\"quiz_launch_info-content\"> <div class=\"title\">{{currentModuleData.pttitle}}</div>  <div class=\"total-questions-wrp\"> <div class=\"txt\">Time Limit -</div> <div class=\"score\">{{currentModuleData.ptDuration | minutesHours}}</div> </div> <div class=\"total-questions-wrp\"><span class=\"txt\">Points earned -</span><span class=\"icon-star\"></span><span class=\"txt\">{{currentModuleData.ptPoints}}</span></div> </div> <div class=\"quiz-note-wrp\"> <div class=\"title\">Note:</div>  <div ng-bind-html=\"currentModuleData.ptDescription\" class=\"note\"></div> </div> </div> <div ng-show=\"error\" class=\"quiz_launch_info-section\"> <div class=\"quiz_launch_info-content\"> <div style=\"font-size:22px;color:#3696ed\" class=\"title-m\">{{error}}</div> </div> </div> <div ng-if=\"(footerState ==\'launchScreen\')\" class=\"quiz-footer-section\"> <div class=\"quiz-footer-wrp clearfix hide-in-mobile\"> <div ng-if=\"!error\" class=\"quiz-foot-start-btn-wrp\"> <div ng-click=\"startQuiz(currentModuleData.moduleId)\" class=\"primary_btn\">Start the Test</div> </div> <div ng-if=\"error\" class=\"quiz-foot-start-btn-wrp\"> <div ng-click=\"goToDashboard();$event.stopPropagation();\" class=\"primary_btn\">Go Back</div> </div> </div> </div>");
$templateCache.put("app/Features/proficiencyTest/template/profTestSummary.html"," <div class=\"qz-qstn-pg-wrp\"> <div class=\"prof-end-scrn-msg\"> <div ng-if=\"ptsummary.test_result === &quot;FAIL&quot;\" class=\"qz-end-msg-section\"> <div class=\"pt-end-msg\"> Sorry! You <span style=\"font-weight: 600\">failed </span>this proficiency test.<br>Your score is <span style=\"font-weight: 600\">{{ptsummary.percentage}} %</span><br>Contact your manager for retake approval </div> </div> <div ng-if=\"ptsummary.test_result === &quot;PASS&quot;\" class=\"qz-end-msg-section\"> <div class=\"pt-end-msg\">Great! You just <span style=\"font-weight: 600\">passed </span>this proficiency test.<br>Your score is <span style=\"font-weight: 600\">{{ptsummary.percentage}} %</span></div> </div> <div class=\"qz-end-score-msg-wrp\"> </div> </div> <div class=\"prof-test-report-wrp\"> <div class=\"qz-answer-report-title\">Sections</div> <div class=\"prof-topic-rprt-wrp\"> <div ng-repeat=\"Section in ptSections\" class=\"prof-topic-wise-item table\"> <div class=\"title table-cell\">{{$index+1}}. {{Section.Name}}</div> <div class=\"topic-progress-bar-wrp table-cell\"> <div class=\"topic-progress-outer\"> <div ng-style=\"topicWidth(Section.percentage)\" class=\"topic-bar-wrp-expected\"></div> </div> </div> <div class=\"percentage-wrp table-cell\"> <div class=\"txt\"> {{Section.percentage}}%</div> </div> </div> </div> </div> <div class=\"prof-test-report-wrp\"> <div class=\"qz-answer-report-title\">Score as per topics</div> <div class=\"prof-topic-rprt-wrp\"> <div ng-repeat=\"topics in ptTopics\" class=\"prof-topic-wise-item table\"> <div class=\"title table-cell\">{{topics.Name}}</div> <div class=\"topic-progress-bar-wrp table-cell\"> <div class=\"topic-progress-outer\"> <div ng-style=\"topicWidth(topics.percentage)\" class=\"topic-bar-wrp-expected\"></div> </div> </div> <div class=\"percentage-wrp table-cell\"> <div class=\"txt\"> {{topics.percentage}}% </div> </div> </div> </div> </div> </div>");
$templateCache.put("app/Features/progressInfoPage/template/badgesSection.html"," <div style=\"padding-top:0px !important\" class=\"prog-pg-badges hide-in-mobile\"> </div> <div style=\"padding:0 20px\" class=\"prog-pg-badges-section row hide-in-mobile\"> <div id=\"certificates\" class=\"prog-pg-badges-title-wrp clearfix\"> <div class=\"title left columns large-12 medium-12\"> <span>CERTIFICATES EARNED </span><span ng-if=\"totalCompletedCertificates&gt;0\">({{totalCompletedCertificates}})</span></div> <div style=\"margin: 8px 0 25px;font-size:13px;\" class=\"description left columns large-12 medium-12\"><span>You receive certificates not only for your learning path but for every skill you complete successfully.</span></div> <div style=\"padding-bottom: 16px;\" class=\"title title-cert\">Active Learning Path</div> <div style=\"background-color:#f6f6f6;padding: 35px;margin-bottom: 17px;\" ng-repeat=\"certificates in currentLpCertificates\" class=\"certificates-section left columns large-12 medium-12\"> <div class=\"certification-logo columns large-2 medium-2\"> <div style=\"background:url(\'/assets/images/certificate_logo.svg\') no-repeat;height:191px;\" class=\"logo\"></div> </div> <div class=\"certification-header columns large-10 medium-10\"> <div style=\"padding-bottom: 0.5em;font-size: 13px;font-weight: bold;\" class=\"certification-header\"><span style=\"font-family: Montserrat;font-size: 20px;font-weight: bold;line-height: 1.5;text-align: left;color: #222222;\">{{certificates.lptitle}}</span><span style=\"padding-left: 20px;\" ng-if=\"certificates.completedCerttificateCount == certificates.totalcertificates\" class=\"icon-check2\"></span><span style=\"padding-left: 2px;\" ng-if=\"certificates.completedCerttificateCount == certificates.totalcertificates\">Completed</span><span style=\"padding-left: 20px;\" ng-if=\"certificates.completedCerttificateCount == 0\" class=\"icon-clock\"></span><span style=\"padding-left: 2px;\" ng-if=\"certificates.completedCerttificateCount == 0\">Not started</span><span style=\"padding-left: 20px;\" ng-if=\"certificates.completedCerttificateCount &gt; 0 &amp;&amp; certificates.completedCerttificateCount &lt; certificates.totalcertificates\" class=\"icon-clock\"></span><span style=\"padding-left: 2px;\" ng-if=\"certificates.completedCerttificateCount &gt; 0 &amp;&amp; certificates.completedCerttificateCount &lt; certificates.totalcertificates\">In Progress</span></div> <div style=\"padding-bottom:45px\" class=\"certification-e\"><span ng-if=\"certificates.lptitle != \'D3 Basics\' &amp;&amp; certificates.lptitle != \'Tornado Framework\'\" style=\"font-family: Montserrat;font-size: 14px;line-height: 1.5;text-align: left;color: #222222;\">Total Certificates Earned : {{certificates.completedCerttificateCount}}/{{certificates.totalcertificates}}</span></div> <div class=\"certificate-view\"> <div style=\"margin-right:16px\" ng-click=\"showCertificate=true;\" class=\"primary_btn\"> <div style=\"padding-top: 6px;padding-bottom: 6px;padding-left:60px;padding-right: 60px;\" ng-click=\"showCertificateOverlay(certificates)\" class=\"txt\">VIEW</div> </div> <div ng-click=\"downloadAll(certificates.lpId)\" ng-mouseover=\"downloadAllMsg=true\" ng-mouseleave=\"downloadAllMsg=false\" ng-if=\"certificates.completedCerttificateCount &gt;0\" class=\"secondary_btn\"> <div style=\"padding-top: 6px;padding-bottom: 6px;padding-left:45px;padding-right: 45px;\" class=\"txt\"> <span style=\"padding-right:5px\" class=\"icon-download\"> <div ng-show=\"downloadAllMsg\" class=\"download-description absolute\"> <div class=\"download-content-wrp download-box-arrow relative\"> <div class=\"content\"><span>Click here to download all your certificates in one go</span></div> </div> </div></span><span>DOWNLOAD</span></div> </div> <div ng-click=\"$event.stopPropagation()\" ng-mouseover=\"noDownloadAllMsg=true\" ng-mouseleave=\"noDownloadAllMsg=false\" ng-if=\"certificates.completedCerttificateCount == 0\" style=\"color:grey;border:1px solid #999999;cursor: default;\" class=\"secondary_btn\"> <div style=\"padding-top: 6px;padding-bottom: 6px;padding-left:45px;padding-right: 45px;\" class=\"txt\"> <span style=\"padding-right:5px\" class=\"icon-download\"></span><span>DOWNLOAD <div ng-show=\"noDownloadAllMsg\" class=\"download-description absolute\"> <div class=\"download-content-wrp download-box-arrow relative\"> <div class=\"content\"><span>No certificates to download yet. Complete a skill to receive a certificate</span></div> </div> </div></span></div> </div> </div> </div> </div> <div class=\"title title-cert\">Archived Learning Paths</div> <div style=\"background-color:#f6f6f6;padding: 35px;\" ng-repeat=\"certificates in oldLpCertificates\" class=\"certificates-section left columns large-12 medium-12\"> <div class=\"certification-logo columns large-2 medium-2\"> <div style=\"background:url(\'/assets/images/certificate_logo.svg\') no-repeat;height:191px;\" class=\"logo\"></div> </div> <div class=\"certification-header columns large-10 medium-10\"> <div style=\"padding-bottom: 0.5em;font-size: 13px;font-weight: bold;\" class=\"certification-header\"><span style=\"font-family: Montserrat;font-size: 20px;font-weight: bold;line-height: 1.5;text-align: left;color: #222222;\">{{certificates.lptitle}}</span><span style=\"padding-left: 20px;\" ng-if=\"certificates.completedCerttificateCount == certificates.totalcertificates\" class=\"icon-check2\"></span> </div> <div style=\"padding-bottom:45px\" class=\"certification-e\"><span ng-if=\"certificates.lptitle != \'D3 Basics\' &amp;&amp; certificates.lptitle != \'Tornado Framework\'\" style=\"font-family: Montserrat;font-size: 14px;line-height: 1.5;text-align: left;color: #222222;\">Total Certificates Earned : {{certificates.completedCerttificateCount}}/{{certificates.totalcertificates}}</span></div> <div class=\"certificate-view\"> <div style=\"margin-right:16px\" ng-click=\"showCertificate=true;\" class=\"primary_btn\"> <div style=\"padding-top: 6px;padding-bottom: 6px;padding-left:60px;padding-right: 60px;\" ng-click=\"showCertificateOverlay(certificates)\" class=\"txt\">VIEW</div> </div> <div ng-click=\"downloadAll(certificates.lpId)\" ng-mouseover=\"downloadAllMsg=true\" ng-mouseleave=\"downloadAllMsg=false\" ng-if=\"certificates.completedCerttificateCount &gt;0\" class=\"secondary_btn\"> <div style=\"padding-top: 6px;padding-bottom: 6px;padding-left:45px;padding-right: 45px;\" class=\"txt\"> <span style=\"padding-right:5px\" class=\"icon-download\"> <div ng-show=\"downloadAllMsg\" class=\"download-description absolute\"> <div class=\"download-content-wrp download-box-arrow relative\"> <div class=\"content\"><span>Click here to download all your certificates in one go</span></div> </div> </div></span><span>DOWNLOAD</span></div> </div> <div ng-click=\"$event.stopPropagation()\" ng-mouseover=\"noDownloadAllMsg=true\" ng-mouseleave=\"noDownloadAllMsg=false\" ng-if=\"certificates.completedCerttificateCount == 0\" style=\"color:grey;border:1px solid #999999;cursor: default;\" class=\"secondary_btn\"> <div style=\"padding-top: 6px;padding-bottom: 6px;padding-left:45px;padding-right: 45px;\" class=\"txt\"> <span style=\"padding-right:5px\" class=\"icon-download\"></span><span>DOWNLOAD <div ng-show=\"noDownloadAllMsg\" class=\"download-description absolute\"> <div class=\"download-content-wrp download-box-arrow relative\"> <div class=\"content\"><span>No certificates to download yet. Complete a skill to receive a certificate</span></div> </div> </div></span></div> </div> </div> </div> </div> </div> </div> <div id=\"myNav\" class=\"certification-overlay overlay\"> <div ng-click=\"closeCertificateOverlay()\" style=\"float: right;\" class=\"upload-avatar-overlay-close remove-focus\"><span class=\"icon-close\"></span></div> <div class=\"certification-overview\"> <div class=\"certification-header left columns large-8 medium-12\"> <div style=\"padding-bottom: 1.5em;font-size: 13px;font-weight: bold;\" class=\"certification-header\"><span style=\"font-family: Montserrat;font-size: 20px;font-weight: bold;line-height: 1.5;text-align: left;color: #222222;\">{{cTitle}}</span><span style=\"padding-left: 20px;\" ng-if=\"completedCert == 0\" class=\"icon-clock\"></span><span style=\"padding-left: 2px;\" ng-if=\"completedCert == 0\">Not started</span><span style=\"padding-left: 20px;\" ng-if=\"completedCert == cTotal\" class=\"icon-check2\"></span><span style=\"padding-left: 2px;\" ng-if=\"completedCert == cTotal\">Completed</span><span style=\"padding-left: 20px;\" ng-if=\"completedCert &gt; 0 &amp;&amp; completedCert &lt; cTotal\" class=\"icon-clock\"></span><span style=\"padding-left: 5px;\" ng-if=\"completedCert &gt; 0 &amp;&amp; completedCert &lt; cTotal\">In Progress</span></div> <div style=\"padding-bottom:3px\" class=\"certification-e\"><span ng-if=\"cTitle != \'D3 Basics\' &amp;&amp; cTitle !=\'Tornado Framework\'\" style=\"font-family: Montserrat;font-size: 14px;line-height: 1.5;text-align: left;color: #222222;\">Skill Certificates Earned : {{completedCert}}/{{cTotal}}</span></div> <div style=\"padding-bottom:3px\" class=\"certification-e\"><span style=\"font-family: Montserrat;font-size: 14px;line-height: 1.5;text-align: left;color: #222222;\" ng-if=\"completedCert != cTotal\">Learning Path Certificates : Not Completed</span><span style=\"font-family: Montserrat;font-size: 14px;line-height: 1.5;text-align: left;color: #222222;\" ng-if=\"completedCert == cTotal\">Learning Path Certificates : Received</span></div> </div> <div style=\"padding:18px\" class=\"certificates-recieved left columns large-4 medium-12\"> <div ng-click=\"downloadAll(cId)\" ng-if=\"completedCert &gt; 0\" class=\"secondary_btn\"> <div style=\"padding-top: 6px;padding-bottom: 6px;padding-left:35px;padding-right: 35px;\" class=\"txt\"> <span style=\"padding-right:5px\" class=\"icon-download\"></span><span>DOWNLOAD ALL</span></div> </div> <div ng-click=\"$event.stopPropagation()\" ng-if=\"completedCert == 0\" style=\"color:#999999;border:1px solid #999999;cursor:default\" class=\"secondary_btn\"> <div style=\"padding-top: 6px;padding-bottom: 6px;padding-left:35px;padding-right: 35px;\" class=\"txt\"> <span style=\"padding-right:5px\" class=\"icon-download\"></span><span>DOWNLOAD ALL</span></div> </div> </div> </div> <div class=\"overlay-content\"> <div style=\"float:left;text-align:center;padding-bottom:10px;padding-top:10px\" ng-repeat=\"cert in certificate.certificates\" ng-click=\"\" ng-if=\"cert.certificateType == \'SKILL\' &amp;&amp; cert.lpTitle != \'D3 Basics\' &amp;&amp; cert.lpTitle != \'Tornado Framework\'\" ng-mouseover=\"overlay=true\" ng-mouseleave=\"overlay=false\" class=\"welcome-scrn-certificate-item columns large-4 medium-6\"> <div style=\"opacity:0.6;z-index:10;width:90%;margin-top:10px;margin-left:16px;height:94%\" ng-if=\"overlay\" class=\"bgraph-section-overlay absolute\"> <div style=\"height:100%\" class=\"clearfix\"> <div style=\"height:100%;padding-top: 50%;padding-left: 3%;font-size: 3em;\" class=\"center\"><span ng-click=\"overlay=false;download(cert.lpId,cert.certificationNumber);$event.stopPropagation();\" class=\"icon-download remove-focus\"></span></div> </div> </div> <div style=\"height:404px;background:url(\'/assets/images/Border.svg\')no-repeat;background-size: contain;\" id=\"cert{{$index}}\" class=\"certificate-template\"> <div style=\"\" class=\"certificate-main-content\"> <div class=\"certification-header-image\"><img ng-src=\"assets/images/Skill_certificate_graphic.svg\" style=\"width:34%;padding-top:12%\"></div> <div style=\"padding-top:6%;font-size:0.70em;font-weight:bold;color:#3696ed\" class=\"certification-skill-text\"><span>NEW SKILL ACQUIRED</span></div> <div style=\"padding-top:10%;letter-spacing:1px;color:black;font-size:0.55em;\" class=\"certification-skill-text\"><span>This is to certify that</span></div> <div style=\"font-weight:bolder;padding-top:2%;font-size:.85em\" class=\"certification-user\"><span>{{user.firstname}} {{user.lastname}}</span></div> <div style=\"padding-top:2%;letter-spacing:1px;color:black;font-size:8px;\" class=\"certification-skill-text\"><span>has successfully compeleted a course in</span></div> <div style=\"min-height: 38px;padding-top:2%;padding-left:5%;padding-right:5%;font-weight:bolder;font-size:0.75em;color:#069edb\" class=\"certification-title\"><span>{{cert.lpCertiticate}}</span></div> <div style=\"padding-top:2%;letter-spacing:1px;color:black;font-size:0.55em;\" class=\"certification-skill-text\"><span>in</span></div> <div style=\"padding-top:2%;padding-left:5%;padding-right:5%;font-weight:bolder;font-size:0.75em;color:#069edb\" class=\"certification-completion\"><span>{{cert.completionDate | date : \"MMMM y\"}}</span></div> <div class=\"certification-footer-image\"><img ng-src=\"assets/images/Jigsaw_logo.svg\" style=\"width:28%;padding-top:7%\"></div> </div> </div> </div> <div style=\"text-align:center;padding-bottom:10px;padding-top:10px;float:left\" ng-if=\"cTitle != \'D3 Basics\' &amp;&amp; cTitle != \'Tornado Framework\'\" ng-repeat=\"cert in lockedCertArray\" ng-click=\"\" class=\"welcome-scrn-certificate-item columns large-4 medium-6\"> <div style=\"z-index:10;width:90%;margin-top:10px;margin-left:16px;height:92%\" ng-if=\"overlay\" class=\"bgraph-section-overlay absolute\"> <div class=\"clearfix\"> <div class=\"right\"><span ng-click=\"overlay=false;exportToPDF($index);$event.stopPropagation();\" class=\"icon-download remove-focus\"></span></div> </div> </div> <div style=\"height:404px;background:url(\'/assets/images/Ceritifcate_Locked.svg\')no-repeat;background-size: contain;\" id=\"cert{{$index}}\" class=\"certificate-template\"></div> </div> <div style=\"text-align:center;padding-bottom:10px;padding-top:10px;float:left\" ng-if=\"cTitle == \'D3 Basics\' || cTitle == \'Tornado Framework\' &amp;&amp; completedCert != cTotal\" ng-click=\"\" class=\"welcome-scrn-certificate-item columns large-4 medium-6\"> <div style=\"z-index:10;width:90%;margin-top:10px;margin-left:16px;height:94%\" ng-if=\"overlay\" class=\"bgraph-section-overlay absolute\"> <div class=\"clearfix\"> <div class=\"right\"><span ng-click=\"overlay=false;exportToPDF($index);$event.stopPropagation();\" class=\"icon-download remove-focus\"></span></div> </div> </div> <div style=\"height:404px;background:url(\'/assets/images/Ceritifcate_Locked.svg\')no-repeat;background-size: contain;\" id=\"cert{{$index}}\" class=\"certificate-template\"></div> </div> <div style=\"text-align:center;padding-bottom:10px;padding-top:10px;float:left\" ng-repeat=\"cert in certificate.certificates\" ng-click=\"\" ng-if=\"cert.certificateType == \'LP\'\" ng-mouseover=\"overlay=true\" ng-mouseleave=\"overlay=false\" id=\"cert{{$index}}\" class=\"welcome-scrn-certificate-item columns large-4 medium-6\"> <div style=\"opacity:0.6;z-index:10;width:90%;margin-top:10px;margin-left:16px;height:94%\" ng-if=\"overlay\" class=\"bgraph-section-overlay absolute\"> <div style=\"height:100%\" class=\"clearfix\"> <div style=\"height:100%;padding-top: 50%;padding-left: 3%;font-size: 3em;\" class=\"center\"><span ng-click=\"overlay=false;download(cert.lpId,cert.certificationNumber);$event.stopPropagation();\" class=\"icon-download remove-focus\"></span></div> </div> </div> <div style=\"height:404px;background:url(\'/assets/images/Border.svg\')no-repeat;background-size: contain;\" id=\"cert{{$index}}\" class=\"certificate-template\"> <div style=\"\" class=\"certificate-main-content\"> <div class=\"certification-header-image\"><img ng-src=\"assets/images/Learning_Path_graphic.svg\" style=\"width:20%;padding-top:12%\"></div> <div style=\"padding-top:6%;font-size:0.70em;font-weight:bold;color:#3696ed\" class=\"certification-skill-text\"><span>CERTIFICATE</span></div> <div style=\"padding-top:10%;letter-spacing:1px;color:black;font-size:0.55em;\" class=\"certification-skill-text\"><span>This is to certify that</span></div> <div style=\"font-weight:bolder;padding-top:2%;font-size:.85em\" class=\"certification-user\"><span>{{user.firstname}} {{user.lastname}}</span></div> <div style=\"padding-top:2%;letter-spacing:1px;color:black;font-size:8px;\" class=\"certification-skill-text\"><span>has successfully compeleted a course in</span></div> <div style=\"min-height: 38px;padding-top:2%;padding-left:5%;padding-right:5%;font-weight:bolder;font-size:0.75em;color:#069edb\" class=\"certification-title\"><span>{{cert.lpCertiticate}}</span></div> <div style=\"padding-top:2%;letter-spacing:1px;color:black;font-size:0.55em;\" class=\"certification-skill-text\"><span>in</span></div> <div style=\"padding-top:2%;padding-left:5%;padding-right:5%;font-weight:bolder;font-size:0.75em;color:#069edb\" class=\"certification-completion\"><span>{{cert.completionDate | date : \"MMMM y\"}}</span></div> <div class=\"certification-footer-image\"><img ng-src=\"assets/images/Jigsaw_logo.svg\" style=\"width:28%;padding-top:7%\"></div> </div> </div> </div> <div style=\"text-align:center;padding-bottom:10px;padding-top:10px;float:left\" ng-repeat=\"cert in certificate.certificates\" ng-click=\"\" ng-if=\"cert.certificateType == \'CAPSTONE\'\" ng-mouseover=\"overlay=true\" ng-mouseleave=\"overlay=false\" id=\"cert{{$index}}\" class=\"welcome-scrn-certificate-item columns large-4 medium-6\"> <div style=\"opacity:0.6;z-index:10;width:90%;margin-top:10px;margin-left:16px;height:94%\" ng-if=\"overlay\" class=\"bgraph-section-overlay absolute\"> <div style=\"height:100%\" class=\"clearfix\"> <div style=\"height:100%;padding-top: 50%;padding-left: 3%;font-size: 3em;\" class=\"center\"><span ng-click=\"overlay=false;download(cert.lpId,cert.certificationNumber);$event.stopPropagation();\" class=\"icon-download remove-focus\"></span></div> </div> </div> <div style=\"height:404px;background:url(\'/assets/images/capstone-report.png\')no-repeat;background-size: contain;\" id=\"cert{{$index}}\" class=\"certificate-template\"> <div style=\"\" class=\"certificate-main-content\"> <div class=\"capstone-head\">CAPSTONE PROJECT REPORT</div> <div class=\"capstone-name\">{{cert.lpCertiticate}}</div> </div> </div> </div> </div> </div>");
$templateCache.put("app/Features/progressInfoPage/template/leaderBoard.html"," <div class=\"prog-pg-leaderboard-title-wrp hide-in-mobile\"> <div class=\"title\">Leaderboard</div> <div class=\"subtitle\">(Top 10)</div>  </div> <div class=\"leader-brd-wrp\"> <div class=\"leader-brd-top-section\"> <div class=\"leader-brd-top-wrp\"> <div class=\"title-wrp\">This week\'s top 3</div> <div class=\"leader-top-three-section row\"> <div ng-repeat=\"data in leaderbrdData | orderBy:[&quot;grank&quot;,&quot;touchtime&quot;]\" ng-if=\"$index&lt;3\" class=\"leader-top-three-item-wrp columns large-4 medium-4 small-4\"> <div class=\"rank-wrp\"> <div class=\"rank\">{{$index+1 | twoDigit}}</div> <div class=\"change\"><img ng-src=\"assets/images/increase.png\"></div> </div> <div class=\"user-img-wrp\"> <div class=\"top-performer-img-con\"> <div id=\"topPerformers-{{$index}}\" ng-style=\"{ \'background-image\' : \'url({{data.profilePhotoUrl}})\'}\" ng-init=\"applySchema(\'topPerformers-{{$index}}\',\'0\');\" class=\"top-performer-img\"></div> </div> </div> <div class=\"user-name-wrp\"> <div class=\"user-name\">{{data.firstname}} {{data.lastName}}</div> </div> <div class=\"user-score-wrp\"> <div class=\"score-star\"><span class=\"icon-star\"></span></div> <div class=\"score\">{{data.points}}</div> </div> </div> </div> </div> </div> <div class=\"leader-brd-ten-section\"> <div class=\"leader-brd-item-wrp row\"> <div ng-show=\"!userInLdrBrd\" ng-if=\"userPosData.urank &gt; 10\" class=\"lrnr-not-a-leader-wrp hide-in-tablet-up\"> <div class=\"leader-brd-item table\"> <div class=\"rank-wrp table-cell\"> <div class=\"rank\"> {{userPosData.urank | twoDigit}}</div> <div class=\"rank-change\"><img ng-src=\"assets/images/increase.png\"></div> </div> <div class=\"user-det-section table-cell\"> <div class=\"user-img-wrp\"><img ng-src=\"{{userPosData.img_url}}\"></div> <div class=\"user-det-wrp\"> <div class=\"user-det-mob hide-in-tablet-up\"> <div class=\"user-name-mob\">{{userPosData.name}}</div> <div class=\"user-det-mob-info clearfix\"> <div class=\"user-score-wrp left\"> <div class=\"score-star\"><span class=\"icon-star\"></span></div> <div class=\"score\">{{userPosData.points}}</div> </div>  </div> </div>  </div> </div> </div> <div class=\"lrnr-prof-lead-msg-wrp\"><span>You need {{userPosData.points}}</span><span class=\"hdng\">{{leaderbrdDataSorted[0].points-userPosData.points}} Points more</span><span>to make it to top 10!</span></div>  </div> <div ng-repeat=\"data in leaderbrdData | orderBy:[&quot;grank&quot;,&quot;touchtime&quot;]\" ng-if=\"$index&gt;=3\" class=\"leader-brd-item table\"> <div class=\"rank-wrp table-cell\"> <div class=\"rank\">{{$index+1 | twoDigit}}</div> <div class=\"rank-change\"><img ng-src=\"assets/images/increase.png\"></div> </div> <div class=\"user-det-section table-cell\"> <div class=\"user-img-wrp\"><img ng-src=\"{{data.profilePhotoUrl}}\"></div> <div class=\"user-det-wrp\"> <div class=\"user-det-desktop hide-in-mobile clearfix\"> <div class=\"user-name left\">{{data.firstname}} {{data.lastName}}</div> <div class=\"user-progress-wrp right\">  <div class=\"user-score-wrp\"> <div class=\"score-star\"><span class=\"icon-star\"></span></div> <div class=\"score\">{{data.points}}</div> </div> </div> </div> <div class=\"user-det-mob hide-in-tablet-up\"> <div class=\"user-name-mob\">{{$index}}</div> <div class=\"user-det-mob-info clearfix\"> <div class=\"user-score-wrp left\"> <div class=\"score-star\"><span class=\"icon-star\"></span></div> <div class=\"score\">{{data.points}}</div> </div>  </div> </div>  </div> </div> </div> <div ng-show=\"!userInLdrBrd\" ng-if=\"userPosData.urank &gt; 10\" class=\"lrnr-not-a-leader-wrp hide-in-mobile\"> <div class=\"leader-brd-item table\"> <div class=\"rank-wrp table-cell\"> <div ng-if=\"userRank == &quot;&quot;\" class=\"rank\"> {{userPosData.urank | twoDigit}}</div> <div class=\"rank\">{{userRank| twoDigit}}</div> <div class=\"rank-change\"><img ng-src=\"assets/images/increase.png\"></div> </div> <div class=\"user-det-section table-cell\"> <div class=\"user-img-wrp\"><img ng-src=\"{{userPosData.profilePhotoUrl}}\"></div> <div class=\"user-det-wrp\"> <div class=\"user-det-desktop hide-in-mobile clearfix\"> <div class=\"user-name left\"><span>{{userPosData.firstname}} {{userPosData.lastName}}</span></div> <div class=\"user-progress-wrp right\">  <div class=\"user-score-wrp\"> <div class=\"score-star\"><span class=\"icon-star\"></span></div> <div class=\"score\">{{userPosData.points}}</div> </div> </div> </div>  </div> </div> </div> <div class=\"lrnr-prof-lead-msg-wrp\"><span>You need</span><span class=\"hdng\">{{leaderbrdDataSorted[0].points-userPosData.points}} Points more</span><span>to make it to top 10!</span></div>  </div> </div> </div> </div>");
$templateCache.put("app/Features/progressInfoPage/template/mobile_landing_page.html"," <div class=\"lrn-prog-mob-landing-page-wrp\"> <div class=\"lrn-prog-mob-hdng-wrp\"> <div class=\"lrn-prog-mob-hdng-top clearfix\"> <div class=\"lrn-prog-mob-user-img-wrp left\"> <div class=\"lrn-prog-mob-user-img\"><img ng-src=\"assets/images/user_lrn.png\"> <div class=\"icon icon-edit\"> </div> </div> </div> <div ng-click=\"goToDashboard()\" class=\"lrn-prog-mob-close-wrp right\"><span class=\"icon-close\"></span></div> </div> <div class=\"lrn-prog-main-msg-wrp\"> <div class=\"msg\">Congratulations on completing Module 07 Need to buck up!</div> <div class=\"scnd-msg\">6 Weeks Left</div> </div> <div class=\"lrn-prog-bar-section\"> <primary-progress-bar proposed-completion=\"expectedCompletion\" actual-completion=\"modulesData.progress\"></primary-progress-bar> </div> <div class=\"lrn-prog-bar-section\"> <proficiency-progress-bar total-tests=\"10\" proposed-completion=\"3\" actual-completion=\"2\"> </proficiency-progress-bar> </div> </div> <div class=\"lrn-prog-mob-content-wrp\"> <div ng-click=\"goToProgressTab()\" class=\"lrn-prog-mob-content-item clearfix remove-focus\"> <div class=\"txt left\">Progress</div> <div class=\"icon right icon-next\"> </div> </div> <div class=\"lrn-prog-mob-content-item clearfix remove-focus\"> <div class=\"txt left\">performance analytics</div> <div class=\"icon right icon-next\"></div> </div> <div ng-click=\"goToPersonalInfo()\" class=\"lrn-prog-mob-content-item clearfix remove-focus\"> <div class=\"txt left\">personal info</div> <div class=\"icon right icon-next\"> </div> </div> </div> </div>");
$templateCache.put("app/Features/progressInfoPage/template/overviewMobile.html"," <div class=\"prog-pg-mob-timeline-wrp\"> <div class=\"prog-pg-mob-timeline-content-wrp\"> <div class=\"prog-pg-mob-timeline-content-title-wrp\"> <div class=\"icon icon-begin\"></div> <div class=\"title-info-wrp\"> <div class=\"txt\">Learning Path Commenced</div> <div class=\"date\">23 March,2016 (Week 1)</div> </div> </div> <div ng-style=\"{ \'height\' : weekHeight}\" class=\"prog-timeline-dummy-wrp\"> <div ng-repeat=\"module in lpModulesData | orderBy:&quot;sequence_id&quot;\" ng-style=\"getModuleHeight(module.suggested_time)\" class=\"prog-pg-mob-timeline-item-wrp\"> <div ng-class=\"{\'started\' : module.status == \'in progress\' , \'completed\' : module.status == \'completed\' , \'not-started\' : module.status == \'not started\'}\" class=\"module-no-wrp\"><span>{{module.sequence_id}} </span></div> <div class=\"module-tile-wrp table\"> <div class=\"connector table-cell\"> <div class=\"dummy\"></div> </div> <div class=\"tile-wrp table-cell\"> <div class=\"tile-wrp-top clearfix\"> <div class=\"tile-wrp-title left\">{{module.title}}</div> <div class=\"tile-wrp-status-section right\"><span ng-class=\"{ \'icon-check\' : module.status == \'completed\' &amp;&amp; module.proficiency_test_taken , \'icon-warning \' : module.status == \'completed\' &amp;&amp; !module.proficiency_test_taken}\"></span></div> </div> <div ng-if=\"module.status == &quot;completed&quot; &amp;&amp; !module.proficiency_test_taken\" class=\"tile-btn-wrp clearfix\"> <div class=\"btn-txt left\">proficiency Test</div> <div class=\"icon icon-next left\"></div> </div> <div ng-if=\"module.status == &quot;in progress&quot; || module.status == &quot;not started&quot;\" class=\"tile-btn-wrp clearfix\"> <div class=\"btn-txt left\">Begin Module</div> <div class=\"icon icon-next left\"></div> </div> <div ng-if=\"module.status == &quot;completed&quot; &amp;&amp; module.proficiency_test_taken\" class=\"tile-btn-wrp clearfix color-scnd\"> <div class=\"btn-txt left\">Badge Level 1 Achieved </div> </div> </div> </div> <div ng-style=\"{\'height\' : module.progress +\'%\'}\" ng-class=\"{\'started\' : module.status == \'in progress\' , \'completed\' : module.status == \'completed\' , \'not-started\' : module.status == \'not started\'}\" class=\"module-prog-indicator\"> </div> </div> </div> <div class=\"prog-pg-mob-timeline-content-title-wrp\"> <div class=\"icon icon-begin\"></div> <div class=\"title-info-wrp\"> <div class=\"txt\">Learning Path ENDS</div> <div class=\"date\">23 March,2016 (Week 1)</div> </div> </div> </div> </div>");
$templateCache.put("app/Features/progressInfoPage/template/personalInfo.html"," <form name=\"profileForm\" ng-submit=\"formSubmitted= true; saveProfileChanges(profileForm.$valid)\"> <div class=\"prsn-info-pg-wrp\"> <div class=\"prsn-info-mob-section\"> <div class=\"prsn-user-name-wrp\"> <div class=\"group\"> <input type=\"text\" ng-model=\"username\" ng-disabled=\"true\"><span class=\"highlight\"></span><span class=\"bar\"></span> <label>Username</label> </div> </div> <div class=\"prsn-user-name-wrp\"> <div class=\"group\"> <input required=\"\" ng-model=\"password\" type=\"password\"><span class=\"highlight\"></span><span class=\"bar\"></span> <label>password</label> </div> </div> <div class=\"prsn-user-name-wrp\"> <div class=\"group\"> <input type=\"text\" ng-model=\"companyName\" ng-disabled=\"true\"><span class=\"highlight\"></span><span class=\"bar\"></span> <label>Company Name</label> </div> </div> <div class=\"prsn-user-name-wrp\"> <div class=\"group\"> <input type=\"text\" ng-model=\"emailID\" ng-disabled=\"true\"><span class=\"highlight\"></span><span class=\"bar\"></span> <label>Email ID</label> </div> </div> <div class=\"prsn-user-name-wrp\"> <div class=\"group\"> <input type=\"text\" required=\"\" ng-model=\"contactNumber\"><span class=\"highlight\"></span><span class=\"bar\"></span> <label>Contact Number</label> </div> </div> <div class=\"prsn-linkedin-btn-wrp\"> <div class=\"linkedin-btn\"><span class=\"text\">LINKEDIN LOGIN</span><span class=\"icon-linkedin\"></span></div> </div> <div class=\"prsn-linkedin-btn-wrp\"> <button type=\"submit\" class=\"primary_btn\">Save Changes</button> </div> </div> <div class=\"prsn-info-desktop-wrp row hide-in-mobile\"> <div class=\"input-wrp\"> <div class=\"prsn-info-input-wrp clearfix\"> <div class=\"type left\"><span>Username</span></div> <div class=\"input-field-wrp left\"> <input type=\"text\" ng-model=\"username\" ng-disabled=\"true\"> </div> </div> <div class=\"prsn-info-input-wrp clearfix\"> <div class=\"type left\"><span>Password</span></div> <div class=\"input-field-wrp left\"> <input ng-model=\"password\" type=\"password\" required=\"\"> </div> </div> <div class=\"prsn-info-input-wrp clearfix\"> <div class=\"type left\"><span>Company Name</span></div> <div class=\"input-field-wrp left\"> <input type=\"text\" ng-model=\"companyName\" ng-disabled=\"true\"> </div> </div> <div class=\"prsn-info-input-wrp clearfix\"> <div class=\"type left\"><span>Email ID</span></div> <div class=\"input-field-wrp left\"> <input type=\"text\" ng-model=\"emailID\" ng-disabled=\"true\"> </div> </div> <div class=\"prsn-info-input-wrp clearfix\"> <div class=\"type left\"><span>Phone number</span></div> <div class=\"input-field-wrp left\"> <input type=\"tel\" ng-model=\"contactNumber\" required=\"\"> </div> </div> <div class=\"prsn-info-btn-wrp row\"> <div class=\"prsn-linkedin-btn-wrp\"> <div class=\"linkedin-btn\"><span class=\"text\">LINKEDIN LOGIN</span><span class=\"icon-linkedin\"></span></div> </div> <button type=\"submit\" class=\"primary_btn\">Save Changes</button> </div> </div> </div> </div> </form>");
$templateCache.put("app/Common/Directives/header/templates/bm_backup.html"," <div ng-class=\"{&quot;active&quot;: parentObj.isBurgerMenuActive, &quot;inactive&quot;: !parentObj.isBurgerMenuActive &amp;&amp; parentObj.isHammIconClicked}\" class=\"burger-menu-container\"> <div style=\"display:none\" ng-click=\"parentObj.isBurgerMenuActive = !parentObj.isBurgerMenuActive\" class=\"burger-menu-overlay\"></div> <div ng-class=\"{\'initiate-local-search\': parentObj.isSearchBoxFocussed}\" class=\"burger-menu-content\"> <div class=\"bm-active-flow-heading table-cell\"><span class=\"bm-flow-heading\">{{modelParent.burgerTitle}}</span></div> <div class=\"bm-in-flow-search-con relative\"> <div class=\"bm-in-flow-search table\"> <div class=\"table-cell bm-search-left-icon\"><span class=\"icon-search\"></span></div> <div class=\"table-cell bm-search-input\"> <input placeholder=\"type here...\" ng-model=\"parentObj.localSearchModel\" ng-focus=\"parentObj.isSearchBoxFocussed = true\" ng-change=\"burgerSearchChanged();\" class=\"burger-menu-search\"> </div> <div class=\"table-cell bm-search-right-icon\"><span ng-if=\"parentObj.isSearchBoxFocussed\" ng-click=\"parentObj.localSearchModel = \'\'; parentObj.isSearchBoxFocussed = false\" class=\"icon-remove\"></span></div> </div> <div ng-if=\"parentObj.isSearchBoxFocussed\" class=\"in-flow-search-suggestions absolute\"> <div class=\"previous-arrow-icon-con\"><span ng-click=\"parentObj.localSearchModel = \'\'; parentObj.isSearchBoxFocussed = false\" class=\"icon-back\"></span></div> <ul class=\"bm-search-results-con\"> <li class=\"table\"> <div class=\"bm-search-result table-cell\">Why is<span class=\"search-match\">Analytics</span>becoming popular?</div> </li> <li class=\"table\"> <div class=\"bm-search-result table-cell\"><span class=\"search-match\">Analytics</span>Quiz A</div> </li> <li class=\"table\"> <div class=\"bm-search-result table-cell\"><span class=\"search-match\">Analytics</span>for Hypothesis testing</div> </li> <li class=\"table\"> <div class=\"bm-search-result table-cell\">Why is<span class=\"search-match\">Analytics</span>becoming popular?</div> </li> <li class=\"table\"> <div class=\"bm-search-result table-cell\"><span class=\"search-match\">Analytics</span>Quiz A</div> </li> </ul> </div> </div> <ul class=\"burger-menu-list-con\"> <li ng-click=\"parentObj.isBurgerMenuActive = !parentObj.isBurgerMenuActive; notificationsClicked();\" class=\"burger-menu-list notification-tab table remove-focus\"> <div title=\"Notifications\" class=\"bm-each-icon-con\"><span class=\"bm-each-icon icon-bell relative\"> <div class=\"bm-notif-count absolute\"><span>3</span></div></span> </div> </li> <li ng-click=\"parentObj.isBurgerMenuActive = !parentObj.isBurgerMenuActive; bookmarksClicked();\" class=\"burger-menu-list table remove-focus\"> <div title=\"Bookmarks\" class=\"bm-each-icon-con\"><span class=\"bm-each-icon icon-bookmark\"></span></div> </li> <li ng-click=\"parentObj.isBurgerMenuActive = !parentObj.isBurgerMenuActive;feedbackClicked();\" class=\"burger-menu-list table remove-focus\"> <div title=\"Feedback\" class=\"bm-each-icon-con\"><span class=\"bm-each-icon icon-feedback\"></span></div> </li> <li ng-click=\"parentObj.isBurgerMenuActive = !parentObj.isBurgerMenuActive; helpClicked();\" class=\"burger-menu-list table remove-focus\"> <div title=\"Help\" class=\"bm-each-icon-con\"><span class=\"bm-each-icon icon-support\"></span></div> </li> <li class=\"burger-menu-list table remove-focus\"> <div title=\"Settings\" class=\"bm-each-icon-con\"><span class=\"bm-each-icon icon-settings\"></span></div> </li> </ul> <div class=\"bm-history-contents\"> <div class=\"bm-history-title\">HISTORY</div> <div class=\"bm-history-details\"> <div ng-repeat=\"item in menuHistoryItems.history\" class=\"bm-each-history-item\"><span ng-class=\"{\'icon-video\':item.type===\'video\',\'icon-search\':item.type===\'search\'}\" class=\"bm-history-icon\"></span><span class=\"bm-search-result-title\">{{item.title}}</span></div> </div> </div> <div class=\"bm-logout-btn\"> <button ng-click=\"initiateLogOut();\" class=\"primary_btn table-cell remove-focus\"><span class=\"icon-logout\"></span><span class=\"text\">LOGOUT</span></button> </div> </div> </div>");
$templateCache.put("app/Common/Directives/header/templates/burgerMenu.html"," <div ng-class=\"{&quot;active&quot;: parentObj.isBurgerMenuActive, &quot;inactive&quot;: !parentObj.isBurgerMenuActive &amp;&amp; parentObj.isHammIconClicked}\" class=\"buyer-burger-menu-container\"> <div ng-click=\"parentObj.isBurgerMenuActive = !parentObj.isBurgerMenuActive\" class=\"buyer-burger-menu-overlay\"></div> <div ng-class=\"{\'initiate-local-search\': parentObj.isSearchBoxFocussed}\" class=\"buyer-burger-menu-content\"> <div class=\"bm-active-flow-heading table-cell\"><span class=\"bm-flow-heading\">{{modelParent.burgerTitle}}</span></div> <ul class=\"buyer-burger-menu-list-con leaner-menu\"> <li ng-click=\"parentObj.isBurgerMenuActive = !parentObj.isBurgerMenuActive; notificationsClicked();\" class=\"buyer-burger-menu-list notification-tab table remove-focus\"> <div title=\"Notifications\" class=\"bm-each-icon-con\"><span class=\"bm-each-icon icon-bell relative\"> <div class=\"bm-notif-count absolute\"><span>3</span></div></span></div> </li> <div class=\"table menu-title\"> <div class=\"burger-each-list-txt table-cell\"><span>Active Learning</span></div> </div> <div ng-click=\"parentObj.isBurgerMenuActive = !parentObj.isBurgerMenuActive;dashboardClicked();\" class=\"buyers-burger-menu-list table remove-focus\"> <div class=\"burger-each-list-txt table-cell menu-item\"><span>Dashboard</span></div> </div> <div ng-click=\"parentObj.isBurgerMenuActive = !parentObj.isBurgerMenuActive;overviewClicked();\" class=\"buyers-burger-menu-list table remove-focus\"> <div class=\"burger-each-list-txt table-cell menu-item\"><span>Learning Overview</span></div> </div> <div ng-click=\"parentObj.isBurgerMenuActive = !parentObj.isBurgerMenuActive;certificatesClicked();\" class=\"buyers-burger-menu-list table remove-focus\"> <div class=\"burger-each-list-txt table-cell menu-item\"><span>Certificates</span></div> </div> <div class=\"table menu-title second-title\"> <div class=\"burger-each-list-txt table-cell\"><span>Others</span></div> </div> <div ng-click=\"showAllLps();parentObj.isBurgerMenuActive = !parentObj.isBurgerMenuActive; parentObj.isHammIconClicked = true;\" class=\"buyers-burger-menu-list table remove-focus\"> <div class=\"burger-each-list-txt table-cell menu-item\"><span>Old Learning Paths </span></div> </div> <div ng-click=\"showProgress();parentObj.isBurgerMenuActive = !parentObj.isBurgerMenuActive; parentObj.isHammIconClicked = true;\" class=\"buyers-burger-menu-list table remove-focus\"> <div class=\"burger-each-list-txt table-cell menu-item\"><span>Profile</span></div> </div> <div ng-click=\"showLearnerProfile();parentObj.isBurgerMenuActive = !parentObj.isBurgerMenuActive; parentObj.isHammIconClicked = true;\" class=\"buyers-burger-menu-list table remove-focus\"> <div class=\"burger-each-list-txt table-cell menu-item\"><span>Settings</span></div> </div> <div ng-click=\"parentObj.isBurgerMenuActive = !parentObj.isBurgerMenuActive; helpClicked();\" class=\"buyers-burger-menu-list table remove-focus\"> <div class=\"burger-each-list-txt table-cell menu-item\"><span>Help</span></div> </div> <div ng-click=\"parentObj.isBurgerMenuActive = !parentObj.isBurgerMenuActive;feedbackClicked();\" class=\"buyers-burger-menu-list table remove-focus\"> <div class=\"burger-each-list-txt table-cell menu-item\"><span>Feedback</span></div> </div> <div ng-click=\"parentObj.isBurgerMenuActive = !parentObj.isBurgerMenuActive;learnerLogoutFunc();\" class=\"buyers-burger-menu-list table remove-focus\"> <div class=\"burger-each-list-txt table-cell menu-item\"><span>Logout</span></div> </div> </ul>  </div> </div>");
$templateCache.put("app/Common/Directives/header/templates/buyerBurgerMenu.html"," <div ng-class=\"{&quot;active&quot;: parentObj.isBuyerBurgerMenuActive, &quot;inactive&quot;: !parentObj.isBuyerBurgerMenuActive &amp;&amp; parentObj.isHammIconClicked}\" class=\"buyer-burger-menu-container\"> <div ng-click=\"parentObj.isBuyerBurgerMenuActive = !parentObj.isBuyerBurgerMenuActive\" class=\"buyer-burger-menu-overlay\"></div> <div ng-class=\"{\'initiate-local-search\': parentObj.isSearchBoxFocussed}\" class=\"manager buyer-burger-menu-content\"> <div class=\"bm-active-flow-heading table-cell\"><span class=\"bm-flow-heading\">Dashboard</span></div> <ul class=\"buyer-burger-menu-list-con\"> <li ng-click=\"parentObj.isBuyerBurgerMenuActive = !parentObj.isBuyerBurgerMenuActive; notificationsClicked();\" class=\"buyer-burger-menu-list notification-tab table remove-focus\"> <div title=\"Notifications\" class=\"bm-each-icon-con\"><span class=\"bm-each-icon icon-bell relative\"> <div class=\"bm-notif-count absolute\"><span>3</span></div></span> </div> </li> <div ng-click=\"parentObj.isBuyerBurgerMenuActive = !parentObj.isBuyerBurgerMenuActive;buyerFeedbackClicked();\" class=\"buyers-burger-menu-list table remove-focus\"> <div class=\"burger-each-list-txt table-cell\"><span>Feedback</span></div> <div class=\"burger-each-list-arrow table-cell\"><span class=\"next-arrow icon-next\"></span></div> </div> <div ng-click=\"parentObj.isBuyerBurgerMenuActive = !parentObj.isBuyerBurgerMenuActive; buyerHelpClicked();\" class=\"buyers-burger-menu-list table remove-focus\"> <div class=\"burger-each-list-txt table-cell remove-focus\"><span>Help</span></div> <div class=\"burger-each-list-arrow table-cell\"><span class=\"next-arrow icon-next\"></span></div> </div> <div ng-click=\"showProfile();parentObj.isBuyerBurgerMenuActive = !parentObj.isBuyerBurgerMenuActive; parentObj.isHammIconClicked = true;\" class=\"buyers-burger-menu-list table remove-focus\"> <div class=\"burger-each-list-txt table-cell\"><span>Settings</span></div> <div class=\"burger-each-list-arrow table-cell\"><span class=\"next-arrow icon-next\"></span></div> </div> </ul>  <div ng-click=\"parentObj.isBuyerBurgerMenuActive = !parentObj.isBuyerBurgerMenuActive;logoutFunc();\" class=\"by-logout-btn\"> <button class=\"primary_btn logout_btn table-cell remove-focus\"><span class=\"icon-logout\"></span><span class=\"text\">LOGOUT</span></button> </div> </div> </div>");
$templateCache.put("app/Features/buyerJourney/partials/allocationScreen/allocationScreen.html"," <div class=\"ballocation-section\"> <div class=\"ballocation-wrp\"> <div class=\"ballocation-header-wrp\"> <div class=\"ballocation-heading\"><span>allocate licenses</span></div> <div class=\"ballocation-sub-heading-wrp clearfix\"> <div class=\"ballocation-sub-heading left\"><span class=\"text\">Total Licenses to allocate:</span><span class=\"value\">{{bJourneyObj.user[0].totalLicenses}}</span></div> </div> </div> <div ui-view=\"\" class=\"ballocation-form-section\"></div> </div> </div>");
$templateCache.put("app/Features/buyerJourney/partials/buyerDashboard/buyerDashboard.html"," <div ng-init=\"showOption=false; applySchemaMob()\" style=\"background-color:#2f343b\" ng-intro-options=\"IntroOptions\" ng-intro-method=\"CallMe\" ng-hints-method=\"startHints\" ng-intro-oncomplete=\"CompletedEvent\" ng-intro-onexit=\"ExitEvent\" ng-intro-onchange=\"ChangeEvent\" ng-intro-onbeforechange=\"BeforeChangeEvent\" ng-intro-onafterchange=\"AfterChangeEvent\" ng-intro-autostart=\"true\" class=\"bdash-mob-header relative\"> <div class=\"clearfix\"> <div class=\"left setup-profile-image-con relative\"> <div id=\"setupProfileImageMob\" ng-style=\"\" class=\"setup-profile-image\"></div> </div> <div class=\"upload-avatar-wrp\"> <div class=\"upload-image table\"> <label ng-click=\"parentObj.uploadAvatar=true\" class=\"table-cell remove-focus\"><span class=\"text\">Select avatar</span><span class=\"icon-notes\"></span></label> </div> </div> <div class=\"left\"> <div class=\"buser-info-wrp\"> <div class=\"buser-name table\"> <div class=\"table-cell\"><span>{{bJourneyObj.user[0].userName}}</span><span class=\"buser-designation\">({{bJourneyObj.user[0].designation}})</span></div> </div> </div> </div> </div> <div ng-click=\"showOption=!showOption\" class=\"buser-manager-wrp table remove-focus\"> <div class=\"table-cell manager\">Manager</div> </div> <div class=\"bnavigation-tiles-wrp full-width table absolute\"> <div ng-class=\"{&quot;active&quot;:bJourneyObj.activeTab === &quot;dashboard&quot;}\" ng-click=\"activeTabFunc(&quot;dashboard&quot;);goToDashboard()\" class=\"table-cell bnavigation-tiles width-one-fourth remove-focus\"><span class=\"icon-dashboard\">{{userProfile}}</span></div>     </div> </div> <div ng-show=\"!userProfile\" ng-include=\"\" src=\"\'app/Features/buyerJourney/partials/buyerDashboard/templates/dashboardNav/dashboardNav.html\'\" class=\"bdashboard-navigation-section\"></div> <div ng-show=\"userProfile\" ng-include=\"\" src=\"\'app/Features/userProfile/userProfile.html\'\" class=\"bdashboard-navigation-section user-prof\"></div> <div ui-view=\"\" class=\"bdashboard-wrp relative\"></div> <upload-avatar> <div ng-if=\"tNCOverlay\" class=\"upload-tnc-overlay\"> <div ng-click=\"openClosetNCOverlay()\" class=\"upload-tnc-overlay-close remove-focus\"><span class=\"icon-close\"></span></div> <div class=\"upload-tnc-section\"> <div class=\"upload-tnc-heading\"><span>Terms and Conditions:</span></div> <div class=\"upload-tnc-text\"> <ul> <li>The Intellectual Property disclosure will inform users that your website, logo and visuals and other content you created is your property and protected by copyright laws</li> <li>A Termination clause will inform users that their accounts on your website (or their access to your website, if they don�t have an account) can be terminated in case of abuses</li> <li>A Governing Law informs users which country�s laws governs the agreement. This is the country in which your company is headquartered or the country from which you operate your web site.</li> <li>A Links To Other Web Sites clause informs users that you are not responsible for any third party web sites that you link to from your website, and that users are responsible for reading these third parties� own Terms and Conditions or Privacy Policies.</li> <li>The Intellectual Property disclosure will inform users that your website, logo and visuals and other content you created is your property and protected by copyright laws</li> <li>A Termination clause will inform users that their accounts on your website (or their access to your website, if they don�t have an account) can be terminated in case of abuses</li> <li>A Governing Law informs users which country�s laws governs the agreement. This is the country in which your company is headquartered or the country from which you operate your web site.</li> <li>A Links To Other Web Sites clause informs users that you are not responsible for any third party web sites that you link to from your website, and that users are responsible for reading these third parties� own Terms and Conditions or Privacy Policies.</li> </ul> </div> </div> </div> </upload-avatar>");
$templateCache.put("app/Features/buyerJourney/partials/welcomeScreen/welcomeScreen.html"," <div ng-intro-options=\"IntroOptions\" ng-intro-method=\"CallMe\" ng-intro-oncomplete=\"CompletedEvent\" ng-intro-onexit=\"ExitEvent\" ng-intro-onchange=\"ChangeEvent\" ng-intro-onbeforechange=\"BeforeChangeEvent\" ng-intro-onafterchange=\"AfterChangeEvent\" ng-intro-autostart=\"ShouldAutoStart\"></div> <div ng-keydown=\"checkKeyEvent($event)\" class=\"bwelcome-screen-wrp\"> <div class=\"bwelcome-msg-hdng-wrp\"> <div class=\"bwelcome-msg\"><span>Welcome to Rubric</span></div> <div class=\"bwelcome-jigsaw\"><span>Powered by Jigsaw Academy</span></div>  </div> <div class=\"bwelcome-msg-bdy-wrp\"> <div class=\"bwelcome-purchase-wrp\"> <div class=\"bwelcome-purchase-heading\"><span>Hi {{bJourneyObj.user.firstname}},</span><span ng-show=\"bJourneyObj.isManager\">you can now kickstart your team\'s learning journey. You have been allotted</span><span ng-show=\"bJourneyObj.isHead\" style=\"padding-left:5px\">you can now kickstart your organization\'s learning journey. You have purchased</span><span ng-if=\"bJourneyObj.isHead\" style=\"padding-left:10px;font-weight:bold\">{{bJourneyObj.WelcomeLicense.welcomeScreenData[0].noOfLicensePurchased}}</span><span ng-if=\"bJourneyObj.isHead\" style=\"padding-left:10px;\">corporate licenses.</span><span ng-if=\"bJourneyObj.isManager\" style=\"padding-left:10px;font-weight:bold\">{{bJourneyObj.WelcomeLicense.welcomeScreenData[0].noOfLicenseAllocated}}</span><span ng-if=\"bJourneyObj.isManager\" style=\"padding-left:10px;\">licenses</span></div> </div> <div class=\"bwelcome-paths-wrp\"> <div class=\"bwelcome-paths-heading\"><span>LEARNING PATHS:</span></div> <div ng-if=\"bJourneyObj.isHead\" class=\"bwelcome-paths-option-wrp\"> <div ng-repeat=\"lp in bJourneyObj.WelcomeLp.welcomeScreenData | unique:&quot;lpTitle&quot;\" class=\"bwelcome-paths-option\"><span>{{lp.lpTitle}}</span><span style=\"color:#fc792c\" id=\"lp{{$index}}\" ng-click=\"showDesc($event)\" class=\"icon-info relative\"> <div ng-show=\"showDescription\" class=\"lp-description absolute\"> <div class=\"lp-content-wrp lp-box-arrow relative\"> <div class=\"content\">{{lp.lpDescription}}</div> </div> </div></span></div> </div> <div ng-if=\"bJourneyObj.isManager\" class=\"bwelcome-paths-option-wrp\"> <div ng-repeat=\"lp in bJourneyObj.WelcomeLp.welcomeScreenData | unique:&quot;lpTitle&quot;\" class=\"bwelcome-paths-option\"><span>{{lp.lpTitle}}</span><span style=\"color:#fc792c\" id=\"lp{{$index}}\" ng-click=\"showDesc($event)\" class=\"icon-info relative\"> <div ng-show=\"showDescription\" class=\"lp-description absolute\"> <div class=\"lp-content-wrp lp-box-arrow relative\"> <div class=\"content\">{{lp.lpDescription}}</div> </div> </div></span></div> </div> </div> <div class=\"bwelcome-btn-wrp\"> <div ng-click=\"goToSetupProfile()\" class=\"primary_btn inline-block remove-focus\">Proceed to Dashboard</div> </div> </div> </div>");
$templateCache.put("app/Features/helpPage/template/faqState/helpFaq.html"," <div class=\"hlp-faq-wrp\"> <div ng-if=\"user_data.role === &quot;Learner&quot;\" class=\"hlp-faq-tabs-switch clearfix row\"> <div class=\"faq-title hide-in-mobile\">Choose a category</div> <div ng-repeat=\"item in faqTopics\" class=\"hlp-faq-tab-dummy left remove-focus\"> <div ng-class=\"{&quot;tile-active&quot;:currentFaqTabName === item.id}\" ng-click=\"changeTabFaq(item.id)\" class=\"hlp-faq-tab\"> <div ng-class=\"item.iconClass\" class=\"icon\"></div> <div class=\"txt\">{{item.title}}</div> </div> <div ng-if=\"currentFaqTabName === item.id &amp;&amp; shwFreqntAns\" class=\"hlp-mob-quest-wrp\"> <div ng-repeat=\"item in faqQuestions | orderBy:&quot;-&quot;\" ng-click=\"openAnswer($index);$event.stopPropagation()\" ng-class=\"{&quot;isactive&quot;:$index == currentQuestion &amp;&amp; shwAnswer}\" class=\"hlp-faq-qstn-item hlp-mob-quest-item remove-focus\"> <div class=\"hlp-faq-qstn table\"> <div class=\"table-cell icn-wrp\"> <div ng-class=\"{&quot;faq-icon-rotate&quot;:$index == currentQuestion &amp;&amp; shwAnswer ,&quot;faq-icon-rotate-anti&quot; :$index == currentQuestion &amp;&amp; !shwAnswer}\" class=\"icon icon-next\"></div> </div> <div class=\"hlp-qstn\">{{item.question}}</div> </div> <div ng-if=\"$index == currentQuestion &amp;&amp; shwAnswer\" ng-bind-html=\"item.answer | trustAsHtml\" class=\"hlp-answer\">{{item.answer}}</div> </div> </div> </div> </div> <div class=\"hlp-faq-content\"> <div class=\"hlp-faq-qstns-wrp hide-in-mobile row\"> <div class=\"faq-title hide-in-mobile\"> Frequently Asked Questions</div> <div class=\"hlp-faq-qstn-wrp\"> <div ng-repeat=\"item in faqQuestions | orderBy:&quot;-&quot;\" ng-click=\"openAnswer($index)\" ng-class=\"{&quot;active&quot;:$index == currentQuestion &amp;&amp; shwAnswer}\" class=\"hlp-faq-qstn-item remove-focus\"> <div class=\"hlp-faq-qstn table\"> <div class=\"table-cell icn-wrp\"> <div ng-class=\"{&quot;faq-icon-rotate&quot;:$index == currentQuestion &amp;&amp; shwAnswer ,&quot;faq-icon-rotate-anti&quot; :$index == currentQuestion &amp;&amp; !shwAnswer}\" class=\"icon icon-next\"></div> </div> <div class=\"hlp-qstn\">{{item.question}}</div> </div> <div ng-if=\"$index == currentQuestion &amp;&amp; shwAnswer\" ng-bind-html=\"item.answer | trustAsHtml\" class=\"hlp-answer\">{{item.answer}}</div> </div> </div> </div> <div class=\"hlp-faq-footer row hide-in-mobile\"> <div class=\"txt\">Can\'t find what you are looking for?</div> <div class=\"btn-wrp\"> <div ng-click=\"raiseAticket()\" class=\"primary_btn\">Contact Us</div> </div> </div> </div> </div>");
$templateCache.put("app/Features/helpPage/template/supportState/supportState.html"," <div class=\"raise-ticket-page\"> <div ng-if=\"toggleTickets\" class=\"support-content row suport-tickets-mob\"> <div class=\"hlp-faq-tabs-switch clearfix\"> <div ng-repeat=\"item in supportTopics\" class=\"hlp-faq-tab-dummy left remove-focus\"> <div ng-class=\"{&quot;tile-active&quot;:currentSupportItem == item.title}\" ng-click=\"supportTopic(item.title)\" class=\"hlp-support-tab\"> <div ng-class=\"item.iconClass\" class=\"icon hide-in-mobile\"></div> <div class=\"txt\">{{item.title}}</div> </div> </div> </div> <div class=\"hlp-sprt-wrp\"> <div class=\"hlp-sprt-input\"> <input type=\"text\" ng-model=\"supportModel.subjectType\" placeholder=\"subject:\" ng-click=\"$event.stopPropagation();\" ng-change=\"takeNoteChange()\" class=\"remove-focus\"> </div> <div class=\"hlp-sprt-txt-area relative\"> <textarea type=\"text\" placeholder=\"Please give us more details\" ng-model=\"supportModel.issue\" ng-change=\"takeNoteChange()\"></textarea> </div> <div class=\"hlp-attach-section clearfix hide-in-mobile\"> <div class=\"hlp-sprt-snd-wrp right\"> <div ng-click=\"openTicket(supportModel.subjectType,supportModel.issue)\" class=\"primary_btn\"> <div style=\"font-size:12px\" class=\"txt-dktp\">send</div> </div> </div> </div> </div> <div class=\"hlp-faq-footer\"> <div class=\"mail-cmpny-wrp\"><span style=\"font-size:12px;padding-right:5px\" class=\"txt\">You can also email us directly at</span><a href=\"mailto:help.rubric@jigsawacademy.com\" style=\"font-size:14px;padding-right:5px\" class=\"mail-id\">help.rubric@jigsawacademy.com</a><span style=\"font-size:12px;padding-right:5px\" class=\"txt\">or call us at</span><span style=\"font-weight:bold;font-size:14px;padding-right:5px\" class=\"txt\">080-39513961</span><span style=\"font-size:12px;padding-right:5px\" class=\"txt\">between 10:30 AM and 6:00 PM on all working days.</span></div> </div> <div class=\"hlp-suprt-mob-btn hide-in-tablet-up\"> <div ng-click=\"openTicket()\" class=\"btn\"> <div class=\"icon icon-send\"></div> <div class=\"txt\">Send</div> </div> </div> </div> <div ng-if=\"!toggleTickets\" class=\"support--tickets-page\"> <div class=\"suprt-ticket-hdng clearfix row\"> <div class=\"txt left\">02 Pending Tickets</div> <div ng-click=\"srchFilterToggle()\" class=\"srch-hdr-optins-wrp right remove-focus relative hide-in-mobile\"> <div class=\"optn\">{{srchResultFilterItem}} | {{selectedFilterLength}}</div> <div class=\"icon icon-filter\"></div> <ul ng-if=\"toggleSrchFilter\" class=\"srch-filter-content\"> <li ng-repeat=\"i in srchResultFilter\" ng-if=\"srchResultFilterItem != i\" ng-click=\"srchResultFilterParam($index);$event.stopPropagation()\" class=\"remove-focus\">{{i}}</li> </ul> </div> </div> <div ng-click=\"srchFilterToggle()\" class=\"srch-hdr-optins-wrp remove-focus relative hide-in-tablet-up\"> <div class=\"optn\">{{srchResultFilterItem}} | {{ticketsData.length}}</div> <div class=\"icon icon-filter\"></div> <ul ng-if=\"toggleSrchFilter\" class=\"srch-filter-content\"> <li ng-repeat=\"i in srchResultFilter\" ng-if=\"srchResultFilterItem != i\" ng-click=\"srchResultFilterParam($index);$event.stopPropagation()\" class=\"remove-focus\">{{i}}</li> </ul> </div> <div class=\"suprt-tickets-section\"> <div ng-repeat=\"ticket in ticketsData | filter: {ticketStatus : selectedFilter}\" ng-click=\"openTicket(ticket.ticketNo)\" n=\"\" class=\"suprt-ticket-item\"> <div class=\"suprt-ticket-wrp row\"> <div class=\"suprt-ticket-item-hdng table full-width relative\"> <div ng-if=\"ticket.messageRead\" class=\"ticket-new\"></div> <div class=\"ticket-no table-cell\"><span># {{ticket.ticketNo}}</span><span>{{ticket.ticketTitle}}</span></div> <div ng-if=\"ticket.attachment\" class=\"atachment-icon table-cell\"> <div class=\"icon icon-attach\"></div> </div> <div class=\"ticket-date table-cell\">{{ticket.ticketDate | date:\'dd MMM yyyy\'}}</div> </div> <div class=\"suprt-ticket-det\">{{ticket.ticketIssue}}</div> <div ng-if=\"currentTicket == ticket.ticketNo &amp;&amp; shwTicket\" class=\"suprt-ticket-expnd\"> <div ng-if=\"ticket.attachment\" class=\"suprt-img-wrp\"><img ng-src=\"{{ticket.attachmentImage}}\"></div> <div class=\"suprt-ticket-det\">{{ticket.ticketResponse}}</div> </div> <div class=\"suprt-ticket-status-wrp clearfix\"> <div ng-if=\"!ticket.ticketStatus\" class=\"ticket-open left\">open</div> <div ng-if=\"ticket.ticketStatus\" class=\"ticket-close left\">Resolved</div> <div ng-if=\"currentTicket == ticket.ticketNo &amp;&amp; shwTicket &amp;&amp; ticket.ticketStatus\" class=\"ticket-raise-btn right\"> <div class=\"secondary_btn\">Not satisfied</div> </div> </div> </div> </div> </div> </div> </div>");
$templateCache.put("app/Features/helpPage/template/takeTourPage/takeTourPage.html"," <div class=\"take-tour-wrp\"> <div class=\"row\"> <div class=\"take-tour-btn table\"><span class=\"icon-arrow table-cell\"></span><span class=\"text table-cell\">TAKE A TOUR</span></div> <div class=\"take-tour-tiles-wrp row\"> <div ng-repeat=\"item in takeAtourData\" class=\"take-tour-tile-section\"> <div class=\"take-tour-title-wrp\"> <div class=\"title\">{{item.title}}</div> <div class=\"icon icon-next\"></div> </div> <div class=\"take-tour-tile-info\">{{item.description}}</div> </div> </div> </div> </div>");
$templateCache.put("app/Features/learnerView/template/caseStudyPage/caseStudyPage.html"," <div class=\"quiz-page-wrp row\"> <div class=\"vid-player-mob-hdng-wrp hide-in-tablet-up\"> <div ng-click=\"goToDashboard();$event.stopPropagation();\" class=\"vid-player-mob-hdng-back remove-focus\"><span class=\"icon-back\"></span></div> <div txt-resize=\"\" maxwidth=\"300\" class=\"vid-player-mob-hdng\"><span class=\"vid-play-mob-txt-no\">{{activeModuleData.sequenceId}}.</span><span class=\"vid-play-mob-txt\">{{activeModuleData.metaData.title}}</span></div> </div> <div class=\"quiz-content-wrp\"> <div class=\"quiz-pg-hdng-wrp clearfix\"> <div ng-click=\"goToDashboard()\" class=\"quiz-pg-hdng-back-wrp left\"><span class=\"icon-back\"></span></div> <div ng-if=\"quizPageState == &quot;questionPage&quot;\" class=\"quiz-pg-hdng-title-wrp left\"><span class=\"txt\">{{questionsData.title}}</span> </div> <div ng-click=\"reportIssueFunc();$event.stopPropagation();\" class=\"quiz-pg-hdng-report-wrp right\"><span class=\"icon-reportissue\"></span></div> </div> <div ng-include=\"\" src=\"quizTemplateUrl\" class=\"quiz-content-section\"></div> <div ng-if=\"quizPageState == &quot;launchPage&quot;\" class=\"quiz-footer-section\"> <div class=\"quiz-footer-wrp clearfix hide-in-mobile\"> <div ng-click=\"playPrevItem()\" class=\"quiz-foot-back-wrp left\"> <div class=\"icon icon-back\"></div> <div class=\"txt\">plaY pREVIOUS</div> </div> <div ng-hide=\"totalItems === currentSequenceId\" ng-click=\"playNextItem()\" class=\"quiz-foot-back-wrp right\"> <div class=\"txt\">plaY Next</div> <div class=\"icon icon-next\"></div> </div> <div class=\"quiz-foot-start-btn-wrp\"> <div ng-click=\"launchLab()\" class=\"primary_btn\">Start the Practice</div> </div> </div> <div class=\"quiz-footer-wrp-mob-btn\"> <div class=\"prev-next-btn-wrp clearfix\"> <div ng-click=\"playPrevItem()\" class=\"quiz-foot-back-wrp left\"> <div class=\"icon icon-back\"></div> <div class=\"txt\">plaY pREVIOUS</div> </div> <div ng-hide=\"totalItems === currentSequenceId\" ng-click=\"playNextItem()\" class=\"quiz-foot-back-wrp right\"> <div class=\"txt\">plaY next</div> <div class=\"icon icon-next\"></div> </div> </div> <div ng-click=\"launchLabMob()\" class=\"primary_btn\">Start the Practice</div> </div> </div> </div> <div ng-if=\"parentObj.launchLabOverlay\" class=\"case-study-overlay-blur-wrp\"></div> <div ng-if=\"parentObj.launchLabOverlay\" class=\"case-study-overlay-wrp\"> <div class=\"case-study-instrc-wrp\"> <div class=\"title-wrp clearfix\"> <div class=\"title left\">Instructions</div> <div ng-click=\"parentObj.launchLabOverlay = false\" class=\"close-wrp right\"><span class=\"icon-close\"></span></div> </div> <div class=\"txt\">{{questionsData.instructions}}</div> </div> </div> <div ng-if=\"parentObj.launchAnswerOverlay\" class=\"case-study-overlay-blur-wrp\"></div> <div ng-if=\"parentObj.launchAnswerOverlay\" class=\"case-study-overlay-wrp\"> <div class=\"case-study-instrc-wrp\"> <div class=\"title-wrp clearfix\"> <div class=\"title left\">Total Time Spent (Minutes)</div> <div ng-click=\"parentObj.launchAnswerOverlay = false\" class=\"close-wrp right\"><span class=\"icon-close\"></span></div> </div> <div class=\"txt\">{{questionsData.instructions}} <input type=\"number\" min=\"0\" ng-model=\"parentObj.timeSpent\"> <div ng-click=\"displayAnswerSheet()\" class=\"primary_btn\">Submit</div> </div> </div> </div> </div>");
$templateCache.put("app/Features/learnerView/template/quizPage/quizPage.html"," <div class=\"quiz-page-wrp row\"> <div class=\"vid-player-mob-hdng-wrp hide-in-tablet-up\"> <div ng-click=\"goToDashboard();$event.stopPropagation();\" class=\"vid-player-mob-hdng-back remove-focus\"><span class=\"icon-back\"></span></div> <div txt-resize=\"\" maxwidth=\"300\" class=\"vid-player-mob-hdng\"><span class=\"vid-play-mob-txt-no\">{{activeModuleData.sequence_id}}.</span><span class=\"vid-play-mob-txt\">{{activeModuleData.metaData.title}}</span></div> </div> <div class=\"quiz-content-wrp\"> <div class=\"quiz-pg-hdng-wrp clearfix\"> <div ng-click=\"goToDashboard()\" class=\"quiz-pg-hdng-back-wrp left\"><span class=\"icon-back\"></span></div> <div ng-if=\"currentQuestionIndex &gt;= 0\" class=\"quiz-pg-hdng-title-wrp left\"><span class=\"txt\">{{activeModuleData.metaData.title}}</span> </div> <div class=\"quiz-pg-hdng-report-wrp right\"> <div ng-click=\"reportIssueFunc();$event.stopPropagation();\" class=\"qz-title-mob-report-issue-wrp\"><span ng-class=\"{\'active\': shwMobOptions}\" class=\"icon-reportissue\"></span> <div ng-show=\"expandedReportIssue\" ng-init=\"riFullView=false\" class=\"quiz-report-issue-expanded-wrp absolute\"> <div class=\"ri-arrow relative\"> <div class=\"clearfix ri-header-wrp\"> <div class=\"left\">report an issue</div> <div ng-click=\"reportIssueFunc();$event.stopPropagation();\" class=\"right remove-focus\"><span class=\"icon-close\"></span></div> </div> <div ng-hide=\"riFullView\" class=\"ri-options-wrp\"> <div ng-click=\"showRIssuesExpanded(&quot;content&quot;);$event.stopPropagation();\" class=\"clearfix ri-options remove-focus\"> <div class=\"left\">Content problem</div> <div class=\"right\"><span class=\"icon-next\"></span></div> </div> <div ng-click=\"showRIssuesExpanded(&quot;tech&quot;);$event.stopPropagation();\" class=\"clearfix ri-options remove-focus\"> <div class=\"left\">Tech problem</div> <div class=\"right\"><span class=\"icon-next\"></span></div> </div> </div> <div ng-show=\"riFullView\" class=\"ri-options-full-view-wrp\"> <div ng-click=\"riFullView=false;$event.stopPropagation();\" class=\"ri-full-view-header\"><span class=\"icon-back\"></span><span>{{problemSelected}} problem</span></div> <div ng-repeat=\"issue in selectedIssue\" class=\"ri-full-view-issues\"> <input type=\"radio\" id=\"opt{{$index}}\" ng-model=\"selectedIssue.issueName\" value=\"{{issue.type}}\" checked=\"selectedIssue.issueName === issue.type\" name=\"issueName\"> <label for=\"opt{{$index}}\" class=\"remove-focus\"></label><span>{{issue.type}}</span> </div> <div class=\"ri-send-button-wrp\"><span ng-click=\"sendRIssue();$event.stopPropagation();\" class=\"primary_btn remove-focus\">send</span></div> </div> </div> </div> </div> </div> </div> <div ng-include=\"\" src=\"quizTemplateUrl\" ng-class=\"{\'cnt-heit\': quizPageState == \'endQuiz\' }\" class=\"quiz-content-section\"></div> <div ng-if=\"quizPageState == &quot;launchPage&quot;\" class=\"quiz-footer-section\"> <div class=\"quiz-footer-wrp clearfix hide-in-mobile\"> <div ng-click=\"playPrevItem()\" class=\"quiz-foot-back-wrp left\"> <div class=\"icon icon-back\"></div> <div class=\"txt\">plaY pREVIOUS</div> </div> <div ng-hide=\"totalItems === currentSequenceId\" ng-click=\"playNextItem()\" class=\"quiz-foot-back-wrp right\"> <div class=\"txt\">plaY Next</div> <div class=\"icon icon-next\"></div> </div> <div class=\"quiz-foot-start-btn-wrp\"> <div ng-click=\"startQuiz()\" ng-if=\"!error &amp;&amp; !quizAttempted\" class=\"primary_btn\">Start the Quiz</div> </div> </div> <div class=\"quiz-footer-wrp-mob-btn\"> <div class=\"prev-next-btn-wrp clearfix\"> <div ng-click=\"playPrevItem()\" class=\"quiz-foot-back-wrp left\"> <div class=\"icon icon-back\"></div> <div class=\"txt\">plaY pREVIOUS</div> </div> <div ng-hide=\"totalItems === currentSequenceId\" ng-click=\"playNextItem()\" class=\"quiz-foot-back-wrp right\"> <div class=\"txt\">plaY next</div> <div class=\"icon icon-next\"></div> </div> </div> <div ng-click=\"startQuiz()\" ng-if=\"!error\" class=\"primary_btn\">Start the Quiz</div> </div> </div> <div ng-if=\"quizPageState == &quot;endQuiz&quot;\" class=\"quiz-footer-section end-footer\"> <div class=\"quiz-footer-wrp clearfix hide-in-mobile end-footer\"> <div ng-hide=\"totalItems === currentSequenceId\" ng-click=\"playNextItem()\" class=\"quiz-foot-back-wrp left\"> <div class=\"txt\">plaY next</div> <div class=\"icon icon-next\"></div> </div> </div> <div class=\"quiz-footer-wrp-mob-btn\"> <div class=\"primary_btn\">Play Next</div> </div> </div> </div> </div>");
$templateCache.put("app/Features/learnerView/template/resourceLinkPage/resourceLinkPage.html"," <div class=\"quiz-page-wrp row\"> <div class=\"vid-player-mob-hdng-wrp hide-in-tablet-up\"> <div ng-click=\"goToDashboard();$event.stopPropagation();\" class=\"vid-player-mob-hdng-back remove-focus\"><span class=\"icon-back\"></span></div> <div txt-resize=\"txt-resize\" maxwidth=\"300\" class=\"vid-player-mob-hdng\"><span class=\"vid-play-mob-txt-no\">{{activeModuleData.sequenceId}}.</span><span class=\"vid-play-mob-txt\">{{activeModuleData.metaData.title}}</span></div> </div> <div class=\"quiz-content-wrp\"> <div class=\"quiz-pg-hdng-wrp clearfix\"> <div ng-click=\"goToDashboard()\" class=\"quiz-pg-hdng-back-wrp left\"><span class=\"icon-back\"></span></div> <div class=\"quiz-pg-hdng-title-wrp left\"><span class=\"txt\">Reference Links</span></div> <div class=\"quiz-pg-hdng-report-wrp right\"> <div ng-click=\"reportIssueFunc();$event.stopPropagation();\" class=\"qz-title-mob-report-issue-wrp\"><span ng-class=\"{\'active\': shwMobOptions}\" class=\"icon-reportissue\"></span></div> </div> </div> <div class=\"resources-page-wrp\"> <div ng-repeat=\"resource in resourcesData track by $index\" class=\"resorces-wrp\"> <div class=\"clearfix\"> <div class=\"left number-wrp\">{{$index+1}}.</div> <div class=\"left details-wrp\"><span ng-bind-html=\"resource.title | trustAsHtml\" ng-click=\"openLink(resource.url)\" class=\"resource-name\">{{resource.title}}</span><span ng-bind-html=\"resource.source | trustAsHtml\" class=\"resouce-source\">{{resource.source}}</span>     </div> </div> </div> </div> <div class=\"quiz-footer-section resource-footer\"> <div class=\"quiz-footer-wrp clearfix\"> <div ng-click=\"playPrevItem()\" class=\"quiz-foot-back-wrp left\"> <div class=\"icon icon-back\"></div> <div class=\"txt\">plaY pREVIOUS</div> </div> <div ng-hide=\"totalItems === currentSequenceId\" ng-click=\"playNextItem()\" class=\"quiz-foot-back-wrp right\"> <div class=\"txt\">plaY Next</div> <div class=\"icon icon-next\"></div> </div> </div> </div> </div> </div>");
$templateCache.put("app/Features/learnerView/template/videoPlayerPage/videoPlayer.html"," <div ng-show=\"!showTrimScreen\" ng-intro-options=\"videoIntroOptions\" ng-intro-method=\"CallMe\" ng-hints-method=\"startHint\" ng-intro-oncomplete=\"CompletedEvent\" ng-intro-onexit=\"ExitEvent\" ng-intro-onchange=\"ChangeEvent\" ng-intro-onbeforechange=\"BeforeChangeEvent\" ng-intro-onafterchange=\"AfterChangeEvent\" ng-intro-autostart=\"ShouldAutoStart\" class=\"vid-player-page-wrp relative\"> <div class=\"vid-player-mob-hdng-wrp hide-in-tablet-up\"> <div ng-click=\"goToDashboard();$event.stopPropagation();\" class=\"vid-player-mob-hdng-back remove-focus\"><span class=\"icon-back\"></span></div> <div txt-resize=\"txt-resize\" maxwidth=\"300\" class=\"vid-player-mob-hdng\"><span class=\"vid-play-mob-txt-no\">{{activeModuleData.sequenceId | twoDigit}}.</span><span class=\"vid-play-mob-txt\">{{activeModuleData.metaData.title}}</span></div> </div> <div class=\"vid-player-section row\"> <div class=\"vid-player-wrp large-12 columns\"> <div class=\"video-player-container\"> <div style=\"height:5%;position:relative\" ng-click=\"goToDashboard();$event.stopPropagation();\" class=\"vid-player-mob-hdng-back remove-focus\"><span class=\"icon-back\"></span></div> <div style=\"color:white;padding-bottom:10px\">{{activeModuleData.sequenceId | twoDigit}} {{activeModuleData.metaData.title}}</div> <div class=\"vid-player-screenshot\"> <div ng-click=\"reportIssueFunc();$event.stopPropagation();\" class=\"vid-player-default-opt-item relative hide-in-mobile remove-focus\"><span ng-class=\"{\'active\': shwMobOptions}\" class=\"icon-reportissue\"></span> <div ng-show=\"expandedReportIssue\" ng-init=\"riFullView=false\" class=\"vid-report-issue-expanded-wrp absolute\"> <div class=\"ri-vid-arrow relative\"> <div class=\"clearfix ri-header-wrp\"> <div class=\"left\">report an issue</div> <div ng-click=\"reportIssueFunc();$event.stopPropagation();\" class=\"right remove-focus\"><span class=\"icon-close\"></span></div> </div> <div ng-hide=\"riFullView\" class=\"ri-options-wrp\"> <div ng-click=\"showRIssuesExpanded(&quot;video&quot;);$event.stopPropagation();\" class=\"clearfix ri-options remove-focus\"> <div class=\"left\">Video problem</div> <div class=\"right\"><span class=\"icon-next\"></span></div> </div> <div ng-click=\"showRIssuesExpanded(&quot;sound&quot;);$event.stopPropagation();\" class=\"clearfix ri-options remove-focus\"> <div class=\"left\">Sound problem</div> <div class=\"right\"><span class=\"icon-next\"></span></div> </div> <div ng-click=\"showRIssuesExpanded(&quot;transcript&quot;);$event.stopPropagation();\" class=\"clearfix ri-options remove-focus\"> <div class=\"left\">Transcript problem</div> <div class=\"right\"><span class=\"icon-next\"></span></div> </div> <div ng-click=\"showRIssuesExpanded(&quot;labelling&quot;);$event.stopPropagation();\" class=\"clearfix ri-options remove-focus\"> <div class=\"left\">Labelling problem</div> <div class=\"right\"><span class=\"icon-next\"></span></div> </div> <div ng-click=\"showRIssuesExpanded(&quot;buffering&quot;);$event.stopPropagation();\" class=\"clearfix ri-options remove-focus\"> <div class=\"left\">Buffering or Connection problem</div> <div class=\"right\"><span class=\"icon-next\"></span></div> </div> </div> <div ng-show=\"riFullView\" class=\"ri-options-full-view-wrp\"> <div ng-click=\"resetRadioModel();$event.stopPropagation();\" class=\"ri-full-view-header\"><span class=\"icon-back\"></span><span>{{problemSelected}} problem</span></div> <div ng-repeat=\"issue in selectedIssue\" class=\"ri-full-view-issues\"> <input type=\"radio\" id=\"issue{{issue.type}}\" ng-model=\"selectedIssue.issueName\" value=\"{{issue.type}}\" checked=\"selectedIssue.issueName === issue.type\"> <label for=\"issue{{issue.type}}\" class=\"remove-focus\"></label><span>{{issue.type}}</span> </div> <div class=\"ri-send-button-wrp\"><span ng-click=\"sendRIssue();$event.stopPropagation();\" class=\"primary_btn remove-focus\">send</span></div> </div> </div> </div> </div> </div> <div id=\"video-container\" style=\"height:95%;position:relative\" class=\"video-container\"></div> </div> </div> </div> <div class=\"vid-trscript-dummy-hdng-wrp row\"> </div> <div ng-class=\"{\'animate-fadeIn\': overlay}\" class=\"vid-trscript-options\"></div> <div ng-if=\"!noTranscript\" class=\"vid-trscript-opt-wrp\"> <div class=\"vid-trscript-options-hdng\"><span>Interactive Transcript</span><span style=\"margin-left:5px\" data-hint=\"Follow the video content with interactive transcripts.\" data-hintposition=\"middle\"></span></div> <text-size-slider min=\"12\" max=\"18\" unit=\"px\" value=\"14\" step=\"2\"></text-size-slider> <div ng-init=\"highlightActive = false;downloadActive = false;checkCodeSnippet()\" class=\"vid-higlighter-download-wrp\"> <div ng-if=\"codeSnippet == true\" ng-click=\"downloadCodeSnippet()\" class=\"vid-download-wrp remove-focus cm-clickable-btn active-state-buttons\"> <div class=\"table-cell cm-btn-inner-wrap\"><span class=\"icon-download icons-active-state\"></span></div> </div> </div> </div> <div id=\"vpstep2\" class=\"below-player-section relative\"> <div ng-class=\"{\'animate-fadeIn\': overlay,\'animate-fadeOut\': !overlay &amp;&amp; isClipboardIconClicked}\" class=\"absolute below-player-section-blur\"></div> <div id=\"scroll\" class=\"vid-trscript-section row scroll-bar clearfix\"> <div id=\"transcriptContainer\" class=\"vid-trscript-txt-section large-12 columns\"> <div ng-if=\"noTranscript\" style=\"text-align: center;\" class=\"golMal\"><br><br><br><br><br> <svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 550.359 57.141\" style=\"width: 70%\"> <defs> <style>.cls-1{fill:#96999c;}</style> </defs> <path d=\"M10.1.954V2.862h-4v10.7H3.979V2.862H0V.954Z\" class=\"cls-1\"></path> <path d=\"M20.109,7.6v5.96H18.038V8.174a2.134,2.134,0,0,0-2.3-2.322A2.736,2.736,0,0,0,13,8.84v4.718h-2.07V.2H13V5.852a3.625,3.625,0,0,1,3.547-1.944A3.346,3.346,0,0,1,20.109,7.6Z\" class=\"cls-1\"></path> <path d=\"M31.3,9.561H24.066a2.916,2.916,0,0,0,2.971,2.395,3.726,3.726,0,0,0,2.7-1.116l1.1,1.17a5.212,5.212,0,0,1-3.961,1.621,4.607,4.607,0,0,1-4.9-4.844,4.65,4.65,0,0,1,4.843-4.879C30.188,3.907,31.557,6.1,31.3,9.561ZM29.5,8.048a2.459,2.459,0,0,0-2.665-2.484A2.714,2.714,0,0,0,24.03,8.048Z\" class=\"cls-1\"></path> <path d=\"M44.282,12.945a4.6,4.6,0,0,1-2.359.7,2.524,2.524,0,0,1-2.683-2.791V5.888H37.89V4.339H39.24V1.71h2.052V4.339H44.12V5.888H41.292v4.591c0,.99.378,1.3,1.026,1.3a3.35,3.35,0,0,0,1.44-.414Z\" class=\"cls-1\"></path> <path d=\"M51.572,3.907v1.98a2.9,2.9,0,0,0-3.313,2.664v5.006H46.188V3.979h2.071V5.888A3.481,3.481,0,0,1,51.572,3.907Z\" class=\"cls-1\"></path> <path d=\"M58.646,13.558v-1.17a3.887,3.887,0,0,1-3.169,1.26c-2.071,0-3.367-1.278-3.367-2.971,0-1.746,1.314-2.863,3.619-2.881h2.9V7.508c0-1.206-.774-1.927-2.287-1.927a5.048,5.048,0,0,0-2.827.973l-.846-1.44a7.017,7.017,0,0,1,4.123-1.206c2.467,0,3.854,1.26,3.872,3.366l.018,6.284Zm-.018-3.367V9.309H56.035c-1.351,0-1.981.36-1.981,1.278,0,.864.7,1.422,1.854,1.422C57.385,12.009,58.52,11.235,58.628,10.19Z\" class=\"cls-1\"></path> <path d=\"M72.615,7.6v5.96H70.544V8.174a2.134,2.134,0,0,0-2.3-2.322,2.682,2.682,0,0,0-2.719,2.61v5.1H63.45V3.979h2.071V5.815a3.617,3.617,0,0,1,3.529-1.908A3.346,3.346,0,0,1,72.615,7.6Z\" class=\"cls-1\"></path> <path d=\"M78.085,5.545c-.811,0-1.4.271-1.4.954,0,1.765,5.1.811,5.078,4.286,0,1.962-1.747,2.845-3.673,2.845A5.926,5.926,0,0,1,74.231,12.3l.738-1.476a5.224,5.224,0,0,0,3.205,1.188c.882,0,1.566-.306,1.566-1.026,0-1.962-5.042-.864-5.023-4.321,0-1.944,1.692-2.772,3.529-2.772a6.053,6.053,0,0,1,3.349.973l-.756,1.53A5.627,5.627,0,0,0,78.085,5.545Z\" class=\"cls-1\"></path> <path d=\"M87.859,5.726a2.832,2.832,0,0,0-2.845,3.061,2.832,2.832,0,0,0,2.845,3.061,3.569,3.569,0,0,0,2.827-1.152l1.152,1.152a4.872,4.872,0,0,1-4.069,1.783,4.608,4.608,0,0,1-4.825-4.844,4.626,4.626,0,0,1,4.825-4.879A5.053,5.053,0,0,1,91.73,5.474L90.6,6.806A3.616,3.616,0,0,0,87.859,5.726Z\" class=\"cls-1\"></path> <path d=\"M99.379,3.907v1.98a2.9,2.9,0,0,0-3.313,2.664v5.006H94V3.979h2.071V5.888A3.481,3.481,0,0,1,99.379,3.907Z\" class=\"cls-1\"></path> <path d=\"M103.32,1.242a1.206,1.206,0,1,1-2.413,0,1.207,1.207,0,1,1,2.413,0Zm-.18,2.736v9.579h-2.053V3.979Z\" class=\"cls-1\"></path> <path d=\"M116.282,8.8c0,2.863-1.8,4.826-4.537,4.826A3.764,3.764,0,0,1,108.36,11.9v5.149h-2.07V3.979h2.07V5.636a3.741,3.741,0,0,1,3.349-1.729C114.428,3.907,116.282,5.888,116.282,8.8Zm-2.088-.071a2.922,2.922,0,1,0-5.834,0,2.924,2.924,0,1,0,5.834,0Z\" class=\"cls-1\"></path> <path d=\"M123.859,12.945a4.6,4.6,0,0,1-2.359.7,2.524,2.524,0,0,1-2.683-2.791V5.888h-1.351V4.339h1.351V1.71h2.052V4.339H123.7V5.888H120.87v4.591c0,.99.378,1.3,1.026,1.3a3.35,3.35,0,0,0,1.44-.414Z\" class=\"cls-1\"></path> <path d=\"M133.614,3.2V4.339h2.5V5.888h-2.5v7.67h-2.052V5.888H130.3V4.339h1.261V3.4A3.14,3.14,0,0,1,134.856.107a3.656,3.656,0,0,1,2.161.666l-.792,1.585a2.315,2.315,0,0,0-1.314-.45A1.2,1.2,0,0,0,133.614,3.2Z\" class=\"cls-1\"></path> <path d=\"M146.252,8.75a5,5,0,0,1-9.993,0,5,5,0,0,1,9.993,0Zm-7.922.036a2.932,2.932,0,1,0,5.852,0,2.932,2.932,0,1,0-5.852,0Z\" class=\"cls-1\"></path> <path d=\"M153.793,3.907v1.98a2.9,2.9,0,0,0-3.313,2.664v5.006h-2.071V3.979h2.071V5.888A3.482,3.482,0,0,1,153.793,3.907Z\" class=\"cls-1\"></path> <path d=\"M166.321,12.945a4.6,4.6,0,0,1-2.359.7,2.524,2.524,0,0,1-2.683-2.791V5.888h-1.351V4.339h1.351V1.71h2.052V4.339h2.827V5.888h-2.827v4.591c0,.99.378,1.3,1.026,1.3a3.35,3.35,0,0,0,1.44-.414Z\" class=\"cls-1\"></path> <path d=\"M177.5,7.6v5.96h-2.071V8.174a2.134,2.134,0,0,0-2.3-2.322,2.736,2.736,0,0,0-2.737,2.988v4.718h-2.07V.2h2.07V5.852a3.625,3.625,0,0,1,3.547-1.944A3.346,3.346,0,0,1,177.5,7.6Z\" class=\"cls-1\"></path> <path d=\"M182.5,1.242a1.206,1.206,0,1,1-2.413,0,1.207,1.207,0,1,1,2.413,0Zm-.18,2.736v9.579h-2.053V3.979Z\" class=\"cls-1\"></path> <path d=\"M188.082,5.545c-.811,0-1.4.271-1.4.954,0,1.765,5.1.811,5.078,4.286,0,1.962-1.747,2.845-3.673,2.845a5.926,5.926,0,0,1-3.854-1.333l.738-1.476a5.224,5.224,0,0,0,3.205,1.188c.882,0,1.566-.306,1.566-1.026,0-1.962-5.042-.864-5.023-4.321,0-1.944,1.692-2.772,3.529-2.772a6.053,6.053,0,0,1,3.349.973l-.756,1.53A5.627,5.627,0,0,0,188.082,5.545Z\" class=\"cls-1\"></path> <path d=\"M199.889,3.979l2.665,7.545,2.629-7.545h2.071l-3.673,9.579h-2.143l-3.709-9.579Z\" class=\"cls-1\"></path> <path d=\"M210.923,1.242a1.206,1.206,0,1,1-2.413,0,1.207,1.207,0,1,1,2.413,0Zm-.18,2.736v9.579H208.69V3.979Z\" class=\"cls-1\"></path> <path d=\"M222.931.2v13.36h-2.07V11.919a3.714,3.714,0,0,1-3.367,1.729c-2.755,0-4.592-2-4.592-4.915,0-2.881,1.855-4.844,4.556-4.844a3.788,3.788,0,0,1,3.4,1.747V.2ZM220.861,8.8a2.917,2.917,0,0,0-2.936-3.15,2.951,2.951,0,0,0-2.953,3.15,2.949,2.949,0,1,0,5.889,0Z\" class=\"cls-1\"></path> <path d=\"M234.505,9.561h-7.238a2.916,2.916,0,0,0,2.971,2.395,3.729,3.729,0,0,0,2.7-1.116l1.1,1.17a5.211,5.211,0,0,1-3.961,1.621,4.607,4.607,0,0,1-4.9-4.844,4.65,4.65,0,0,1,4.843-4.879C233.388,3.907,234.757,6.1,234.505,9.561Zm-1.8-1.513a2.46,2.46,0,0,0-2.665-2.484,2.714,2.714,0,0,0-2.81,2.484Z\" class=\"cls-1\"></path> <path d=\"M245.755,8.75a5,5,0,0,1-9.993,0,5,5,0,0,1,9.993,0Zm-7.923.036a2.932,2.932,0,1,0,5.853,0,2.932,2.932,0,1,0-5.853,0Z\" class=\"cls-1\"></path> <path d=\"M255.544,1.242a1.206,1.206,0,1,1-2.412,0,1.207,1.207,0,1,1,2.412,0Zm-.18,2.736v9.579h-2.053V3.979Z\" class=\"cls-1\"></path> <path d=\"M261.125,5.545c-.811,0-1.4.271-1.4.954,0,1.765,5.1.811,5.078,4.286,0,1.962-1.747,2.845-3.674,2.845a5.928,5.928,0,0,1-3.854-1.333l.738-1.476a5.227,5.227,0,0,0,3.205,1.188c.883,0,1.566-.306,1.566-1.026,0-1.962-5.041-.864-5.023-4.321,0-1.944,1.693-2.772,3.529-2.772a6.056,6.056,0,0,1,3.35.973l-.757,1.53A5.629,5.629,0,0,0,261.125,5.545Z\" class=\"cls-1\"></path> <path d=\"M281.449,7.6v5.96h-2.07V8.174a2.134,2.134,0,0,0-2.3-2.322,2.682,2.682,0,0,0-2.719,2.61v5.1h-2.071V3.979h2.071V5.815a3.616,3.616,0,0,1,3.528-1.908A3.346,3.346,0,0,1,281.449,7.6Z\" class=\"cls-1\"></path> <path d=\"M293.31,8.75a5,5,0,0,1-9.992,0,5,5,0,0,1,9.992,0Zm-7.922.036a2.932,2.932,0,1,0,5.852,0,2.932,2.932,0,1,0-5.852,0Z\" class=\"cls-1\"></path> <path d=\"M300.888,12.945a4.6,4.6,0,0,1-2.359.7,2.524,2.524,0,0,1-2.683-2.791V5.888H294.5V4.339h1.351V1.71H297.9V4.339h2.827V5.888H297.9v4.591c0,.99.378,1.3,1.026,1.3a3.346,3.346,0,0,0,1.439-.414Z\" class=\"cls-1\"></path> <path d=\"M308.842,17.141a3.241,3.241,0,0,1-2.215-.811l.882-1.6a2.028,2.028,0,0,0,1.243.469,1.56,1.56,0,0,0,1.458-1.062l.324-.721-3.961-9.435h2.143l2.863,7.257,2.664-7.257h2.07l-4.357,10.894A3.194,3.194,0,0,1,308.842,17.141Z\" class=\"cls-1\"></path> <path d=\"M325.818,9.561H318.58a2.917,2.917,0,0,0,2.972,2.395,3.723,3.723,0,0,0,2.7-1.116l1.1,1.17a5.213,5.213,0,0,1-3.961,1.621,4.607,4.607,0,0,1-4.9-4.844,4.65,4.65,0,0,1,4.844-4.879C324.7,3.907,326.07,6.1,325.818,9.561Zm-1.8-1.513a2.458,2.458,0,0,0-2.664-2.484,2.713,2.713,0,0,0-2.809,2.484Z\" class=\"cls-1\"></path> <path d=\"M333.4,12.945a4.6,4.6,0,0,1-2.359.7,2.524,2.524,0,0,1-2.683-2.791V5.888H327V4.339h1.351V1.71h2.053V4.339h2.827V5.888h-2.827v4.591c0,.99.378,1.3,1.026,1.3a3.346,3.346,0,0,0,1.439-.414Z\" class=\"cls-1\"></path> <path d=\"M346.446,13.558v-1.17a3.886,3.886,0,0,1-3.169,1.26c-2.07,0-3.367-1.278-3.367-2.971,0-1.746,1.314-2.863,3.619-2.881h2.9V7.508c0-1.206-.773-1.927-2.286-1.927a5.047,5.047,0,0,0-2.827.973l-.846-1.44a7.016,7.016,0,0,1,4.123-1.206c2.467,0,3.854,1.26,3.871,3.366l.018,6.284Zm-.019-3.367V9.309h-2.592c-1.352,0-1.981.36-1.981,1.278,0,.864.7,1.422,1.854,1.422C345.185,12.009,346.32,11.235,346.427,10.19Z\" class=\"cls-1\"></path> <path d=\"M351.611,3.979l2.664,7.545L356.9,3.979h2.07L355.3,13.558h-2.143L349.45,3.979Z\" class=\"cls-1\"></path> <path d=\"M365.885,13.558v-1.17a3.886,3.886,0,0,1-3.169,1.26c-2.07,0-3.367-1.278-3.367-2.971,0-1.746,1.314-2.863,3.619-2.881h2.9V7.508c0-1.206-.774-1.927-2.287-1.927a5.052,5.052,0,0,0-2.827.973l-.846-1.44a7.016,7.016,0,0,1,4.123-1.206c2.467,0,3.854,1.26,3.871,3.366l.018,6.284Zm-.018-3.367V9.309h-2.593c-1.351,0-1.98.36-1.98,1.278,0,.864.7,1.422,1.854,1.422C364.625,12.009,365.759,11.235,365.868,10.19Z\" class=\"cls-1\"></path> <path d=\"M372.922,1.242a1.207,1.207,0,1,1-2.413,0,1.207,1.207,0,1,1,2.413,0Zm-.181,2.736v9.579h-2.053V3.979Z\" class=\"cls-1\"></path> <path d=\"M377.962.2v13.36h-2.07V.2Z\" class=\"cls-1\"></path> <path d=\"M386.855,13.558v-1.17a3.885,3.885,0,0,1-3.169,1.26c-2.07,0-3.366-1.278-3.366-2.971,0-1.746,1.314-2.863,3.619-2.881h2.9V7.508c0-1.206-.774-1.927-2.287-1.927a5.046,5.046,0,0,0-2.826.973l-.847-1.44A7.019,7.019,0,0,1,385,3.907c2.467,0,3.854,1.26,3.871,3.366l.019,6.284Zm-.018-3.367V9.309h-2.593c-1.351,0-1.981.36-1.981,1.278,0,.864.7,1.422,1.855,1.422C385.6,12.009,386.729,11.235,386.837,10.19Z\" class=\"cls-1\"></path> <path d=\"M401.742,8.8c0,2.863-1.8,4.826-4.537,4.826A3.763,3.763,0,0,1,393.82,11.9v1.656h-2.07V.2h2.07V5.636a3.741,3.741,0,0,1,3.35-1.729C399.888,3.907,401.742,5.888,401.742,8.8Zm-2.088-.071a2.922,2.922,0,1,0-5.834,0,2.924,2.924,0,1,0,5.834,0Z\" class=\"cls-1\"></path> <path d=\"M406.06.2v13.36h-2.07V.2Z\" class=\"cls-1\"></path> <path d=\"M417.636,9.561H410.4a2.916,2.916,0,0,0,2.971,2.395,3.729,3.729,0,0,0,2.7-1.116l1.1,1.17a5.211,5.211,0,0,1-3.961,1.621,4.607,4.607,0,0,1-4.9-4.844,4.65,4.65,0,0,1,4.843-4.879C416.519,3.907,417.888,6.1,417.636,9.561Zm-1.8-1.513a2.46,2.46,0,0,0-2.665-2.484,2.714,2.714,0,0,0-2.81,2.484Z\" class=\"cls-1\"></path> <path d=\"M421.359,12.514a1.136,1.136,0,1,1-2.269,0,1.135,1.135,0,1,1,2.269,0Z\" class=\"cls-1\"></path> </svg> </div> <div ng-if=\"downloadActive\" class=\"golMal\">{{videosData[0]}}</div> <div ng-repeat=\"video in videosData\" ng-init=\"parentIndex = $index\" class=\"vid-trscript-para-wrp\"> <div class=\"vid-trscript-dummy-wrp\"> <div ng-class=\"{&quot;vid-para-active&quot;:activeTime &gt;= video.start &amp;&amp; activeTime &lt; video.end}\" class=\"vid-trscript-para-time-wrp\"><span class=\"icon-clock\"></span> <div class=\"vid-trscript-para-time\">{{video.start | transcriptTime}}</div> </div> <div class=\"vid-trscript-para-txt-wrp vid-trscript-para-txt-size\"><span ng-repeat=\"items in video.val\"><span id=\"t-{{items.startTime}}\" data-time=\"{{items.startTime}}\" para-no=\"{{parentIndex}}\" sent-no=\"{{$index}}\" ng-click=\"goToTime(items.startTime)\" ng-class=\"{&quot;vid-text-active &quot;:activeTime &gt;= items.startTime &amp;&amp; activeTime &lt; items.endTime}\" ng-bind-html=\"highlightTextMarkup(items.text)\" ng-mousedown=\"selectionStarted($index, parentIndex)\" dtouch-start=\"touchSelectionStart($index, parentIndex)\" dtouch-end=\"touchSelectionEnd($index, parentIndex,items)\" dtouch-move=\"touchMove()\" class=\"remove-focus\">{{items.text}}</span></span></div> </div> </div> </div> </div> </div> <div ng-show=\"expandedReportIssueMob\" class=\"ri-mob-wrp absolute\"> <div class=\"clearfix close-btn-wrp\"> <div ng-click=\"reportIssueMobFunc();$event.stopPropagation();\" class=\"right remove-focus\"><span class=\"icon-close\"></span></div> </div> <div class=\"relative ri-mob-data-wrp\"> <div class=\"ri-mob-issue-wrp absolute\"> <div class=\"clearfix ri-header-wrp\"> <div class=\"left\">report an issue</div> </div> <div ng-hide=\"riFullView\" class=\"ri-options-wrp\"> <div ng-click=\"showRIssuesExpanded(&quot;video&quot;);$event.stopPropagation();\" class=\"clearfix ri-options remove-focus\"> <div class=\"left\">Video problem</div> <div class=\"right\"><span class=\"icon-next\"></span></div> </div> <div ng-click=\"showRIssuesExpanded(&quot;sound&quot;);$event.stopPropagation();\" class=\"clearfix ri-options remove-focus\"> <div class=\"left\">Sound problem</div> <div class=\"right\"><span class=\"icon-next\"></span></div> </div> <div ng-click=\"showRIssuesExpanded(&quot;transcript&quot;);$event.stopPropagation();\" class=\"clearfix ri-options remove-focus\"> <div class=\"left\">Transcript problem</div> <div class=\"right\"><span class=\"icon-next\"></span></div> </div> <div ng-click=\"showRIssuesExpanded(&quot;labelling&quot;);$event.stopPropagation();\" class=\"clearfix ri-options remove-focus\"> <div class=\"left\">Labelling problem</div> <div class=\"right\"><span class=\"icon-next\"></span></div> </div> <div ng-click=\"showRIssuesExpanded(&quot;buffering&quot;);$event.stopPropagation();\" class=\"clearfix ri-options remove-focus\"> <div class=\"left\">Buffering or Connection problem</div> <div class=\"right\"><span class=\"icon-next\"></span></div> </div> </div> <div ng-show=\"riFullView\" class=\"ri-options-full-view-wrp\"> <div ng-click=\"riFullView=false;$event.stopPropagation();\" class=\"ri-full-view-header\"><span class=\"icon-back\"></span><span>{{problemSelected}} problem</span></div> <div ng-repeat=\"issue in selectedIssue\" class=\"ri-full-view-issues\"> <input type=\"radio\" id=\"opt{{$index}}\" ng-model=\"selectedIssue.issueName\" value=\"{{issue.type}}\" checked=\"selectedIssue.issueName === issue.type\" name=\"issueName\"> <label for=\"opt{{$index}}\" class=\"remove-focus\"></label><span>{{issue.type}}</span> </div> <div class=\"ri-send-button-wrp\"><span ng-click=\"sendRIssue();$event.stopPropagation();\" class=\"primary_btn remove-focus\">send</span></div> </div> </div> </div> </div> </div> <div ng-show=\"showTrimScreen\" class=\"vid-pg-trim-wrp show\"> <div ng-show=\"showMobTrim &amp;&amp; !askExpertMob\" class=\"vid-pg-mob-trim-section\"> <div ng-show=\"!vidTrimSaveMob\" class=\"vid-trim-function\"> <div class=\"vid-trim-pg-top-wrp clearfix\"> <div class=\"vid-trim-mob-hdng\">TRIM</div> <div ng-click=\"mobileTrimNotes()\" class=\"vid-trim-mob-close remove-focus\"><span class=\"icon-close\"></span></div> </div> <div class=\"vid-trim-video-trim-wrp\"> <div class=\"vid-overlay-slider-section-mob table full-width\"> <div ng-click=\"trimRewindMob();$event.stopPropagation();\" class=\"vid-overlay-slider-cntrl-wrp table-cell remove-focus\"><span class=\"icon-back\"></span></div> <div class=\"vid-overlay-slider-img-wrp-mob table-cell\"> <div class=\"trim-bg-img-mob\"><img img-width-thumbnail=\"img-width-thumbnail\" ng-src=\"assets/strip.jpg\" class=\"thumbnails-img\"> <div range-slider=\"range-slider\" min=\"sliderMin\" max=\"sliderMax\" model-max=\"sliderModelMaxMob\" model-min=\"sliderModelMinMob\" disabled=\"sliderDisabled\" on-handle-down=\"sliderHandleGrab()\" on-handle-up=\"sliderHandleRelease()\" class=\"slider-dummy\"></div> <div class=\"slider-left-blurred-mob\"> <div class=\"video-slider-min\"><span>{{sliderModelMinMob | transcriptTime}}</span></div> </div> <div class=\"slider-right-blurred-mob\"> <div class=\"video-slider-max\"><span>{{sliderModelMaxMob | transcriptTime}}</span></div> </div> </div> </div> <div ng-click=\"trimMoveAheadMob();$event.stopPropagation();\" class=\"vid-overlay-slider-cntrl-wrp table-cell remove-focus\"><span class=\"icon-next\"></span></div> </div> </div> <div class=\"vid-trim-transcript-wrp scroll-bar\"> <div class=\"vid-trim-transcript-hdng\">Interactive Transcript</div> <div class=\"vid-trim-transcript-text-wrp\"> <div class=\"vid-trim-trscript-para-wrp\"><span ng-repeat=\"sentence in paragraph\">{{sentence}}</span></div> </div> <div class=\"vid-trim-transcript-btn-wrp\"> <div class=\"tertiary_color\">Clear</div> <div ng-click=\"saveMobileTrim()\" class=\"primary_btn\">Ok</div> </div> </div> </div> <div ng-show=\"vidTrimSaveMob\" class=\"vid-trim-mob-save-section\"> <div class=\"vid-trim-pg-top-wrp clearfix\"> <div class=\"vid-trim-mob-hdng\">Save Video</div> <div ng-click=\"mobileTrimNotes()\" class=\"vid-trim-mob-close remove-focus\"><span class=\"icon-close\"></span></div> </div> <div class=\"vid-trim-mob-save-img-wrp\"> <div class=\"vid-trim-mob-save-img\"><img img-width-thumbnail=\"img-width-thumbnail\" ng-src=\"assets/strip.jpg\"></div><span class=\"icon-play\"></span> </div> <div class=\"vid-trim-mob-time table\"> <div class=\"vid-trim-mob-start table-cell\">{{ sliderModelMinMob | transcriptTime }}</div> <div class=\"vid-trim-mob-end table-cell\">{{ sliderModelMaxMob | transcriptTime }}</div> </div> <div class=\"vid-save-video-edit-wrp-mob\"> <div class=\"show-filter\"> <input type=\"text\" placeholder=\"Take notes\" ng-model=\"takeNoteModel\" ng-change=\"takeNoteChange()\"> </div> </div> <div class=\"vid-trim-save-mob-btns\"> <div ng-click=\"cancelSaveTrimMob()\" class=\"tertiary_color\">Cancel</div> <div ng-click=\"SaveTrimMob()\" class=\"primary_btn\">Save</div> </div> </div> </div> <div ng-show=\"!showMobTrim &amp;&amp; !askExpertMob\" class=\"vid-pg-mob-take-notes-wrp\"> <div class=\"vid-mob-take-notes-title-wrp full-width\"> <div class=\"vid-mob-take-note-pg-title table-cell full-width\"><span class=\"icon-takenotes\"></span><span class=\"text\">Take Notes</span></div> <div ng-click=\"closeTakeNoteMob()\" class=\"vid-mob-take-note-mob-close table-cell remove-focus\"><span class=\"icon-close\"></span></div> </div> <div class=\"vid-take-note-mob-content\"> <div class=\"vid-mob-preload-title-wrp table full-width\"> <div ng-hide=\"editTitleTakeNotesToggle\" contenteditable=\"true\" ng-model=\"takeNoteTitle\" class=\"vid-mob-takenote-title table-cell\">{{ takeNoteTitle }}</div> <div ng-show=\"editTitleTakeNotesToggle\" class=\"vid-mob-takenote-title table-cell\"> <div class=\"input-field-container dark-border\"> <input type=\"text\" ng-model=\"takeNoteTitle\" class=\"edit-title-field\"><span ng-if=\"takeNoteTitle.length&gt;0\" ng-click=\"cleartakeNoteTitle()\" class=\"icon-remove remove-focus\"></span> </div> </div> <div ng-click=\"editTitleTakeNotes()\" class=\"vid-mob-takenote-title-edit table-cell remove-focus\"><span class=\"icon-notes\"></span></div> </div> <div class=\"vid-take-notes-edit-wrp-mob relative\"> <textarea type=\"text\" placeholder=\"Take notes\" ng-model=\"takeNoteModel\" ng-change=\"takeNoteChange()\"></textarea><span ng-if=\"takeNoteModel.length &gt; 0\" ng-click=\"clearTakeNotes()\" class=\"icon-remove absolute remove-focus\"></span> </div> <div class=\"vid-take-note-preload-section\"> <div class=\"vid-player-incl-trsncrpt-wrp table\"> <div class=\"vid-player-incl-trscrpt-chkbox table-cell\"> <input id=\"inclTrscptTakeNotesMob\" type=\"checkbox\" ng-model=\"inclTrscptTakeNotesMob\" checked=\"inclTrscptTakeNotesMob\"> <label for=\"inclTrscptTakeNotesMob\" ng-class=\"{&quot;icon-checkbox_inactive&quot;:!inclTrscptTakeNotesMob,&quot;icon-checkbox_selected&quot;:inclTrscptTakeNotesMob}\" class=\"remove-focus\"></label><span>Include Transcript</span> </div> </div> <div ng-show=\"inclTrscptTakeNotesMob\" class=\"vid-take-note-preload-wrp table\"> <div class=\"vid-take-note-preload-text table-cell\"><span ng-repeat=\"sentence in paragraph\">{{sentence}}</span></div> </div> </div> <div class=\"vid-take-note-save-mob full-width\"> <div ng-click=\"saveNotesMob()\" class=\"primary_btn table-cell\">Save To Clipboard</div> </div> </div> </div> <div ng-show=\"askExpertMob\" ng-class=\"{\'relative\': !askExpertMobSearch}\" class=\"vid-pg-mob-take-notes-wrp\"> <div ng-show=\"askExpertMobSearch\" class=\"vid-mob-take-notes-title-wrp full-width\"> <div class=\"vid-ask-expert-mob-title table-cell\"><span class=\"icon-askanexpert\"></span></div> <div class=\"vid-mob-take-note-pg-title table-cell full-width\">Ask An Expert</div> <div ng-click=\"closeAskExprtMob()\" class=\"vid-mob-take-note-mob-close table-cell remove-focus\"><span class=\"icon-close\"></span></div> </div> <div class=\"vid-mob-preload-title-wrp table full-width\"> <div ng-hide=\"ShwEditAskexprtTitle\" ng-bind=\"titleAskAnExpert\" class=\"vid-mob-takenote-title table-cell\">{{ titleAskAnExpert }}</div> <div ng-show=\"ShwEditAskexprtTitle\" class=\"vid-mob-takenote-title table-cell\"> <div class=\"input-field-container dark-border\"> <input type=\"text\" ng-model=\"titleAskAnExpert\" class=\"edit-title-field\"><span ng-if=\"titleAskAnExpert.length&gt;0\" ng-click=\"clearAskExpertTitleMob()\" class=\"icon-remove remove-focus\"></span> </div> </div> <div ng-click=\"editAskAnexprtTitle()\" class=\"vid-mob-takenote-title-edit table-cell remove-focus\"><span class=\"icon-notes\"></span></div> </div> <div ng-hide=\"showSelectedFAQ\" class=\"vid-ask-exprt-content\"> <div class=\"search-input-ask\"> <div class=\"vid-take-notes-edit-wrp-mob remove-focus table full-width\"> <div ng-hide=\"askExpertMobSearch\" ng-click=\"cancelAskExpertMobSearch()\" class=\"back-btn table-cell remove-focus\"><span class=\"icon-back\"></span></div> <div ng-class=\"{\'full-width\': !askExpertMobSearch}\" class=\"show-filter table-cell\"> <input type=\"text\" placeholder=\"Ask an Expert\" ng-model=\"modelData.askedQuestion\" ng-focus=\"askExpertMobSearchFunc()\"><span ng-if=\"modelData.askedQuestion.length &gt; 0\" ng-click=\"clearAskAnExpert()\" class=\"icon-remove remove-focus\"></span> </div> </div> <div ng-hide=\"askExpertMobSearch\" class=\"vid-blur-overlay absolute\"></div> </div> <div ng-show=\"modelData.askedQuestion.length &gt; 0 &amp;&amp; askingQuestion\" class=\"vid-ask-exprt-suggested-ques\"> <div ng-repeat=\"question in askExpertData.suggestedQuestions | filter:suggestQuestions\" class=\"search-suggestions remove-focus\"> <div class=\"each-suggested-items clearfix\"><span ng-bind-html=\"highlightTextMarkup(question.duplicateQues)\" ng-click=\"selectedQuestion(question)\" class=\"left\">{{question.duplicateQues}}</span><span ng-if=\"question.answered\" class=\"right icon-check\"></span><span ng-if=\"!question.answered\" class=\"right icon-repost\"></span></div> </div> </div> <div class=\"vid-ask-exprt-frq-wrp\"> <div class=\"vid-ask-exprt-frq-title\">Frequently Asked Questions</div> <div class=\"vid-ask-exprt-frq-quest-wrp\"> <div ng-repeat=\"question in askExpertData.frequentlyAskedQuestions\" ng-click=\"selectedFAQ(question)\" class=\"vid-ask-exprt-frq-quest-item table remove-focus full-width\"> <div class=\"vid-ask-exprt-frq-quest table-cell\">{{question.question}}</div> <div class=\"vid-ask-exprt-frq-quest-status table-cell\"><span ng-if=\"question.answered === false\" class=\"icon-repost\"></span><span ng-if=\"question.answered === true\" class=\"icon-check\"></span></div> </div> </div> </div> <div ng-show=\"askExpertMobSearch\" ng-click=\"postQuestion()\" class=\"vid-take-note-save-mob table full-width\">post</div> </div> <div ng-show=\"showSelectedFAQ\" class=\"vid-ask-exprt-content\"> <div class=\"vid-question-answered-wrp\"> <div class=\"vid-question-answered-item\"> <div class=\"vid-question\">Q - {{selectedFQ.question}}</div> <div class=\"vid-answer-wrp table\"> <div class=\"vid-answer-title vid-question table-cell\">Ans </div> <div class=\"vid-ask-expert-answer table-cell\">- {{selectedFQ.answer}}</div> </div> </div> </div> <div class=\"vid-answered-wrp table full-width\"> <div ng-click=\"shwAskExpertMob()\" class=\"secondary_btn cancel-btn remove-focus table-cell\">cancel</div> </div> </div> </div> </div>");
$templateCache.put("app/Features/learnerView/template/youTubePlayerPage/youTubePlayerPage.html"," <div ng-show=\"!showTrimScreen &amp;&amp; isYouTubeVideo\" ng-intro-options=\"youtubeIntroOptions\" ng-intro-method=\"CallMe\" ng-hints-method=\"startHint\" ng-intro-oncomplete=\"CompletedEvent\" ng-intro-onexit=\"ExitEvent\" ng-intro-onchange=\"ChangeEvent\" ng-intro-onbeforechange=\"BeforeChangeEvent\" ng-intro-onafterchange=\"AfterChangeEvent\" ng-intro-autostart=\"ShouldAutoStart\" class=\"vid-player-page-wrp relative\"> <div class=\"vid-player-mob-hdng-wrp hide-in-tablet-up\"> <div ng-click=\"goToPrevState();$event.stopPropagation();\" class=\"vid-player-mob-hdng-back remove-focus\"><span class=\"icon-back\"></span></div> <div txt-resize=\"txt-resize\" maxwidth=\"300\" class=\"vid-player-mob-hdng\"><span class=\"vid-play-mob-txt-no\">{{activeModuleData.sequenceId}}.</span><span class=\"vid-play-mob-txt\">{{activeModuleData.metaData.title}}</span></div> </div> <div class=\"vid-player-section row\"> <div class=\"vid-player-wrp large-12 columns\"> <div class=\"video-player-container\"> <div style=\"height:5%;position:relative\" ng-click=\"goToDashboard();$event.stopPropagation();\" class=\"vid-player-mob-hdng-back remove-focus\"><span class=\"icon-back\"></span></div> <div style=\"color:white;padding-bottom:10px\">{{activeModuleData.sequenceId | twoDigit}} {{activeModuleData.metaData.title}}</div> <div id=\"yt-container\" style=\"height: 95%\"></div> </div> </div> </div> <div id=\"ystep2\" data-hint=\"Follow the video content with interactive transcripts. Download the transcript using the orange download button.\" class=\"below-player-section relative\"> <div ng-class=\"{\'animate-fadeIn\': overlay,\'animate-fadeOut\': !overlay &amp;&amp; isClipboardIconClicked}\" class=\"absolute below-player-section-blur\"></div> <div id=\"scroll\" class=\"vid-trscript-section row scroll-bar clearfix\"> <div id=\"transcriptContainer\" class=\"vid-trscript-txt-section large-12 columns\"> <div style=\"text-align: center;\" class=\"golMal\"><br><br><br> <svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 550.359 57.141\" style=\"width: 70%\"> <defs> <style>.cls-1{fill:#96999c;}</style> </defs> <path d=\"M10.1.954V2.862h-4v10.7H3.979V2.862H0V.954Z\" class=\"cls-1\"></path> <path d=\"M20.109,7.6v5.96H18.038V8.174a2.134,2.134,0,0,0-2.3-2.322A2.736,2.736,0,0,0,13,8.84v4.718h-2.07V.2H13V5.852a3.625,3.625,0,0,1,3.547-1.944A3.346,3.346,0,0,1,20.109,7.6Z\" class=\"cls-1\"></path> <path d=\"M31.3,9.561H24.066a2.916,2.916,0,0,0,2.971,2.395,3.726,3.726,0,0,0,2.7-1.116l1.1,1.17a5.212,5.212,0,0,1-3.961,1.621,4.607,4.607,0,0,1-4.9-4.844,4.65,4.65,0,0,1,4.843-4.879C30.188,3.907,31.557,6.1,31.3,9.561ZM29.5,8.048a2.459,2.459,0,0,0-2.665-2.484A2.714,2.714,0,0,0,24.03,8.048Z\" class=\"cls-1\"></path> <path d=\"M44.282,12.945a4.6,4.6,0,0,1-2.359.7,2.524,2.524,0,0,1-2.683-2.791V5.888H37.89V4.339H39.24V1.71h2.052V4.339H44.12V5.888H41.292v4.591c0,.99.378,1.3,1.026,1.3a3.35,3.35,0,0,0,1.44-.414Z\" class=\"cls-1\"></path> <path d=\"M51.572,3.907v1.98a2.9,2.9,0,0,0-3.313,2.664v5.006H46.188V3.979h2.071V5.888A3.481,3.481,0,0,1,51.572,3.907Z\" class=\"cls-1\"></path> <path d=\"M58.646,13.558v-1.17a3.887,3.887,0,0,1-3.169,1.26c-2.071,0-3.367-1.278-3.367-2.971,0-1.746,1.314-2.863,3.619-2.881h2.9V7.508c0-1.206-.774-1.927-2.287-1.927a5.048,5.048,0,0,0-2.827.973l-.846-1.44a7.017,7.017,0,0,1,4.123-1.206c2.467,0,3.854,1.26,3.872,3.366l.018,6.284Zm-.018-3.367V9.309H56.035c-1.351,0-1.981.36-1.981,1.278,0,.864.7,1.422,1.854,1.422C57.385,12.009,58.52,11.235,58.628,10.19Z\" class=\"cls-1\"></path> <path d=\"M72.615,7.6v5.96H70.544V8.174a2.134,2.134,0,0,0-2.3-2.322,2.682,2.682,0,0,0-2.719,2.61v5.1H63.45V3.979h2.071V5.815a3.617,3.617,0,0,1,3.529-1.908A3.346,3.346,0,0,1,72.615,7.6Z\" class=\"cls-1\"></path> <path d=\"M78.085,5.545c-.811,0-1.4.271-1.4.954,0,1.765,5.1.811,5.078,4.286,0,1.962-1.747,2.845-3.673,2.845A5.926,5.926,0,0,1,74.231,12.3l.738-1.476a5.224,5.224,0,0,0,3.205,1.188c.882,0,1.566-.306,1.566-1.026,0-1.962-5.042-.864-5.023-4.321,0-1.944,1.692-2.772,3.529-2.772a6.053,6.053,0,0,1,3.349.973l-.756,1.53A5.627,5.627,0,0,0,78.085,5.545Z\" class=\"cls-1\"></path> <path d=\"M87.859,5.726a2.832,2.832,0,0,0-2.845,3.061,2.832,2.832,0,0,0,2.845,3.061,3.569,3.569,0,0,0,2.827-1.152l1.152,1.152a4.872,4.872,0,0,1-4.069,1.783,4.608,4.608,0,0,1-4.825-4.844,4.626,4.626,0,0,1,4.825-4.879A5.053,5.053,0,0,1,91.73,5.474L90.6,6.806A3.616,3.616,0,0,0,87.859,5.726Z\" class=\"cls-1\"></path> <path d=\"M99.379,3.907v1.98a2.9,2.9,0,0,0-3.313,2.664v5.006H94V3.979h2.071V5.888A3.481,3.481,0,0,1,99.379,3.907Z\" class=\"cls-1\"></path> <path d=\"M103.32,1.242a1.206,1.206,0,1,1-2.413,0,1.207,1.207,0,1,1,2.413,0Zm-.18,2.736v9.579h-2.053V3.979Z\" class=\"cls-1\"></path> <path d=\"M116.282,8.8c0,2.863-1.8,4.826-4.537,4.826A3.764,3.764,0,0,1,108.36,11.9v5.149h-2.07V3.979h2.07V5.636a3.741,3.741,0,0,1,3.349-1.729C114.428,3.907,116.282,5.888,116.282,8.8Zm-2.088-.071a2.922,2.922,0,1,0-5.834,0,2.924,2.924,0,1,0,5.834,0Z\" class=\"cls-1\"></path> <path d=\"M123.859,12.945a4.6,4.6,0,0,1-2.359.7,2.524,2.524,0,0,1-2.683-2.791V5.888h-1.351V4.339h1.351V1.71h2.052V4.339H123.7V5.888H120.87v4.591c0,.99.378,1.3,1.026,1.3a3.35,3.35,0,0,0,1.44-.414Z\" class=\"cls-1\"></path> <path d=\"M133.614,3.2V4.339h2.5V5.888h-2.5v7.67h-2.052V5.888H130.3V4.339h1.261V3.4A3.14,3.14,0,0,1,134.856.107a3.656,3.656,0,0,1,2.161.666l-.792,1.585a2.315,2.315,0,0,0-1.314-.45A1.2,1.2,0,0,0,133.614,3.2Z\" class=\"cls-1\"></path> <path d=\"M146.252,8.75a5,5,0,0,1-9.993,0,5,5,0,0,1,9.993,0Zm-7.922.036a2.932,2.932,0,1,0,5.852,0,2.932,2.932,0,1,0-5.852,0Z\" class=\"cls-1\"></path> <path d=\"M153.793,3.907v1.98a2.9,2.9,0,0,0-3.313,2.664v5.006h-2.071V3.979h2.071V5.888A3.482,3.482,0,0,1,153.793,3.907Z\" class=\"cls-1\"></path> <path d=\"M166.321,12.945a4.6,4.6,0,0,1-2.359.7,2.524,2.524,0,0,1-2.683-2.791V5.888h-1.351V4.339h1.351V1.71h2.052V4.339h2.827V5.888h-2.827v4.591c0,.99.378,1.3,1.026,1.3a3.35,3.35,0,0,0,1.44-.414Z\" class=\"cls-1\"></path> <path d=\"M177.5,7.6v5.96h-2.071V8.174a2.134,2.134,0,0,0-2.3-2.322,2.736,2.736,0,0,0-2.737,2.988v4.718h-2.07V.2h2.07V5.852a3.625,3.625,0,0,1,3.547-1.944A3.346,3.346,0,0,1,177.5,7.6Z\" class=\"cls-1\"></path> <path d=\"M182.5,1.242a1.206,1.206,0,1,1-2.413,0,1.207,1.207,0,1,1,2.413,0Zm-.18,2.736v9.579h-2.053V3.979Z\" class=\"cls-1\"></path> <path d=\"M188.082,5.545c-.811,0-1.4.271-1.4.954,0,1.765,5.1.811,5.078,4.286,0,1.962-1.747,2.845-3.673,2.845a5.926,5.926,0,0,1-3.854-1.333l.738-1.476a5.224,5.224,0,0,0,3.205,1.188c.882,0,1.566-.306,1.566-1.026,0-1.962-5.042-.864-5.023-4.321,0-1.944,1.692-2.772,3.529-2.772a6.053,6.053,0,0,1,3.349.973l-.756,1.53A5.627,5.627,0,0,0,188.082,5.545Z\" class=\"cls-1\"></path> <path d=\"M199.889,3.979l2.665,7.545,2.629-7.545h2.071l-3.673,9.579h-2.143l-3.709-9.579Z\" class=\"cls-1\"></path> <path d=\"M210.923,1.242a1.206,1.206,0,1,1-2.413,0,1.207,1.207,0,1,1,2.413,0Zm-.18,2.736v9.579H208.69V3.979Z\" class=\"cls-1\"></path> <path d=\"M222.931.2v13.36h-2.07V11.919a3.714,3.714,0,0,1-3.367,1.729c-2.755,0-4.592-2-4.592-4.915,0-2.881,1.855-4.844,4.556-4.844a3.788,3.788,0,0,1,3.4,1.747V.2ZM220.861,8.8a2.917,2.917,0,0,0-2.936-3.15,2.951,2.951,0,0,0-2.953,3.15,2.949,2.949,0,1,0,5.889,0Z\" class=\"cls-1\"></path> <path d=\"M234.505,9.561h-7.238a2.916,2.916,0,0,0,2.971,2.395,3.729,3.729,0,0,0,2.7-1.116l1.1,1.17a5.211,5.211,0,0,1-3.961,1.621,4.607,4.607,0,0,1-4.9-4.844,4.65,4.65,0,0,1,4.843-4.879C233.388,3.907,234.757,6.1,234.505,9.561Zm-1.8-1.513a2.46,2.46,0,0,0-2.665-2.484,2.714,2.714,0,0,0-2.81,2.484Z\" class=\"cls-1\"></path> <path d=\"M245.755,8.75a5,5,0,0,1-9.993,0,5,5,0,0,1,9.993,0Zm-7.923.036a2.932,2.932,0,1,0,5.853,0,2.932,2.932,0,1,0-5.853,0Z\" class=\"cls-1\"></path> <path d=\"M255.544,1.242a1.206,1.206,0,1,1-2.412,0,1.207,1.207,0,1,1,2.412,0Zm-.18,2.736v9.579h-2.053V3.979Z\" class=\"cls-1\"></path> <path d=\"M261.125,5.545c-.811,0-1.4.271-1.4.954,0,1.765,5.1.811,5.078,4.286,0,1.962-1.747,2.845-3.674,2.845a5.928,5.928,0,0,1-3.854-1.333l.738-1.476a5.227,5.227,0,0,0,3.205,1.188c.883,0,1.566-.306,1.566-1.026,0-1.962-5.041-.864-5.023-4.321,0-1.944,1.693-2.772,3.529-2.772a6.056,6.056,0,0,1,3.35.973l-.757,1.53A5.629,5.629,0,0,0,261.125,5.545Z\" class=\"cls-1\"></path> <path d=\"M281.449,7.6v5.96h-2.07V8.174a2.134,2.134,0,0,0-2.3-2.322,2.682,2.682,0,0,0-2.719,2.61v5.1h-2.071V3.979h2.071V5.815a3.616,3.616,0,0,1,3.528-1.908A3.346,3.346,0,0,1,281.449,7.6Z\" class=\"cls-1\"></path> <path d=\"M293.31,8.75a5,5,0,0,1-9.992,0,5,5,0,0,1,9.992,0Zm-7.922.036a2.932,2.932,0,1,0,5.852,0,2.932,2.932,0,1,0-5.852,0Z\" class=\"cls-1\"></path> <path d=\"M300.888,12.945a4.6,4.6,0,0,1-2.359.7,2.524,2.524,0,0,1-2.683-2.791V5.888H294.5V4.339h1.351V1.71H297.9V4.339h2.827V5.888H297.9v4.591c0,.99.378,1.3,1.026,1.3a3.346,3.346,0,0,0,1.439-.414Z\" class=\"cls-1\"></path> <path d=\"M308.842,17.141a3.241,3.241,0,0,1-2.215-.811l.882-1.6a2.028,2.028,0,0,0,1.243.469,1.56,1.56,0,0,0,1.458-1.062l.324-.721-3.961-9.435h2.143l2.863,7.257,2.664-7.257h2.07l-4.357,10.894A3.194,3.194,0,0,1,308.842,17.141Z\" class=\"cls-1\"></path> <path d=\"M325.818,9.561H318.58a2.917,2.917,0,0,0,2.972,2.395,3.723,3.723,0,0,0,2.7-1.116l1.1,1.17a5.213,5.213,0,0,1-3.961,1.621,4.607,4.607,0,0,1-4.9-4.844,4.65,4.65,0,0,1,4.844-4.879C324.7,3.907,326.07,6.1,325.818,9.561Zm-1.8-1.513a2.458,2.458,0,0,0-2.664-2.484,2.713,2.713,0,0,0-2.809,2.484Z\" class=\"cls-1\"></path> <path d=\"M333.4,12.945a4.6,4.6,0,0,1-2.359.7,2.524,2.524,0,0,1-2.683-2.791V5.888H327V4.339h1.351V1.71h2.053V4.339h2.827V5.888h-2.827v4.591c0,.99.378,1.3,1.026,1.3a3.346,3.346,0,0,0,1.439-.414Z\" class=\"cls-1\"></path> <path d=\"M346.446,13.558v-1.17a3.886,3.886,0,0,1-3.169,1.26c-2.07,0-3.367-1.278-3.367-2.971,0-1.746,1.314-2.863,3.619-2.881h2.9V7.508c0-1.206-.773-1.927-2.286-1.927a5.047,5.047,0,0,0-2.827.973l-.846-1.44a7.016,7.016,0,0,1,4.123-1.206c2.467,0,3.854,1.26,3.871,3.366l.018,6.284Zm-.019-3.367V9.309h-2.592c-1.352,0-1.981.36-1.981,1.278,0,.864.7,1.422,1.854,1.422C345.185,12.009,346.32,11.235,346.427,10.19Z\" class=\"cls-1\"></path> <path d=\"M351.611,3.979l2.664,7.545L356.9,3.979h2.07L355.3,13.558h-2.143L349.45,3.979Z\" class=\"cls-1\"></path> <path d=\"M365.885,13.558v-1.17a3.886,3.886,0,0,1-3.169,1.26c-2.07,0-3.367-1.278-3.367-2.971,0-1.746,1.314-2.863,3.619-2.881h2.9V7.508c0-1.206-.774-1.927-2.287-1.927a5.052,5.052,0,0,0-2.827.973l-.846-1.44a7.016,7.016,0,0,1,4.123-1.206c2.467,0,3.854,1.26,3.871,3.366l.018,6.284Zm-.018-3.367V9.309h-2.593c-1.351,0-1.98.36-1.98,1.278,0,.864.7,1.422,1.854,1.422C364.625,12.009,365.759,11.235,365.868,10.19Z\" class=\"cls-1\"></path> <path d=\"M372.922,1.242a1.207,1.207,0,1,1-2.413,0,1.207,1.207,0,1,1,2.413,0Zm-.181,2.736v9.579h-2.053V3.979Z\" class=\"cls-1\"></path> <path d=\"M377.962.2v13.36h-2.07V.2Z\" class=\"cls-1\"></path> <path d=\"M386.855,13.558v-1.17a3.885,3.885,0,0,1-3.169,1.26c-2.07,0-3.366-1.278-3.366-2.971,0-1.746,1.314-2.863,3.619-2.881h2.9V7.508c0-1.206-.774-1.927-2.287-1.927a5.046,5.046,0,0,0-2.826.973l-.847-1.44A7.019,7.019,0,0,1,385,3.907c2.467,0,3.854,1.26,3.871,3.366l.019,6.284Zm-.018-3.367V9.309h-2.593c-1.351,0-1.981.36-1.981,1.278,0,.864.7,1.422,1.855,1.422C385.6,12.009,386.729,11.235,386.837,10.19Z\" class=\"cls-1\"></path> <path d=\"M401.742,8.8c0,2.863-1.8,4.826-4.537,4.826A3.763,3.763,0,0,1,393.82,11.9v1.656h-2.07V.2h2.07V5.636a3.741,3.741,0,0,1,3.35-1.729C399.888,3.907,401.742,5.888,401.742,8.8Zm-2.088-.071a2.922,2.922,0,1,0-5.834,0,2.924,2.924,0,1,0,5.834,0Z\" class=\"cls-1\"></path> <path d=\"M406.06.2v13.36h-2.07V.2Z\" class=\"cls-1\"></path> <path d=\"M417.636,9.561H410.4a2.916,2.916,0,0,0,2.971,2.395,3.729,3.729,0,0,0,2.7-1.116l1.1,1.17a5.211,5.211,0,0,1-3.961,1.621,4.607,4.607,0,0,1-4.9-4.844,4.65,4.65,0,0,1,4.843-4.879C416.519,3.907,417.888,6.1,417.636,9.561Zm-1.8-1.513a2.46,2.46,0,0,0-2.665-2.484,2.714,2.714,0,0,0-2.81,2.484Z\" class=\"cls-1\"></path> <path d=\"M421.359,12.514a1.136,1.136,0,1,1-2.269,0,1.135,1.135,0,1,1,2.269,0Z\" class=\"cls-1\"></path> </svg> </div> </div> </div> </div> </div> <div ng-show=\"isWebLink\" class=\"quiz-page-wrp row\"> <div class=\"vid-player-mob-hdng-wrp hide-in-tablet-up\"> <div ng-click=\"goToDashboard();$event.stopPropagation();\" class=\"vid-player-mob-hdng-back remove-focus\"><span class=\"icon-back\"></span></div> <div txt-resize=\"txt-resize\" maxwidth=\"300\" class=\"vid-player-mob-hdng\"><span class=\"vid-play-mob-txt-no\">{{activeModuleData.sequenceId}}.</span><span class=\"vid-play-mob-txt\">{{activeModuleData.metaData.title}}</span></div> </div> <div class=\"quiz-content-wrp\"> <div class=\"quiz-pg-hdng-wrp clearfix\"> <div ng-click=\"goToDashboard()\" class=\"quiz-pg-hdng-back-wrp left\"><span class=\"icon-back\"></span></div> <div class=\"quiz-pg-hdng-title-wrp left\"> <div>Web Tutorials</div> </div> <div class=\"quiz-pg-hdng-report-wrp right\"> <div ng-click=\"reportIssueFunc();$event.stopPropagation();\" class=\"qz-title-mob-report-issue-wrp\"><span ng-class=\"{\'active\': shwMobOptions}\" class=\"icon-reportissue\"></span></div> </div> </div> <div class=\"resources-page-wrp\"> <div class=\"resorces-wrp\"> <div class=\"clearfix\"> <div class=\"left number-wrp\">1. &nbsp</div> <div class=\"left details-wrp\"></div><span ng-bind-html=\"activeModuleData.metaData.title | trustAsHtml\" ng-click=\"openLink(webLink)\" class=\"resource-name\"></span> </div> </div> </div> </div> </div> <div class=\"youTube-footer-section resource-footer\"> <div class=\"youTube-footer-wrp clearfix\"> <div ng-hide=\"currentSequenceId === 1\" ng-click=\"playPrevItem()\" class=\"youTube-foot-back-wrp left\"> <div class=\"icon icon-back\"></div> <div class=\"txt\">plaY pREVIOUS</div> </div> <div ng-hide=\"totalItems === currentSequenceId\" ng-click=\"playNextItem()\" class=\"youTube-foot-back-wrp right\"> <div class=\"txt\">plaY Next</div> <div class=\"icon icon-next\"></div> </div> </div> </div>");
$templateCache.put("app/Features/proficiencyTest/template/moduleSummaryPage/moduleSummaryPage.html"," <div class=\"summary-page-wrp\"> <div class=\"summary-module-details-wrp text-center\"> <div class=\"sy-module-name\"><span>{{summaryData.moduleName}}</span></div> <div class=\"sy-module-progress\"><span>{{summaryData.progress}}% </span><span class=\"sec-text\">completed</span></div> <div class=\"sy-module-links\"> <div class=\"inline-block sy-video\"><span class=\"icon-video\"></span><span> {{summaryData.duration_completed | minutesHours}}/{{summaryData.duration | minutesHours}} video</span></div> <div class=\"inline-block sy-assignment\"><span class=\"icon-assignment\"></span><span> {{summaryData.assignment_duration_completed | minutesHours}}/{{summaryData.assignment_duration | minutesHours}} assignment</span></div> </div> <div class=\"sy-module-points\"><span class=\"text\">Points earned - </span><span class=\"icon-star\"></span><span class=\"points\"> {{summaryData.total_points_earned}}/{{summaryData.total_points}}</span></div> </div> <div class=\"summary-details-wrp\"> <div class=\"summary-section\"> <div class=\"box-heading\">Important topics to cover</div> <div class=\"summary-wrp\"> <div ng-repeat=\"videos in summaryData.videos_list\" class=\"inner-wrp topics-wrp clearfix full-width\"> <div class=\"left name\"> <span class=\"icon-video\"></span><span>{{videos.video_name}}</span></div> <div class=\"left progress_bar\"> <module-progress-bar progressbardata=\"videos.progress\"></module-progress-bar> </div> <div class=\"right details\"><span>{{videos.duration_completed}}/{{videos.duration}} completed</span></div> </div> </div> </div> <div class=\"summary-section quiz-section\"> <div class=\"box-heading\">QUIZES</div> <div class=\"summary-wrp\"> <div ng-repeat=\"quiz in summaryData.quiz_list\" class=\"inner-wrp clearfix full-width hide-for-small\"> <div class=\"left name\"><span>{{quiz.quiz_name}}</span></div> <div class=\"left progress_bar relative\"> <div class=\"numbers\"><span>{{quiz.correct_answers | twoDigit}}/</span><span class=\"total_ques\">{{quiz.total_questions | twoDigit}}</span></div> <div class=\"bar\"></div> <div ng-style=\"{ \'width\' : quiz.correct_answers / quiz.total_questions *100 + \'%\'}\" class=\"actual-bar absolute\"></div> </div> <div class=\"right details\"> <div class=\"navigation_btn\"><span ng-if=\"quiz.status==&quot;completed&quot; &amp;&amp; quiz.attempts_left!=0\">retake quiz</span><span ng-if=\"quiz.status==&quot;in progress&quot;\">resume</span><span ng-if=\"quiz.status==&quot;not started&quot;\">take quiz</span><span ng-if=\"quiz.attempts_left==0\">see details</span></div> <div class=\"attempts-wrp\"><span>{{quiz.attempts_left}} attempts left</span></div> </div> </div> </div> <div class=\"summary-wrp\"> <div ng-repeat=\"quiz in summaryData.quiz_list\" class=\"inner-wrp full-width show-for-small\"> <div class=\"clearfix\"> <div class=\"left name\"><span>{{quiz.quiz_name}} </span></div> <div class=\"right\"> <div class=\"navigation_btn\"><span ng-if=\"quiz.status==&quot;completed&quot; &amp;&amp; quiz.attempts_left!=0\">retake quiz</span><span ng-if=\"quiz.status==&quot;in progress&quot;\">resume</span><span ng-if=\"quiz.status==&quot;not started&quot;\">take quiz</span><span ng-if=\"quiz.attempts_left==0\">see details</span></div> <div class=\"attempts-wrp\"><span>{{quiz.attempts_left}} attempts left</span></div> </div> </div> <div class=\"clearfix progress-bar-wrp-mob\"> <div class=\"left progress_bar progress-bar-mob relative\"> <div class=\"bar\"></div> <div ng-style=\"{ \'width\' : quiz.correct_answers / quiz.total_questions *100 + \'%\'}\" class=\"actual-bar absolute\"></div> </div> <div class=\"right\"> <div class=\"numbers\"><span>{{quiz.correct_answers | twoDigit}}/</span><span class=\"total_ques\">{{quiz.total_questions | twoDigit}}</span></div> </div> </div> </div> </div> </div> </div> <div class=\"table full-width text-center clip-btn-wrp\"> <div class=\"table-cell\"><span class=\"text\">go to clipboard</span><span class=\"icon-next\"></span></div> </div> </div>");
$templateCache.put("app/Features/progressInfoPage/template/performanceAnalytics/performanceAnalytics.html"," <div ng-controller=\"performanceAnalyticsCtrl\" class=\"performance-analytics-page\"> <div class=\"performance-graph-section\"></div> <div class=\"skills-achieved-section\"></div> <div class=\"mates-usage-section\"></div> <div class=\"tips-section\"> <div class=\"heading\"></div> <ul> <li></li> </ul> </div> </div>");
$templateCache.put("app/Features/learnerView/template/caseStudyPage/template/caseStudyAnswer.html"," <div class=\"case-study-pg-wrp\"> <div class=\"qz-qstn-pg-wrp case-study-qwrp\"> <div class=\"qz-title-section hide-in-tablet-up clearfix\"> <div class=\"qz-title-mob-wrp left\"><span>{{questionsData.title}}</span></div> <div class=\"qz-title-mob-right-wrp right\"> <div class=\"qz-title-mob-report-issue-wrp\"><span class=\"icon-reportissue\"></span></div> </div> </div> <div class=\"qz-qstn-section\"> <div class=\"case-study-dwnload-wrp clearfix\"> <div class=\"case-questions-title left\">All Answers</div>  </div>  <div ng-bind-html=\"questionsData.solutionHtml | trustAsHtml\" class=\"case-qstn-wrp\">{{questionsData.solutionHtml}}</div> </div> <div class=\"quiz-footer-section\"> </div> </div> <div class=\"quiz-footer-section\"> <div class=\"quiz-footer-wrp clearfix hide-in-mobile\"> <div ng-click=\"playPrevItem()\" class=\"quiz-foot-back-wrp left\"> <div class=\"icon icon-back\"></div> <div class=\"txt\">plaY pREVIOUS</div> </div> <div ng-click=\"playNextItem()\" class=\"quiz-foot-back-wrp right\"> <div class=\"txt\">plaY Next</div> <div class=\"icon icon-next\"></div> </div> <div class=\"quiz-foot-start-btn-wrp\"> <div ng-click=\"download(questionsData.solutionUrl)\" class=\"primary_btn\">Download Answer Sheet</div> </div> </div> <div class=\"quiz-footer-wrp-mob-btn\"> <div class=\"prev-next-btn-wrp clearfix\"> <div ng-click=\"playPrevItem()\" class=\"quiz-foot-back-wrp left\"> <div class=\"icon icon-back\"></div> <div class=\"txt\">plaY pREVIOUS</div> </div> <div ng-click=\"playNextItem()\" class=\"quiz-foot-back-wrp right\"> <div class=\"txt\">plaY next</div> <div class=\"icon icon-next\"></div> </div> <div ng-click=\"download(questionsData.solutionUrl)\" class=\"primary_btn\">Download Answer Sheet</div> </div> </div> </div> </div>");
$templateCache.put("app/Features/learnerView/template/caseStudyPage/template/caseStudyQuestion.html"," <div class=\"case-study-pg-wrp\"> <div class=\"qz-qstn-pg-wrp case-study-qwrp\"> <div class=\"qz-title-section hide-in-tablet-up clearfix\"> <div class=\"qz-title-mob-wrp left\"><span>{{questionsData.title}}</span></div> <div class=\"qz-title-mob-right-wrp right\"> <div class=\"qz-title-mob-report-issue-wrp\"><span class=\"icon-reportissue\"></span></div> </div> </div> <div class=\"qz-qstn-section\"> <div class=\"case-study-dwnload-wrp clearfix\"> <div class=\"case-questions-title left\">All Questions</div> <div ng-show=\"questionsData.datasetUrl\" ng-click=\"download(questionsData.datasetUrl)\" class=\"case-study-dwnload-txt right\">Download data Set</div> </div> <div ng-bind-html=\"questionsData.excerciseHtml | trustAsHtml\" class=\"case-qstn-wrp\"> </div> </div> <div class=\"quiz-footer-section\"> <div class=\"quiz-footer-wrp clearfix hide-in-mobile\"> <div class=\"quiz-foot-start-btn-wrp\"> <button ng-click=\"launchDownloadAnswerSheet()\" class=\"primary_btn remove-focus\">Show Answer Sheet</button> <button ng-click=\"download(questionsData.excersieUrl)\" download=\"download()\" class=\"primary_btn remove-focus\">Download Exercise Sheet</button> <button ng-show=\"questionsData.isLabNeeded === &quot;Y&quot;\" ng-click=\"launchJigsawlabs()\" class=\"primary_btn remove-focus\">Launch Jigsaw Lab</button> </div> </div> <div class=\"quiz-footer-wrp-mob-btn\"> <button class=\"primary_btn\">Launch Jigsaw Lab </button> </div> </div> </div> </div>");
$templateCache.put("app/Features/learnerView/template/caseStudyPage/template/caseStudylaunch.html"," <div class=\"quiz_launch_info-section\"> <div class=\"quiz_launch_info-content\"> <div class=\"title\">{{module.metaData.title}}</div> <div class=\"total-questions-wrp\"> <div class=\"txt\">Average Time taken -</div> <div class=\"score\">{{module.metaData.duration | minutesHours}}</div> </div> <div class=\"total-questions-wrp\"><span class=\"txt\">Points to be earned -</span><span class=\"icon-star\"></span><span class=\"txt\">{{module.totalPoints}}</span></div> <div ng-if=\"mobLaunchErr\" class=\"quiz-launch-overlay-blur\"></div> <div ng-if=\"mobLaunchErr\" class=\"quiz-launch-overlay\"> <div ng-click=\"closeErrScrn()\" class=\"close-wrp remove-focus\"> <div class=\"icon icon-close\"></div> </div> <div class=\"close-msg\"><span>Practice test can only be taken only on a Desktop</span></div> </div> </div> <div class=\"quiz-note-wrp\"> <div class=\"title\">Note:</div> <div class=\"note\">{{module.metaData.description}}</div> </div> </div>");
$templateCache.put("app/Features/learnerView/template/quizPage/templates/quiz_end.html"," <div class=\"qz-qstn-pg-wrp\"> <div class=\"qz-qstn-section\"> <div ng-if=\"lowScrMsg\" class=\"qz-end-msg-section\"> <div class=\"qz-end-icon-wrp\"><span class=\"icon-man_studying\"></span></div> <div class=\"qz-end-msg\">Looks like you need more practice</div> </div> <div ng-if=\"!lowScrMsg\" class=\"qz-end-msg-section\"> <div class=\"qz-end-icon-wrp\"><span class=\"icon-askanexpert\"></span></div> <div class=\"qz-end-msg\">Good Job</div> </div> <div class=\"qz-end-score-msg-wrp\"> <div class=\"qz-end-score-msg\"><span>You answered</span><span class=\"bold\">{{crtAnswer}}</span><span>question(s) right out of</span><span class=\"bold\">{{noOfQuestions}}</span></div> <div class=\"qz-end-score-points\"><span>Points to be earned -</span><span class=\"icon-star\"></span><span>{{module.totalPoints}}</span></div> </div> </div> <div class=\"qz-answer-report-wrp\"> <div class=\"qz-answer-report-title\">SUMMARY</div> <div class=\"qz-answer-report-item-wrp\"> <div ng-repeat=\"item in quizReport\" class=\"qz-answer-report-item clearfix\"> <div class=\"index-no left\">{{$index+1}}.</div> <div class=\"answer-status left\"><span ng-class=\"{\'icon-check\': item.answerStatus ==\'true\',\'icon-close answer-wrng\': item.answerStatus ==\'false\'}\"></span><span ng-if=\"item.answerStatus ==&quot;skipped&quot;\" class=\"txt\">skipped</span></div> <div class=\"related-video-wrp left\"> <div class=\"txt\">{{item.relatedVideoTitle}}</div> <div class=\"icon-next\"></div> </div> </div> </div> </div> </div>");
$templateCache.put("app/Features/learnerView/template/quizPage/templates/quiz_launch.html"," <div ng-show=\"!error &amp;&amp; !quizAttempted\" class=\"quiz_launch_info-section\"> <div class=\"quiz_launch_info-content\"> <div class=\"title\">{{module.metaData.title}}</div> <div class=\"total-questions-wrp\"> <div class=\"txt\">Total Questions -</div> <div class=\"score\">{{module.metaData.totalQuestionsToDisplay | twoDigit}}</div> </div> <div class=\"total-questions-wrp\"> <div class=\"txt\">Average Time Taken -</div> <div class=\"score\">{{module.metaData.duration | minutesHours}}</div> </div> <div class=\"total-questions-wrp\"><span class=\"txt\">Points to be earned -</span><span class=\"icon-star\"></span><span class=\"txt\">{{module.totalPoints}}</span></div> </div> <div class=\"quiz-note-wrp\"> <div class=\"title\">Note:</div> <div class=\"note\">{{module.metaData.description}}</div> </div> </div> <div ng-show=\"error\" class=\"quiz_launch_info-section\"> <div class=\"quiz_launch_info-content\"> <div class=\"title\">{{error}}</div> </div> </div> <div ng-show=\"quizAttempted\" style=\"padding-top: 20%;\" class=\"quiz_launch_info-section\"> <div class=\"pt-end-msg\"><span>You have already completed this quiz.</span><br><span>Please proceed to the next item in the playlist.</span></div> </div>");
$templateCache.put("app/Features/learnerView/template/quizPage/templates/quiz_question.html"," <form ng-repeat=\"question in quizQuestionsData\" ng-if=\"$index == currentQuestionIndex\" ng-init=\"questionIndex = currentQuestionIndex; optType = question.type\" name=\"quiz\" ng-submit=\"formSubmitted=true;answerSubmitted(quiz.$valid ,$index);\" novalidate=\"novalidate\" class=\"qz-qstn-pg-wrp\"> <div class=\"qz-title-section hide-in-tablet-up clearfix\"> <div class=\"qz-title-mob-wrp left\"><span>{{quizData.title}}</span></div> <div class=\"qz-title-mob-right-wrp right\"> <div ng-click=\"reportIssueMobFunc();$event.stopPropagation();\" class=\"qz-title-mob-report-issue-wrp remove-focus\"><span class=\"icon-reportissue\"></span></div> </div> </div> <div class=\"qz-qstn-section\"> <div class=\"qz-qstn-no-wrp\">Question- {{$index+1}}/{{module.metaData.totalQuestionsToDisplay}}</div> <div ng-bind-html=\"question.question | trustAsHtml\" class=\"qz-qstn-wrp\">{{question.question}}</div> </div> <div class=\"qz-qstn-answers-section row\"> <div ng-repeat=\"item in question.options\" ng-style=\"setOptionHeight()\" style=\"display: inline-block;vertical-align: top;float: inherit;\" class=\"answer-item-wrp column large-6 medium-6 table\"> <div class=\"answer-item-chk-bx table-cell\"> <input type=\"radio\" id=\"opt{{$index}}\" ng-model=\"question.eachQuestion\" value=\"{{item}}\" name=\"question\" ng-change=\"optionSelected(question.eachQuestion);\" ng-disabled=\"quizReport[questionIndex].answerStatus ===\'true\' || quizReport[questionIndex].answerStatus ===\'false\'\" checked=\"question.eachQuestion === item\" required=\"required\"> <label for=\"opt{{$index}}\" class=\"remove-focus\"></label> </div> <div ng-if=\"question.type ==\'html\'\" class=\"answer-item-answer table-cell\"><span ng-bind-html=\"item | trustAsHtml\">{{item}}</span></div> <div ng-if=\"question.type ==\'text\'\" class=\"answer-item-answer table-cell\"><span>{{item}}</span></div> </div> </div> <div id=\"answerExp\" ng-if=\"quizReport[currentQuestionIndex].answerStatus ===\'true\' || quizReport[currentQuestionIndex].answerStatus ===\'false\'\" class=\"qz-answer-page-section\"> <div class=\"qz-crct-answer-wrp\"> <div ng-if=\"quizReport[currentQuestionIndex].answerStatus === &quot;true&quot;\" class=\"qz-answer-icon\"><span class=\"icon-success\"></span></div> <div ng-if=\"quizReport[currentQuestionIndex].answerStatus === &quot;false&quot;\" class=\"qz-answer-wrng-wrp table\"> <div class=\"icon icon-remove table-cell\"></div> <div class=\"msg table-cell\"><span ng-bind-html=\"quizReport[ currentQuestionIndex ].usrSelectedOption | trustAsHtml\" ng-if=\"question.type == &quot;html&quot;\" class=\"txt\">{{quizReport[ currentQuestionIndex ].usrSelectedOption}}</span><span ng-if=\"question.type == &quot;text&quot;\" class=\"txt\">{{quizReport[ currentQuestionIndex ].usrSelectedOption}}</span><span class=\"err-msg\">is the wrong answer</span></div> </div> <div class=\"qz-answer-dummy\"> <div ng-bind-html=\"quizReport[ currentQuestionIndex ].crctOption | trustAsHtml\" ng-if=\"question.type == &quot;html&quot;\" class=\"qz-answer\">{{quizReport[ currentQuestionIndex ].crctOption}}</div> <div ng-if=\"question.type == &quot;text&quot;\" class=\"qz-answer\">{{quizReport[ currentQuestionIndex ].crctOption}}</div> <div class=\"qz-answer-status\">is the correct answer</div> </div> </div> <div class=\"qz-crct-answer-info-wrp\"> <div class=\"info\">{{question.description}}</div> <div ng-if=\"question.relatedVideoId\" class=\"related-video-info-wrp\"> <div class=\"title\">See Related Video</div> <div class=\"video-info-wrp\"><span class=\"icon-video\"></span><span ng-click=\"loadRelatedVideo(question.relatedVideoId, question.relatedVideoSeqId)\" class=\"link-txt\">{{question.relatedVideoTitle}}</span></div> </div> </div> </div> <div ng-if=\"quizPageState == &quot;questionPage&quot; &amp;&amp; !(quizReport[currentQuestionIndex].answerStatus &amp;&amp; quizReport[currentQuestionIndex].answerStatus !== &quot;skipped&quot;)\" class=\"quiz-footer-section\"> <div class=\"quiz-footer-wrp clearfix hide-in-mobile\"> <div ng-click=\"prevQuestion()\" ng-if=\"currentQuestionIndex &gt; 0\" class=\"quiz-foot-back-wrp left remove-focus\"> <div class=\"icon icon-back\"></div> <div class=\"txt\">back</div> </div> <div ng-click=\"skipQuestion($index)\" ng-if=\"(currentQuestionIndex+1) &lt;= module.metaData.totalQuestionsToDisplay\" class=\"quiz-foot-back-wrp right remove-focus\"> <div class=\"txt\">skip</div> <div class=\"icon icon-next\"></div> </div> <div class=\"quiz-foot-start-btn-wrp\"> <button type=\"submit\" class=\"primary_btn remove-focus\">Submit</button> </div> </div> <div class=\"quiz-footer-wrp-mob-btn\"> <div class=\"prev-next-btn-wrp clearfix\"> <div ng-click=\"prevQuestion()\" ng-if=\"currentQuestionIndex &gt; 0\" class=\"quiz-foot-back-wrp left remove-focus\"> <div class=\"icon icon-back\"></div> <div class=\"txt\">back</div> </div> <div ng-click=\"skipQuestion($index)\" ng-if=\"(currentQuestionIndex+1) &lt;= module.metaData.totalQuestionsToDisplay\" class=\"quiz-foot-back-wrp right remove-focus\"> <div class=\"txt\">Skip</div> <div class=\"icon icon-next\"></div> </div> </div> <button type=\"submit\" class=\"primary_btn\">Submit</button> </div> </div> <div ng-if=\"quizReport[currentQuestionIndex].answerStatus &amp;&amp; quizReport[currentQuestionIndex].answerStatus !== &quot;skipped&quot;\" class=\"quiz-footer-section\"> <div class=\"quiz-footer-wrp clearfix hide-in-mobile\"> <div ng-if=\"currentQuestionIndex &gt; 0\" ng-click=\"prevQuestion()\" class=\"quiz-foot-back-wrp left\"> <div class=\"icon icon-back\"></div> <div class=\"txt\">back</div> </div> <div ng-click=\"goTonextQuestion()\" class=\"quiz-foot-back-wrp right\"> <div class=\"txt\">next</div> <div class=\"icon icon-next\"></div> </div> </div> <div class=\"quiz-footer-wrp-mob-btn\"> <div class=\"prev-next-btn-wrp clearfix submit-state\"> <div class=\"quiz-foot-back-wrp left\"> <div ng-if=\"currentQuestionIndex &gt; 0\" ng-click=\"prevQuestion()\" class=\"icon icon-back\"></div> <div class=\"txt\">back</div> </div> </div> <div ng-click=\"goTonextQuestion()\" class=\"primary_btn\">Next</div> </div> </div> </form> <div ng-show=\"expandedReportIssueMob\" class=\"quiz-report-issue-mob-expanded-wrp absolute\"> <div class=\"clearfix close-btn-wrp\"> <div ng-click=\"reportIssueMobFunc();$event.stopPropagation();\" class=\"right remove-focus\"><span class=\"icon-close\"></span></div> </div> <div class=\"relative ri-mob-data-wrp\"> <div class=\"ri-mob-issue-wrp absolute\"> <div class=\"clearfix ri-header-wrp\"> <div class=\"left\">report an issue</div> </div> <div ng-if=\"!riQuizFullView\" class=\"ri-options-wrp\"> <div ng-click=\"showRIssuesExpandedMob(&quot;content&quot;);$event.stopPropagation();\" class=\"clearfix ri-options remove-focus\"> <div class=\"left\">Content problem</div> <div class=\"right\"><span class=\"icon-next\"></span></div> </div> <div ng-click=\"showRIssuesExpandedMob(&quot;tech&quot;);$event.stopPropagation();\" class=\"clearfix ri-options remove-focus\"> <div class=\"left\">Tech problem</div> <div class=\"right\"><span class=\"icon-next\"></span></div> </div> </div> <div ng-if=\"riQuizFullView\" class=\"ri-options-full-view-wrp\"> <div ng-click=\"goBackToIssuesList();$event.stopPropagation();\" class=\"ri-full-view-header\"><span class=\"icon-back\"></span><span>{{problemSelected}} problem</span></div> <div ng-repeat=\"issue in selectedIssue\" class=\"ri-full-view-issues\"> <input type=\"radio\" id=\"opt{{$index}}\" ng-model=\"selectedIssue.issueName\" value=\"{{issue.type}}\" checked=\"selectedIssue.issueName === issue.type\" name=\"issueName\"> <label for=\"opt{{$index}}\" class=\"remove-focus\"></label><span>{{issue.type}}</span> </div> <div class=\"ri-send-button-wrp\"><span ng-click=\"sendRIssue();$event.stopPropagation();\" class=\"primary_btn remove-focus\">send</span></div> </div> </div> </div> </div>");
$templateCache.put("app/Features/buyerJourney/partials/allocationScreen/partials/allocationForm/allocationForm.html"," <form ng-if=\"bJourneyObj.isHead\" name=\"form\" ng-submit=\"formSubmitted=true;goToSuccess(form.$valid);\" novalidate=\"\" class=\"ballocation-form-wrp\"> <div class=\"bteam-name-wrp relative\"> <div class=\"bteam-name inline-block\"><span>team name - </span></div> <input name=\"teamName\" type=\"text\" ng-model=\"bJourneyObj.inputTeamName\" placeholder=\"type here\" required=\"\" class=\"inline-block\"><span ng-if=\"formSubmitted &amp;&amp; form.teamName.$invalid\" class=\"absolute error-text profile-email-error\">Team name can not be empty</span> </div> <div class=\"bform-details-section\"> <div class=\"bform-details-wrp\"> <div class=\"blicenses-allowed-heading\"><span>No of Licenses to be alloted:</span></div> <div class=\"binput-wrp\"> <div class=\"blicenses-allowed-wrp\"> <input name=\"licenseNumber\" type=\"text\" ng-model=\"bJourneyObj.inputLicenseNumber\" placeholder=\"400\" required=\"\"><span ng-if=\"formSubmitted &amp;&amp; form.licenseNumber.$invalid\" class=\"absolute error-text profile-email-error\">License Number can not be empty</span> </div> </div> <div class=\"binput-fields-wrp team-manager-section\"> <div class=\"team-manager-wrp\"> <ui-select name=\"teamManager\" search-enabled=\"searchEnabled\" ng-model=\"bJourneyObj.inputTeamManger\" ng-change=\"selectedTeamManagerFunc($select.selected)\" ng-disabled=\"disabled\" required=\"\"> <ui-select-match placeholder=\"select manager\">{{$select.selected.managerName}}</ui-select-match> <ui-select-choices repeat=\"tm in bJourneyObj.user.managersList\"><small>{{tm.managerName}}</small></ui-select-choices> </ui-select> </div> </div> <div ng-show=\"mangaerSelected\" class=\"binput-wrp\"> <div class=\"bcorporate-wrp\"> <input name=\"corporateMail\" type=\"text\" ng-model=\"bJourneyObj.inputCorporateMail\" placeholder=\"Corporate Mail ID\" readonly=\"\"><span ng-if=\"formSubmitted &amp;&amp; form.corporateMail.$invalid\" class=\"absolute error-text profile-email-error\">corporate Mail can not be empty</span> </div> </div> <div ng-show=\"mangaerSelected\" class=\"binput-wrp\"> <div class=\"bcontact-number-wrp\"> <input name=\"contactNumber\" type=\"text\" ng-model=\"bJourneyObj.inputContactNumber\" placeholder=\"Contact Number\" required=\"\"><span ng-if=\"formSubmitted &amp;&amp; form.contactNumber.$invalid\" class=\"absolute error-text profile-email-error\">contact Number can not be empty</span> </div> </div> </div> <div class=\"blearning-path-section\"> <div class=\"bwelcome-paths-heading\"><span>Select Learning Paths to allocate to this team:</span></div> <div class=\"bwelcome-paths-option-wrp\"> <div class=\"bwelcome-paths-option bcheckbox-wrp\"> <input type=\"checkbox\" id=\"dataScience\" checked=\"bJourneyObj.dataScience\" ng-model=\"bJourneyObj.dataScience\" ng-change=\"filterItemType(dataScience)\"> <label for=\"dataScience\" ng-class=\"{&quot;icon-checkbox_inactive&quot;:bJourneyObj.dataScience,&quot;icon-checkbox_selected&quot;:!bJourneyObj.dataScience}\"></label><span>Data Science</span> </div> <div class=\"bwelcome-paths-option bcheckbox-wrp\"> <input type=\"checkbox\" id=\"hrAnalytics\" checked=\"bJourneyObj.hrAnalytics\" ng-model=\"bJourneyObj.hrAnalytics\" ng-change=\"filterItemType(hrAnalytics)\"> <label for=\"hrAnalytics\" ng-class=\"{&quot;icon-checkbox_inactive&quot;:bJourneyObj.hrAnalytics,&quot;icon-checkbox_selected&quot;:!bJourneyObj.hrAnalytics}\"></label><span>HR Analytics</span> </div> </div> </div> <div class=\"ballocation-btn-wrp clearfix\"> <button type=\"submit\" class=\"primary_btn right\">Done</button> </div> </div> </form> <form ng-if=\"bJourneyObj.isManager &amp;&amp; !anotherTeam\" name=\"form\" ng-submit=\"formSubmitted=true;goToSuccess(form.$valid);\" novalidate=\"\" class=\"ballocation-form-wrp\"> <div class=\"bform-details-section\"> <div class=\"bform-details-wrp\"> <div class=\"bmanager-input-wrp table full-width\"> <div class=\"blicenses-allowed-heading table-cell\"><span>learning path:</span></div> <div class=\"table-cell binput-fields-wrp\"> <div class=\"blicenses-allowed-wrp\"> <ui-select name=\"learningPath\" search-enabled=\"searchEnabled\" ng-model=\"bJourneyObj.inputLearningPath\" ng-disabled=\"disabled\" required=\"\"> <ui-select-match placeholder=\"select\">{{$select.selected.lpName}}</ui-select-match> <ui-select-choices repeat=\"lp in bJourneyObj.user.learningPaths\"><small>{{lp.lpName}}</small></ui-select-choices> </ui-select><span ng-if=\"formSubmitted &amp;&amp; form.learningPath.$invalid\" class=\"absolute error-text profile-email-error\">Learning path can not be empty</span> </div> </div> </div> <div class=\"bmanager-input-wrp table full-width licenses\"> <div class=\"blicenses-allowed-heading table-cell\"><span>licenses:</span></div> <div class=\"binput-wrp table-cell binput-fields-wrp\"> <div class=\"team-manager-wrp\"> <input name=\"licenses\" type=\"text\" ng-model=\"bJourneyObj.inputLicenses\" placeholder=\"No. of licenses\" required=\"\"><span ng-if=\"formSubmitted &amp;&amp; form.licenses.$invalid\" class=\"absolute error-text profile-email-error\">licenses can not be empty</span> </div> </div> </div> <div class=\"tertiary_color table\"><span class=\"icon-download table-cell\"></span><span class=\"table-cell text\">download learner form</span></div> <div class=\"create-another-btn-wrp\"> <button ng-click=\"anotherTeamFunc()\" class=\"bcreate-another-team-wrp table remove-focus\"> <div class=\"table-cell text\">create another team</div> <div class=\"table-cell icon-next\"></div> </button> </div> </div> <div class=\"ballocation-btn-wrp clearfix\"> <button type=\"submit\" class=\"primary_btn right\">Done</button> <button ng-click=\"goToDashboard()\" class=\"secondary_btn right\">later</button> </div> </div> </form> <form ng-if=\"bJourneyObj.isManager &amp;&amp; anotherTeam\" name=\"form\" ng-submit=\"formSubmitted=true;goToSuccess(form.$valid);\" novalidate=\"\" class=\"ballocation-form-wrp\"> <div class=\"bteam-name-wrp first-team relative clearfix\"> <div class=\"bteam-name left\"><span>learning path - </span><span class=\"bold\">{{bJourneyObj.inputLearningPath.lpName}} | </span><span class=\"bold\">{{bJourneyObj.inputLicenses}}</span></div> <div ng-click=\"anotherTeamFunc()\" class=\"right remove-focus\"><span class=\"icon-expand\"></span></div> </div> <div class=\"bform-details-section second-team\"> <div class=\"bform-details-wrp\"> <div class=\"bmanager-input-wrp table full-width\"> <div class=\"blicenses-allowed-heading table-cell\"><span>learning path:</span></div> <div class=\"table-cell binput-fields-wrp\"> <div class=\"blicenses-allowed-wrp\"> <ui-select name=\"learningPathSecondTeam\" search-enabled=\"searchEnabled\" ng-model=\"bJourneyObj.learningPathSecondTeam\" ng-disabled=\"disabled\" required=\"\"> <ui-select-match placeholder=\"select\">{{$select.selected.lpName}}</ui-select-match> <ui-select-choices repeat=\"lp in bJourneyObj.user.learningPaths\"><small>{{lp.lpName}}</small></ui-select-choices> </ui-select><span ng-if=\"formSubmitted &amp;&amp; form.learningPathSecondTeam.$invalid\" class=\"absolute error-text profile-email-error\">Learning path can not be empty</span> </div> </div> </div> <div class=\"bmanager-input-wrp table full-width licenses\"> <div class=\"blicenses-allowed-heading table-cell\"><span>licenses:</span></div> <div class=\"binput-wrp table-cell binput-fields-wrp\"> <div class=\"team-manager-wrp\"> <input name=\"licensesSecondTeam\" type=\"text\" ng-model=\"bJourneyObj.inputLicensesSecondTeam\" placeholder=\"No. of licenses\" required=\"\"><span ng-if=\"formSubmitted &amp;&amp; form.licensesSecondTeam.$invalid\" class=\"absolute error-text profile-email-error\">licenses can not be empty</span> </div> </div> </div> <div class=\"tertiary_color table\"><span class=\"icon-download table-cell\"></span><span class=\"table-cell text\">download learner form</span></div> </div> <div class=\"ballocation-btn-wrp clearfix\"> <button type=\"submit\" class=\"primary_btn right\">Done</button> <button ng-click=\"goToDashboard()\" class=\"tertiary_color right\">later</button> </div> </div> </form>");
$templateCache.put("app/Features/buyerJourney/partials/allocationScreen/partials/successScreen/successScreen.html"," <div class=\"bsuccess-section\"> <div class=\"bsuccess-wrp relative\"> <div class=\"bsuccess-icon-wrp\"><span class=\"icon-success\"></span></div> <div ng-show=\"bJourneyObj.isHead\" class=\"bsuccess-msg-wrp\"> <div class=\"bsuccess-msg\"><span id=\"license-num\" class=\"bold-text\">{{bJourneyObj.inputLicenseNumber}}</span><span class=\"normal-text\">licenses have been</span></div> <div class=\"bsuccess-msg\"><span class=\"normal-text\">successfully alloted to</span><span id=\"team-name\" class=\"bold-text\">{{bJourneyObj.inputTeamName}}</span></div> </div> <div ng-show=\"bJourneyObj.isManager\" class=\"bsuccess-msg-wrp\"> <div class=\"bsuccess-msg\"><span class=\"normal-text\">You have successfully created your team</span></div> <div class=\"bsuccess-msg\"><span class=\"normal-text\">for {{lpAllocatedNum}} Learning Paths</span></div> </div> <div ng-show=\"bJourneyObj.isManager\" class=\"bsuccess-lp-info-wrp first-team\"> <div class=\"bsuccess-lp-heading inline-block\">Learning Path:</div> <div class=\"bsuccess-lp-name name inline-block\">{{bJourneyObj.inputLearningPath.lpName}} </div> <div class=\"bsuccess-lp-name number inline-block\">{{bJourneyObj.inputLicenses}} Learners</div> </div> <div ng-if=\"bJourneyObj.learningPathSecondTeam != null\" class=\"bsuccess-lp-info-wrp\"> <div class=\"bsuccess-lp-heading inline-block\">Learning Path:</div> <div class=\"bsuccess-lp-name name inline-block\">{{bJourneyObj.learningPathSecondTeam.lpName}} </div> <div class=\"bsuccess-lp-name number inline-block\">{{bJourneyObj.inputLicensesSecondTeam}} Learners</div> </div> <div class=\"bremaining-license-wrp absolute\"><span>{{bJourneyObj.user.totalLicensesRemaining}} Licenses remaining to allocate</span></div> <div ng-click=\"goTOBDash()\" class=\"primary_btn absolute\"><span>done</span></div> <div ng-click=\"goToAllocationPage()\" class=\"ballocate-new-team-wrp table absolute remove-focus\"><span class=\"text table-cell\">allocate new team</span><span class=\"icon-next table-cell\"></span></div> </div> </div>");
$templateCache.put("app/Features/buyerJourney/partials/buyerDashboard/templates/badgeSection/badgeSection.html"," <div class=\"prog-pg-badges-info-section hide-in-mobile\"> <div class=\"prog-pg-badges-title-wrp clearfix\"> <div class=\"title left\">Badges</div> </div> <div class=\"prog-pg-badges-section row\"> <div style=\"width:100%;\" ng-if=\"BData.badgesEarnedByUser.length == 0\" class=\"prog-pg-badges-item-wrp column large-12 remove-focus\"> <div style=\"background-position:center;font-size:15vh\" class=\"no-badge-data\"><span style=\"visibility:hidden;\">No Badges available</span></div> </div> <div ng-if=\"BData.badgesEarnedByUser.length &gt;0\" ng-repeat=\"item in BData.badgesEarnedByUser\" ng-click=\"badgeItemClick($index, item, $parent.$index);$event.stopPropagation();\" id=\"thisBadge{{$parent.$index}}{{$index}}\" attr-parent-index=\"{{$parent.$index}}\" class=\"prog-pg-badges-item-wrp column large-4 remove-focus thisBadge{{$parent.$index}}{{$index}}\"> <div class=\"prog-pg-badges-item\"> <div class=\"badge-wrp\"> <div class=\"icon icon-badge\"><span>{{item.lpId | twoDigit}}</span></div> </div> <div class=\"badge-title\">{{item.moduleShortTitle}}</div> <div class=\"badge-grade\">{{item.badgeLevel}}</div> </div> <div ng-if=\"selectedIndex == $index &amp;&amp; shwexpand\" class=\"prog-pg-badges-arrow-wrp\"><img ng-src=\"assets/images/icon_down.png\" class=\"icon\"></div> <div ng-if=\"selectedIndex == $index &amp;&amp; selectedParentIndex == $parent.$index &amp;&amp; shwexpand\" class=\"prog-pg-badges-item-expnd-wrp prog-pg-badges-item-expnd-section\"> <div class=\"title-wrp clearfix\"> <div class=\"badge-title-wrp\"> <div class=\"badge-txt\">{{item.moduleShortTitle}}</div> <div class=\"badge-info-wrp\"> <div class=\"badge-info-item\"><span class=\"icon-video icon\"></span><span class=\"txt\">{{item.video_watched | minutesHours}}</span>/ {{item.total_video_duration | minutesHours}} Video</div> <div class=\"badge-info-item\"><span class=\"icon-assignment icon\"></span><span class=\"txt\">{{item.assignment_duration_taken | minutesHours}} /{{item.total_assignment_duration | minutesHours}} assignment</span></div> </div> </div> <div class=\"badge-title-wrp\"><span class=\"icon-star icon\"></span><span class=\"score\">{{item.points_earned}} / {{item.total_points}}</span> <div class=\"badge-prof-test-det-wrp\"><span class=\"info-txt\">PROFICIENCY TEST SCORE:</span><span class=\"info-score\"> {{item.moduleScore}} LEVEL {{item.badgeLevel}}</span></div> </div> </div> <div class=\"badge-btn-section clearfix\"> <div class=\"badge-date-det-wrp left\"> <div class=\"badge-date-item\"><span class=\"date-title\">Start Date:</span><span class=\"date-info\">{{item.start_date | dateFilter}}</span></div> <div class=\"badge-date-item\"><span class=\"date-title\">End Date</span><span class=\"date-info\">{{item.end_date | dateFilter}}</span></div> </div> <div class=\"badge-start-on-date right\"> <div class=\"badge-date-item\"><span class=\"date-title\">Taken On:</span><span class=\"date-info\">{{item.completedOn | dateFilter}}</span></div> </div> </div> </div> <div ng-if=\"shwexpand &amp;&amp; selectedParentIndex == $parent.$index &amp;&amp; selectedIndex == $index\" class=\"prog-badge-dummy\"></div> </div> </div> </div>");
$templateCache.put("app/Features/buyerJourney/partials/buyerDashboard/templates/content/content.html"," <div class=\"bcontent-wrp\"> <div ng-repeat=\"content in bJourneyObj.contentData\" class=\"bcontent-lp-wrp\"> <div class=\"table bcontents-table\"> <div class=\"table-cell lp-details-section\"> <div class=\"bcontent-lp-name\">{{content.lpName}}</div> <div class=\"bcontent-lp-contains\"> <div class=\"bgraph-info-wrp inline-block\"><span class=\"bgraph-subheading\">skills:</span><span class=\"bgraph-subvalue\">{{content.skills}}</span></div> <div class=\"bgraph-info-wrp inline-block\"><span class=\"bgraph-subheading\">videos:</span><span class=\"bgraph-subvalue\">{{content.videos}}</span></div> <div class=\"bgraph-info-wrp inline-block\"><span class=\"bgraph-subheading\">duration:</span><span class=\"bgraph-subvalue\">{{content.durationHours}}H</span></div> </div> </div> <div class=\"table-cell bcontent-lp-description\"> <p>{{content.lpDescription}}</p> </div> </div> <div class=\"clearfix lp-info-section\"> <div class=\"left table\"><span class=\"icon-view table-cell\"></span><span class=\"views table-cell\">{{content.views}}</span><span class=\"time-required table-cell\"> Usually takes about {{content.durationExpectedMonths}} months</span></div> <div class=\"right\"> <div ng-click=\"requestLicenses(content.lpName)\" class=\"purchase-licenses remove-focus\"><span>request more licenses</span></div> </div> </div> </div> </div>");
$templateCache.put("app/Features/buyerJourney/partials/buyerDashboard/templates/dashboardNav/dashboardNav.html"," <div ng-controller=\"dashNavCtrl\" class=\"bnavigation-wrp table\"> <div ng-if=\"bJourneyObj.isManager\" ng-class=\"{\'active\': bJourneyObj.currentTab === \'trackProgress\'}\" ng-click=\"trackProgressTab()\" class=\"table-cell remove-focus bdash-nav-btn\">track progress</div> <div ng-if=\"bJourneyObj.isManager\" ng-class=\"{\'active\': bJourneyObj.currentTab === \'learnersView\'}\" ng-click=\"learnersTab()\" class=\"table-cell remove-focus bdash-nav-btn\">learners</div> </div>");
$templateCache.put("app/Features/buyerJourney/partials/buyerDashboard/templates/learnersView/learnersView.html"," <div ng-controller=\"learnersViewCtrl\" class=\"blearners-wrp\"> <div class=\"directive\"></div> <div ng-init=\"showRetakeRequest=false\" class=\"blearners-retake-wrp\"> <div class=\"blearners-retake-heading-wrp\"> <div class=\"clearfix\"> <div class=\"left\"><span ng-if=\"lretake.retaketest.length != 1\" class=\"heading\">{{lretake.retaketest.length}} Learners have requested for retake of Proficiency Test</span><span ng-if=\"lretake.retaketest.length == 1\" class=\"heading\">{{lretake.retaketest.length}} Learner has requested for retake of Proficiency Test</span></div> <div ng-click=\"showRetakeRequest = !showRetakeRequest\" ng-class=\"{\'is-active\':showRetakeRequest}\" class=\"right remove-focus bview-btn-wrp\"><span ng-if=\"!showRetakeRequest\">Hide</span><span ng-if=\"showRetakeRequest\">View</span><span ng-class=\"{\'icon-down\': showRetakeRequest, \'icon-up\': !showRetakeRequest}\"></span></div> </div> </div> <table ng-show=\"!showRetakeRequest\" class=\"bjourney-primary-table blearners-table\"> <thead> <tr> <th>name</th> <th>module title</th> <th>proficiency test score</th> <th>date</th> <th>action</th> </tr> </thead> <tbody> <tr ng-repeat=\"retake in lretake.retaketest\"> <td><span class=\"name\">{{retake.firstname}}</span></td> <td>{{retake.moduleTitle}}</td> <td>{{retake.securedScore}}</td> <td>{{retake.endTime | dateFilter}}</td> <td ng-init=\"menuOpt = false\"><span ng-if=\"testApproved\">approved</span><span ng-click=\"approveLearner(\'{{retake.fbUserId}}\', \'{{retake.lpId}}\', \'{{retake.ptId}}\',\'{{retake.moduleSeqId}}\',\'{{$index}}\',\'{{retake.moduleTitle}}\')\" class=\"primary_btn learner-view\">approve</span><span style=\"display:none\" class=\"approved-learner\">approved</span>  </td> </tr> </tbody> </table> </div> <div class=\"blearners-data-wrp\"> <div class=\"clearfix\"> <div class=\"left\"> <div style=\"text-align:center\" class=\"binput-wrp-lp\"> <ui-select name=\"lpDetails\" search-enabled=\"searchEnabled\" ng-model=\"bJourneyObj.selectModel\" ng-disabled=\"disabled\"> <ui-select-match placeholder=\"Learning path\">{{$select.selected.lpTitle}}</ui-select-match> <ui-select-choices repeat=\"lp in learnersTData.usersForLp | unique:\'lpTitle\'\"><small>{{lp.lpTitle}}</small></ui-select-choices> </ui-select> </div> </div> <div class=\"right\">      </div> </div> <div ng-include=\"\" src=\"NotifyScreen\" class=\"lib-help-page\"></div> <div ng-include=\"\" src=\"completeProfTestScreen\" class=\"lib-help-page\"></div> <div ng-include=\"\" src=\"WelcomeBackScreen\" class=\"lib-help-page\"></div> <div ng-include=\"\" src=\"logoutConfirmationScreen\" class=\"lib-help-page\"></div> <div ng-include=\"\" src=\"attemptProfTestScreen\" class=\"lib-help-page\"></div> <ul class=\"ul-heading clearfix\"> <li class=\"name\">LEARNER</li> <li style=\"text-align:center\" class=\"lp\">CURRENT LP</li> <li ng-click=\"activeFilterFunc(&quot;actualProgressInPct&quot;)\" class=\"percentage remove-focus\"><span class=\"text\">PROGRESS</span><span ng-class=\"{\'icon-sort\': activeFilter == \'actualProgressInPct\', \'icon-sort2\': activeFilter != \'actualProgressInPct\'}\"></span></li> <li class=\"status\">STATUS</li> <li ng-click=\"activeFilterFunc(&quot;userRank&quot;)\" class=\"rank remove-focus\"><span class=\"text\">RANK</span><span ng-class=\"{\'icon-sort\': activeFilter == \'userRank\', \'icon-sort2\': activeFilter != \'userRank\'}\"></span></li> </ul> <ul ng-repeat=\"learner in learnersTData.usersForLp | filter: {lpTitle : bJourneyObj.selectModel.lpTitle} | orderBy:&quot;-&quot;\" ng-attr-id=\"{{ learner.id }}\" ng-click=\"loadBadgeData($index,&quot;{{learner.lpId}}&quot;,&quot;{{learner.fbUsername}}&quot;,showExpandedLearnersView);\" class=\"ul-value relative remove-focus clearfix\"> <li class=\"name\">{{learner.userName}}</li> <li style=\"text-align:center\" class=\"lp\">{{learner.lpTitle}}</li> <li class=\"percentage\">{{learner.actualProgressInPct | number:0}}%</li> <li ng-if=\"learner.actualProgressInPct &gt;= learner.expectedProgressInPct\" class=\"status\">ON TRACK </li> <li ng-if=\"learner.actualProgressInPct &lt; learner.expectedProgressInPct\" class=\"status\">OFF TRACK </li> <li ng-if=\"learner.userRank !== null\" class=\"rank\">{{learner.userRank}}</li> <li ng-if=\"learner.userRank === null\" class=\"rank\">---</li>     <div ng-show=\"showExpandedLearnersView{{$index}}\" class=\"blearners-expanded-view\"> <div class=\"inline-block\"><span style=\"font-size:12px;\" class=\"heading\">Progress :</span><span style=\"padding-left:5px\" ng-if=\"learner.actualProgressInPct &lt;100\" class=\"value\">{{learner.actualProgressInPct | number:1}}%</span><span style=\"padding-left:5px\" ng-if=\"learner.actualProgressInPct &gt;=100\" class=\"value\">100%</span><span style=\"font-size:12px;padding-left:5px\" class=\"heading\">should have been at </span><span ng-if=\"learner.expectedProgressInPct &lt;100\" class=\"value\">{{learner.expectedProgressInPct | number:0}}%</span><span style=\"padding-left:5px\" ng-if=\"learner.expectedProgressInPct &gt;=100\" class=\"value\">100%</span></div> <div style=\"float:right;padding-right:10px\" class=\"inline-block\"><span style=\"font-size:12px;\" class=\"heading\">total learning hours:</span><span class=\"value\">{{learner.totalTimeSpent | number:2}}H</span></div> <div style=\"padding-top:10px\" class=\"date-block\"><span style=\"font-size:10px;\" class=\"heading\">start date : </span><span style=\"padding-left:5px;font-size:12px\" class=\"value\">{{learner.lpStartDate | dateFilter}}</span><span style=\"font-size:10px;padding-left:10px\" class=\"heading\">end data : </span><span style=\"padding-left:5px;font-size:12px\" class=\"value\">{{learner.lpEndDate | dateFilter}}</span></div> <table ng-show=\"!showRetakeRequest\" class=\"bjourney-primary-table blearners-table\"> <thead> <tr> <th>module name</th> <th>Progress</th> <th>proficiency test</th> <th>status</th> </tr> </thead> <tbody> <tr ng-repeat=\"item in BData.badgesEarnedByUser\"> <td style=\"text-align:left;padding-left:5px\">{{item.moduleShortTitle}}</td> <td ng-if=\"item.duration &gt; 0 &amp;&amp; item.durationCompleted/item.duration &lt;=1\">{{(item.durationCompleted/item.duration) *100 | number:1}} %</td> <td ng-if=\"item.duration == 0\">---</td> <td ng-if=\"item.duration &gt; 0 &amp;&amp; item.durationCompleted/item.duration &gt;1\">100 %</td> <td ng-if=\"item.moduleScore !== null\">{{item.moduleScore}}</td> <td ng-if=\"item.moduleScore === null\">Not Attempted</td> <td>{{item.learningStatus}}</td> </tr> </tbody> </table>     </div> </ul> </div> </div>");
$templateCache.put("app/Features/buyerJourney/partials/buyerDashboard/templates/learningHealthTile/learningHealthTile.html"," <div id=\"blearning-health-section\" ng-controller=\"learningHealthCtrl\" scroll-on-click=\"\" class=\"relative full-width left main-widget-tile\"> <div class=\"bwidget-tile-wrp main-tile-wrp\"> <div class=\"bgraph-heading\"><span>learning health</span><span ng-click=\"overlayActiveFunc();$event.stopPropagation();\" class=\"icon-info remove-focus\"></span>  <p class=\"trial-p-n\"></p> </div> <div ng-if=\"bJourneyObj.dashData.LearningHealth[bJourneyObj.dashData.LearningHealth.length-1].percentage == 0 &amp;&amp; bJourneyObj.dashData.LearningHealth.length == 1\" ng-click=\"$event.stopPropagation()\" style=\"cursor:default;text-align:center;background:url(\'/assets/Icons/Learning_health.svg\')no-repeat;background-color:white;background-size: 35vh;background-position: center;\" class=\"bgraph-section remove-focus relative\"> <div ng-if=\"overlayActive\" class=\"bgraph-section-overlay absolute\"> <div class=\"clearfix\"> <div class=\"right\"><span ng-click=\"overlayActiveFunc();$event.stopPropagation();\" class=\"icon-close remove-focus\"></span></div> </div> <div class=\"text-wrp\"><span>Learning Health gives a complete view of the progress of your learners and if they are on track to meet their completion dates.</span></div> </div> </div> <div ng-if=\"bJourneyObj.dashData.LearningHealth[bJourneyObj.dashData.LearningHealth.length-1].percentage &gt; 0 || bJourneyObj.dashData.LearningHealth.length &gt; 1\" ng-class=\"{\'active-border\': $index == currentTile &amp;&amp; tileExpnd}\" class=\"bgraph-section remove-focus relative\"> <div class=\"clearfix\"> <div ng-init=\"i=bJourneyObj.dashData.LearningHealth.length\" class=\"left bgraph-info-section\"><span ng-if=\"bJourneyObj.dashData.LearningHealth.length&gt;0\" class=\"bnumber\">{{bJourneyObj.dashData.LearningHealth[i-1].percentage | number:2}}%</span><span ng-if=\"bJourneyObj.dashData.LearningHealth.length == 0\" class=\"bnumber\">0%</span><span class=\"bstatus\">ON TRACK</span></div> </div> <div ng-init=\"k=learningHealthChartData.length\" class=\"graph-wrp\"> <div ng-if=\"k &gt;1\" class=\"absolute percent-chenge-wrp\"><span ng-if=\"learningHealthChartData[k-1].percentage&gt;learningHealthChartData[k-2].percentage &amp;&amp; learningHealthChartData[k-1].percentage !=0\" class=\"icon-rankup\"></span><span ng-if=\"learningHealthChartData[k-1].percentage&lt;learningHealthChartData[k-2].percentage &amp;&amp; learningHealthChartData[k-1].percentage !=0\" class=\"icon-rankdown\"></span><span class=\"text\">{{learningHealthChartData[k-1].percentage-learningHealthChartData[k-2].percentage | number:2}}%</span></div> <line-chart-health healthchartdata=\"learningHealthChartData\"></line-chart-health> <p class=\"dummy-P\"></p> <div class=\"x-axis-wrp relative\"><span ng-class=\"{\'active\': previousGraphBtn}\" ng-click=\"fetchPreviousGraphData();$event.stopPropagation();\" class=\"icon-back absolute\"></span><span ng-class=\"{\'active\': nextGraphBtn}\" ng-click=\"fetchNextGraphData();$event.stopPropagation();\" class=\"icon-next absolute\"></span> </div> <div class=\"x-axis-label absolute\"><span class=\"x-axis-label-text\">Weeks</span><span class=\"x-axis-label-indicator\"></span></div> </div> <div ng-if=\"overlayActive\" class=\"bgraph-section-overlay absolute\"> <div class=\"clearfix\"> <div class=\"right\"><span ng-click=\"overlayActiveFunc();$event.stopPropagation();\" class=\"icon-close remove-focus\"></span></div> </div> <div class=\"text-wrp\"><span>Learning Health gives a complete view of the progress of your learners and if they are on track to meet their completion dates.</span></div> </div> <div ng-if=\"filterActive\" class=\"bgraph-section-overlay absolute\"> <div class=\"clearfix\"> <div class=\"right\"><span ng-click=\"overlayFilter();$event.stopPropagation();\" class=\"icon-close remove-focus\"></span></div> </div> <div class=\"text-wrp\"> <div class=\"buttons-wrp\"> <div style=\"padding-bottom:20px\" class=\"select-mode\"><span>filters :</span></div> <div style=\"margin:6px;width:120px\" ng-click=\"modeChangeFunc(&quot;monthly&quot;);$event.stopPropagation();\" class=\"tertiary_color inline-block remove-focus\">monthly</div> <div style=\"margin:6px;width:120px\" ng-click=\"modeChangeFunc(&quot;quaterly&quot;);$event.stopPropagation();\" class=\"tertiary_color inline-block\">quarterly</div> <div style=\"margin:6px;width:120px\" ng-click=\"modeChangeFunc(&quot;yearly&quot;);$event.stopPropagation();\" class=\"tertiary_color inline-block\">yearly</div> <div style=\"margin:6px;width:120px\" ng-click=\"modeChangeFunc(&quot;customize&quot;);$event.stopPropagation();\" class=\"tertiary_color inline-block\">customize</div> </div> </div> </div> </div> <div ng-if=\"$index == currentTile &amp;&amp; tileExpnd\" class=\"bgraph-dummy-wrp absolute full-width text-center\"><img ng-src=\"assets/images/icon_down.png\"> <div class=\"bdummy-block\"></div> </div> </div> <div id=\"expanded-wrp\" ng-if=\"$index == currentTile &amp;&amp; tileExpnd\" ng-click=\"$event.stopPropagation();\" class=\"blearning-health-wrp expanded-wrp absolute\"> <div class=\"table full-width blearning-health-expanded\"> <div class=\"bgraph-heading table-cell text-left\"><span>learning health</span></div> <div class=\"bview-option-team-path-wrp table-cell text-center\"><span ng-class=\"{\'active\': byTeam}\" ng-click=\"byTeam=true;byPath=false;bJourneyObj.lHealthTableExpnd=false;$event.stopPropagation();changeView(byTeam,byPath);retrieveHieght()\" class=\"remove-focus by-team\">by team</span><span ng-class=\"{\'active\': byPath}\" ng-click=\"byTeam=false;byPath=true;bJourneyObj.lHealthTableExpnd=false;$event.stopPropagation();changeView(byTeam,byPath);retrieveHieght()\" class=\"remove-focus by-path\">by path</span></div> <div class=\"bview-option-list-disc-wrp table-cell text-right\"><span style=\"display:none\" ng-json-export-excel=\"\" data=\"bJourneyObj.lhDrillData.LearningHealthByTeam\" filename=\"\'LearningHealth\'\" report-fields=\"{teamName:\'Team\',managerDesignation:\'Designation\',managerName:\' Manager name\',noOfLearnersInTeam:\'Learners Count\' }\" class=\"icon-download\"></span><span ng-class=\"{\'active\': byDisc}\" ng-click=\"byList=false;byDisc=true;$event.stopPropagation();retrieveHieght();bJourneyObj.lHealthTableExpnd=false;$event.stopPropagation()\" class=\"inline-block remove-focus icon-piechart\"></span><span ng-class=\"{\'active\': byList}\" ng-click=\"byList=true;byDisc=false;$event.stopPropagation();retrieveHieght();bJourneyObj.lHealthTableExpnd=false;$event.stopPropagation()\" class=\"inline-block remove-focus icon-listview\"></span></div>  </div>  <div class=\"blearning-health-expanded-view full-width\"> <div ng-if=\"byTeam &amp;&amp; byDisc\" class=\"bteam-disc-view-wrp clearfix\"> <div ng-repeat=\"team in bJourneyObj.lhDrillData.LearningHealthByTeam\" ng-click=\"showLearners(&quot;{{team.teamId}}&quot;,$index, tileNo);$event.stopPropagation();gotoAnchor1($event);\" class=\"left relative bpie-chart-section\">  <div class=\"bpie-chart-wrp\"> <div class=\"bpie-chart-heading inline-block\">{{team.teamName}}</div> <div class=\"bpie-chart-subheading inline-block\">{{team.noOfLearnersInTeam}} learners</div> <div ng-if=\"bJourneyObj.isHead\" class=\"bteam-manager-info-wrp clearfix relative\"><img ng-src=\"{{baseimageurl}}/avatars/1/{{team.profilePhotoUrl}}\" class=\"left\"> <div class=\"left manager-info\"> <div class=\"bteam-manager-name\">{{team.managerName}}</div> <div class=\"bteam-manager-designation\">{{team.managerDesignation}}</div> </div>  </div> <div class=\"bdonut-chart-team\"> <donut-chart data=\"team\"></donut-chart> </div> <div ng-if=\"$index == currentTable &amp;&amp; bJourneyObj.lHealthTableExpnd\" class=\"division-pin-wrp\"><img ng-src=\"assets/images/division-pin.png\"></div> <div id=\"blearners-section\" ng-if=\"$index == currentTable &amp;&amp; bJourneyObj.lHealthTableExpnd\" ng-click=\"$event.stopPropagation()\" class=\"blearners-section absolute\"> <div class=\"blearners-sub-heading-wrp clearfix\"> <div class=\"left\"> <div class=\"blearners-sub-heading\">Learners - {{team.teamName}}</div>  </div>   </div> <div class=\"blearner-data-section\"> <ul class=\"ul-heading table\"> <li class=\"name\">LEARNER</li> <li class=\"rank\">LEADERBOARD RANK</li> <li class=\"bprogress\"> PROGRESS</li> <li class=\"status\">STATUS</li> </ul> <ul ng-repeat=\"learner in byPathLD.LearningHealthUsers\" class=\"ul-value relative table\"> <li style=\"text-align:left\" class=\"name\"><span style=\"padding-left:0px\"><img ng-src=\"{{baseimageurl}}/avatars/1/{{learner.profilePhotoUrl}}\"></span><span ng-if=\"byTeam\" style=\"display: inline-block;width:20vh;position: relative;top: 1.5vh;\">{{learner.userName}}</span><span ng-if=\"byPath\" style=\"display: inline-block;width:20vh;position: relative;top: 1.5vh;\">{{learner.fbUsername}}</span></li> <li ng-if=\"learner.userRank === null\" class=\"rank\">--</li> <li ng-if=\"learner.userRank !== null\" class=\"rank\">{{learner.userRank}}</li> <li class=\"bprogress\"> <div class=\"scnd-hdr-progress-bar-section\"> <buyers-primary-progress-bar proposed-completion=\"learner.expectedProgressInPctCum\" expected-completion=\"learner.expectedProgressInPctCum\" actual-completion=\"learner.actualProgressInPctCum\"></buyers-primary-progress-bar> <buyers-proficiency-progress-bar total-tests=\"learner.totalNoOfProficiency\" proposed-completion=\"learner.noOfProficiencyCompleted\" tests-taken=\"learner.noOfProficiencyCompleted\"></buyers-proficiency-progress-bar> </div> </li> <li ng-class=\"{\'green\': learner.learnerStatus === \'On Track\',\'red\': learner.learnerStatus == \'dangerously behind\' || \'little behind\' || \'Not Started\', \'yellow\': learner.learnerStatus == \'Off Track\'}\" class=\"status\">{{learner.learnerStatus}}</li>  </ul> </div> </div> </div> </div> </div> <div ng-if=\"byTeam &amp;&amp; byList\" class=\"bteam-list-view-wrp\"> <div class=\"btable-wrp\"> <table class=\"bjourney-primary-table\"> <thead> <tr> <th>team</th> <th>learners</th> <th>manager</th> <th>on track</th> <th>off track</th> <th>not started</th> </tr> </thead> <tbody> <tr ng-repeat=\"team in bJourneyObj.lhDrillData.LearningHealthByTeam\"> <td>{{team.teamName}}</td> <td>{{team.noOfLearnersInTeam}}</td> <td>{{team.managerName}}</td>  <td class=\"green\">{{team.onTrackPerc}}%</td> <td class=\"yellow\">{{team.behindTrackPerc}}%</td> <td class=\"red\">{{team.notStartedPerc}}%</td> </tr> </tbody> </table> </div> </div> <div ng-if=\"byPath &amp;&amp; byDisc\" class=\"bpath-disc-view-wrp clearfix\"> <div ng-repeat=\"path in bJourneyObj.lhDrillDataByPath.LearningHealthByPath\" ng-click=\"showLearners(&quot;{{path.lpId}}&quot;,$index, tileNo);$event.stopPropagation();gotoAnchor1($event);\" class=\"left bpie-chart-section relative remove-focus\">  <div class=\"bpie-chart-wrp\"> <div class=\"bpie-chart-heading text-center\">{{path.lpTitle}}</div> <div class=\"bpie-chart-subheading text-center\">{{path.noOfLearnersInLP}} learners</div> <div class=\"bdonut-chart-path text-center\"> <donut-chart data=\"path\"></donut-chart> </div> <div ng-if=\"$index == currentTable &amp;&amp; bJourneyObj.lHealthTableExpnd\" class=\"division-pin-wrp\"><img ng-src=\"assets/images/division-pin.png\"></div> <div id=\"blearners-section\" ng-if=\"$index == currentTable &amp;&amp; bJourneyObj.lHealthTableExpnd\" ng-click=\"$event.stopPropagation()\" class=\"blearners-section absolute\"> <div class=\"blearners-sub-heading-wrp clearfix\"> <div class=\"left\"> <div class=\"blearners-sub-heading\">Learners - {{path.lpTitle}}</div>  </div>   </div> <div class=\"blearner-data-section\"> <ul class=\"ul-heading table\"> <li class=\"name\">LEARNER</li> <li class=\"rank\">LEADERBOARD RANK</li> <li class=\"bprogress\"> PROGRESS</li> <li class=\"status\">STATUS</li> </ul> <ul ng-repeat=\"learner in byPathLD.LearningHealthUsers\" class=\"ul-value relative table\"> <li style=\"text-align:left\" class=\"name\"><img ng-src=\"{{baseimageurl}}/avatars/1/{{learner.profilePhotoUrl}}\"><span style=\"display: inline-block;width:20vh;position: relative;top: 1.5vh;\">{{learner.userName}}</span></li> <li ng-if=\"learner.userRank === null\" class=\"rank\">--</li> <li ng-if=\"learner.userRank !== null\" class=\"rank\">{{learner.userRank}}</li> <li class=\"bprogress\"> <div class=\"scnd-hdr-progress-bar-section\"> <buyers-primary-progress-bar proposed-completion=\"learner.expectedProgressInPctCum\" expected-completion=\"learner.expectedProgressInPctCum\" actual-completion=\"learner.actualProgressInPctCum\"></buyers-primary-progress-bar> <buyers-proficiency-progress-bar total-tests=\"learner.totalNoOfProficiency\" proposed-completion=\"learner.noOfProficiencyCompleted\" tests-taken=\"learner.noOfProficiencyCompleted\"></buyers-proficiency-progress-bar> </div> </li> <li ng-class=\"{\'green\': learner.learnerStatus === \'On Track\',\'red\': learner.learnerStatus == \'dangerously behind\' || \'little behind\' || \'Not Started\', \'yellow\': learner.learnerStatus == \'Off Track\'}\" class=\"status\">{{learner.learnerStatus}}</li>  </ul> </div> </div> </div> </div> </div> <div ng-if=\"byPath &amp;&amp; byList\" class=\"bpath-disc-view-wrp\"> <div class=\"btable-wrp\"> <table class=\"bjourney-primary-table\"> <thead> <tr> <th>learning path</th> <th>learners</th> <th>on track</th> <th>off track</th> <th>not started</th> </tr> </thead> <tbody> <tr ng-repeat=\"path in bJourneyObj.lhDrillDataByPath.LearningHealthByPath\" ng-click=\"$event.stopPropagation();\" class=\"remove-focus\"> <td>{{path.lpTitle}}</td> <td>{{path.noOfLearnersInLP}}</td> <td class=\"green\">{{path.onTrackPerc}}%</td> <td class=\"yellow\">{{path.behindTrackPerc}}%</td> <td class=\"red\">{{path.notStartedPerc}}%</td> </tr> </tbody> </table> </div> </div> <div ng-if=\"byDisc\" class=\"full-width text-center bcolor-box-wrp\"> <div class=\"inline-block box green-color\"></div> <div class=\"inline-block text\">on track</div> <div class=\"inline-block box yellow-color\"></div> <div class=\"inline-block text\">off track</div> <div class=\"inline-block box red-color\"></div> <div class=\"inline-block text\">not started</div> </div> </div> </div> </div>");
$templateCache.put("app/Features/buyerJourney/partials/buyerDashboard/templates/learningHoursTile/learningHoursTile.html"," <div id=\"btotal-learning-section\" ng-controller=\"learningHoursCtrl\" class=\"relative full-width left main-widget-tile\"> <div class=\"bwidget-tile-wrp main-tile-wrp\"> <div class=\"bgraph-heading\"><span>learning hours</span><span ng-click=\"overlayActiveFunc();$event.stopPropagation();\" class=\"icon-info remove-focus\"></span>  </div> <div ng-if=\"bJourneyObj.dashDataHrs.learningHrs[0].timeAlreadySpent == 0\" ng-click=\"$event.stopPropagation()\" style=\"cursor:default;text-align:center;background:url(\'/assets/Icons/Learning_hours.svg\')no-repeat;background-color:white;background-size: 35vh;background-position: center;\" class=\"bgraph-section remove-focus relative\"> <div ng-if=\"overlayActive\" class=\"bgraph-section-overlay absolute\"> <div class=\"clearfix\"> <div class=\"right\"><span ng-click=\"overlayActiveFunc();$event.stopPropagation();\" class=\"icon-close remove-focus\"></span></div> </div> <div style=\"font-size:14px;letter-spacing:1px\" class=\"text-wrp\"><span>Learning Hours shows the total number of hours completed by your learners in their respective learning paths and library usage.</span></div> </div> </div> <div ng-if=\"bJourneyObj.dashDataHrs.learningHrs[0].timeAlreadySpent &gt; 0\" ng-class=\"{\'active-border\': $index == currentTile &amp;&amp; tileExpnd}\" class=\"bgraph-section remove-focus relative\"> <div class=\"clearfix\"> <div ng-init=\"i=bJourneyObj.dashDataHrs.learningHrs.length\" class=\"left bgraph-info-section\"><span class=\"bnumber\">{{bJourneyObj.dashDataHrs.learningHrs[0].timeAlreadySpent | number:2}}</span><span style=\"padding-left:7px\" class=\"bstatus\">hours</span></div> </div> <div ng-init=\"k=learningHoursChartData.length\" class=\"graph-wrp\"> <div ng-if=\"k&gt;1\" class=\"absolute percent-chenge-wrp\"><span ng-if=\"learningHoursChartData[0].percentage&gt;learningHoursChartData[1].percentage\" class=\"icon-rankup\"></span><span ng-if=\"learningHoursChartData[0].percentage&lt;learningHoursChartData[1].percentage\" class=\"icon-rankdown\"></span><span ng-if=\"learningHoursChartData[0].percentage&gt;=learningHoursChartData[1].percentage\" class=\"text\">{{((learningHoursChartData[0].percentage-learningHoursChartData[1].percentage)/learningHoursChartData[1].percentage)*100 | number:2}}%</span><span ng-if=\"learningHoursChartData[0].percentage&lt;learningHoursChartData[1].percentage\" class=\"text\">{{((learningHoursChartData[0].percentage-learningHoursChartData[1].percentage)/learningHoursChartData[1].percentage)*100 | number:2}}%</span></div>   <line-chart-hours hourschartdata=\"learningHoursChartData\"></line-chart-hours> <div class=\"x-axis-wrp relative\"><span ng-class=\"{\'active\': previousGraphBtn}\" ng-click=\"fetchPreviousGraphData();$event.stopPropagation();\" class=\"icon-back absolute\"></span><span ng-class=\"{\'active\': nextGraphBtn}\" ng-click=\"fetchNextGraphData();$event.stopPropagation();\" class=\"icon-next absolute\"></span> </div> <div class=\"x-axis-label absolute\"><span class=\"x-axis-label-text\">Weeks</span><span class=\"x-axis-label-indicator\"></span></div> </div> <div ng-if=\"overlayActive\" class=\"bgraph-section-overlay absolute\"> <div class=\"clearfix\"> <div class=\"right\"><span ng-click=\"overlayActiveFunc();$event.stopPropagation();\" class=\"icon-close remove-focus\"></span></div> </div> <div style=\"font-size:14px;letter-spacing:1px\" class=\"text-wrp\"><span>Learning Hours shows the total number of hours completed by your learners in their respective learning paths and library usage.</span></div> </div> <div ng-if=\"filterActive\" class=\"bgraph-section-overlay absolute\"> <div class=\"clearfix\"> <div class=\"right\"><span ng-click=\"overlayFilter();$event.stopPropagation();\" class=\"icon-close remove-focus\"></span></div> </div> <div class=\"text-wrp\"> <div class=\"buttons-wrp\"> <div style=\"padding-bottom:20px\" class=\"select-mode\"><span>filters :</span></div> <div style=\"margin:6px;width:120px\" ng-click=\"modeChangeFunc(&quot;monthly&quot;);$event.stopPropagation();\" class=\"tertiary_color inline-block remove-focus\">monthly</div> <div style=\"margin:6px;width:120px\" ng-click=\"modeChangeFunc(&quot;quaterly&quot;);$event.stopPropagation();\" class=\"tertiary_color inline-block\">quarterly</div> <div style=\"margin:6px;width:120px\" ng-click=\"modeChangeFunc(&quot;yearly&quot;);$event.stopPropagation();\" class=\"tertiary_color inline-block\">yearly</div> <div style=\"margin:6px;width:120px\" ng-click=\"modeChangeFunc(&quot;customize&quot;);$event.stopPropagation();\" class=\"tertiary_color inline-block\">customize</div> </div> </div> </div> </div> <div ng-if=\"$index == currentTile &amp;&amp; tileExpnd\" class=\"bgraph-dummy-wrp absolute full-width text-center\"><img ng-src=\"assets/images/icon_down.png\"> <div class=\"bdummy-block\"></div> </div> </div> <div id=\"expanded-wrp\" ng-if=\"$index == currentTile &amp;&amp; tileExpnd\" ng-click=\"$event.stopPropagation();\" class=\"blearning-hours-wrp blearning-health-wrp expanded-wrp absolute\"> <div style=\"margin-top:10px\" class=\"clearfix expanded-header-wrp\"> <div class=\"bgraph-heading left\"><span>learning hours</span></div> <div style=\"width:32%\" class=\"bview-option-team-path-wrp table-cell text-center\"><span ng-class=\"{\'active\': byTeam}\" ng-click=\"listViewClick($event,byList,true);bJourneyObj.lHealthTableExpnd=false;$event.stopPropagation();retrieveHieght()\" class=\"remove-focus by-team\">by team</span><span ng-class=\"{\'active\': byPath}\" ng-click=\"listViewClick($event,byList,false);bJourneyObj.lHealthTableExpnd=false;$event.stopPropagation();retrieveHieght()\" class=\"remove-focus by-path\">by path</span>  </div> <div style=\"width:23%\" class=\"bview-option-list-disc-wrp table-cell text-right right\"><span style=\"display:none\" ng-click=\"\" class=\"icon-download\"></span><span ng-class=\"{\'active\': byDisc}\" ng-click=\"listViewClick($event,false,byTeam);bJourneyObj.lHealthTableExpnd=false;$event.stopPropagation();retrieveHieght()\" class=\"inline-block remove-focus icon-piechart\"></span><span ng-class=\"{\'active\': byList}\" ng-click=\"listViewClick($event,true,byTeam);bJourneyObj.lHealthTableExpnd=false;$event.stopPropagation();retrieveHieght()\" class=\"inline-block remove-focus icon-listview\"></span></div> </div> <div ng-if=\"byDisc &amp;&amp; byTeam\" class=\"bexpanded-graph-wrp clearfix\"> <div ng-repeat=\"team in lhrsArray\" ng-click=\"showLearners(&quot;{{team.value[0].data.teamId}}&quot;,$index, tileNo);\" class=\"left width-fifty-percent\"><loading-state ng-show=\"!learnersLoaded\"></loading-state> <div style=\"background-color:white;padding:15px\" class=\"blearning-expanded\"> <div class=\"team-name\">{{team.teamName}}</div> <div class=\"btime-wrp\"><span class=\"heading\">Total completed hours:</span><span class=\"value\">{{team.timespent | number:2}}H</span></div> <div id=\"graph-wrp\" ng-init=\"key=team.graph.length\" class=\"graph-wrp graph-wrp-chart relative\"> <div ng-if=\"team.graph[key-2].hours != undefined\" class=\"absolute percent-chenge-wrp\">    </div> <div ng-if=\"team.graph[key-2].hours == undefined\" class=\"absolute percent-chenge-wrp\">   </div> <line-chart-hours-expanded hourschartdata=\"team.graph\"></line-chart-hours-expanded>  <div style=\"position:relative;top:0px\" class=\"x-axis-label absolute\"><span class=\"x-axis-label-text\">Weeks</span><span class=\"x-axis-label-indicator\"></span></div> </div> </div> <div ng-if=\"$index == currentTable &amp;&amp; bJourneyObj.lHealthTableExpnd\" class=\"division-pin-wrp\"><img ng-src=\"assets/images/division-pin.png\"></div> <div id=\"blearners-section\" ng-if=\"$index == currentTable &amp;&amp; bJourneyObj.lHealthTableExpnd\" style=\"position:absolute;left:-35px;right:-35px\" ng-click=\"$event.stopPropagation()\" class=\"blearners-section absolute\"> <div class=\"blearners-sub-heading-wrp clearfix\"> <div class=\"left\"> <div class=\"blearners-sub-heading\">Learners - {{team.teamName}}</div> <div ng-init=\"menuOpt=false\" class=\"blearner-progress-section\"></div> </div>  </div> <div class=\"blearner-data-section\"> <ul class=\"ul-heading table\"> <li style=\"text-align:center;width:34%\" class=\"name\">LEARNER</li> <li style=\"width:22%;text-align:center\" class=\"rank\">LEARNING PATH</li> <li style=\"width:22%;text-align:center\" class=\"bprogress\"> TOTAL LEARNING HOURS</li> <li style=\"width:22%;text-align:center\" class=\"status\">AVERAGE LEARNING HOURS</li> </ul> <ul ng-repeat=\"l2team in lHrsLevel2TV.learningHrs\" class=\"ul-value relative table\"> <li style=\"width:34%\" class=\"name\"><img ng-src=\"{{baseimageurl}}/avatars/1/{{l2team.profilePhotoUrl}}\"><span style=\"display: inline-block;width:30vh;position: relative;top: 1.5vh;\">{{l2team.userName}}</span></li> <li style=\"width:22%\" class=\"rank\">{{l2team.lpTitle}}</li> <li style=\"width:22%;text-align:center\" class=\"bprogress\">{{l2team.totalTimeSpent | number:1}}</li> <li style=\"width:22%;text-align:center\" class=\"status\">{{l2team.avgtimeSpent | number:1}}</li> </ul> </div> </div> </div> </div> <div ng-if=\"byTeam &amp;&amp; byList\" class=\"bteam-list-view-wrp\"> <div class=\"Learnighrs-listview\"> <div class=\"btable-wrp\"> <table class=\"bjourney-primary-table\"> <thead> <tr> <th>Team</th> <th>Number of Users</th> <th>Total Learning hours</th> <th>Average Learning hours</th> </tr> </thead> <tbody> <tr ng-repeat=\"team in lHrsLevel1TVByTeam.learningHrs\"> <td>{{team.team}}</td> <td>{{team.userName}}</td> <td>{{team.totalHours | number:1}}</td> <td>{{team.avgHours | number:1}}</td> </tr> </tbody> </table> </div> </div> </div> <div ng-if=\"byDisc &amp;&amp; byPath\" class=\"bexpanded-graph-wrp clearfix\"> <div ng-repeat=\"path in lhrsPArray\" ng-click=\"showLearners(&quot;{{path.value[0].data.lpId}}&quot;,$index, tileNo);\" class=\"left width-fifty-percent\"><loading-state ng-show=\"!learnersLoaded\"></loading-state> <div style=\"background-color:white;padding:15px\" class=\"blearning-expanded\"> <div ng-show=\"bJourneyObj.isHead\" class=\"team-name\">{{path.lpTitle}}</div> <div ng-show=\"bJourneyObj.isManager\" class=\"team-name\">{{path.lpTitle}}</div> <div class=\"btime-wrp\"><span class=\"heading\">Total completed hours:</span><span class=\"value\">{{path.timespent | number:2}}H</span></div> <div id=\"graph-wrp{{$index}}\" ng-init=\"key=path.graph.length\" class=\"graph-wrp graph-wrp-chart relative\"> <div ng-if=\"path.graph[key-2].percentageChange !== undefined\" class=\"absolute percent-chenge-wrp\">    </div> <div ng-if=\"path.graph[key-2].percentageChange === undefined\" class=\"absolute percent-chenge-wrp\">   </div> <line-chart-hours-expanded hourschartdata=\"path.graph\"></line-chart-hours-expanded> <div class=\"x-axis-wrp relative\">   </div> <div style=\"position:relative;top:0px\" class=\"x-axis-label absolute\"><span class=\"x-axis-label-text\">Weeks</span><span class=\"x-axis-label-indicator\"></span></div> </div> </div> <div ng-if=\"$index == currentTable &amp;&amp; bJourneyObj.lHealthTableExpnd\" class=\"division-pin-wrp\"><img ng-src=\"assets/images/division-pin.png\"></div> <div id=\"blearners-section\" ng-if=\"$index == currentTable &amp;&amp; bJourneyObj.lHealthTableExpnd\" style=\"position:absolute;left:-35px;right:-35px\" ng-click=\"$event.stopPropagation()\" class=\"blearners-section absolute\"> <div class=\"blearners-sub-heading-wrp clearfix\"> <div class=\"left\"> <div class=\"blearners-sub-heading\">Learners - {{path.lpTitle}}</div> <div ng-init=\"menuOpt=false\" class=\"blearner-progress-section\"></div> </div>   </div> <div class=\"blearner-data-section\"> <ul class=\"ul-heading table\"> <li style=\"text-align:center;width:40%\" class=\"name\">LEARNER</li> <li style=\"text-align:center;width:30%\" class=\"bprogress\"> TOTAL LEARNING HOURS</li> <li style=\"text-align:center;width:30%\" class=\"status\">AVERAGE LEARNING HOURS</li> </ul> <ul ng-repeat=\"l2path in lHrsLevel2PV.learningHrs\" class=\"ul-value relative table\"> <li style=\"width:40%\" class=\"name\"><img ng-src=\"{{baseimageurl}}/avatars/1/{{l2path.profilePhotoUrl}}\"><span style=\"display: inline-block;width:30vh;position: relative;top: 1.5vh;\">{{l2path.userName}}</span></li> <li style=\"text-align:center;width:30%\" class=\"bprogress\">{{l2path.totalTimeSpent | number:1}}</li> <li style=\"text-align:center;width:30%\" class=\"status\">{{l2path.avgtimeSpent | number:1}}</li> </ul> </div> </div> </div> </div> <div ng-if=\"bJourneyObj.isHead &amp;&amp; byPath &amp;&amp; byList\" class=\"bteam-list-view-wrp\"> <div class=\"Learnighrs-listview\"> <div class=\"btable-wrp\"> <table class=\"bjourney-primary-table\"> <thead> <tr> <th>Learner Path</th> <th>Number of Users</th> <th>Total Learning hours</th> <th>Average Learning hours</th> </tr> </thead> <tbody> <tr ng-repeat=\"path in lHrsLevel1TV.learningHrs\"> <td>{{path.Title}}</td> <td>{{path.userName}}</td> <td>{{path.totalHours | number:1}}</td> <td>{{path.avgHours | number:1}}</td> </tr> </tbody> </table> </div> </div> </div> <div ng-if=\"bJourneyObj.isManager &amp;&amp; byPath &amp;&amp; byList\" class=\"bteam-list-view-wrp\"> <div class=\"Learnighrs-listview\"> <div class=\"btable-wrp\"> <table class=\"bjourney-primary-table\"> <thead> <tr> <th>Learner Path</th> <th>Number of Users</th> <th>Total Learning hours</th> <th>Average Learning hours</th> </tr> </thead> <tbody> <tr ng-repeat=\"path in lHrsLevel1TV.learningHrs\"> <td>{{path.Title}}</td> <td>{{path.userName}}</td> <td>{{path.totalHours | number:1}}</td> <td>{{path.avgHours | number:1}}</td> </tr> </tbody> </table> </div> </div> </div> </div> </div>");
$templateCache.put("app/Features/buyerJourney/partials/buyerDashboard/templates/licenseManagementTile/licenseManagementTile.html"," <div id=\"blicense-management-section\" ng-controller=\"licenseManagementCtrl\" class=\"relative left\"> <div class=\"bwidget-tile-wrp\"> <div class=\"bgraph-heading\"><span>license management</span><span ng-click=\"overlayActiveFunc();$event.stopPropagation();\" style=\"color:#ccc;padding-left:2vh\" class=\"icon-info remove-focus\"></span></div> <div id=\"license\" ng-click=\"gotoAnchor($event)\" ng-mousedown=\"gotoAnchor($event)\" ng-class=\"{\'active-border\': $index == currentTile &amp;&amp; tileExpnd}\" class=\"bgraph-section remove-focus relative\"> <div class=\"clearfix\"></div> <div ng-if=\"bJourneyObj.isHead\" class=\"bgraph-license-allocation-info clearfix\"> <div class=\"purchasedLicense\"> <div class=\"value value-purchased\">{{LMData.licenceMgmtContents[0].purchasedLicences}}</div> <div class=\"heading purchased\">Total Licenses Purchased</div> </div> <div class=\"left allocatedLicence\"> <div class=\"heading\">Total Licenses Allocated</div> <div class=\"value\">{{LMData.licenceMgmtContents[0].allocatedLicences}}</div> </div> <div class=\"left\"> <div class=\"heading\">Total Licenses Unallocated</div>  <div style=\"color:#ab0000\" class=\"value unallocatedLicense\">{{LMData.licenceMgmtContents[0].unAllocatedLicences}}</div> </div> </div> <div ng-if=\"bJourneyObj.isManager\" class=\"bgraph-license-allocation-info clearfix\"> <div class=\"purchasedLicenseManager\"> <div class=\"value value-purchased\">{{LMData.licenceMgmtContents[0].purchasedLicences}}</div> <div class=\"heading purchased\">Total Licenses Allocated</div> </div> </div> <div ng-if=\"overlayActive\" class=\"bgraph-section-overlay absolute\"> <div class=\"clearfix\"> <div class=\"right\"><span ng-click=\"overlayActiveFunc();$event.stopPropagation();\" class=\"icon-close remove-focus\"></span></div> </div> <div style=\"font-size:14px;letter-spacing:1px\" class=\"text-wrp\"><span>License Management gives you an breakdown of your licenses. You can see the number of licenses allocated by the learning paths, teams and individual learners.</span></div> </div> </div> <div ng-if=\"$index == currentTile &amp;&amp; tileExpnd\" class=\"bgraph-dummy-wrp absolute full-width text-center\"><img ng-src=\"assets/images/icon_down.png\"> <div class=\"bdummy-block\"></div> </div> </div> <div id=\"expanded-wrp\" ng-if=\"$index == currentTile &amp;&amp; tileExpnd\" ng-click=\"$event.stopPropagation();\" class=\"expanded-wrp blearning-health-wrp absolute\"> <div class=\"table full-width blearning-health-expanded\"> <div class=\"bgraph-heading table-cell text-left\"><span>License Management</span></div> <div class=\"bview-option-team-path-wrp table-cell text-center\"><span ng-class=\"{\'active\': byTeam}\" ng-click=\"byTeam=true;byPath=false;$event.stopPropagation();\" class=\"remove-focus by-team\">by team</span><span ng-class=\"{\'active\': byPath}\" ng-click=\"byTeam=false;byPath=true;$event.stopPropagation();\" class=\"remove-focus by-path\">by path</span>  </div> <div class=\"bview-option-list-disc-wrp table-cell text-right\"></div> </div> <div style=\"padding-bottom:30px\" class=\"clearfix\"> <div style=\"width:50%\" class=\"right\"> <div class=\"bview-option-list-disc-wrp table-cell text-right\"><span ng-class=\"{\'active\': byDisc}\" ng-click=\"byList=false;byDisc=true;$event.stopPropagation();\" class=\"inline-block remove-focus icon-piechart\"></span><span ng-class=\"{\'active\': byList}\" ng-click=\"byList=true;byDisc=false;$event.stopPropagation();\" class=\"inline-block remove-focus icon-listview\"></span> <span ng-show=\"bJourneyObj.isHead\" ng-click=\"purchaseHistory();$event.stopPropagation();\" class=\"inline-block vertical-align-top primary_btn\">Purchase history</span><span ng-show=\"bJourneyObj.isManager\" ng-click=\"optionSelected();$event.stopPropagation();\" class=\"inline-block vertical-align-top primary_btn\">learner details</span> </div> </div> </div> <div style=\"background-color:white;margin-left:20%;padding-top:20px\" ng-if=\"byDisc\" class=\"left width-fifty-percent ng-scope\"> <div ng-if=\"bJourneyObj.isHead &amp;&amp; byTeam &amp;&amp; byDisc\" style=\"padding:20px\" class=\"chart-section\"> <div style=\"\" class=\"graph-wrp\"> <bar-chart chartdata=\"LMByTeamGraph\" mode=\"modeVar\"></bar-chart> <div class=\"x-axis-wrp relative\"><span ng-class=\"{\'active\': previousGraphBtn}\" ng-click=\"fetchPreviousGraphData();$event.stopPropagation();\" class=\"icon-back absolute\"></span><span ng-class=\"{\'active\': nextGraphBtn}\" ng-click=\"fetchNextGraphData();$event.stopPropagation();\" class=\"icon-next absolute\"></span> </div> <div class=\"x-axis-label absolute\"><span class=\"x-axis-label-text\">team name</span><span class=\"x-axis-label-indicator\"></span></div> </div> </div> <div ng-if=\"bJourneyObj.isManager &amp;&amp; byTeam &amp;&amp; byDisc\" style=\"padding:20px\" class=\"chart-section\"> <div style=\"\" class=\"graph-wrp\"> <manager-bar-chart chartdata=\"LMByTeamGraph\" mode=\"modeVar\"></manager-bar-chart> <div class=\"x-axis-wrp relative\"><span ng-class=\"{\'active\': previousGraphBtn}\" ng-click=\"fetchPreviousGraphData();$event.stopPropagation();\" class=\"icon-back absolute\"></span><span ng-class=\"{\'active\': nextGraphBtn}\" ng-click=\"fetchNextGraphData();$event.stopPropagation();\" class=\"icon-next absolute\"></span> </div> <div class=\"x-axis-label absolute\"><span class=\"x-axis-label-text\">team name</span><span class=\"x-axis-label-indicator\"></span></div> </div> </div> </div> <div ng-if=\"bJourneyObj.isHead &amp;&amp; byTeam &amp;&amp; byList\" ng-click=\"\" class=\"bteam-list-view-wrp\"> <div ng-repeat=\"license in LMByTeamGraph.licenceMgmtGraph\" ng-if=\"license.teamName ==\'UnAllocated\'\" class=\"unAllocated\">UnAllocated : {{license.unAllocated}}</div> <div class=\"license-listview\"> <div class=\"btable-wrp\"> <table class=\"bjourney-primary-table\"> <thead> <tr> <th>Team</th> <th>Total License Allocated</th> </tr> </thead> <tbody> <tr ng-repeat=\"license in LMByTeamGraph.licenceMgmtGraph\" ng-if=\"license.teamName!=\'UnAllocated\'\"> <td>{{license.teamName}}</td> <td>{{license.usedLicences+license.unUsedLicences}}</td> </tr> </tbody> </table> </div> </div> </div> <div style=\"background-color:white;margin-left:20%;padding-top:20px\" ng-if=\"byDisc\" class=\"left width-fifty-percent ng-scope\"> <div ng-if=\"bJourneyObj.isHead &amp;&amp; byPath &amp;&amp; byDisc\" style=\"padding:20px\" class=\"chart-section\"> <div class=\"graph-wrp\"> <bar-chart chartdata=\"LMByPathGraph\" mode=\"modeVar\"></bar-chart> <div class=\"x-axis-wrp relative\"><span ng-class=\"{\'active\': previousGraphBtn}\" ng-click=\"fetchPreviousGraphData();$event.stopPropagation();\" class=\"icon-back absolute\"></span><span ng-class=\"{\'active\': nextGraphBtn}\" ng-click=\"fetchNextGraphData();$event.stopPropagation();\" class=\"icon-next absolute\"></span> </div> <div class=\"x-axis-label absolute\"><span class=\"x-axis-label-text\">learning paths</span><span class=\"x-axis-label-indicator\"></span></div> </div> <p class=\"dummy-P\"> <div class=\"x-axis-wrp relative\"></div> </p> </div> <div ng-if=\"bJourneyObj.isManager &amp;&amp; byPath &amp;&amp; byDisc\" style=\"padding:20px\" class=\"chart-section\"> <div class=\"graph-wrp\"> <manager-bar-chart chartdata=\"LMByPathGraph\" mode=\"modeVar\"></manager-bar-chart> <div class=\"x-axis-wrp relative\"><span ng-class=\"{\'active\': previousGraphBtn}\" ng-click=\"fetchPreviousGraphData();$event.stopPropagation();\" class=\"icon-back absolute\"></span><span ng-class=\"{\'active\': nextGraphBtn}\" ng-click=\"fetchNextGraphData();$event.stopPropagation();\" class=\"icon-next absolute\"></span> </div> <div class=\"x-axis-label absolute\"><span class=\"x-axis-label-text\">learning paths</span><span class=\"x-axis-label-indicator\"></span></div> </div> <p class=\"dummy-P\"> <div class=\"x-axis-wrp relative\"></div> </p> </div> </div> <div ng-if=\"bJourneyObj.isHead &amp;&amp; byPath &amp;&amp; byList\" ng-click=\"\" class=\"bteam-list-view-wrp\"> <div ng-repeat=\"blicense in LMByPathGraph.licenceMgmtGraph\" ng-if=\"blicense.lpName == \'UnAllocated\'\" class=\"unAllocated\">UnAllocated : {{blicense.unAllocated}}</div> <div class=\"license-listview\"> <div class=\"btable-wrp\"> <table class=\"bjourney-primary-table\"> <thead> <tr> <th>Learning Path</th> <th>Total License Allocated</th> </tr> </thead> <tbody> <tr ng-repeat=\"blicense in LMByPathGraph.licenceMgmtGraph\" ng-if=\"blicense.lpName!=\'UnAllocated\'\"> <td>{{blicense.lpName}}</td> <td>{{blicense.usedLicences+blicense.unUsedLicences}}</td> </tr> </tbody> </table> </div> </div> </div> <div ng-if=\"bJourneyObj.isManager &amp;&amp; byPath &amp;&amp; byList\" ng-click=\"\" class=\"bteam-list-view-wrp\">  <div class=\"license-listview\"> <div class=\"btable-wrp\"> <table class=\"bjourney-primary-table\"> <thead> <tr> <th>Learning Path</th> <th>Total License Allocated</th> </tr> </thead> <tbody> <tr ng-repeat=\"blicense in final[0].licenceMgmtGraph\" ng-if=\"blicense.lpTitle!=\'UnAllocated\'\"> <td>{{blicense.lpTitle}}</td> <td>{{blicense.usedLicences}}</td> </tr> </tbody> </table> </div> </div> </div> <div ng-if=\"bJourneyObj.isManager &amp;&amp; byTeam &amp;&amp; byList\" class=\"bteam-list-view-wrp\">  <div class=\"license-listview\"> <div class=\"btable-wrp\"> <table class=\"bjourney-primary-table\"> <thead> <tr> <th>Learning Path</th> <th>Total License Allocated</th> </tr> </thead> <tbody> <tr ng-repeat=\"license in LMByTeamGraph.licenceMgmtGraph\" ng-if=\"license.lpTitle!=\'UnAllocated\'\"> <td>{{license.teamName}}</td> <td>{{license.usedLicences}}</td> </tr> </tbody> </table> </div> </div> </div> </div> </div>");
$templateCache.put("app/Features/buyerJourney/partials/buyerDashboard/templates/purchaseHistory/purchaseHistory.html"," <div class=\"bpurchase-history-wrp\"> <div style=\"text-spacing:2px;color:#ff6700;padding-bottom:15px;font-family:montserratSemiBold;position:relative;bottom:30px;color:orange\" class=\"back-button\"><a ng-click=\"backButton()\" style=\"color:#ff6700\"><span class=\"icon-back\"></span><span style=\"font-size:18px;padding-left:3px;position:relative;\">BACK TO DASHBOARD</span></a></div> <div class=\"clearfix\"> <div class=\"left\"> <div class=\"left bpurchase-history-info\"> <div class=\"bpurchased-heading\">total licenses purchased</div> <div class=\"bpurchased-value\">{{LMData.licenceMgmtContents[0].purchasedLicences}}</div> </div> <div class=\"left bpurchase-history-info\"> <div class=\"bpurchased-heading\">total allocated licenses</div> <div class=\"bpurchased-value\">{{LMData.licenceMgmtContents[0].allocatedLicences}}</div> </div> <div class=\"left bpurchase-history-info relative\"> <div class=\"bpurchased-heading\">total unallocated licenses</div> <div class=\"bpurchased-value\">{{LMData.licenceMgmtContents[0].unAllocatedLicences}}</div> </div> </div>  </div> <table class=\"bjourney-primary-table\"> <thead> <tr> <th>no. of licenses</th> <th>date of purchase</th> <th>expiry date</th> <th>unallocated</th> </tr> </thead> <tbody> <tr ng-repeat=\"purchase in purchaseHistory.purchaseHistory\"> <td class=\"number\">{{purchase.noOfLicensePurchased}}</td> <td class=\"date\">{{purchase.purchcaseDate | dateFilter}}</td> <td ng-class=\"{\'date-warning\':purchase.initiateDateWarning}\" class=\"date\"> <div class=\"date-icon-con\"> <div class=\"warning-icon-con\"><span class=\"icon-info\"></span></div> <div class=\"date-text\">{{purchase.expiryDate | dateFilter}}</div> </div> </td> <td ng-class=\"{&quot;zero&quot;:purchase.unallocated === 0}\" class=\"number\">{{purchase.noOfLicensesUnAllocated}}</td> </tr> </tbody> </table> </div>");
$templateCache.put("app/Features/buyerJourney/partials/buyerDashboard/templates/roiTile/roiTile.html"," <div id=\"roi-section\" ng-controller=\"roiTileCtrl\" ng-click=\"$event.stopPropagation()\" style=\"cursor:default\" class=\"bwidget-tile-wrp\"> <div class=\"bgraph-heading\"><span>ROI</span><span ng-click=\"overlayActiveFunc();$event.stopPropagation();\" style=\"color:#ccc;padding-left:2vh\" class=\"icon-info remove-focus\"></span></div> <div class=\"bgraph-section relative\"> <div class=\"clearfix\"> <div class=\"bgraph-info-section\"> <div class=\"roi-value bnumber\">{{bJourneyObj.dashDataROI.roi[0].dollarSpentOnEach | twoDigit}}</div> <div class=\"roi-statement bstatus\">for every dollar spent</div> </div> </div> <div class=\"broi-details-wrp\"> <div class=\"clearfix\"> <div class=\"left width-fifty-percent-roi bgraph-info-section\"> <div class=\"roi-substatement\">earned skill value</div> <div class=\"roi-subvalue bnumber\">{{bJourneyObj.dashDataROI.roi[0].earnedSkillVal | twoDigit}}</div> </div> <div class=\"right width-fifty-percent-roi bgraph-info-section\"> <div class=\"roi-substatement\">total training cost</div> <div class=\"roi-subvalue bnumber\">{{bJourneyObj.dashDataROI.roi[0].totalTrainingCost | twoDigit}}</div> </div> </div> </div> <div ng-if=\"overlayActive\" class=\"bgraph-section-overlay absolute\"> <div class=\"clearfix\"> <div class=\"right\"><span ng-click=\"overlayActiveFunc();$event.stopPropagation();\" class=\"icon-close remove-focus\"></span></div> </div> <div style=\"font-size:14px;letter-spacing:1px\" class=\"text-wrp\"><span>The ROI widget connects the training investment to the earned value so you can see the impact of the training.</span></div> </div> </div> </div>");
$templateCache.put("app/Features/buyerJourney/partials/buyerDashboard/templates/skillsTile/skillsTile.html"," <div id=\"bskills-section\" ng-controller=\"skillsTileCtrl\" class=\"relative full-width left main-widget-tile\"> <div class=\"bwidget-tile-wrp main-tile-wrp\"> <div class=\"bgraph-heading\"><span>skills</span><span ng-click=\"overlayActiveFunc();$event.stopPropagation();\" style=\"color:#ccc;padding-left:2vh\" class=\"icon-info remove-focus\"></span></div> <div ng-if=\"bJourneyObj.dashDataskills.learningSkills[0].totalSkills == 0\" ng-click=\"$event.stopPropagation()\" style=\"cursor:default;text-align:center;background:url(\'/assets/Icons/Skills.svg\')no-repeat;background-color:white;background-size: 35vh;background-position: center;\" class=\"bgraph-section relative\"> <div ng-if=\"overlayActive\" class=\"bgraph-section-overlay absolute\"> <div class=\"clearfix\"> <div class=\"right\"><span ng-click=\"overlayActiveFunc();$event.stopPropagation();\" class=\"icon-close remove-focus\"></span></div> </div> <div style=\"font-size:14px;letter-spacing:1px\" class=\"text-wrp\"><span>Each learning path is a collection of modules, which are mapped to specific skills. Here, we list the skills acquired by your learners.</span></div> </div> </div> <div ng-if=\"bJourneyObj.dashDataskills.learningSkills[0].totalSkills&gt;0\" ng-class=\"{\'active-border\': $index == currentTile &amp;&amp; tileExpnd}\" class=\"bgraph-section relative\"> <div class=\"clearfix\"> <div class=\"left bgraph-info-section\"><span ng-if=\"bJourneyObj.dashDataskills.learningSkills[0].totalSkills&gt;0\" class=\"bnumber\">{{bJourneyObj.dashDataskills.learningSkills[0].totalSkills}}</span><span ng-if=\"bJourneyObj.dashDataskills.learningSkills[0].totalSkills == 0\" class=\"bnumber\">0</span><span style=\"padding-left:6px\" class=\"bstatus\">skills acquired</span></div>   </div> <div style=\"height:80%\" class=\"graph-wrp\"> <vertical-bar-chart chartdata=\"bJourneyObj.dashDataskills\" mode=\"modeVar\"></vertical-bar-chart> </div> <div ng-if=\"overlayActive\" class=\"bgraph-section-overlay absolute\"> <div class=\"clearfix\"> <div class=\"right\"><span ng-click=\"overlayActiveFunc();$event.stopPropagation();\" class=\"icon-close remove-focus\"></span></div> </div> <div style=\"font-size:14px;letter-spacing:1px\" class=\"text-wrp\"><span>Each learning path is a collection of modules, which are mapped to specific skills. Here, we list the skills acquired by your learners.</span></div> </div> </div> <div ng-if=\"$index == currentTile &amp;&amp; tileExpnd\" class=\"bgraph-dummy-wrp absolute full-width text-center\"><img ng-src=\"assets/images/icon_down.png\"> <div class=\"bdummy-block\"></div> </div> </div> <div id=\"expanded-wrp\" ng-if=\"$index == currentTile &amp;&amp; tileExpnd\" ng-click=\"$event.stopPropagation();\" class=\"skills-expanded-wrp blearning-health-wrp expanded-wrp absolute\"> <div class=\"clearfix expanded-header-wrp\"> <div class=\"bgraph-heading left\"><span>top skills</span></div> <div style=\"width:32%\" class=\"bview-option-team-path-wrp table-cell text-center\"><span ng-class=\"{\'active\': byTeam}\" ng-click=\"skillListViewClick(true,byList);bJourneyObj.lHealthTableExpnd=false;$event.stopPropagation();retrieveHieght()\" class=\"remove-focus by-team\">by team</span><span ng-class=\"{\'active\': byPath}\" ng-click=\"skillListViewClick(false,byList);bJourneyObj.lHealthTableExpnd=false;$event.stopPropagation();retrieveHieght()\" class=\"remove-focus by-path\">by path</span>   </div> <div style=\"width:22%\" class=\"bview-option-list-disc-wrp table-cell text-right right\"><span style=\"display:none\" ng-click=\"exportData()\" class=\"icon-download\"></span><span ng-class=\"{\'active\': byDisc}\" ng-click=\"skillListViewClick(byTeam,false);$event.stopPropagation();bJourneyObj.lHealthTableExpnd=false;$event.stopPropagation();retrieveHieght()\" class=\"inline-block remove-focus icon-piechart\"></span><span ng-class=\"{\'active\': byList}\" ng-click=\"skillListViewClick(byTeam,true);$event.stopPropagation();bJourneyObj.lHealthTableExpnd=false;$event.stopPropagation();retrieveHieght()\" class=\"inline-block remove-focus icon-listview\"></span></div> <div ng-if=\"bJourneyObj.isManager &amp;&amp; byPath\" ng-click=\"$event.stopPropagation();\" class=\"right lp-filter-wrp relative\"> <ui-select style=\"padding-left:7px;padding-top:3px\" name=\"lpFilter\" search-enabled=\"searchEnabled\" ng-model=\"bJourneyObj.selectLP\" ng-disabled=\"disabled\" ng-change=\"selectedLPFunc(bJourneyObj.selectLP);bJourneyObj.lHealthTableExpnd=false;$event.stopPropagation();retrieveHieght()\"> <ui-select-match placeholder=\"All\" style=\"text-overflow: clip;word-break: break-all;word-wrap: break-word;overflow: hidden;overflow-wrap: break-word;height: 20px;width: 90%;\">{{$select.selected.lpTitle}}</ui-select-match> <ui-select-choices repeat=\"lp in skillsPArray\"><small>{{lp.lpTitle}}</small></ui-select-choices> </ui-select> <div class=\"absolute icon-wrp\"> <div class=\"icon-filter\"></div> </div> </div> <div ng-if=\"bJourneyObj.isManager &amp;&amp; byTeam\" ng-click=\"$event.stopPropagation();\" class=\"right lp-filter-wrp relative\"> <ui-select style=\"padding-left:7px;padding-top:3px\" name=\"teamFilter\" search-enabled=\"searchEnabled\" ng-model=\"bJourneyObj.selectTeam\" ng-disabled=\"disabled\" ng-change=\"selectedTeamFunc(bJourneyObj.selectTeam)\"> <ui-select-match placeholder=\"All\">{{$select.selected.team}}</ui-select-match> <ui-select-choices repeat=\"team in sArray\"><small>{{team.team}}</small></ui-select-choices> </ui-select> <div class=\"absolute icon-wrp\"> <div class=\"icon-filter\"></div> </div> </div> </div> <div ng-if=\"bJourneyObj.isHead &amp;&amp; byTeam &amp;&amp; byDisc &amp;&amp; skill.team != &quot;All&quot; &amp;&amp; skill.learningpath.length&gt;0\" ng-repeat=\"skill in sArray\" class=\"bwidget-tile-wrp\"> <div style=\"padding:10px\" class=\"teamName\"><span style=\"color:#4377e5\">Team : {{skill.team}}</span></div> <div style=\"min-height:350px;max-height:auto\" class=\"table-head\"> <div ng-repeat=\"lpath in skill.learningpath\" class=\"left width-fifty-percent ng-scope\"> <div style=\"height:280px\" class=\"bgraph-section remove-focus relative\"> <div style=\"color:#818181;width:100%;padding-bottom:20px;text-align:center\" class=\"bgraph-heading\">{{lpath.lp}}</div> <div style=\"width:100%;height:90%\" class=\"chart-section\"> <div style=\"width:100%;height:95%\" class=\"graph-wrp\"> <skill-donut-chart chartdata=\"lpath.graph\" mode=\"modeVar\"></skill-donut-chart> </div> </div> </div> </div> </div> </div> <div ng-if=\"byTeam &amp;&amp; byList\" ng-click=\"skilllistViewClick();\" class=\"bteam-list-view-wrp\"> <div ng-repeat=\"team in sArray\" ng-if=\"team.team!= \'All\' &amp;&amp; team.learningpath.length&gt;0\" class=\"skills-listview\"> <div style=\"padding-top:15px;color:#4377e5\" class=\"team-name\">{{team.team}}</div> <div ng-repeat=\"lpData in team.learningpath\" class=\"lp-name\"> <div style=\"color:#818181;width:100%;padding:10px;\" class=\"learningpath\">{{lpData.lp}}</div> <div class=\"btable-wrp\"> <table class=\"bjourney-primary-table\"> <thead> <tr> <th>module Title</th> <th>learner</th> </tr> </thead> <tbody> <tr ng-repeat=\"teamData in lpData.value\"> <td>{{teamData.value.moduleTitle}}</td> <td>{{teamData.value.SkillLearners}}</td> </tr> </tbody> </table> </div> </div> </div> </div> <div ng-repeat=\"skills in skillsPArray\" ng-if=\"bJourneyObj.isHead &amp;&amp; byPath &amp;&amp; byDisc &amp;&amp; skills.lpTitle != &quot;All&quot;\" class=\"bwidget-tile-wrp\"> <div class=\"left width-fifty-percent ng-scope\"> <div style=\"height:280px\" class=\"bgraph-section remove-focus relative\"> <div style=\"width:100%;padding-bottom:20px;text-align:center\" class=\"bgraph-heading\"><span>{{skills.lpTitle}}</span></div> <div style=\"width:100%;height:90%\" class=\"chart-section\"> <div style=\"width:100%;height:95%\" class=\"graph-wrp\"> <skill-donut-chart chartdata=\"skills.graph\" mode=\"modeVar\"></skill-donut-chart> </div> </div> </div> </div> </div> <div style=\"height:auto\" ng-repeat=\"skill in sArray\" ng-if=\"bJourneyObj.isManager &amp;&amp; byTeam &amp;&amp; byDisc &amp;&amp; skill.team != &quot;All&quot; &amp;&amp; skill.learningpath.length&gt;0\" class=\"bwidget-tile-wrp\"> <div style=\"padding:10px\" class=\"teamName\"><span style=\"color:#4377e5\">Team : {{skill.team}}</span></div> <div ng-repeat=\"lpath in skill.learningpath | filter: filterSelectedTeam\" ng-click=\"showLearners(\'{{lpath.value[0].value.lpId}}\',\'{{$index}}\', tileNo);$event.stopPropagation();gotoAnchor1($event);\" class=\"left width-fifty-percent ng-scope\"><loading-state ng-show=\"!learnersLoaded\"></loading-state> <div style=\"height:280px\" class=\"bgraph-section remove-focus relative\"> <div style=\"color:#818181;width:100%;padding-bottom:20px;text-align:center\" class=\"bgraph-heading\">{{lpath.lp}}</div> <div style=\"width:100%;height:90%\" class=\"chart-section\"> <div style=\"width:100%;height:95%\" class=\"graph-wrp\"> <skill-donut-chart chartdata=\"lpath.graph\" mode=\"modeVar\"></skill-donut-chart> </div> </div> </div> <div ng-if=\"$index == currentTable &amp;&amp; bJourneyObj.lHealthTableExpnd\" class=\"division-pin-wrp\"><img ng-src=\"assets/images/division-pin.png\"></div> <div id=\"blearners-section\" ng-if=\"$index == currentTable &amp;&amp; bJourneyObj.lHealthTableExpnd\" style=\"position:absolute;left:-35px;right:-35px\" ng-click=\"$event.stopPropagation()\" class=\"blearners-section absolute\"> <div class=\"blearners-sub-heading-wrp clearfix\"> <div class=\"left\"> <div class=\"blearners-sub-heading\">Learners - {{lpath.lp}}</div> <div ng-init=\"menuOpt=false\" class=\"blearner-progress-section\"></div> </div>  </div> <div class=\"blearner-data-section\"> <ul class=\"ul-heading table\"> <li style=\"width:20%;text-align:center\" class=\"name\">USER</li> <li style=\"width:20%;text-align:center\" class=\"rank\">SKILLS</li> <li style=\"width:20%;text-align:center\" class=\"bprogress\"> STATUS</li> <li style=\"width:20%;text-align:center\" class=\"bprogress\"> COMPLETED ON</li> <li style=\"width:20%\" class=\"rank\">SCORE</li> </ul> <ul ng-repeat=\"tlearner in skillL2DatabyTeam.learningSkills\" ng-if=\"tlearner.learningStatus == \'Completed\'\" class=\"ul-value relative table\"> <li style=\"width:30%\" class=\"name\"><img ng-src=\"{{baseimageurl}}/avatars/1/{{tlearner.profilePhotoUrl}}\"><span style=\"display: inline-block;width:30vh;position: relative;top: 1.5vh;\">{{tlearner.username}}</span></li> <li style=\"width:25%;text-align:center\" class=\"rank\">{{tlearner.moduleTitle}}</li> <li style=\"width:15%;text-align:center\" class=\"rank\">{{tlearner.learningStatus}}</li> <li style=\"width:15%;text-align:center\" ng-if=\"tlearner.completedOn !== null\" class=\"bprogress\">{{tlearner.completedOn | dateFilter}}</li> <li style=\"width:15%;text-align:center\" ng-if=\"tlearner.completedOn === null\" class=\"bprogress\">----</li> <li style=\"width:15%;text-align:center\" ng-if=\"tlearner.moduleScore !== null\" class=\"rank\">{{tlearner.moduleScore}}</li> <li style=\"width:15%;text-align:center\" ng-if=\"tlearner.moduleScore === null\" class=\"rank\">NA</li> </ul> </div> </div> </div> </div> <div ng-if=\"bJourneyObj.isManager &amp;&amp; byPath &amp;&amp; byDisc &amp;&amp; skills.lpTitle != &quot;All&quot;\" class=\"bwidget-tile-wrp\"> <div ng-repeat=\"skills in skillsPArray | filter: filterSelectedLP\" ng-click=\"showLearnersForPath(\'{{skills.value[0].data.lpId}}\',\'{{$index}}\', tileNo);$event.stopPropagation();gotoAnchor1($event);\" ng-if=\"skills.lpTitle != \'All\'\" class=\"left width-fifty-percent ng-scope\"><loading-state ng-show=\"!learnersLoaded\"></loading-state> <div style=\"height:280px\" class=\"blearning-expanded bgraph-section remove-focus relative\"> <div style=\"width:100%;padding-bottom:20px;text-align:center\" class=\"bgraph-heading\"><span>{{skills.lpTitle}}</span></div> <div style=\"width:100%;height:90%\" class=\"chart-section\"> <div style=\"width:100%;height:95%\" class=\"graph-wrp\"> <skill-donut-chart chartdata=\"skills.graph\" mode=\"modeVar\"></skill-donut-chart> </div> </div> </div> <div ng-if=\"$index == 0 &amp;&amp; bJourneyObj.lHealthTableExpnd|| $index == currentTable &amp;&amp; bJourneyObj.lHealthTableExpnd\" class=\"division-pin-wrp\"><img ng-src=\"assets/images/division-pin.png\"></div> <div id=\"blearners-section\" ng-if=\"$index == 0 &amp;&amp; bJourneyObj.lHealthTableExpnd|| $index == currentTable &amp;&amp; bJourneyObj.lHealthTableExpnd\" style=\"position:absolute;left:-35px;right:-35px\" ng-click=\"$event.stopPropagation()\" class=\"blearners-section absolute\"> <div class=\"blearners-sub-heading-wrp clearfix\"> <div class=\"left\"> <div class=\"blearners-sub-heading\">Learners - {{skills.lpTitle}}</div> <div ng-init=\"menuOpt=false\" class=\"blearner-progress-section\"></div> </div>  </div> <div class=\"blearner-data-section\"> <ul class=\"ul-heading table\"> <li style=\"width:30%\" class=\"name\">LEARNER</li> <li style=\"width:25%\" class=\"rank\">SKILLS</li> <li style=\"width:15%\" class=\"rank\">STATUS</li> <li style=\"width:15%\" class=\"bprogress\"> COMPLETED ON</li> <li style=\"width:15%\" class=\"rank\">SCORE</li> </ul> <ul ng-repeat=\"plearner in skillL2DatabyPath.learningSkills\" ng-if=\"plearner.learningStatus == \'Completed\'\" class=\"ul-value relative table\"> <li style=\"width:30%;text-align:left\" class=\"name\"><img ng-src=\"{{baseimageurl}}/avatars/1/{{plearner.profilePhotoUrl}}\"><span style=\"display: inline-block;width:30vh;position: relative;top: 1.5vh;\">{{plearner.username}}</span></li> <li style=\"width:25%;text-align:center\" class=\"rank\">{{plearner.moduleTitle}}</li> <li style=\"width:15%;text-align:center\" class=\"rank\">{{plearner.learningStatus}}</li> <li style=\"width:15%;text-align:center\" ng-if=\"plearner.completedOn !== null\" class=\"bprogress\">{{plearner.completedOn | dateFilter}}</li> <li style=\"width:15%;text-align:center\" ng-if=\"plearner.completedOn === null\" class=\"bprogress\">----</li> <li style=\"width:15%;text-align:center\" ng-if=\"plearner.moduleScore !== null\" class=\"rank\">{{plearner.moduleScore}}</li> <li style=\"width:15%;text-align:center\" ng-if=\"plearner.moduleScore === null\" class=\"rank\">NA</li> </ul> </div> </div> </div> </div> <div ng-if=\"bJourneyObj.isHead &amp;&amp; byPath &amp;&amp; byList\" ng-click=\"skilllistViewClick();\" class=\"bteam-list-view-wrp\"> <div ng-repeat=\"path in skillsPArray\" ng-if=\"path.lpTitle!=\'All\'\" class=\"skills-listview\"> <div ng-show=\"bJourneyObj.isHead\" style=\"padding-top:15px\" class=\"team-name\">{{path.lpTitle}}</div> <div class=\"btable-wrp\"> <table class=\"bjourney-primary-table\"> <thead> <tr> <th>module Title</th> <th>learner</th> </tr> </thead> <tbody> <tr ng-repeat=\"teamData in path.value\" ng-if=\"teamData.data.moduleTitle!= \'All\'\"> <td>{{teamData.data.moduleTitle}}</td> <td>{{teamData.data.SkillLearners}}</td> </tr> </tbody> </table> </div> </div> </div> <div ng-if=\"bJourneyObj.isManager &amp;&amp; byPath &amp;&amp; byList\" ng-click=\"skilllistViewClick();\" class=\"bteam-list-view-wrp\"> <div ng-repeat=\"path in skillsPArray | filter: filterSelectedLP\" ng-if=\"path.lpTitle !=\'All\'\" class=\"skills-listview\"> <div ng-show=\"bJourneyObj.isManager\" style=\"padding-top:15px\" class=\"team-name\">{{path.lpTitle}}</div> <div class=\"btable-wrp\"> <table class=\"bjourney-primary-table\"> <thead> <tr> <th>module Title</th> <th>learner</th> </tr> </thead> <tbody> <tr ng-repeat=\"teamData in path.value\"> <td>{{teamData.data.moduleTitle}}</td> <td>{{teamData.data.SkillLearners}}</td> </tr> </tbody> </table> </div> </div> </div> </div> </div>");
$templateCache.put("app/Features/buyerJourney/partials/buyerDashboard/templates/trackProgress/trackProgress.html"," <div ng-click=\"passEvent($event)\" ng-intro-options=\"IntroOptions\" ng-intro-method=\"CallMe\" ng-hints-method=\"startHints\" ng-intro-oncomplete=\"CompletedEvent\" ng-intro-onexit=\"ExitEvent\" ng-intro-onchange=\"ChangeEvent\" ng-intro-onbeforechange=\"BeforeChangeEvent\" ng-intro-onafterchange=\"AfterChangeEvent\" ng-intro-autostart=\"ShouldAutoStart\" class=\"btrack-progress-section\"> <div ng-if=\"bJourneyObj.isHead\" style=\"font-size:30px;letter-spacing:3px;color:black;font-family:montserratSemiBold\" class=\"Dashboard-title\"><span>DASHBOARD</span></div> <div class=\"clearfix\"> <div class=\"left\"> <div class=\"bcircular-tiles-wrp-mobile\"> <div class=\"item-wrp inline-block\"><span class=\"heading\">teams:</span><span class=\"value\">{{bJourneyObj.dashboardInfo.attributes[0].noOfTeams | twoDigit}}</span></div> <div class=\"item-wrp inline-block\"><span class=\"heading\">paths:</span><span class=\"value\">{{bJourneyObj.dashboardInfo.attributes[0].noOfPaths | twoDigit}}</span></div> <div class=\"item-wrp inline-block\"><span class=\"heading\">learners:</span><span class=\"value\">{{bJourneyObj.dashboardInfo.attributes[0].noOfLearners | twoDigit}}</span></div> </div> <div ng-if=\"bJourneyObj.isHead\" class=\"bwelcome-statement-wrp\"> <span class=\"bold-text\">{{bJourneyObj.message}}</span>  </div>  <div ng-if=\"bJourneyObj.isManager\" class=\"bwelcome-statement-wrp\">  <span class=\"bold-text\">{{bJourneyObj.message}}</span> </div>  <div id=\"step4\" ng-click=\"downloadlist();$event.stopPropogation();\" ng-class=\"{\'vid-filter-active\':toggleDownloadFilter}\" class=\"downloadlist-filter table-cell\"><span class=\"download-text\">CREATE A REPORT</span><span class=\"icon-down\"></span></div> <div ng-show=\"toggleDownloadFilter\" class=\"downloadlist-wrp\"> <div style=\"font-family:montserratSemiBold!important\" id=\"selectAll\" class=\"downloadlist-item\"> <input type=\"checkbox\" id=\"selectAll\" checked=\"selectAll\"> <label id=\"selectAllLabel\" for=\"selectAll\" ng-click=\"selectAll=!selectAll;SelectAllDOwnload()\" ng-class=\"{&quot;icon-checkbox_inactive&quot;:!selectAll,&quot;icon-checkbox_selected&quot;:selectAll}\" class=\"remove-focus dwnList\"></label><span>Select All</span> </div> <div id=\"lHealth\" class=\"downloadlist-item\"> <input type=\"checkbox\" id=\"lHealth\" checked=\"lHealth\"> <label id=\"learning-health\" for=\"lHealth\" ng-click=\"lHealth=!lHealth\" ng-class=\"{&quot;icon-checkbox_inactive&quot;:!lHealth,&quot;icon-checkbox_selected&quot;:lHealth}\" class=\"remove-focus dwnList\"></label><span>Learning Health</span> </div> <div id=\"skills\" class=\"downloadlist-item\"> <input type=\"checkbox\" id=\"skills\" checked=\"skills\"> <label id=\"skills\" for=\"skills\" ng-click=\"skills=!skills;UnselectAll($event)\" ng-class=\"{&quot;icon-checkbox_inactive&quot;:!skills,&quot;icon-checkbox_selected&quot;:skills}\" class=\"remove-focus dwnList\"></label><span>Skills</span> </div> <div id=\"learningHours\" class=\"downloadlist-item\"> <input type=\"checkbox\" id=\"learningHours\" checked=\"learningHours\"> <label id=\"learning-hours\" for=\"learningHours\" ng-click=\"learningHours=!learningHours\" ng-class=\"{&quot;icon-checkbox_inactive&quot;:!learningHours,&quot;icon-checkbox_selected&quot;:learningHours}\" class=\"remove-focus dwnList\"></label><span>Learning Hours</span> </div> <div id=\"licenseMng\" class=\"downloadlist-item\"> <input type=\"checkbox\" id=\"licenseMng\" checked=\"licenseMng\"> <label id=\"license-management\" for=\"licenseMng\" ng-click=\"licenseMng=!licenseMng\" ng-class=\"{&quot;icon-checkbox_inactive&quot;:!licenseMng,&quot;icon-checkbox_selected&quot;:licenseMng}\" class=\"remove-focus dwnList\"></label><span>License Management</span> </div> <div role=\"button\" tabindex=\"0\" class=\"ballocate-link table remove-focus\"> <div class=\"bwelcome-btn-wrp\"> <div id=\"step4\" ng-click=\"downloadWidgetData();downloadlist();\" class=\"primary_btn inline-block remove-focus\">Download</div> </div> </div> </div> </div> <div class=\"right bcircular-tiles-wrp\"> <div data-hint=\"details about the learners,teams,paths\" class=\"bcircular-tiles\"> <div class=\"welcome-scrn-det-item-wrp\"> <div class=\"welcome-scrn-det-item\"> <div style=\"background-color:#05A4DE\" class=\"welcome-scrn-det-item-inner\"><span>{{bJourneyObj.dashboardInfo.attributes[0].noOfLearners | twoDigit}}</span></div> </div> <div class=\"welcome-scrn-det-item-title\">learners</div> </div> <div class=\"welcome-scrn-det-item-wrp\"> <div class=\"welcome-scrn-det-item\"> <div class=\"welcome-scrn-det-item-inner\"><span>{{bJourneyObj.dashboardInfo.attributes[0].noOfPaths | twoDigit}}</span></div> </div> <div class=\"welcome-scrn-det-item-title\">paths</div> </div> <div class=\"welcome-scrn-det-item-wrp\"> <div class=\"welcome-scrn-det-item\"> <div class=\"welcome-scrn-det-item-inner\"><span>{{bJourneyObj.dashboardInfo.attributes[0].noOfTeams | twoDigit}}</span></div> </div> <div class=\"welcome-scrn-det-item-title\">teams</div> </div> </div> </div> </div> </div> <div ng-if=\"bJourneyObj.trackProgress\" ng-include=\"\" src=\"\'app/Features/buyerJourney/partials/buyerDashboard/templates/trackProgress/trackProgress.html\'\" class=\"bdashboard-welcome-section\"></div> <div id=\"step1\" class=\"bdashboard-tiles-section clearfix\"> <div ng-repeat=\"item in widegetUrl\" ng-include=\"\" src=\"item\" ng-click=\"tileClick($index);gotoAnchor($event)\" ng-init=\"tileNo = $index\" class=\"bdashboard-tiles left remove-focus\"></div> </div> <div ng-include=\"\" src=\"\'app/Features/buyerJourney/partials/buyerDashboard/templates/widgetsBar/widgetsBar.html\'\" class=\"bdashboard-add-widgets-section\"></div>");
$templateCache.put("app/Features/buyerJourney/partials/buyerDashboard/templates/widgetsBar/widgetsBar.html"," <div ng-class=\"{\'widgets-bar-animate-up\': expandedWidgetsBar}\" ng-controller=\"widgetsBarCtrl\" class=\"bwidget-wrp relative\"></div>");
$templateCache.put("app/Features/learnerView/template/videoPlayerPage/partials/Cuepoints/vidCuePoints.html"," <div ng-repeat=\"cuepoint in cuepoints.points\" style=\"transform: scale({{circleDia(cuepoint)}});left: {{calcLeft(cuepoint)}}%;\" ng-class=\"{\'cue-point-active\': currentTime &gt; {{activeCue(cuepoint)}} }\"></div>");
$templateCache.put("app/Features/learnerView/template/videoPlayerPage/partials/imgWidthThumbnail/imgWidthThumbnail.html"," <div ng-repeat=\"cuepoint in cuepoints.points\" style=\"transform: scale({{circleDia(cuepoint)}});left: {{calcLeft(cuepoint)}}%;\" ng-class=\"{\'cue-point-active\': currentTime &gt; {{activeCue(cuepoint)}} }\"></div>");
$templateCache.put("app/Features/learnerView/template/videoPlayerPage/partials/rewindTen/rewindTen.html"," <div class=\"rewind-ten-wrp\"> <div ng-click=\"rewindTen()\" class=\"rewind-ten-icon remove-focus\"><span class=\"icon-secback\"></span></div> </div>");
$templateCache.put("app/Features/learnerView/template/videoPlayerPage/partials/textSlider/textSizeSlider.html"," <div class=\"text-size-slider\"> <div class=\"slider-functional-area table\"> <div class=\"slider-heading-text text-left\">TEXT SIZE</div> <div class=\"table-cell text-left-character\"><span ng-model=\"textSize\" ng-click=\"txtValueChange(14)\" unit=\"px\" class=\"small-letter\">A</span><span ng-model=\"textSize\" ng-click=\"txtValueChange(18)\" unit=\"px\" class=\"small-letter2\">A</span><span ng-model=\"textSize\" ng-click=\"txtValueChange(22)\" unit=\"px\" class=\"small-letter3\">A</span><span ng-model=\"textSize\" ng-click=\"txtValueChange(26)\" unit=\"px\" class=\"small-letter4\">A</span></div> </div> </div>");
$templateCache.put("app/Features/buyerJourney/partials/buyerDashboard/templates/learnersView/attemptProfTest/attemptProfTest.html"," <div ng-if=\"shwAttemptProfTestScreen\" class=\"attempt-test-pg-wrp\"> <div class=\"attempt-test-bg-opcity\"></div> <div class=\"attempt-test-cntnt-pg\"> <div class=\"attempt-test-cntnt-pg-dummy relative\"> <div ng-show=\"beforeAttemptProfTestSuccess\" class=\"attempt-test-options-sctn\"> <div class=\"attempt-prof-test-content-sctn\"> <div class=\"attempt-prof-test-msg\"><span>You just attempt a proficiency test only once</span></div> <div class=\"attempt-prof-test-msg2\"><span>Please complete the skill content before you start the test</span></div> <div class=\"start-lp-btn-wrp destp-btn table hide-for-small-only\"> <button ng-click=\"toggleAttemptProfTestScreen()\" class=\"secondary_btn table-cell remove-focus gtd-button\"><span class=\"text\">START TEST NOW</span></button> <button ng-click=\"toggleAttemptProfTestScreen()\" class=\"secondary_btn table-cell remove-focus explore-course\"><span class=\"text\">GO BACK</span></button> </div> </div> </div> </div> </div> </div>");
$templateCache.put("app/Features/buyerJourney/partials/buyerDashboard/templates/learnersView/completeProfTest/completeProfTest.html"," <div ng-if=\"shwCProfTestScreen\" class=\"prof-test-pg-wrp\"> <div class=\"prof-test-bg-opcity\"></div> <div class=\"prof-test-cntnt-pg\"> <div class=\"prof-test-cntnt-pg-dummy relative\"> <div ng-show=\"beforeCProfTestSuccess\" class=\"prof-test-options-sctn\"> <div class=\"complete-prof-test-content-sctn\"> <div class=\"prof-test-options-top-wrp table full-width\"> <div class=\"msg table-cell\"> Good job Varun!</div> </div> <div class=\"complete-prof-test-msg\"><span>You just earned a proficiency badge for</span></div> <div class=\"complete-prof-test-name\"><span>Analytics for Manager</span></div> </div> </div> </div> </div> </div>");
$templateCache.put("app/Features/buyerJourney/partials/buyerDashboard/templates/learnersView/logoutConfirmation/logoutConfirmation.html"," <div ng-if=\"shwLogoutConfirmationScreen\" class=\"logout-confirmation-pg-wrp\"> <div class=\"logout-confirmation-bg-opcity\"></div> <div class=\"logout-confirmation-cntnt-pg\"> <div class=\"logout-confirmation-cntnt-pg-dummy relative\"> <div ng-show=\"beforeLogoutConfirmationSuccess\" class=\"logout-confirmation-options-sctn\"> <div class=\"logout-confirmation-content-sctn\"> <div class=\"logout-confirmation-msg\"><span>Are you sure you want to logout?</span></div> <div class=\"start-lp-btn-wrp destp-btn table hide-for-small-only\"> <button ng-click=\"toggleLogoutConfirmationScreen()\" class=\"secondary_btn table-cell remove-focus gtd-button\"><span class=\"text\">GO BACK</span></button> <button ng-click=\"toggleLogoutConfirmationScreen()\" class=\"primary_btn table-cell remove-focus explore-course\"><span class=\"text\">LOGOUT</span></button> </div> </div> </div> </div> </div> </div>");
$templateCache.put("app/Features/buyerJourney/partials/buyerDashboard/templates/learnersView/notifyUser/notifyUser.html"," <div ng-if=\"shwNotifyScreen\" class=\"notify-pg-wrp\"> <div class=\"notify-bg-opcity\"></div> <div class=\"notify-cntnt-pg\"> <div class=\"notify-cntnt-pg-dummy relative\"> <div ng-show=\"beforeNotifySuccess\" class=\"notify-options-sctn\"> <div class=\"congratulation-content-sctn\"> <div class=\"notify-options-top-wrp table full-width\"> <div class=\"msg table-cell\"> Congratulations</div> </div> <div class=\"congratulation-user\"><span>You made that look easy</span><span class=\"user\">Vaibhav</span></div> <div class=\"certification-msg\"><span>You just earned a certification for</span></div> <div class=\"certification-name\"><span>Analytics for Manager</span></div> <div class=\"start-lp-btn-wrp destp-btn table hide-for-small-only\"> <button ng-click=\"toggleNotifyScreen()\" class=\"primary_btn table-cell remove-focus gtd-button\"><span class=\"text\">GO TO DASHBOARD</span></button> <button ng-click=\"toggleNotifyScreen()\" class=\"primary_btn table-cell remove-focus explore-course\"><span class=\"text\">EXPLORE COURSES</span></button> </div> </div> </div> </div> </div> </div>");
$templateCache.put("app/Features/buyerJourney/partials/buyerDashboard/templates/learnersView/welcomeBack/welcomeBack.html"," <div ng-if=\"showWelcomeBackScreen\" class=\"welcome-back-pg-wrp\"> <div class=\"welcome-back-bg-opcity\"></div> <div class=\"welcome-back-cntnt-pg\"> <div class=\"welcome-back-cntnt-pg-dummy relative\"> <div ng-show=\"beforeWelcomeBackSuccess\" class=\"welcome-back-options-sctn\"> <div class=\"welcome-back-content-sctn\"> <div class=\"welcome-back-user\"><span>Welcome back</span><span class=\"user\">Varun</span></div> <div class=\"welcome-back-msg\"><span>Due date for the current module is</span><span class=\"date\">22 Nov 2016</span></div> <div class=\"welcome-back-msg\"><span>Due date for the learning path is</span><span class=\"date\">26 Feb 2017</span></div> <div class=\"start-lp-btn-wrp destp-btn table hide-for-small-only\"> <button ng-click=\"toggleWelcomeBackScreen()\" class=\"primary_btn table-cell remove-focus gtd-button\"><span class=\"text\">START LEARNING PATH</span></button> </div> </div> </div> </div> </div> </div>");}]);